import { j as N } from "./jsx-runtime.BREq8dyb.js";
import { cx as D8 } from "@emotion/css";
import { faArrowDownArrowUp as O8, faMagnifyingGlass as R8, faGripDotsVertical as M8, faXmark as Ar, faArrowDown as N8, faSearch as P8, faTableRows as L8, faTableColumns as B8, faFileExclamation as U8, faFileUpload as H8 } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon as r1 } from "@fortawesome/react-fontawesome";
import { styled as Fr, Alert as W8, Box as l0, Stepper as V8, Step as G8, Typography as yr, StepIndicator as j8, Button as f5, Checkbox as r4, Select as Ir, Option as m4, Tooltip as I2, Divider as z8, Input as $8, IconButton as X8, Grid as oe, CircularProgress as K8 } from "@mui/joy";
import { g as Y8, b as o5, v as J8, m as br } from "./lodash.CbaCmyiN.js";
import { memo as K1, useCallback as D3, useEffect as ke, useMemo as G3, useState as Ce, Fragment as Dr } from "react";
import { u as Or } from "./react-dropzone.DjXRqxPt.js";
import q8 from "./transitions/Collapse/Collapse.js";
import "./transitions/Fade/Fade.js";
import l5 from "./transitions/Grow/Grow.js";
import "./transitions/Zoom/Zoom.js";
import { useDataset as Ue } from "./components/DatasetUploader/contexts/DatasetContext/DatasetContext.js";
import { useFeature as S4 } from "./components/DatasetUploader/contexts/FeatureContext/FeatureContext.js";
import { useFile as He } from "./components/DatasetUploader/contexts/FileContext/FileContext.js";
import { useIntrospection as Z8 } from "./components/DatasetUploader/contexts/IntrospectionContext/IntrospectionContext.js";
import { useNavigator as Rr, NavigatorProvider as Q8 } from "./components/DatasetUploader/contexts/NavigatorContext/NavigatorContext.js";
import { useOptions as g3 } from "./components/DatasetUploader/contexts/OptionsContext/OptionsContext.js";
import { useSchema as _3 } from "./components/DatasetUploader/contexts/SchemaContext/SchemaContext.js";
import { useTypifycation as et } from "./components/DatasetUploader/contexts/TypificationContext/TypificationContext.js";
import "./components/DatasetUploader/contexts/WorkerContext/WorkerContext.js";
import h5 from "./components/DatasetUploader/components/Prepper/components/FileSelectDialogButton/FileSelectDialogButton.js";
import rt from "./components/DatasetUploader/components/Prepper/components/ShowRowsSelect/ShowRowsSelect.js";
import tt from "./components/DatasetUploader/components/Prepper/components/ShowColumnsSelect/ShowColumnsSelect.js";
import { NavigatorStepKey as r2, ShowColumns as O3, ShowRows as S3 } from "./components/DatasetUploader/types/index.js";
import { tableRowClasses as at } from "@mui/material";
import { useMaterialReactTable as nt, MaterialReactTable as it } from "material-react-table";
import st from "./components/DatasetUploader/containers/DatasetContainer/DatasetContainer.js";
import ct from "./components/DatasetUploader/containers/FeatureContainer/FeatureContainer.js";
import ft from "./components/DatasetUploader/containers/FileContainer/FileContainer.js";
import ot from "./components/DatasetUploader/containers/IntrospectionContainer/IntrospectionContainer.js";
import { faFile as lt, faRefresh as ht, faShieldKeyhole as ut, faArrowRight as xt, faCheck as dt, faText as pt, faPhone as mt, fa1 as vt, faBinary as gt, fa0 as _t, faAt as Tt, faCalendarDay as Et } from "@fortawesome/pro-regular-svg-icons";
import Mr from "./components/DatasetUploader/components/Navigator/components/FormatDataControls/FormatDataControls.js";
import wt from "./components/DatasetUploader/components/Prepper/components/FilePreviewAndTagTable/components/Header/components/HashToggleButton/HashToggleButton.js";
import Nr from "./components/DatasetUploader/components/Navigator/components/FixValuesControls/FixValuesControls.js";
import { useDebounceFn as kt } from "@decentriq/hooks";
import { TableColumnHashingAlgorithm as Ct } from "@decentriq/graphql/dist/enums";
import { S as St } from "./DqInlineEditor.BguPN4Ku.js";
import At from "./components/DatasetUploader/containers/OptionsContainer/OptionsContainer.js";
import Ft from "./components/DatasetUploader/containers/SchemaContainer/SchemaContainer.js";
import "./components/DatasetUploader/containers/TypificationContainer/TypificationContainer.js";
import "./components/DatasetUploader/components/Controller/Controller.js";
import yt from "./components/DatasetUploader/components/Messenger/Messenger.js";
import { faExclamationTriangle as It } from "@fortawesome/pro-solid-svg-icons";
import bt from "./components/DatasetUploader/components/Prepper/components/FileRequirements/FileRequirements.js";
import Dt from "./components/DatasetUploader/components/Reporter/Reporter.js";
import { formatSize as Ot, getLatestVersionedSchema as u5 } from "./components/DatasetUploader/utils/index.js";
import Rt from "./components/DatasetUploader/containers/WorkerContainer/WorkerContainer.js";
import { ErrorHandler as Mt } from "./components/DatasetUploader/handlers/ErrorHandler/ErrorHandler.js";
import "./components/DqAlert/DqAlert.js";
import "./components/DqAudienceRulesBuilder/DqAudienceRulesBuilder.js";
import "./components/DqAudienceRulesBuilder/models.js";
import "./react-click-away-listener.BrTEM9EK.js";
import "./components/DqDomainsEditor/DqDomainsEditor.js";
import Nt from "./components/DqEmptyData/DqEmptyData.js";
import "./components/DqFloatingLabelInput/DqFloatingLabelInput.js";
import "./components/DqFloatingLabelSelect/DqFloatingLabelSelect.js";
import "./components/DqIcon/DqIcon.js";
import "./components/DqId/DqId.js";
import "@decentriq/utils";
import "./components/DqLoader/DqLoader.js";
import "./components/DqOtpInput/DqOtpInput.js";
import "./components/DqParticipantsEditor/DqParticipantsEditor.js";
import "./components/DqSidePanel/DqSidePanel.js";
import "./components/DqSidePanel/DqSidePanelActions.js";
import "./components/DqSidePanel/DqSidePanelContent.js";
import "./components/DqSidePanel/DqSidePanelTitle.js";
import "./components/DqSidePanel/DqSidePanelTitleToolbar.js";
import "./components/DqSortableAccordion/DqSortableAccordion.js";
import "./components/DqSortableAccordionDetails/DqSortableAccordionDetails.js";
import "./components/DqSortableAccordionGroup/DqSortableAccordionGroup.js";
import "./components/DqSortableAccordionSummary/DqSortableAccordionSummary.js";
import "./components/DqSpinner/DqSpinner.js";
import "./components/Loader/Loader.js";
import x5 from "./components/DatasetUploader/components/Prepper/components/ShowRowsButton/ShowRowsButton.js";
import Pt from "./components/DatasetUploader/components/Prepper/components/FilePreviewAndTagTable/components/Footer/Footer.js";
import Lt from "./components/DatasetUploader/components/Prepper/components/FilePreviewAndTagTable/components/Cell/Cell.js";
var Q3 = {}, d1 = {
  detecting: 0,
  foundIt: 1,
  notMe: 2,
  start: 0,
  error: 1,
  itsMe: 2,
  SHORTCUT_THRESHOLD: 0.95
}, Bt = d1;
function Ut() {
  this.reset = function() {
    this._mState = Bt.detecting;
  }, this.getCharsetName = function() {
    return null;
  }, this.getSupportedCharsetNames = function() {
    throw new Error("Unimplemented method getSupportedCharsetNames()");
  }, this.feed = function(e) {
  }, this.getState = function() {
    return this._mState;
  }, this.getConfidence = function() {
    return 0;
  }, this.filterHighBitOnly = function(e) {
    return e = e.replace(/[\x00-\x7F]+/g, " "), e;
  }, this.filterWithoutEnglishLetters = function(e) {
    return e = e.replace(/[A-Za-z]+/g, " "), e;
  }, this.removeXmlTags = function(e) {
    for (var t = "", r = !1, a = 0, n = 0; n < e.length; n++) {
      var i = e[n];
      i == ">" && e[n - 1] !== "?" ? (a = n + 1, r = !1) : i == "<" && e[n + 1] !== "?" && (n > a && !r && (t = t + e.substring(a, n) + " "), r = !0);
    }
    return r || (t = t + e.substring(a)), t;
  };
}
var Z2 = Ut, h2 = {};
h2.log = function() {
};
h2.setLogger = function(t) {
  h2.enabled = !0, h2.log = t;
};
var A3 = d1, Pr = Z2, d5 = h2;
function A4() {
  Pr.apply(this);
  var e = this;
  function t() {
    e._mActiveNum = 0, e._mProbers = [], e._mBestGuessProber = null;
  }
  this.reset = function() {
    A4.prototype.reset.apply(this), this._mActiveNum = 0;
    for (var r = 0, a; a = this._mProbers[r]; r++)
      a && (a.reset(), a.active = !0, this._mActiveNum++);
    this._mBestGuessProber = null;
  }, this.getCharsetName = function() {
    return !this._mBestGuessProber && (this.getConfidence(), !this._mBestGuessProber) ? null : this._mBestGuessProber.getCharsetName();
  }, this.getSupportedCharsetNames = function() {
    throw new Error("Unimplemented method getSupportedCharsetNames()");
  }, this.feed = function(r) {
    for (var a = 0, n; n = this._mProbers[a]; a++)
      if (!(!n || !n.active)) {
        var i = n.feed(r);
        if (i) {
          if (i == A3.foundIt)
            return this._mBestGuessProber = n, this.getState();
          if (i == A3.notMe && (n.active = !1, this._mActiveNum--, this._mActiveNum <= 0))
            return this._mState = A3.notMe, this.getState();
        }
      }
    return this.getState();
  }, this.getConfidence = function() {
    var r = this.getState();
    if (r == A3.foundIt)
      return 0.99;
    if (r == A3.notMe)
      return 0.01;
    var a = 0;
    this._mBestGuessProber = null;
    for (var n = 0, i; i = this._mProbers[n]; n++)
      if (i) {
        if (!i.active) {
          d5.log(i.getCharsetName() + ` not active
`);
          continue;
        }
        var c = i.getConfidence();
        d5.log(i.getCharsetName() + " confidence = " + c + `
`), a < c && (a = c, this._mBestGuessProber = i);
      }
    return this._mBestGuessProber ? a : 0;
  }, t();
}
A4.prototype = new Pr();
var Lr = A4, p5 = d1;
function Ht(e) {
  var t = this;
  function r(a) {
    t._mModel = a, t._mCurrentBytePos = 0, t._mCurrentCharLen = 0, t.reset();
  }
  this.reset = function() {
    this._mCurrentState = p5.start;
  }, this.nextState = function(a) {
    var n = this._mModel.classTable[a.charCodeAt(0)];
    return this._mCurrentState == p5.start && (this._mCurrentBytePos = 0, this._mCurrentCharLen = this._mModel.charLenTable[n]), this._mCurrentState = this._mModel.stateTable[this._mCurrentState * this._mModel.classFactor + n], this._mCurrentBytePos++, this._mCurrentState;
  }, this.getCurrentCharLen = function() {
    return this._mCurrentCharLen;
  }, this.getCodingStateMachine = function() {
    return this._mModel.name;
  }, r(e);
}
var P2 = Ht, Br = Z2, C2 = d1, Wt = h2;
function F4() {
  Br.apply(this), this.reset = function() {
    F4.prototype.reset.apply(this), this._mCodingSM && this._mCodingSM.reset(), this._mDistributionAnalyzer && this._mDistributionAnalyzer.reset(), this._mLastChar = ["\0", "\0"];
  }, this.getCharsetName = function() {
  }, this.feed = function(e) {
    for (var t = e.length, r = 0; r < t; r++) {
      var a = this._mCodingSM.nextState(e[r]);
      if (a == C2.error) {
        Wt.log(this.getCharsetName() + " prober hit error at byte " + r + `
`), this._mState = C2.notMe;
        break;
      } else if (a == C2.itsMe) {
        this._mState = C2.foundIt;
        break;
      } else if (a == C2.start) {
        var n = this._mCodingSM.getCurrentCharLen();
        r == 0 ? (this._mLastChar[1] = e[0], this._mDistributionAnalyzer.feed(this._mLastChar.join(""), n)) : this._mDistributionAnalyzer.feed(e.slice(r - 1, r + 1), n);
      }
    }
    return this._mLastChar[0] = e[t - 1], this.getState() == C2.detecting && this._mDistributionAnalyzer.gotEnoughData() && this.getConfidence() > C2.SHORTCUT_THRESHOLD && (this._mState = C2.foundIt), this.getState();
  }, this.getConfidence = function() {
    return this._mDistributionAnalyzer.getConfidence();
  };
}
F4.prototype = new Br();
var T3 = F4, a1 = d1, Vt = [
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 00 - 07    //allow 0x00 as legal value
  1,
  1,
  1,
  1,
  1,
  1,
  0,
  0,
  // 08 - 0f
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 10 - 17
  1,
  1,
  1,
  0,
  1,
  1,
  1,
  1,
  // 18 - 1f
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 20 - 27
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 28 - 2f
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 30 - 37
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 38 - 3f
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 40 - 47
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 48 - 4f
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 50 - 57
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 58 - 5f
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 60 - 67
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 68 - 6f
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 70 - 77
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  1,
  // 78 - 7f
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  // 80 - 87
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  // 88 - 8f
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  // 90 - 97
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  // 98 - 9f
  4,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  // a0 - a7
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  // a8 - af
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  // b0 - b7
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  // b8 - bf
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  // c0 - c7
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  // c8 - cf
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  // d0 - d7
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  // d8 - df
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  // e0 - e7
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  // e8 - ef
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  // f0 - f7
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  0
  // f8 - ff
], Gt = [
  a1.error,
  a1.start,
  a1.start,
  3,
  a1.error,
  a1.error,
  a1.error,
  a1.error,
  //00-07
  a1.error,
  a1.error,
  a1.itsMe,
  a1.itsMe,
  a1.itsMe,
  a1.itsMe,
  a1.itsMe,
  a1.error,
  //08-0f
  a1.error,
  a1.start,
  a1.start,
  a1.start,
  a1.start,
  a1.start,
  a1.start,
  a1.start
  //10-17
], jt = [0, 1, 1, 2, 0], zt = {
  classTable: Vt,
  classFactor: 5,
  stateTable: Gt,
  charLenTable: jt,
  name: "Big5"
}, Y1 = {}, We = {};
We.JIS_TYPICAL_DISTRIBUTION_RATIO = 3;
We.JIS_TABLE_SIZE = 4368;
We.JISCharToFreqOrder = [
  40,
  1,
  6,
  182,
  152,
  180,
  295,
  2127,
  285,
  381,
  3295,
  4304,
  3068,
  4606,
  3165,
  3510,
  //   16
  3511,
  1822,
  2785,
  4607,
  1193,
  2226,
  5070,
  4608,
  171,
  2996,
  1247,
  18,
  179,
  5071,
  856,
  1661,
  //   32
  1262,
  5072,
  619,
  127,
  3431,
  3512,
  3230,
  1899,
  1700,
  232,
  228,
  1294,
  1298,
  284,
  283,
  2041,
  //   48
  2042,
  1061,
  1062,
  48,
  49,
  44,
  45,
  433,
  434,
  1040,
  1041,
  996,
  787,
  2997,
  1255,
  4305,
  //   64
  2108,
  4609,
  1684,
  1648,
  5073,
  5074,
  5075,
  5076,
  5077,
  5078,
  3687,
  5079,
  4610,
  5080,
  3927,
  3928,
  //   80
  5081,
  3296,
  3432,
  290,
  2285,
  1471,
  2187,
  5082,
  2580,
  2825,
  1303,
  2140,
  1739,
  1445,
  2691,
  3375,
  //   96
  1691,
  3297,
  4306,
  4307,
  4611,
  452,
  3376,
  1182,
  2713,
  3688,
  3069,
  4308,
  5083,
  5084,
  5085,
  5086,
  //  112
  5087,
  5088,
  5089,
  5090,
  5091,
  5092,
  5093,
  5094,
  5095,
  5096,
  5097,
  5098,
  5099,
  5100,
  5101,
  5102,
  //  128
  5103,
  5104,
  5105,
  5106,
  5107,
  5108,
  5109,
  5110,
  5111,
  5112,
  4097,
  5113,
  5114,
  5115,
  5116,
  5117,
  //  144
  5118,
  5119,
  5120,
  5121,
  5122,
  5123,
  5124,
  5125,
  5126,
  5127,
  5128,
  5129,
  5130,
  5131,
  5132,
  5133,
  //  160
  5134,
  5135,
  5136,
  5137,
  5138,
  5139,
  5140,
  5141,
  5142,
  5143,
  5144,
  5145,
  5146,
  5147,
  5148,
  5149,
  //  176
  5150,
  5151,
  5152,
  4612,
  5153,
  5154,
  5155,
  5156,
  5157,
  5158,
  5159,
  5160,
  5161,
  5162,
  5163,
  5164,
  //  192
  5165,
  5166,
  5167,
  5168,
  5169,
  5170,
  5171,
  5172,
  5173,
  5174,
  5175,
  1472,
  598,
  618,
  820,
  1205,
  //  208
  1309,
  1412,
  1858,
  1307,
  1692,
  5176,
  5177,
  5178,
  5179,
  5180,
  5181,
  5182,
  1142,
  1452,
  1234,
  1172,
  //  224
  1875,
  2043,
  2149,
  1793,
  1382,
  2973,
  925,
  2404,
  1067,
  1241,
  960,
  1377,
  2935,
  1491,
  919,
  1217,
  //  240
  1865,
  2030,
  1406,
  1499,
  2749,
  4098,
  5183,
  5184,
  5185,
  5186,
  5187,
  5188,
  2561,
  4099,
  3117,
  1804,
  //  256
  2049,
  3689,
  4309,
  3513,
  1663,
  5189,
  3166,
  3118,
  3298,
  1587,
  1561,
  3433,
  5190,
  3119,
  1625,
  2998,
  //  272
  3299,
  4613,
  1766,
  3690,
  2786,
  4614,
  5191,
  5192,
  5193,
  5194,
  2161,
  26,
  3377,
  2,
  3929,
  20,
  //  288
  3691,
  47,
  4100,
  50,
  17,
  16,
  35,
  268,
  27,
  243,
  42,
  155,
  24,
  154,
  29,
  184,
  //  304
  4,
  91,
  14,
  92,
  53,
  396,
  33,
  289,
  9,
  37,
  64,
  620,
  21,
  39,
  321,
  5,
  //  320
  12,
  11,
  52,
  13,
  3,
  208,
  138,
  0,
  7,
  60,
  526,
  141,
  151,
  1069,
  181,
  275,
  //  336
  1591,
  83,
  132,
  1475,
  126,
  331,
  829,
  15,
  69,
  160,
  59,
  22,
  157,
  55,
  1079,
  312,
  //  352
  109,
  38,
  23,
  25,
  10,
  19,
  79,
  5195,
  61,
  382,
  1124,
  8,
  30,
  5196,
  5197,
  5198,
  //  368
  5199,
  5200,
  5201,
  5202,
  5203,
  5204,
  5205,
  5206,
  89,
  62,
  74,
  34,
  2416,
  112,
  139,
  196,
  //  384
  271,
  149,
  84,
  607,
  131,
  765,
  46,
  88,
  153,
  683,
  76,
  874,
  101,
  258,
  57,
  80,
  //  400
  32,
  364,
  121,
  1508,
  169,
  1547,
  68,
  235,
  145,
  2999,
  41,
  360,
  3027,
  70,
  63,
  31,
  //  416
  43,
  259,
  262,
  1383,
  99,
  533,
  194,
  66,
  93,
  846,
  217,
  192,
  56,
  106,
  58,
  565,
  //  432
  280,
  272,
  311,
  256,
  146,
  82,
  308,
  71,
  100,
  128,
  214,
  655,
  110,
  261,
  104,
  1140,
  //  448
  54,
  51,
  36,
  87,
  67,
  3070,
  185,
  2618,
  2936,
  2020,
  28,
  1066,
  2390,
  2059,
  5207,
  5208,
  //  464
  5209,
  5210,
  5211,
  5212,
  5213,
  5214,
  5215,
  5216,
  4615,
  5217,
  5218,
  5219,
  5220,
  5221,
  5222,
  5223,
  //  480
  5224,
  5225,
  5226,
  5227,
  5228,
  5229,
  5230,
  5231,
  5232,
  5233,
  5234,
  5235,
  5236,
  3514,
  5237,
  5238,
  //  496
  5239,
  5240,
  5241,
  5242,
  5243,
  5244,
  2297,
  2031,
  4616,
  4310,
  3692,
  5245,
  3071,
  5246,
  3598,
  5247,
  //  512
  4617,
  3231,
  3515,
  5248,
  4101,
  4311,
  4618,
  3808,
  4312,
  4102,
  5249,
  4103,
  4104,
  3599,
  5250,
  5251,
  //  528
  5252,
  5253,
  5254,
  5255,
  5256,
  5257,
  5258,
  5259,
  5260,
  5261,
  5262,
  5263,
  5264,
  5265,
  5266,
  5267,
  //  544
  5268,
  5269,
  5270,
  5271,
  5272,
  5273,
  5274,
  5275,
  5276,
  5277,
  5278,
  5279,
  5280,
  5281,
  5282,
  5283,
  //  560
  5284,
  5285,
  5286,
  5287,
  5288,
  5289,
  5290,
  5291,
  5292,
  5293,
  5294,
  5295,
  5296,
  5297,
  5298,
  5299,
  //  576
  5300,
  5301,
  5302,
  5303,
  5304,
  5305,
  5306,
  5307,
  5308,
  5309,
  5310,
  5311,
  5312,
  5313,
  5314,
  5315,
  //  592
  5316,
  5317,
  5318,
  5319,
  5320,
  5321,
  5322,
  5323,
  5324,
  5325,
  5326,
  5327,
  5328,
  5329,
  5330,
  5331,
  //  608
  5332,
  5333,
  5334,
  5335,
  5336,
  5337,
  5338,
  5339,
  5340,
  5341,
  5342,
  5343,
  5344,
  5345,
  5346,
  5347,
  //  624
  5348,
  5349,
  5350,
  5351,
  5352,
  5353,
  5354,
  5355,
  5356,
  5357,
  5358,
  5359,
  5360,
  5361,
  5362,
  5363,
  //  640
  5364,
  5365,
  5366,
  5367,
  5368,
  5369,
  5370,
  5371,
  5372,
  5373,
  5374,
  5375,
  5376,
  5377,
  5378,
  5379,
  //  656
  5380,
  5381,
  363,
  642,
  2787,
  2878,
  2788,
  2789,
  2316,
  3232,
  2317,
  3434,
  2011,
  165,
  1942,
  3930,
  //  672
  3931,
  3932,
  3933,
  5382,
  4619,
  5383,
  4620,
  5384,
  5385,
  5386,
  5387,
  5388,
  5389,
  5390,
  5391,
  5392,
  //  688
  5393,
  5394,
  5395,
  5396,
  5397,
  5398,
  5399,
  5400,
  5401,
  5402,
  5403,
  5404,
  5405,
  5406,
  5407,
  5408,
  //  704
  5409,
  5410,
  5411,
  5412,
  5413,
  5414,
  5415,
  5416,
  5417,
  5418,
  5419,
  5420,
  5421,
  5422,
  5423,
  5424,
  //  720
  5425,
  5426,
  5427,
  5428,
  5429,
  5430,
  5431,
  5432,
  5433,
  5434,
  5435,
  5436,
  5437,
  5438,
  5439,
  5440,
  //  736
  5441,
  5442,
  5443,
  5444,
  5445,
  5446,
  5447,
  5448,
  5449,
  5450,
  5451,
  5452,
  5453,
  5454,
  5455,
  5456,
  //  752
  5457,
  5458,
  5459,
  5460,
  5461,
  5462,
  5463,
  5464,
  5465,
  5466,
  5467,
  5468,
  5469,
  5470,
  5471,
  5472,
  //  768
  5473,
  5474,
  5475,
  5476,
  5477,
  5478,
  5479,
  5480,
  5481,
  5482,
  5483,
  5484,
  5485,
  5486,
  5487,
  5488,
  //  784
  5489,
  5490,
  5491,
  5492,
  5493,
  5494,
  5495,
  5496,
  5497,
  5498,
  5499,
  5500,
  5501,
  5502,
  5503,
  5504,
  //  800
  5505,
  5506,
  5507,
  5508,
  5509,
  5510,
  5511,
  5512,
  5513,
  5514,
  5515,
  5516,
  5517,
  5518,
  5519,
  5520,
  //  816
  5521,
  5522,
  5523,
  5524,
  5525,
  5526,
  5527,
  5528,
  5529,
  5530,
  5531,
  5532,
  5533,
  5534,
  5535,
  5536,
  //  832
  5537,
  5538,
  5539,
  5540,
  5541,
  5542,
  5543,
  5544,
  5545,
  5546,
  5547,
  5548,
  5549,
  5550,
  5551,
  5552,
  //  848
  5553,
  5554,
  5555,
  5556,
  5557,
  5558,
  5559,
  5560,
  5561,
  5562,
  5563,
  5564,
  5565,
  5566,
  5567,
  5568,
  //  864
  5569,
  5570,
  5571,
  5572,
  5573,
  5574,
  5575,
  5576,
  5577,
  5578,
  5579,
  5580,
  5581,
  5582,
  5583,
  5584,
  //  880
  5585,
  5586,
  5587,
  5588,
  5589,
  5590,
  5591,
  5592,
  5593,
  5594,
  5595,
  5596,
  5597,
  5598,
  5599,
  5600,
  //  896
  5601,
  5602,
  5603,
  5604,
  5605,
  5606,
  5607,
  5608,
  5609,
  5610,
  5611,
  5612,
  5613,
  5614,
  5615,
  5616,
  //  912
  5617,
  5618,
  5619,
  5620,
  5621,
  5622,
  5623,
  5624,
  5625,
  5626,
  5627,
  5628,
  5629,
  5630,
  5631,
  5632,
  //  928
  5633,
  5634,
  5635,
  5636,
  5637,
  5638,
  5639,
  5640,
  5641,
  5642,
  5643,
  5644,
  5645,
  5646,
  5647,
  5648,
  //  944
  5649,
  5650,
  5651,
  5652,
  5653,
  5654,
  5655,
  5656,
  5657,
  5658,
  5659,
  5660,
  5661,
  5662,
  5663,
  5664,
  //  960
  5665,
  5666,
  5667,
  5668,
  5669,
  5670,
  5671,
  5672,
  5673,
  5674,
  5675,
  5676,
  5677,
  5678,
  5679,
  5680,
  //  976
  5681,
  5682,
  5683,
  5684,
  5685,
  5686,
  5687,
  5688,
  5689,
  5690,
  5691,
  5692,
  5693,
  5694,
  5695,
  5696,
  //  992
  5697,
  5698,
  5699,
  5700,
  5701,
  5702,
  5703,
  5704,
  5705,
  5706,
  5707,
  5708,
  5709,
  5710,
  5711,
  5712,
  // 1008
  5713,
  5714,
  5715,
  5716,
  5717,
  5718,
  5719,
  5720,
  5721,
  5722,
  5723,
  5724,
  5725,
  5726,
  5727,
  5728,
  // 1024
  5729,
  5730,
  5731,
  5732,
  5733,
  5734,
  5735,
  5736,
  5737,
  5738,
  5739,
  5740,
  5741,
  5742,
  5743,
  5744,
  // 1040
  5745,
  5746,
  5747,
  5748,
  5749,
  5750,
  5751,
  5752,
  5753,
  5754,
  5755,
  5756,
  5757,
  5758,
  5759,
  5760,
  // 1056
  5761,
  5762,
  5763,
  5764,
  5765,
  5766,
  5767,
  5768,
  5769,
  5770,
  5771,
  5772,
  5773,
  5774,
  5775,
  5776,
  // 1072
  5777,
  5778,
  5779,
  5780,
  5781,
  5782,
  5783,
  5784,
  5785,
  5786,
  5787,
  5788,
  5789,
  5790,
  5791,
  5792,
  // 1088
  5793,
  5794,
  5795,
  5796,
  5797,
  5798,
  5799,
  5800,
  5801,
  5802,
  5803,
  5804,
  5805,
  5806,
  5807,
  5808,
  // 1104
  5809,
  5810,
  5811,
  5812,
  5813,
  5814,
  5815,
  5816,
  5817,
  5818,
  5819,
  5820,
  5821,
  5822,
  5823,
  5824,
  // 1120
  5825,
  5826,
  5827,
  5828,
  5829,
  5830,
  5831,
  5832,
  5833,
  5834,
  5835,
  5836,
  5837,
  5838,
  5839,
  5840,
  // 1136
  5841,
  5842,
  5843,
  5844,
  5845,
  5846,
  5847,
  5848,
  5849,
  5850,
  5851,
  5852,
  5853,
  5854,
  5855,
  5856,
  // 1152
  5857,
  5858,
  5859,
  5860,
  5861,
  5862,
  5863,
  5864,
  5865,
  5866,
  5867,
  5868,
  5869,
  5870,
  5871,
  5872,
  // 1168
  5873,
  5874,
  5875,
  5876,
  5877,
  5878,
  5879,
  5880,
  5881,
  5882,
  5883,
  5884,
  5885,
  5886,
  5887,
  5888,
  // 1184
  5889,
  5890,
  5891,
  5892,
  5893,
  5894,
  5895,
  5896,
  5897,
  5898,
  5899,
  5900,
  5901,
  5902,
  5903,
  5904,
  // 1200
  5905,
  5906,
  5907,
  5908,
  5909,
  5910,
  5911,
  5912,
  5913,
  5914,
  5915,
  5916,
  5917,
  5918,
  5919,
  5920,
  // 1216
  5921,
  5922,
  5923,
  5924,
  5925,
  5926,
  5927,
  5928,
  5929,
  5930,
  5931,
  5932,
  5933,
  5934,
  5935,
  5936,
  // 1232
  5937,
  5938,
  5939,
  5940,
  5941,
  5942,
  5943,
  5944,
  5945,
  5946,
  5947,
  5948,
  5949,
  5950,
  5951,
  5952,
  // 1248
  5953,
  5954,
  5955,
  5956,
  5957,
  5958,
  5959,
  5960,
  5961,
  5962,
  5963,
  5964,
  5965,
  5966,
  5967,
  5968,
  // 1264
  5969,
  5970,
  5971,
  5972,
  5973,
  5974,
  5975,
  5976,
  5977,
  5978,
  5979,
  5980,
  5981,
  5982,
  5983,
  5984,
  // 1280
  5985,
  5986,
  5987,
  5988,
  5989,
  5990,
  5991,
  5992,
  5993,
  5994,
  5995,
  5996,
  5997,
  5998,
  5999,
  6e3,
  // 1296
  6001,
  6002,
  6003,
  6004,
  6005,
  6006,
  6007,
  6008,
  6009,
  6010,
  6011,
  6012,
  6013,
  6014,
  6015,
  6016,
  // 1312
  6017,
  6018,
  6019,
  6020,
  6021,
  6022,
  6023,
  6024,
  6025,
  6026,
  6027,
  6028,
  6029,
  6030,
  6031,
  6032,
  // 1328
  6033,
  6034,
  6035,
  6036,
  6037,
  6038,
  6039,
  6040,
  6041,
  6042,
  6043,
  6044,
  6045,
  6046,
  6047,
  6048,
  // 1344
  6049,
  6050,
  6051,
  6052,
  6053,
  6054,
  6055,
  6056,
  6057,
  6058,
  6059,
  6060,
  6061,
  6062,
  6063,
  6064,
  // 1360
  6065,
  6066,
  6067,
  6068,
  6069,
  6070,
  6071,
  6072,
  6073,
  6074,
  6075,
  6076,
  6077,
  6078,
  6079,
  6080,
  // 1376
  6081,
  6082,
  6083,
  6084,
  6085,
  6086,
  6087,
  6088,
  6089,
  6090,
  6091,
  6092,
  6093,
  6094,
  6095,
  6096,
  // 1392
  6097,
  6098,
  6099,
  6100,
  6101,
  6102,
  6103,
  6104,
  6105,
  6106,
  6107,
  6108,
  6109,
  6110,
  6111,
  6112,
  // 1408
  6113,
  6114,
  2044,
  2060,
  4621,
  997,
  1235,
  473,
  1186,
  4622,
  920,
  3378,
  6115,
  6116,
  379,
  1108,
  // 1424
  4313,
  2657,
  2735,
  3934,
  6117,
  3809,
  636,
  3233,
  573,
  1026,
  3693,
  3435,
  2974,
  3300,
  2298,
  4105,
  // 1440
  854,
  2937,
  2463,
  393,
  2581,
  2417,
  539,
  752,
  1280,
  2750,
  2480,
  140,
  1161,
  440,
  708,
  1569,
  // 1456
  665,
  2497,
  1746,
  1291,
  1523,
  3e3,
  164,
  1603,
  847,
  1331,
  537,
  1997,
  486,
  508,
  1693,
  2418,
  // 1472
  1970,
  2227,
  878,
  1220,
  299,
  1030,
  969,
  652,
  2751,
  624,
  1137,
  3301,
  2619,
  65,
  3302,
  2045,
  // 1488
  1761,
  1859,
  3120,
  1930,
  3694,
  3516,
  663,
  1767,
  852,
  835,
  3695,
  269,
  767,
  2826,
  2339,
  1305,
  // 1504
  896,
  1150,
  770,
  1616,
  6118,
  506,
  1502,
  2075,
  1012,
  2519,
  775,
  2520,
  2975,
  2340,
  2938,
  4314,
  // 1520
  3028,
  2086,
  1224,
  1943,
  2286,
  6119,
  3072,
  4315,
  2240,
  1273,
  1987,
  3935,
  1557,
  175,
  597,
  985,
  // 1536
  3517,
  2419,
  2521,
  1416,
  3029,
  585,
  938,
  1931,
  1007,
  1052,
  1932,
  1685,
  6120,
  3379,
  4316,
  4623,
  // 1552
  804,
  599,
  3121,
  1333,
  2128,
  2539,
  1159,
  1554,
  2032,
  3810,
  687,
  2033,
  2904,
  952,
  675,
  1467,
  // 1568
  3436,
  6121,
  2241,
  1096,
  1786,
  2440,
  1543,
  1924,
  980,
  1813,
  2228,
  781,
  2692,
  1879,
  728,
  1918,
  // 1584
  3696,
  4624,
  548,
  1950,
  4625,
  1809,
  1088,
  1356,
  3303,
  2522,
  1944,
  502,
  972,
  373,
  513,
  2827,
  // 1600
  586,
  2377,
  2391,
  1003,
  1976,
  1631,
  6122,
  2464,
  1084,
  648,
  1776,
  4626,
  2141,
  324,
  962,
  2012,
  // 1616
  2177,
  2076,
  1384,
  742,
  2178,
  1448,
  1173,
  1810,
  222,
  102,
  301,
  445,
  125,
  2420,
  662,
  2498,
  // 1632
  277,
  200,
  1476,
  1165,
  1068,
  224,
  2562,
  1378,
  1446,
  450,
  1880,
  659,
  791,
  582,
  4627,
  2939,
  // 1648
  3936,
  1516,
  1274,
  555,
  2099,
  3697,
  1020,
  1389,
  1526,
  3380,
  1762,
  1723,
  1787,
  2229,
  412,
  2114,
  // 1664
  1900,
  2392,
  3518,
  512,
  2597,
  427,
  1925,
  2341,
  3122,
  1653,
  1686,
  2465,
  2499,
  697,
  330,
  273,
  // 1680
  380,
  2162,
  951,
  832,
  780,
  991,
  1301,
  3073,
  965,
  2270,
  3519,
  668,
  2523,
  2636,
  1286,
  535,
  // 1696
  1407,
  518,
  671,
  957,
  2658,
  2378,
  267,
  611,
  2197,
  3030,
  6123,
  248,
  2299,
  967,
  1799,
  2356,
  // 1712
  850,
  1418,
  3437,
  1876,
  1256,
  1480,
  2828,
  1718,
  6124,
  6125,
  1755,
  1664,
  2405,
  6126,
  4628,
  2879,
  // 1728
  2829,
  499,
  2179,
  676,
  4629,
  557,
  2329,
  2214,
  2090,
  325,
  3234,
  464,
  811,
  3001,
  992,
  2342,
  // 1744
  2481,
  1232,
  1469,
  303,
  2242,
  466,
  1070,
  2163,
  603,
  1777,
  2091,
  4630,
  2752,
  4631,
  2714,
  322,
  // 1760
  2659,
  1964,
  1768,
  481,
  2188,
  1463,
  2330,
  2857,
  3600,
  2092,
  3031,
  2421,
  4632,
  2318,
  2070,
  1849,
  // 1776
  2598,
  4633,
  1302,
  2254,
  1668,
  1701,
  2422,
  3811,
  2905,
  3032,
  3123,
  2046,
  4106,
  1763,
  1694,
  4634,
  // 1792
  1604,
  943,
  1724,
  1454,
  917,
  868,
  2215,
  1169,
  2940,
  552,
  1145,
  1800,
  1228,
  1823,
  1955,
  316,
  // 1808
  1080,
  2510,
  361,
  1807,
  2830,
  4107,
  2660,
  3381,
  1346,
  1423,
  1134,
  4108,
  6127,
  541,
  1263,
  1229,
  // 1824
  1148,
  2540,
  545,
  465,
  1833,
  2880,
  3438,
  1901,
  3074,
  2482,
  816,
  3937,
  713,
  1788,
  2500,
  122,
  // 1840
  1575,
  195,
  1451,
  2501,
  1111,
  6128,
  859,
  374,
  1225,
  2243,
  2483,
  4317,
  390,
  1033,
  3439,
  3075,
  // 1856
  2524,
  1687,
  266,
  793,
  1440,
  2599,
  946,
  779,
  802,
  507,
  897,
  1081,
  528,
  2189,
  1292,
  711,
  // 1872
  1866,
  1725,
  1167,
  1640,
  753,
  398,
  2661,
  1053,
  246,
  348,
  4318,
  137,
  1024,
  3440,
  1600,
  2077,
  // 1888
  2129,
  825,
  4319,
  698,
  238,
  521,
  187,
  2300,
  1157,
  2423,
  1641,
  1605,
  1464,
  1610,
  1097,
  2541,
  // 1904
  1260,
  1436,
  759,
  2255,
  1814,
  2150,
  705,
  3235,
  409,
  2563,
  3304,
  561,
  3033,
  2005,
  2564,
  726,
  // 1920
  1956,
  2343,
  3698,
  4109,
  949,
  3812,
  3813,
  3520,
  1669,
  653,
  1379,
  2525,
  881,
  2198,
  632,
  2256,
  // 1936
  1027,
  778,
  1074,
  733,
  1957,
  514,
  1481,
  2466,
  554,
  2180,
  702,
  3938,
  1606,
  1017,
  1398,
  6129,
  // 1952
  1380,
  3521,
  921,
  993,
  1313,
  594,
  449,
  1489,
  1617,
  1166,
  768,
  1426,
  1360,
  495,
  1794,
  3601,
  // 1968
  1177,
  3602,
  1170,
  4320,
  2344,
  476,
  425,
  3167,
  4635,
  3168,
  1424,
  401,
  2662,
  1171,
  3382,
  1998,
  // 1984
  1089,
  4110,
  477,
  3169,
  474,
  6130,
  1909,
  596,
  2831,
  1842,
  494,
  693,
  1051,
  1028,
  1207,
  3076,
  // 2000
  606,
  2115,
  727,
  2790,
  1473,
  1115,
  743,
  3522,
  630,
  805,
  1532,
  4321,
  2021,
  366,
  1057,
  838,
  // 2016
  684,
  1114,
  2142,
  4322,
  2050,
  1492,
  1892,
  1808,
  2271,
  3814,
  2424,
  1971,
  1447,
  1373,
  3305,
  1090,
  // 2032
  1536,
  3939,
  3523,
  3306,
  1455,
  2199,
  336,
  369,
  2331,
  1035,
  584,
  2393,
  902,
  718,
  2600,
  6131,
  // 2048
  2753,
  463,
  2151,
  1149,
  1611,
  2467,
  715,
  1308,
  3124,
  1268,
  343,
  1413,
  3236,
  1517,
  1347,
  2663,
  // 2064
  2093,
  3940,
  2022,
  1131,
  1553,
  2100,
  2941,
  1427,
  3441,
  2942,
  1323,
  2484,
  6132,
  1980,
  872,
  2368,
  // 2080
  2441,
  2943,
  320,
  2369,
  2116,
  1082,
  679,
  1933,
  3941,
  2791,
  3815,
  625,
  1143,
  2023,
  422,
  2200,
  // 2096
  3816,
  6133,
  730,
  1695,
  356,
  2257,
  1626,
  2301,
  2858,
  2637,
  1627,
  1778,
  937,
  883,
  2906,
  2693,
  // 2112
  3002,
  1769,
  1086,
  400,
  1063,
  1325,
  3307,
  2792,
  4111,
  3077,
  456,
  2345,
  1046,
  747,
  6134,
  1524,
  // 2128
  884,
  1094,
  3383,
  1474,
  2164,
  1059,
  974,
  1688,
  2181,
  2258,
  1047,
  345,
  1665,
  1187,
  358,
  875,
  // 2144
  3170,
  305,
  660,
  3524,
  2190,
  1334,
  1135,
  3171,
  1540,
  1649,
  2542,
  1527,
  927,
  968,
  2793,
  885,
  // 2160
  1972,
  1850,
  482,
  500,
  2638,
  1218,
  1109,
  1085,
  2543,
  1654,
  2034,
  876,
  78,
  2287,
  1482,
  1277,
  // 2176
  861,
  1675,
  1083,
  1779,
  724,
  2754,
  454,
  397,
  1132,
  1612,
  2332,
  893,
  672,
  1237,
  257,
  2259,
  // 2192
  2370,
  135,
  3384,
  337,
  2244,
  547,
  352,
  340,
  709,
  2485,
  1400,
  788,
  1138,
  2511,
  540,
  772,
  // 2208
  1682,
  2260,
  2272,
  2544,
  2013,
  1843,
  1902,
  4636,
  1999,
  1562,
  2288,
  4637,
  2201,
  1403,
  1533,
  407,
  // 2224
  576,
  3308,
  1254,
  2071,
  978,
  3385,
  170,
  136,
  1201,
  3125,
  2664,
  3172,
  2394,
  213,
  912,
  873,
  // 2240
  3603,
  1713,
  2202,
  699,
  3604,
  3699,
  813,
  3442,
  493,
  531,
  1054,
  468,
  2907,
  1483,
  304,
  281,
  // 2256
  4112,
  1726,
  1252,
  2094,
  339,
  2319,
  2130,
  2639,
  756,
  1563,
  2944,
  748,
  571,
  2976,
  1588,
  2425,
  // 2272
  2715,
  1851,
  1460,
  2426,
  1528,
  1392,
  1973,
  3237,
  288,
  3309,
  685,
  3386,
  296,
  892,
  2716,
  2216,
  // 2288
  1570,
  2245,
  722,
  1747,
  2217,
  905,
  3238,
  1103,
  6135,
  1893,
  1441,
  1965,
  251,
  1805,
  2371,
  3700,
  // 2304
  2601,
  1919,
  1078,
  75,
  2182,
  1509,
  1592,
  1270,
  2640,
  4638,
  2152,
  6136,
  3310,
  3817,
  524,
  706,
  // 2320
  1075,
  292,
  3818,
  1756,
  2602,
  317,
  98,
  3173,
  3605,
  3525,
  1844,
  2218,
  3819,
  2502,
  814,
  567,
  // 2336
  385,
  2908,
  1534,
  6137,
  534,
  1642,
  3239,
  797,
  6138,
  1670,
  1529,
  953,
  4323,
  188,
  1071,
  538,
  // 2352
  178,
  729,
  3240,
  2109,
  1226,
  1374,
  2e3,
  2357,
  2977,
  731,
  2468,
  1116,
  2014,
  2051,
  6139,
  1261,
  // 2368
  1593,
  803,
  2859,
  2736,
  3443,
  556,
  682,
  823,
  1541,
  6140,
  1369,
  2289,
  1706,
  2794,
  845,
  462,
  // 2384
  2603,
  2665,
  1361,
  387,
  162,
  2358,
  1740,
  739,
  1770,
  1720,
  1304,
  1401,
  3241,
  1049,
  627,
  1571,
  // 2400
  2427,
  3526,
  1877,
  3942,
  1852,
  1500,
  431,
  1910,
  1503,
  677,
  297,
  2795,
  286,
  1433,
  1038,
  1198,
  // 2416
  2290,
  1133,
  1596,
  4113,
  4639,
  2469,
  1510,
  1484,
  3943,
  6141,
  2442,
  108,
  712,
  4640,
  2372,
  866,
  // 2432
  3701,
  2755,
  3242,
  1348,
  834,
  1945,
  1408,
  3527,
  2395,
  3243,
  1811,
  824,
  994,
  1179,
  2110,
  1548,
  // 2448
  1453,
  790,
  3003,
  690,
  4324,
  4325,
  2832,
  2909,
  3820,
  1860,
  3821,
  225,
  1748,
  310,
  346,
  1780,
  // 2464
  2470,
  821,
  1993,
  2717,
  2796,
  828,
  877,
  3528,
  2860,
  2471,
  1702,
  2165,
  2910,
  2486,
  1789,
  453,
  // 2480
  359,
  2291,
  1676,
  73,
  1164,
  1461,
  1127,
  3311,
  421,
  604,
  314,
  1037,
  589,
  116,
  2487,
  737,
  // 2496
  837,
  1180,
  111,
  244,
  735,
  6142,
  2261,
  1861,
  1362,
  986,
  523,
  418,
  581,
  2666,
  3822,
  103,
  // 2512
  855,
  503,
  1414,
  1867,
  2488,
  1091,
  657,
  1597,
  979,
  605,
  1316,
  4641,
  1021,
  2443,
  2078,
  2001,
  // 2528
  1209,
  96,
  587,
  2166,
  1032,
  260,
  1072,
  2153,
  173,
  94,
  226,
  3244,
  819,
  2006,
  4642,
  4114,
  // 2544
  2203,
  231,
  1744,
  782,
  97,
  2667,
  786,
  3387,
  887,
  391,
  442,
  2219,
  4326,
  1425,
  6143,
  2694,
  // 2560
  633,
  1544,
  1202,
  483,
  2015,
  592,
  2052,
  1958,
  2472,
  1655,
  419,
  129,
  4327,
  3444,
  3312,
  1714,
  // 2576
  1257,
  3078,
  4328,
  1518,
  1098,
  865,
  1310,
  1019,
  1885,
  1512,
  1734,
  469,
  2444,
  148,
  773,
  436,
  // 2592
  1815,
  1868,
  1128,
  1055,
  4329,
  1245,
  2756,
  3445,
  2154,
  1934,
  1039,
  4643,
  579,
  1238,
  932,
  2320,
  // 2608
  353,
  205,
  801,
  115,
  2428,
  944,
  2321,
  1881,
  399,
  2565,
  1211,
  678,
  766,
  3944,
  335,
  2101,
  // 2624
  1459,
  1781,
  1402,
  3945,
  2737,
  2131,
  1010,
  844,
  981,
  1326,
  1013,
  550,
  1816,
  1545,
  2620,
  1335,
  // 2640
  1008,
  371,
  2881,
  936,
  1419,
  1613,
  3529,
  1456,
  1395,
  2273,
  1834,
  2604,
  1317,
  2738,
  2503,
  416,
  // 2656
  1643,
  4330,
  806,
  1126,
  229,
  591,
  3946,
  1314,
  1981,
  1576,
  1837,
  1666,
  347,
  1790,
  977,
  3313,
  // 2672
  764,
  2861,
  1853,
  688,
  2429,
  1920,
  1462,
  77,
  595,
  415,
  2002,
  3034,
  798,
  1192,
  4115,
  6144,
  // 2688
  2978,
  4331,
  3035,
  2695,
  2582,
  2072,
  2566,
  430,
  2430,
  1727,
  842,
  1396,
  3947,
  3702,
  613,
  377,
  // 2704
  278,
  236,
  1417,
  3388,
  3314,
  3174,
  757,
  1869,
  107,
  3530,
  6145,
  1194,
  623,
  2262,
  207,
  1253,
  // 2720
  2167,
  3446,
  3948,
  492,
  1117,
  1935,
  536,
  1838,
  2757,
  1246,
  4332,
  696,
  2095,
  2406,
  1393,
  1572,
  // 2736
  3175,
  1782,
  583,
  190,
  253,
  1390,
  2230,
  830,
  3126,
  3389,
  934,
  3245,
  1703,
  1749,
  2979,
  1870,
  // 2752
  2545,
  1656,
  2204,
  869,
  2346,
  4116,
  3176,
  1817,
  496,
  1764,
  4644,
  942,
  1504,
  404,
  1903,
  1122,
  // 2768
  1580,
  3606,
  2945,
  1022,
  515,
  372,
  1735,
  955,
  2431,
  3036,
  6146,
  2797,
  1110,
  2302,
  2798,
  617,
  // 2784
  6147,
  441,
  762,
  1771,
  3447,
  3607,
  3608,
  1904,
  840,
  3037,
  86,
  939,
  1385,
  572,
  1370,
  2445,
  // 2800
  1336,
  114,
  3703,
  898,
  294,
  203,
  3315,
  703,
  1583,
  2274,
  429,
  961,
  4333,
  1854,
  1951,
  3390,
  // 2816
  2373,
  3704,
  4334,
  1318,
  1381,
  966,
  1911,
  2322,
  1006,
  1155,
  309,
  989,
  458,
  2718,
  1795,
  1372,
  // 2832
  1203,
  252,
  1689,
  1363,
  3177,
  517,
  1936,
  168,
  1490,
  562,
  193,
  3823,
  1042,
  4117,
  1835,
  551,
  // 2848
  470,
  4645,
  395,
  489,
  3448,
  1871,
  1465,
  2583,
  2641,
  417,
  1493,
  279,
  1295,
  511,
  1236,
  1119,
  // 2864
  72,
  1231,
  1982,
  1812,
  3004,
  871,
  1564,
  984,
  3449,
  1667,
  2696,
  2096,
  4646,
  2347,
  2833,
  1673,
  // 2880
  3609,
  695,
  3246,
  2668,
  807,
  1183,
  4647,
  890,
  388,
  2333,
  1801,
  1457,
  2911,
  1765,
  1477,
  1031,
  // 2896
  3316,
  3317,
  1278,
  3391,
  2799,
  2292,
  2526,
  163,
  3450,
  4335,
  2669,
  1404,
  1802,
  6148,
  2323,
  2407,
  // 2912
  1584,
  1728,
  1494,
  1824,
  1269,
  298,
  909,
  3318,
  1034,
  1632,
  375,
  776,
  1683,
  2061,
  291,
  210,
  // 2928
  1123,
  809,
  1249,
  1002,
  2642,
  3038,
  206,
  1011,
  2132,
  144,
  975,
  882,
  1565,
  342,
  667,
  754,
  // 2944
  1442,
  2143,
  1299,
  2303,
  2062,
  447,
  626,
  2205,
  1221,
  2739,
  2912,
  1144,
  1214,
  2206,
  2584,
  760,
  // 2960
  1715,
  614,
  950,
  1281,
  2670,
  2621,
  810,
  577,
  1287,
  2546,
  4648,
  242,
  2168,
  250,
  2643,
  691,
  // 2976
  123,
  2644,
  647,
  313,
  1029,
  689,
  1357,
  2946,
  1650,
  216,
  771,
  1339,
  1306,
  808,
  2063,
  549,
  // 2992
  913,
  1371,
  2913,
  2914,
  6149,
  1466,
  1092,
  1174,
  1196,
  1311,
  2605,
  2396,
  1783,
  1796,
  3079,
  406,
  // 3008
  2671,
  2117,
  3949,
  4649,
  487,
  1825,
  2220,
  6150,
  2915,
  448,
  2348,
  1073,
  6151,
  2397,
  1707,
  130,
  // 3024
  900,
  1598,
  329,
  176,
  1959,
  2527,
  1620,
  6152,
  2275,
  4336,
  3319,
  1983,
  2191,
  3705,
  3610,
  2155,
  // 3040
  3706,
  1912,
  1513,
  1614,
  6153,
  1988,
  646,
  392,
  2304,
  1589,
  3320,
  3039,
  1826,
  1239,
  1352,
  1340,
  // 3056
  2916,
  505,
  2567,
  1709,
  1437,
  2408,
  2547,
  906,
  6154,
  2672,
  384,
  1458,
  1594,
  1100,
  1329,
  710,
  // 3072
  423,
  3531,
  2064,
  2231,
  2622,
  1989,
  2673,
  1087,
  1882,
  333,
  841,
  3005,
  1296,
  2882,
  2379,
  580,
  // 3088
  1937,
  1827,
  1293,
  2585,
  601,
  574,
  249,
  1772,
  4118,
  2079,
  1120,
  645,
  901,
  1176,
  1690,
  795,
  // 3104
  2207,
  478,
  1434,
  516,
  1190,
  1530,
  761,
  2080,
  930,
  1264,
  355,
  435,
  1552,
  644,
  1791,
  987,
  // 3120
  220,
  1364,
  1163,
  1121,
  1538,
  306,
  2169,
  1327,
  1222,
  546,
  2645,
  218,
  241,
  610,
  1704,
  3321,
  // 3136
  1984,
  1839,
  1966,
  2528,
  451,
  6155,
  2586,
  3707,
  2568,
  907,
  3178,
  254,
  2947,
  186,
  1845,
  4650,
  // 3152
  745,
  432,
  1757,
  428,
  1633,
  888,
  2246,
  2221,
  2489,
  3611,
  2118,
  1258,
  1265,
  956,
  3127,
  1784,
  // 3168
  4337,
  2490,
  319,
  510,
  119,
  457,
  3612,
  274,
  2035,
  2007,
  4651,
  1409,
  3128,
  970,
  2758,
  590,
  // 3184
  2800,
  661,
  2247,
  4652,
  2008,
  3950,
  1420,
  1549,
  3080,
  3322,
  3951,
  1651,
  1375,
  2111,
  485,
  2491,
  // 3200
  1429,
  1156,
  6156,
  2548,
  2183,
  1495,
  831,
  1840,
  2529,
  2446,
  501,
  1657,
  307,
  1894,
  3247,
  1341,
  // 3216
  666,
  899,
  2156,
  1539,
  2549,
  1559,
  886,
  349,
  2208,
  3081,
  2305,
  1736,
  3824,
  2170,
  2759,
  1014,
  // 3232
  1913,
  1386,
  542,
  1397,
  2948,
  490,
  368,
  716,
  362,
  159,
  282,
  2569,
  1129,
  1658,
  1288,
  1750,
  // 3248
  2674,
  276,
  649,
  2016,
  751,
  1496,
  658,
  1818,
  1284,
  1862,
  2209,
  2087,
  2512,
  3451,
  622,
  2834,
  // 3264
  376,
  117,
  1060,
  2053,
  1208,
  1721,
  1101,
  1443,
  247,
  1250,
  3179,
  1792,
  3952,
  2760,
  2398,
  3953,
  // 3280
  6157,
  2144,
  3708,
  446,
  2432,
  1151,
  2570,
  3452,
  2447,
  2761,
  2835,
  1210,
  2448,
  3082,
  424,
  2222,
  // 3296
  1251,
  2449,
  2119,
  2836,
  504,
  1581,
  4338,
  602,
  817,
  857,
  3825,
  2349,
  2306,
  357,
  3826,
  1470,
  // 3312
  1883,
  2883,
  255,
  958,
  929,
  2917,
  3248,
  302,
  4653,
  1050,
  1271,
  1751,
  2307,
  1952,
  1430,
  2697,
  // 3328
  2719,
  2359,
  354,
  3180,
  777,
  158,
  2036,
  4339,
  1659,
  4340,
  4654,
  2308,
  2949,
  2248,
  1146,
  2232,
  // 3344
  3532,
  2720,
  1696,
  2623,
  3827,
  6158,
  3129,
  1550,
  2698,
  1485,
  1297,
  1428,
  637,
  931,
  2721,
  2145,
  // 3360
  914,
  2550,
  2587,
  81,
  2450,
  612,
  827,
  2646,
  1242,
  4655,
  1118,
  2884,
  472,
  1855,
  3181,
  3533,
  // 3376
  3534,
  569,
  1353,
  2699,
  1244,
  1758,
  2588,
  4119,
  2009,
  2762,
  2171,
  3709,
  1312,
  1531,
  6159,
  1152,
  // 3392
  1938,
  134,
  1830,
  471,
  3710,
  2276,
  1112,
  1535,
  3323,
  3453,
  3535,
  982,
  1337,
  2950,
  488,
  826,
  // 3408
  674,
  1058,
  1628,
  4120,
  2017,
  522,
  2399,
  211,
  568,
  1367,
  3454,
  350,
  293,
  1872,
  1139,
  3249,
  // 3424
  1399,
  1946,
  3006,
  1300,
  2360,
  3324,
  588,
  736,
  6160,
  2606,
  744,
  669,
  3536,
  3828,
  6161,
  1358,
  // 3440
  199,
  723,
  848,
  933,
  851,
  1939,
  1505,
  1514,
  1338,
  1618,
  1831,
  4656,
  1634,
  3613,
  443,
  2740,
  // 3456
  3829,
  717,
  1947,
  491,
  1914,
  6162,
  2551,
  1542,
  4121,
  1025,
  6163,
  1099,
  1223,
  198,
  3040,
  2722,
  // 3472
  370,
  410,
  1905,
  2589,
  998,
  1248,
  3182,
  2380,
  519,
  1449,
  4122,
  1710,
  947,
  928,
  1153,
  4341,
  // 3488
  2277,
  344,
  2624,
  1511,
  615,
  105,
  161,
  1212,
  1076,
  1960,
  3130,
  2054,
  1926,
  1175,
  1906,
  2473,
  // 3504
  414,
  1873,
  2801,
  6164,
  2309,
  315,
  1319,
  3325,
  318,
  2018,
  2146,
  2157,
  963,
  631,
  223,
  4342,
  // 3520
  4343,
  2675,
  479,
  3711,
  1197,
  2625,
  3712,
  2676,
  2361,
  6165,
  4344,
  4123,
  6166,
  2451,
  3183,
  1886,
  // 3536
  2184,
  1674,
  1330,
  1711,
  1635,
  1506,
  799,
  219,
  3250,
  3083,
  3954,
  1677,
  3713,
  3326,
  2081,
  3614,
  // 3552
  1652,
  2073,
  4657,
  1147,
  3041,
  1752,
  643,
  1961,
  147,
  1974,
  3955,
  6167,
  1716,
  2037,
  918,
  3007,
  // 3568
  1994,
  120,
  1537,
  118,
  609,
  3184,
  4345,
  740,
  3455,
  1219,
  332,
  1615,
  3830,
  6168,
  1621,
  2980,
  // 3584
  1582,
  783,
  212,
  553,
  2350,
  3714,
  1349,
  2433,
  2082,
  4124,
  889,
  6169,
  2310,
  1275,
  1410,
  973,
  // 3600
  166,
  1320,
  3456,
  1797,
  1215,
  3185,
  2885,
  1846,
  2590,
  2763,
  4658,
  629,
  822,
  3008,
  763,
  940,
  // 3616
  1990,
  2862,
  439,
  2409,
  1566,
  1240,
  1622,
  926,
  1282,
  1907,
  2764,
  654,
  2210,
  1607,
  327,
  1130,
  // 3632
  3956,
  1678,
  1623,
  6170,
  2434,
  2192,
  686,
  608,
  3831,
  3715,
  903,
  3957,
  3042,
  6171,
  2741,
  1522,
  // 3648
  1915,
  1105,
  1555,
  2552,
  1359,
  323,
  3251,
  4346,
  3457,
  738,
  1354,
  2553,
  2311,
  2334,
  1828,
  2003,
  // 3664
  3832,
  1753,
  2351,
  1227,
  6172,
  1887,
  4125,
  1478,
  6173,
  2410,
  1874,
  1712,
  1847,
  520,
  1204,
  2607,
  // 3680
  264,
  4659,
  836,
  2677,
  2102,
  600,
  4660,
  3833,
  2278,
  3084,
  6174,
  4347,
  3615,
  1342,
  640,
  532,
  // 3696
  543,
  2608,
  1888,
  2400,
  2591,
  1009,
  4348,
  1497,
  341,
  1737,
  3616,
  2723,
  1394,
  529,
  3252,
  1321,
  // 3712
  983,
  4661,
  1515,
  2120,
  971,
  2592,
  924,
  287,
  1662,
  3186,
  4349,
  2700,
  4350,
  1519,
  908,
  1948,
  // 3728
  2452,
  156,
  796,
  1629,
  1486,
  2223,
  2055,
  694,
  4126,
  1259,
  1036,
  3392,
  1213,
  2249,
  2742,
  1889,
  // 3744
  1230,
  3958,
  1015,
  910,
  408,
  559,
  3617,
  4662,
  746,
  725,
  935,
  4663,
  3959,
  3009,
  1289,
  563,
  // 3760
  867,
  4664,
  3960,
  1567,
  2981,
  2038,
  2626,
  988,
  2263,
  2381,
  4351,
  143,
  2374,
  704,
  1895,
  6175,
  // 3776
  1188,
  3716,
  2088,
  673,
  3085,
  2362,
  4352,
  484,
  1608,
  1921,
  2765,
  2918,
  215,
  904,
  3618,
  3537,
  // 3792
  894,
  509,
  976,
  3043,
  2701,
  3961,
  4353,
  2837,
  2982,
  498,
  6176,
  6177,
  1102,
  3538,
  1332,
  3393,
  // 3808
  1487,
  1636,
  1637,
  233,
  245,
  3962,
  383,
  650,
  995,
  3044,
  460,
  1520,
  1206,
  2352,
  749,
  3327,
  // 3824
  530,
  700,
  389,
  1438,
  1560,
  1773,
  3963,
  2264,
  719,
  2951,
  2724,
  3834,
  870,
  1832,
  1644,
  1e3,
  // 3840
  839,
  2474,
  3717,
  197,
  1630,
  3394,
  365,
  2886,
  3964,
  1285,
  2133,
  734,
  922,
  818,
  1106,
  732,
  // 3856
  480,
  2083,
  1774,
  3458,
  923,
  2279,
  1350,
  221,
  3086,
  85,
  2233,
  2234,
  3835,
  1585,
  3010,
  2147,
  // 3872
  1387,
  1705,
  2382,
  1619,
  2475,
  133,
  239,
  2802,
  1991,
  1016,
  2084,
  2383,
  411,
  2838,
  1113,
  651,
  // 3888
  1985,
  1160,
  3328,
  990,
  1863,
  3087,
  1048,
  1276,
  2647,
  265,
  2627,
  1599,
  3253,
  2056,
  150,
  638,
  // 3904
  2019,
  656,
  853,
  326,
  1479,
  680,
  1439,
  4354,
  1001,
  1759,
  413,
  3459,
  3395,
  2492,
  1431,
  459,
  // 3920
  4355,
  1125,
  3329,
  2265,
  1953,
  1450,
  2065,
  2863,
  849,
  351,
  2678,
  3131,
  3254,
  3255,
  1104,
  1577,
  // 3936
  227,
  1351,
  1645,
  2453,
  2193,
  1421,
  2887,
  812,
  2121,
  634,
  95,
  2435,
  201,
  2312,
  4665,
  1646,
  // 3952
  1671,
  2743,
  1601,
  2554,
  2702,
  2648,
  2280,
  1315,
  1366,
  2089,
  3132,
  1573,
  3718,
  3965,
  1729,
  1189,
  // 3968
  328,
  2679,
  1077,
  1940,
  1136,
  558,
  1283,
  964,
  1195,
  621,
  2074,
  1199,
  1743,
  3460,
  3619,
  1896,
  // 3984
  1916,
  1890,
  3836,
  2952,
  1154,
  2112,
  1064,
  862,
  378,
  3011,
  2066,
  2113,
  2803,
  1568,
  2839,
  6178,
  // 4000
  3088,
  2919,
  1941,
  1660,
  2004,
  1992,
  2194,
  142,
  707,
  1590,
  1708,
  1624,
  1922,
  1023,
  1836,
  1233,
  // 4016
  1004,
  2313,
  789,
  741,
  3620,
  6179,
  1609,
  2411,
  1200,
  4127,
  3719,
  3720,
  4666,
  2057,
  3721,
  593,
  // 4032
  2840,
  367,
  2920,
  1878,
  6180,
  3461,
  1521,
  628,
  1168,
  692,
  2211,
  2649,
  300,
  720,
  2067,
  2571,
  // 4048
  2953,
  3396,
  959,
  2504,
  3966,
  3539,
  3462,
  1977,
  701,
  6181,
  954,
  1043,
  800,
  681,
  183,
  3722,
  // 4064
  1803,
  1730,
  3540,
  4128,
  2103,
  815,
  2314,
  174,
  467,
  230,
  2454,
  1093,
  2134,
  755,
  3541,
  3397,
  // 4080
  1141,
  1162,
  6182,
  1738,
  2039,
  270,
  3256,
  2513,
  1005,
  1647,
  2185,
  3837,
  858,
  1679,
  1897,
  1719,
  // 4096
  2954,
  2324,
  1806,
  402,
  670,
  167,
  4129,
  1498,
  2158,
  2104,
  750,
  6183,
  915,
  189,
  1680,
  1551,
  // 4112
  455,
  4356,
  1501,
  2455,
  405,
  1095,
  2955,
  338,
  1586,
  1266,
  1819,
  570,
  641,
  1324,
  237,
  1556,
  // 4128
  2650,
  1388,
  3723,
  6184,
  1368,
  2384,
  1343,
  1978,
  3089,
  2436,
  879,
  3724,
  792,
  1191,
  758,
  3012,
  // 4144
  1411,
  2135,
  1322,
  4357,
  240,
  4667,
  1848,
  3725,
  1574,
  6185,
  420,
  3045,
  1546,
  1391,
  714,
  4358,
  // 4160
  1967,
  941,
  1864,
  863,
  664,
  426,
  560,
  1731,
  2680,
  1785,
  2864,
  1949,
  2363,
  403,
  3330,
  1415,
  // 4176
  1279,
  2136,
  1697,
  2335,
  204,
  721,
  2097,
  3838,
  90,
  6186,
  2085,
  2505,
  191,
  3967,
  124,
  2148,
  // 4192
  1376,
  1798,
  1178,
  1107,
  1898,
  1405,
  860,
  4359,
  1243,
  1272,
  2375,
  2983,
  1558,
  2456,
  1638,
  113,
  // 4208
  3621,
  578,
  1923,
  2609,
  880,
  386,
  4130,
  784,
  2186,
  2266,
  1422,
  2956,
  2172,
  1722,
  497,
  263,
  // 4224
  2514,
  1267,
  2412,
  2610,
  177,
  2703,
  3542,
  774,
  1927,
  1344,
  616,
  1432,
  1595,
  1018,
  172,
  4360,
  // 4240
  2325,
  911,
  4361,
  438,
  1468,
  3622,
  794,
  3968,
  2024,
  2173,
  1681,
  1829,
  2957,
  945,
  895,
  3090,
  // 4256
  575,
  2212,
  2476,
  475,
  2401,
  2681,
  785,
  2744,
  1745,
  2293,
  2555,
  1975,
  3133,
  2865,
  394,
  4668,
  // 4272
  3839,
  635,
  4131,
  639,
  202,
  1507,
  2195,
  2766,
  1345,
  1435,
  2572,
  3726,
  1908,
  1184,
  1181,
  2457,
  // 4288
  3727,
  3134,
  4362,
  843,
  2611,
  437,
  916,
  4669,
  234,
  769,
  1884,
  3046,
  3047,
  3623,
  833,
  6187,
  // 4304
  1639,
  2250,
  2402,
  1355,
  1185,
  2010,
  2047,
  999,
  525,
  1732,
  1290,
  1488,
  2612,
  948,
  1578,
  3728,
  // 4320
  2413,
  2477,
  1216,
  2725,
  2159,
  334,
  3840,
  1328,
  3624,
  2921,
  1525,
  4132,
  564,
  1056,
  891,
  4363,
  // 4336
  1444,
  1698,
  2385,
  2251,
  3729,
  1365,
  2281,
  2235,
  1717,
  6188,
  864,
  3841,
  2515,
  444,
  527,
  2767,
  // 4352
  2922,
  3625,
  544,
  461,
  6189,
  566,
  209,
  2437,
  3398,
  2098,
  1065,
  2068,
  3331,
  3626,
  3257,
  2137,
  // 4368  //last 512
  //Everything below is of no interest for detection purpose
  2138,
  2122,
  3730,
  2888,
  1995,
  1820,
  1044,
  6190,
  6191,
  6192,
  6193,
  6194,
  6195,
  6196,
  6197,
  6198,
  // 4384
  6199,
  6200,
  6201,
  6202,
  6203,
  6204,
  6205,
  4670,
  6206,
  6207,
  6208,
  6209,
  6210,
  6211,
  6212,
  6213,
  // 4400
  6214,
  6215,
  6216,
  6217,
  6218,
  6219,
  6220,
  6221,
  6222,
  6223,
  6224,
  6225,
  6226,
  6227,
  6228,
  6229,
  // 4416
  6230,
  6231,
  6232,
  6233,
  6234,
  6235,
  6236,
  6237,
  3187,
  6238,
  6239,
  3969,
  6240,
  6241,
  6242,
  6243,
  // 4432
  6244,
  4671,
  6245,
  6246,
  4672,
  6247,
  6248,
  4133,
  6249,
  6250,
  4364,
  6251,
  2923,
  2556,
  2613,
  4673,
  // 4448
  4365,
  3970,
  6252,
  6253,
  6254,
  6255,
  4674,
  6256,
  6257,
  6258,
  2768,
  2353,
  4366,
  4675,
  4676,
  3188,
  // 4464
  4367,
  3463,
  6259,
  4134,
  4677,
  4678,
  6260,
  2267,
  6261,
  3842,
  3332,
  4368,
  3543,
  6262,
  6263,
  6264,
  // 4480
  3013,
  1954,
  1928,
  4135,
  4679,
  6265,
  6266,
  2478,
  3091,
  6267,
  4680,
  4369,
  6268,
  6269,
  1699,
  6270,
  // 4496
  3544,
  4136,
  4681,
  6271,
  4137,
  6272,
  4370,
  2804,
  6273,
  6274,
  2593,
  3971,
  3972,
  4682,
  6275,
  2236,
  // 4512
  4683,
  6276,
  6277,
  4684,
  6278,
  6279,
  4138,
  3973,
  4685,
  6280,
  6281,
  3258,
  6282,
  6283,
  6284,
  6285,
  // 4528
  3974,
  4686,
  2841,
  3975,
  6286,
  6287,
  3545,
  6288,
  6289,
  4139,
  4687,
  4140,
  6290,
  4141,
  6291,
  4142,
  // 4544
  6292,
  6293,
  3333,
  6294,
  6295,
  6296,
  4371,
  6297,
  3399,
  6298,
  6299,
  4372,
  3976,
  6300,
  6301,
  6302,
  // 4560
  4373,
  6303,
  6304,
  3843,
  3731,
  6305,
  4688,
  4374,
  6306,
  6307,
  3259,
  2294,
  6308,
  3732,
  2530,
  4143,
  // 4576
  6309,
  4689,
  6310,
  6311,
  6312,
  3048,
  6313,
  6314,
  4690,
  3733,
  2237,
  6315,
  6316,
  2282,
  3334,
  6317,
  // 4592
  6318,
  3844,
  6319,
  6320,
  4691,
  6321,
  3400,
  4692,
  6322,
  4693,
  6323,
  3049,
  6324,
  4375,
  6325,
  3977,
  // 4608
  6326,
  6327,
  6328,
  3546,
  6329,
  4694,
  3335,
  6330,
  4695,
  4696,
  6331,
  6332,
  6333,
  6334,
  4376,
  3978,
  // 4624
  6335,
  4697,
  3979,
  4144,
  6336,
  3980,
  4698,
  6337,
  6338,
  6339,
  6340,
  6341,
  4699,
  4700,
  4701,
  6342,
  // 4640
  6343,
  4702,
  6344,
  6345,
  4703,
  6346,
  6347,
  4704,
  6348,
  4705,
  4706,
  3135,
  6349,
  4707,
  6350,
  4708,
  // 4656
  6351,
  4377,
  6352,
  4709,
  3734,
  4145,
  6353,
  2506,
  4710,
  3189,
  6354,
  3050,
  4711,
  3981,
  6355,
  3547,
  // 4672
  3014,
  4146,
  4378,
  3735,
  2651,
  3845,
  3260,
  3136,
  2224,
  1986,
  6356,
  3401,
  6357,
  4712,
  2594,
  3627,
  // 4688
  3137,
  2573,
  3736,
  3982,
  4713,
  3628,
  4714,
  4715,
  2682,
  3629,
  4716,
  6358,
  3630,
  4379,
  3631,
  6359,
  // 4704
  6360,
  6361,
  3983,
  6362,
  6363,
  6364,
  6365,
  4147,
  3846,
  4717,
  6366,
  6367,
  3737,
  2842,
  6368,
  4718,
  // 4720
  2628,
  6369,
  3261,
  6370,
  2386,
  6371,
  6372,
  3738,
  3984,
  4719,
  3464,
  4720,
  3402,
  6373,
  2924,
  3336,
  // 4736
  4148,
  2866,
  6374,
  2805,
  3262,
  4380,
  2704,
  2069,
  2531,
  3138,
  2806,
  2984,
  6375,
  2769,
  6376,
  4721,
  // 4752
  4722,
  3403,
  6377,
  6378,
  3548,
  6379,
  6380,
  2705,
  3092,
  1979,
  4149,
  2629,
  3337,
  2889,
  6381,
  3338,
  // 4768
  4150,
  2557,
  3339,
  4381,
  6382,
  3190,
  3263,
  3739,
  6383,
  4151,
  4723,
  4152,
  2558,
  2574,
  3404,
  3191,
  // 4784
  6384,
  6385,
  4153,
  6386,
  4724,
  4382,
  6387,
  6388,
  4383,
  6389,
  6390,
  4154,
  6391,
  4725,
  3985,
  6392,
  // 4800
  3847,
  4155,
  6393,
  6394,
  6395,
  6396,
  6397,
  3465,
  6398,
  4384,
  6399,
  6400,
  6401,
  6402,
  6403,
  6404,
  // 4816
  4156,
  6405,
  6406,
  6407,
  6408,
  2123,
  6409,
  6410,
  2326,
  3192,
  4726,
  6411,
  6412,
  6413,
  6414,
  4385,
  // 4832
  4157,
  6415,
  6416,
  4158,
  6417,
  3093,
  3848,
  6418,
  3986,
  6419,
  6420,
  3849,
  6421,
  6422,
  6423,
  4159,
  // 4848
  6424,
  6425,
  4160,
  6426,
  3740,
  6427,
  6428,
  6429,
  6430,
  3987,
  6431,
  4727,
  6432,
  2238,
  6433,
  6434,
  // 4864
  4386,
  3988,
  6435,
  6436,
  3632,
  6437,
  6438,
  2843,
  6439,
  6440,
  6441,
  6442,
  3633,
  6443,
  2958,
  6444,
  // 4880
  6445,
  3466,
  6446,
  2364,
  4387,
  3850,
  6447,
  4388,
  2959,
  3340,
  6448,
  3851,
  6449,
  4728,
  6450,
  6451,
  // 4896
  3264,
  4729,
  6452,
  3193,
  6453,
  4389,
  4390,
  2706,
  3341,
  4730,
  6454,
  3139,
  6455,
  3194,
  6456,
  3051,
  // 4912
  2124,
  3852,
  1602,
  4391,
  4161,
  3853,
  1158,
  3854,
  4162,
  3989,
  4392,
  3990,
  4731,
  4732,
  4393,
  2040,
  // 4928
  4163,
  4394,
  3265,
  6457,
  2807,
  3467,
  3855,
  6458,
  6459,
  6460,
  3991,
  3468,
  4733,
  4734,
  6461,
  3140,
  // 4944
  2960,
  6462,
  4735,
  6463,
  6464,
  6465,
  6466,
  4736,
  4737,
  4738,
  4739,
  6467,
  6468,
  4164,
  2403,
  3856,
  // 4960
  6469,
  6470,
  2770,
  2844,
  6471,
  4740,
  6472,
  6473,
  6474,
  6475,
  6476,
  6477,
  6478,
  3195,
  6479,
  4741,
  // 4976
  4395,
  6480,
  2867,
  6481,
  4742,
  2808,
  6482,
  2493,
  4165,
  6483,
  6484,
  6485,
  6486,
  2295,
  4743,
  6487,
  // 4992
  6488,
  6489,
  3634,
  6490,
  6491,
  6492,
  6493,
  6494,
  6495,
  6496,
  2985,
  4744,
  6497,
  6498,
  4745,
  6499,
  // 5008
  6500,
  2925,
  3141,
  4166,
  6501,
  6502,
  4746,
  6503,
  6504,
  4747,
  6505,
  6506,
  6507,
  2890,
  6508,
  6509,
  // 5024
  6510,
  6511,
  6512,
  6513,
  6514,
  6515,
  6516,
  6517,
  6518,
  6519,
  3469,
  4167,
  6520,
  6521,
  6522,
  4748,
  // 5040
  4396,
  3741,
  4397,
  4749,
  4398,
  3342,
  2125,
  4750,
  6523,
  4751,
  4752,
  4753,
  3052,
  6524,
  2961,
  4168,
  // 5056
  6525,
  4754,
  6526,
  4755,
  4399,
  2926,
  4169,
  6527,
  3857,
  6528,
  4400,
  4170,
  6529,
  4171,
  6530,
  6531,
  // 5072
  2595,
  6532,
  6533,
  6534,
  6535,
  3635,
  6536,
  6537,
  6538,
  6539,
  6540,
  6541,
  6542,
  4756,
  6543,
  6544,
  // 5088
  6545,
  6546,
  6547,
  6548,
  4401,
  6549,
  6550,
  6551,
  6552,
  4402,
  3405,
  4757,
  4403,
  6553,
  6554,
  6555,
  // 5104
  4172,
  3742,
  6556,
  6557,
  6558,
  3992,
  3636,
  6559,
  6560,
  3053,
  2726,
  6561,
  3549,
  4173,
  3054,
  4404,
  // 5120
  6562,
  6563,
  3993,
  4405,
  3266,
  3550,
  2809,
  4406,
  6564,
  6565,
  6566,
  4758,
  4759,
  6567,
  3743,
  6568,
  // 5136
  4760,
  3744,
  4761,
  3470,
  6569,
  6570,
  6571,
  4407,
  6572,
  3745,
  4174,
  6573,
  4175,
  2810,
  4176,
  3196,
  // 5152
  4762,
  6574,
  4177,
  6575,
  6576,
  2494,
  2891,
  3551,
  6577,
  6578,
  3471,
  6579,
  4408,
  6580,
  3015,
  3197,
  // 5168
  6581,
  3343,
  2532,
  3994,
  3858,
  6582,
  3094,
  3406,
  4409,
  6583,
  2892,
  4178,
  4763,
  4410,
  3016,
  4411,
  // 5184
  6584,
  3995,
  3142,
  3017,
  2683,
  6585,
  4179,
  6586,
  6587,
  4764,
  4412,
  6588,
  6589,
  4413,
  6590,
  2986,
  // 5200
  6591,
  2962,
  3552,
  6592,
  2963,
  3472,
  6593,
  6594,
  4180,
  4765,
  6595,
  6596,
  2225,
  3267,
  4414,
  6597,
  // 5216
  3407,
  3637,
  4766,
  6598,
  6599,
  3198,
  6600,
  4415,
  6601,
  3859,
  3199,
  6602,
  3473,
  4767,
  2811,
  4416,
  // 5232
  1856,
  3268,
  3200,
  2575,
  3996,
  3997,
  3201,
  4417,
  6603,
  3095,
  2927,
  6604,
  3143,
  6605,
  2268,
  6606,
  // 5248
  3998,
  3860,
  3096,
  2771,
  6607,
  6608,
  3638,
  2495,
  4768,
  6609,
  3861,
  6610,
  3269,
  2745,
  4769,
  4181,
  // 5264
  3553,
  6611,
  2845,
  3270,
  6612,
  6613,
  6614,
  3862,
  6615,
  6616,
  4770,
  4771,
  6617,
  3474,
  3999,
  4418,
  // 5280
  4419,
  6618,
  3639,
  3344,
  6619,
  4772,
  4182,
  6620,
  2126,
  6621,
  6622,
  6623,
  4420,
  4773,
  6624,
  3018,
  // 5296
  6625,
  4774,
  3554,
  6626,
  4183,
  2025,
  3746,
  6627,
  4184,
  2707,
  6628,
  4421,
  4422,
  3097,
  1775,
  4185,
  // 5312
  3555,
  6629,
  6630,
  2868,
  6631,
  6632,
  4423,
  6633,
  6634,
  4424,
  2414,
  2533,
  2928,
  6635,
  4186,
  2387,
  // 5328
  6636,
  4775,
  6637,
  4187,
  6638,
  1891,
  4425,
  3202,
  3203,
  6639,
  6640,
  4776,
  6641,
  3345,
  6642,
  6643,
  // 5344
  3640,
  6644,
  3475,
  3346,
  3641,
  4e3,
  6645,
  3144,
  6646,
  3098,
  2812,
  4188,
  3642,
  3204,
  6647,
  3863,
  // 5360
  3476,
  6648,
  3864,
  6649,
  4426,
  4001,
  6650,
  6651,
  6652,
  2576,
  6653,
  4189,
  4777,
  6654,
  6655,
  6656,
  // 5376
  2846,
  6657,
  3477,
  3205,
  4002,
  6658,
  4003,
  6659,
  3347,
  2252,
  6660,
  6661,
  6662,
  4778,
  6663,
  6664,
  // 5392
  6665,
  6666,
  6667,
  6668,
  6669,
  4779,
  4780,
  2048,
  6670,
  3478,
  3099,
  6671,
  3556,
  3747,
  4004,
  6672,
  // 5408
  6673,
  6674,
  3145,
  4005,
  3748,
  6675,
  6676,
  6677,
  6678,
  6679,
  3408,
  6680,
  6681,
  6682,
  6683,
  3206,
  // 5424
  3207,
  6684,
  6685,
  4781,
  4427,
  6686,
  4782,
  4783,
  4784,
  6687,
  6688,
  6689,
  4190,
  6690,
  6691,
  3479,
  // 5440
  6692,
  2746,
  6693,
  4428,
  6694,
  6695,
  6696,
  6697,
  6698,
  6699,
  4785,
  6700,
  6701,
  3208,
  2727,
  6702,
  // 5456
  3146,
  6703,
  6704,
  3409,
  2196,
  6705,
  4429,
  6706,
  6707,
  6708,
  2534,
  1996,
  6709,
  6710,
  6711,
  2747,
  // 5472
  6712,
  6713,
  6714,
  4786,
  3643,
  6715,
  4430,
  4431,
  6716,
  3557,
  6717,
  4432,
  4433,
  6718,
  6719,
  6720,
  // 5488
  6721,
  3749,
  6722,
  4006,
  4787,
  6723,
  6724,
  3644,
  4788,
  4434,
  6725,
  6726,
  4789,
  2772,
  6727,
  6728,
  // 5504
  6729,
  6730,
  6731,
  2708,
  3865,
  2813,
  4435,
  6732,
  6733,
  4790,
  4791,
  3480,
  6734,
  6735,
  6736,
  6737,
  // 5520
  4436,
  3348,
  6738,
  3410,
  4007,
  6739,
  6740,
  4008,
  6741,
  6742,
  4792,
  3411,
  4191,
  6743,
  6744,
  6745,
  // 5536
  6746,
  6747,
  3866,
  6748,
  3750,
  6749,
  6750,
  6751,
  6752,
  6753,
  6754,
  6755,
  3867,
  6756,
  4009,
  6757,
  // 5552
  4793,
  4794,
  6758,
  2814,
  2987,
  6759,
  6760,
  6761,
  4437,
  6762,
  6763,
  6764,
  6765,
  3645,
  6766,
  6767,
  // 5568
  3481,
  4192,
  6768,
  3751,
  6769,
  6770,
  2174,
  6771,
  3868,
  3752,
  6772,
  6773,
  6774,
  4193,
  4795,
  4438,
  // 5584
  3558,
  4796,
  4439,
  6775,
  4797,
  6776,
  6777,
  4798,
  6778,
  4799,
  3559,
  4800,
  6779,
  6780,
  6781,
  3482,
  // 5600
  6782,
  2893,
  6783,
  6784,
  4194,
  4801,
  4010,
  6785,
  6786,
  4440,
  6787,
  4011,
  6788,
  6789,
  6790,
  6791,
  // 5616
  6792,
  6793,
  4802,
  6794,
  6795,
  6796,
  4012,
  6797,
  6798,
  6799,
  6800,
  3349,
  4803,
  3483,
  6801,
  4804,
  // 5632
  4195,
  6802,
  4013,
  6803,
  6804,
  4196,
  6805,
  4014,
  4015,
  6806,
  2847,
  3271,
  2848,
  6807,
  3484,
  6808,
  // 5648
  6809,
  6810,
  4441,
  6811,
  4442,
  4197,
  4443,
  3272,
  4805,
  6812,
  3412,
  4016,
  1579,
  6813,
  6814,
  4017,
  // 5664
  6815,
  3869,
  6816,
  2964,
  6817,
  4806,
  6818,
  6819,
  4018,
  3646,
  6820,
  6821,
  4807,
  4019,
  4020,
  6822,
  // 5680
  6823,
  3560,
  6824,
  6825,
  4021,
  4444,
  6826,
  4198,
  6827,
  6828,
  4445,
  6829,
  6830,
  4199,
  4808,
  6831,
  // 5696
  6832,
  6833,
  3870,
  3019,
  2458,
  6834,
  3753,
  3413,
  3350,
  6835,
  4809,
  3871,
  4810,
  3561,
  4446,
  6836,
  // 5712
  6837,
  4447,
  4811,
  4812,
  6838,
  2459,
  4448,
  6839,
  4449,
  6840,
  6841,
  4022,
  3872,
  6842,
  4813,
  4814,
  // 5728
  6843,
  6844,
  4815,
  4200,
  4201,
  4202,
  6845,
  4023,
  6846,
  6847,
  4450,
  3562,
  3873,
  6848,
  6849,
  4816,
  // 5744
  4817,
  6850,
  4451,
  4818,
  2139,
  6851,
  3563,
  6852,
  6853,
  3351,
  6854,
  6855,
  3352,
  4024,
  2709,
  3414,
  // 5760
  4203,
  4452,
  6856,
  4204,
  6857,
  6858,
  3874,
  3875,
  6859,
  6860,
  4819,
  6861,
  6862,
  6863,
  6864,
  4453,
  // 5776
  3647,
  6865,
  6866,
  4820,
  6867,
  6868,
  6869,
  6870,
  4454,
  6871,
  2869,
  6872,
  6873,
  4821,
  6874,
  3754,
  // 5792
  6875,
  4822,
  4205,
  6876,
  6877,
  6878,
  3648,
  4206,
  4455,
  6879,
  4823,
  6880,
  4824,
  3876,
  6881,
  3055,
  // 5808
  4207,
  6882,
  3415,
  6883,
  6884,
  6885,
  4208,
  4209,
  6886,
  4210,
  3353,
  6887,
  3354,
  3564,
  3209,
  3485,
  // 5824
  2652,
  6888,
  2728,
  6889,
  3210,
  3755,
  6890,
  4025,
  4456,
  6891,
  4825,
  6892,
  6893,
  6894,
  6895,
  4211,
  // 5840
  6896,
  6897,
  6898,
  4826,
  6899,
  6900,
  4212,
  6901,
  4827,
  6902,
  2773,
  3565,
  6903,
  4828,
  6904,
  6905,
  // 5856
  6906,
  6907,
  3649,
  3650,
  6908,
  2849,
  3566,
  6909,
  3567,
  3100,
  6910,
  6911,
  6912,
  6913,
  6914,
  6915,
  // 5872
  4026,
  6916,
  3355,
  4829,
  3056,
  4457,
  3756,
  6917,
  3651,
  6918,
  4213,
  3652,
  2870,
  6919,
  4458,
  6920,
  // 5888
  2438,
  6921,
  6922,
  3757,
  2774,
  4830,
  6923,
  3356,
  4831,
  4832,
  6924,
  4833,
  4459,
  3653,
  2507,
  6925,
  // 5904
  4834,
  2535,
  6926,
  6927,
  3273,
  4027,
  3147,
  6928,
  3568,
  6929,
  6930,
  6931,
  4460,
  6932,
  3877,
  4461,
  // 5920
  2729,
  3654,
  6933,
  6934,
  6935,
  6936,
  2175,
  4835,
  2630,
  4214,
  4028,
  4462,
  4836,
  4215,
  6937,
  3148,
  // 5936
  4216,
  4463,
  4837,
  4838,
  4217,
  6938,
  6939,
  2850,
  4839,
  6940,
  4464,
  6941,
  6942,
  6943,
  4840,
  6944,
  // 5952
  4218,
  3274,
  4465,
  6945,
  6946,
  2710,
  6947,
  4841,
  4466,
  6948,
  6949,
  2894,
  6950,
  6951,
  4842,
  6952,
  // 5968
  4219,
  3057,
  2871,
  6953,
  6954,
  6955,
  6956,
  4467,
  6957,
  2711,
  6958,
  6959,
  6960,
  3275,
  3101,
  4843,
  // 5984
  6961,
  3357,
  3569,
  6962,
  4844,
  6963,
  6964,
  4468,
  4845,
  3570,
  6965,
  3102,
  4846,
  3758,
  6966,
  4847,
  // 6000
  3878,
  4848,
  4849,
  4029,
  6967,
  2929,
  3879,
  4850,
  4851,
  6968,
  6969,
  1733,
  6970,
  4220,
  6971,
  6972,
  // 6016
  6973,
  6974,
  6975,
  6976,
  4852,
  6977,
  6978,
  6979,
  6980,
  6981,
  6982,
  3759,
  6983,
  6984,
  6985,
  3486,
  // 6032
  3487,
  6986,
  3488,
  3416,
  6987,
  6988,
  6989,
  6990,
  6991,
  6992,
  6993,
  6994,
  6995,
  6996,
  6997,
  4853,
  // 6048
  6998,
  6999,
  4030,
  7e3,
  7001,
  3211,
  7002,
  7003,
  4221,
  7004,
  7005,
  3571,
  4031,
  7006,
  3572,
  7007,
  // 6064
  2614,
  4854,
  2577,
  7008,
  7009,
  2965,
  3655,
  3656,
  4855,
  2775,
  3489,
  3880,
  4222,
  4856,
  3881,
  4032,
  // 6080
  3882,
  3657,
  2730,
  3490,
  4857,
  7010,
  3149,
  7011,
  4469,
  4858,
  2496,
  3491,
  4859,
  2283,
  7012,
  7013,
  // 6096
  7014,
  2365,
  4860,
  4470,
  7015,
  7016,
  3760,
  7017,
  7018,
  4223,
  1917,
  7019,
  7020,
  7021,
  4471,
  7022,
  // 6112
  2776,
  4472,
  7023,
  7024,
  7025,
  7026,
  4033,
  7027,
  3573,
  4224,
  4861,
  4034,
  4862,
  7028,
  7029,
  1929,
  // 6128
  3883,
  4035,
  7030,
  4473,
  3058,
  7031,
  2536,
  3761,
  3884,
  7032,
  4036,
  7033,
  2966,
  2895,
  1968,
  4474,
  // 6144
  3276,
  4225,
  3417,
  3492,
  4226,
  2105,
  7034,
  7035,
  1754,
  2596,
  3762,
  4227,
  4863,
  4475,
  3763,
  4864,
  // 6160
  3764,
  2615,
  2777,
  3103,
  3765,
  3658,
  3418,
  4865,
  2296,
  3766,
  2815,
  7036,
  7037,
  7038,
  3574,
  2872,
  // 6176
  3277,
  4476,
  7039,
  4037,
  4477,
  7040,
  7041,
  4038,
  7042,
  7043,
  7044,
  7045,
  7046,
  7047,
  2537,
  7048,
  // 6192
  7049,
  7050,
  7051,
  7052,
  7053,
  7054,
  4478,
  7055,
  7056,
  3767,
  3659,
  4228,
  3575,
  7057,
  7058,
  4229,
  // 6208
  7059,
  7060,
  7061,
  3660,
  7062,
  3212,
  7063,
  3885,
  4039,
  2460,
  7064,
  7065,
  7066,
  7067,
  7068,
  7069,
  // 6224
  7070,
  7071,
  7072,
  7073,
  7074,
  4866,
  3768,
  4867,
  7075,
  7076,
  7077,
  7078,
  4868,
  3358,
  3278,
  2653,
  // 6240
  7079,
  7080,
  4479,
  3886,
  7081,
  7082,
  4869,
  7083,
  7084,
  7085,
  7086,
  7087,
  7088,
  2538,
  7089,
  7090,
  // 6256
  7091,
  4040,
  3150,
  3769,
  4870,
  4041,
  2896,
  3359,
  4230,
  2930,
  7092,
  3279,
  7093,
  2967,
  4480,
  3213,
  // 6272
  4481,
  3661,
  7094,
  7095,
  7096,
  7097,
  7098,
  7099,
  7100,
  7101,
  7102,
  2461,
  3770,
  7103,
  7104,
  4231,
  // 6288
  3151,
  7105,
  7106,
  7107,
  4042,
  3662,
  7108,
  7109,
  4871,
  3663,
  4872,
  4043,
  3059,
  7110,
  7111,
  7112,
  // 6304
  3493,
  2988,
  7113,
  4873,
  7114,
  7115,
  7116,
  3771,
  4874,
  7117,
  7118,
  4232,
  4875,
  7119,
  3576,
  2336,
  // 6320
  4876,
  7120,
  4233,
  3419,
  4044,
  4877,
  4878,
  4482,
  4483,
  4879,
  4484,
  4234,
  7121,
  3772,
  4880,
  1045,
  // 6336
  3280,
  3664,
  4881,
  4882,
  7122,
  7123,
  7124,
  7125,
  4883,
  7126,
  2778,
  7127,
  4485,
  4486,
  7128,
  4884,
  // 6352
  3214,
  3887,
  7129,
  7130,
  3215,
  7131,
  4885,
  4045,
  7132,
  7133,
  4046,
  7134,
  7135,
  7136,
  7137,
  7138,
  // 6368
  7139,
  7140,
  7141,
  7142,
  7143,
  4235,
  7144,
  4886,
  7145,
  7146,
  7147,
  4887,
  7148,
  7149,
  7150,
  4487,
  // 6384
  4047,
  4488,
  7151,
  7152,
  4888,
  4048,
  2989,
  3888,
  7153,
  3665,
  7154,
  4049,
  7155,
  7156,
  7157,
  7158,
  // 6400
  7159,
  7160,
  2931,
  4889,
  4890,
  4489,
  7161,
  2631,
  3889,
  4236,
  2779,
  7162,
  7163,
  4891,
  7164,
  3060,
  // 6416
  7165,
  1672,
  4892,
  7166,
  4893,
  4237,
  3281,
  4894,
  7167,
  7168,
  3666,
  7169,
  3494,
  7170,
  7171,
  4050,
  // 6432
  7172,
  7173,
  3104,
  3360,
  3420,
  4490,
  4051,
  2684,
  4052,
  7174,
  4053,
  7175,
  7176,
  7177,
  2253,
  4054,
  // 6448
  7178,
  7179,
  4895,
  7180,
  3152,
  3890,
  3153,
  4491,
  3216,
  7181,
  7182,
  7183,
  2968,
  4238,
  4492,
  4055,
  // 6464
  7184,
  2990,
  7185,
  2479,
  7186,
  7187,
  4493,
  7188,
  7189,
  7190,
  7191,
  7192,
  4896,
  7193,
  4897,
  2969,
  // 6480
  4494,
  4898,
  7194,
  3495,
  7195,
  7196,
  4899,
  4495,
  7197,
  3105,
  2731,
  7198,
  4900,
  7199,
  7200,
  7201,
  // 6496
  4056,
  7202,
  3361,
  7203,
  7204,
  4496,
  4901,
  4902,
  7205,
  4497,
  7206,
  7207,
  2315,
  4903,
  7208,
  4904,
  // 6512
  7209,
  4905,
  2851,
  7210,
  7211,
  3577,
  7212,
  3578,
  4906,
  7213,
  4057,
  3667,
  4907,
  7214,
  4058,
  2354,
  // 6528
  3891,
  2376,
  3217,
  3773,
  7215,
  7216,
  7217,
  7218,
  7219,
  4498,
  7220,
  4908,
  3282,
  2685,
  7221,
  3496,
  // 6544
  4909,
  2632,
  3154,
  4910,
  7222,
  2337,
  7223,
  4911,
  7224,
  7225,
  7226,
  4912,
  4913,
  3283,
  4239,
  4499,
  // 6560
  7227,
  2816,
  7228,
  7229,
  7230,
  7231,
  7232,
  7233,
  7234,
  4914,
  4500,
  4501,
  7235,
  7236,
  7237,
  2686,
  // 6576
  7238,
  4915,
  7239,
  2897,
  4502,
  7240,
  4503,
  7241,
  2516,
  7242,
  4504,
  3362,
  3218,
  7243,
  7244,
  7245,
  // 6592
  4916,
  7246,
  7247,
  4505,
  3363,
  7248,
  7249,
  7250,
  7251,
  3774,
  4506,
  7252,
  7253,
  4917,
  7254,
  7255,
  // 6608
  3284,
  2991,
  4918,
  4919,
  3219,
  3892,
  4920,
  3106,
  3497,
  4921,
  7256,
  7257,
  7258,
  4922,
  7259,
  4923,
  // 6624
  3364,
  4507,
  4508,
  4059,
  7260,
  4240,
  3498,
  7261,
  7262,
  4924,
  7263,
  2992,
  3893,
  4060,
  3220,
  7264,
  // 6640
  7265,
  7266,
  7267,
  7268,
  7269,
  4509,
  3775,
  7270,
  2817,
  7271,
  4061,
  4925,
  4510,
  3776,
  7272,
  4241,
  // 6656
  4511,
  3285,
  7273,
  7274,
  3499,
  7275,
  7276,
  7277,
  4062,
  4512,
  4926,
  7278,
  3107,
  3894,
  7279,
  7280,
  // 6672
  4927,
  7281,
  4513,
  7282,
  7283,
  3668,
  7284,
  7285,
  4242,
  4514,
  4243,
  7286,
  2058,
  4515,
  4928,
  4929,
  // 6688
  4516,
  7287,
  3286,
  4244,
  7288,
  4517,
  7289,
  7290,
  7291,
  3669,
  7292,
  7293,
  4930,
  4931,
  4932,
  2355,
  // 6704
  4933,
  7294,
  2633,
  4518,
  7295,
  4245,
  7296,
  7297,
  4519,
  7298,
  7299,
  4520,
  4521,
  4934,
  7300,
  4246,
  // 6720
  4522,
  7301,
  7302,
  7303,
  3579,
  7304,
  4247,
  4935,
  7305,
  4936,
  7306,
  7307,
  7308,
  7309,
  3777,
  7310,
  // 6736
  4523,
  7311,
  7312,
  7313,
  4248,
  3580,
  7314,
  4524,
  3778,
  4249,
  7315,
  3581,
  7316,
  3287,
  7317,
  3221,
  // 6752
  7318,
  4937,
  7319,
  7320,
  7321,
  7322,
  7323,
  7324,
  4938,
  4939,
  7325,
  4525,
  7326,
  7327,
  7328,
  4063,
  // 6768
  7329,
  7330,
  4940,
  7331,
  7332,
  4941,
  7333,
  4526,
  7334,
  3500,
  2780,
  1741,
  4942,
  2026,
  1742,
  7335,
  // 6784
  7336,
  3582,
  4527,
  2388,
  7337,
  7338,
  7339,
  4528,
  7340,
  4250,
  4943,
  7341,
  7342,
  7343,
  4944,
  7344,
  // 6800
  7345,
  7346,
  3020,
  7347,
  4945,
  7348,
  7349,
  7350,
  7351,
  3895,
  7352,
  3896,
  4064,
  3897,
  7353,
  7354,
  // 6816
  7355,
  4251,
  7356,
  7357,
  3898,
  7358,
  3779,
  7359,
  3780,
  3288,
  7360,
  7361,
  4529,
  7362,
  4946,
  4530,
  // 6832
  2027,
  7363,
  3899,
  4531,
  4947,
  3222,
  3583,
  7364,
  4948,
  7365,
  7366,
  7367,
  7368,
  4949,
  3501,
  4950,
  // 6848
  3781,
  4951,
  4532,
  7369,
  2517,
  4952,
  4252,
  4953,
  3155,
  7370,
  4954,
  4955,
  4253,
  2518,
  4533,
  7371,
  // 6864
  7372,
  2712,
  4254,
  7373,
  7374,
  7375,
  3670,
  4956,
  3671,
  7376,
  2389,
  3502,
  4065,
  7377,
  2338,
  7378,
  // 6880
  7379,
  7380,
  7381,
  3061,
  7382,
  4957,
  7383,
  7384,
  7385,
  7386,
  4958,
  4534,
  7387,
  7388,
  2993,
  7389,
  // 6896
  3062,
  7390,
  4959,
  7391,
  7392,
  7393,
  4960,
  3108,
  4961,
  7394,
  4535,
  7395,
  4962,
  3421,
  4536,
  7396,
  // 6912
  4963,
  7397,
  4964,
  1857,
  7398,
  4965,
  7399,
  7400,
  2176,
  3584,
  4966,
  7401,
  7402,
  3422,
  4537,
  3900,
  // 6928
  3585,
  7403,
  3782,
  7404,
  2852,
  7405,
  7406,
  7407,
  4538,
  3783,
  2654,
  3423,
  4967,
  4539,
  7408,
  3784,
  // 6944
  3586,
  2853,
  4540,
  4541,
  7409,
  3901,
  7410,
  3902,
  7411,
  7412,
  3785,
  3109,
  2327,
  3903,
  7413,
  7414,
  // 6960
  2970,
  4066,
  2932,
  7415,
  7416,
  7417,
  3904,
  3672,
  3424,
  7418,
  4542,
  4543,
  4544,
  7419,
  4968,
  7420,
  // 6976
  7421,
  4255,
  7422,
  7423,
  7424,
  7425,
  7426,
  4067,
  7427,
  3673,
  3365,
  4545,
  7428,
  3110,
  2559,
  3674,
  // 6992
  7429,
  7430,
  3156,
  7431,
  7432,
  3503,
  7433,
  3425,
  4546,
  7434,
  3063,
  2873,
  7435,
  3223,
  4969,
  4547,
  // 7008
  4548,
  2898,
  4256,
  4068,
  7436,
  4069,
  3587,
  3786,
  2933,
  3787,
  4257,
  4970,
  4971,
  3788,
  7437,
  4972,
  // 7024
  3064,
  7438,
  4549,
  7439,
  7440,
  7441,
  7442,
  7443,
  4973,
  3905,
  7444,
  2874,
  7445,
  7446,
  7447,
  7448,
  // 7040
  3021,
  7449,
  4550,
  3906,
  3588,
  4974,
  7450,
  7451,
  3789,
  3675,
  7452,
  2578,
  7453,
  4070,
  7454,
  7455,
  // 7056
  7456,
  4258,
  3676,
  7457,
  4975,
  7458,
  4976,
  4259,
  3790,
  3504,
  2634,
  4977,
  3677,
  4551,
  4260,
  7459,
  // 7072
  7460,
  7461,
  7462,
  3907,
  4261,
  4978,
  7463,
  7464,
  7465,
  7466,
  4979,
  4980,
  7467,
  7468,
  2213,
  4262,
  // 7088
  7469,
  7470,
  7471,
  3678,
  4981,
  7472,
  2439,
  7473,
  4263,
  3224,
  3289,
  7474,
  3908,
  2415,
  4982,
  7475,
  // 7104
  4264,
  7476,
  4983,
  2655,
  7477,
  7478,
  2732,
  4552,
  2854,
  2875,
  7479,
  7480,
  4265,
  7481,
  4553,
  4984,
  // 7120
  7482,
  7483,
  4266,
  7484,
  3679,
  3366,
  3680,
  2818,
  2781,
  2782,
  3367,
  3589,
  4554,
  3065,
  7485,
  4071,
  // 7136
  2899,
  7486,
  7487,
  3157,
  2462,
  4072,
  4555,
  4073,
  4985,
  4986,
  3111,
  4267,
  2687,
  3368,
  4556,
  4074,
  // 7152
  3791,
  4268,
  7488,
  3909,
  2783,
  7489,
  2656,
  1962,
  3158,
  4557,
  4987,
  1963,
  3159,
  3160,
  7490,
  3112,
  // 7168
  4988,
  4989,
  3022,
  4990,
  4991,
  3792,
  2855,
  7491,
  7492,
  2971,
  4558,
  7493,
  7494,
  4992,
  7495,
  7496,
  // 7184
  7497,
  7498,
  4993,
  7499,
  3426,
  4559,
  4994,
  7500,
  3681,
  4560,
  4269,
  4270,
  3910,
  7501,
  4075,
  4995,
  // 7200
  4271,
  7502,
  7503,
  4076,
  7504,
  4996,
  7505,
  3225,
  4997,
  4272,
  4077,
  2819,
  3023,
  7506,
  7507,
  2733,
  // 7216
  4561,
  7508,
  4562,
  7509,
  3369,
  3793,
  7510,
  3590,
  2508,
  7511,
  7512,
  4273,
  3113,
  2994,
  2616,
  7513,
  // 7232
  7514,
  7515,
  7516,
  7517,
  7518,
  2820,
  3911,
  4078,
  2748,
  7519,
  7520,
  4563,
  4998,
  7521,
  7522,
  7523,
  // 7248
  7524,
  4999,
  4274,
  7525,
  4564,
  3682,
  2239,
  4079,
  4565,
  7526,
  7527,
  7528,
  7529,
  5e3,
  7530,
  7531,
  // 7264
  5001,
  4275,
  3794,
  7532,
  7533,
  7534,
  3066,
  5002,
  4566,
  3161,
  7535,
  7536,
  4080,
  7537,
  3162,
  7538,
  // 7280
  7539,
  4567,
  7540,
  7541,
  7542,
  7543,
  7544,
  7545,
  5003,
  7546,
  4568,
  7547,
  7548,
  7549,
  7550,
  7551,
  // 7296
  7552,
  7553,
  7554,
  7555,
  7556,
  5004,
  7557,
  7558,
  7559,
  5005,
  7560,
  3795,
  7561,
  4569,
  7562,
  7563,
  // 7312
  7564,
  2821,
  3796,
  4276,
  4277,
  4081,
  7565,
  2876,
  7566,
  5006,
  7567,
  7568,
  2900,
  7569,
  3797,
  3912,
  // 7328
  7570,
  7571,
  7572,
  4278,
  7573,
  7574,
  7575,
  5007,
  7576,
  7577,
  5008,
  7578,
  7579,
  4279,
  2934,
  7580,
  // 7344
  7581,
  5009,
  7582,
  4570,
  7583,
  4280,
  7584,
  7585,
  7586,
  4571,
  4572,
  3913,
  7587,
  4573,
  3505,
  7588,
  // 7360
  5010,
  7589,
  7590,
  7591,
  7592,
  3798,
  4574,
  7593,
  7594,
  5011,
  7595,
  4281,
  7596,
  7597,
  7598,
  4282,
  // 7376
  5012,
  7599,
  7600,
  5013,
  3163,
  7601,
  5014,
  7602,
  3914,
  7603,
  7604,
  2734,
  4575,
  4576,
  4577,
  7605,
  // 7392
  7606,
  7607,
  7608,
  7609,
  3506,
  5015,
  4578,
  7610,
  4082,
  7611,
  2822,
  2901,
  2579,
  3683,
  3024,
  4579,
  // 7408
  3507,
  7612,
  4580,
  7613,
  3226,
  3799,
  5016,
  7614,
  7615,
  7616,
  7617,
  7618,
  7619,
  7620,
  2995,
  3290,
  // 7424
  7621,
  4083,
  7622,
  5017,
  7623,
  7624,
  7625,
  7626,
  7627,
  4581,
  3915,
  7628,
  3291,
  7629,
  5018,
  7630,
  // 7440
  7631,
  7632,
  7633,
  4084,
  7634,
  7635,
  3427,
  3800,
  7636,
  7637,
  4582,
  7638,
  5019,
  4583,
  5020,
  7639,
  // 7456
  3916,
  7640,
  3801,
  5021,
  4584,
  4283,
  7641,
  7642,
  3428,
  3591,
  2269,
  7643,
  2617,
  7644,
  4585,
  3592,
  // 7472
  7645,
  4586,
  2902,
  7646,
  7647,
  3227,
  5022,
  7648,
  4587,
  7649,
  4284,
  7650,
  7651,
  7652,
  4588,
  2284,
  // 7488
  7653,
  5023,
  7654,
  7655,
  7656,
  4589,
  5024,
  3802,
  7657,
  7658,
  5025,
  3508,
  4590,
  7659,
  7660,
  7661,
  // 7504
  1969,
  5026,
  7662,
  7663,
  3684,
  1821,
  2688,
  7664,
  2028,
  2509,
  4285,
  7665,
  2823,
  1841,
  7666,
  2689,
  // 7520
  3114,
  7667,
  3917,
  4085,
  2160,
  5027,
  5028,
  2972,
  7668,
  5029,
  7669,
  7670,
  7671,
  3593,
  4086,
  7672,
  // 7536
  4591,
  4087,
  5030,
  3803,
  7673,
  7674,
  7675,
  7676,
  7677,
  7678,
  7679,
  4286,
  2366,
  4592,
  4593,
  3067,
  // 7552
  2328,
  7680,
  7681,
  4594,
  3594,
  3918,
  2029,
  4287,
  7682,
  5031,
  3919,
  3370,
  4288,
  4595,
  2856,
  7683,
  // 7568
  3509,
  7684,
  7685,
  5032,
  5033,
  7686,
  7687,
  3804,
  2784,
  7688,
  7689,
  7690,
  7691,
  3371,
  7692,
  7693,
  // 7584
  2877,
  5034,
  7694,
  7695,
  3920,
  4289,
  4088,
  7696,
  7697,
  7698,
  5035,
  7699,
  5036,
  4290,
  5037,
  5038,
  // 7600
  5039,
  7700,
  7701,
  7702,
  5040,
  5041,
  3228,
  7703,
  1760,
  7704,
  5042,
  3229,
  4596,
  2106,
  4089,
  7705,
  // 7616
  4597,
  2824,
  5043,
  2107,
  3372,
  7706,
  4291,
  4090,
  5044,
  7707,
  4091,
  7708,
  5045,
  3025,
  3805,
  4598,
  // 7632
  4292,
  4293,
  4294,
  3373,
  7709,
  4599,
  7710,
  5046,
  7711,
  7712,
  5047,
  5048,
  3806,
  7713,
  7714,
  7715,
  // 7648
  5049,
  7716,
  7717,
  7718,
  7719,
  4600,
  5050,
  7720,
  7721,
  7722,
  5051,
  7723,
  4295,
  3429,
  7724,
  7725,
  // 7664
  7726,
  7727,
  3921,
  7728,
  3292,
  5052,
  4092,
  7729,
  7730,
  7731,
  7732,
  7733,
  7734,
  7735,
  5053,
  5054,
  // 7680
  7736,
  7737,
  7738,
  7739,
  3922,
  3685,
  7740,
  7741,
  7742,
  7743,
  2635,
  5055,
  7744,
  5056,
  4601,
  7745,
  // 7696
  7746,
  2560,
  7747,
  7748,
  7749,
  7750,
  3923,
  7751,
  7752,
  7753,
  7754,
  7755,
  4296,
  2903,
  7756,
  7757,
  // 7712
  7758,
  7759,
  7760,
  3924,
  7761,
  5057,
  4297,
  7762,
  7763,
  5058,
  4298,
  7764,
  4093,
  7765,
  7766,
  5059,
  // 7728
  3925,
  7767,
  7768,
  7769,
  7770,
  7771,
  7772,
  7773,
  7774,
  7775,
  7776,
  3595,
  7777,
  4299,
  5060,
  4094,
  // 7744
  7778,
  3293,
  5061,
  7779,
  7780,
  4300,
  7781,
  7782,
  4602,
  7783,
  3596,
  7784,
  7785,
  3430,
  2367,
  7786,
  // 7760
  3164,
  5062,
  5063,
  4301,
  7787,
  7788,
  4095,
  5064,
  5065,
  7789,
  3374,
  3115,
  7790,
  7791,
  7792,
  7793,
  // 7776
  7794,
  7795,
  7796,
  3597,
  4603,
  7797,
  7798,
  3686,
  3116,
  3807,
  5066,
  7799,
  7800,
  5067,
  7801,
  7802,
  // 7792
  4604,
  4302,
  5068,
  4303,
  4096,
  7803,
  7804,
  3294,
  7805,
  7806,
  5069,
  4605,
  2690,
  7807,
  3026,
  7808,
  // 7808
  7809,
  7810,
  7811,
  7812,
  7813,
  7814,
  7815,
  7816,
  7817,
  7818,
  7819,
  7820,
  7821,
  7822,
  7823,
  7824,
  // 7824
  7825,
  7826,
  7827,
  7828,
  7829,
  7830,
  7831,
  7832,
  7833,
  7834,
  7835,
  7836,
  7837,
  7838,
  7839,
  7840,
  // 7840
  7841,
  7842,
  7843,
  7844,
  7845,
  7846,
  7847,
  7848,
  7849,
  7850,
  7851,
  7852,
  7853,
  7854,
  7855,
  7856,
  // 7856
  7857,
  7858,
  7859,
  7860,
  7861,
  7862,
  7863,
  7864,
  7865,
  7866,
  7867,
  7868,
  7869,
  7870,
  7871,
  7872,
  // 7872
  7873,
  7874,
  7875,
  7876,
  7877,
  7878,
  7879,
  7880,
  7881,
  7882,
  7883,
  7884,
  7885,
  7886,
  7887,
  7888,
  // 7888
  7889,
  7890,
  7891,
  7892,
  7893,
  7894,
  7895,
  7896,
  7897,
  7898,
  7899,
  7900,
  7901,
  7902,
  7903,
  7904,
  // 7904
  7905,
  7906,
  7907,
  7908,
  7909,
  7910,
  7911,
  7912,
  7913,
  7914,
  7915,
  7916,
  7917,
  7918,
  7919,
  7920,
  // 7920
  7921,
  7922,
  7923,
  7924,
  3926,
  7925,
  7926,
  7927,
  7928,
  7929,
  7930,
  7931,
  7932,
  7933,
  7934,
  7935,
  // 7936
  7936,
  7937,
  7938,
  7939,
  7940,
  7941,
  7942,
  7943,
  7944,
  7945,
  7946,
  7947,
  7948,
  7949,
  7950,
  7951,
  // 7952
  7952,
  7953,
  7954,
  7955,
  7956,
  7957,
  7958,
  7959,
  7960,
  7961,
  7962,
  7963,
  7964,
  7965,
  7966,
  7967,
  // 7968
  7968,
  7969,
  7970,
  7971,
  7972,
  7973,
  7974,
  7975,
  7976,
  7977,
  7978,
  7979,
  7980,
  7981,
  7982,
  7983,
  // 7984
  7984,
  7985,
  7986,
  7987,
  7988,
  7989,
  7990,
  7991,
  7992,
  7993,
  7994,
  7995,
  7996,
  7997,
  7998,
  7999,
  // 8000
  8e3,
  8001,
  8002,
  8003,
  8004,
  8005,
  8006,
  8007,
  8008,
  8009,
  8010,
  8011,
  8012,
  8013,
  8014,
  8015,
  // 8016
  8016,
  8017,
  8018,
  8019,
  8020,
  8021,
  8022,
  8023,
  8024,
  8025,
  8026,
  8027,
  8028,
  8029,
  8030,
  8031,
  // 8032
  8032,
  8033,
  8034,
  8035,
  8036,
  8037,
  8038,
  8039,
  8040,
  8041,
  8042,
  8043,
  8044,
  8045,
  8046,
  8047,
  // 8048
  8048,
  8049,
  8050,
  8051,
  8052,
  8053,
  8054,
  8055,
  8056,
  8057,
  8058,
  8059,
  8060,
  8061,
  8062,
  8063,
  // 8064
  8064,
  8065,
  8066,
  8067,
  8068,
  8069,
  8070,
  8071,
  8072,
  8073,
  8074,
  8075,
  8076,
  8077,
  8078,
  8079,
  // 8080
  8080,
  8081,
  8082,
  8083,
  8084,
  8085,
  8086,
  8087,
  8088,
  8089,
  8090,
  8091,
  8092,
  8093,
  8094,
  8095,
  // 8096
  8096,
  8097,
  8098,
  8099,
  8100,
  8101,
  8102,
  8103,
  8104,
  8105,
  8106,
  8107,
  8108,
  8109,
  8110,
  8111,
  // 8112
  8112,
  8113,
  8114,
  8115,
  8116,
  8117,
  8118,
  8119,
  8120,
  8121,
  8122,
  8123,
  8124,
  8125,
  8126,
  8127,
  // 8128
  8128,
  8129,
  8130,
  8131,
  8132,
  8133,
  8134,
  8135,
  8136,
  8137,
  8138,
  8139,
  8140,
  8141,
  8142,
  8143,
  // 8144
  8144,
  8145,
  8146,
  8147,
  8148,
  8149,
  8150,
  8151,
  8152,
  8153,
  8154,
  8155,
  8156,
  8157,
  8158,
  8159,
  // 8160
  8160,
  8161,
  8162,
  8163,
  8164,
  8165,
  8166,
  8167,
  8168,
  8169,
  8170,
  8171,
  8172,
  8173,
  8174,
  8175,
  // 8176
  8176,
  8177,
  8178,
  8179,
  8180,
  8181,
  8182,
  8183,
  8184,
  8185,
  8186,
  8187,
  8188,
  8189,
  8190,
  8191,
  // 8192
  8192,
  8193,
  8194,
  8195,
  8196,
  8197,
  8198,
  8199,
  8200,
  8201,
  8202,
  8203,
  8204,
  8205,
  8206,
  8207,
  // 8208
  8208,
  8209,
  8210,
  8211,
  8212,
  8213,
  8214,
  8215,
  8216,
  8217,
  8218,
  8219,
  8220,
  8221,
  8222,
  8223,
  // 8224
  8224,
  8225,
  8226,
  8227,
  8228,
  8229,
  8230,
  8231,
  8232,
  8233,
  8234,
  8235,
  8236,
  8237,
  8238,
  8239,
  // 8240
  8240,
  8241,
  8242,
  8243,
  8244,
  8245,
  8246,
  8247,
  8248,
  8249,
  8250,
  8251,
  8252,
  8253,
  8254,
  8255,
  // 8256
  8256,
  8257,
  8258,
  8259,
  8260,
  8261,
  8262,
  8263,
  8264,
  8265,
  8266,
  8267,
  8268,
  8269,
  8270,
  8271
  // 8272
];
var Ve = {};
Ve.EUCTW_TYPICAL_DISTRIBUTION_RATIO = 0.75;
Ve.EUCTW_TABLE_SIZE = 8102;
Ve.EUCTWCharToFreqOrder = [
  1,
  1800,
  1506,
  255,
  1431,
  198,
  9,
  82,
  6,
  7310,
  177,
  202,
  3615,
  1256,
  2808,
  110,
  // 2742
  3735,
  33,
  3241,
  261,
  76,
  44,
  2113,
  16,
  2931,
  2184,
  1176,
  659,
  3868,
  26,
  3404,
  2643,
  // 2758
  1198,
  3869,
  3313,
  4060,
  410,
  2211,
  302,
  590,
  361,
  1963,
  8,
  204,
  58,
  4296,
  7311,
  1931,
  // 2774
  63,
  7312,
  7313,
  317,
  1614,
  75,
  222,
  159,
  4061,
  2412,
  1480,
  7314,
  3500,
  3068,
  224,
  2809,
  // 2790
  3616,
  3,
  10,
  3870,
  1471,
  29,
  2774,
  1135,
  2852,
  1939,
  873,
  130,
  3242,
  1123,
  312,
  7315,
  // 2806
  4297,
  2051,
  507,
  252,
  682,
  7316,
  142,
  1914,
  124,
  206,
  2932,
  34,
  3501,
  3173,
  64,
  604,
  // 2822
  7317,
  2494,
  1976,
  1977,
  155,
  1990,
  645,
  641,
  1606,
  7318,
  3405,
  337,
  72,
  406,
  7319,
  80,
  // 2838
  630,
  238,
  3174,
  1509,
  263,
  939,
  1092,
  2644,
  756,
  1440,
  1094,
  3406,
  449,
  69,
  2969,
  591,
  // 2854
  179,
  2095,
  471,
  115,
  2034,
  1843,
  60,
  50,
  2970,
  134,
  806,
  1868,
  734,
  2035,
  3407,
  180,
  // 2870
  995,
  1607,
  156,
  537,
  2893,
  688,
  7320,
  319,
  1305,
  779,
  2144,
  514,
  2374,
  298,
  4298,
  359,
  // 2886
  2495,
  90,
  2707,
  1338,
  663,
  11,
  906,
  1099,
  2545,
  20,
  2436,
  182,
  532,
  1716,
  7321,
  732,
  // 2902
  1376,
  4062,
  1311,
  1420,
  3175,
  25,
  2312,
  1056,
  113,
  399,
  382,
  1949,
  242,
  3408,
  2467,
  529,
  // 2918
  3243,
  475,
  1447,
  3617,
  7322,
  117,
  21,
  656,
  810,
  1297,
  2295,
  2329,
  3502,
  7323,
  126,
  4063,
  // 2934
  706,
  456,
  150,
  613,
  4299,
  71,
  1118,
  2036,
  4064,
  145,
  3069,
  85,
  835,
  486,
  2114,
  1246,
  // 2950
  1426,
  428,
  727,
  1285,
  1015,
  800,
  106,
  623,
  303,
  1281,
  7324,
  2127,
  2354,
  347,
  3736,
  221,
  // 2966
  3503,
  3110,
  7325,
  1955,
  1153,
  4065,
  83,
  296,
  1199,
  3070,
  192,
  624,
  93,
  7326,
  822,
  1897,
  // 2982
  2810,
  3111,
  795,
  2064,
  991,
  1554,
  1542,
  1592,
  27,
  43,
  2853,
  859,
  139,
  1456,
  860,
  4300,
  // 2998
  437,
  712,
  3871,
  164,
  2392,
  3112,
  695,
  211,
  3017,
  2096,
  195,
  3872,
  1608,
  3504,
  3505,
  3618,
  // 3014
  3873,
  234,
  811,
  2971,
  2097,
  3874,
  2229,
  1441,
  3506,
  1615,
  2375,
  668,
  2076,
  1638,
  305,
  228,
  // 3030
  1664,
  4301,
  467,
  415,
  7327,
  262,
  2098,
  1593,
  239,
  108,
  300,
  200,
  1033,
  512,
  1247,
  2077,
  // 3046
  7328,
  7329,
  2173,
  3176,
  3619,
  2673,
  593,
  845,
  1062,
  3244,
  88,
  1723,
  2037,
  3875,
  1950,
  212,
  // 3062
  266,
  152,
  149,
  468,
  1898,
  4066,
  4302,
  77,
  187,
  7330,
  3018,
  37,
  5,
  2972,
  7331,
  3876,
  // 3078
  7332,
  7333,
  39,
  2517,
  4303,
  2894,
  3177,
  2078,
  55,
  148,
  74,
  4304,
  545,
  483,
  1474,
  1029,
  // 3094
  1665,
  217,
  1869,
  1531,
  3113,
  1104,
  2645,
  4067,
  24,
  172,
  3507,
  900,
  3877,
  3508,
  3509,
  4305,
  // 3110
  32,
  1408,
  2811,
  1312,
  329,
  487,
  2355,
  2247,
  2708,
  784,
  2674,
  4,
  3019,
  3314,
  1427,
  1788,
  // 3126
  188,
  109,
  499,
  7334,
  3620,
  1717,
  1789,
  888,
  1217,
  3020,
  4306,
  7335,
  3510,
  7336,
  3315,
  1520,
  // 3142
  3621,
  3878,
  196,
  1034,
  775,
  7337,
  7338,
  929,
  1815,
  249,
  439,
  38,
  7339,
  1063,
  7340,
  794,
  // 3158
  3879,
  1435,
  2296,
  46,
  178,
  3245,
  2065,
  7341,
  2376,
  7342,
  214,
  1709,
  4307,
  804,
  35,
  707,
  // 3174
  324,
  3622,
  1601,
  2546,
  140,
  459,
  4068,
  7343,
  7344,
  1365,
  839,
  272,
  978,
  2257,
  2572,
  3409,
  // 3190
  2128,
  1363,
  3623,
  1423,
  697,
  100,
  3071,
  48,
  70,
  1231,
  495,
  3114,
  2193,
  7345,
  1294,
  7346,
  // 3206
  2079,
  462,
  586,
  1042,
  3246,
  853,
  256,
  988,
  185,
  2377,
  3410,
  1698,
  434,
  1084,
  7347,
  3411,
  // 3222
  314,
  2615,
  2775,
  4308,
  2330,
  2331,
  569,
  2280,
  637,
  1816,
  2518,
  757,
  1162,
  1878,
  1616,
  3412,
  // 3238
  287,
  1577,
  2115,
  768,
  4309,
  1671,
  2854,
  3511,
  2519,
  1321,
  3737,
  909,
  2413,
  7348,
  4069,
  933,
  // 3254
  3738,
  7349,
  2052,
  2356,
  1222,
  4310,
  765,
  2414,
  1322,
  786,
  4311,
  7350,
  1919,
  1462,
  1677,
  2895,
  // 3270
  1699,
  7351,
  4312,
  1424,
  2437,
  3115,
  3624,
  2590,
  3316,
  1774,
  1940,
  3413,
  3880,
  4070,
  309,
  1369,
  // 3286
  1130,
  2812,
  364,
  2230,
  1653,
  1299,
  3881,
  3512,
  3882,
  3883,
  2646,
  525,
  1085,
  3021,
  902,
  2e3,
  // 3302
  1475,
  964,
  4313,
  421,
  1844,
  1415,
  1057,
  2281,
  940,
  1364,
  3116,
  376,
  4314,
  4315,
  1381,
  7,
  // 3318
  2520,
  983,
  2378,
  336,
  1710,
  2675,
  1845,
  321,
  3414,
  559,
  1131,
  3022,
  2742,
  1808,
  1132,
  1313,
  // 3334
  265,
  1481,
  1857,
  7352,
  352,
  1203,
  2813,
  3247,
  167,
  1089,
  420,
  2814,
  776,
  792,
  1724,
  3513,
  // 3350
  4071,
  2438,
  3248,
  7353,
  4072,
  7354,
  446,
  229,
  333,
  2743,
  901,
  3739,
  1200,
  1557,
  4316,
  2647,
  // 3366
  1920,
  395,
  2744,
  2676,
  3740,
  4073,
  1835,
  125,
  916,
  3178,
  2616,
  4317,
  7355,
  7356,
  3741,
  7357,
  // 3382
  7358,
  7359,
  4318,
  3117,
  3625,
  1133,
  2547,
  1757,
  3415,
  1510,
  2313,
  1409,
  3514,
  7360,
  2145,
  438,
  // 3398
  2591,
  2896,
  2379,
  3317,
  1068,
  958,
  3023,
  461,
  311,
  2855,
  2677,
  4074,
  1915,
  3179,
  4075,
  1978,
  // 3414
  383,
  750,
  2745,
  2617,
  4076,
  274,
  539,
  385,
  1278,
  1442,
  7361,
  1154,
  1964,
  384,
  561,
  210,
  // 3430
  98,
  1295,
  2548,
  3515,
  7362,
  1711,
  2415,
  1482,
  3416,
  3884,
  2897,
  1257,
  129,
  7363,
  3742,
  642,
  // 3446
  523,
  2776,
  2777,
  2648,
  7364,
  141,
  2231,
  1333,
  68,
  176,
  441,
  876,
  907,
  4077,
  603,
  2592,
  // 3462
  710,
  171,
  3417,
  404,
  549,
  18,
  3118,
  2393,
  1410,
  3626,
  1666,
  7365,
  3516,
  4319,
  2898,
  4320,
  // 3478
  7366,
  2973,
  368,
  7367,
  146,
  366,
  99,
  871,
  3627,
  1543,
  748,
  807,
  1586,
  1185,
  22,
  2258,
  // 3494
  379,
  3743,
  3180,
  7368,
  3181,
  505,
  1941,
  2618,
  1991,
  1382,
  2314,
  7369,
  380,
  2357,
  218,
  702,
  // 3510
  1817,
  1248,
  3418,
  3024,
  3517,
  3318,
  3249,
  7370,
  2974,
  3628,
  930,
  3250,
  3744,
  7371,
  59,
  7372,
  // 3526
  585,
  601,
  4078,
  497,
  3419,
  1112,
  1314,
  4321,
  1801,
  7373,
  1223,
  1472,
  2174,
  7374,
  749,
  1836,
  // 3542
  690,
  1899,
  3745,
  1772,
  3885,
  1476,
  429,
  1043,
  1790,
  2232,
  2116,
  917,
  4079,
  447,
  1086,
  1629,
  // 3558
  7375,
  556,
  7376,
  7377,
  2020,
  1654,
  844,
  1090,
  105,
  550,
  966,
  1758,
  2815,
  1008,
  1782,
  686,
  // 3574
  1095,
  7378,
  2282,
  793,
  1602,
  7379,
  3518,
  2593,
  4322,
  4080,
  2933,
  2297,
  4323,
  3746,
  980,
  2496,
  // 3590
  544,
  353,
  527,
  4324,
  908,
  2678,
  2899,
  7380,
  381,
  2619,
  1942,
  1348,
  7381,
  1341,
  1252,
  560,
  // 3606
  3072,
  7382,
  3420,
  2856,
  7383,
  2053,
  973,
  886,
  2080,
  143,
  4325,
  7384,
  7385,
  157,
  3886,
  496,
  // 3622
  4081,
  57,
  840,
  540,
  2038,
  4326,
  4327,
  3421,
  2117,
  1445,
  970,
  2259,
  1748,
  1965,
  2081,
  4082,
  // 3638
  3119,
  1234,
  1775,
  3251,
  2816,
  3629,
  773,
  1206,
  2129,
  1066,
  2039,
  1326,
  3887,
  1738,
  1725,
  4083,
  // 3654
  279,
  3120,
  51,
  1544,
  2594,
  423,
  1578,
  2130,
  2066,
  173,
  4328,
  1879,
  7386,
  7387,
  1583,
  264,
  // 3670
  610,
  3630,
  4329,
  2439,
  280,
  154,
  7388,
  7389,
  7390,
  1739,
  338,
  1282,
  3073,
  693,
  2857,
  1411,
  // 3686
  1074,
  3747,
  2440,
  7391,
  4330,
  7392,
  7393,
  1240,
  952,
  2394,
  7394,
  2900,
  1538,
  2679,
  685,
  1483,
  // 3702
  4084,
  2468,
  1436,
  953,
  4085,
  2054,
  4331,
  671,
  2395,
  79,
  4086,
  2441,
  3252,
  608,
  567,
  2680,
  // 3718
  3422,
  4087,
  4088,
  1691,
  393,
  1261,
  1791,
  2396,
  7395,
  4332,
  7396,
  7397,
  7398,
  7399,
  1383,
  1672,
  // 3734
  3748,
  3182,
  1464,
  522,
  1119,
  661,
  1150,
  216,
  675,
  4333,
  3888,
  1432,
  3519,
  609,
  4334,
  2681,
  // 3750
  2397,
  7400,
  7401,
  7402,
  4089,
  3025,
  0,
  7403,
  2469,
  315,
  231,
  2442,
  301,
  3319,
  4335,
  2380,
  // 3766
  7404,
  233,
  4090,
  3631,
  1818,
  4336,
  4337,
  7405,
  96,
  1776,
  1315,
  2082,
  7406,
  257,
  7407,
  1809,
  // 3782
  3632,
  2709,
  1139,
  1819,
  4091,
  2021,
  1124,
  2163,
  2778,
  1777,
  2649,
  7408,
  3074,
  363,
  1655,
  3183,
  // 3798
  7409,
  2975,
  7410,
  7411,
  7412,
  3889,
  1567,
  3890,
  718,
  103,
  3184,
  849,
  1443,
  341,
  3320,
  2934,
  // 3814
  1484,
  7413,
  1712,
  127,
  67,
  339,
  4092,
  2398,
  679,
  1412,
  821,
  7414,
  7415,
  834,
  738,
  351,
  // 3830
  2976,
  2146,
  846,
  235,
  1497,
  1880,
  418,
  1992,
  3749,
  2710,
  186,
  1100,
  2147,
  2746,
  3520,
  1545,
  // 3846
  1355,
  2935,
  2858,
  1377,
  583,
  3891,
  4093,
  2573,
  2977,
  7416,
  1298,
  3633,
  1078,
  2549,
  3634,
  2358,
  // 3862
  78,
  3750,
  3751,
  267,
  1289,
  2099,
  2001,
  1594,
  4094,
  348,
  369,
  1274,
  2194,
  2175,
  1837,
  4338,
  // 3878
  1820,
  2817,
  3635,
  2747,
  2283,
  2002,
  4339,
  2936,
  2748,
  144,
  3321,
  882,
  4340,
  3892,
  2749,
  3423,
  // 3894
  4341,
  2901,
  7417,
  4095,
  1726,
  320,
  7418,
  3893,
  3026,
  788,
  2978,
  7419,
  2818,
  1773,
  1327,
  2859,
  // 3910
  3894,
  2819,
  7420,
  1306,
  4342,
  2003,
  1700,
  3752,
  3521,
  2359,
  2650,
  787,
  2022,
  506,
  824,
  3636,
  // 3926
  534,
  323,
  4343,
  1044,
  3322,
  2023,
  1900,
  946,
  3424,
  7421,
  1778,
  1500,
  1678,
  7422,
  1881,
  4344,
  // 3942
  165,
  243,
  4345,
  3637,
  2521,
  123,
  683,
  4096,
  764,
  4346,
  36,
  3895,
  1792,
  589,
  2902,
  816,
  // 3958
  626,
  1667,
  3027,
  2233,
  1639,
  1555,
  1622,
  3753,
  3896,
  7423,
  3897,
  2860,
  1370,
  1228,
  1932,
  891,
  // 3974
  2083,
  2903,
  304,
  4097,
  7424,
  292,
  2979,
  2711,
  3522,
  691,
  2100,
  4098,
  1115,
  4347,
  118,
  662,
  // 3990
  7425,
  611,
  1156,
  854,
  2381,
  1316,
  2861,
  2,
  386,
  515,
  2904,
  7426,
  7427,
  3253,
  868,
  2234,
  // 4006
  1486,
  855,
  2651,
  785,
  2212,
  3028,
  7428,
  1040,
  3185,
  3523,
  7429,
  3121,
  448,
  7430,
  1525,
  7431,
  // 4022
  2164,
  4348,
  7432,
  3754,
  7433,
  4099,
  2820,
  3524,
  3122,
  503,
  818,
  3898,
  3123,
  1568,
  814,
  676,
  // 4038
  1444,
  306,
  1749,
  7434,
  3755,
  1416,
  1030,
  197,
  1428,
  805,
  2821,
  1501,
  4349,
  7435,
  7436,
  7437,
  // 4054
  1993,
  7438,
  4350,
  7439,
  7440,
  2195,
  13,
  2779,
  3638,
  2980,
  3124,
  1229,
  1916,
  7441,
  3756,
  2131,
  // 4070
  7442,
  4100,
  4351,
  2399,
  3525,
  7443,
  2213,
  1511,
  1727,
  1120,
  7444,
  7445,
  646,
  3757,
  2443,
  307,
  // 4086
  7446,
  7447,
  1595,
  3186,
  7448,
  7449,
  7450,
  3639,
  1113,
  1356,
  3899,
  1465,
  2522,
  2523,
  7451,
  519,
  // 4102
  7452,
  128,
  2132,
  92,
  2284,
  1979,
  7453,
  3900,
  1512,
  342,
  3125,
  2196,
  7454,
  2780,
  2214,
  1980,
  // 4118
  3323,
  7455,
  290,
  1656,
  1317,
  789,
  827,
  2360,
  7456,
  3758,
  4352,
  562,
  581,
  3901,
  7457,
  401,
  // 4134
  4353,
  2248,
  94,
  4354,
  1399,
  2781,
  7458,
  1463,
  2024,
  4355,
  3187,
  1943,
  7459,
  828,
  1105,
  4101,
  // 4150
  1262,
  1394,
  7460,
  4102,
  605,
  4356,
  7461,
  1783,
  2862,
  7462,
  2822,
  819,
  2101,
  578,
  2197,
  2937,
  // 4166
  7463,
  1502,
  436,
  3254,
  4103,
  3255,
  2823,
  3902,
  2905,
  3425,
  3426,
  7464,
  2712,
  2315,
  7465,
  7466,
  // 4182
  2332,
  2067,
  23,
  4357,
  193,
  826,
  3759,
  2102,
  699,
  1630,
  4104,
  3075,
  390,
  1793,
  1064,
  3526,
  // 4198
  7467,
  1579,
  3076,
  3077,
  1400,
  7468,
  4105,
  1838,
  1640,
  2863,
  7469,
  4358,
  4359,
  137,
  4106,
  598,
  // 4214
  3078,
  1966,
  780,
  104,
  974,
  2938,
  7470,
  278,
  899,
  253,
  402,
  572,
  504,
  493,
  1339,
  7471,
  // 4230
  3903,
  1275,
  4360,
  2574,
  2550,
  7472,
  3640,
  3029,
  3079,
  2249,
  565,
  1334,
  2713,
  863,
  41,
  7473,
  // 4246
  7474,
  4361,
  7475,
  1657,
  2333,
  19,
  463,
  2750,
  4107,
  606,
  7476,
  2981,
  3256,
  1087,
  2084,
  1323,
  // 4262
  2652,
  2982,
  7477,
  1631,
  1623,
  1750,
  4108,
  2682,
  7478,
  2864,
  791,
  2714,
  2653,
  2334,
  232,
  2416,
  // 4278
  7479,
  2983,
  1498,
  7480,
  2654,
  2620,
  755,
  1366,
  3641,
  3257,
  3126,
  2025,
  1609,
  119,
  1917,
  3427,
  // 4294
  862,
  1026,
  4109,
  7481,
  3904,
  3760,
  4362,
  3905,
  4363,
  2260,
  1951,
  2470,
  7482,
  1125,
  817,
  4110,
  // 4310
  4111,
  3906,
  1513,
  1766,
  2040,
  1487,
  4112,
  3030,
  3258,
  2824,
  3761,
  3127,
  7483,
  7484,
  1507,
  7485,
  // 4326
  2683,
  733,
  40,
  1632,
  1106,
  2865,
  345,
  4113,
  841,
  2524,
  230,
  4364,
  2984,
  1846,
  3259,
  3428,
  // 4342
  7486,
  1263,
  986,
  3429,
  7487,
  735,
  879,
  254,
  1137,
  857,
  622,
  1300,
  1180,
  1388,
  1562,
  3907,
  // 4358
  3908,
  2939,
  967,
  2751,
  2655,
  1349,
  592,
  2133,
  1692,
  3324,
  2985,
  1994,
  4114,
  1679,
  3909,
  1901,
  // 4374
  2185,
  7488,
  739,
  3642,
  2715,
  1296,
  1290,
  7489,
  4115,
  2198,
  2199,
  1921,
  1563,
  2595,
  2551,
  1870,
  // 4390
  2752,
  2986,
  7490,
  435,
  7491,
  343,
  1108,
  596,
  17,
  1751,
  4365,
  2235,
  3430,
  3643,
  7492,
  4366,
  // 4406
  294,
  3527,
  2940,
  1693,
  477,
  979,
  281,
  2041,
  3528,
  643,
  2042,
  3644,
  2621,
  2782,
  2261,
  1031,
  // 4422
  2335,
  2134,
  2298,
  3529,
  4367,
  367,
  1249,
  2552,
  7493,
  3530,
  7494,
  4368,
  1283,
  3325,
  2004,
  240,
  // 4438
  1762,
  3326,
  4369,
  4370,
  836,
  1069,
  3128,
  474,
  7495,
  2148,
  2525,
  268,
  3531,
  7496,
  3188,
  1521,
  // 4454
  1284,
  7497,
  1658,
  1546,
  4116,
  7498,
  3532,
  3533,
  7499,
  4117,
  3327,
  2684,
  1685,
  4118,
  961,
  1673,
  // 4470
  2622,
  190,
  2005,
  2200,
  3762,
  4371,
  4372,
  7500,
  570,
  2497,
  3645,
  1490,
  7501,
  4373,
  2623,
  3260,
  // 4486
  1956,
  4374,
  584,
  1514,
  396,
  1045,
  1944,
  7502,
  4375,
  1967,
  2444,
  7503,
  7504,
  4376,
  3910,
  619,
  // 4502
  7505,
  3129,
  3261,
  215,
  2006,
  2783,
  2553,
  3189,
  4377,
  3190,
  4378,
  763,
  4119,
  3763,
  4379,
  7506,
  // 4518
  7507,
  1957,
  1767,
  2941,
  3328,
  3646,
  1174,
  452,
  1477,
  4380,
  3329,
  3130,
  7508,
  2825,
  1253,
  2382,
  // 4534
  2186,
  1091,
  2285,
  4120,
  492,
  7509,
  638,
  1169,
  1824,
  2135,
  1752,
  3911,
  648,
  926,
  1021,
  1324,
  // 4550
  4381,
  520,
  4382,
  997,
  847,
  1007,
  892,
  4383,
  3764,
  2262,
  1871,
  3647,
  7510,
  2400,
  1784,
  4384,
  // 4566
  1952,
  2942,
  3080,
  3191,
  1728,
  4121,
  2043,
  3648,
  4385,
  2007,
  1701,
  3131,
  1551,
  30,
  2263,
  4122,
  // 4582
  7511,
  2026,
  4386,
  3534,
  7512,
  501,
  7513,
  4123,
  594,
  3431,
  2165,
  1821,
  3535,
  3432,
  3536,
  3192,
  // 4598
  829,
  2826,
  4124,
  7514,
  1680,
  3132,
  1225,
  4125,
  7515,
  3262,
  4387,
  4126,
  3133,
  2336,
  7516,
  4388,
  // 4614
  4127,
  7517,
  3912,
  3913,
  7518,
  1847,
  2383,
  2596,
  3330,
  7519,
  4389,
  374,
  3914,
  652,
  4128,
  4129,
  // 4630
  375,
  1140,
  798,
  7520,
  7521,
  7522,
  2361,
  4390,
  2264,
  546,
  1659,
  138,
  3031,
  2445,
  4391,
  7523,
  // 4646
  2250,
  612,
  1848,
  910,
  796,
  3765,
  1740,
  1371,
  825,
  3766,
  3767,
  7524,
  2906,
  2554,
  7525,
  692,
  // 4662
  444,
  3032,
  2624,
  801,
  4392,
  4130,
  7526,
  1491,
  244,
  1053,
  3033,
  4131,
  4132,
  340,
  7527,
  3915,
  // 4678
  1041,
  2987,
  293,
  1168,
  87,
  1357,
  7528,
  1539,
  959,
  7529,
  2236,
  721,
  694,
  4133,
  3768,
  219,
  // 4694
  1478,
  644,
  1417,
  3331,
  2656,
  1413,
  1401,
  1335,
  1389,
  3916,
  7530,
  7531,
  2988,
  2362,
  3134,
  1825,
  // 4710
  730,
  1515,
  184,
  2827,
  66,
  4393,
  7532,
  1660,
  2943,
  246,
  3332,
  378,
  1457,
  226,
  3433,
  975,
  // 4726
  3917,
  2944,
  1264,
  3537,
  674,
  696,
  7533,
  163,
  7534,
  1141,
  2417,
  2166,
  713,
  3538,
  3333,
  4394,
  // 4742
  3918,
  7535,
  7536,
  1186,
  15,
  7537,
  1079,
  1070,
  7538,
  1522,
  3193,
  3539,
  276,
  1050,
  2716,
  758,
  // 4758
  1126,
  653,
  2945,
  3263,
  7539,
  2337,
  889,
  3540,
  3919,
  3081,
  2989,
  903,
  1250,
  4395,
  3920,
  3434,
  // 4774
  3541,
  1342,
  1681,
  1718,
  766,
  3264,
  286,
  89,
  2946,
  3649,
  7540,
  1713,
  7541,
  2597,
  3334,
  2990,
  // 4790
  7542,
  2947,
  2215,
  3194,
  2866,
  7543,
  4396,
  2498,
  2526,
  181,
  387,
  1075,
  3921,
  731,
  2187,
  3335,
  // 4806
  7544,
  3265,
  310,
  313,
  3435,
  2299,
  770,
  4134,
  54,
  3034,
  189,
  4397,
  3082,
  3769,
  3922,
  7545,
  // 4822
  1230,
  1617,
  1849,
  355,
  3542,
  4135,
  4398,
  3336,
  111,
  4136,
  3650,
  1350,
  3135,
  3436,
  3035,
  4137,
  // 4838
  2149,
  3266,
  3543,
  7546,
  2784,
  3923,
  3924,
  2991,
  722,
  2008,
  7547,
  1071,
  247,
  1207,
  2338,
  2471,
  // 4854
  1378,
  4399,
  2009,
  864,
  1437,
  1214,
  4400,
  373,
  3770,
  1142,
  2216,
  667,
  4401,
  442,
  2753,
  2555,
  // 4870
  3771,
  3925,
  1968,
  4138,
  3267,
  1839,
  837,
  170,
  1107,
  934,
  1336,
  1882,
  7548,
  7549,
  2118,
  4139,
  // 4886
  2828,
  743,
  1569,
  7550,
  4402,
  4140,
  582,
  2384,
  1418,
  3437,
  7551,
  1802,
  7552,
  357,
  1395,
  1729,
  // 4902
  3651,
  3268,
  2418,
  1564,
  2237,
  7553,
  3083,
  3772,
  1633,
  4403,
  1114,
  2085,
  4141,
  1532,
  7554,
  482,
  // 4918
  2446,
  4404,
  7555,
  7556,
  1492,
  833,
  1466,
  7557,
  2717,
  3544,
  1641,
  2829,
  7558,
  1526,
  1272,
  3652,
  // 4934
  4142,
  1686,
  1794,
  416,
  2556,
  1902,
  1953,
  1803,
  7559,
  3773,
  2785,
  3774,
  1159,
  2316,
  7560,
  2867,
  // 4950
  4405,
  1610,
  1584,
  3036,
  2419,
  2754,
  443,
  3269,
  1163,
  3136,
  7561,
  7562,
  3926,
  7563,
  4143,
  2499,
  // 4966
  3037,
  4406,
  3927,
  3137,
  2103,
  1647,
  3545,
  2010,
  1872,
  4144,
  7564,
  4145,
  431,
  3438,
  7565,
  250,
  // 4982
  97,
  81,
  4146,
  7566,
  1648,
  1850,
  1558,
  160,
  848,
  7567,
  866,
  740,
  1694,
  7568,
  2201,
  2830,
  // 4998
  3195,
  4147,
  4407,
  3653,
  1687,
  950,
  2472,
  426,
  469,
  3196,
  3654,
  3655,
  3928,
  7569,
  7570,
  1188,
  // 5014
  424,
  1995,
  861,
  3546,
  4148,
  3775,
  2202,
  2685,
  168,
  1235,
  3547,
  4149,
  7571,
  2086,
  1674,
  4408,
  // 5030
  3337,
  3270,
  220,
  2557,
  1009,
  7572,
  3776,
  670,
  2992,
  332,
  1208,
  717,
  7573,
  7574,
  3548,
  2447,
  // 5046
  3929,
  3338,
  7575,
  513,
  7576,
  1209,
  2868,
  3339,
  3138,
  4409,
  1080,
  7577,
  7578,
  7579,
  7580,
  2527,
  // 5062
  3656,
  3549,
  815,
  1587,
  3930,
  3931,
  7581,
  3550,
  3439,
  3777,
  1254,
  4410,
  1328,
  3038,
  1390,
  3932,
  // 5078
  1741,
  3933,
  3778,
  3934,
  7582,
  236,
  3779,
  2448,
  3271,
  7583,
  7584,
  3657,
  3780,
  1273,
  3781,
  4411,
  // 5094
  7585,
  308,
  7586,
  4412,
  245,
  4413,
  1851,
  2473,
  1307,
  2575,
  430,
  715,
  2136,
  2449,
  7587,
  270,
  // 5110
  199,
  2869,
  3935,
  7588,
  3551,
  2718,
  1753,
  761,
  1754,
  725,
  1661,
  1840,
  4414,
  3440,
  3658,
  7589,
  // 5126
  7590,
  587,
  14,
  3272,
  227,
  2598,
  326,
  480,
  2265,
  943,
  2755,
  3552,
  291,
  650,
  1883,
  7591,
  // 5142
  1702,
  1226,
  102,
  1547,
  62,
  3441,
  904,
  4415,
  3442,
  1164,
  4150,
  7592,
  7593,
  1224,
  1548,
  2756,
  // 5158
  391,
  498,
  1493,
  7594,
  1386,
  1419,
  7595,
  2055,
  1177,
  4416,
  813,
  880,
  1081,
  2363,
  566,
  1145,
  // 5174
  4417,
  2286,
  1001,
  1035,
  2558,
  2599,
  2238,
  394,
  1286,
  7596,
  7597,
  2068,
  7598,
  86,
  1494,
  1730,
  // 5190
  3936,
  491,
  1588,
  745,
  897,
  2948,
  843,
  3340,
  3937,
  2757,
  2870,
  3273,
  1768,
  998,
  2217,
  2069,
  // 5206
  397,
  1826,
  1195,
  1969,
  3659,
  2993,
  3341,
  284,
  7599,
  3782,
  2500,
  2137,
  2119,
  1903,
  7600,
  3938,
  // 5222
  2150,
  3939,
  4151,
  1036,
  3443,
  1904,
  114,
  2559,
  4152,
  209,
  1527,
  7601,
  7602,
  2949,
  2831,
  2625,
  // 5238
  2385,
  2719,
  3139,
  812,
  2560,
  7603,
  3274,
  7604,
  1559,
  737,
  1884,
  3660,
  1210,
  885,
  28,
  2686,
  // 5254
  3553,
  3783,
  7605,
  4153,
  1004,
  1779,
  4418,
  7606,
  346,
  1981,
  2218,
  2687,
  4419,
  3784,
  1742,
  797,
  // 5270
  1642,
  3940,
  1933,
  1072,
  1384,
  2151,
  896,
  3941,
  3275,
  3661,
  3197,
  2871,
  3554,
  7607,
  2561,
  1958,
  // 5286
  4420,
  2450,
  1785,
  7608,
  7609,
  7610,
  3942,
  4154,
  1005,
  1308,
  3662,
  4155,
  2720,
  4421,
  4422,
  1528,
  // 5302
  2600,
  161,
  1178,
  4156,
  1982,
  987,
  4423,
  1101,
  4157,
  631,
  3943,
  1157,
  3198,
  2420,
  1343,
  1241,
  // 5318
  1016,
  2239,
  2562,
  372,
  877,
  2339,
  2501,
  1160,
  555,
  1934,
  911,
  3944,
  7611,
  466,
  1170,
  169,
  // 5334
  1051,
  2907,
  2688,
  3663,
  2474,
  2994,
  1182,
  2011,
  2563,
  1251,
  2626,
  7612,
  992,
  2340,
  3444,
  1540,
  // 5350
  2721,
  1201,
  2070,
  2401,
  1996,
  2475,
  7613,
  4424,
  528,
  1922,
  2188,
  1503,
  1873,
  1570,
  2364,
  3342,
  // 5366
  3276,
  7614,
  557,
  1073,
  7615,
  1827,
  3445,
  2087,
  2266,
  3140,
  3039,
  3084,
  767,
  3085,
  2786,
  4425,
  // 5382
  1006,
  4158,
  4426,
  2341,
  1267,
  2176,
  3664,
  3199,
  778,
  3945,
  3200,
  2722,
  1597,
  2657,
  7616,
  4427,
  // 5398
  7617,
  3446,
  7618,
  7619,
  7620,
  3277,
  2689,
  1433,
  3278,
  131,
  95,
  1504,
  3946,
  723,
  4159,
  3141,
  // 5414
  1841,
  3555,
  2758,
  2189,
  3947,
  2027,
  2104,
  3665,
  7621,
  2995,
  3948,
  1218,
  7622,
  3343,
  3201,
  3949,
  // 5430
  4160,
  2576,
  248,
  1634,
  3785,
  912,
  7623,
  2832,
  3666,
  3040,
  3786,
  654,
  53,
  7624,
  2996,
  7625,
  // 5446
  1688,
  4428,
  777,
  3447,
  1032,
  3950,
  1425,
  7626,
  191,
  820,
  2120,
  2833,
  971,
  4429,
  931,
  3202,
  // 5462
  135,
  664,
  783,
  3787,
  1997,
  772,
  2908,
  1935,
  3951,
  3788,
  4430,
  2909,
  3203,
  282,
  2723,
  640,
  // 5478
  1372,
  3448,
  1127,
  922,
  325,
  3344,
  7627,
  7628,
  711,
  2044,
  7629,
  7630,
  3952,
  2219,
  2787,
  1936,
  // 5494
  3953,
  3345,
  2220,
  2251,
  3789,
  2300,
  7631,
  4431,
  3790,
  1258,
  3279,
  3954,
  3204,
  2138,
  2950,
  3955,
  // 5510
  3956,
  7632,
  2221,
  258,
  3205,
  4432,
  101,
  1227,
  7633,
  3280,
  1755,
  7634,
  1391,
  3281,
  7635,
  2910,
  // 5526
  2056,
  893,
  7636,
  7637,
  7638,
  1402,
  4161,
  2342,
  7639,
  7640,
  3206,
  3556,
  7641,
  7642,
  878,
  1325,
  // 5542
  1780,
  2788,
  4433,
  259,
  1385,
  2577,
  744,
  1183,
  2267,
  4434,
  7643,
  3957,
  2502,
  7644,
  684,
  1024,
  // 5558
  4162,
  7645,
  472,
  3557,
  3449,
  1165,
  3282,
  3958,
  3959,
  322,
  2152,
  881,
  455,
  1695,
  1152,
  1340,
  // 5574
  660,
  554,
  2153,
  4435,
  1058,
  4436,
  4163,
  830,
  1065,
  3346,
  3960,
  4437,
  1923,
  7646,
  1703,
  1918,
  // 5590
  7647,
  932,
  2268,
  122,
  7648,
  4438,
  947,
  677,
  7649,
  3791,
  2627,
  297,
  1905,
  1924,
  2269,
  4439,
  // 5606
  2317,
  3283,
  7650,
  7651,
  4164,
  7652,
  4165,
  84,
  4166,
  112,
  989,
  7653,
  547,
  1059,
  3961,
  701,
  // 5622
  3558,
  1019,
  7654,
  4167,
  7655,
  3450,
  942,
  639,
  457,
  2301,
  2451,
  993,
  2951,
  407,
  851,
  494,
  // 5638
  4440,
  3347,
  927,
  7656,
  1237,
  7657,
  2421,
  3348,
  573,
  4168,
  680,
  921,
  2911,
  1279,
  1874,
  285,
  // 5654
  790,
  1448,
  1983,
  719,
  2167,
  7658,
  7659,
  4441,
  3962,
  3963,
  1649,
  7660,
  1541,
  563,
  7661,
  1077,
  // 5670
  7662,
  3349,
  3041,
  3451,
  511,
  2997,
  3964,
  3965,
  3667,
  3966,
  1268,
  2564,
  3350,
  3207,
  4442,
  4443,
  // 5686
  7663,
  535,
  1048,
  1276,
  1189,
  2912,
  2028,
  3142,
  1438,
  1373,
  2834,
  2952,
  1134,
  2012,
  7664,
  4169,
  // 5702
  1238,
  2578,
  3086,
  1259,
  7665,
  700,
  7666,
  2953,
  3143,
  3668,
  4170,
  7667,
  4171,
  1146,
  1875,
  1906,
  // 5718
  4444,
  2601,
  3967,
  781,
  2422,
  132,
  1589,
  203,
  147,
  273,
  2789,
  2402,
  898,
  1786,
  2154,
  3968,
  // 5734
  3969,
  7668,
  3792,
  2790,
  7669,
  7670,
  4445,
  4446,
  7671,
  3208,
  7672,
  1635,
  3793,
  965,
  7673,
  1804,
  // 5750
  2690,
  1516,
  3559,
  1121,
  1082,
  1329,
  3284,
  3970,
  1449,
  3794,
  65,
  1128,
  2835,
  2913,
  2759,
  1590,
  // 5766
  3795,
  7674,
  7675,
  12,
  2658,
  45,
  976,
  2579,
  3144,
  4447,
  517,
  2528,
  1013,
  1037,
  3209,
  7676,
  // 5782
  3796,
  2836,
  7677,
  3797,
  7678,
  3452,
  7679,
  2602,
  614,
  1998,
  2318,
  3798,
  3087,
  2724,
  2628,
  7680,
  // 5798
  2580,
  4172,
  599,
  1269,
  7681,
  1810,
  3669,
  7682,
  2691,
  3088,
  759,
  1060,
  489,
  1805,
  3351,
  3285,
  // 5814
  1358,
  7683,
  7684,
  2386,
  1387,
  1215,
  2629,
  2252,
  490,
  7685,
  7686,
  4173,
  1759,
  2387,
  2343,
  7687,
  // 5830
  4448,
  3799,
  1907,
  3971,
  2630,
  1806,
  3210,
  4449,
  3453,
  3286,
  2760,
  2344,
  874,
  7688,
  7689,
  3454,
  // 5846
  3670,
  1858,
  91,
  2914,
  3671,
  3042,
  3800,
  4450,
  7690,
  3145,
  3972,
  2659,
  7691,
  3455,
  1202,
  1403,
  // 5862
  3801,
  2954,
  2529,
  1517,
  2503,
  4451,
  3456,
  2504,
  7692,
  4452,
  7693,
  2692,
  1885,
  1495,
  1731,
  3973,
  // 5878
  2365,
  4453,
  7694,
  2029,
  7695,
  7696,
  3974,
  2693,
  1216,
  237,
  2581,
  4174,
  2319,
  3975,
  3802,
  4454,
  // 5894
  4455,
  2694,
  3560,
  3457,
  445,
  4456,
  7697,
  7698,
  7699,
  7700,
  2761,
  61,
  3976,
  3672,
  1822,
  3977,
  // 5910
  7701,
  687,
  2045,
  935,
  925,
  405,
  2660,
  703,
  1096,
  1859,
  2725,
  4457,
  3978,
  1876,
  1367,
  2695,
  // 5926
  3352,
  918,
  2105,
  1781,
  2476,
  334,
  3287,
  1611,
  1093,
  4458,
  564,
  3146,
  3458,
  3673,
  3353,
  945,
  // 5942
  2631,
  2057,
  4459,
  7702,
  1925,
  872,
  4175,
  7703,
  3459,
  2696,
  3089,
  349,
  4176,
  3674,
  3979,
  4460,
  // 5958
  3803,
  4177,
  3675,
  2155,
  3980,
  4461,
  4462,
  4178,
  4463,
  2403,
  2046,
  782,
  3981,
  400,
  251,
  4179,
  // 5974
  1624,
  7704,
  7705,
  277,
  3676,
  299,
  1265,
  476,
  1191,
  3804,
  2121,
  4180,
  4181,
  1109,
  205,
  7706,
  // 5990
  2582,
  1e3,
  2156,
  3561,
  1860,
  7707,
  7708,
  7709,
  4464,
  7710,
  4465,
  2565,
  107,
  2477,
  2157,
  3982,
  // 6006
  3460,
  3147,
  7711,
  1533,
  541,
  1301,
  158,
  753,
  4182,
  2872,
  3562,
  7712,
  1696,
  370,
  1088,
  4183,
  // 6022
  4466,
  3563,
  579,
  327,
  440,
  162,
  2240,
  269,
  1937,
  1374,
  3461,
  968,
  3043,
  56,
  1396,
  3090,
  // 6038
  2106,
  3288,
  3354,
  7713,
  1926,
  2158,
  4467,
  2998,
  7714,
  3564,
  7715,
  7716,
  3677,
  4468,
  2478,
  7717,
  // 6054
  2791,
  7718,
  1650,
  4469,
  7719,
  2603,
  7720,
  7721,
  3983,
  2661,
  3355,
  1149,
  3356,
  3984,
  3805,
  3985,
  // 6070
  7722,
  1076,
  49,
  7723,
  951,
  3211,
  3289,
  3290,
  450,
  2837,
  920,
  7724,
  1811,
  2792,
  2366,
  4184,
  // 6086
  1908,
  1138,
  2367,
  3806,
  3462,
  7725,
  3212,
  4470,
  1909,
  1147,
  1518,
  2423,
  4471,
  3807,
  7726,
  4472,
  // 6102
  2388,
  2604,
  260,
  1795,
  3213,
  7727,
  7728,
  3808,
  3291,
  708,
  7729,
  3565,
  1704,
  7730,
  3566,
  1351,
  // 6118
  1618,
  3357,
  2999,
  1886,
  944,
  4185,
  3358,
  4186,
  3044,
  3359,
  4187,
  7731,
  3678,
  422,
  413,
  1714,
  // 6134
  3292,
  500,
  2058,
  2345,
  4188,
  2479,
  7732,
  1344,
  1910,
  954,
  7733,
  1668,
  7734,
  7735,
  3986,
  2404,
  // 6150
  4189,
  3567,
  3809,
  4190,
  7736,
  2302,
  1318,
  2505,
  3091,
  133,
  3092,
  2873,
  4473,
  629,
  31,
  2838,
  // 6166
  2697,
  3810,
  4474,
  850,
  949,
  4475,
  3987,
  2955,
  1732,
  2088,
  4191,
  1496,
  1852,
  7737,
  3988,
  620,
  // 6182
  3214,
  981,
  1242,
  3679,
  3360,
  1619,
  3680,
  1643,
  3293,
  2139,
  2452,
  1970,
  1719,
  3463,
  2168,
  7738,
  // 6198
  3215,
  7739,
  7740,
  3361,
  1828,
  7741,
  1277,
  4476,
  1565,
  2047,
  7742,
  1636,
  3568,
  3093,
  7743,
  869,
  // 6214
  2839,
  655,
  3811,
  3812,
  3094,
  3989,
  3e3,
  3813,
  1310,
  3569,
  4477,
  7744,
  7745,
  7746,
  1733,
  558,
  // 6230
  4478,
  3681,
  335,
  1549,
  3045,
  1756,
  4192,
  3682,
  1945,
  3464,
  1829,
  1291,
  1192,
  470,
  2726,
  2107,
  // 6246
  2793,
  913,
  1054,
  3990,
  7747,
  1027,
  7748,
  3046,
  3991,
  4479,
  982,
  2662,
  3362,
  3148,
  3465,
  3216,
  // 6262
  3217,
  1946,
  2794,
  7749,
  571,
  4480,
  7750,
  1830,
  7751,
  3570,
  2583,
  1523,
  2424,
  7752,
  2089,
  984,
  // 6278
  4481,
  3683,
  1959,
  7753,
  3684,
  852,
  923,
  2795,
  3466,
  3685,
  969,
  1519,
  999,
  2048,
  2320,
  1705,
  // 6294
  7754,
  3095,
  615,
  1662,
  151,
  597,
  3992,
  2405,
  2321,
  1049,
  275,
  4482,
  3686,
  4193,
  568,
  3687,
  // 6310
  3571,
  2480,
  4194,
  3688,
  7755,
  2425,
  2270,
  409,
  3218,
  7756,
  1566,
  2874,
  3467,
  1002,
  769,
  2840,
  // 6326
  194,
  2090,
  3149,
  3689,
  2222,
  3294,
  4195,
  628,
  1505,
  7757,
  7758,
  1763,
  2177,
  3001,
  3993,
  521,
  // 6342
  1161,
  2584,
  1787,
  2203,
  2406,
  4483,
  3994,
  1625,
  4196,
  4197,
  412,
  42,
  3096,
  464,
  7759,
  2632,
  // 6358
  4484,
  3363,
  1760,
  1571,
  2875,
  3468,
  2530,
  1219,
  2204,
  3814,
  2633,
  2140,
  2368,
  4485,
  4486,
  3295,
  // 6374
  1651,
  3364,
  3572,
  7760,
  7761,
  3573,
  2481,
  3469,
  7762,
  3690,
  7763,
  7764,
  2271,
  2091,
  460,
  7765,
  // 6390
  4487,
  7766,
  3002,
  962,
  588,
  3574,
  289,
  3219,
  2634,
  1116,
  52,
  7767,
  3047,
  1796,
  7768,
  7769,
  // 6406
  7770,
  1467,
  7771,
  1598,
  1143,
  3691,
  4198,
  1984,
  1734,
  1067,
  4488,
  1280,
  3365,
  465,
  4489,
  1572,
  // 6422
  510,
  7772,
  1927,
  2241,
  1812,
  1644,
  3575,
  7773,
  4490,
  3692,
  7774,
  7775,
  2663,
  1573,
  1534,
  7776,
  // 6438
  7777,
  4199,
  536,
  1807,
  1761,
  3470,
  3815,
  3150,
  2635,
  7778,
  7779,
  7780,
  4491,
  3471,
  2915,
  1911,
  // 6454
  2796,
  7781,
  3296,
  1122,
  377,
  3220,
  7782,
  360,
  7783,
  7784,
  4200,
  1529,
  551,
  7785,
  2059,
  3693,
  // 6470
  1769,
  2426,
  7786,
  2916,
  4201,
  3297,
  3097,
  2322,
  2108,
  2030,
  4492,
  1404,
  136,
  1468,
  1479,
  672,
  // 6486
  1171,
  3221,
  2303,
  271,
  3151,
  7787,
  2762,
  7788,
  2049,
  678,
  2727,
  865,
  1947,
  4493,
  7789,
  2013,
  // 6502
  3995,
  2956,
  7790,
  2728,
  2223,
  1397,
  3048,
  3694,
  4494,
  4495,
  1735,
  2917,
  3366,
  3576,
  7791,
  3816,
  // 6518
  509,
  2841,
  2453,
  2876,
  3817,
  7792,
  7793,
  3152,
  3153,
  4496,
  4202,
  2531,
  4497,
  2304,
  1166,
  1010,
  // 6534
  552,
  681,
  1887,
  7794,
  7795,
  2957,
  2958,
  3996,
  1287,
  1596,
  1861,
  3154,
  358,
  453,
  736,
  175,
  // 6550
  478,
  1117,
  905,
  1167,
  1097,
  7796,
  1853,
  1530,
  7797,
  1706,
  7798,
  2178,
  3472,
  2287,
  3695,
  3473,
  // 6566
  3577,
  4203,
  2092,
  4204,
  7799,
  3367,
  1193,
  2482,
  4205,
  1458,
  2190,
  2205,
  1862,
  1888,
  1421,
  3298,
  // 6582
  2918,
  3049,
  2179,
  3474,
  595,
  2122,
  7800,
  3997,
  7801,
  7802,
  4206,
  1707,
  2636,
  223,
  3696,
  1359,
  // 6598
  751,
  3098,
  183,
  3475,
  7803,
  2797,
  3003,
  419,
  2369,
  633,
  704,
  3818,
  2389,
  241,
  7804,
  7805,
  // 6614
  7806,
  838,
  3004,
  3697,
  2272,
  2763,
  2454,
  3819,
  1938,
  2050,
  3998,
  1309,
  3099,
  2242,
  1181,
  7807,
  // 6630
  1136,
  2206,
  3820,
  2370,
  1446,
  4207,
  2305,
  4498,
  7808,
  7809,
  4208,
  1055,
  2605,
  484,
  3698,
  7810,
  // 6646
  3999,
  625,
  4209,
  2273,
  3368,
  1499,
  4210,
  4e3,
  7811,
  4001,
  4211,
  3222,
  2274,
  2275,
  3476,
  7812,
  // 6662
  7813,
  2764,
  808,
  2606,
  3699,
  3369,
  4002,
  4212,
  3100,
  2532,
  526,
  3370,
  3821,
  4213,
  955,
  7814,
  // 6678
  1620,
  4214,
  2637,
  2427,
  7815,
  1429,
  3700,
  1669,
  1831,
  994,
  928,
  7816,
  3578,
  1260,
  7817,
  7818,
  // 6694
  7819,
  1948,
  2288,
  741,
  2919,
  1626,
  4215,
  2729,
  2455,
  867,
  1184,
  362,
  3371,
  1392,
  7820,
  7821,
  // 6710
  4003,
  4216,
  1770,
  1736,
  3223,
  2920,
  4499,
  4500,
  1928,
  2698,
  1459,
  1158,
  7822,
  3050,
  3372,
  2877,
  // 6726
  1292,
  1929,
  2506,
  2842,
  3701,
  1985,
  1187,
  2071,
  2014,
  2607,
  4217,
  7823,
  2566,
  2507,
  2169,
  3702,
  // 6742
  2483,
  3299,
  7824,
  3703,
  4501,
  7825,
  7826,
  666,
  1003,
  3005,
  1022,
  3579,
  4218,
  7827,
  4502,
  1813,
  // 6758
  2253,
  574,
  3822,
  1603,
  295,
  1535,
  705,
  3823,
  4219,
  283,
  858,
  417,
  7828,
  7829,
  3224,
  4503,
  // 6774
  4504,
  3051,
  1220,
  1889,
  1046,
  2276,
  2456,
  4004,
  1393,
  1599,
  689,
  2567,
  388,
  4220,
  7830,
  2484,
  // 6790
  802,
  7831,
  2798,
  3824,
  2060,
  1405,
  2254,
  7832,
  4505,
  3825,
  2109,
  1052,
  1345,
  3225,
  1585,
  7833,
  // 6806
  809,
  7834,
  7835,
  7836,
  575,
  2730,
  3477,
  956,
  1552,
  1469,
  1144,
  2323,
  7837,
  2324,
  1560,
  2457,
  // 6822
  3580,
  3226,
  4005,
  616,
  2207,
  3155,
  2180,
  2289,
  7838,
  1832,
  7839,
  3478,
  4506,
  7840,
  1319,
  3704,
  // 6838
  3705,
  1211,
  3581,
  1023,
  3227,
  1293,
  2799,
  7841,
  7842,
  7843,
  3826,
  607,
  2306,
  3827,
  762,
  2878,
  // 6854
  1439,
  4221,
  1360,
  7844,
  1485,
  3052,
  7845,
  4507,
  1038,
  4222,
  1450,
  2061,
  2638,
  4223,
  1379,
  4508,
  // 6870
  2585,
  7846,
  7847,
  4224,
  1352,
  1414,
  2325,
  2921,
  1172,
  7848,
  7849,
  3828,
  3829,
  7850,
  1797,
  1451,
  // 6886
  7851,
  7852,
  7853,
  7854,
  2922,
  4006,
  4007,
  2485,
  2346,
  411,
  4008,
  4009,
  3582,
  3300,
  3101,
  4509,
  // 6902
  1561,
  2664,
  1452,
  4010,
  1375,
  7855,
  7856,
  47,
  2959,
  316,
  7857,
  1406,
  1591,
  2923,
  3156,
  7858,
  // 6918
  1025,
  2141,
  3102,
  3157,
  354,
  2731,
  884,
  2224,
  4225,
  2407,
  508,
  3706,
  726,
  3583,
  996,
  2428,
  // 6934
  3584,
  729,
  7859,
  392,
  2191,
  1453,
  4011,
  4510,
  3707,
  7860,
  7861,
  2458,
  3585,
  2608,
  1675,
  2800,
  // 6950
  919,
  2347,
  2960,
  2348,
  1270,
  4511,
  4012,
  73,
  7862,
  7863,
  647,
  7864,
  3228,
  2843,
  2255,
  1550,
  // 6966
  1346,
  3006,
  7865,
  1332,
  883,
  3479,
  7866,
  7867,
  7868,
  7869,
  3301,
  2765,
  7870,
  1212,
  831,
  1347,
  // 6982
  4226,
  4512,
  2326,
  3830,
  1863,
  3053,
  720,
  3831,
  4513,
  4514,
  3832,
  7871,
  4227,
  7872,
  7873,
  4515,
  // 6998
  7874,
  7875,
  1798,
  4516,
  3708,
  2609,
  4517,
  3586,
  1645,
  2371,
  7876,
  7877,
  2924,
  669,
  2208,
  2665,
  // 7014
  2429,
  7878,
  2879,
  7879,
  7880,
  1028,
  3229,
  7881,
  4228,
  2408,
  7882,
  2256,
  1353,
  7883,
  7884,
  4518,
  // 7030
  3158,
  518,
  7885,
  4013,
  7886,
  4229,
  1960,
  7887,
  2142,
  4230,
  7888,
  7889,
  3007,
  2349,
  2350,
  3833,
  // 7046
  516,
  1833,
  1454,
  4014,
  2699,
  4231,
  4519,
  2225,
  2610,
  1971,
  1129,
  3587,
  7890,
  2766,
  7891,
  2961,
  // 7062
  1422,
  577,
  1470,
  3008,
  1524,
  3373,
  7892,
  7893,
  432,
  4232,
  3054,
  3480,
  7894,
  2586,
  1455,
  2508,
  // 7078
  2226,
  1972,
  1175,
  7895,
  1020,
  2732,
  4015,
  3481,
  4520,
  7896,
  2733,
  7897,
  1743,
  1361,
  3055,
  3482,
  // 7094
  2639,
  4016,
  4233,
  4521,
  2290,
  895,
  924,
  4234,
  2170,
  331,
  2243,
  3056,
  166,
  1627,
  3057,
  1098,
  // 7110
  7898,
  1232,
  2880,
  2227,
  3374,
  4522,
  657,
  403,
  1196,
  2372,
  542,
  3709,
  3375,
  1600,
  4235,
  3483,
  // 7126
  7899,
  4523,
  2767,
  3230,
  576,
  530,
  1362,
  7900,
  4524,
  2533,
  2666,
  3710,
  4017,
  7901,
  842,
  3834,
  // 7142
  7902,
  2801,
  2031,
  1014,
  4018,
  213,
  2700,
  3376,
  665,
  621,
  4236,
  7903,
  3711,
  2925,
  2430,
  7904,
  // 7158
  2431,
  3302,
  3588,
  3377,
  7905,
  4237,
  2534,
  4238,
  4525,
  3589,
  1682,
  4239,
  3484,
  1380,
  7906,
  724,
  // 7174
  2277,
  600,
  1670,
  7907,
  1337,
  1233,
  4526,
  3103,
  2244,
  7908,
  1621,
  4527,
  7909,
  651,
  4240,
  7910,
  // 7190
  1612,
  4241,
  2611,
  7911,
  2844,
  7912,
  2734,
  2307,
  3058,
  7913,
  716,
  2459,
  3059,
  174,
  1255,
  2701,
  // 7206
  4019,
  3590,
  548,
  1320,
  1398,
  728,
  4020,
  1574,
  7914,
  1890,
  1197,
  3060,
  4021,
  7915,
  3061,
  3062,
  // 7222
  3712,
  3591,
  3713,
  747,
  7916,
  635,
  4242,
  4528,
  7917,
  7918,
  7919,
  4243,
  7920,
  7921,
  4529,
  7922,
  // 7238
  3378,
  4530,
  2432,
  451,
  7923,
  3714,
  2535,
  2072,
  4244,
  2735,
  4245,
  4022,
  7924,
  1764,
  4531,
  7925,
  // 7254
  4246,
  350,
  7926,
  2278,
  2390,
  2486,
  7927,
  4247,
  4023,
  2245,
  1434,
  4024,
  488,
  4532,
  458,
  4248,
  // 7270
  4025,
  3715,
  771,
  1330,
  2391,
  3835,
  2568,
  3159,
  2159,
  2409,
  1553,
  2667,
  3160,
  4249,
  7928,
  2487,
  // 7286
  2881,
  2612,
  1720,
  2702,
  4250,
  3379,
  4533,
  7929,
  2536,
  4251,
  7930,
  3231,
  4252,
  2768,
  7931,
  2015,
  // 7302
  2736,
  7932,
  1155,
  1017,
  3716,
  3836,
  7933,
  3303,
  2308,
  201,
  1864,
  4253,
  1430,
  7934,
  4026,
  7935,
  // 7318
  7936,
  7937,
  7938,
  7939,
  4254,
  1604,
  7940,
  414,
  1865,
  371,
  2587,
  4534,
  4535,
  3485,
  2016,
  3104,
  // 7334
  4536,
  1708,
  960,
  4255,
  887,
  389,
  2171,
  1536,
  1663,
  1721,
  7941,
  2228,
  4027,
  2351,
  2926,
  1580,
  // 7350
  7942,
  7943,
  7944,
  1744,
  7945,
  2537,
  4537,
  4538,
  7946,
  4539,
  7947,
  2073,
  7948,
  7949,
  3592,
  3380,
  // 7366
  2882,
  4256,
  7950,
  4257,
  2640,
  3381,
  2802,
  673,
  2703,
  2460,
  709,
  3486,
  4028,
  3593,
  4258,
  7951,
  // 7382
  1148,
  502,
  634,
  7952,
  7953,
  1204,
  4540,
  3594,
  1575,
  4541,
  2613,
  3717,
  7954,
  3718,
  3105,
  948,
  // 7398
  3232,
  121,
  1745,
  3837,
  1110,
  7955,
  4259,
  3063,
  2509,
  3009,
  4029,
  3719,
  1151,
  1771,
  3838,
  1488,
  // 7414
  4030,
  1986,
  7956,
  2433,
  3487,
  7957,
  7958,
  2093,
  7959,
  4260,
  3839,
  1213,
  1407,
  2803,
  531,
  2737,
  // 7430
  2538,
  3233,
  1011,
  1537,
  7960,
  2769,
  4261,
  3106,
  1061,
  7961,
  3720,
  3721,
  1866,
  2883,
  7962,
  2017,
  // 7446
  120,
  4262,
  4263,
  2062,
  3595,
  3234,
  2309,
  3840,
  2668,
  3382,
  1954,
  4542,
  7963,
  7964,
  3488,
  1047,
  // 7462
  2704,
  1266,
  7965,
  1368,
  4543,
  2845,
  649,
  3383,
  3841,
  2539,
  2738,
  1102,
  2846,
  2669,
  7966,
  7967,
  // 7478
  1999,
  7968,
  1111,
  3596,
  2962,
  7969,
  2488,
  3842,
  3597,
  2804,
  1854,
  3384,
  3722,
  7970,
  7971,
  3385,
  // 7494
  2410,
  2884,
  3304,
  3235,
  3598,
  7972,
  2569,
  7973,
  3599,
  2805,
  4031,
  1460,
  856,
  7974,
  3600,
  7975,
  // 7510
  2885,
  2963,
  7976,
  2886,
  3843,
  7977,
  4264,
  632,
  2510,
  875,
  3844,
  1697,
  3845,
  2291,
  7978,
  7979,
  // 7526
  4544,
  3010,
  1239,
  580,
  4545,
  4265,
  7980,
  914,
  936,
  2074,
  1190,
  4032,
  1039,
  2123,
  7981,
  7982,
  // 7542
  7983,
  3386,
  1473,
  7984,
  1354,
  4266,
  3846,
  7985,
  2172,
  3064,
  4033,
  915,
  3305,
  4267,
  4268,
  3306,
  // 7558
  1605,
  1834,
  7986,
  2739,
  398,
  3601,
  4269,
  3847,
  4034,
  328,
  1912,
  2847,
  4035,
  3848,
  1331,
  4270,
  // 7574
  3011,
  937,
  4271,
  7987,
  3602,
  4036,
  4037,
  3387,
  2160,
  4546,
  3388,
  524,
  742,
  538,
  3065,
  1012,
  // 7590
  7988,
  7989,
  3849,
  2461,
  7990,
  658,
  1103,
  225,
  3850,
  7991,
  7992,
  4547,
  7993,
  4548,
  7994,
  3236,
  // 7606
  1243,
  7995,
  4038,
  963,
  2246,
  4549,
  7996,
  2705,
  3603,
  3161,
  7997,
  7998,
  2588,
  2327,
  7999,
  4550,
  // 7622
  8e3,
  8001,
  8002,
  3489,
  3307,
  957,
  3389,
  2540,
  2032,
  1930,
  2927,
  2462,
  870,
  2018,
  3604,
  1746,
  // 7638
  2770,
  2771,
  2434,
  2463,
  8003,
  3851,
  8004,
  3723,
  3107,
  3724,
  3490,
  3390,
  3725,
  8005,
  1179,
  3066,
  // 7654
  8006,
  3162,
  2373,
  4272,
  3726,
  2541,
  3163,
  3108,
  2740,
  4039,
  8007,
  3391,
  1556,
  2542,
  2292,
  977,
  // 7670
  2887,
  2033,
  4040,
  1205,
  3392,
  8008,
  1765,
  3393,
  3164,
  2124,
  1271,
  1689,
  714,
  4551,
  3491,
  8009,
  // 7686
  2328,
  3852,
  533,
  4273,
  3605,
  2181,
  617,
  8010,
  2464,
  3308,
  3492,
  2310,
  8011,
  8012,
  3165,
  8013,
  // 7702
  8014,
  3853,
  1987,
  618,
  427,
  2641,
  3493,
  3394,
  8015,
  8016,
  1244,
  1690,
  8017,
  2806,
  4274,
  4552,
  // 7718
  8018,
  3494,
  8019,
  8020,
  2279,
  1576,
  473,
  3606,
  4275,
  3395,
  972,
  8021,
  3607,
  8022,
  3067,
  8023,
  // 7734
  8024,
  4553,
  4554,
  8025,
  3727,
  4041,
  4042,
  8026,
  153,
  4555,
  356,
  8027,
  1891,
  2888,
  4276,
  2143,
  // 7750
  408,
  803,
  2352,
  8028,
  3854,
  8029,
  4277,
  1646,
  2570,
  2511,
  4556,
  4557,
  3855,
  8030,
  3856,
  4278,
  // 7766
  8031,
  2411,
  3396,
  752,
  8032,
  8033,
  1961,
  2964,
  8034,
  746,
  3012,
  2465,
  8035,
  4279,
  3728,
  698,
  // 7782
  4558,
  1892,
  4280,
  3608,
  2543,
  4559,
  3609,
  3857,
  8036,
  3166,
  3397,
  8037,
  1823,
  1302,
  4043,
  2706,
  // 7798
  3858,
  1973,
  4281,
  8038,
  4282,
  3167,
  823,
  1303,
  1288,
  1236,
  2848,
  3495,
  4044,
  3398,
  774,
  3859,
  // 7814
  8039,
  1581,
  4560,
  1304,
  2849,
  3860,
  4561,
  8040,
  2435,
  2161,
  1083,
  3237,
  4283,
  4045,
  4284,
  344,
  // 7830
  1173,
  288,
  2311,
  454,
  1683,
  8041,
  8042,
  1461,
  4562,
  4046,
  2589,
  8043,
  8044,
  4563,
  985,
  894,
  // 7846
  8045,
  3399,
  3168,
  8046,
  1913,
  2928,
  3729,
  1988,
  8047,
  2110,
  1974,
  8048,
  4047,
  8049,
  2571,
  1194,
  // 7862
  425,
  8050,
  4564,
  3169,
  1245,
  3730,
  4285,
  8051,
  8052,
  2850,
  8053,
  636,
  4565,
  1855,
  3861,
  760,
  // 7878
  1799,
  8054,
  4286,
  2209,
  1508,
  4566,
  4048,
  1893,
  1684,
  2293,
  8055,
  8056,
  8057,
  4287,
  4288,
  2210,
  // 7894
  479,
  8058,
  8059,
  832,
  8060,
  4049,
  2489,
  8061,
  2965,
  2490,
  3731,
  990,
  3109,
  627,
  1814,
  2642,
  // 7910
  4289,
  1582,
  4290,
  2125,
  2111,
  3496,
  4567,
  8062,
  799,
  4291,
  3170,
  8063,
  4568,
  2112,
  1737,
  3013,
  // 7926
  1018,
  543,
  754,
  4292,
  3309,
  1676,
  4569,
  4570,
  4050,
  8064,
  1489,
  8065,
  3497,
  8066,
  2614,
  2889,
  // 7942
  4051,
  8067,
  8068,
  2966,
  8069,
  8070,
  8071,
  8072,
  3171,
  4571,
  4572,
  2182,
  1722,
  8073,
  3238,
  3239,
  // 7958
  1842,
  3610,
  1715,
  481,
  365,
  1975,
  1856,
  8074,
  8075,
  1962,
  2491,
  4573,
  8076,
  2126,
  3611,
  3240,
  // 7974
  433,
  1894,
  2063,
  2075,
  8077,
  602,
  2741,
  8078,
  8079,
  8080,
  8081,
  8082,
  3014,
  1628,
  3400,
  8083,
  // 7990
  3172,
  4574,
  4052,
  2890,
  4575,
  2512,
  8084,
  2544,
  2772,
  8085,
  8086,
  8087,
  3310,
  4576,
  2891,
  8088,
  // 8006
  4577,
  8089,
  2851,
  4578,
  4579,
  1221,
  2967,
  4053,
  2513,
  8090,
  8091,
  8092,
  1867,
  1989,
  8093,
  8094,
  // 8022
  8095,
  1895,
  8096,
  8097,
  4580,
  1896,
  4054,
  318,
  8098,
  2094,
  4055,
  4293,
  8099,
  8100,
  485,
  8101,
  // 8038
  938,
  3862,
  553,
  2670,
  116,
  8102,
  3863,
  3612,
  8103,
  3498,
  2671,
  2773,
  3401,
  3311,
  2807,
  8104,
  // 8054
  3613,
  2929,
  4056,
  1747,
  2930,
  2968,
  8105,
  8106,
  207,
  8107,
  8108,
  2672,
  4581,
  2514,
  8109,
  3015,
  // 8070
  890,
  3614,
  3864,
  8110,
  1877,
  3732,
  3402,
  8111,
  2183,
  2353,
  3403,
  1652,
  8112,
  8113,
  8114,
  941,
  // 8086
  2294,
  208,
  3499,
  4057,
  2019,
  330,
  4294,
  3865,
  2892,
  2492,
  3733,
  4295,
  8115,
  8116,
  8117,
  8118,
  // 8102
  //Everything below is of no interest for detection purpose
  2515,
  1613,
  4582,
  8119,
  3312,
  3866,
  2516,
  8120,
  4058,
  8121,
  1637,
  4059,
  2466,
  4583,
  3867,
  8122,
  // 8118
  2493,
  3016,
  3734,
  8123,
  8124,
  2192,
  8125,
  8126,
  2162,
  8127,
  8128,
  8129,
  8130,
  8131,
  8132,
  8133,
  // 8134
  8134,
  8135,
  8136,
  8137,
  8138,
  8139,
  8140,
  8141,
  8142,
  8143,
  8144,
  8145,
  8146,
  8147,
  8148,
  8149,
  // 8150
  8150,
  8151,
  8152,
  8153,
  8154,
  8155,
  8156,
  8157,
  8158,
  8159,
  8160,
  8161,
  8162,
  8163,
  8164,
  8165,
  // 8166
  8166,
  8167,
  8168,
  8169,
  8170,
  8171,
  8172,
  8173,
  8174,
  8175,
  8176,
  8177,
  8178,
  8179,
  8180,
  8181,
  // 8182
  8182,
  8183,
  8184,
  8185,
  8186,
  8187,
  8188,
  8189,
  8190,
  8191,
  8192,
  8193,
  8194,
  8195,
  8196,
  8197,
  // 8198
  8198,
  8199,
  8200,
  8201,
  8202,
  8203,
  8204,
  8205,
  8206,
  8207,
  8208,
  8209,
  8210,
  8211,
  8212,
  8213,
  // 8214
  8214,
  8215,
  8216,
  8217,
  8218,
  8219,
  8220,
  8221,
  8222,
  8223,
  8224,
  8225,
  8226,
  8227,
  8228,
  8229,
  // 8230
  8230,
  8231,
  8232,
  8233,
  8234,
  8235,
  8236,
  8237,
  8238,
  8239,
  8240,
  8241,
  8242,
  8243,
  8244,
  8245,
  // 8246
  8246,
  8247,
  8248,
  8249,
  8250,
  8251,
  8252,
  8253,
  8254,
  8255,
  8256,
  8257,
  8258,
  8259,
  8260,
  8261,
  // 8262
  8262,
  8263,
  8264,
  8265,
  8266,
  8267,
  8268,
  8269,
  8270,
  8271,
  8272,
  8273,
  8274,
  8275,
  8276,
  8277,
  // 8278
  8278,
  8279,
  8280,
  8281,
  8282,
  8283,
  8284,
  8285,
  8286,
  8287,
  8288,
  8289,
  8290,
  8291,
  8292,
  8293,
  // 8294
  8294,
  8295,
  8296,
  8297,
  8298,
  8299,
  8300,
  8301,
  8302,
  8303,
  8304,
  8305,
  8306,
  8307,
  8308,
  8309,
  // 8310
  8310,
  8311,
  8312,
  8313,
  8314,
  8315,
  8316,
  8317,
  8318,
  8319,
  8320,
  8321,
  8322,
  8323,
  8324,
  8325,
  // 8326
  8326,
  8327,
  8328,
  8329,
  8330,
  8331,
  8332,
  8333,
  8334,
  8335,
  8336,
  8337,
  8338,
  8339,
  8340,
  8341,
  // 8342
  8342,
  8343,
  8344,
  8345,
  8346,
  8347,
  8348,
  8349,
  8350,
  8351,
  8352,
  8353,
  8354,
  8355,
  8356,
  8357,
  // 8358
  8358,
  8359,
  8360,
  8361,
  8362,
  8363,
  8364,
  8365,
  8366,
  8367,
  8368,
  8369,
  8370,
  8371,
  8372,
  8373,
  // 8374
  8374,
  8375,
  8376,
  8377,
  8378,
  8379,
  8380,
  8381,
  8382,
  8383,
  8384,
  8385,
  8386,
  8387,
  8388,
  8389,
  // 8390
  8390,
  8391,
  8392,
  8393,
  8394,
  8395,
  8396,
  8397,
  8398,
  8399,
  8400,
  8401,
  8402,
  8403,
  8404,
  8405,
  // 8406
  8406,
  8407,
  8408,
  8409,
  8410,
  8411,
  8412,
  8413,
  8414,
  8415,
  8416,
  8417,
  8418,
  8419,
  8420,
  8421,
  // 8422
  8422,
  8423,
  8424,
  8425,
  8426,
  8427,
  8428,
  8429,
  8430,
  8431,
  8432,
  8433,
  8434,
  8435,
  8436,
  8437,
  // 8438
  8438,
  8439,
  8440,
  8441,
  8442,
  8443,
  8444,
  8445,
  8446,
  8447,
  8448,
  8449,
  8450,
  8451,
  8452,
  8453,
  // 8454
  8454,
  8455,
  8456,
  8457,
  8458,
  8459,
  8460,
  8461,
  8462,
  8463,
  8464,
  8465,
  8466,
  8467,
  8468,
  8469,
  // 8470
  8470,
  8471,
  8472,
  8473,
  8474,
  8475,
  8476,
  8477,
  8478,
  8479,
  8480,
  8481,
  8482,
  8483,
  8484,
  8485,
  // 8486
  8486,
  8487,
  8488,
  8489,
  8490,
  8491,
  8492,
  8493,
  8494,
  8495,
  8496,
  8497,
  8498,
  8499,
  8500,
  8501,
  // 8502
  8502,
  8503,
  8504,
  8505,
  8506,
  8507,
  8508,
  8509,
  8510,
  8511,
  8512,
  8513,
  8514,
  8515,
  8516,
  8517,
  // 8518
  8518,
  8519,
  8520,
  8521,
  8522,
  8523,
  8524,
  8525,
  8526,
  8527,
  8528,
  8529,
  8530,
  8531,
  8532,
  8533,
  // 8534
  8534,
  8535,
  8536,
  8537,
  8538,
  8539,
  8540,
  8541,
  8542,
  8543,
  8544,
  8545,
  8546,
  8547,
  8548,
  8549,
  // 8550
  8550,
  8551,
  8552,
  8553,
  8554,
  8555,
  8556,
  8557,
  8558,
  8559,
  8560,
  8561,
  8562,
  8563,
  8564,
  8565,
  // 8566
  8566,
  8567,
  8568,
  8569,
  8570,
  8571,
  8572,
  8573,
  8574,
  8575,
  8576,
  8577,
  8578,
  8579,
  8580,
  8581,
  // 8582
  8582,
  8583,
  8584,
  8585,
  8586,
  8587,
  8588,
  8589,
  8590,
  8591,
  8592,
  8593,
  8594,
  8595,
  8596,
  8597,
  // 8598
  8598,
  8599,
  8600,
  8601,
  8602,
  8603,
  8604,
  8605,
  8606,
  8607,
  8608,
  8609,
  8610,
  8611,
  8612,
  8613,
  // 8614
  8614,
  8615,
  8616,
  8617,
  8618,
  8619,
  8620,
  8621,
  8622,
  8623,
  8624,
  8625,
  8626,
  8627,
  8628,
  8629,
  // 8630
  8630,
  8631,
  8632,
  8633,
  8634,
  8635,
  8636,
  8637,
  8638,
  8639,
  8640,
  8641,
  8642,
  8643,
  8644,
  8645,
  // 8646
  8646,
  8647,
  8648,
  8649,
  8650,
  8651,
  8652,
  8653,
  8654,
  8655,
  8656,
  8657,
  8658,
  8659,
  8660,
  8661,
  // 8662
  8662,
  8663,
  8664,
  8665,
  8666,
  8667,
  8668,
  8669,
  8670,
  8671,
  8672,
  8673,
  8674,
  8675,
  8676,
  8677,
  // 8678
  8678,
  8679,
  8680,
  8681,
  8682,
  8683,
  8684,
  8685,
  8686,
  8687,
  8688,
  8689,
  8690,
  8691,
  8692,
  8693,
  // 8694
  8694,
  8695,
  8696,
  8697,
  8698,
  8699,
  8700,
  8701,
  8702,
  8703,
  8704,
  8705,
  8706,
  8707,
  8708,
  8709,
  // 8710
  8710,
  8711,
  8712,
  8713,
  8714,
  8715,
  8716,
  8717,
  8718,
  8719,
  8720,
  8721,
  8722,
  8723,
  8724,
  8725,
  // 8726
  8726,
  8727,
  8728,
  8729,
  8730,
  8731,
  8732,
  8733,
  8734,
  8735,
  8736,
  8737,
  8738,
  8739,
  8740,
  8741
];
var Ge = {};
Ge.EUCKR_TYPICAL_DISTRIBUTION_RATIO = 6;
Ge.EUCKR_TABLE_SIZE = 2352;
Ge.EUCKRCharToFreqOrder = [
  13,
  130,
  120,
  1396,
  481,
  1719,
  1720,
  328,
  609,
  212,
  1721,
  707,
  400,
  299,
  1722,
  87,
  1397,
  1723,
  104,
  536,
  1117,
  1203,
  1724,
  1267,
  685,
  1268,
  508,
  1725,
  1726,
  1727,
  1728,
  1398,
  1399,
  1729,
  1730,
  1731,
  141,
  621,
  326,
  1057,
  368,
  1732,
  267,
  488,
  20,
  1733,
  1269,
  1734,
  945,
  1400,
  1735,
  47,
  904,
  1270,
  1736,
  1737,
  773,
  248,
  1738,
  409,
  313,
  786,
  429,
  1739,
  116,
  987,
  813,
  1401,
  683,
  75,
  1204,
  145,
  1740,
  1741,
  1742,
  1743,
  16,
  847,
  667,
  622,
  708,
  1744,
  1745,
  1746,
  966,
  787,
  304,
  129,
  1747,
  60,
  820,
  123,
  676,
  1748,
  1749,
  1750,
  1751,
  617,
  1752,
  626,
  1753,
  1754,
  1755,
  1756,
  653,
  1757,
  1758,
  1759,
  1760,
  1761,
  1762,
  856,
  344,
  1763,
  1764,
  1765,
  1766,
  89,
  401,
  418,
  806,
  905,
  848,
  1767,
  1768,
  1769,
  946,
  1205,
  709,
  1770,
  1118,
  1771,
  241,
  1772,
  1773,
  1774,
  1271,
  1775,
  569,
  1776,
  999,
  1777,
  1778,
  1779,
  1780,
  337,
  751,
  1058,
  28,
  628,
  254,
  1781,
  177,
  906,
  270,
  349,
  891,
  1079,
  1782,
  19,
  1783,
  379,
  1784,
  315,
  1785,
  629,
  754,
  1402,
  559,
  1786,
  636,
  203,
  1206,
  1787,
  710,
  567,
  1788,
  935,
  814,
  1789,
  1790,
  1207,
  766,
  528,
  1791,
  1792,
  1208,
  1793,
  1794,
  1795,
  1796,
  1797,
  1403,
  1798,
  1799,
  533,
  1059,
  1404,
  1405,
  1156,
  1406,
  936,
  884,
  1080,
  1800,
  351,
  1801,
  1802,
  1803,
  1804,
  1805,
  801,
  1806,
  1807,
  1808,
  1119,
  1809,
  1157,
  714,
  474,
  1407,
  1810,
  298,
  899,
  885,
  1811,
  1120,
  802,
  1158,
  1812,
  892,
  1813,
  1814,
  1408,
  659,
  1815,
  1816,
  1121,
  1817,
  1818,
  1819,
  1820,
  1821,
  1822,
  319,
  1823,
  594,
  545,
  1824,
  815,
  937,
  1209,
  1825,
  1826,
  573,
  1409,
  1022,
  1827,
  1210,
  1828,
  1829,
  1830,
  1831,
  1832,
  1833,
  556,
  722,
  807,
  1122,
  1060,
  1834,
  697,
  1835,
  900,
  557,
  715,
  1836,
  1410,
  540,
  1411,
  752,
  1159,
  294,
  597,
  1211,
  976,
  803,
  770,
  1412,
  1837,
  1838,
  39,
  794,
  1413,
  358,
  1839,
  371,
  925,
  1840,
  453,
  661,
  788,
  531,
  723,
  544,
  1023,
  1081,
  869,
  91,
  1841,
  392,
  430,
  790,
  602,
  1414,
  677,
  1082,
  457,
  1415,
  1416,
  1842,
  1843,
  475,
  327,
  1024,
  1417,
  795,
  121,
  1844,
  733,
  403,
  1418,
  1845,
  1846,
  1847,
  300,
  119,
  711,
  1212,
  627,
  1848,
  1272,
  207,
  1849,
  1850,
  796,
  1213,
  382,
  1851,
  519,
  1852,
  1083,
  893,
  1853,
  1854,
  1855,
  367,
  809,
  487,
  671,
  1856,
  663,
  1857,
  1858,
  956,
  471,
  306,
  857,
  1859,
  1860,
  1160,
  1084,
  1861,
  1862,
  1863,
  1864,
  1865,
  1061,
  1866,
  1867,
  1868,
  1869,
  1870,
  1871,
  282,
  96,
  574,
  1872,
  502,
  1085,
  1873,
  1214,
  1874,
  907,
  1875,
  1876,
  827,
  977,
  1419,
  1420,
  1421,
  268,
  1877,
  1422,
  1878,
  1879,
  1880,
  308,
  1881,
  2,
  537,
  1882,
  1883,
  1215,
  1884,
  1885,
  127,
  791,
  1886,
  1273,
  1423,
  1887,
  34,
  336,
  404,
  643,
  1888,
  571,
  654,
  894,
  840,
  1889,
  0,
  886,
  1274,
  122,
  575,
  260,
  908,
  938,
  1890,
  1275,
  410,
  316,
  1891,
  1892,
  100,
  1893,
  1894,
  1123,
  48,
  1161,
  1124,
  1025,
  1895,
  633,
  901,
  1276,
  1896,
  1897,
  115,
  816,
  1898,
  317,
  1899,
  694,
  1900,
  909,
  734,
  1424,
  572,
  866,
  1425,
  691,
  85,
  524,
  1010,
  543,
  394,
  841,
  1901,
  1902,
  1903,
  1026,
  1904,
  1905,
  1906,
  1907,
  1908,
  1909,
  30,
  451,
  651,
  988,
  310,
  1910,
  1911,
  1426,
  810,
  1216,
  93,
  1912,
  1913,
  1277,
  1217,
  1914,
  858,
  759,
  45,
  58,
  181,
  610,
  269,
  1915,
  1916,
  131,
  1062,
  551,
  443,
  1e3,
  821,
  1427,
  957,
  895,
  1086,
  1917,
  1918,
  375,
  1919,
  359,
  1920,
  687,
  1921,
  822,
  1922,
  293,
  1923,
  1924,
  40,
  662,
  118,
  692,
  29,
  939,
  887,
  640,
  482,
  174,
  1925,
  69,
  1162,
  728,
  1428,
  910,
  1926,
  1278,
  1218,
  1279,
  386,
  870,
  217,
  854,
  1163,
  823,
  1927,
  1928,
  1929,
  1930,
  834,
  1931,
  78,
  1932,
  859,
  1933,
  1063,
  1934,
  1935,
  1936,
  1937,
  438,
  1164,
  208,
  595,
  1938,
  1939,
  1940,
  1941,
  1219,
  1125,
  1942,
  280,
  888,
  1429,
  1430,
  1220,
  1431,
  1943,
  1944,
  1945,
  1946,
  1947,
  1280,
  150,
  510,
  1432,
  1948,
  1949,
  1950,
  1951,
  1952,
  1953,
  1954,
  1011,
  1087,
  1955,
  1433,
  1043,
  1956,
  881,
  1957,
  614,
  958,
  1064,
  1065,
  1221,
  1958,
  638,
  1001,
  860,
  967,
  896,
  1434,
  989,
  492,
  553,
  1281,
  1165,
  1959,
  1282,
  1002,
  1283,
  1222,
  1960,
  1961,
  1962,
  1963,
  36,
  383,
  228,
  753,
  247,
  454,
  1964,
  876,
  678,
  1965,
  1966,
  1284,
  126,
  464,
  490,
  835,
  136,
  672,
  529,
  940,
  1088,
  1435,
  473,
  1967,
  1968,
  467,
  50,
  390,
  227,
  587,
  279,
  378,
  598,
  792,
  968,
  240,
  151,
  160,
  849,
  882,
  1126,
  1285,
  639,
  1044,
  133,
  140,
  288,
  360,
  811,
  563,
  1027,
  561,
  142,
  523,
  1969,
  1970,
  1971,
  7,
  103,
  296,
  439,
  407,
  506,
  634,
  990,
  1972,
  1973,
  1974,
  1975,
  645,
  1976,
  1977,
  1978,
  1979,
  1980,
  1981,
  236,
  1982,
  1436,
  1983,
  1984,
  1089,
  192,
  828,
  618,
  518,
  1166,
  333,
  1127,
  1985,
  818,
  1223,
  1986,
  1987,
  1988,
  1989,
  1990,
  1991,
  1992,
  1993,
  342,
  1128,
  1286,
  746,
  842,
  1994,
  1995,
  560,
  223,
  1287,
  98,
  8,
  189,
  650,
  978,
  1288,
  1996,
  1437,
  1997,
  17,
  345,
  250,
  423,
  277,
  234,
  512,
  226,
  97,
  289,
  42,
  167,
  1998,
  201,
  1999,
  2e3,
  843,
  836,
  824,
  532,
  338,
  783,
  1090,
  182,
  576,
  436,
  1438,
  1439,
  527,
  500,
  2001,
  947,
  889,
  2002,
  2003,
  2004,
  2005,
  262,
  600,
  314,
  447,
  2006,
  547,
  2007,
  693,
  738,
  1129,
  2008,
  71,
  1440,
  745,
  619,
  688,
  2009,
  829,
  2010,
  2011,
  147,
  2012,
  33,
  948,
  2013,
  2014,
  74,
  224,
  2015,
  61,
  191,
  918,
  399,
  637,
  2016,
  1028,
  1130,
  257,
  902,
  2017,
  2018,
  2019,
  2020,
  2021,
  2022,
  2023,
  2024,
  2025,
  2026,
  837,
  2027,
  2028,
  2029,
  2030,
  179,
  874,
  591,
  52,
  724,
  246,
  2031,
  2032,
  2033,
  2034,
  1167,
  969,
  2035,
  1289,
  630,
  605,
  911,
  1091,
  1168,
  2036,
  2037,
  2038,
  1441,
  912,
  2039,
  623,
  2040,
  2041,
  253,
  1169,
  1290,
  2042,
  1442,
  146,
  620,
  611,
  577,
  433,
  2043,
  1224,
  719,
  1170,
  959,
  440,
  437,
  534,
  84,
  388,
  480,
  1131,
  159,
  220,
  198,
  679,
  2044,
  1012,
  819,
  1066,
  1443,
  113,
  1225,
  194,
  318,
  1003,
  1029,
  2045,
  2046,
  2047,
  2048,
  1067,
  2049,
  2050,
  2051,
  2052,
  2053,
  59,
  913,
  112,
  2054,
  632,
  2055,
  455,
  144,
  739,
  1291,
  2056,
  273,
  681,
  499,
  2057,
  448,
  2058,
  2059,
  760,
  2060,
  2061,
  970,
  384,
  169,
  245,
  1132,
  2062,
  2063,
  414,
  1444,
  2064,
  2065,
  41,
  235,
  2066,
  157,
  252,
  877,
  568,
  919,
  789,
  580,
  2067,
  725,
  2068,
  2069,
  1292,
  2070,
  2071,
  1445,
  2072,
  1446,
  2073,
  2074,
  55,
  588,
  66,
  1447,
  271,
  1092,
  2075,
  1226,
  2076,
  960,
  1013,
  372,
  2077,
  2078,
  2079,
  2080,
  2081,
  1293,
  2082,
  2083,
  2084,
  2085,
  850,
  2086,
  2087,
  2088,
  2089,
  2090,
  186,
  2091,
  1068,
  180,
  2092,
  2093,
  2094,
  109,
  1227,
  522,
  606,
  2095,
  867,
  1448,
  1093,
  991,
  1171,
  926,
  353,
  1133,
  2096,
  581,
  2097,
  2098,
  2099,
  1294,
  1449,
  1450,
  2100,
  596,
  1172,
  1014,
  1228,
  2101,
  1451,
  1295,
  1173,
  1229,
  2102,
  2103,
  1296,
  1134,
  1452,
  949,
  1135,
  2104,
  2105,
  1094,
  1453,
  1454,
  1455,
  2106,
  1095,
  2107,
  2108,
  2109,
  2110,
  2111,
  2112,
  2113,
  2114,
  2115,
  2116,
  2117,
  804,
  2118,
  2119,
  1230,
  1231,
  805,
  1456,
  405,
  1136,
  2120,
  2121,
  2122,
  2123,
  2124,
  720,
  701,
  1297,
  992,
  1457,
  927,
  1004,
  2125,
  2126,
  2127,
  2128,
  2129,
  2130,
  22,
  417,
  2131,
  303,
  2132,
  385,
  2133,
  971,
  520,
  513,
  2134,
  1174,
  73,
  1096,
  231,
  274,
  962,
  1458,
  673,
  2135,
  1459,
  2136,
  152,
  1137,
  2137,
  2138,
  2139,
  2140,
  1005,
  1138,
  1460,
  1139,
  2141,
  2142,
  2143,
  2144,
  11,
  374,
  844,
  2145,
  154,
  1232,
  46,
  1461,
  2146,
  838,
  830,
  721,
  1233,
  106,
  2147,
  90,
  428,
  462,
  578,
  566,
  1175,
  352,
  2148,
  2149,
  538,
  1234,
  124,
  1298,
  2150,
  1462,
  761,
  565,
  2151,
  686,
  2152,
  649,
  2153,
  72,
  173,
  2154,
  460,
  415,
  2155,
  1463,
  2156,
  1235,
  305,
  2157,
  2158,
  2159,
  2160,
  2161,
  2162,
  579,
  2163,
  2164,
  2165,
  2166,
  2167,
  747,
  2168,
  2169,
  2170,
  2171,
  1464,
  669,
  2172,
  2173,
  2174,
  2175,
  2176,
  1465,
  2177,
  23,
  530,
  285,
  2178,
  335,
  729,
  2179,
  397,
  2180,
  2181,
  2182,
  1030,
  2183,
  2184,
  698,
  2185,
  2186,
  325,
  2187,
  2188,
  369,
  2189,
  799,
  1097,
  1015,
  348,
  2190,
  1069,
  680,
  2191,
  851,
  1466,
  2192,
  2193,
  10,
  2194,
  613,
  424,
  2195,
  979,
  108,
  449,
  589,
  27,
  172,
  81,
  1031,
  80,
  774,
  281,
  350,
  1032,
  525,
  301,
  582,
  1176,
  2196,
  674,
  1045,
  2197,
  2198,
  1467,
  730,
  762,
  2199,
  2200,
  2201,
  2202,
  1468,
  2203,
  993,
  2204,
  2205,
  266,
  1070,
  963,
  1140,
  2206,
  2207,
  2208,
  664,
  1098,
  972,
  2209,
  2210,
  2211,
  1177,
  1469,
  1470,
  871,
  2212,
  2213,
  2214,
  2215,
  2216,
  1471,
  2217,
  2218,
  2219,
  2220,
  2221,
  2222,
  2223,
  2224,
  2225,
  2226,
  2227,
  1472,
  1236,
  2228,
  2229,
  2230,
  2231,
  2232,
  2233,
  2234,
  2235,
  1299,
  2236,
  2237,
  200,
  2238,
  477,
  373,
  2239,
  2240,
  731,
  825,
  777,
  2241,
  2242,
  2243,
  521,
  486,
  548,
  2244,
  2245,
  2246,
  1473,
  1300,
  53,
  549,
  137,
  875,
  76,
  158,
  2247,
  1301,
  1474,
  469,
  396,
  1016,
  278,
  712,
  2248,
  321,
  442,
  503,
  767,
  744,
  941,
  1237,
  1178,
  1475,
  2249,
  82,
  178,
  1141,
  1179,
  973,
  2250,
  1302,
  2251,
  297,
  2252,
  2253,
  570,
  2254,
  2255,
  2256,
  18,
  450,
  206,
  2257,
  290,
  292,
  1142,
  2258,
  511,
  162,
  99,
  346,
  164,
  735,
  2259,
  1476,
  1477,
  4,
  554,
  343,
  798,
  1099,
  2260,
  1100,
  2261,
  43,
  171,
  1303,
  139,
  215,
  2262,
  2263,
  717,
  775,
  2264,
  1033,
  322,
  216,
  2265,
  831,
  2266,
  149,
  2267,
  1304,
  2268,
  2269,
  702,
  1238,
  135,
  845,
  347,
  309,
  2270,
  484,
  2271,
  878,
  655,
  238,
  1006,
  1478,
  2272,
  67,
  2273,
  295,
  2274,
  2275,
  461,
  2276,
  478,
  942,
  412,
  2277,
  1034,
  2278,
  2279,
  2280,
  265,
  2281,
  541,
  2282,
  2283,
  2284,
  2285,
  2286,
  70,
  852,
  1071,
  2287,
  2288,
  2289,
  2290,
  21,
  56,
  509,
  117,
  432,
  2291,
  2292,
  331,
  980,
  552,
  1101,
  148,
  284,
  105,
  393,
  1180,
  1239,
  755,
  2293,
  187,
  2294,
  1046,
  1479,
  2295,
  340,
  2296,
  63,
  1047,
  230,
  2297,
  2298,
  1305,
  763,
  1306,
  101,
  800,
  808,
  494,
  2299,
  2300,
  2301,
  903,
  2302,
  37,
  1072,
  14,
  5,
  2303,
  79,
  675,
  2304,
  312,
  2305,
  2306,
  2307,
  2308,
  2309,
  1480,
  6,
  1307,
  2310,
  2311,
  2312,
  1,
  470,
  35,
  24,
  229,
  2313,
  695,
  210,
  86,
  778,
  15,
  784,
  592,
  779,
  32,
  77,
  855,
  964,
  2314,
  259,
  2315,
  501,
  380,
  2316,
  2317,
  83,
  981,
  153,
  689,
  1308,
  1481,
  1482,
  1483,
  2318,
  2319,
  716,
  1484,
  2320,
  2321,
  2322,
  2323,
  2324,
  2325,
  1485,
  2326,
  2327,
  128,
  57,
  68,
  261,
  1048,
  211,
  170,
  1240,
  31,
  2328,
  51,
  435,
  742,
  2329,
  2330,
  2331,
  635,
  2332,
  264,
  456,
  2333,
  2334,
  2335,
  425,
  2336,
  1486,
  143,
  507,
  263,
  943,
  2337,
  363,
  920,
  1487,
  256,
  1488,
  1102,
  243,
  601,
  1489,
  2338,
  2339,
  2340,
  2341,
  2342,
  2343,
  2344,
  861,
  2345,
  2346,
  2347,
  2348,
  2349,
  2350,
  395,
  2351,
  1490,
  1491,
  62,
  535,
  166,
  225,
  2352,
  2353,
  668,
  419,
  1241,
  138,
  604,
  928,
  2354,
  1181,
  2355,
  1492,
  1493,
  2356,
  2357,
  2358,
  1143,
  2359,
  696,
  2360,
  387,
  307,
  1309,
  682,
  476,
  2361,
  2362,
  332,
  12,
  222,
  156,
  2363,
  232,
  2364,
  641,
  276,
  656,
  517,
  1494,
  1495,
  1035,
  416,
  736,
  1496,
  2365,
  1017,
  586,
  2366,
  2367,
  2368,
  1497,
  2369,
  242,
  2370,
  2371,
  2372,
  1498,
  2373,
  965,
  713,
  2374,
  2375,
  2376,
  2377,
  740,
  982,
  1499,
  944,
  1500,
  1007,
  2378,
  2379,
  1310,
  1501,
  2380,
  2381,
  2382,
  785,
  329,
  2383,
  2384,
  1502,
  2385,
  2386,
  2387,
  932,
  2388,
  1503,
  2389,
  2390,
  2391,
  2392,
  1242,
  2393,
  2394,
  2395,
  2396,
  2397,
  994,
  950,
  2398,
  2399,
  2400,
  2401,
  1504,
  1311,
  2402,
  2403,
  2404,
  2405,
  1049,
  749,
  2406,
  2407,
  853,
  718,
  1144,
  1312,
  2408,
  1182,
  1505,
  2409,
  2410,
  255,
  516,
  479,
  564,
  550,
  214,
  1506,
  1507,
  1313,
  413,
  239,
  444,
  339,
  1145,
  1036,
  1508,
  1509,
  1314,
  1037,
  1510,
  1315,
  2411,
  1511,
  2412,
  2413,
  2414,
  176,
  703,
  497,
  624,
  593,
  921,
  302,
  2415,
  341,
  165,
  1103,
  1512,
  2416,
  1513,
  2417,
  2418,
  2419,
  376,
  2420,
  700,
  2421,
  2422,
  2423,
  258,
  768,
  1316,
  2424,
  1183,
  2425,
  995,
  608,
  2426,
  2427,
  2428,
  2429,
  221,
  2430,
  2431,
  2432,
  2433,
  2434,
  2435,
  2436,
  2437,
  195,
  323,
  726,
  188,
  897,
  983,
  1317,
  377,
  644,
  1050,
  879,
  2438,
  452,
  2439,
  2440,
  2441,
  2442,
  2443,
  2444,
  914,
  2445,
  2446,
  2447,
  2448,
  915,
  489,
  2449,
  1514,
  1184,
  2450,
  2451,
  515,
  64,
  427,
  495,
  2452,
  583,
  2453,
  483,
  485,
  1038,
  562,
  213,
  1515,
  748,
  666,
  2454,
  2455,
  2456,
  2457,
  334,
  2458,
  780,
  996,
  1008,
  705,
  1243,
  2459,
  2460,
  2461,
  2462,
  2463,
  114,
  2464,
  493,
  1146,
  366,
  163,
  1516,
  961,
  1104,
  2465,
  291,
  2466,
  1318,
  1105,
  2467,
  1517,
  365,
  2468,
  355,
  951,
  1244,
  2469,
  1319,
  2470,
  631,
  2471,
  2472,
  218,
  1320,
  364,
  320,
  756,
  1518,
  1519,
  1321,
  1520,
  1322,
  2473,
  2474,
  2475,
  2476,
  997,
  2477,
  2478,
  2479,
  2480,
  665,
  1185,
  2481,
  916,
  1521,
  2482,
  2483,
  2484,
  584,
  684,
  2485,
  2486,
  797,
  2487,
  1051,
  1186,
  2488,
  2489,
  2490,
  1522,
  2491,
  2492,
  370,
  2493,
  1039,
  1187,
  65,
  2494,
  434,
  205,
  463,
  1188,
  2495,
  125,
  812,
  391,
  402,
  826,
  699,
  286,
  398,
  155,
  781,
  771,
  585,
  2496,
  590,
  505,
  1073,
  2497,
  599,
  244,
  219,
  917,
  1018,
  952,
  646,
  1523,
  2498,
  1323,
  2499,
  2500,
  49,
  984,
  354,
  741,
  2501,
  625,
  2502,
  1324,
  2503,
  1019,
  190,
  357,
  757,
  491,
  95,
  782,
  868,
  2504,
  2505,
  2506,
  2507,
  2508,
  2509,
  134,
  1524,
  1074,
  422,
  1525,
  898,
  2510,
  161,
  2511,
  2512,
  2513,
  2514,
  769,
  2515,
  1526,
  2516,
  2517,
  411,
  1325,
  2518,
  472,
  1527,
  2519,
  2520,
  2521,
  2522,
  2523,
  2524,
  985,
  2525,
  2526,
  2527,
  2528,
  2529,
  2530,
  764,
  2531,
  1245,
  2532,
  2533,
  25,
  204,
  311,
  2534,
  496,
  2535,
  1052,
  2536,
  2537,
  2538,
  2539,
  2540,
  2541,
  2542,
  199,
  704,
  504,
  468,
  758,
  657,
  1528,
  196,
  44,
  839,
  1246,
  272,
  750,
  2543,
  765,
  862,
  2544,
  2545,
  1326,
  2546,
  132,
  615,
  933,
  2547,
  732,
  2548,
  2549,
  2550,
  1189,
  1529,
  2551,
  283,
  1247,
  1053,
  607,
  929,
  2552,
  2553,
  2554,
  930,
  183,
  872,
  616,
  1040,
  1147,
  2555,
  1148,
  1020,
  441,
  249,
  1075,
  2556,
  2557,
  2558,
  466,
  743,
  2559,
  2560,
  2561,
  92,
  514,
  426,
  420,
  526,
  2562,
  2563,
  2564,
  2565,
  2566,
  2567,
  2568,
  185,
  2569,
  2570,
  2571,
  2572,
  776,
  1530,
  658,
  2573,
  362,
  2574,
  361,
  922,
  1076,
  793,
  2575,
  2576,
  2577,
  2578,
  2579,
  2580,
  1531,
  251,
  2581,
  2582,
  2583,
  2584,
  1532,
  54,
  612,
  237,
  1327,
  2585,
  2586,
  275,
  408,
  647,
  111,
  2587,
  1533,
  1106,
  465,
  3,
  458,
  9,
  38,
  2588,
  107,
  110,
  890,
  209,
  26,
  737,
  498,
  2589,
  1534,
  2590,
  431,
  202,
  88,
  1535,
  356,
  287,
  1107,
  660,
  1149,
  2591,
  381,
  1536,
  986,
  1150,
  445,
  1248,
  1151,
  974,
  2592,
  2593,
  846,
  2594,
  446,
  953,
  184,
  1249,
  1250,
  727,
  2595,
  923,
  193,
  883,
  2596,
  2597,
  2598,
  102,
  324,
  539,
  817,
  2599,
  421,
  1041,
  2600,
  832,
  2601,
  94,
  175,
  197,
  406,
  2602,
  459,
  2603,
  2604,
  2605,
  2606,
  2607,
  330,
  555,
  2608,
  2609,
  2610,
  706,
  1108,
  389,
  2611,
  2612,
  2613,
  2614,
  233,
  2615,
  833,
  558,
  931,
  954,
  1251,
  2616,
  2617,
  1537,
  546,
  2618,
  2619,
  1009,
  2620,
  2621,
  2622,
  1538,
  690,
  1328,
  2623,
  955,
  2624,
  1539,
  2625,
  2626,
  772,
  2627,
  2628,
  2629,
  2630,
  2631,
  924,
  648,
  863,
  603,
  2632,
  2633,
  934,
  1540,
  864,
  865,
  2634,
  642,
  1042,
  670,
  1190,
  2635,
  2636,
  2637,
  2638,
  168,
  2639,
  652,
  873,
  542,
  1054,
  1541,
  2640,
  2641,
  2642,
  // 512, 256
  //Everything below is of no interest for detection purpose
  2643,
  2644,
  2645,
  2646,
  2647,
  2648,
  2649,
  2650,
  2651,
  2652,
  2653,
  2654,
  2655,
  2656,
  2657,
  2658,
  2659,
  2660,
  2661,
  2662,
  2663,
  2664,
  2665,
  2666,
  2667,
  2668,
  2669,
  2670,
  2671,
  2672,
  2673,
  2674,
  2675,
  2676,
  2677,
  2678,
  2679,
  2680,
  2681,
  2682,
  2683,
  2684,
  2685,
  2686,
  2687,
  2688,
  2689,
  2690,
  2691,
  2692,
  2693,
  2694,
  2695,
  2696,
  2697,
  2698,
  2699,
  1542,
  880,
  2700,
  2701,
  2702,
  2703,
  2704,
  2705,
  2706,
  2707,
  2708,
  2709,
  2710,
  2711,
  2712,
  2713,
  2714,
  2715,
  2716,
  2717,
  2718,
  2719,
  2720,
  2721,
  2722,
  2723,
  2724,
  2725,
  1543,
  2726,
  2727,
  2728,
  2729,
  2730,
  2731,
  2732,
  1544,
  2733,
  2734,
  2735,
  2736,
  2737,
  2738,
  2739,
  2740,
  2741,
  2742,
  2743,
  2744,
  2745,
  2746,
  2747,
  2748,
  2749,
  2750,
  2751,
  2752,
  2753,
  2754,
  1545,
  2755,
  2756,
  2757,
  2758,
  2759,
  2760,
  2761,
  2762,
  2763,
  2764,
  2765,
  2766,
  1546,
  2767,
  1547,
  2768,
  2769,
  2770,
  2771,
  2772,
  2773,
  2774,
  2775,
  2776,
  2777,
  2778,
  2779,
  2780,
  2781,
  2782,
  2783,
  2784,
  2785,
  2786,
  1548,
  2787,
  2788,
  2789,
  1109,
  2790,
  2791,
  2792,
  2793,
  2794,
  2795,
  2796,
  2797,
  2798,
  2799,
  2800,
  2801,
  2802,
  2803,
  2804,
  2805,
  2806,
  2807,
  2808,
  2809,
  2810,
  2811,
  2812,
  1329,
  2813,
  2814,
  2815,
  2816,
  2817,
  2818,
  2819,
  2820,
  2821,
  2822,
  2823,
  2824,
  2825,
  2826,
  2827,
  2828,
  2829,
  2830,
  2831,
  2832,
  2833,
  2834,
  2835,
  2836,
  2837,
  2838,
  2839,
  2840,
  2841,
  2842,
  2843,
  2844,
  2845,
  2846,
  2847,
  2848,
  2849,
  2850,
  2851,
  2852,
  2853,
  2854,
  2855,
  2856,
  1549,
  2857,
  2858,
  2859,
  2860,
  1550,
  2861,
  2862,
  1551,
  2863,
  2864,
  2865,
  2866,
  2867,
  2868,
  2869,
  2870,
  2871,
  2872,
  2873,
  2874,
  1110,
  1330,
  2875,
  2876,
  2877,
  2878,
  2879,
  2880,
  2881,
  2882,
  2883,
  2884,
  2885,
  2886,
  2887,
  2888,
  2889,
  2890,
  2891,
  2892,
  2893,
  2894,
  2895,
  2896,
  2897,
  2898,
  2899,
  2900,
  2901,
  2902,
  2903,
  2904,
  2905,
  2906,
  2907,
  2908,
  2909,
  2910,
  2911,
  2912,
  2913,
  2914,
  2915,
  2916,
  2917,
  2918,
  2919,
  2920,
  2921,
  2922,
  2923,
  2924,
  2925,
  2926,
  2927,
  2928,
  2929,
  2930,
  1331,
  2931,
  2932,
  2933,
  2934,
  2935,
  2936,
  2937,
  2938,
  2939,
  2940,
  2941,
  2942,
  2943,
  1552,
  2944,
  2945,
  2946,
  2947,
  2948,
  2949,
  2950,
  2951,
  2952,
  2953,
  2954,
  2955,
  2956,
  2957,
  2958,
  2959,
  2960,
  2961,
  2962,
  2963,
  2964,
  1252,
  2965,
  2966,
  2967,
  2968,
  2969,
  2970,
  2971,
  2972,
  2973,
  2974,
  2975,
  2976,
  2977,
  2978,
  2979,
  2980,
  2981,
  2982,
  2983,
  2984,
  2985,
  2986,
  2987,
  2988,
  2989,
  2990,
  2991,
  2992,
  2993,
  2994,
  2995,
  2996,
  2997,
  2998,
  2999,
  3e3,
  3001,
  3002,
  3003,
  3004,
  3005,
  3006,
  3007,
  3008,
  3009,
  3010,
  3011,
  3012,
  1553,
  3013,
  3014,
  3015,
  3016,
  3017,
  1554,
  3018,
  1332,
  3019,
  3020,
  3021,
  3022,
  3023,
  3024,
  3025,
  3026,
  3027,
  3028,
  3029,
  3030,
  3031,
  3032,
  3033,
  3034,
  3035,
  3036,
  3037,
  3038,
  3039,
  3040,
  3041,
  3042,
  3043,
  3044,
  3045,
  3046,
  3047,
  3048,
  3049,
  3050,
  1555,
  3051,
  3052,
  3053,
  1556,
  1557,
  3054,
  3055,
  3056,
  3057,
  3058,
  3059,
  3060,
  3061,
  3062,
  3063,
  3064,
  3065,
  3066,
  3067,
  1558,
  3068,
  3069,
  3070,
  3071,
  3072,
  3073,
  3074,
  3075,
  3076,
  1559,
  3077,
  3078,
  3079,
  3080,
  3081,
  3082,
  3083,
  1253,
  3084,
  3085,
  3086,
  3087,
  3088,
  3089,
  3090,
  3091,
  3092,
  3093,
  3094,
  3095,
  3096,
  3097,
  3098,
  3099,
  3100,
  3101,
  3102,
  3103,
  3104,
  3105,
  3106,
  3107,
  3108,
  1152,
  3109,
  3110,
  3111,
  3112,
  3113,
  1560,
  3114,
  3115,
  3116,
  3117,
  1111,
  3118,
  3119,
  3120,
  3121,
  3122,
  3123,
  3124,
  3125,
  3126,
  3127,
  3128,
  3129,
  3130,
  3131,
  3132,
  3133,
  3134,
  3135,
  3136,
  3137,
  3138,
  3139,
  3140,
  3141,
  3142,
  3143,
  3144,
  3145,
  3146,
  3147,
  3148,
  3149,
  3150,
  3151,
  3152,
  3153,
  3154,
  3155,
  3156,
  3157,
  3158,
  3159,
  3160,
  3161,
  3162,
  3163,
  3164,
  3165,
  3166,
  3167,
  3168,
  3169,
  3170,
  3171,
  3172,
  3173,
  3174,
  3175,
  3176,
  1333,
  3177,
  3178,
  3179,
  3180,
  3181,
  3182,
  3183,
  3184,
  3185,
  3186,
  3187,
  3188,
  3189,
  1561,
  3190,
  3191,
  1334,
  3192,
  3193,
  3194,
  3195,
  3196,
  3197,
  3198,
  3199,
  3200,
  3201,
  3202,
  3203,
  3204,
  3205,
  3206,
  3207,
  3208,
  3209,
  3210,
  3211,
  3212,
  3213,
  3214,
  3215,
  3216,
  3217,
  3218,
  3219,
  3220,
  3221,
  3222,
  3223,
  3224,
  3225,
  3226,
  3227,
  3228,
  3229,
  3230,
  3231,
  3232,
  3233,
  3234,
  1562,
  3235,
  3236,
  3237,
  3238,
  3239,
  3240,
  3241,
  3242,
  3243,
  3244,
  3245,
  3246,
  3247,
  3248,
  3249,
  3250,
  3251,
  3252,
  3253,
  3254,
  3255,
  3256,
  3257,
  3258,
  3259,
  3260,
  3261,
  3262,
  3263,
  3264,
  3265,
  3266,
  3267,
  3268,
  3269,
  3270,
  3271,
  3272,
  3273,
  3274,
  3275,
  3276,
  3277,
  1563,
  3278,
  3279,
  3280,
  3281,
  3282,
  3283,
  3284,
  3285,
  3286,
  3287,
  3288,
  3289,
  3290,
  3291,
  3292,
  3293,
  3294,
  3295,
  3296,
  3297,
  3298,
  3299,
  3300,
  3301,
  3302,
  3303,
  3304,
  3305,
  3306,
  3307,
  3308,
  3309,
  3310,
  3311,
  3312,
  3313,
  3314,
  3315,
  3316,
  3317,
  3318,
  3319,
  3320,
  3321,
  3322,
  3323,
  3324,
  3325,
  3326,
  3327,
  3328,
  3329,
  3330,
  3331,
  3332,
  3333,
  3334,
  3335,
  3336,
  3337,
  3338,
  3339,
  3340,
  3341,
  3342,
  3343,
  3344,
  3345,
  3346,
  3347,
  3348,
  3349,
  3350,
  3351,
  3352,
  3353,
  3354,
  3355,
  3356,
  3357,
  3358,
  3359,
  3360,
  3361,
  3362,
  3363,
  3364,
  1335,
  3365,
  3366,
  3367,
  3368,
  3369,
  3370,
  3371,
  3372,
  3373,
  3374,
  3375,
  3376,
  3377,
  3378,
  3379,
  3380,
  3381,
  3382,
  3383,
  3384,
  3385,
  3386,
  3387,
  1336,
  3388,
  3389,
  3390,
  3391,
  3392,
  3393,
  3394,
  3395,
  3396,
  3397,
  3398,
  3399,
  3400,
  3401,
  3402,
  3403,
  3404,
  3405,
  3406,
  3407,
  3408,
  3409,
  3410,
  3411,
  3412,
  3413,
  3414,
  1337,
  3415,
  3416,
  3417,
  3418,
  3419,
  1338,
  3420,
  3421,
  3422,
  1564,
  1565,
  3423,
  3424,
  3425,
  3426,
  3427,
  3428,
  3429,
  3430,
  3431,
  1254,
  3432,
  3433,
  3434,
  1339,
  3435,
  3436,
  3437,
  3438,
  3439,
  1566,
  3440,
  3441,
  3442,
  3443,
  3444,
  3445,
  3446,
  3447,
  3448,
  3449,
  3450,
  3451,
  3452,
  3453,
  3454,
  1255,
  3455,
  3456,
  3457,
  3458,
  3459,
  1567,
  1191,
  3460,
  1568,
  1569,
  3461,
  3462,
  3463,
  1570,
  3464,
  3465,
  3466,
  3467,
  3468,
  1571,
  3469,
  3470,
  3471,
  3472,
  3473,
  1572,
  3474,
  3475,
  3476,
  3477,
  3478,
  3479,
  3480,
  3481,
  3482,
  3483,
  3484,
  3485,
  3486,
  1340,
  3487,
  3488,
  3489,
  3490,
  3491,
  3492,
  1021,
  3493,
  3494,
  3495,
  3496,
  3497,
  3498,
  1573,
  3499,
  1341,
  3500,
  3501,
  3502,
  3503,
  3504,
  3505,
  3506,
  3507,
  3508,
  3509,
  3510,
  3511,
  1342,
  3512,
  3513,
  3514,
  3515,
  3516,
  1574,
  1343,
  3517,
  3518,
  3519,
  1575,
  3520,
  1576,
  3521,
  3522,
  3523,
  3524,
  3525,
  3526,
  3527,
  3528,
  3529,
  3530,
  3531,
  3532,
  3533,
  3534,
  3535,
  3536,
  3537,
  3538,
  3539,
  3540,
  3541,
  3542,
  3543,
  3544,
  3545,
  3546,
  3547,
  3548,
  3549,
  3550,
  3551,
  3552,
  3553,
  3554,
  3555,
  3556,
  3557,
  3558,
  3559,
  3560,
  3561,
  3562,
  3563,
  3564,
  3565,
  3566,
  3567,
  3568,
  3569,
  3570,
  3571,
  3572,
  3573,
  3574,
  3575,
  3576,
  3577,
  3578,
  3579,
  3580,
  1577,
  3581,
  3582,
  1578,
  3583,
  3584,
  3585,
  3586,
  3587,
  3588,
  3589,
  3590,
  3591,
  3592,
  3593,
  3594,
  3595,
  3596,
  3597,
  3598,
  3599,
  3600,
  3601,
  3602,
  3603,
  3604,
  1579,
  3605,
  3606,
  3607,
  3608,
  3609,
  3610,
  3611,
  3612,
  3613,
  3614,
  3615,
  3616,
  3617,
  3618,
  3619,
  3620,
  3621,
  3622,
  3623,
  3624,
  3625,
  3626,
  3627,
  3628,
  3629,
  1580,
  3630,
  3631,
  1581,
  3632,
  3633,
  3634,
  3635,
  3636,
  3637,
  3638,
  3639,
  3640,
  3641,
  3642,
  3643,
  3644,
  3645,
  3646,
  3647,
  3648,
  3649,
  3650,
  3651,
  3652,
  3653,
  3654,
  3655,
  3656,
  1582,
  3657,
  3658,
  3659,
  3660,
  3661,
  3662,
  3663,
  3664,
  3665,
  3666,
  3667,
  3668,
  3669,
  3670,
  3671,
  3672,
  3673,
  3674,
  3675,
  3676,
  3677,
  3678,
  3679,
  3680,
  3681,
  3682,
  3683,
  3684,
  3685,
  3686,
  3687,
  3688,
  3689,
  3690,
  3691,
  3692,
  3693,
  3694,
  3695,
  3696,
  3697,
  3698,
  3699,
  3700,
  1192,
  3701,
  3702,
  3703,
  3704,
  1256,
  3705,
  3706,
  3707,
  3708,
  1583,
  1257,
  3709,
  3710,
  3711,
  3712,
  3713,
  3714,
  3715,
  3716,
  1584,
  3717,
  3718,
  3719,
  3720,
  3721,
  3722,
  3723,
  3724,
  3725,
  3726,
  3727,
  3728,
  3729,
  3730,
  3731,
  3732,
  3733,
  3734,
  3735,
  3736,
  3737,
  3738,
  3739,
  3740,
  3741,
  3742,
  3743,
  3744,
  3745,
  1344,
  3746,
  3747,
  3748,
  3749,
  3750,
  3751,
  3752,
  3753,
  3754,
  3755,
  3756,
  1585,
  3757,
  3758,
  3759,
  3760,
  3761,
  3762,
  3763,
  3764,
  3765,
  3766,
  1586,
  3767,
  3768,
  3769,
  3770,
  3771,
  3772,
  3773,
  3774,
  3775,
  3776,
  3777,
  3778,
  1345,
  3779,
  3780,
  3781,
  3782,
  3783,
  3784,
  3785,
  3786,
  3787,
  3788,
  3789,
  3790,
  3791,
  3792,
  3793,
  3794,
  3795,
  1346,
  1587,
  3796,
  3797,
  1588,
  3798,
  3799,
  3800,
  3801,
  3802,
  3803,
  3804,
  3805,
  3806,
  1347,
  3807,
  3808,
  3809,
  3810,
  3811,
  1589,
  3812,
  3813,
  3814,
  3815,
  3816,
  3817,
  3818,
  3819,
  3820,
  3821,
  1590,
  3822,
  3823,
  1591,
  1348,
  3824,
  3825,
  3826,
  3827,
  3828,
  3829,
  3830,
  1592,
  3831,
  3832,
  1593,
  3833,
  3834,
  3835,
  3836,
  3837,
  3838,
  3839,
  3840,
  3841,
  3842,
  3843,
  3844,
  1349,
  3845,
  3846,
  3847,
  3848,
  3849,
  3850,
  3851,
  3852,
  3853,
  3854,
  3855,
  3856,
  3857,
  3858,
  1594,
  3859,
  3860,
  3861,
  3862,
  3863,
  3864,
  3865,
  3866,
  3867,
  3868,
  3869,
  1595,
  3870,
  3871,
  3872,
  3873,
  1596,
  3874,
  3875,
  3876,
  3877,
  3878,
  3879,
  3880,
  3881,
  3882,
  3883,
  3884,
  3885,
  3886,
  1597,
  3887,
  3888,
  3889,
  3890,
  3891,
  3892,
  3893,
  3894,
  3895,
  1598,
  3896,
  3897,
  3898,
  1599,
  1600,
  3899,
  1350,
  3900,
  1351,
  3901,
  3902,
  1352,
  3903,
  3904,
  3905,
  3906,
  3907,
  3908,
  3909,
  3910,
  3911,
  3912,
  3913,
  3914,
  3915,
  3916,
  3917,
  3918,
  3919,
  3920,
  3921,
  3922,
  3923,
  3924,
  1258,
  3925,
  3926,
  3927,
  3928,
  3929,
  3930,
  3931,
  1193,
  3932,
  1601,
  3933,
  3934,
  3935,
  3936,
  3937,
  3938,
  3939,
  3940,
  3941,
  3942,
  3943,
  1602,
  3944,
  3945,
  3946,
  3947,
  3948,
  1603,
  3949,
  3950,
  3951,
  3952,
  3953,
  3954,
  3955,
  3956,
  3957,
  3958,
  3959,
  3960,
  3961,
  3962,
  3963,
  3964,
  3965,
  1604,
  3966,
  3967,
  3968,
  3969,
  3970,
  3971,
  3972,
  3973,
  3974,
  3975,
  3976,
  3977,
  1353,
  3978,
  3979,
  3980,
  3981,
  3982,
  3983,
  3984,
  3985,
  3986,
  3987,
  3988,
  3989,
  3990,
  3991,
  1354,
  3992,
  3993,
  3994,
  3995,
  3996,
  3997,
  3998,
  3999,
  4e3,
  4001,
  4002,
  4003,
  4004,
  4005,
  4006,
  4007,
  4008,
  4009,
  4010,
  4011,
  4012,
  4013,
  4014,
  4015,
  4016,
  4017,
  4018,
  4019,
  4020,
  4021,
  4022,
  4023,
  1355,
  4024,
  4025,
  4026,
  4027,
  4028,
  4029,
  4030,
  4031,
  4032,
  4033,
  4034,
  4035,
  4036,
  4037,
  4038,
  4039,
  4040,
  1605,
  4041,
  4042,
  4043,
  4044,
  4045,
  4046,
  4047,
  4048,
  4049,
  4050,
  4051,
  4052,
  4053,
  4054,
  4055,
  4056,
  4057,
  4058,
  4059,
  4060,
  1606,
  4061,
  4062,
  4063,
  4064,
  1607,
  4065,
  4066,
  4067,
  4068,
  4069,
  4070,
  4071,
  4072,
  4073,
  4074,
  4075,
  4076,
  1194,
  4077,
  4078,
  1608,
  4079,
  4080,
  4081,
  4082,
  4083,
  4084,
  4085,
  4086,
  4087,
  1609,
  4088,
  4089,
  4090,
  4091,
  4092,
  4093,
  4094,
  4095,
  4096,
  4097,
  4098,
  4099,
  4100,
  4101,
  4102,
  4103,
  4104,
  4105,
  4106,
  4107,
  4108,
  1259,
  4109,
  4110,
  4111,
  4112,
  4113,
  4114,
  4115,
  4116,
  4117,
  4118,
  4119,
  4120,
  4121,
  4122,
  4123,
  4124,
  1195,
  4125,
  4126,
  4127,
  1610,
  4128,
  4129,
  4130,
  4131,
  4132,
  4133,
  4134,
  4135,
  4136,
  4137,
  1356,
  4138,
  4139,
  4140,
  4141,
  4142,
  4143,
  4144,
  1611,
  4145,
  4146,
  4147,
  4148,
  4149,
  4150,
  4151,
  4152,
  4153,
  4154,
  4155,
  4156,
  4157,
  4158,
  4159,
  4160,
  4161,
  4162,
  4163,
  4164,
  4165,
  4166,
  4167,
  4168,
  4169,
  4170,
  4171,
  4172,
  4173,
  4174,
  4175,
  4176,
  4177,
  4178,
  4179,
  4180,
  4181,
  4182,
  4183,
  4184,
  4185,
  4186,
  4187,
  4188,
  4189,
  4190,
  4191,
  4192,
  4193,
  4194,
  4195,
  4196,
  4197,
  4198,
  4199,
  4200,
  4201,
  4202,
  4203,
  4204,
  4205,
  4206,
  4207,
  4208,
  4209,
  4210,
  4211,
  4212,
  4213,
  4214,
  4215,
  4216,
  4217,
  4218,
  4219,
  1612,
  4220,
  4221,
  4222,
  4223,
  4224,
  4225,
  4226,
  4227,
  1357,
  4228,
  1613,
  4229,
  4230,
  4231,
  4232,
  4233,
  4234,
  4235,
  4236,
  4237,
  4238,
  4239,
  4240,
  4241,
  4242,
  4243,
  1614,
  4244,
  4245,
  4246,
  4247,
  4248,
  4249,
  4250,
  4251,
  4252,
  4253,
  4254,
  4255,
  4256,
  4257,
  4258,
  4259,
  4260,
  4261,
  4262,
  4263,
  4264,
  4265,
  4266,
  4267,
  4268,
  4269,
  4270,
  1196,
  1358,
  4271,
  4272,
  4273,
  4274,
  4275,
  4276,
  4277,
  4278,
  4279,
  4280,
  4281,
  4282,
  4283,
  4284,
  4285,
  4286,
  4287,
  1615,
  4288,
  4289,
  4290,
  4291,
  4292,
  4293,
  4294,
  4295,
  4296,
  4297,
  4298,
  4299,
  4300,
  4301,
  4302,
  4303,
  4304,
  4305,
  4306,
  4307,
  4308,
  4309,
  4310,
  4311,
  4312,
  4313,
  4314,
  4315,
  4316,
  4317,
  4318,
  4319,
  4320,
  4321,
  4322,
  4323,
  4324,
  4325,
  4326,
  4327,
  4328,
  4329,
  4330,
  4331,
  4332,
  4333,
  4334,
  1616,
  4335,
  4336,
  4337,
  4338,
  4339,
  4340,
  4341,
  4342,
  4343,
  4344,
  4345,
  4346,
  4347,
  4348,
  4349,
  4350,
  4351,
  4352,
  4353,
  4354,
  4355,
  4356,
  4357,
  4358,
  4359,
  4360,
  1617,
  4361,
  4362,
  4363,
  4364,
  4365,
  1618,
  4366,
  4367,
  4368,
  4369,
  4370,
  4371,
  4372,
  4373,
  4374,
  4375,
  4376,
  4377,
  4378,
  4379,
  4380,
  4381,
  4382,
  4383,
  4384,
  4385,
  4386,
  4387,
  4388,
  4389,
  4390,
  4391,
  4392,
  4393,
  4394,
  4395,
  4396,
  4397,
  4398,
  4399,
  4400,
  4401,
  4402,
  4403,
  4404,
  4405,
  4406,
  4407,
  4408,
  4409,
  4410,
  4411,
  4412,
  4413,
  4414,
  4415,
  4416,
  1619,
  4417,
  4418,
  4419,
  4420,
  4421,
  4422,
  4423,
  4424,
  4425,
  1112,
  4426,
  4427,
  4428,
  4429,
  4430,
  1620,
  4431,
  4432,
  4433,
  4434,
  4435,
  4436,
  4437,
  4438,
  4439,
  4440,
  4441,
  4442,
  1260,
  1261,
  4443,
  4444,
  4445,
  4446,
  4447,
  4448,
  4449,
  4450,
  4451,
  4452,
  4453,
  4454,
  4455,
  1359,
  4456,
  4457,
  4458,
  4459,
  4460,
  4461,
  4462,
  4463,
  4464,
  4465,
  1621,
  4466,
  4467,
  4468,
  4469,
  4470,
  4471,
  4472,
  4473,
  4474,
  4475,
  4476,
  4477,
  4478,
  4479,
  4480,
  4481,
  4482,
  4483,
  4484,
  4485,
  4486,
  4487,
  4488,
  4489,
  1055,
  4490,
  4491,
  4492,
  4493,
  4494,
  4495,
  4496,
  4497,
  4498,
  4499,
  4500,
  4501,
  4502,
  4503,
  4504,
  4505,
  4506,
  4507,
  4508,
  4509,
  4510,
  4511,
  4512,
  4513,
  4514,
  4515,
  4516,
  4517,
  4518,
  1622,
  4519,
  4520,
  4521,
  1623,
  4522,
  4523,
  4524,
  4525,
  4526,
  4527,
  4528,
  4529,
  4530,
  4531,
  4532,
  4533,
  4534,
  4535,
  1360,
  4536,
  4537,
  4538,
  4539,
  4540,
  4541,
  4542,
  4543,
  975,
  4544,
  4545,
  4546,
  4547,
  4548,
  4549,
  4550,
  4551,
  4552,
  4553,
  4554,
  4555,
  4556,
  4557,
  4558,
  4559,
  4560,
  4561,
  4562,
  4563,
  4564,
  4565,
  4566,
  4567,
  4568,
  4569,
  4570,
  4571,
  1624,
  4572,
  4573,
  4574,
  4575,
  4576,
  1625,
  4577,
  4578,
  4579,
  4580,
  4581,
  4582,
  4583,
  4584,
  1626,
  4585,
  4586,
  4587,
  4588,
  4589,
  4590,
  4591,
  4592,
  4593,
  4594,
  4595,
  1627,
  4596,
  4597,
  4598,
  4599,
  4600,
  4601,
  4602,
  4603,
  4604,
  4605,
  4606,
  4607,
  4608,
  4609,
  4610,
  4611,
  4612,
  4613,
  4614,
  4615,
  1628,
  4616,
  4617,
  4618,
  4619,
  4620,
  4621,
  4622,
  4623,
  4624,
  4625,
  4626,
  4627,
  4628,
  4629,
  4630,
  4631,
  4632,
  4633,
  4634,
  4635,
  4636,
  4637,
  4638,
  4639,
  4640,
  4641,
  4642,
  4643,
  4644,
  4645,
  4646,
  4647,
  4648,
  4649,
  1361,
  4650,
  4651,
  4652,
  4653,
  4654,
  4655,
  4656,
  4657,
  4658,
  4659,
  4660,
  4661,
  1362,
  4662,
  4663,
  4664,
  4665,
  4666,
  4667,
  4668,
  4669,
  4670,
  4671,
  4672,
  4673,
  4674,
  4675,
  4676,
  4677,
  4678,
  4679,
  4680,
  4681,
  4682,
  1629,
  4683,
  4684,
  4685,
  4686,
  4687,
  1630,
  4688,
  4689,
  4690,
  4691,
  1153,
  4692,
  4693,
  4694,
  1113,
  4695,
  4696,
  4697,
  4698,
  4699,
  4700,
  4701,
  4702,
  4703,
  4704,
  4705,
  4706,
  4707,
  4708,
  4709,
  4710,
  4711,
  1197,
  4712,
  4713,
  4714,
  4715,
  4716,
  4717,
  4718,
  4719,
  4720,
  4721,
  4722,
  4723,
  4724,
  4725,
  4726,
  4727,
  4728,
  4729,
  4730,
  4731,
  4732,
  4733,
  4734,
  4735,
  1631,
  4736,
  1632,
  4737,
  4738,
  4739,
  4740,
  4741,
  4742,
  4743,
  4744,
  1633,
  4745,
  4746,
  4747,
  4748,
  4749,
  1262,
  4750,
  4751,
  4752,
  4753,
  4754,
  1363,
  4755,
  4756,
  4757,
  4758,
  4759,
  4760,
  4761,
  4762,
  4763,
  4764,
  4765,
  4766,
  4767,
  4768,
  1634,
  4769,
  4770,
  4771,
  4772,
  4773,
  4774,
  4775,
  4776,
  4777,
  4778,
  1635,
  4779,
  4780,
  4781,
  4782,
  4783,
  4784,
  4785,
  4786,
  4787,
  4788,
  4789,
  1636,
  4790,
  4791,
  4792,
  4793,
  4794,
  4795,
  4796,
  4797,
  4798,
  4799,
  4800,
  4801,
  4802,
  4803,
  4804,
  4805,
  4806,
  1637,
  4807,
  4808,
  4809,
  1638,
  4810,
  4811,
  4812,
  4813,
  4814,
  4815,
  4816,
  4817,
  4818,
  1639,
  4819,
  4820,
  4821,
  4822,
  4823,
  4824,
  4825,
  4826,
  4827,
  4828,
  4829,
  4830,
  4831,
  4832,
  4833,
  1077,
  4834,
  4835,
  4836,
  4837,
  4838,
  4839,
  4840,
  4841,
  4842,
  4843,
  4844,
  4845,
  4846,
  4847,
  4848,
  4849,
  4850,
  4851,
  4852,
  4853,
  4854,
  4855,
  4856,
  4857,
  4858,
  4859,
  4860,
  4861,
  4862,
  4863,
  4864,
  4865,
  4866,
  4867,
  4868,
  4869,
  4870,
  4871,
  4872,
  4873,
  4874,
  4875,
  4876,
  4877,
  4878,
  4879,
  4880,
  4881,
  4882,
  4883,
  1640,
  4884,
  4885,
  1641,
  4886,
  4887,
  4888,
  4889,
  4890,
  4891,
  4892,
  4893,
  4894,
  4895,
  4896,
  4897,
  4898,
  4899,
  4900,
  4901,
  4902,
  4903,
  4904,
  4905,
  4906,
  4907,
  4908,
  4909,
  4910,
  4911,
  1642,
  4912,
  4913,
  4914,
  1364,
  4915,
  4916,
  4917,
  4918,
  4919,
  4920,
  4921,
  4922,
  4923,
  4924,
  4925,
  4926,
  4927,
  4928,
  4929,
  4930,
  4931,
  1643,
  4932,
  4933,
  4934,
  4935,
  4936,
  4937,
  4938,
  4939,
  4940,
  4941,
  4942,
  4943,
  4944,
  4945,
  4946,
  4947,
  4948,
  4949,
  4950,
  4951,
  4952,
  4953,
  4954,
  4955,
  4956,
  4957,
  4958,
  4959,
  4960,
  4961,
  4962,
  4963,
  4964,
  4965,
  4966,
  4967,
  4968,
  4969,
  4970,
  4971,
  4972,
  4973,
  4974,
  4975,
  4976,
  4977,
  4978,
  4979,
  4980,
  1644,
  4981,
  4982,
  4983,
  4984,
  1645,
  4985,
  4986,
  1646,
  4987,
  4988,
  4989,
  4990,
  4991,
  4992,
  4993,
  4994,
  4995,
  4996,
  4997,
  4998,
  4999,
  5e3,
  5001,
  5002,
  5003,
  5004,
  5005,
  1647,
  5006,
  1648,
  5007,
  5008,
  5009,
  5010,
  5011,
  5012,
  1078,
  5013,
  5014,
  5015,
  5016,
  5017,
  5018,
  5019,
  5020,
  5021,
  5022,
  5023,
  5024,
  5025,
  5026,
  5027,
  5028,
  1365,
  5029,
  5030,
  5031,
  5032,
  5033,
  5034,
  5035,
  5036,
  5037,
  5038,
  5039,
  1649,
  5040,
  5041,
  5042,
  5043,
  5044,
  5045,
  1366,
  5046,
  5047,
  5048,
  5049,
  5050,
  5051,
  5052,
  5053,
  5054,
  5055,
  1650,
  5056,
  5057,
  5058,
  5059,
  5060,
  5061,
  5062,
  5063,
  5064,
  5065,
  5066,
  5067,
  5068,
  5069,
  5070,
  5071,
  5072,
  5073,
  5074,
  5075,
  5076,
  5077,
  1651,
  5078,
  5079,
  5080,
  5081,
  5082,
  5083,
  5084,
  5085,
  5086,
  5087,
  5088,
  5089,
  5090,
  5091,
  5092,
  5093,
  5094,
  5095,
  5096,
  5097,
  5098,
  5099,
  5100,
  5101,
  5102,
  5103,
  5104,
  5105,
  5106,
  5107,
  5108,
  5109,
  5110,
  1652,
  5111,
  5112,
  5113,
  5114,
  5115,
  5116,
  5117,
  5118,
  1367,
  5119,
  5120,
  5121,
  5122,
  5123,
  5124,
  5125,
  5126,
  5127,
  5128,
  5129,
  1653,
  5130,
  5131,
  5132,
  5133,
  5134,
  5135,
  5136,
  5137,
  5138,
  5139,
  5140,
  5141,
  5142,
  5143,
  5144,
  5145,
  5146,
  5147,
  5148,
  5149,
  1368,
  5150,
  1654,
  5151,
  1369,
  5152,
  5153,
  5154,
  5155,
  5156,
  5157,
  5158,
  5159,
  5160,
  5161,
  5162,
  5163,
  5164,
  5165,
  5166,
  5167,
  5168,
  5169,
  5170,
  5171,
  5172,
  5173,
  5174,
  5175,
  5176,
  5177,
  5178,
  1370,
  5179,
  5180,
  5181,
  5182,
  5183,
  5184,
  5185,
  5186,
  5187,
  5188,
  5189,
  5190,
  5191,
  5192,
  5193,
  5194,
  5195,
  5196,
  5197,
  5198,
  1655,
  5199,
  5200,
  5201,
  5202,
  1656,
  5203,
  5204,
  5205,
  5206,
  1371,
  5207,
  1372,
  5208,
  5209,
  5210,
  5211,
  1373,
  5212,
  5213,
  1374,
  5214,
  5215,
  5216,
  5217,
  5218,
  5219,
  5220,
  5221,
  5222,
  5223,
  5224,
  5225,
  5226,
  5227,
  5228,
  5229,
  5230,
  5231,
  5232,
  5233,
  5234,
  5235,
  5236,
  5237,
  5238,
  5239,
  5240,
  5241,
  5242,
  5243,
  5244,
  5245,
  5246,
  5247,
  1657,
  5248,
  5249,
  5250,
  5251,
  1658,
  1263,
  5252,
  5253,
  5254,
  5255,
  5256,
  1375,
  5257,
  5258,
  5259,
  5260,
  5261,
  5262,
  5263,
  5264,
  5265,
  5266,
  5267,
  5268,
  5269,
  5270,
  5271,
  5272,
  5273,
  5274,
  5275,
  5276,
  5277,
  5278,
  5279,
  5280,
  5281,
  5282,
  5283,
  1659,
  5284,
  5285,
  5286,
  5287,
  5288,
  5289,
  5290,
  5291,
  5292,
  5293,
  5294,
  5295,
  5296,
  5297,
  5298,
  5299,
  5300,
  1660,
  5301,
  5302,
  5303,
  5304,
  5305,
  5306,
  5307,
  5308,
  5309,
  5310,
  5311,
  5312,
  5313,
  5314,
  5315,
  5316,
  5317,
  5318,
  5319,
  5320,
  5321,
  1376,
  5322,
  5323,
  5324,
  5325,
  5326,
  5327,
  5328,
  5329,
  5330,
  5331,
  5332,
  5333,
  1198,
  5334,
  5335,
  5336,
  5337,
  5338,
  5339,
  5340,
  5341,
  5342,
  5343,
  1661,
  5344,
  5345,
  5346,
  5347,
  5348,
  5349,
  5350,
  5351,
  5352,
  5353,
  5354,
  5355,
  5356,
  5357,
  5358,
  5359,
  5360,
  5361,
  5362,
  5363,
  5364,
  5365,
  5366,
  5367,
  5368,
  5369,
  5370,
  5371,
  5372,
  5373,
  5374,
  5375,
  5376,
  5377,
  5378,
  5379,
  5380,
  5381,
  5382,
  5383,
  5384,
  5385,
  5386,
  5387,
  5388,
  5389,
  5390,
  5391,
  5392,
  5393,
  5394,
  5395,
  5396,
  5397,
  5398,
  1264,
  5399,
  5400,
  5401,
  5402,
  5403,
  5404,
  5405,
  5406,
  5407,
  5408,
  5409,
  5410,
  5411,
  5412,
  1662,
  5413,
  5414,
  5415,
  5416,
  1663,
  5417,
  5418,
  5419,
  5420,
  5421,
  5422,
  5423,
  5424,
  5425,
  5426,
  5427,
  5428,
  5429,
  5430,
  5431,
  5432,
  5433,
  5434,
  5435,
  5436,
  5437,
  5438,
  1664,
  5439,
  5440,
  5441,
  5442,
  5443,
  5444,
  5445,
  5446,
  5447,
  5448,
  5449,
  5450,
  5451,
  5452,
  5453,
  5454,
  5455,
  5456,
  5457,
  5458,
  5459,
  5460,
  5461,
  5462,
  5463,
  5464,
  5465,
  5466,
  5467,
  5468,
  5469,
  5470,
  5471,
  5472,
  5473,
  5474,
  5475,
  5476,
  5477,
  5478,
  1154,
  5479,
  5480,
  5481,
  5482,
  5483,
  5484,
  5485,
  1665,
  5486,
  5487,
  5488,
  5489,
  5490,
  5491,
  5492,
  5493,
  5494,
  5495,
  5496,
  5497,
  5498,
  5499,
  5500,
  5501,
  5502,
  5503,
  5504,
  5505,
  5506,
  5507,
  5508,
  5509,
  5510,
  5511,
  5512,
  5513,
  5514,
  5515,
  5516,
  5517,
  5518,
  5519,
  5520,
  5521,
  5522,
  5523,
  5524,
  5525,
  5526,
  5527,
  5528,
  5529,
  5530,
  5531,
  5532,
  5533,
  5534,
  5535,
  5536,
  5537,
  5538,
  5539,
  5540,
  5541,
  5542,
  5543,
  5544,
  5545,
  5546,
  5547,
  5548,
  1377,
  5549,
  5550,
  5551,
  5552,
  5553,
  5554,
  5555,
  5556,
  5557,
  5558,
  5559,
  5560,
  5561,
  5562,
  5563,
  5564,
  5565,
  5566,
  5567,
  5568,
  5569,
  5570,
  1114,
  5571,
  5572,
  5573,
  5574,
  5575,
  5576,
  5577,
  5578,
  5579,
  5580,
  5581,
  5582,
  5583,
  5584,
  5585,
  5586,
  5587,
  5588,
  5589,
  5590,
  5591,
  5592,
  1378,
  5593,
  5594,
  5595,
  5596,
  5597,
  5598,
  5599,
  5600,
  5601,
  5602,
  5603,
  5604,
  5605,
  5606,
  5607,
  5608,
  5609,
  5610,
  5611,
  5612,
  5613,
  5614,
  1379,
  5615,
  5616,
  5617,
  5618,
  5619,
  5620,
  5621,
  5622,
  5623,
  5624,
  5625,
  5626,
  5627,
  5628,
  5629,
  5630,
  5631,
  5632,
  5633,
  5634,
  1380,
  5635,
  5636,
  5637,
  5638,
  5639,
  5640,
  5641,
  5642,
  5643,
  5644,
  5645,
  5646,
  5647,
  5648,
  5649,
  1381,
  1056,
  5650,
  5651,
  5652,
  5653,
  5654,
  5655,
  5656,
  5657,
  5658,
  5659,
  5660,
  1666,
  5661,
  5662,
  5663,
  5664,
  5665,
  5666,
  5667,
  5668,
  1667,
  5669,
  1668,
  5670,
  5671,
  5672,
  5673,
  5674,
  5675,
  5676,
  5677,
  5678,
  1155,
  5679,
  5680,
  5681,
  5682,
  5683,
  5684,
  5685,
  5686,
  5687,
  5688,
  5689,
  5690,
  5691,
  5692,
  5693,
  5694,
  5695,
  5696,
  5697,
  5698,
  1669,
  5699,
  5700,
  5701,
  5702,
  5703,
  5704,
  5705,
  1670,
  5706,
  5707,
  5708,
  5709,
  5710,
  1671,
  5711,
  5712,
  5713,
  5714,
  1382,
  5715,
  5716,
  5717,
  5718,
  5719,
  5720,
  5721,
  5722,
  5723,
  5724,
  5725,
  1672,
  5726,
  5727,
  1673,
  1674,
  5728,
  5729,
  5730,
  5731,
  5732,
  5733,
  5734,
  5735,
  5736,
  1675,
  5737,
  5738,
  5739,
  5740,
  5741,
  5742,
  5743,
  5744,
  1676,
  5745,
  5746,
  5747,
  5748,
  5749,
  5750,
  5751,
  1383,
  5752,
  5753,
  5754,
  5755,
  5756,
  5757,
  5758,
  5759,
  5760,
  5761,
  5762,
  5763,
  5764,
  5765,
  5766,
  5767,
  5768,
  1677,
  5769,
  5770,
  5771,
  5772,
  5773,
  1678,
  5774,
  5775,
  5776,
  998,
  5777,
  5778,
  5779,
  5780,
  5781,
  5782,
  5783,
  5784,
  5785,
  1384,
  5786,
  5787,
  5788,
  5789,
  5790,
  5791,
  5792,
  5793,
  5794,
  5795,
  5796,
  5797,
  5798,
  5799,
  5800,
  1679,
  5801,
  5802,
  5803,
  1115,
  1116,
  5804,
  5805,
  5806,
  5807,
  5808,
  5809,
  5810,
  5811,
  5812,
  5813,
  5814,
  5815,
  5816,
  5817,
  5818,
  5819,
  5820,
  5821,
  5822,
  5823,
  5824,
  5825,
  5826,
  5827,
  5828,
  5829,
  5830,
  5831,
  5832,
  5833,
  5834,
  5835,
  5836,
  5837,
  5838,
  5839,
  5840,
  5841,
  5842,
  5843,
  5844,
  5845,
  5846,
  5847,
  5848,
  5849,
  5850,
  5851,
  5852,
  5853,
  5854,
  5855,
  1680,
  5856,
  5857,
  5858,
  5859,
  5860,
  5861,
  5862,
  5863,
  5864,
  1681,
  5865,
  5866,
  5867,
  1682,
  5868,
  5869,
  5870,
  5871,
  5872,
  5873,
  5874,
  5875,
  5876,
  5877,
  5878,
  5879,
  1683,
  5880,
  1684,
  5881,
  5882,
  5883,
  5884,
  1685,
  5885,
  5886,
  5887,
  5888,
  5889,
  5890,
  5891,
  5892,
  5893,
  5894,
  5895,
  5896,
  5897,
  5898,
  5899,
  5900,
  5901,
  5902,
  5903,
  5904,
  5905,
  5906,
  5907,
  1686,
  5908,
  5909,
  5910,
  5911,
  5912,
  5913,
  5914,
  5915,
  5916,
  5917,
  5918,
  5919,
  5920,
  5921,
  5922,
  5923,
  5924,
  5925,
  5926,
  5927,
  5928,
  5929,
  5930,
  5931,
  5932,
  5933,
  5934,
  5935,
  1687,
  5936,
  5937,
  5938,
  5939,
  5940,
  5941,
  5942,
  5943,
  5944,
  5945,
  5946,
  5947,
  5948,
  5949,
  5950,
  5951,
  5952,
  1688,
  1689,
  5953,
  1199,
  5954,
  5955,
  5956,
  5957,
  5958,
  5959,
  5960,
  5961,
  1690,
  5962,
  5963,
  5964,
  5965,
  5966,
  5967,
  5968,
  5969,
  5970,
  5971,
  5972,
  5973,
  5974,
  5975,
  5976,
  5977,
  5978,
  5979,
  5980,
  5981,
  1385,
  5982,
  1386,
  5983,
  5984,
  5985,
  5986,
  5987,
  5988,
  5989,
  5990,
  5991,
  5992,
  5993,
  5994,
  5995,
  5996,
  5997,
  5998,
  5999,
  6e3,
  6001,
  6002,
  6003,
  6004,
  6005,
  6006,
  6007,
  6008,
  6009,
  6010,
  6011,
  6012,
  6013,
  6014,
  6015,
  6016,
  6017,
  6018,
  6019,
  6020,
  6021,
  6022,
  6023,
  6024,
  6025,
  6026,
  6027,
  1265,
  6028,
  6029,
  1691,
  6030,
  6031,
  6032,
  6033,
  6034,
  6035,
  6036,
  6037,
  6038,
  6039,
  6040,
  6041,
  6042,
  6043,
  6044,
  6045,
  6046,
  6047,
  6048,
  6049,
  6050,
  6051,
  6052,
  6053,
  6054,
  6055,
  6056,
  6057,
  6058,
  6059,
  6060,
  6061,
  6062,
  6063,
  6064,
  6065,
  6066,
  6067,
  6068,
  6069,
  6070,
  6071,
  6072,
  6073,
  6074,
  6075,
  6076,
  6077,
  6078,
  6079,
  6080,
  6081,
  6082,
  6083,
  6084,
  1692,
  6085,
  6086,
  6087,
  6088,
  6089,
  6090,
  6091,
  6092,
  6093,
  6094,
  6095,
  6096,
  6097,
  6098,
  6099,
  6100,
  6101,
  6102,
  6103,
  6104,
  6105,
  6106,
  6107,
  6108,
  6109,
  6110,
  6111,
  6112,
  6113,
  6114,
  6115,
  6116,
  6117,
  6118,
  6119,
  6120,
  6121,
  6122,
  6123,
  6124,
  6125,
  6126,
  6127,
  6128,
  6129,
  6130,
  6131,
  1693,
  6132,
  6133,
  6134,
  6135,
  6136,
  1694,
  6137,
  6138,
  6139,
  6140,
  6141,
  1695,
  6142,
  6143,
  6144,
  6145,
  6146,
  6147,
  6148,
  6149,
  6150,
  6151,
  6152,
  6153,
  6154,
  6155,
  6156,
  6157,
  6158,
  6159,
  6160,
  6161,
  6162,
  6163,
  6164,
  6165,
  6166,
  6167,
  6168,
  6169,
  6170,
  6171,
  6172,
  6173,
  6174,
  6175,
  6176,
  6177,
  6178,
  6179,
  6180,
  6181,
  6182,
  6183,
  6184,
  6185,
  1696,
  6186,
  6187,
  6188,
  6189,
  6190,
  6191,
  6192,
  6193,
  6194,
  6195,
  6196,
  6197,
  6198,
  6199,
  6200,
  6201,
  6202,
  6203,
  6204,
  6205,
  6206,
  6207,
  6208,
  6209,
  6210,
  6211,
  6212,
  6213,
  6214,
  6215,
  6216,
  6217,
  6218,
  6219,
  1697,
  6220,
  6221,
  6222,
  6223,
  6224,
  6225,
  6226,
  6227,
  6228,
  6229,
  6230,
  6231,
  6232,
  6233,
  6234,
  6235,
  6236,
  6237,
  6238,
  6239,
  6240,
  6241,
  6242,
  6243,
  6244,
  6245,
  6246,
  6247,
  6248,
  6249,
  6250,
  6251,
  6252,
  6253,
  1698,
  6254,
  6255,
  6256,
  6257,
  6258,
  6259,
  6260,
  6261,
  6262,
  6263,
  1200,
  6264,
  6265,
  6266,
  6267,
  6268,
  6269,
  6270,
  6271,
  //1024
  6272,
  6273,
  6274,
  6275,
  6276,
  6277,
  6278,
  6279,
  6280,
  6281,
  6282,
  6283,
  6284,
  6285,
  6286,
  6287,
  6288,
  6289,
  6290,
  6291,
  6292,
  6293,
  6294,
  6295,
  6296,
  6297,
  6298,
  6299,
  6300,
  6301,
  6302,
  1699,
  6303,
  6304,
  1700,
  6305,
  6306,
  6307,
  6308,
  6309,
  6310,
  6311,
  6312,
  6313,
  6314,
  6315,
  6316,
  6317,
  6318,
  6319,
  6320,
  6321,
  6322,
  6323,
  6324,
  6325,
  6326,
  6327,
  6328,
  6329,
  6330,
  6331,
  6332,
  6333,
  6334,
  6335,
  6336,
  6337,
  6338,
  6339,
  1701,
  6340,
  6341,
  6342,
  6343,
  6344,
  1387,
  6345,
  6346,
  6347,
  6348,
  6349,
  6350,
  6351,
  6352,
  6353,
  6354,
  6355,
  6356,
  6357,
  6358,
  6359,
  6360,
  6361,
  6362,
  6363,
  6364,
  6365,
  6366,
  6367,
  6368,
  6369,
  6370,
  6371,
  6372,
  6373,
  6374,
  6375,
  6376,
  6377,
  6378,
  6379,
  6380,
  6381,
  6382,
  6383,
  6384,
  6385,
  6386,
  6387,
  6388,
  6389,
  6390,
  6391,
  6392,
  6393,
  6394,
  6395,
  6396,
  6397,
  6398,
  6399,
  6400,
  6401,
  6402,
  6403,
  6404,
  6405,
  6406,
  6407,
  6408,
  6409,
  6410,
  6411,
  6412,
  6413,
  1702,
  6414,
  6415,
  6416,
  6417,
  6418,
  6419,
  6420,
  6421,
  6422,
  1703,
  6423,
  6424,
  6425,
  6426,
  6427,
  6428,
  6429,
  6430,
  6431,
  6432,
  6433,
  6434,
  6435,
  6436,
  6437,
  6438,
  1704,
  6439,
  6440,
  6441,
  6442,
  6443,
  6444,
  6445,
  6446,
  6447,
  6448,
  6449,
  6450,
  6451,
  6452,
  6453,
  6454,
  6455,
  6456,
  6457,
  6458,
  6459,
  6460,
  6461,
  6462,
  6463,
  6464,
  6465,
  6466,
  6467,
  6468,
  6469,
  6470,
  6471,
  6472,
  6473,
  6474,
  6475,
  6476,
  6477,
  6478,
  6479,
  6480,
  6481,
  6482,
  6483,
  6484,
  6485,
  6486,
  6487,
  6488,
  6489,
  6490,
  6491,
  6492,
  6493,
  6494,
  6495,
  6496,
  6497,
  6498,
  6499,
  6500,
  6501,
  6502,
  6503,
  1266,
  6504,
  6505,
  6506,
  6507,
  6508,
  6509,
  6510,
  6511,
  6512,
  6513,
  6514,
  6515,
  6516,
  6517,
  6518,
  6519,
  6520,
  6521,
  6522,
  6523,
  6524,
  6525,
  6526,
  6527,
  6528,
  6529,
  6530,
  6531,
  6532,
  6533,
  6534,
  6535,
  6536,
  6537,
  6538,
  6539,
  6540,
  6541,
  6542,
  6543,
  6544,
  6545,
  6546,
  6547,
  6548,
  6549,
  6550,
  6551,
  1705,
  1706,
  6552,
  6553,
  6554,
  6555,
  6556,
  6557,
  6558,
  6559,
  6560,
  6561,
  6562,
  6563,
  6564,
  6565,
  6566,
  6567,
  6568,
  6569,
  6570,
  6571,
  6572,
  6573,
  6574,
  6575,
  6576,
  6577,
  6578,
  6579,
  6580,
  6581,
  6582,
  6583,
  6584,
  6585,
  6586,
  6587,
  6588,
  6589,
  6590,
  6591,
  6592,
  6593,
  6594,
  6595,
  6596,
  6597,
  6598,
  6599,
  6600,
  6601,
  6602,
  6603,
  6604,
  6605,
  6606,
  6607,
  6608,
  6609,
  6610,
  6611,
  6612,
  6613,
  6614,
  6615,
  6616,
  6617,
  6618,
  6619,
  6620,
  6621,
  6622,
  6623,
  6624,
  6625,
  6626,
  6627,
  6628,
  6629,
  6630,
  6631,
  6632,
  6633,
  6634,
  6635,
  6636,
  6637,
  1388,
  6638,
  6639,
  6640,
  6641,
  6642,
  6643,
  6644,
  1707,
  6645,
  6646,
  6647,
  6648,
  6649,
  6650,
  6651,
  6652,
  6653,
  6654,
  6655,
  6656,
  6657,
  6658,
  6659,
  6660,
  6661,
  6662,
  6663,
  1708,
  6664,
  6665,
  6666,
  6667,
  6668,
  6669,
  6670,
  6671,
  6672,
  6673,
  6674,
  1201,
  6675,
  6676,
  6677,
  6678,
  6679,
  6680,
  6681,
  6682,
  6683,
  6684,
  6685,
  6686,
  6687,
  6688,
  6689,
  6690,
  6691,
  6692,
  6693,
  6694,
  6695,
  6696,
  6697,
  6698,
  6699,
  6700,
  6701,
  6702,
  6703,
  6704,
  6705,
  6706,
  6707,
  6708,
  6709,
  6710,
  6711,
  6712,
  6713,
  6714,
  6715,
  6716,
  6717,
  6718,
  6719,
  6720,
  6721,
  6722,
  6723,
  6724,
  6725,
  1389,
  6726,
  6727,
  6728,
  6729,
  6730,
  6731,
  6732,
  6733,
  6734,
  6735,
  6736,
  1390,
  1709,
  6737,
  6738,
  6739,
  6740,
  6741,
  6742,
  1710,
  6743,
  6744,
  6745,
  6746,
  1391,
  6747,
  6748,
  6749,
  6750,
  6751,
  6752,
  6753,
  6754,
  6755,
  6756,
  6757,
  1392,
  6758,
  6759,
  6760,
  6761,
  6762,
  6763,
  6764,
  6765,
  6766,
  6767,
  6768,
  6769,
  6770,
  6771,
  6772,
  6773,
  6774,
  6775,
  6776,
  6777,
  6778,
  6779,
  6780,
  1202,
  6781,
  6782,
  6783,
  6784,
  6785,
  6786,
  6787,
  6788,
  6789,
  6790,
  6791,
  6792,
  6793,
  6794,
  6795,
  6796,
  6797,
  6798,
  6799,
  6800,
  6801,
  6802,
  6803,
  6804,
  6805,
  6806,
  6807,
  6808,
  6809,
  1711,
  6810,
  6811,
  6812,
  6813,
  6814,
  6815,
  6816,
  6817,
  6818,
  6819,
  6820,
  6821,
  6822,
  6823,
  6824,
  6825,
  6826,
  6827,
  6828,
  6829,
  6830,
  6831,
  6832,
  6833,
  6834,
  6835,
  6836,
  1393,
  6837,
  6838,
  6839,
  6840,
  6841,
  6842,
  6843,
  6844,
  6845,
  6846,
  6847,
  6848,
  6849,
  6850,
  6851,
  6852,
  6853,
  6854,
  6855,
  6856,
  6857,
  6858,
  6859,
  6860,
  6861,
  6862,
  6863,
  6864,
  6865,
  6866,
  6867,
  6868,
  6869,
  6870,
  6871,
  6872,
  6873,
  6874,
  6875,
  6876,
  6877,
  6878,
  6879,
  6880,
  6881,
  6882,
  6883,
  6884,
  6885,
  6886,
  6887,
  6888,
  6889,
  6890,
  6891,
  6892,
  6893,
  6894,
  6895,
  6896,
  6897,
  6898,
  6899,
  6900,
  6901,
  6902,
  1712,
  6903,
  6904,
  6905,
  6906,
  6907,
  6908,
  6909,
  6910,
  1713,
  6911,
  6912,
  6913,
  6914,
  6915,
  6916,
  6917,
  6918,
  6919,
  6920,
  6921,
  6922,
  6923,
  6924,
  6925,
  6926,
  6927,
  6928,
  6929,
  6930,
  6931,
  6932,
  6933,
  6934,
  6935,
  6936,
  6937,
  6938,
  6939,
  6940,
  6941,
  6942,
  6943,
  6944,
  6945,
  6946,
  6947,
  6948,
  6949,
  6950,
  6951,
  6952,
  6953,
  6954,
  6955,
  6956,
  6957,
  6958,
  6959,
  6960,
  6961,
  6962,
  6963,
  6964,
  6965,
  6966,
  6967,
  6968,
  6969,
  6970,
  6971,
  6972,
  6973,
  6974,
  1714,
  6975,
  6976,
  6977,
  6978,
  6979,
  6980,
  6981,
  6982,
  6983,
  6984,
  6985,
  6986,
  6987,
  6988,
  1394,
  6989,
  6990,
  6991,
  6992,
  6993,
  6994,
  6995,
  6996,
  6997,
  6998,
  6999,
  7e3,
  1715,
  7001,
  7002,
  7003,
  7004,
  7005,
  7006,
  7007,
  7008,
  7009,
  7010,
  7011,
  7012,
  7013,
  7014,
  7015,
  7016,
  7017,
  7018,
  7019,
  7020,
  7021,
  7022,
  7023,
  7024,
  7025,
  7026,
  7027,
  7028,
  1716,
  7029,
  7030,
  7031,
  7032,
  7033,
  7034,
  7035,
  7036,
  7037,
  7038,
  7039,
  7040,
  7041,
  7042,
  7043,
  7044,
  7045,
  7046,
  7047,
  7048,
  7049,
  7050,
  7051,
  7052,
  7053,
  7054,
  7055,
  7056,
  7057,
  7058,
  7059,
  7060,
  7061,
  7062,
  7063,
  7064,
  7065,
  7066,
  7067,
  7068,
  7069,
  7070,
  7071,
  7072,
  7073,
  7074,
  7075,
  7076,
  7077,
  7078,
  7079,
  7080,
  7081,
  7082,
  7083,
  7084,
  7085,
  7086,
  7087,
  7088,
  7089,
  7090,
  7091,
  7092,
  7093,
  7094,
  7095,
  7096,
  7097,
  7098,
  7099,
  7100,
  7101,
  7102,
  7103,
  7104,
  7105,
  7106,
  7107,
  7108,
  7109,
  7110,
  7111,
  7112,
  7113,
  7114,
  7115,
  7116,
  7117,
  7118,
  7119,
  7120,
  7121,
  7122,
  7123,
  7124,
  7125,
  7126,
  7127,
  7128,
  7129,
  7130,
  7131,
  7132,
  7133,
  7134,
  7135,
  7136,
  7137,
  7138,
  7139,
  7140,
  7141,
  7142,
  7143,
  7144,
  7145,
  7146,
  7147,
  7148,
  7149,
  7150,
  7151,
  7152,
  7153,
  7154,
  7155,
  7156,
  7157,
  7158,
  7159,
  7160,
  7161,
  7162,
  7163,
  7164,
  7165,
  7166,
  7167,
  7168,
  7169,
  7170,
  7171,
  7172,
  7173,
  7174,
  7175,
  7176,
  7177,
  7178,
  7179,
  7180,
  7181,
  7182,
  7183,
  7184,
  7185,
  7186,
  7187,
  7188,
  7189,
  7190,
  7191,
  7192,
  7193,
  7194,
  7195,
  7196,
  7197,
  7198,
  7199,
  7200,
  7201,
  7202,
  7203,
  7204,
  7205,
  7206,
  7207,
  1395,
  7208,
  7209,
  7210,
  7211,
  7212,
  7213,
  1717,
  7214,
  7215,
  7216,
  7217,
  7218,
  7219,
  7220,
  7221,
  7222,
  7223,
  7224,
  7225,
  7226,
  7227,
  7228,
  7229,
  7230,
  7231,
  7232,
  7233,
  7234,
  7235,
  7236,
  7237,
  7238,
  7239,
  7240,
  7241,
  7242,
  7243,
  7244,
  7245,
  7246,
  7247,
  7248,
  7249,
  7250,
  7251,
  7252,
  7253,
  7254,
  7255,
  7256,
  7257,
  7258,
  7259,
  7260,
  7261,
  7262,
  7263,
  7264,
  7265,
  7266,
  7267,
  7268,
  7269,
  7270,
  7271,
  7272,
  7273,
  7274,
  7275,
  7276,
  7277,
  7278,
  7279,
  7280,
  7281,
  7282,
  7283,
  7284,
  7285,
  7286,
  7287,
  7288,
  7289,
  7290,
  7291,
  7292,
  7293,
  7294,
  7295,
  7296,
  7297,
  7298,
  7299,
  7300,
  7301,
  7302,
  7303,
  7304,
  7305,
  7306,
  7307,
  7308,
  7309,
  7310,
  7311,
  7312,
  7313,
  1718,
  7314,
  7315,
  7316,
  7317,
  7318,
  7319,
  7320,
  7321,
  7322,
  7323,
  7324,
  7325,
  7326,
  7327,
  7328,
  7329,
  7330,
  7331,
  7332,
  7333,
  7334,
  7335,
  7336,
  7337,
  7338,
  7339,
  7340,
  7341,
  7342,
  7343,
  7344,
  7345,
  7346,
  7347,
  7348,
  7349,
  7350,
  7351,
  7352,
  7353,
  7354,
  7355,
  7356,
  7357,
  7358,
  7359,
  7360,
  7361,
  7362,
  7363,
  7364,
  7365,
  7366,
  7367,
  7368,
  7369,
  7370,
  7371,
  7372,
  7373,
  7374,
  7375,
  7376,
  7377,
  7378,
  7379,
  7380,
  7381,
  7382,
  7383,
  7384,
  7385,
  7386,
  7387,
  7388,
  7389,
  7390,
  7391,
  7392,
  7393,
  7394,
  7395,
  7396,
  7397,
  7398,
  7399,
  7400,
  7401,
  7402,
  7403,
  7404,
  7405,
  7406,
  7407,
  7408,
  7409,
  7410,
  7411,
  7412,
  7413,
  7414,
  7415,
  7416,
  7417,
  7418,
  7419,
  7420,
  7421,
  7422,
  7423,
  7424,
  7425,
  7426,
  7427,
  7428,
  7429,
  7430,
  7431,
  7432,
  7433,
  7434,
  7435,
  7436,
  7437,
  7438,
  7439,
  7440,
  7441,
  7442,
  7443,
  7444,
  7445,
  7446,
  7447,
  7448,
  7449,
  7450,
  7451,
  7452,
  7453,
  7454,
  7455,
  7456,
  7457,
  7458,
  7459,
  7460,
  7461,
  7462,
  7463,
  7464,
  7465,
  7466,
  7467,
  7468,
  7469,
  7470,
  7471,
  7472,
  7473,
  7474,
  7475,
  7476,
  7477,
  7478,
  7479,
  7480,
  7481,
  7482,
  7483,
  7484,
  7485,
  7486,
  7487,
  7488,
  7489,
  7490,
  7491,
  7492,
  7493,
  7494,
  7495,
  7496,
  7497,
  7498,
  7499,
  7500,
  7501,
  7502,
  7503,
  7504,
  7505,
  7506,
  7507,
  7508,
  7509,
  7510,
  7511,
  7512,
  7513,
  7514,
  7515,
  7516,
  7517,
  7518,
  7519,
  7520,
  7521,
  7522,
  7523,
  7524,
  7525,
  7526,
  7527,
  7528,
  7529,
  7530,
  7531,
  7532,
  7533,
  7534,
  7535,
  7536,
  7537,
  7538,
  7539,
  7540,
  7541,
  7542,
  7543,
  7544,
  7545,
  7546,
  7547,
  7548,
  7549,
  7550,
  7551,
  7552,
  7553,
  7554,
  7555,
  7556,
  7557,
  7558,
  7559,
  7560,
  7561,
  7562,
  7563,
  7564,
  7565,
  7566,
  7567,
  7568,
  7569,
  7570,
  7571,
  7572,
  7573,
  7574,
  7575,
  7576,
  7577,
  7578,
  7579,
  7580,
  7581,
  7582,
  7583,
  7584,
  7585,
  7586,
  7587,
  7588,
  7589,
  7590,
  7591,
  7592,
  7593,
  7594,
  7595,
  7596,
  7597,
  7598,
  7599,
  7600,
  7601,
  7602,
  7603,
  7604,
  7605,
  7606,
  7607,
  7608,
  7609,
  7610,
  7611,
  7612,
  7613,
  7614,
  7615,
  7616,
  7617,
  7618,
  7619,
  7620,
  7621,
  7622,
  7623,
  7624,
  7625,
  7626,
  7627,
  7628,
  7629,
  7630,
  7631,
  7632,
  7633,
  7634,
  7635,
  7636,
  7637,
  7638,
  7639,
  7640,
  7641,
  7642,
  7643,
  7644,
  7645,
  7646,
  7647,
  7648,
  7649,
  7650,
  7651,
  7652,
  7653,
  7654,
  7655,
  7656,
  7657,
  7658,
  7659,
  7660,
  7661,
  7662,
  7663,
  7664,
  7665,
  7666,
  7667,
  7668,
  7669,
  7670,
  7671,
  7672,
  7673,
  7674,
  7675,
  7676,
  7677,
  7678,
  7679,
  7680,
  7681,
  7682,
  7683,
  7684,
  7685,
  7686,
  7687,
  7688,
  7689,
  7690,
  7691,
  7692,
  7693,
  7694,
  7695,
  7696,
  7697,
  7698,
  7699,
  7700,
  7701,
  7702,
  7703,
  7704,
  7705,
  7706,
  7707,
  7708,
  7709,
  7710,
  7711,
  7712,
  7713,
  7714,
  7715,
  7716,
  7717,
  7718,
  7719,
  7720,
  7721,
  7722,
  7723,
  7724,
  7725,
  7726,
  7727,
  7728,
  7729,
  7730,
  7731,
  7732,
  7733,
  7734,
  7735,
  7736,
  7737,
  7738,
  7739,
  7740,
  7741,
  7742,
  7743,
  7744,
  7745,
  7746,
  7747,
  7748,
  7749,
  7750,
  7751,
  7752,
  7753,
  7754,
  7755,
  7756,
  7757,
  7758,
  7759,
  7760,
  7761,
  7762,
  7763,
  7764,
  7765,
  7766,
  7767,
  7768,
  7769,
  7770,
  7771,
  7772,
  7773,
  7774,
  7775,
  7776,
  7777,
  7778,
  7779,
  7780,
  7781,
  7782,
  7783,
  7784,
  7785,
  7786,
  7787,
  7788,
  7789,
  7790,
  7791,
  7792,
  7793,
  7794,
  7795,
  7796,
  7797,
  7798,
  7799,
  7800,
  7801,
  7802,
  7803,
  7804,
  7805,
  7806,
  7807,
  7808,
  7809,
  7810,
  7811,
  7812,
  7813,
  7814,
  7815,
  7816,
  7817,
  7818,
  7819,
  7820,
  7821,
  7822,
  7823,
  7824,
  7825,
  7826,
  7827,
  7828,
  7829,
  7830,
  7831,
  7832,
  7833,
  7834,
  7835,
  7836,
  7837,
  7838,
  7839,
  7840,
  7841,
  7842,
  7843,
  7844,
  7845,
  7846,
  7847,
  7848,
  7849,
  7850,
  7851,
  7852,
  7853,
  7854,
  7855,
  7856,
  7857,
  7858,
  7859,
  7860,
  7861,
  7862,
  7863,
  7864,
  7865,
  7866,
  7867,
  7868,
  7869,
  7870,
  7871,
  7872,
  7873,
  7874,
  7875,
  7876,
  7877,
  7878,
  7879,
  7880,
  7881,
  7882,
  7883,
  7884,
  7885,
  7886,
  7887,
  7888,
  7889,
  7890,
  7891,
  7892,
  7893,
  7894,
  7895,
  7896,
  7897,
  7898,
  7899,
  7900,
  7901,
  7902,
  7903,
  7904,
  7905,
  7906,
  7907,
  7908,
  7909,
  7910,
  7911,
  7912,
  7913,
  7914,
  7915,
  7916,
  7917,
  7918,
  7919,
  7920,
  7921,
  7922,
  7923,
  7924,
  7925,
  7926,
  7927,
  7928,
  7929,
  7930,
  7931,
  7932,
  7933,
  7934,
  7935,
  7936,
  7937,
  7938,
  7939,
  7940,
  7941,
  7942,
  7943,
  7944,
  7945,
  7946,
  7947,
  7948,
  7949,
  7950,
  7951,
  7952,
  7953,
  7954,
  7955,
  7956,
  7957,
  7958,
  7959,
  7960,
  7961,
  7962,
  7963,
  7964,
  7965,
  7966,
  7967,
  7968,
  7969,
  7970,
  7971,
  7972,
  7973,
  7974,
  7975,
  7976,
  7977,
  7978,
  7979,
  7980,
  7981,
  7982,
  7983,
  7984,
  7985,
  7986,
  7987,
  7988,
  7989,
  7990,
  7991,
  7992,
  7993,
  7994,
  7995,
  7996,
  7997,
  7998,
  7999,
  8e3,
  8001,
  8002,
  8003,
  8004,
  8005,
  8006,
  8007,
  8008,
  8009,
  8010,
  8011,
  8012,
  8013,
  8014,
  8015,
  8016,
  8017,
  8018,
  8019,
  8020,
  8021,
  8022,
  8023,
  8024,
  8025,
  8026,
  8027,
  8028,
  8029,
  8030,
  8031,
  8032,
  8033,
  8034,
  8035,
  8036,
  8037,
  8038,
  8039,
  8040,
  8041,
  8042,
  8043,
  8044,
  8045,
  8046,
  8047,
  8048,
  8049,
  8050,
  8051,
  8052,
  8053,
  8054,
  8055,
  8056,
  8057,
  8058,
  8059,
  8060,
  8061,
  8062,
  8063,
  8064,
  8065,
  8066,
  8067,
  8068,
  8069,
  8070,
  8071,
  8072,
  8073,
  8074,
  8075,
  8076,
  8077,
  8078,
  8079,
  8080,
  8081,
  8082,
  8083,
  8084,
  8085,
  8086,
  8087,
  8088,
  8089,
  8090,
  8091,
  8092,
  8093,
  8094,
  8095,
  8096,
  8097,
  8098,
  8099,
  8100,
  8101,
  8102,
  8103,
  8104,
  8105,
  8106,
  8107,
  8108,
  8109,
  8110,
  8111,
  8112,
  8113,
  8114,
  8115,
  8116,
  8117,
  8118,
  8119,
  8120,
  8121,
  8122,
  8123,
  8124,
  8125,
  8126,
  8127,
  8128,
  8129,
  8130,
  8131,
  8132,
  8133,
  8134,
  8135,
  8136,
  8137,
  8138,
  8139,
  8140,
  8141,
  8142,
  8143,
  8144,
  8145,
  8146,
  8147,
  8148,
  8149,
  8150,
  8151,
  8152,
  8153,
  8154,
  8155,
  8156,
  8157,
  8158,
  8159,
  8160,
  8161,
  8162,
  8163,
  8164,
  8165,
  8166,
  8167,
  8168,
  8169,
  8170,
  8171,
  8172,
  8173,
  8174,
  8175,
  8176,
  8177,
  8178,
  8179,
  8180,
  8181,
  8182,
  8183,
  8184,
  8185,
  8186,
  8187,
  8188,
  8189,
  8190,
  8191,
  8192,
  8193,
  8194,
  8195,
  8196,
  8197,
  8198,
  8199,
  8200,
  8201,
  8202,
  8203,
  8204,
  8205,
  8206,
  8207,
  8208,
  8209,
  8210,
  8211,
  8212,
  8213,
  8214,
  8215,
  8216,
  8217,
  8218,
  8219,
  8220,
  8221,
  8222,
  8223,
  8224,
  8225,
  8226,
  8227,
  8228,
  8229,
  8230,
  8231,
  8232,
  8233,
  8234,
  8235,
  8236,
  8237,
  8238,
  8239,
  8240,
  8241,
  8242,
  8243,
  8244,
  8245,
  8246,
  8247,
  8248,
  8249,
  8250,
  8251,
  8252,
  8253,
  8254,
  8255,
  8256,
  8257,
  8258,
  8259,
  8260,
  8261,
  8262,
  8263,
  8264,
  8265,
  8266,
  8267,
  8268,
  8269,
  8270,
  8271,
  8272,
  8273,
  8274,
  8275,
  8276,
  8277,
  8278,
  8279,
  8280,
  8281,
  8282,
  8283,
  8284,
  8285,
  8286,
  8287,
  8288,
  8289,
  8290,
  8291,
  8292,
  8293,
  8294,
  8295,
  8296,
  8297,
  8298,
  8299,
  8300,
  8301,
  8302,
  8303,
  8304,
  8305,
  8306,
  8307,
  8308,
  8309,
  8310,
  8311,
  8312,
  8313,
  8314,
  8315,
  8316,
  8317,
  8318,
  8319,
  8320,
  8321,
  8322,
  8323,
  8324,
  8325,
  8326,
  8327,
  8328,
  8329,
  8330,
  8331,
  8332,
  8333,
  8334,
  8335,
  8336,
  8337,
  8338,
  8339,
  8340,
  8341,
  8342,
  8343,
  8344,
  8345,
  8346,
  8347,
  8348,
  8349,
  8350,
  8351,
  8352,
  8353,
  8354,
  8355,
  8356,
  8357,
  8358,
  8359,
  8360,
  8361,
  8362,
  8363,
  8364,
  8365,
  8366,
  8367,
  8368,
  8369,
  8370,
  8371,
  8372,
  8373,
  8374,
  8375,
  8376,
  8377,
  8378,
  8379,
  8380,
  8381,
  8382,
  8383,
  8384,
  8385,
  8386,
  8387,
  8388,
  8389,
  8390,
  8391,
  8392,
  8393,
  8394,
  8395,
  8396,
  8397,
  8398,
  8399,
  8400,
  8401,
  8402,
  8403,
  8404,
  8405,
  8406,
  8407,
  8408,
  8409,
  8410,
  8411,
  8412,
  8413,
  8414,
  8415,
  8416,
  8417,
  8418,
  8419,
  8420,
  8421,
  8422,
  8423,
  8424,
  8425,
  8426,
  8427,
  8428,
  8429,
  8430,
  8431,
  8432,
  8433,
  8434,
  8435,
  8436,
  8437,
  8438,
  8439,
  8440,
  8441,
  8442,
  8443,
  8444,
  8445,
  8446,
  8447,
  8448,
  8449,
  8450,
  8451,
  8452,
  8453,
  8454,
  8455,
  8456,
  8457,
  8458,
  8459,
  8460,
  8461,
  8462,
  8463,
  8464,
  8465,
  8466,
  8467,
  8468,
  8469,
  8470,
  8471,
  8472,
  8473,
  8474,
  8475,
  8476,
  8477,
  8478,
  8479,
  8480,
  8481,
  8482,
  8483,
  8484,
  8485,
  8486,
  8487,
  8488,
  8489,
  8490,
  8491,
  8492,
  8493,
  8494,
  8495,
  8496,
  8497,
  8498,
  8499,
  8500,
  8501,
  8502,
  8503,
  8504,
  8505,
  8506,
  8507,
  8508,
  8509,
  8510,
  8511,
  8512,
  8513,
  8514,
  8515,
  8516,
  8517,
  8518,
  8519,
  8520,
  8521,
  8522,
  8523,
  8524,
  8525,
  8526,
  8527,
  8528,
  8529,
  8530,
  8531,
  8532,
  8533,
  8534,
  8535,
  8536,
  8537,
  8538,
  8539,
  8540,
  8541,
  8542,
  8543,
  8544,
  8545,
  8546,
  8547,
  8548,
  8549,
  8550,
  8551,
  8552,
  8553,
  8554,
  8555,
  8556,
  8557,
  8558,
  8559,
  8560,
  8561,
  8562,
  8563,
  8564,
  8565,
  8566,
  8567,
  8568,
  8569,
  8570,
  8571,
  8572,
  8573,
  8574,
  8575,
  8576,
  8577,
  8578,
  8579,
  8580,
  8581,
  8582,
  8583,
  8584,
  8585,
  8586,
  8587,
  8588,
  8589,
  8590,
  8591,
  8592,
  8593,
  8594,
  8595,
  8596,
  8597,
  8598,
  8599,
  8600,
  8601,
  8602,
  8603,
  8604,
  8605,
  8606,
  8607,
  8608,
  8609,
  8610,
  8611,
  8612,
  8613,
  8614,
  8615,
  8616,
  8617,
  8618,
  8619,
  8620,
  8621,
  8622,
  8623,
  8624,
  8625,
  8626,
  8627,
  8628,
  8629,
  8630,
  8631,
  8632,
  8633,
  8634,
  8635,
  8636,
  8637,
  8638,
  8639,
  8640,
  8641,
  8642,
  8643,
  8644,
  8645,
  8646,
  8647,
  8648,
  8649,
  8650,
  8651,
  8652,
  8653,
  8654,
  8655,
  8656,
  8657,
  8658,
  8659,
  8660,
  8661,
  8662,
  8663,
  8664,
  8665,
  8666,
  8667,
  8668,
  8669,
  8670,
  8671,
  8672,
  8673,
  8674,
  8675,
  8676,
  8677,
  8678,
  8679,
  8680,
  8681,
  8682,
  8683,
  8684,
  8685,
  8686,
  8687,
  8688,
  8689,
  8690,
  8691,
  8692,
  8693,
  8694,
  8695,
  8696,
  8697,
  8698,
  8699,
  8700,
  8701,
  8702,
  8703,
  8704,
  8705,
  8706,
  8707,
  8708,
  8709,
  8710,
  8711,
  8712,
  8713,
  8714,
  8715,
  8716,
  8717,
  8718,
  8719,
  8720,
  8721,
  8722,
  8723,
  8724,
  8725,
  8726,
  8727,
  8728,
  8729,
  8730,
  8731,
  8732,
  8733,
  8734,
  8735,
  8736,
  8737,
  8738,
  8739,
  8740,
  8741
];
var je = {};
je.GB2312_TYPICAL_DISTRIBUTION_RATIO = 0.9;
je.GB2312_TABLE_SIZE = 3760;
je.GB2312CharToFreqOrder = [
  1671,
  749,
  1443,
  2364,
  3924,
  3807,
  2330,
  3921,
  1704,
  3463,
  2691,
  1511,
  1515,
  572,
  3191,
  2205,
  2361,
  224,
  2558,
  479,
  1711,
  963,
  3162,
  440,
  4060,
  1905,
  2966,
  2947,
  3580,
  2647,
  3961,
  3842,
  2204,
  869,
  4207,
  970,
  2678,
  5626,
  2944,
  2956,
  1479,
  4048,
  514,
  3595,
  588,
  1346,
  2820,
  3409,
  249,
  4088,
  1746,
  1873,
  2047,
  1774,
  581,
  1813,
  358,
  1174,
  3590,
  1014,
  1561,
  4844,
  2245,
  670,
  1636,
  3112,
  889,
  1286,
  953,
  556,
  2327,
  3060,
  1290,
  3141,
  613,
  185,
  3477,
  1367,
  850,
  3820,
  1715,
  2428,
  2642,
  2303,
  2732,
  3041,
  2562,
  2648,
  3566,
  3946,
  1349,
  388,
  3098,
  2091,
  1360,
  3585,
  152,
  1687,
  1539,
  738,
  1559,
  59,
  1232,
  2925,
  2267,
  1388,
  1249,
  1741,
  1679,
  2960,
  151,
  1566,
  1125,
  1352,
  4271,
  924,
  4296,
  385,
  3166,
  4459,
  310,
  1245,
  2850,
  70,
  3285,
  2729,
  3534,
  3575,
  2398,
  3298,
  3466,
  1960,
  2265,
  217,
  3647,
  864,
  1909,
  2084,
  4401,
  2773,
  1010,
  3269,
  5152,
  853,
  3051,
  3121,
  1244,
  4251,
  1895,
  364,
  1499,
  1540,
  2313,
  1180,
  3655,
  2268,
  562,
  715,
  2417,
  3061,
  544,
  336,
  3768,
  2380,
  1752,
  4075,
  950,
  280,
  2425,
  4382,
  183,
  2759,
  3272,
  333,
  4297,
  2155,
  1688,
  2356,
  1444,
  1039,
  4540,
  736,
  1177,
  3349,
  2443,
  2368,
  2144,
  2225,
  565,
  196,
  1482,
  3406,
  927,
  1335,
  4147,
  692,
  878,
  1311,
  1653,
  3911,
  3622,
  1378,
  4200,
  1840,
  2969,
  3149,
  2126,
  1816,
  2534,
  1546,
  2393,
  2760,
  737,
  2494,
  13,
  447,
  245,
  2747,
  38,
  2765,
  2129,
  2589,
  1079,
  606,
  360,
  471,
  3755,
  2890,
  404,
  848,
  699,
  1785,
  1236,
  370,
  2221,
  1023,
  3746,
  2074,
  2026,
  2023,
  2388,
  1581,
  2119,
  812,
  1141,
  3091,
  2536,
  1519,
  804,
  2053,
  406,
  1596,
  1090,
  784,
  548,
  4414,
  1806,
  2264,
  2936,
  1100,
  343,
  4114,
  5096,
  622,
  3358,
  743,
  3668,
  1510,
  1626,
  5020,
  3567,
  2513,
  3195,
  4115,
  5627,
  2489,
  2991,
  24,
  2065,
  2697,
  1087,
  2719,
  48,
  1634,
  315,
  68,
  985,
  2052,
  198,
  2239,
  1347,
  1107,
  1439,
  597,
  2366,
  2172,
  871,
  3307,
  919,
  2487,
  2790,
  1867,
  236,
  2570,
  1413,
  3794,
  906,
  3365,
  3381,
  1701,
  1982,
  1818,
  1524,
  2924,
  1205,
  616,
  2586,
  2072,
  2004,
  575,
  253,
  3099,
  32,
  1365,
  1182,
  197,
  1714,
  2454,
  1201,
  554,
  3388,
  3224,
  2748,
  756,
  2587,
  250,
  2567,
  1507,
  1517,
  3529,
  1922,
  2761,
  2337,
  3416,
  1961,
  1677,
  2452,
  2238,
  3153,
  615,
  911,
  1506,
  1474,
  2495,
  1265,
  1906,
  2749,
  3756,
  3280,
  2161,
  898,
  2714,
  1759,
  3450,
  2243,
  2444,
  563,
  26,
  3286,
  2266,
  3769,
  3344,
  2707,
  3677,
  611,
  1402,
  531,
  1028,
  2871,
  4548,
  1375,
  261,
  2948,
  835,
  1190,
  4134,
  353,
  840,
  2684,
  1900,
  3082,
  1435,
  2109,
  1207,
  1674,
  329,
  1872,
  2781,
  4055,
  2686,
  2104,
  608,
  3318,
  2423,
  2957,
  2768,
  1108,
  3739,
  3512,
  3271,
  3985,
  2203,
  1771,
  3520,
  1418,
  2054,
  1681,
  1153,
  225,
  1627,
  2929,
  162,
  2050,
  2511,
  3687,
  1954,
  124,
  1859,
  2431,
  1684,
  3032,
  2894,
  585,
  4805,
  3969,
  2869,
  2704,
  2088,
  2032,
  2095,
  3656,
  2635,
  4362,
  2209,
  256,
  518,
  2042,
  2105,
  3777,
  3657,
  643,
  2298,
  1148,
  1779,
  190,
  989,
  3544,
  414,
  11,
  2135,
  2063,
  2979,
  1471,
  403,
  3678,
  126,
  770,
  1563,
  671,
  2499,
  3216,
  2877,
  600,
  1179,
  307,
  2805,
  4937,
  1268,
  1297,
  2694,
  252,
  4032,
  1448,
  1494,
  1331,
  1394,
  127,
  2256,
  222,
  1647,
  1035,
  1481,
  3056,
  1915,
  1048,
  873,
  3651,
  210,
  33,
  1608,
  2516,
  200,
  1520,
  415,
  102,
  0,
  3389,
  1287,
  817,
  91,
  3299,
  2940,
  836,
  1814,
  549,
  2197,
  1396,
  1669,
  2987,
  3582,
  2297,
  2848,
  4528,
  1070,
  687,
  20,
  1819,
  121,
  1552,
  1364,
  1461,
  1968,
  2617,
  3540,
  2824,
  2083,
  177,
  948,
  4938,
  2291,
  110,
  4549,
  2066,
  648,
  3359,
  1755,
  2110,
  2114,
  4642,
  4845,
  1693,
  3937,
  3308,
  1257,
  1869,
  2123,
  208,
  1804,
  3159,
  2992,
  2531,
  2549,
  3361,
  2418,
  1350,
  2347,
  2800,
  2568,
  1291,
  2036,
  2680,
  72,
  842,
  1990,
  212,
  1233,
  1154,
  1586,
  75,
  2027,
  3410,
  4900,
  1823,
  1337,
  2710,
  2676,
  728,
  2810,
  1522,
  3026,
  4995,
  157,
  755,
  1050,
  4022,
  710,
  785,
  1936,
  2194,
  2085,
  1406,
  2777,
  2400,
  150,
  1250,
  4049,
  1206,
  807,
  1910,
  534,
  529,
  3309,
  1721,
  1660,
  274,
  39,
  2827,
  661,
  2670,
  1578,
  925,
  3248,
  3815,
  1094,
  4278,
  4901,
  4252,
  41,
  1150,
  3747,
  2572,
  2227,
  4501,
  3658,
  4902,
  3813,
  3357,
  3617,
  2884,
  2258,
  887,
  538,
  4187,
  3199,
  1294,
  2439,
  3042,
  2329,
  2343,
  2497,
  1255,
  107,
  543,
  1527,
  521,
  3478,
  3568,
  194,
  5062,
  15,
  961,
  3870,
  1241,
  1192,
  2664,
  66,
  5215,
  3260,
  2111,
  1295,
  1127,
  2152,
  3805,
  4135,
  901,
  1164,
  1976,
  398,
  1278,
  530,
  1460,
  748,
  904,
  1054,
  1966,
  1426,
  53,
  2909,
  509,
  523,
  2279,
  1534,
  536,
  1019,
  239,
  1685,
  460,
  2353,
  673,
  1065,
  2401,
  3600,
  4298,
  2272,
  1272,
  2363,
  284,
  1753,
  3679,
  4064,
  1695,
  81,
  815,
  2677,
  2757,
  2731,
  1386,
  859,
  500,
  4221,
  2190,
  2566,
  757,
  1006,
  2519,
  2068,
  1166,
  1455,
  337,
  2654,
  3203,
  1863,
  1682,
  1914,
  3025,
  1252,
  1409,
  1366,
  847,
  714,
  2834,
  2038,
  3209,
  964,
  2970,
  1901,
  885,
  2553,
  1078,
  1756,
  3049,
  301,
  1572,
  3326,
  688,
  2130,
  1996,
  2429,
  1805,
  1648,
  2930,
  3421,
  2750,
  3652,
  3088,
  262,
  1158,
  1254,
  389,
  1641,
  1812,
  526,
  1719,
  923,
  2073,
  1073,
  1902,
  468,
  489,
  4625,
  1140,
  857,
  2375,
  3070,
  3319,
  2863,
  380,
  116,
  1328,
  2693,
  1161,
  2244,
  273,
  1212,
  1884,
  2769,
  3011,
  1775,
  1142,
  461,
  3066,
  1200,
  2147,
  2212,
  790,
  702,
  2695,
  4222,
  1601,
  1058,
  434,
  2338,
  5153,
  3640,
  67,
  2360,
  4099,
  2502,
  618,
  3472,
  1329,
  416,
  1132,
  830,
  2782,
  1807,
  2653,
  3211,
  3510,
  1662,
  192,
  2124,
  296,
  3979,
  1739,
  1611,
  3684,
  23,
  118,
  324,
  446,
  1239,
  1225,
  293,
  2520,
  3814,
  3795,
  2535,
  3116,
  17,
  1074,
  467,
  2692,
  2201,
  387,
  2922,
  45,
  1326,
  3055,
  1645,
  3659,
  2817,
  958,
  243,
  1903,
  2320,
  1339,
  2825,
  1784,
  3289,
  356,
  576,
  865,
  2315,
  2381,
  3377,
  3916,
  1088,
  3122,
  1713,
  1655,
  935,
  628,
  4689,
  1034,
  1327,
  441,
  800,
  720,
  894,
  1979,
  2183,
  1528,
  5289,
  2702,
  1071,
  4046,
  3572,
  2399,
  1571,
  3281,
  79,
  761,
  1103,
  327,
  134,
  758,
  1899,
  1371,
  1615,
  879,
  442,
  215,
  2605,
  2579,
  173,
  2048,
  2485,
  1057,
  2975,
  3317,
  1097,
  2253,
  3801,
  4263,
  1403,
  1650,
  2946,
  814,
  4968,
  3487,
  1548,
  2644,
  1567,
  1285,
  2,
  295,
  2636,
  97,
  946,
  3576,
  832,
  141,
  4257,
  3273,
  760,
  3821,
  3521,
  3156,
  2607,
  949,
  1024,
  1733,
  1516,
  1803,
  1920,
  2125,
  2283,
  2665,
  3180,
  1501,
  2064,
  3560,
  2171,
  1592,
  803,
  3518,
  1416,
  732,
  3897,
  4258,
  1363,
  1362,
  2458,
  119,
  1427,
  602,
  1525,
  2608,
  1605,
  1639,
  3175,
  694,
  3064,
  10,
  465,
  76,
  2e3,
  4846,
  4208,
  444,
  3781,
  1619,
  3353,
  2206,
  1273,
  3796,
  740,
  2483,
  320,
  1723,
  2377,
  3660,
  2619,
  1359,
  1137,
  1762,
  1724,
  2345,
  2842,
  1850,
  1862,
  912,
  821,
  1866,
  612,
  2625,
  1735,
  2573,
  3369,
  1093,
  844,
  89,
  937,
  930,
  1424,
  3564,
  2413,
  2972,
  1004,
  3046,
  3019,
  2011,
  711,
  3171,
  1452,
  4178,
  428,
  801,
  1943,
  432,
  445,
  2811,
  206,
  4136,
  1472,
  730,
  349,
  73,
  397,
  2802,
  2547,
  998,
  1637,
  1167,
  789,
  396,
  3217,
  154,
  1218,
  716,
  1120,
  1780,
  2819,
  4826,
  1931,
  3334,
  3762,
  2139,
  1215,
  2627,
  552,
  3664,
  3628,
  3232,
  1405,
  2383,
  3111,
  1356,
  2652,
  3577,
  3320,
  3101,
  1703,
  640,
  1045,
  1370,
  1246,
  4996,
  371,
  1575,
  2436,
  1621,
  2210,
  984,
  4033,
  1734,
  2638,
  16,
  4529,
  663,
  2755,
  3255,
  1451,
  3917,
  2257,
  1253,
  1955,
  2234,
  1263,
  2951,
  214,
  1229,
  617,
  485,
  359,
  1831,
  1969,
  473,
  2310,
  750,
  2058,
  165,
  80,
  2864,
  2419,
  361,
  4344,
  2416,
  2479,
  1134,
  796,
  3726,
  1266,
  2943,
  860,
  2715,
  938,
  390,
  2734,
  1313,
  1384,
  248,
  202,
  877,
  1064,
  2854,
  522,
  3907,
  279,
  1602,
  297,
  2357,
  395,
  3740,
  137,
  2075,
  944,
  4089,
  2584,
  1267,
  3802,
  62,
  1533,
  2285,
  178,
  176,
  780,
  2440,
  201,
  3707,
  590,
  478,
  1560,
  4354,
  2117,
  1075,
  30,
  74,
  4643,
  4004,
  1635,
  1441,
  2745,
  776,
  2596,
  238,
  1077,
  1692,
  1912,
  2844,
  605,
  499,
  1742,
  3947,
  241,
  3053,
  980,
  1749,
  936,
  2640,
  4511,
  2582,
  515,
  1543,
  2162,
  5322,
  2892,
  2993,
  890,
  2148,
  1924,
  665,
  1827,
  3581,
  1032,
  968,
  3163,
  339,
  1044,
  1896,
  270,
  583,
  1791,
  1720,
  4367,
  1194,
  3488,
  3669,
  43,
  2523,
  1657,
  163,
  2167,
  290,
  1209,
  1622,
  3378,
  550,
  634,
  2508,
  2510,
  695,
  2634,
  2384,
  2512,
  1476,
  1414,
  220,
  1469,
  2341,
  2138,
  2852,
  3183,
  2900,
  4939,
  2865,
  3502,
  1211,
  3680,
  854,
  3227,
  1299,
  2976,
  3172,
  186,
  2998,
  1459,
  443,
  1067,
  3251,
  1495,
  321,
  1932,
  3054,
  909,
  753,
  1410,
  1828,
  436,
  2441,
  1119,
  1587,
  3164,
  2186,
  1258,
  227,
  231,
  1425,
  1890,
  3200,
  3942,
  247,
  959,
  725,
  5254,
  2741,
  577,
  2158,
  2079,
  929,
  120,
  174,
  838,
  2813,
  591,
  1115,
  417,
  2024,
  40,
  3240,
  1536,
  1037,
  291,
  4151,
  2354,
  632,
  1298,
  2406,
  2500,
  3535,
  1825,
  1846,
  3451,
  205,
  1171,
  345,
  4238,
  18,
  1163,
  811,
  685,
  2208,
  1217,
  425,
  1312,
  1508,
  1175,
  4308,
  2552,
  1033,
  587,
  1381,
  3059,
  2984,
  3482,
  340,
  1316,
  4023,
  3972,
  792,
  3176,
  519,
  777,
  4690,
  918,
  933,
  4130,
  2981,
  3741,
  90,
  3360,
  2911,
  2200,
  5184,
  4550,
  609,
  3079,
  2030,
  272,
  3379,
  2736,
  363,
  3881,
  1130,
  1447,
  286,
  779,
  357,
  1169,
  3350,
  3137,
  1630,
  1220,
  2687,
  2391,
  747,
  1277,
  3688,
  2618,
  2682,
  2601,
  1156,
  3196,
  5290,
  4034,
  3102,
  1689,
  3596,
  3128,
  874,
  219,
  2783,
  798,
  508,
  1843,
  2461,
  269,
  1658,
  1776,
  1392,
  1913,
  2983,
  3287,
  2866,
  2159,
  2372,
  829,
  4076,
  46,
  4253,
  2873,
  1889,
  1894,
  915,
  1834,
  1631,
  2181,
  2318,
  298,
  664,
  2818,
  3555,
  2735,
  954,
  3228,
  3117,
  527,
  3511,
  2173,
  681,
  2712,
  3033,
  2247,
  2346,
  3467,
  1652,
  155,
  2164,
  3382,
  113,
  1994,
  450,
  899,
  494,
  994,
  1237,
  2958,
  1875,
  2336,
  1926,
  3727,
  545,
  1577,
  1550,
  633,
  3473,
  204,
  1305,
  3072,
  2410,
  1956,
  2471,
  707,
  2134,
  841,
  2195,
  2196,
  2663,
  3843,
  1026,
  4940,
  990,
  3252,
  4997,
  368,
  1092,
  437,
  3212,
  3258,
  1933,
  1829,
  675,
  2977,
  2893,
  412,
  943,
  3723,
  4644,
  3294,
  3283,
  2230,
  2373,
  5154,
  2389,
  2241,
  2661,
  2323,
  1404,
  2524,
  593,
  787,
  677,
  3008,
  1275,
  2059,
  438,
  2709,
  2609,
  2240,
  2269,
  2246,
  1446,
  36,
  1568,
  1373,
  3892,
  1574,
  2301,
  1456,
  3962,
  693,
  2276,
  5216,
  2035,
  1143,
  2720,
  1919,
  1797,
  1811,
  2763,
  4137,
  2597,
  1830,
  1699,
  1488,
  1198,
  2090,
  424,
  1694,
  312,
  3634,
  3390,
  4179,
  3335,
  2252,
  1214,
  561,
  1059,
  3243,
  2295,
  2561,
  975,
  5155,
  2321,
  2751,
  3772,
  472,
  1537,
  3282,
  3398,
  1047,
  2077,
  2348,
  2878,
  1323,
  3340,
  3076,
  690,
  2906,
  51,
  369,
  170,
  3541,
  1060,
  2187,
  2688,
  3670,
  2541,
  1083,
  1683,
  928,
  3918,
  459,
  109,
  4427,
  599,
  3744,
  4286,
  143,
  2101,
  2730,
  2490,
  82,
  1588,
  3036,
  2121,
  281,
  1860,
  477,
  4035,
  1238,
  2812,
  3020,
  2716,
  3312,
  1530,
  2188,
  2055,
  1317,
  843,
  636,
  1808,
  1173,
  3495,
  649,
  181,
  1002,
  147,
  3641,
  1159,
  2414,
  3750,
  2289,
  2795,
  813,
  3123,
  2610,
  1136,
  4368,
  5,
  3391,
  4541,
  2174,
  420,
  429,
  1728,
  754,
  1228,
  2115,
  2219,
  347,
  2223,
  2733,
  735,
  1518,
  3003,
  2355,
  3134,
  1764,
  3948,
  3329,
  1888,
  2424,
  1001,
  1234,
  1972,
  3321,
  3363,
  1672,
  1021,
  1450,
  1584,
  226,
  765,
  655,
  2526,
  3404,
  3244,
  2302,
  3665,
  731,
  594,
  2184,
  319,
  1576,
  621,
  658,
  2656,
  4299,
  2099,
  3864,
  1279,
  2071,
  2598,
  2739,
  795,
  3086,
  3699,
  3908,
  1707,
  2352,
  2402,
  1382,
  3136,
  2475,
  1465,
  4847,
  3496,
  3865,
  1085,
  3004,
  2591,
  1084,
  213,
  2287,
  1963,
  3565,
  2250,
  822,
  793,
  4574,
  3187,
  1772,
  1789,
  3050,
  595,
  1484,
  1959,
  2770,
  1080,
  2650,
  456,
  422,
  2996,
  940,
  3322,
  4328,
  4345,
  3092,
  2742,
  965,
  2784,
  739,
  4124,
  952,
  1358,
  2498,
  2949,
  2565,
  332,
  2698,
  2378,
  660,
  2260,
  2473,
  4194,
  3856,
  2919,
  535,
  1260,
  2651,
  1208,
  1428,
  1300,
  1949,
  1303,
  2942,
  433,
  2455,
  2450,
  1251,
  1946,
  614,
  1269,
  641,
  1306,
  1810,
  2737,
  3078,
  2912,
  564,
  2365,
  1419,
  1415,
  1497,
  4460,
  2367,
  2185,
  1379,
  3005,
  1307,
  3218,
  2175,
  1897,
  3063,
  682,
  1157,
  4040,
  4005,
  1712,
  1160,
  1941,
  1399,
  394,
  402,
  2952,
  1573,
  1151,
  2986,
  2404,
  862,
  299,
  2033,
  1489,
  3006,
  346,
  171,
  2886,
  3401,
  1726,
  2932,
  168,
  2533,
  47,
  2507,
  1030,
  3735,
  1145,
  3370,
  1395,
  1318,
  1579,
  3609,
  4560,
  2857,
  4116,
  1457,
  2529,
  1965,
  504,
  1036,
  2690,
  2988,
  2405,
  745,
  5871,
  849,
  2397,
  2056,
  3081,
  863,
  2359,
  3857,
  2096,
  99,
  1397,
  1769,
  2300,
  4428,
  1643,
  3455,
  1978,
  1757,
  3718,
  1440,
  35,
  4879,
  3742,
  1296,
  4228,
  2280,
  160,
  5063,
  1599,
  2013,
  166,
  520,
  3479,
  1646,
  3345,
  3012,
  490,
  1937,
  1545,
  1264,
  2182,
  2505,
  1096,
  1188,
  1369,
  1436,
  2421,
  1667,
  2792,
  2460,
  1270,
  2122,
  727,
  3167,
  2143,
  806,
  1706,
  1012,
  1800,
  3037,
  960,
  2218,
  1882,
  805,
  139,
  2456,
  1139,
  1521,
  851,
  1052,
  3093,
  3089,
  342,
  2039,
  744,
  5097,
  1468,
  1502,
  1585,
  2087,
  223,
  939,
  326,
  2140,
  2577,
  892,
  2481,
  1623,
  4077,
  982,
  3708,
  135,
  2131,
  87,
  2503,
  3114,
  2326,
  1106,
  876,
  1616,
  547,
  2997,
  2831,
  2093,
  3441,
  4530,
  4314,
  9,
  3256,
  4229,
  4148,
  659,
  1462,
  1986,
  1710,
  2046,
  2913,
  2231,
  4090,
  4880,
  5255,
  3392,
  3274,
  1368,
  3689,
  4645,
  1477,
  705,
  3384,
  3635,
  1068,
  1529,
  2941,
  1458,
  3782,
  1509,
  100,
  1656,
  2548,
  718,
  2339,
  408,
  1590,
  2780,
  3548,
  1838,
  4117,
  3719,
  1345,
  3530,
  717,
  3442,
  2778,
  3220,
  2898,
  1892,
  4590,
  3614,
  3371,
  2043,
  1998,
  1224,
  3483,
  891,
  635,
  584,
  2559,
  3355,
  733,
  1766,
  1729,
  1172,
  3789,
  1891,
  2307,
  781,
  2982,
  2271,
  1957,
  1580,
  5773,
  2633,
  2005,
  4195,
  3097,
  1535,
  3213,
  1189,
  1934,
  5693,
  3262,
  586,
  3118,
  1324,
  1598,
  517,
  1564,
  2217,
  1868,
  1893,
  4445,
  3728,
  2703,
  3139,
  1526,
  1787,
  1992,
  3882,
  2875,
  1549,
  1199,
  1056,
  2224,
  1904,
  2711,
  5098,
  4287,
  338,
  1993,
  3129,
  3489,
  2689,
  1809,
  2815,
  1997,
  957,
  1855,
  3898,
  2550,
  3275,
  3057,
  1105,
  1319,
  627,
  1505,
  1911,
  1883,
  3526,
  698,
  3629,
  3456,
  1833,
  1431,
  746,
  77,
  1261,
  2017,
  2296,
  1977,
  1885,
  125,
  1334,
  1600,
  525,
  1798,
  1109,
  2222,
  1470,
  1945,
  559,
  2236,
  1186,
  3443,
  2476,
  1929,
  1411,
  2411,
  3135,
  1777,
  3372,
  2621,
  1841,
  1613,
  3229,
  668,
  1430,
  1839,
  2643,
  2916,
  195,
  1989,
  2671,
  2358,
  1387,
  629,
  3205,
  2293,
  5256,
  4439,
  123,
  1310,
  888,
  1879,
  4300,
  3021,
  3605,
  1003,
  1162,
  3192,
  2910,
  2010,
  140,
  2395,
  2859,
  55,
  1082,
  2012,
  2901,
  662,
  419,
  2081,
  1438,
  680,
  2774,
  4654,
  3912,
  1620,
  1731,
  1625,
  5035,
  4065,
  2328,
  512,
  1344,
  802,
  5443,
  2163,
  2311,
  2537,
  524,
  3399,
  98,
  1155,
  2103,
  1918,
  2606,
  3925,
  2816,
  1393,
  2465,
  1504,
  3773,
  2177,
  3963,
  1478,
  4346,
  180,
  1113,
  4655,
  3461,
  2028,
  1698,
  833,
  2696,
  1235,
  1322,
  1594,
  4408,
  3623,
  3013,
  3225,
  2040,
  3022,
  541,
  2881,
  607,
  3632,
  2029,
  1665,
  1219,
  639,
  1385,
  1686,
  1099,
  2803,
  3231,
  1938,
  3188,
  2858,
  427,
  676,
  2772,
  1168,
  2025,
  454,
  3253,
  2486,
  3556,
  230,
  1950,
  580,
  791,
  1991,
  1280,
  1086,
  1974,
  2034,
  630,
  257,
  3338,
  2788,
  4903,
  1017,
  86,
  4790,
  966,
  2789,
  1995,
  1696,
  1131,
  259,
  3095,
  4188,
  1308,
  179,
  1463,
  5257,
  289,
  4107,
  1248,
  42,
  3413,
  1725,
  2288,
  896,
  1947,
  774,
  4474,
  4254,
  604,
  3430,
  4264,
  392,
  2514,
  2588,
  452,
  237,
  1408,
  3018,
  988,
  4531,
  1970,
  3034,
  3310,
  540,
  2370,
  1562,
  1288,
  2990,
  502,
  4765,
  1147,
  4,
  1853,
  2708,
  207,
  294,
  2814,
  4078,
  2902,
  2509,
  684,
  34,
  3105,
  3532,
  2551,
  644,
  709,
  2801,
  2344,
  573,
  1727,
  3573,
  3557,
  2021,
  1081,
  3100,
  4315,
  2100,
  3681,
  199,
  2263,
  1837,
  2385,
  146,
  3484,
  1195,
  2776,
  3949,
  997,
  1939,
  3973,
  1008,
  1091,
  1202,
  1962,
  1847,
  1149,
  4209,
  5444,
  1076,
  493,
  117,
  5400,
  2521,
  972,
  1490,
  2934,
  1796,
  4542,
  2374,
  1512,
  2933,
  2657,
  413,
  2888,
  1135,
  2762,
  2314,
  2156,
  1355,
  2369,
  766,
  2007,
  2527,
  2170,
  3124,
  2491,
  2593,
  2632,
  4757,
  2437,
  234,
  3125,
  3591,
  1898,
  1750,
  1376,
  1942,
  3468,
  3138,
  570,
  2127,
  2145,
  3276,
  4131,
  962,
  132,
  1445,
  4196,
  19,
  941,
  3624,
  3480,
  3366,
  1973,
  1374,
  4461,
  3431,
  2629,
  283,
  2415,
  2275,
  808,
  2887,
  3620,
  2112,
  2563,
  1353,
  3610,
  955,
  1089,
  3103,
  1053,
  96,
  88,
  4097,
  823,
  3808,
  1583,
  399,
  292,
  4091,
  3313,
  421,
  1128,
  642,
  4006,
  903,
  2539,
  1877,
  2082,
  596,
  29,
  4066,
  1790,
  722,
  2157,
  130,
  995,
  1569,
  769,
  1485,
  464,
  513,
  2213,
  288,
  1923,
  1101,
  2453,
  4316,
  133,
  486,
  2445,
  50,
  625,
  487,
  2207,
  57,
  423,
  481,
  2962,
  159,
  3729,
  1558,
  491,
  303,
  482,
  501,
  240,
  2837,
  112,
  3648,
  2392,
  1783,
  362,
  8,
  3433,
  3422,
  610,
  2793,
  3277,
  1390,
  1284,
  1654,
  21,
  3823,
  734,
  367,
  623,
  193,
  287,
  374,
  1009,
  1483,
  816,
  476,
  313,
  2255,
  2340,
  1262,
  2150,
  2899,
  1146,
  2581,
  782,
  2116,
  1659,
  2018,
  1880,
  255,
  3586,
  3314,
  1110,
  2867,
  2137,
  2564,
  986,
  2767,
  5185,
  2006,
  650,
  158,
  926,
  762,
  881,
  3157,
  2717,
  2362,
  3587,
  306,
  3690,
  3245,
  1542,
  3077,
  2427,
  1691,
  2478,
  2118,
  2985,
  3490,
  2438,
  539,
  2305,
  983,
  129,
  1754,
  355,
  4201,
  2386,
  827,
  2923,
  104,
  1773,
  2838,
  2771,
  411,
  2905,
  3919,
  376,
  767,
  122,
  1114,
  828,
  2422,
  1817,
  3506,
  266,
  3460,
  1007,
  1609,
  4998,
  945,
  2612,
  4429,
  2274,
  726,
  1247,
  1964,
  2914,
  2199,
  2070,
  4002,
  4108,
  657,
  3323,
  1422,
  579,
  455,
  2764,
  4737,
  1222,
  2895,
  1670,
  824,
  1223,
  1487,
  2525,
  558,
  861,
  3080,
  598,
  2659,
  2515,
  1967,
  752,
  2583,
  2376,
  2214,
  4180,
  977,
  704,
  2464,
  4999,
  2622,
  4109,
  1210,
  2961,
  819,
  1541,
  142,
  2284,
  44,
  418,
  457,
  1126,
  3730,
  4347,
  4626,
  1644,
  1876,
  3671,
  1864,
  302,
  1063,
  5694,
  624,
  723,
  1984,
  3745,
  1314,
  1676,
  2488,
  1610,
  1449,
  3558,
  3569,
  2166,
  2098,
  409,
  1011,
  2325,
  3704,
  2306,
  818,
  1732,
  1383,
  1824,
  1844,
  3757,
  999,
  2705,
  3497,
  1216,
  1423,
  2683,
  2426,
  2954,
  2501,
  2726,
  2229,
  1475,
  2554,
  5064,
  1971,
  1794,
  1666,
  2014,
  1343,
  783,
  724,
  191,
  2434,
  1354,
  2220,
  5065,
  1763,
  2752,
  2472,
  4152,
  131,
  175,
  2885,
  3434,
  92,
  1466,
  4920,
  2616,
  3871,
  3872,
  3866,
  128,
  1551,
  1632,
  669,
  1854,
  3682,
  4691,
  4125,
  1230,
  188,
  2973,
  3290,
  1302,
  1213,
  560,
  3266,
  917,
  763,
  3909,
  3249,
  1760,
  868,
  1958,
  764,
  1782,
  2097,
  145,
  2277,
  3774,
  4462,
  64,
  1491,
  3062,
  971,
  2132,
  3606,
  2442,
  221,
  1226,
  1617,
  218,
  323,
  1185,
  3207,
  3147,
  571,
  619,
  1473,
  1005,
  1744,
  2281,
  449,
  1887,
  2396,
  3685,
  275,
  375,
  3816,
  1743,
  3844,
  3731,
  845,
  1983,
  2350,
  4210,
  1377,
  773,
  967,
  3499,
  3052,
  3743,
  2725,
  4007,
  1697,
  1022,
  3943,
  1464,
  3264,
  2855,
  2722,
  1952,
  1029,
  2839,
  2467,
  84,
  4383,
  2215,
  820,
  1391,
  2015,
  2448,
  3672,
  377,
  1948,
  2168,
  797,
  2545,
  3536,
  2578,
  2645,
  94,
  2874,
  1678,
  405,
  1259,
  3071,
  771,
  546,
  1315,
  470,
  1243,
  3083,
  895,
  2468,
  981,
  969,
  2037,
  846,
  4181,
  653,
  1276,
  2928,
  14,
  2594,
  557,
  3007,
  2474,
  156,
  902,
  1338,
  1740,
  2574,
  537,
  2518,
  973,
  2282,
  2216,
  2433,
  1928,
  138,
  2903,
  1293,
  2631,
  1612,
  646,
  3457,
  839,
  2935,
  111,
  496,
  2191,
  2847,
  589,
  3186,
  149,
  3994,
  2060,
  4031,
  2641,
  4067,
  3145,
  1870,
  37,
  3597,
  2136,
  1025,
  2051,
  3009,
  3383,
  3549,
  1121,
  1016,
  3261,
  1301,
  251,
  2446,
  2599,
  2153,
  872,
  3246,
  637,
  334,
  3705,
  831,
  884,
  921,
  3065,
  3140,
  4092,
  2198,
  1944,
  246,
  2964,
  108,
  2045,
  1152,
  1921,
  2308,
  1031,
  203,
  3173,
  4170,
  1907,
  3890,
  810,
  1401,
  2003,
  1690,
  506,
  647,
  1242,
  2828,
  1761,
  1649,
  3208,
  2249,
  1589,
  3709,
  2931,
  5156,
  1708,
  498,
  666,
  2613,
  834,
  3817,
  1231,
  184,
  2851,
  1124,
  883,
  3197,
  2261,
  3710,
  1765,
  1553,
  2658,
  1178,
  2639,
  2351,
  93,
  1193,
  942,
  2538,
  2141,
  4402,
  235,
  1821,
  870,
  1591,
  2192,
  1709,
  1871,
  3341,
  1618,
  4126,
  2595,
  2334,
  603,
  651,
  69,
  701,
  268,
  2662,
  3411,
  2555,
  1380,
  1606,
  503,
  448,
  254,
  2371,
  2646,
  574,
  1187,
  2309,
  1770,
  322,
  2235,
  1292,
  1801,
  305,
  566,
  1133,
  229,
  2067,
  2057,
  706,
  167,
  483,
  2002,
  2672,
  3295,
  1820,
  3561,
  3067,
  316,
  378,
  2746,
  3452,
  1112,
  136,
  1981,
  507,
  1651,
  2917,
  1117,
  285,
  4591,
  182,
  2580,
  3522,
  1304,
  335,
  3303,
  1835,
  2504,
  1795,
  1792,
  2248,
  674,
  1018,
  2106,
  2449,
  1857,
  2292,
  2845,
  976,
  3047,
  1781,
  2600,
  2727,
  1389,
  1281,
  52,
  3152,
  153,
  265,
  3950,
  672,
  3485,
  3951,
  4463,
  430,
  1183,
  365,
  278,
  2169,
  27,
  1407,
  1336,
  2304,
  209,
  1340,
  1730,
  2202,
  1852,
  2403,
  2883,
  979,
  1737,
  1062,
  631,
  2829,
  2542,
  3876,
  2592,
  825,
  2086,
  2226,
  3048,
  3625,
  352,
  1417,
  3724,
  542,
  991,
  431,
  1351,
  3938,
  1861,
  2294,
  826,
  1361,
  2927,
  3142,
  3503,
  1738,
  463,
  2462,
  2723,
  582,
  1916,
  1595,
  2808,
  400,
  3845,
  3891,
  2868,
  3621,
  2254,
  58,
  2492,
  1123,
  910,
  2160,
  2614,
  1372,
  1603,
  1196,
  1072,
  3385,
  1700,
  3267,
  1980,
  696,
  480,
  2430,
  920,
  799,
  1570,
  2920,
  1951,
  2041,
  4047,
  2540,
  1321,
  4223,
  2469,
  3562,
  2228,
  1271,
  2602,
  401,
  2833,
  3351,
  2575,
  5157,
  907,
  2312,
  1256,
  410,
  263,
  3507,
  1582,
  996,
  678,
  1849,
  2316,
  1480,
  908,
  3545,
  2237,
  703,
  2322,
  667,
  1826,
  2849,
  1531,
  2604,
  2999,
  2407,
  3146,
  2151,
  2630,
  1786,
  3711,
  469,
  3542,
  497,
  3899,
  2409,
  858,
  837,
  4446,
  3393,
  1274,
  786,
  620,
  1845,
  2001,
  3311,
  484,
  308,
  3367,
  1204,
  1815,
  3691,
  2332,
  1532,
  2557,
  1842,
  2020,
  2724,
  1927,
  2333,
  4440,
  567,
  22,
  1673,
  2728,
  4475,
  1987,
  1858,
  1144,
  1597,
  101,
  1832,
  3601,
  12,
  974,
  3783,
  4391,
  951,
  1412,
  1,
  3720,
  453,
  4608,
  4041,
  528,
  1041,
  1027,
  3230,
  2628,
  1129,
  875,
  1051,
  3291,
  1203,
  2262,
  1069,
  2860,
  2799,
  2149,
  2615,
  3278,
  144,
  1758,
  3040,
  31,
  475,
  1680,
  366,
  2685,
  3184,
  311,
  1642,
  4008,
  2466,
  5036,
  1593,
  1493,
  2809,
  216,
  1420,
  1668,
  233,
  304,
  2128,
  3284,
  232,
  1429,
  1768,
  1040,
  2008,
  3407,
  2740,
  2967,
  2543,
  242,
  2133,
  778,
  1565,
  2022,
  2620,
  505,
  2189,
  2756,
  1098,
  2273,
  372,
  1614,
  708,
  553,
  2846,
  2094,
  2278,
  169,
  3626,
  2835,
  4161,
  228,
  2674,
  3165,
  809,
  1454,
  1309,
  466,
  1705,
  1095,
  900,
  3423,
  880,
  2667,
  3751,
  5258,
  2317,
  3109,
  2571,
  4317,
  2766,
  1503,
  1342,
  866,
  4447,
  1118,
  63,
  2076,
  314,
  1881,
  1348,
  1061,
  172,
  978,
  3515,
  1747,
  532,
  511,
  3970,
  6,
  601,
  905,
  2699,
  3300,
  1751,
  276,
  1467,
  3725,
  2668,
  65,
  4239,
  2544,
  2779,
  2556,
  1604,
  578,
  2451,
  1802,
  992,
  2331,
  2624,
  1320,
  3446,
  713,
  1513,
  1013,
  103,
  2786,
  2447,
  1661,
  886,
  1702,
  916,
  654,
  3574,
  2031,
  1556,
  751,
  2178,
  2821,
  2179,
  1498,
  1538,
  2176,
  271,
  914,
  2251,
  2080,
  1325,
  638,
  1953,
  2937,
  3877,
  2432,
  2754,
  95,
  3265,
  1716,
  260,
  1227,
  4083,
  775,
  106,
  1357,
  3254,
  426,
  1607,
  555,
  2480,
  772,
  1985,
  244,
  2546,
  474,
  495,
  1046,
  2611,
  1851,
  2061,
  71,
  2089,
  1675,
  2590,
  742,
  3758,
  2843,
  3222,
  1433,
  267,
  2180,
  2576,
  2826,
  2233,
  2092,
  3913,
  2435,
  956,
  1745,
  3075,
  856,
  2113,
  1116,
  451,
  3,
  1988,
  2896,
  1398,
  993,
  2463,
  1878,
  2049,
  1341,
  2718,
  2721,
  2870,
  2108,
  712,
  2904,
  4363,
  2753,
  2324,
  277,
  2872,
  2349,
  2649,
  384,
  987,
  435,
  691,
  3e3,
  922,
  164,
  3939,
  652,
  1500,
  1184,
  4153,
  2482,
  3373,
  2165,
  4848,
  2335,
  3775,
  3508,
  3154,
  2806,
  2830,
  1554,
  2102,
  1664,
  2530,
  1434,
  2408,
  893,
  1547,
  2623,
  3447,
  2832,
  2242,
  2532,
  3169,
  2856,
  3223,
  2078,
  49,
  3770,
  3469,
  462,
  318,
  656,
  2259,
  3250,
  3069,
  679,
  1629,
  2758,
  344,
  1138,
  1104,
  3120,
  1836,
  1283,
  3115,
  2154,
  1437,
  4448,
  934,
  759,
  1999,
  794,
  2862,
  1038,
  533,
  2560,
  1722,
  2342,
  855,
  2626,
  1197,
  1663,
  4476,
  3127,
  85,
  4240,
  2528,
  25,
  1111,
  1181,
  3673,
  407,
  3470,
  4561,
  2679,
  2713,
  768,
  1925,
  2841,
  3986,
  1544,
  1165,
  932,
  373,
  1240,
  2146,
  1930,
  2673,
  721,
  4766,
  354,
  4333,
  391,
  2963,
  187,
  61,
  3364,
  1442,
  1102,
  330,
  1940,
  1767,
  341,
  3809,
  4118,
  393,
  2496,
  2062,
  2211,
  105,
  331,
  300,
  439,
  913,
  1332,
  626,
  379,
  3304,
  1557,
  328,
  689,
  3952,
  309,
  1555,
  931,
  317,
  2517,
  3027,
  325,
  569,
  686,
  2107,
  3084,
  60,
  1042,
  1333,
  2794,
  264,
  3177,
  4014,
  1628,
  258,
  3712,
  7,
  4464,
  1176,
  1043,
  1778,
  683,
  114,
  1975,
  78,
  1492,
  383,
  1886,
  510,
  386,
  645,
  5291,
  2891,
  2069,
  3305,
  4138,
  3867,
  2939,
  2603,
  2493,
  1935,
  1066,
  1848,
  3588,
  1015,
  1282,
  1289,
  4609,
  697,
  1453,
  3044,
  2666,
  3611,
  1856,
  2412,
  54,
  719,
  1330,
  568,
  3778,
  2459,
  1748,
  788,
  492,
  551,
  1191,
  1e3,
  488,
  3394,
  3763,
  282,
  1799,
  348,
  2016,
  1523,
  3155,
  2390,
  1049,
  382,
  2019,
  1788,
  1170,
  729,
  2968,
  3523,
  897,
  3926,
  2785,
  2938,
  3292,
  350,
  2319,
  3238,
  1718,
  1717,
  2655,
  3453,
  3143,
  4465,
  161,
  2889,
  2980,
  2009,
  1421,
  56,
  1908,
  1640,
  2387,
  2232,
  1917,
  1874,
  2477,
  4921,
  148,
  83,
  3438,
  592,
  4245,
  2882,
  1822,
  1055,
  741,
  115,
  1496,
  1624,
  381,
  1638,
  4592,
  1020,
  516,
  3214,
  458,
  947,
  4575,
  1432,
  211,
  1514,
  2926,
  1865,
  2142,
  189,
  852,
  1221,
  1400,
  1486,
  882,
  2299,
  4036,
  351,
  28,
  1122,
  700,
  6479,
  6480,
  6481,
  6482,
  6483,
  // last 512
  //Everything below is of no interest for detection purpose
  5508,
  6484,
  3900,
  3414,
  3974,
  4441,
  4024,
  3537,
  4037,
  5628,
  5099,
  3633,
  6485,
  3148,
  6486,
  3636,
  5509,
  3257,
  5510,
  5973,
  5445,
  5872,
  4941,
  4403,
  3174,
  4627,
  5873,
  6276,
  2286,
  4230,
  5446,
  5874,
  5122,
  6102,
  6103,
  4162,
  5447,
  5123,
  5323,
  4849,
  6277,
  3980,
  3851,
  5066,
  4246,
  5774,
  5067,
  6278,
  3001,
  2807,
  5695,
  3346,
  5775,
  5974,
  5158,
  5448,
  6487,
  5975,
  5976,
  5776,
  3598,
  6279,
  5696,
  4806,
  4211,
  4154,
  6280,
  6488,
  6489,
  6490,
  6281,
  4212,
  5037,
  3374,
  4171,
  6491,
  4562,
  4807,
  4722,
  4827,
  5977,
  6104,
  4532,
  4079,
  5159,
  5324,
  5160,
  4404,
  3858,
  5359,
  5875,
  3975,
  4288,
  4610,
  3486,
  4512,
  5325,
  3893,
  5360,
  6282,
  6283,
  5560,
  2522,
  4231,
  5978,
  5186,
  5449,
  2569,
  3878,
  6284,
  5401,
  3578,
  4415,
  6285,
  4656,
  5124,
  5979,
  2506,
  4247,
  4449,
  3219,
  3417,
  4334,
  4969,
  4329,
  6492,
  4576,
  4828,
  4172,
  4416,
  4829,
  5402,
  6286,
  3927,
  3852,
  5361,
  4369,
  4830,
  4477,
  4867,
  5876,
  4173,
  6493,
  6105,
  4657,
  6287,
  6106,
  5877,
  5450,
  6494,
  4155,
  4868,
  5451,
  3700,
  5629,
  4384,
  6288,
  6289,
  5878,
  3189,
  4881,
  6107,
  6290,
  6495,
  4513,
  6496,
  4692,
  4515,
  4723,
  5100,
  3356,
  6497,
  6291,
  3810,
  4080,
  5561,
  3570,
  4430,
  5980,
  6498,
  4355,
  5697,
  6499,
  4724,
  6108,
  6109,
  3764,
  4050,
  5038,
  5879,
  4093,
  3226,
  6292,
  5068,
  5217,
  4693,
  3342,
  5630,
  3504,
  4831,
  4377,
  4466,
  4309,
  5698,
  4431,
  5777,
  6293,
  5778,
  4272,
  3706,
  6110,
  5326,
  3752,
  4676,
  5327,
  4273,
  5403,
  4767,
  5631,
  6500,
  5699,
  5880,
  3475,
  5039,
  6294,
  5562,
  5125,
  4348,
  4301,
  4482,
  4068,
  5126,
  4593,
  5700,
  3380,
  3462,
  5981,
  5563,
  3824,
  5404,
  4970,
  5511,
  3825,
  4738,
  6295,
  6501,
  5452,
  4516,
  6111,
  5881,
  5564,
  6502,
  6296,
  5982,
  6503,
  4213,
  4163,
  3454,
  6504,
  6112,
  4009,
  4450,
  6113,
  4658,
  6297,
  6114,
  3035,
  6505,
  6115,
  3995,
  4904,
  4739,
  4563,
  4942,
  4110,
  5040,
  3661,
  3928,
  5362,
  3674,
  6506,
  5292,
  3612,
  4791,
  5565,
  4149,
  5983,
  5328,
  5259,
  5021,
  4725,
  4577,
  4564,
  4517,
  4364,
  6298,
  5405,
  4578,
  5260,
  4594,
  4156,
  4157,
  5453,
  3592,
  3491,
  6507,
  5127,
  5512,
  4709,
  4922,
  5984,
  5701,
  4726,
  4289,
  6508,
  4015,
  6116,
  5128,
  4628,
  3424,
  4241,
  5779,
  6299,
  4905,
  6509,
  6510,
  5454,
  5702,
  5780,
  6300,
  4365,
  4923,
  3971,
  6511,
  5161,
  3270,
  3158,
  5985,
  4100,
  867,
  5129,
  5703,
  6117,
  5363,
  3695,
  3301,
  5513,
  4467,
  6118,
  6512,
  5455,
  4232,
  4242,
  4629,
  6513,
  3959,
  4478,
  6514,
  5514,
  5329,
  5986,
  4850,
  5162,
  5566,
  3846,
  4694,
  6119,
  5456,
  4869,
  5781,
  3779,
  6301,
  5704,
  5987,
  5515,
  4710,
  6302,
  5882,
  6120,
  4392,
  5364,
  5705,
  6515,
  6121,
  6516,
  6517,
  3736,
  5988,
  5457,
  5989,
  4695,
  2457,
  5883,
  4551,
  5782,
  6303,
  6304,
  6305,
  5130,
  4971,
  6122,
  5163,
  6123,
  4870,
  3263,
  5365,
  3150,
  4871,
  6518,
  6306,
  5783,
  5069,
  5706,
  3513,
  3498,
  4409,
  5330,
  5632,
  5366,
  5458,
  5459,
  3991,
  5990,
  4502,
  3324,
  5991,
  5784,
  3696,
  4518,
  5633,
  4119,
  6519,
  4630,
  5634,
  4417,
  5707,
  4832,
  5992,
  3418,
  6124,
  5993,
  5567,
  4768,
  5218,
  6520,
  4595,
  3458,
  5367,
  6125,
  5635,
  6126,
  4202,
  6521,
  4740,
  4924,
  6307,
  3981,
  4069,
  4385,
  6308,
  3883,
  2675,
  4051,
  3834,
  4302,
  4483,
  5568,
  5994,
  4972,
  4101,
  5368,
  6309,
  5164,
  5884,
  3922,
  6127,
  6522,
  6523,
  5261,
  5460,
  5187,
  4164,
  5219,
  3538,
  5516,
  4111,
  3524,
  5995,
  6310,
  6311,
  5369,
  3181,
  3386,
  2484,
  5188,
  3464,
  5569,
  3627,
  5708,
  6524,
  5406,
  5165,
  4677,
  4492,
  6312,
  4872,
  4851,
  5885,
  4468,
  5996,
  6313,
  5709,
  5710,
  6128,
  2470,
  5886,
  6314,
  5293,
  4882,
  5785,
  3325,
  5461,
  5101,
  6129,
  5711,
  5786,
  6525,
  4906,
  6526,
  6527,
  4418,
  5887,
  5712,
  4808,
  2907,
  3701,
  5713,
  5888,
  6528,
  3765,
  5636,
  5331,
  6529,
  6530,
  3593,
  5889,
  3637,
  4943,
  3692,
  5714,
  5787,
  4925,
  6315,
  6130,
  5462,
  4405,
  6131,
  6132,
  6316,
  5262,
  6531,
  6532,
  5715,
  3859,
  5716,
  5070,
  4696,
  5102,
  3929,
  5788,
  3987,
  4792,
  5997,
  6533,
  6534,
  3920,
  4809,
  5e3,
  5998,
  6535,
  2974,
  5370,
  6317,
  5189,
  5263,
  5717,
  3826,
  6536,
  3953,
  5001,
  4883,
  3190,
  5463,
  5890,
  4973,
  5999,
  4741,
  6133,
  6134,
  3607,
  5570,
  6e3,
  4711,
  3362,
  3630,
  4552,
  5041,
  6318,
  6001,
  2950,
  2953,
  5637,
  4646,
  5371,
  4944,
  6002,
  2044,
  4120,
  3429,
  6319,
  6537,
  5103,
  4833,
  6538,
  6539,
  4884,
  4647,
  3884,
  6003,
  6004,
  4758,
  3835,
  5220,
  5789,
  4565,
  5407,
  6540,
  6135,
  5294,
  4697,
  4852,
  6320,
  6321,
  3206,
  4907,
  6541,
  6322,
  4945,
  6542,
  6136,
  6543,
  6323,
  6005,
  4631,
  3519,
  6544,
  5891,
  6545,
  5464,
  3784,
  5221,
  6546,
  5571,
  4659,
  6547,
  6324,
  6137,
  5190,
  6548,
  3853,
  6549,
  4016,
  4834,
  3954,
  6138,
  5332,
  3827,
  4017,
  3210,
  3546,
  4469,
  5408,
  5718,
  3505,
  4648,
  5790,
  5131,
  5638,
  5791,
  5465,
  4727,
  4318,
  6325,
  6326,
  5792,
  4553,
  4010,
  4698,
  3439,
  4974,
  3638,
  4335,
  3085,
  6006,
  5104,
  5042,
  5166,
  5892,
  5572,
  6327,
  4356,
  4519,
  5222,
  5573,
  5333,
  5793,
  5043,
  6550,
  5639,
  5071,
  4503,
  6328,
  6139,
  6551,
  6140,
  3914,
  3901,
  5372,
  6007,
  5640,
  4728,
  4793,
  3976,
  3836,
  4885,
  6552,
  4127,
  6553,
  4451,
  4102,
  5002,
  6554,
  3686,
  5105,
  6555,
  5191,
  5072,
  5295,
  4611,
  5794,
  5296,
  6556,
  5893,
  5264,
  5894,
  4975,
  5466,
  5265,
  4699,
  4976,
  4370,
  4056,
  3492,
  5044,
  4886,
  6557,
  5795,
  4432,
  4769,
  4357,
  5467,
  3940,
  4660,
  4290,
  6141,
  4484,
  4770,
  4661,
  3992,
  6329,
  4025,
  4662,
  5022,
  4632,
  4835,
  4070,
  5297,
  4663,
  4596,
  5574,
  5132,
  5409,
  5895,
  6142,
  4504,
  5192,
  4664,
  5796,
  5896,
  3885,
  5575,
  5797,
  5023,
  4810,
  5798,
  3732,
  5223,
  4712,
  5298,
  4084,
  5334,
  5468,
  6143,
  4052,
  4053,
  4336,
  4977,
  4794,
  6558,
  5335,
  4908,
  5576,
  5224,
  4233,
  5024,
  4128,
  5469,
  5225,
  4873,
  6008,
  5045,
  4729,
  4742,
  4633,
  3675,
  4597,
  6559,
  5897,
  5133,
  5577,
  5003,
  5641,
  5719,
  6330,
  6560,
  3017,
  2382,
  3854,
  4406,
  4811,
  6331,
  4393,
  3964,
  4946,
  6561,
  2420,
  3722,
  6562,
  4926,
  4378,
  3247,
  1736,
  4442,
  6332,
  5134,
  6333,
  5226,
  3996,
  2918,
  5470,
  4319,
  4003,
  4598,
  4743,
  4744,
  4485,
  3785,
  3902,
  5167,
  5004,
  5373,
  4394,
  5898,
  6144,
  4874,
  1793,
  3997,
  6334,
  4085,
  4214,
  5106,
  5642,
  4909,
  5799,
  6009,
  4419,
  4189,
  3330,
  5899,
  4165,
  4420,
  5299,
  5720,
  5227,
  3347,
  6145,
  4081,
  6335,
  2876,
  3930,
  6146,
  3293,
  3786,
  3910,
  3998,
  5900,
  5300,
  5578,
  2840,
  6563,
  5901,
  5579,
  6147,
  3531,
  5374,
  6564,
  6565,
  5580,
  4759,
  5375,
  6566,
  6148,
  3559,
  5643,
  6336,
  6010,
  5517,
  6337,
  6338,
  5721,
  5902,
  3873,
  6011,
  6339,
  6567,
  5518,
  3868,
  3649,
  5722,
  6568,
  4771,
  4947,
  6569,
  6149,
  4812,
  6570,
  2853,
  5471,
  6340,
  6341,
  5644,
  4795,
  6342,
  6012,
  5723,
  6343,
  5724,
  6013,
  4349,
  6344,
  3160,
  6150,
  5193,
  4599,
  4514,
  4493,
  5168,
  4320,
  6345,
  4927,
  3666,
  4745,
  5169,
  5903,
  5005,
  4928,
  6346,
  5725,
  6014,
  4730,
  4203,
  5046,
  4948,
  3395,
  5170,
  6015,
  4150,
  6016,
  5726,
  5519,
  6347,
  5047,
  3550,
  6151,
  6348,
  4197,
  4310,
  5904,
  6571,
  5581,
  2965,
  6152,
  4978,
  3960,
  4291,
  5135,
  6572,
  5301,
  5727,
  4129,
  4026,
  5905,
  4853,
  5728,
  5472,
  6153,
  6349,
  4533,
  2700,
  4505,
  5336,
  4678,
  3583,
  5073,
  2994,
  4486,
  3043,
  4554,
  5520,
  6350,
  6017,
  5800,
  4487,
  6351,
  3931,
  4103,
  5376,
  6352,
  4011,
  4321,
  4311,
  4190,
  5136,
  6018,
  3988,
  3233,
  4350,
  5906,
  5645,
  4198,
  6573,
  5107,
  3432,
  4191,
  3435,
  5582,
  6574,
  4139,
  5410,
  6353,
  5411,
  3944,
  5583,
  5074,
  3198,
  6575,
  6354,
  4358,
  6576,
  5302,
  4600,
  5584,
  5194,
  5412,
  6577,
  6578,
  5585,
  5413,
  5303,
  4248,
  5414,
  3879,
  4433,
  6579,
  4479,
  5025,
  4854,
  5415,
  6355,
  4760,
  4772,
  3683,
  2978,
  4700,
  3797,
  4452,
  3965,
  3932,
  3721,
  4910,
  5801,
  6580,
  5195,
  3551,
  5907,
  3221,
  3471,
  3029,
  6019,
  3999,
  5908,
  5909,
  5266,
  5267,
  3444,
  3023,
  3828,
  3170,
  4796,
  5646,
  4979,
  4259,
  6356,
  5647,
  5337,
  3694,
  6357,
  5648,
  5338,
  4520,
  4322,
  5802,
  3031,
  3759,
  4071,
  6020,
  5586,
  4836,
  4386,
  5048,
  6581,
  3571,
  4679,
  4174,
  4949,
  6154,
  4813,
  3787,
  3402,
  3822,
  3958,
  3215,
  3552,
  5268,
  4387,
  3933,
  4950,
  4359,
  6021,
  5910,
  5075,
  3579,
  6358,
  4234,
  4566,
  5521,
  6359,
  3613,
  5049,
  6022,
  5911,
  3375,
  3702,
  3178,
  4911,
  5339,
  4521,
  6582,
  6583,
  4395,
  3087,
  3811,
  5377,
  6023,
  6360,
  6155,
  4027,
  5171,
  5649,
  4421,
  4249,
  2804,
  6584,
  2270,
  6585,
  4e3,
  4235,
  3045,
  6156,
  5137,
  5729,
  4140,
  4312,
  3886,
  6361,
  4330,
  6157,
  4215,
  6158,
  3500,
  3676,
  4929,
  4331,
  3713,
  4930,
  5912,
  4265,
  3776,
  3368,
  5587,
  4470,
  4855,
  3038,
  4980,
  3631,
  6159,
  6160,
  4132,
  4680,
  6161,
  6362,
  3923,
  4379,
  5588,
  4255,
  6586,
  4121,
  6587,
  6363,
  4649,
  6364,
  3288,
  4773,
  4774,
  6162,
  6024,
  6365,
  3543,
  6588,
  4274,
  3107,
  3737,
  5050,
  5803,
  4797,
  4522,
  5589,
  5051,
  5730,
  3714,
  4887,
  5378,
  4001,
  4523,
  6163,
  5026,
  5522,
  4701,
  4175,
  2791,
  3760,
  6589,
  5473,
  4224,
  4133,
  3847,
  4814,
  4815,
  4775,
  3259,
  5416,
  6590,
  2738,
  6164,
  6025,
  5304,
  3733,
  5076,
  5650,
  4816,
  5590,
  6591,
  6165,
  6592,
  3934,
  5269,
  6593,
  3396,
  5340,
  6594,
  5804,
  3445,
  3602,
  4042,
  4488,
  5731,
  5732,
  3525,
  5591,
  4601,
  5196,
  6166,
  6026,
  5172,
  3642,
  4612,
  3202,
  4506,
  4798,
  6366,
  3818,
  5108,
  4303,
  5138,
  5139,
  4776,
  3332,
  4304,
  2915,
  3415,
  4434,
  5077,
  5109,
  4856,
  2879,
  5305,
  4817,
  6595,
  5913,
  3104,
  3144,
  3903,
  4634,
  5341,
  3133,
  5110,
  5651,
  5805,
  6167,
  4057,
  5592,
  2945,
  4371,
  5593,
  6596,
  3474,
  4182,
  6367,
  6597,
  6168,
  4507,
  4279,
  6598,
  2822,
  6599,
  4777,
  4713,
  5594,
  3829,
  6169,
  3887,
  5417,
  6170,
  3653,
  5474,
  6368,
  4216,
  2971,
  5228,
  3790,
  4579,
  6369,
  5733,
  6600,
  6601,
  4951,
  4746,
  4555,
  6602,
  5418,
  5475,
  6027,
  3400,
  4665,
  5806,
  6171,
  4799,
  6028,
  5052,
  6172,
  3343,
  4800,
  4747,
  5006,
  6370,
  4556,
  4217,
  5476,
  4396,
  5229,
  5379,
  5477,
  3839,
  5914,
  5652,
  5807,
  4714,
  3068,
  4635,
  5808,
  6173,
  5342,
  4192,
  5078,
  5419,
  5523,
  5734,
  6174,
  4557,
  6175,
  4602,
  6371,
  6176,
  6603,
  5809,
  6372,
  5735,
  4260,
  3869,
  5111,
  5230,
  6029,
  5112,
  6177,
  3126,
  4681,
  5524,
  5915,
  2706,
  3563,
  4748,
  3130,
  6178,
  4018,
  5525,
  6604,
  6605,
  5478,
  4012,
  4837,
  6606,
  4534,
  4193,
  5810,
  4857,
  3615,
  5479,
  6030,
  4082,
  3697,
  3539,
  4086,
  5270,
  3662,
  4508,
  4931,
  5916,
  4912,
  5811,
  5027,
  3888,
  6607,
  4397,
  3527,
  3302,
  3798,
  2775,
  2921,
  2637,
  3966,
  4122,
  4388,
  4028,
  4054,
  1633,
  4858,
  5079,
  3024,
  5007,
  3982,
  3412,
  5736,
  6608,
  3426,
  3236,
  5595,
  3030,
  6179,
  3427,
  3336,
  3279,
  3110,
  6373,
  3874,
  3039,
  5080,
  5917,
  5140,
  4489,
  3119,
  6374,
  5812,
  3405,
  4494,
  6031,
  4666,
  4141,
  6180,
  4166,
  6032,
  5813,
  4981,
  6609,
  5081,
  4422,
  4982,
  4112,
  3915,
  5653,
  3296,
  3983,
  6375,
  4266,
  4410,
  5654,
  6610,
  6181,
  3436,
  5082,
  6611,
  5380,
  6033,
  3819,
  5596,
  4535,
  5231,
  5306,
  5113,
  6612,
  4952,
  5918,
  4275,
  3113,
  6613,
  6376,
  6182,
  6183,
  5814,
  3073,
  4731,
  4838,
  5008,
  3831,
  6614,
  4888,
  3090,
  3848,
  4280,
  5526,
  5232,
  3014,
  5655,
  5009,
  5737,
  5420,
  5527,
  6615,
  5815,
  5343,
  5173,
  5381,
  4818,
  6616,
  3151,
  4953,
  6617,
  5738,
  2796,
  3204,
  4360,
  2989,
  4281,
  5739,
  5174,
  5421,
  5197,
  3132,
  5141,
  3849,
  5142,
  5528,
  5083,
  3799,
  3904,
  4839,
  5480,
  2880,
  4495,
  3448,
  6377,
  6184,
  5271,
  5919,
  3771,
  3193,
  6034,
  6035,
  5920,
  5010,
  6036,
  5597,
  6037,
  6378,
  6038,
  3106,
  5422,
  6618,
  5423,
  5424,
  4142,
  6619,
  4889,
  5084,
  4890,
  4313,
  5740,
  6620,
  3437,
  5175,
  5307,
  5816,
  4199,
  5198,
  5529,
  5817,
  5199,
  5656,
  4913,
  5028,
  5344,
  3850,
  6185,
  2955,
  5272,
  5011,
  5818,
  4567,
  4580,
  5029,
  5921,
  3616,
  5233,
  6621,
  6622,
  6186,
  4176,
  6039,
  6379,
  6380,
  3352,
  5200,
  5273,
  2908,
  5598,
  5234,
  3837,
  5308,
  6623,
  6624,
  5819,
  4496,
  4323,
  5309,
  5201,
  6625,
  6626,
  4983,
  3194,
  3838,
  4167,
  5530,
  5922,
  5274,
  6381,
  6382,
  3860,
  3861,
  5599,
  3333,
  4292,
  4509,
  6383,
  3553,
  5481,
  5820,
  5531,
  4778,
  6187,
  3955,
  3956,
  4324,
  4389,
  4218,
  3945,
  4325,
  3397,
  2681,
  5923,
  4779,
  5085,
  4019,
  5482,
  4891,
  5382,
  5383,
  6040,
  4682,
  3425,
  5275,
  4094,
  6627,
  5310,
  3015,
  5483,
  5657,
  4398,
  5924,
  3168,
  4819,
  6628,
  5925,
  6629,
  5532,
  4932,
  4613,
  6041,
  6630,
  4636,
  6384,
  4780,
  4204,
  5658,
  4423,
  5821,
  3989,
  4683,
  5822,
  6385,
  4954,
  6631,
  5345,
  6188,
  5425,
  5012,
  5384,
  3894,
  6386,
  4490,
  4104,
  6632,
  5741,
  5053,
  6633,
  5823,
  5926,
  5659,
  5660,
  5927,
  6634,
  5235,
  5742,
  5824,
  4840,
  4933,
  4820,
  6387,
  4859,
  5928,
  4955,
  6388,
  4143,
  3584,
  5825,
  5346,
  5013,
  6635,
  5661,
  6389,
  5014,
  5484,
  5743,
  4337,
  5176,
  5662,
  6390,
  2836,
  6391,
  3268,
  6392,
  6636,
  6042,
  5236,
  6637,
  4158,
  6638,
  5744,
  5663,
  4471,
  5347,
  3663,
  4123,
  5143,
  4293,
  3895,
  6639,
  6640,
  5311,
  5929,
  5826,
  3800,
  6189,
  6393,
  6190,
  5664,
  5348,
  3554,
  3594,
  4749,
  4603,
  6641,
  5385,
  4801,
  6043,
  5827,
  4183,
  6642,
  5312,
  5426,
  4761,
  6394,
  5665,
  6191,
  4715,
  2669,
  6643,
  6644,
  5533,
  3185,
  5427,
  5086,
  5930,
  5931,
  5386,
  6192,
  6044,
  6645,
  4781,
  4013,
  5745,
  4282,
  4435,
  5534,
  4390,
  4267,
  6045,
  5746,
  4984,
  6046,
  2743,
  6193,
  3501,
  4087,
  5485,
  5932,
  5428,
  4184,
  4095,
  5747,
  4061,
  5054,
  3058,
  3862,
  5933,
  5600,
  6646,
  5144,
  3618,
  6395,
  3131,
  5055,
  5313,
  6396,
  4650,
  4956,
  3855,
  6194,
  3896,
  5202,
  4985,
  4029,
  4225,
  6195,
  6647,
  5828,
  5486,
  5829,
  3589,
  3002,
  6648,
  6397,
  4782,
  5276,
  6649,
  6196,
  6650,
  4105,
  3803,
  4043,
  5237,
  5830,
  6398,
  4096,
  3643,
  6399,
  3528,
  6651,
  4453,
  3315,
  4637,
  6652,
  3984,
  6197,
  5535,
  3182,
  3339,
  6653,
  3096,
  2660,
  6400,
  6654,
  3449,
  5934,
  4250,
  4236,
  6047,
  6401,
  5831,
  6655,
  5487,
  3753,
  4062,
  5832,
  6198,
  6199,
  6656,
  3766,
  6657,
  3403,
  4667,
  6048,
  6658,
  4338,
  2897,
  5833,
  3880,
  2797,
  3780,
  4326,
  6659,
  5748,
  5015,
  6660,
  5387,
  4351,
  5601,
  4411,
  6661,
  3654,
  4424,
  5935,
  4339,
  4072,
  5277,
  4568,
  5536,
  6402,
  6662,
  5238,
  6663,
  5349,
  5203,
  6200,
  5204,
  6201,
  5145,
  4536,
  5016,
  5056,
  4762,
  5834,
  4399,
  4957,
  6202,
  6403,
  5666,
  5749,
  6664,
  4340,
  6665,
  5936,
  5177,
  5667,
  6666,
  6667,
  3459,
  4668,
  6404,
  6668,
  6669,
  4543,
  6203,
  6670,
  4276,
  6405,
  4480,
  5537,
  6671,
  4614,
  5205,
  5668,
  6672,
  3348,
  2193,
  4763,
  6406,
  6204,
  5937,
  5602,
  4177,
  5669,
  3419,
  6673,
  4020,
  6205,
  4443,
  4569,
  5388,
  3715,
  3639,
  6407,
  6049,
  4058,
  6206,
  6674,
  5938,
  4544,
  6050,
  4185,
  4294,
  4841,
  4651,
  4615,
  5488,
  6207,
  6408,
  6051,
  5178,
  3241,
  3509,
  5835,
  6208,
  4958,
  5836,
  4341,
  5489,
  5278,
  6209,
  2823,
  5538,
  5350,
  5206,
  5429,
  6675,
  4638,
  4875,
  4073,
  3516,
  4684,
  4914,
  4860,
  5939,
  5603,
  5389,
  6052,
  5057,
  3237,
  5490,
  3791,
  6676,
  6409,
  6677,
  4821,
  4915,
  4106,
  5351,
  5058,
  4243,
  5539,
  4244,
  5604,
  4842,
  4916,
  5239,
  3028,
  3716,
  5837,
  5114,
  5605,
  5390,
  5940,
  5430,
  6210,
  4332,
  6678,
  5540,
  4732,
  3667,
  3840,
  6053,
  4305,
  3408,
  5670,
  5541,
  6410,
  2744,
  5240,
  5750,
  6679,
  3234,
  5606,
  6680,
  5607,
  5671,
  3608,
  4283,
  4159,
  4400,
  5352,
  4783,
  6681,
  6411,
  6682,
  4491,
  4802,
  6211,
  6412,
  5941,
  6413,
  6414,
  5542,
  5751,
  6683,
  4669,
  3734,
  5942,
  6684,
  6415,
  5943,
  5059,
  3328,
  4670,
  4144,
  4268,
  6685,
  6686,
  6687,
  6688,
  4372,
  3603,
  6689,
  5944,
  5491,
  4373,
  3440,
  6416,
  5543,
  4784,
  4822,
  5608,
  3792,
  4616,
  5838,
  5672,
  3514,
  5391,
  6417,
  4892,
  6690,
  4639,
  6691,
  6054,
  5673,
  5839,
  6055,
  6692,
  6056,
  5392,
  6212,
  4038,
  5544,
  5674,
  4497,
  6057,
  6693,
  5840,
  4284,
  5675,
  4021,
  4545,
  5609,
  6418,
  4454,
  6419,
  6213,
  4113,
  4472,
  5314,
  3738,
  5087,
  5279,
  4074,
  5610,
  4959,
  4063,
  3179,
  4750,
  6058,
  6420,
  6214,
  3476,
  4498,
  4716,
  5431,
  4960,
  4685,
  6215,
  5241,
  6694,
  6421,
  6216,
  6695,
  5841,
  5945,
  6422,
  3748,
  5946,
  5179,
  3905,
  5752,
  5545,
  5947,
  4374,
  6217,
  4455,
  6423,
  4412,
  6218,
  4803,
  5353,
  6696,
  3832,
  5280,
  6219,
  4327,
  4702,
  6220,
  6221,
  6059,
  4652,
  5432,
  6424,
  3749,
  4751,
  6425,
  5753,
  4986,
  5393,
  4917,
  5948,
  5030,
  5754,
  4861,
  4733,
  6426,
  4703,
  6697,
  6222,
  4671,
  5949,
  4546,
  4961,
  5180,
  6223,
  5031,
  3316,
  5281,
  6698,
  4862,
  4295,
  4934,
  5207,
  3644,
  6427,
  5842,
  5950,
  6428,
  6429,
  4570,
  5843,
  5282,
  6430,
  6224,
  5088,
  3239,
  6060,
  6699,
  5844,
  5755,
  6061,
  6431,
  2701,
  5546,
  6432,
  5115,
  5676,
  4039,
  3993,
  3327,
  4752,
  4425,
  5315,
  6433,
  3941,
  6434,
  5677,
  4617,
  4604,
  3074,
  4581,
  6225,
  5433,
  6435,
  6226,
  6062,
  4823,
  5756,
  5116,
  6227,
  3717,
  5678,
  4717,
  5845,
  6436,
  5679,
  5846,
  6063,
  5847,
  6064,
  3977,
  3354,
  6437,
  3863,
  5117,
  6228,
  5547,
  5394,
  4499,
  4524,
  6229,
  4605,
  6230,
  4306,
  4500,
  6700,
  5951,
  6065,
  3693,
  5952,
  5089,
  4366,
  4918,
  6701,
  6231,
  5548,
  6232,
  6702,
  6438,
  4704,
  5434,
  6703,
  6704,
  5953,
  4168,
  6705,
  5680,
  3420,
  6706,
  5242,
  4407,
  6066,
  3812,
  5757,
  5090,
  5954,
  4672,
  4525,
  3481,
  5681,
  4618,
  5395,
  5354,
  5316,
  5955,
  6439,
  4962,
  6707,
  4526,
  6440,
  3465,
  4673,
  6067,
  6441,
  5682,
  6708,
  5435,
  5492,
  5758,
  5683,
  4619,
  4571,
  4674,
  4804,
  4893,
  4686,
  5493,
  4753,
  6233,
  6068,
  4269,
  6442,
  6234,
  5032,
  4705,
  5146,
  5243,
  5208,
  5848,
  6235,
  6443,
  4963,
  5033,
  4640,
  4226,
  6236,
  5849,
  3387,
  6444,
  6445,
  4436,
  4437,
  5850,
  4843,
  5494,
  4785,
  4894,
  6709,
  4361,
  6710,
  5091,
  5956,
  3331,
  6237,
  4987,
  5549,
  6069,
  6711,
  4342,
  3517,
  4473,
  5317,
  6070,
  6712,
  6071,
  4706,
  6446,
  5017,
  5355,
  6713,
  6714,
  4988,
  5436,
  6447,
  4734,
  5759,
  6715,
  4735,
  4547,
  4456,
  4754,
  6448,
  5851,
  6449,
  6450,
  3547,
  5852,
  5318,
  6451,
  6452,
  5092,
  4205,
  6716,
  6238,
  4620,
  4219,
  5611,
  6239,
  6072,
  4481,
  5760,
  5957,
  5958,
  4059,
  6240,
  6453,
  4227,
  4537,
  6241,
  5761,
  4030,
  4186,
  5244,
  5209,
  3761,
  4457,
  4876,
  3337,
  5495,
  5181,
  6242,
  5959,
  5319,
  5612,
  5684,
  5853,
  3493,
  5854,
  6073,
  4169,
  5613,
  5147,
  4895,
  6074,
  5210,
  6717,
  5182,
  6718,
  3830,
  6243,
  2798,
  3841,
  6075,
  6244,
  5855,
  5614,
  3604,
  4606,
  5496,
  5685,
  5118,
  5356,
  6719,
  6454,
  5960,
  5357,
  5961,
  6720,
  4145,
  3935,
  4621,
  5119,
  5962,
  4261,
  6721,
  6455,
  4786,
  5963,
  4375,
  4582,
  6245,
  6246,
  6247,
  6076,
  5437,
  4877,
  5856,
  3376,
  4380,
  6248,
  4160,
  6722,
  5148,
  6456,
  5211,
  6457,
  6723,
  4718,
  6458,
  6724,
  6249,
  5358,
  4044,
  3297,
  6459,
  6250,
  5857,
  5615,
  5497,
  5245,
  6460,
  5498,
  6725,
  6251,
  6252,
  5550,
  3793,
  5499,
  2959,
  5396,
  6461,
  6462,
  4572,
  5093,
  5500,
  5964,
  3806,
  4146,
  6463,
  4426,
  5762,
  5858,
  6077,
  6253,
  4755,
  3967,
  4220,
  5965,
  6254,
  4989,
  5501,
  6464,
  4352,
  6726,
  6078,
  4764,
  2290,
  5246,
  3906,
  5438,
  5283,
  3767,
  4964,
  2861,
  5763,
  5094,
  6255,
  6256,
  4622,
  5616,
  5859,
  5860,
  4707,
  6727,
  4285,
  4708,
  4824,
  5617,
  6257,
  5551,
  4787,
  5212,
  4965,
  4935,
  4687,
  6465,
  6728,
  6466,
  5686,
  6079,
  3494,
  4413,
  2995,
  5247,
  5966,
  5618,
  6729,
  5967,
  5764,
  5765,
  5687,
  5502,
  6730,
  6731,
  6080,
  5397,
  6467,
  4990,
  6258,
  6732,
  4538,
  5060,
  5619,
  6733,
  4719,
  5688,
  5439,
  5018,
  5149,
  5284,
  5503,
  6734,
  6081,
  4607,
  6259,
  5120,
  3645,
  5861,
  4583,
  6260,
  4584,
  4675,
  5620,
  4098,
  5440,
  6261,
  4863,
  2379,
  3306,
  4585,
  5552,
  5689,
  4586,
  5285,
  6735,
  4864,
  6736,
  5286,
  6082,
  6737,
  4623,
  3010,
  4788,
  4381,
  4558,
  5621,
  4587,
  4896,
  3698,
  3161,
  5248,
  4353,
  4045,
  6262,
  3754,
  5183,
  4588,
  6738,
  6263,
  6739,
  6740,
  5622,
  3936,
  6741,
  6468,
  6742,
  6264,
  5095,
  6469,
  4991,
  5968,
  6743,
  4992,
  6744,
  6083,
  4897,
  6745,
  4256,
  5766,
  4307,
  3108,
  3968,
  4444,
  5287,
  3889,
  4343,
  6084,
  4510,
  6085,
  4559,
  6086,
  4898,
  5969,
  6746,
  5623,
  5061,
  4919,
  5249,
  5250,
  5504,
  5441,
  6265,
  5320,
  4878,
  3242,
  5862,
  5251,
  3428,
  6087,
  6747,
  4237,
  5624,
  5442,
  6266,
  5553,
  4539,
  6748,
  2585,
  3533,
  5398,
  4262,
  6088,
  5150,
  4736,
  4438,
  6089,
  6267,
  5505,
  4966,
  6749,
  6268,
  6750,
  6269,
  5288,
  5554,
  3650,
  6090,
  6091,
  4624,
  6092,
  5690,
  6751,
  5863,
  4270,
  5691,
  4277,
  5555,
  5864,
  6752,
  5692,
  4720,
  4865,
  6470,
  5151,
  4688,
  4825,
  6753,
  3094,
  6754,
  6471,
  3235,
  4653,
  6755,
  5213,
  5399,
  6756,
  3201,
  4589,
  5865,
  4967,
  6472,
  5866,
  6473,
  5019,
  3016,
  6757,
  5321,
  4756,
  3957,
  4573,
  6093,
  4993,
  5767,
  4721,
  6474,
  6758,
  5625,
  6759,
  4458,
  6475,
  6270,
  6760,
  5556,
  4994,
  5214,
  5252,
  6271,
  3875,
  5768,
  6094,
  5034,
  5506,
  4376,
  5769,
  6761,
  2120,
  6476,
  5253,
  5770,
  6762,
  5771,
  5970,
  3990,
  5971,
  5557,
  5558,
  5772,
  6477,
  6095,
  2787,
  4641,
  5972,
  5121,
  6096,
  6097,
  6272,
  6763,
  3703,
  5867,
  5507,
  6273,
  4206,
  6274,
  4789,
  6098,
  6764,
  3619,
  3646,
  3833,
  3804,
  2394,
  3788,
  4936,
  3978,
  4866,
  4899,
  6099,
  6100,
  5559,
  6478,
  6765,
  3599,
  5868,
  6101,
  5869,
  5870,
  6275,
  6766,
  4527,
  6767
];
var ze = {};
ze.BIG5_TYPICAL_DISTRIBUTION_RATIO = 0.75;
ze.BIG5_TABLE_SIZE = 5376;
ze.Big5CharToFreqOrder = [
  1,
  1801,
  1506,
  255,
  1431,
  198,
  9,
  82,
  6,
  5008,
  177,
  202,
  3681,
  1256,
  2821,
  110,
  //   16
  3814,
  33,
  3274,
  261,
  76,
  44,
  2114,
  16,
  2946,
  2187,
  1176,
  659,
  3971,
  26,
  3451,
  2653,
  //   32
  1198,
  3972,
  3350,
  4202,
  410,
  2215,
  302,
  590,
  361,
  1964,
  8,
  204,
  58,
  4510,
  5009,
  1932,
  //   48
  63,
  5010,
  5011,
  317,
  1614,
  75,
  222,
  159,
  4203,
  2417,
  1480,
  5012,
  3555,
  3091,
  224,
  2822,
  //   64
  3682,
  3,
  10,
  3973,
  1471,
  29,
  2787,
  1135,
  2866,
  1940,
  873,
  130,
  3275,
  1123,
  312,
  5013,
  //   80
  4511,
  2052,
  507,
  252,
  682,
  5014,
  142,
  1915,
  124,
  206,
  2947,
  34,
  3556,
  3204,
  64,
  604,
  //   96
  5015,
  2501,
  1977,
  1978,
  155,
  1991,
  645,
  641,
  1606,
  5016,
  3452,
  337,
  72,
  406,
  5017,
  80,
  //  112
  630,
  238,
  3205,
  1509,
  263,
  939,
  1092,
  2654,
  756,
  1440,
  1094,
  3453,
  449,
  69,
  2987,
  591,
  //  128
  179,
  2096,
  471,
  115,
  2035,
  1844,
  60,
  50,
  2988,
  134,
  806,
  1869,
  734,
  2036,
  3454,
  180,
  //  144
  995,
  1607,
  156,
  537,
  2907,
  688,
  5018,
  319,
  1305,
  779,
  2145,
  514,
  2379,
  298,
  4512,
  359,
  //  160
  2502,
  90,
  2716,
  1338,
  663,
  11,
  906,
  1099,
  2553,
  20,
  2441,
  182,
  532,
  1716,
  5019,
  732,
  //  176
  1376,
  4204,
  1311,
  1420,
  3206,
  25,
  2317,
  1056,
  113,
  399,
  382,
  1950,
  242,
  3455,
  2474,
  529,
  //  192
  3276,
  475,
  1447,
  3683,
  5020,
  117,
  21,
  656,
  810,
  1297,
  2300,
  2334,
  3557,
  5021,
  126,
  4205,
  //  208
  706,
  456,
  150,
  613,
  4513,
  71,
  1118,
  2037,
  4206,
  145,
  3092,
  85,
  835,
  486,
  2115,
  1246,
  //  224
  1426,
  428,
  727,
  1285,
  1015,
  800,
  106,
  623,
  303,
  1281,
  5022,
  2128,
  2359,
  347,
  3815,
  221,
  //  240
  3558,
  3135,
  5023,
  1956,
  1153,
  4207,
  83,
  296,
  1199,
  3093,
  192,
  624,
  93,
  5024,
  822,
  1898,
  //  256
  2823,
  3136,
  795,
  2065,
  991,
  1554,
  1542,
  1592,
  27,
  43,
  2867,
  859,
  139,
  1456,
  860,
  4514,
  //  272
  437,
  712,
  3974,
  164,
  2397,
  3137,
  695,
  211,
  3037,
  2097,
  195,
  3975,
  1608,
  3559,
  3560,
  3684,
  //  288
  3976,
  234,
  811,
  2989,
  2098,
  3977,
  2233,
  1441,
  3561,
  1615,
  2380,
  668,
  2077,
  1638,
  305,
  228,
  //  304
  1664,
  4515,
  467,
  415,
  5025,
  262,
  2099,
  1593,
  239,
  108,
  300,
  200,
  1033,
  512,
  1247,
  2078,
  //  320
  5026,
  5027,
  2176,
  3207,
  3685,
  2682,
  593,
  845,
  1062,
  3277,
  88,
  1723,
  2038,
  3978,
  1951,
  212,
  //  336
  266,
  152,
  149,
  468,
  1899,
  4208,
  4516,
  77,
  187,
  5028,
  3038,
  37,
  5,
  2990,
  5029,
  3979,
  //  352
  5030,
  5031,
  39,
  2524,
  4517,
  2908,
  3208,
  2079,
  55,
  148,
  74,
  4518,
  545,
  483,
  1474,
  1029,
  //  368
  1665,
  217,
  1870,
  1531,
  3138,
  1104,
  2655,
  4209,
  24,
  172,
  3562,
  900,
  3980,
  3563,
  3564,
  4519,
  //  384
  32,
  1408,
  2824,
  1312,
  329,
  487,
  2360,
  2251,
  2717,
  784,
  2683,
  4,
  3039,
  3351,
  1427,
  1789,
  //  400
  188,
  109,
  499,
  5032,
  3686,
  1717,
  1790,
  888,
  1217,
  3040,
  4520,
  5033,
  3565,
  5034,
  3352,
  1520,
  //  416
  3687,
  3981,
  196,
  1034,
  775,
  5035,
  5036,
  929,
  1816,
  249,
  439,
  38,
  5037,
  1063,
  5038,
  794,
  //  432
  3982,
  1435,
  2301,
  46,
  178,
  3278,
  2066,
  5039,
  2381,
  5040,
  214,
  1709,
  4521,
  804,
  35,
  707,
  //  448
  324,
  3688,
  1601,
  2554,
  140,
  459,
  4210,
  5041,
  5042,
  1365,
  839,
  272,
  978,
  2262,
  2580,
  3456,
  //  464
  2129,
  1363,
  3689,
  1423,
  697,
  100,
  3094,
  48,
  70,
  1231,
  495,
  3139,
  2196,
  5043,
  1294,
  5044,
  //  480
  2080,
  462,
  586,
  1042,
  3279,
  853,
  256,
  988,
  185,
  2382,
  3457,
  1698,
  434,
  1084,
  5045,
  3458,
  //  496
  314,
  2625,
  2788,
  4522,
  2335,
  2336,
  569,
  2285,
  637,
  1817,
  2525,
  757,
  1162,
  1879,
  1616,
  3459,
  //  512
  287,
  1577,
  2116,
  768,
  4523,
  1671,
  2868,
  3566,
  2526,
  1321,
  3816,
  909,
  2418,
  5046,
  4211,
  933,
  //  528
  3817,
  4212,
  2053,
  2361,
  1222,
  4524,
  765,
  2419,
  1322,
  786,
  4525,
  5047,
  1920,
  1462,
  1677,
  2909,
  //  544
  1699,
  5048,
  4526,
  1424,
  2442,
  3140,
  3690,
  2600,
  3353,
  1775,
  1941,
  3460,
  3983,
  4213,
  309,
  1369,
  //  560
  1130,
  2825,
  364,
  2234,
  1653,
  1299,
  3984,
  3567,
  3985,
  3986,
  2656,
  525,
  1085,
  3041,
  902,
  2001,
  //  576
  1475,
  964,
  4527,
  421,
  1845,
  1415,
  1057,
  2286,
  940,
  1364,
  3141,
  376,
  4528,
  4529,
  1381,
  7,
  //  592
  2527,
  983,
  2383,
  336,
  1710,
  2684,
  1846,
  321,
  3461,
  559,
  1131,
  3042,
  2752,
  1809,
  1132,
  1313,
  //  608
  265,
  1481,
  1858,
  5049,
  352,
  1203,
  2826,
  3280,
  167,
  1089,
  420,
  2827,
  776,
  792,
  1724,
  3568,
  //  624
  4214,
  2443,
  3281,
  5050,
  4215,
  5051,
  446,
  229,
  333,
  2753,
  901,
  3818,
  1200,
  1557,
  4530,
  2657,
  //  640
  1921,
  395,
  2754,
  2685,
  3819,
  4216,
  1836,
  125,
  916,
  3209,
  2626,
  4531,
  5052,
  5053,
  3820,
  5054,
  //  656
  5055,
  5056,
  4532,
  3142,
  3691,
  1133,
  2555,
  1757,
  3462,
  1510,
  2318,
  1409,
  3569,
  5057,
  2146,
  438,
  //  672
  2601,
  2910,
  2384,
  3354,
  1068,
  958,
  3043,
  461,
  311,
  2869,
  2686,
  4217,
  1916,
  3210,
  4218,
  1979,
  //  688
  383,
  750,
  2755,
  2627,
  4219,
  274,
  539,
  385,
  1278,
  1442,
  5058,
  1154,
  1965,
  384,
  561,
  210,
  //  704
  98,
  1295,
  2556,
  3570,
  5059,
  1711,
  2420,
  1482,
  3463,
  3987,
  2911,
  1257,
  129,
  5060,
  3821,
  642,
  //  720
  523,
  2789,
  2790,
  2658,
  5061,
  141,
  2235,
  1333,
  68,
  176,
  441,
  876,
  907,
  4220,
  603,
  2602,
  //  736
  710,
  171,
  3464,
  404,
  549,
  18,
  3143,
  2398,
  1410,
  3692,
  1666,
  5062,
  3571,
  4533,
  2912,
  4534,
  //  752
  5063,
  2991,
  368,
  5064,
  146,
  366,
  99,
  871,
  3693,
  1543,
  748,
  807,
  1586,
  1185,
  22,
  2263,
  //  768
  379,
  3822,
  3211,
  5065,
  3212,
  505,
  1942,
  2628,
  1992,
  1382,
  2319,
  5066,
  380,
  2362,
  218,
  702,
  //  784
  1818,
  1248,
  3465,
  3044,
  3572,
  3355,
  3282,
  5067,
  2992,
  3694,
  930,
  3283,
  3823,
  5068,
  59,
  5069,
  //  800
  585,
  601,
  4221,
  497,
  3466,
  1112,
  1314,
  4535,
  1802,
  5070,
  1223,
  1472,
  2177,
  5071,
  749,
  1837,
  //  816
  690,
  1900,
  3824,
  1773,
  3988,
  1476,
  429,
  1043,
  1791,
  2236,
  2117,
  917,
  4222,
  447,
  1086,
  1629,
  //  832
  5072,
  556,
  5073,
  5074,
  2021,
  1654,
  844,
  1090,
  105,
  550,
  966,
  1758,
  2828,
  1008,
  1783,
  686,
  //  848
  1095,
  5075,
  2287,
  793,
  1602,
  5076,
  3573,
  2603,
  4536,
  4223,
  2948,
  2302,
  4537,
  3825,
  980,
  2503,
  //  864
  544,
  353,
  527,
  4538,
  908,
  2687,
  2913,
  5077,
  381,
  2629,
  1943,
  1348,
  5078,
  1341,
  1252,
  560,
  //  880
  3095,
  5079,
  3467,
  2870,
  5080,
  2054,
  973,
  886,
  2081,
  143,
  4539,
  5081,
  5082,
  157,
  3989,
  496,
  //  896
  4224,
  57,
  840,
  540,
  2039,
  4540,
  4541,
  3468,
  2118,
  1445,
  970,
  2264,
  1748,
  1966,
  2082,
  4225,
  //  912
  3144,
  1234,
  1776,
  3284,
  2829,
  3695,
  773,
  1206,
  2130,
  1066,
  2040,
  1326,
  3990,
  1738,
  1725,
  4226,
  //  928
  279,
  3145,
  51,
  1544,
  2604,
  423,
  1578,
  2131,
  2067,
  173,
  4542,
  1880,
  5083,
  5084,
  1583,
  264,
  //  944
  610,
  3696,
  4543,
  2444,
  280,
  154,
  5085,
  5086,
  5087,
  1739,
  338,
  1282,
  3096,
  693,
  2871,
  1411,
  //  960
  1074,
  3826,
  2445,
  5088,
  4544,
  5089,
  5090,
  1240,
  952,
  2399,
  5091,
  2914,
  1538,
  2688,
  685,
  1483,
  //  976
  4227,
  2475,
  1436,
  953,
  4228,
  2055,
  4545,
  671,
  2400,
  79,
  4229,
  2446,
  3285,
  608,
  567,
  2689,
  //  992
  3469,
  4230,
  4231,
  1691,
  393,
  1261,
  1792,
  2401,
  5092,
  4546,
  5093,
  5094,
  5095,
  5096,
  1383,
  1672,
  // 1008
  3827,
  3213,
  1464,
  522,
  1119,
  661,
  1150,
  216,
  675,
  4547,
  3991,
  1432,
  3574,
  609,
  4548,
  2690,
  // 1024
  2402,
  5097,
  5098,
  5099,
  4232,
  3045,
  0,
  5100,
  2476,
  315,
  231,
  2447,
  301,
  3356,
  4549,
  2385,
  // 1040
  5101,
  233,
  4233,
  3697,
  1819,
  4550,
  4551,
  5102,
  96,
  1777,
  1315,
  2083,
  5103,
  257,
  5104,
  1810,
  // 1056
  3698,
  2718,
  1139,
  1820,
  4234,
  2022,
  1124,
  2164,
  2791,
  1778,
  2659,
  5105,
  3097,
  363,
  1655,
  3214,
  // 1072
  5106,
  2993,
  5107,
  5108,
  5109,
  3992,
  1567,
  3993,
  718,
  103,
  3215,
  849,
  1443,
  341,
  3357,
  2949,
  // 1088
  1484,
  5110,
  1712,
  127,
  67,
  339,
  4235,
  2403,
  679,
  1412,
  821,
  5111,
  5112,
  834,
  738,
  351,
  // 1104
  2994,
  2147,
  846,
  235,
  1497,
  1881,
  418,
  1993,
  3828,
  2719,
  186,
  1100,
  2148,
  2756,
  3575,
  1545,
  // 1120
  1355,
  2950,
  2872,
  1377,
  583,
  3994,
  4236,
  2581,
  2995,
  5113,
  1298,
  3699,
  1078,
  2557,
  3700,
  2363,
  // 1136
  78,
  3829,
  3830,
  267,
  1289,
  2100,
  2002,
  1594,
  4237,
  348,
  369,
  1274,
  2197,
  2178,
  1838,
  4552,
  // 1152
  1821,
  2830,
  3701,
  2757,
  2288,
  2003,
  4553,
  2951,
  2758,
  144,
  3358,
  882,
  4554,
  3995,
  2759,
  3470,
  // 1168
  4555,
  2915,
  5114,
  4238,
  1726,
  320,
  5115,
  3996,
  3046,
  788,
  2996,
  5116,
  2831,
  1774,
  1327,
  2873,
  // 1184
  3997,
  2832,
  5117,
  1306,
  4556,
  2004,
  1700,
  3831,
  3576,
  2364,
  2660,
  787,
  2023,
  506,
  824,
  3702,
  // 1200
  534,
  323,
  4557,
  1044,
  3359,
  2024,
  1901,
  946,
  3471,
  5118,
  1779,
  1500,
  1678,
  5119,
  1882,
  4558,
  // 1216
  165,
  243,
  4559,
  3703,
  2528,
  123,
  683,
  4239,
  764,
  4560,
  36,
  3998,
  1793,
  589,
  2916,
  816,
  // 1232
  626,
  1667,
  3047,
  2237,
  1639,
  1555,
  1622,
  3832,
  3999,
  5120,
  4e3,
  2874,
  1370,
  1228,
  1933,
  891,
  // 1248
  2084,
  2917,
  304,
  4240,
  5121,
  292,
  2997,
  2720,
  3577,
  691,
  2101,
  4241,
  1115,
  4561,
  118,
  662,
  // 1264
  5122,
  611,
  1156,
  854,
  2386,
  1316,
  2875,
  2,
  386,
  515,
  2918,
  5123,
  5124,
  3286,
  868,
  2238,
  // 1280
  1486,
  855,
  2661,
  785,
  2216,
  3048,
  5125,
  1040,
  3216,
  3578,
  5126,
  3146,
  448,
  5127,
  1525,
  5128,
  // 1296
  2165,
  4562,
  5129,
  3833,
  5130,
  4242,
  2833,
  3579,
  3147,
  503,
  818,
  4001,
  3148,
  1568,
  814,
  676,
  // 1312
  1444,
  306,
  1749,
  5131,
  3834,
  1416,
  1030,
  197,
  1428,
  805,
  2834,
  1501,
  4563,
  5132,
  5133,
  5134,
  // 1328
  1994,
  5135,
  4564,
  5136,
  5137,
  2198,
  13,
  2792,
  3704,
  2998,
  3149,
  1229,
  1917,
  5138,
  3835,
  2132,
  // 1344
  5139,
  4243,
  4565,
  2404,
  3580,
  5140,
  2217,
  1511,
  1727,
  1120,
  5141,
  5142,
  646,
  3836,
  2448,
  307,
  // 1360
  5143,
  5144,
  1595,
  3217,
  5145,
  5146,
  5147,
  3705,
  1113,
  1356,
  4002,
  1465,
  2529,
  2530,
  5148,
  519,
  // 1376
  5149,
  128,
  2133,
  92,
  2289,
  1980,
  5150,
  4003,
  1512,
  342,
  3150,
  2199,
  5151,
  2793,
  2218,
  1981,
  // 1392
  3360,
  4244,
  290,
  1656,
  1317,
  789,
  827,
  2365,
  5152,
  3837,
  4566,
  562,
  581,
  4004,
  5153,
  401,
  // 1408
  4567,
  2252,
  94,
  4568,
  5154,
  1399,
  2794,
  5155,
  1463,
  2025,
  4569,
  3218,
  1944,
  5156,
  828,
  1105,
  // 1424
  4245,
  1262,
  1394,
  5157,
  4246,
  605,
  4570,
  5158,
  1784,
  2876,
  5159,
  2835,
  819,
  2102,
  578,
  2200,
  // 1440
  2952,
  5160,
  1502,
  436,
  3287,
  4247,
  3288,
  2836,
  4005,
  2919,
  3472,
  3473,
  5161,
  2721,
  2320,
  5162,
  // 1456
  5163,
  2337,
  2068,
  23,
  4571,
  193,
  826,
  3838,
  2103,
  699,
  1630,
  4248,
  3098,
  390,
  1794,
  1064,
  // 1472
  3581,
  5164,
  1579,
  3099,
  3100,
  1400,
  5165,
  4249,
  1839,
  1640,
  2877,
  5166,
  4572,
  4573,
  137,
  4250,
  // 1488
  598,
  3101,
  1967,
  780,
  104,
  974,
  2953,
  5167,
  278,
  899,
  253,
  402,
  572,
  504,
  493,
  1339,
  // 1504
  5168,
  4006,
  1275,
  4574,
  2582,
  2558,
  5169,
  3706,
  3049,
  3102,
  2253,
  565,
  1334,
  2722,
  863,
  41,
  // 1520
  5170,
  5171,
  4575,
  5172,
  1657,
  2338,
  19,
  463,
  2760,
  4251,
  606,
  5173,
  2999,
  3289,
  1087,
  2085,
  // 1536
  1323,
  2662,
  3e3,
  5174,
  1631,
  1623,
  1750,
  4252,
  2691,
  5175,
  2878,
  791,
  2723,
  2663,
  2339,
  232,
  // 1552
  2421,
  5176,
  3001,
  1498,
  5177,
  2664,
  2630,
  755,
  1366,
  3707,
  3290,
  3151,
  2026,
  1609,
  119,
  1918,
  // 1568
  3474,
  862,
  1026,
  4253,
  5178,
  4007,
  3839,
  4576,
  4008,
  4577,
  2265,
  1952,
  2477,
  5179,
  1125,
  817,
  // 1584
  4254,
  4255,
  4009,
  1513,
  1766,
  2041,
  1487,
  4256,
  3050,
  3291,
  2837,
  3840,
  3152,
  5180,
  5181,
  1507,
  // 1600
  5182,
  2692,
  733,
  40,
  1632,
  1106,
  2879,
  345,
  4257,
  841,
  2531,
  230,
  4578,
  3002,
  1847,
  3292,
  // 1616
  3475,
  5183,
  1263,
  986,
  3476,
  5184,
  735,
  879,
  254,
  1137,
  857,
  622,
  1300,
  1180,
  1388,
  1562,
  // 1632
  4010,
  4011,
  2954,
  967,
  2761,
  2665,
  1349,
  592,
  2134,
  1692,
  3361,
  3003,
  1995,
  4258,
  1679,
  4012,
  // 1648
  1902,
  2188,
  5185,
  739,
  3708,
  2724,
  1296,
  1290,
  5186,
  4259,
  2201,
  2202,
  1922,
  1563,
  2605,
  2559,
  // 1664
  1871,
  2762,
  3004,
  5187,
  435,
  5188,
  343,
  1108,
  596,
  17,
  1751,
  4579,
  2239,
  3477,
  3709,
  5189,
  // 1680
  4580,
  294,
  3582,
  2955,
  1693,
  477,
  979,
  281,
  2042,
  3583,
  643,
  2043,
  3710,
  2631,
  2795,
  2266,
  // 1696
  1031,
  2340,
  2135,
  2303,
  3584,
  4581,
  367,
  1249,
  2560,
  5190,
  3585,
  5191,
  4582,
  1283,
  3362,
  2005,
  // 1712
  240,
  1762,
  3363,
  4583,
  4584,
  836,
  1069,
  3153,
  474,
  5192,
  2149,
  2532,
  268,
  3586,
  5193,
  3219,
  // 1728
  1521,
  1284,
  5194,
  1658,
  1546,
  4260,
  5195,
  3587,
  3588,
  5196,
  4261,
  3364,
  2693,
  1685,
  4262,
  961,
  // 1744
  1673,
  2632,
  190,
  2006,
  2203,
  3841,
  4585,
  4586,
  5197,
  570,
  2504,
  3711,
  1490,
  5198,
  4587,
  2633,
  // 1760
  3293,
  1957,
  4588,
  584,
  1514,
  396,
  1045,
  1945,
  5199,
  4589,
  1968,
  2449,
  5200,
  5201,
  4590,
  4013,
  // 1776
  619,
  5202,
  3154,
  3294,
  215,
  2007,
  2796,
  2561,
  3220,
  4591,
  3221,
  4592,
  763,
  4263,
  3842,
  4593,
  // 1792
  5203,
  5204,
  1958,
  1767,
  2956,
  3365,
  3712,
  1174,
  452,
  1477,
  4594,
  3366,
  3155,
  5205,
  2838,
  1253,
  // 1808
  2387,
  2189,
  1091,
  2290,
  4264,
  492,
  5206,
  638,
  1169,
  1825,
  2136,
  1752,
  4014,
  648,
  926,
  1021,
  // 1824
  1324,
  4595,
  520,
  4596,
  997,
  847,
  1007,
  892,
  4597,
  3843,
  2267,
  1872,
  3713,
  2405,
  1785,
  4598,
  // 1840
  1953,
  2957,
  3103,
  3222,
  1728,
  4265,
  2044,
  3714,
  4599,
  2008,
  1701,
  3156,
  1551,
  30,
  2268,
  4266,
  // 1856
  5207,
  2027,
  4600,
  3589,
  5208,
  501,
  5209,
  4267,
  594,
  3478,
  2166,
  1822,
  3590,
  3479,
  3591,
  3223,
  // 1872
  829,
  2839,
  4268,
  5210,
  1680,
  3157,
  1225,
  4269,
  5211,
  3295,
  4601,
  4270,
  3158,
  2341,
  5212,
  4602,
  // 1888
  4271,
  5213,
  4015,
  4016,
  5214,
  1848,
  2388,
  2606,
  3367,
  5215,
  4603,
  374,
  4017,
  652,
  4272,
  4273,
  // 1904
  375,
  1140,
  798,
  5216,
  5217,
  5218,
  2366,
  4604,
  2269,
  546,
  1659,
  138,
  3051,
  2450,
  4605,
  5219,
  // 1920
  2254,
  612,
  1849,
  910,
  796,
  3844,
  1740,
  1371,
  825,
  3845,
  3846,
  5220,
  2920,
  2562,
  5221,
  692,
  // 1936
  444,
  3052,
  2634,
  801,
  4606,
  4274,
  5222,
  1491,
  244,
  1053,
  3053,
  4275,
  4276,
  340,
  5223,
  4018,
  // 1952
  1041,
  3005,
  293,
  1168,
  87,
  1357,
  5224,
  1539,
  959,
  5225,
  2240,
  721,
  694,
  4277,
  3847,
  219,
  // 1968
  1478,
  644,
  1417,
  3368,
  2666,
  1413,
  1401,
  1335,
  1389,
  4019,
  5226,
  5227,
  3006,
  2367,
  3159,
  1826,
  // 1984
  730,
  1515,
  184,
  2840,
  66,
  4607,
  5228,
  1660,
  2958,
  246,
  3369,
  378,
  1457,
  226,
  3480,
  975,
  // 2000
  4020,
  2959,
  1264,
  3592,
  674,
  696,
  5229,
  163,
  5230,
  1141,
  2422,
  2167,
  713,
  3593,
  3370,
  4608,
  // 2016
  4021,
  5231,
  5232,
  1186,
  15,
  5233,
  1079,
  1070,
  5234,
  1522,
  3224,
  3594,
  276,
  1050,
  2725,
  758,
  // 2032
  1126,
  653,
  2960,
  3296,
  5235,
  2342,
  889,
  3595,
  4022,
  3104,
  3007,
  903,
  1250,
  4609,
  4023,
  3481,
  // 2048
  3596,
  1342,
  1681,
  1718,
  766,
  3297,
  286,
  89,
  2961,
  3715,
  5236,
  1713,
  5237,
  2607,
  3371,
  3008,
  // 2064
  5238,
  2962,
  2219,
  3225,
  2880,
  5239,
  4610,
  2505,
  2533,
  181,
  387,
  1075,
  4024,
  731,
  2190,
  3372,
  // 2080
  5240,
  3298,
  310,
  313,
  3482,
  2304,
  770,
  4278,
  54,
  3054,
  189,
  4611,
  3105,
  3848,
  4025,
  5241,
  // 2096
  1230,
  1617,
  1850,
  355,
  3597,
  4279,
  4612,
  3373,
  111,
  4280,
  3716,
  1350,
  3160,
  3483,
  3055,
  4281,
  // 2112
  2150,
  3299,
  3598,
  5242,
  2797,
  4026,
  4027,
  3009,
  722,
  2009,
  5243,
  1071,
  247,
  1207,
  2343,
  2478,
  // 2128
  1378,
  4613,
  2010,
  864,
  1437,
  1214,
  4614,
  373,
  3849,
  1142,
  2220,
  667,
  4615,
  442,
  2763,
  2563,
  // 2144
  3850,
  4028,
  1969,
  4282,
  3300,
  1840,
  837,
  170,
  1107,
  934,
  1336,
  1883,
  5244,
  5245,
  2119,
  4283,
  // 2160
  2841,
  743,
  1569,
  5246,
  4616,
  4284,
  582,
  2389,
  1418,
  3484,
  5247,
  1803,
  5248,
  357,
  1395,
  1729,
  // 2176
  3717,
  3301,
  2423,
  1564,
  2241,
  5249,
  3106,
  3851,
  1633,
  4617,
  1114,
  2086,
  4285,
  1532,
  5250,
  482,
  // 2192
  2451,
  4618,
  5251,
  5252,
  1492,
  833,
  1466,
  5253,
  2726,
  3599,
  1641,
  2842,
  5254,
  1526,
  1272,
  3718,
  // 2208
  4286,
  1686,
  1795,
  416,
  2564,
  1903,
  1954,
  1804,
  5255,
  3852,
  2798,
  3853,
  1159,
  2321,
  5256,
  2881,
  // 2224
  4619,
  1610,
  1584,
  3056,
  2424,
  2764,
  443,
  3302,
  1163,
  3161,
  5257,
  5258,
  4029,
  5259,
  4287,
  2506,
  // 2240
  3057,
  4620,
  4030,
  3162,
  2104,
  1647,
  3600,
  2011,
  1873,
  4288,
  5260,
  4289,
  431,
  3485,
  5261,
  250,
  // 2256
  97,
  81,
  4290,
  5262,
  1648,
  1851,
  1558,
  160,
  848,
  5263,
  866,
  740,
  1694,
  5264,
  2204,
  2843,
  // 2272
  3226,
  4291,
  4621,
  3719,
  1687,
  950,
  2479,
  426,
  469,
  3227,
  3720,
  3721,
  4031,
  5265,
  5266,
  1188,
  // 2288
  424,
  1996,
  861,
  3601,
  4292,
  3854,
  2205,
  2694,
  168,
  1235,
  3602,
  4293,
  5267,
  2087,
  1674,
  4622,
  // 2304
  3374,
  3303,
  220,
  2565,
  1009,
  5268,
  3855,
  670,
  3010,
  332,
  1208,
  717,
  5269,
  5270,
  3603,
  2452,
  // 2320
  4032,
  3375,
  5271,
  513,
  5272,
  1209,
  2882,
  3376,
  3163,
  4623,
  1080,
  5273,
  5274,
  5275,
  5276,
  2534,
  // 2336
  3722,
  3604,
  815,
  1587,
  4033,
  4034,
  5277,
  3605,
  3486,
  3856,
  1254,
  4624,
  1328,
  3058,
  1390,
  4035,
  // 2352
  1741,
  4036,
  3857,
  4037,
  5278,
  236,
  3858,
  2453,
  3304,
  5279,
  5280,
  3723,
  3859,
  1273,
  3860,
  4625,
  // 2368
  5281,
  308,
  5282,
  4626,
  245,
  4627,
  1852,
  2480,
  1307,
  2583,
  430,
  715,
  2137,
  2454,
  5283,
  270,
  // 2384
  199,
  2883,
  4038,
  5284,
  3606,
  2727,
  1753,
  761,
  1754,
  725,
  1661,
  1841,
  4628,
  3487,
  3724,
  5285,
  // 2400
  5286,
  587,
  14,
  3305,
  227,
  2608,
  326,
  480,
  2270,
  943,
  2765,
  3607,
  291,
  650,
  1884,
  5287,
  // 2416
  1702,
  1226,
  102,
  1547,
  62,
  3488,
  904,
  4629,
  3489,
  1164,
  4294,
  5288,
  5289,
  1224,
  1548,
  2766,
  // 2432
  391,
  498,
  1493,
  5290,
  1386,
  1419,
  5291,
  2056,
  1177,
  4630,
  813,
  880,
  1081,
  2368,
  566,
  1145,
  // 2448
  4631,
  2291,
  1001,
  1035,
  2566,
  2609,
  2242,
  394,
  1286,
  5292,
  5293,
  2069,
  5294,
  86,
  1494,
  1730,
  // 2464
  4039,
  491,
  1588,
  745,
  897,
  2963,
  843,
  3377,
  4040,
  2767,
  2884,
  3306,
  1768,
  998,
  2221,
  2070,
  // 2480
  397,
  1827,
  1195,
  1970,
  3725,
  3011,
  3378,
  284,
  5295,
  3861,
  2507,
  2138,
  2120,
  1904,
  5296,
  4041,
  // 2496
  2151,
  4042,
  4295,
  1036,
  3490,
  1905,
  114,
  2567,
  4296,
  209,
  1527,
  5297,
  5298,
  2964,
  2844,
  2635,
  // 2512
  2390,
  2728,
  3164,
  812,
  2568,
  5299,
  3307,
  5300,
  1559,
  737,
  1885,
  3726,
  1210,
  885,
  28,
  2695,
  // 2528
  3608,
  3862,
  5301,
  4297,
  1004,
  1780,
  4632,
  5302,
  346,
  1982,
  2222,
  2696,
  4633,
  3863,
  1742,
  797,
  // 2544
  1642,
  4043,
  1934,
  1072,
  1384,
  2152,
  896,
  4044,
  3308,
  3727,
  3228,
  2885,
  3609,
  5303,
  2569,
  1959,
  // 2560
  4634,
  2455,
  1786,
  5304,
  5305,
  5306,
  4045,
  4298,
  1005,
  1308,
  3728,
  4299,
  2729,
  4635,
  4636,
  1528,
  // 2576
  2610,
  161,
  1178,
  4300,
  1983,
  987,
  4637,
  1101,
  4301,
  631,
  4046,
  1157,
  3229,
  2425,
  1343,
  1241,
  // 2592
  1016,
  2243,
  2570,
  372,
  877,
  2344,
  2508,
  1160,
  555,
  1935,
  911,
  4047,
  5307,
  466,
  1170,
  169,
  // 2608
  1051,
  2921,
  2697,
  3729,
  2481,
  3012,
  1182,
  2012,
  2571,
  1251,
  2636,
  5308,
  992,
  2345,
  3491,
  1540,
  // 2624
  2730,
  1201,
  2071,
  2406,
  1997,
  2482,
  5309,
  4638,
  528,
  1923,
  2191,
  1503,
  1874,
  1570,
  2369,
  3379,
  // 2640
  3309,
  5310,
  557,
  1073,
  5311,
  1828,
  3492,
  2088,
  2271,
  3165,
  3059,
  3107,
  767,
  3108,
  2799,
  4639,
  // 2656
  1006,
  4302,
  4640,
  2346,
  1267,
  2179,
  3730,
  3230,
  778,
  4048,
  3231,
  2731,
  1597,
  2667,
  5312,
  4641,
  // 2672
  5313,
  3493,
  5314,
  5315,
  5316,
  3310,
  2698,
  1433,
  3311,
  131,
  95,
  1504,
  4049,
  723,
  4303,
  3166,
  // 2688
  1842,
  3610,
  2768,
  2192,
  4050,
  2028,
  2105,
  3731,
  5317,
  3013,
  4051,
  1218,
  5318,
  3380,
  3232,
  4052,
  // 2704
  4304,
  2584,
  248,
  1634,
  3864,
  912,
  5319,
  2845,
  3732,
  3060,
  3865,
  654,
  53,
  5320,
  3014,
  5321,
  // 2720
  1688,
  4642,
  777,
  3494,
  1032,
  4053,
  1425,
  5322,
  191,
  820,
  2121,
  2846,
  971,
  4643,
  931,
  3233,
  // 2736
  135,
  664,
  783,
  3866,
  1998,
  772,
  2922,
  1936,
  4054,
  3867,
  4644,
  2923,
  3234,
  282,
  2732,
  640,
  // 2752
  1372,
  3495,
  1127,
  922,
  325,
  3381,
  5323,
  5324,
  711,
  2045,
  5325,
  5326,
  4055,
  2223,
  2800,
  1937,
  // 2768
  4056,
  3382,
  2224,
  2255,
  3868,
  2305,
  5327,
  4645,
  3869,
  1258,
  3312,
  4057,
  3235,
  2139,
  2965,
  4058,
  // 2784
  4059,
  5328,
  2225,
  258,
  3236,
  4646,
  101,
  1227,
  5329,
  3313,
  1755,
  5330,
  1391,
  3314,
  5331,
  2924,
  // 2800
  2057,
  893,
  5332,
  5333,
  5334,
  1402,
  4305,
  2347,
  5335,
  5336,
  3237,
  3611,
  5337,
  5338,
  878,
  1325,
  // 2816
  1781,
  2801,
  4647,
  259,
  1385,
  2585,
  744,
  1183,
  2272,
  4648,
  5339,
  4060,
  2509,
  5340,
  684,
  1024,
  // 2832
  4306,
  5341,
  472,
  3612,
  3496,
  1165,
  3315,
  4061,
  4062,
  322,
  2153,
  881,
  455,
  1695,
  1152,
  1340,
  // 2848
  660,
  554,
  2154,
  4649,
  1058,
  4650,
  4307,
  830,
  1065,
  3383,
  4063,
  4651,
  1924,
  5342,
  1703,
  1919,
  // 2864
  5343,
  932,
  2273,
  122,
  5344,
  4652,
  947,
  677,
  5345,
  3870,
  2637,
  297,
  1906,
  1925,
  2274,
  4653,
  // 2880
  2322,
  3316,
  5346,
  5347,
  4308,
  5348,
  4309,
  84,
  4310,
  112,
  989,
  5349,
  547,
  1059,
  4064,
  701,
  // 2896
  3613,
  1019,
  5350,
  4311,
  5351,
  3497,
  942,
  639,
  457,
  2306,
  2456,
  993,
  2966,
  407,
  851,
  494,
  // 2912
  4654,
  3384,
  927,
  5352,
  1237,
  5353,
  2426,
  3385,
  573,
  4312,
  680,
  921,
  2925,
  1279,
  1875,
  285,
  // 2928
  790,
  1448,
  1984,
  719,
  2168,
  5354,
  5355,
  4655,
  4065,
  4066,
  1649,
  5356,
  1541,
  563,
  5357,
  1077,
  // 2944
  5358,
  3386,
  3061,
  3498,
  511,
  3015,
  4067,
  4068,
  3733,
  4069,
  1268,
  2572,
  3387,
  3238,
  4656,
  4657,
  // 2960
  5359,
  535,
  1048,
  1276,
  1189,
  2926,
  2029,
  3167,
  1438,
  1373,
  2847,
  2967,
  1134,
  2013,
  5360,
  4313,
  // 2976
  1238,
  2586,
  3109,
  1259,
  5361,
  700,
  5362,
  2968,
  3168,
  3734,
  4314,
  5363,
  4315,
  1146,
  1876,
  1907,
  // 2992
  4658,
  2611,
  4070,
  781,
  2427,
  132,
  1589,
  203,
  147,
  273,
  2802,
  2407,
  898,
  1787,
  2155,
  4071,
  // 3008
  4072,
  5364,
  3871,
  2803,
  5365,
  5366,
  4659,
  4660,
  5367,
  3239,
  5368,
  1635,
  3872,
  965,
  5369,
  1805,
  // 3024
  2699,
  1516,
  3614,
  1121,
  1082,
  1329,
  3317,
  4073,
  1449,
  3873,
  65,
  1128,
  2848,
  2927,
  2769,
  1590,
  // 3040
  3874,
  5370,
  5371,
  12,
  2668,
  45,
  976,
  2587,
  3169,
  4661,
  517,
  2535,
  1013,
  1037,
  3240,
  5372,
  // 3056
  3875,
  2849,
  5373,
  3876,
  5374,
  3499,
  5375,
  2612,
  614,
  1999,
  2323,
  3877,
  3110,
  2733,
  2638,
  5376,
  // 3072
  2588,
  4316,
  599,
  1269,
  5377,
  1811,
  3735,
  5378,
  2700,
  3111,
  759,
  1060,
  489,
  1806,
  3388,
  3318,
  // 3088
  1358,
  5379,
  5380,
  2391,
  1387,
  1215,
  2639,
  2256,
  490,
  5381,
  5382,
  4317,
  1759,
  2392,
  2348,
  5383,
  // 3104
  4662,
  3878,
  1908,
  4074,
  2640,
  1807,
  3241,
  4663,
  3500,
  3319,
  2770,
  2349,
  874,
  5384,
  5385,
  3501,
  // 3120
  3736,
  1859,
  91,
  2928,
  3737,
  3062,
  3879,
  4664,
  5386,
  3170,
  4075,
  2669,
  5387,
  3502,
  1202,
  1403,
  // 3136
  3880,
  2969,
  2536,
  1517,
  2510,
  4665,
  3503,
  2511,
  5388,
  4666,
  5389,
  2701,
  1886,
  1495,
  1731,
  4076,
  // 3152
  2370,
  4667,
  5390,
  2030,
  5391,
  5392,
  4077,
  2702,
  1216,
  237,
  2589,
  4318,
  2324,
  4078,
  3881,
  4668,
  // 3168
  4669,
  2703,
  3615,
  3504,
  445,
  4670,
  5393,
  5394,
  5395,
  5396,
  2771,
  61,
  4079,
  3738,
  1823,
  4080,
  // 3184
  5397,
  687,
  2046,
  935,
  925,
  405,
  2670,
  703,
  1096,
  1860,
  2734,
  4671,
  4081,
  1877,
  1367,
  2704,
  // 3200
  3389,
  918,
  2106,
  1782,
  2483,
  334,
  3320,
  1611,
  1093,
  4672,
  564,
  3171,
  3505,
  3739,
  3390,
  945,
  // 3216
  2641,
  2058,
  4673,
  5398,
  1926,
  872,
  4319,
  5399,
  3506,
  2705,
  3112,
  349,
  4320,
  3740,
  4082,
  4674,
  // 3232
  3882,
  4321,
  3741,
  2156,
  4083,
  4675,
  4676,
  4322,
  4677,
  2408,
  2047,
  782,
  4084,
  400,
  251,
  4323,
  // 3248
  1624,
  5400,
  5401,
  277,
  3742,
  299,
  1265,
  476,
  1191,
  3883,
  2122,
  4324,
  4325,
  1109,
  205,
  5402,
  // 3264
  2590,
  1e3,
  2157,
  3616,
  1861,
  5403,
  5404,
  5405,
  4678,
  5406,
  4679,
  2573,
  107,
  2484,
  2158,
  4085,
  // 3280
  3507,
  3172,
  5407,
  1533,
  541,
  1301,
  158,
  753,
  4326,
  2886,
  3617,
  5408,
  1696,
  370,
  1088,
  4327,
  // 3296
  4680,
  3618,
  579,
  327,
  440,
  162,
  2244,
  269,
  1938,
  1374,
  3508,
  968,
  3063,
  56,
  1396,
  3113,
  // 3312
  2107,
  3321,
  3391,
  5409,
  1927,
  2159,
  4681,
  3016,
  5410,
  3619,
  5411,
  5412,
  3743,
  4682,
  2485,
  5413,
  // 3328
  2804,
  5414,
  1650,
  4683,
  5415,
  2613,
  5416,
  5417,
  4086,
  2671,
  3392,
  1149,
  3393,
  4087,
  3884,
  4088,
  // 3344
  5418,
  1076,
  49,
  5419,
  951,
  3242,
  3322,
  3323,
  450,
  2850,
  920,
  5420,
  1812,
  2805,
  2371,
  4328,
  // 3360
  1909,
  1138,
  2372,
  3885,
  3509,
  5421,
  3243,
  4684,
  1910,
  1147,
  1518,
  2428,
  4685,
  3886,
  5422,
  4686,
  // 3376
  2393,
  2614,
  260,
  1796,
  3244,
  5423,
  5424,
  3887,
  3324,
  708,
  5425,
  3620,
  1704,
  5426,
  3621,
  1351,
  // 3392
  1618,
  3394,
  3017,
  1887,
  944,
  4329,
  3395,
  4330,
  3064,
  3396,
  4331,
  5427,
  3744,
  422,
  413,
  1714,
  // 3408
  3325,
  500,
  2059,
  2350,
  4332,
  2486,
  5428,
  1344,
  1911,
  954,
  5429,
  1668,
  5430,
  5431,
  4089,
  2409,
  // 3424
  4333,
  3622,
  3888,
  4334,
  5432,
  2307,
  1318,
  2512,
  3114,
  133,
  3115,
  2887,
  4687,
  629,
  31,
  2851,
  // 3440
  2706,
  3889,
  4688,
  850,
  949,
  4689,
  4090,
  2970,
  1732,
  2089,
  4335,
  1496,
  1853,
  5433,
  4091,
  620,
  // 3456
  3245,
  981,
  1242,
  3745,
  3397,
  1619,
  3746,
  1643,
  3326,
  2140,
  2457,
  1971,
  1719,
  3510,
  2169,
  5434,
  // 3472
  3246,
  5435,
  5436,
  3398,
  1829,
  5437,
  1277,
  4690,
  1565,
  2048,
  5438,
  1636,
  3623,
  3116,
  5439,
  869,
  // 3488
  2852,
  655,
  3890,
  3891,
  3117,
  4092,
  3018,
  3892,
  1310,
  3624,
  4691,
  5440,
  5441,
  5442,
  1733,
  558,
  // 3504
  4692,
  3747,
  335,
  1549,
  3065,
  1756,
  4336,
  3748,
  1946,
  3511,
  1830,
  1291,
  1192,
  470,
  2735,
  2108,
  // 3520
  2806,
  913,
  1054,
  4093,
  5443,
  1027,
  5444,
  3066,
  4094,
  4693,
  982,
  2672,
  3399,
  3173,
  3512,
  3247,
  // 3536
  3248,
  1947,
  2807,
  5445,
  571,
  4694,
  5446,
  1831,
  5447,
  3625,
  2591,
  1523,
  2429,
  5448,
  2090,
  984,
  // 3552
  4695,
  3749,
  1960,
  5449,
  3750,
  852,
  923,
  2808,
  3513,
  3751,
  969,
  1519,
  999,
  2049,
  2325,
  1705,
  // 3568
  5450,
  3118,
  615,
  1662,
  151,
  597,
  4095,
  2410,
  2326,
  1049,
  275,
  4696,
  3752,
  4337,
  568,
  3753,
  // 3584
  3626,
  2487,
  4338,
  3754,
  5451,
  2430,
  2275,
  409,
  3249,
  5452,
  1566,
  2888,
  3514,
  1002,
  769,
  2853,
  // 3600
  194,
  2091,
  3174,
  3755,
  2226,
  3327,
  4339,
  628,
  1505,
  5453,
  5454,
  1763,
  2180,
  3019,
  4096,
  521,
  // 3616
  1161,
  2592,
  1788,
  2206,
  2411,
  4697,
  4097,
  1625,
  4340,
  4341,
  412,
  42,
  3119,
  464,
  5455,
  2642,
  // 3632
  4698,
  3400,
  1760,
  1571,
  2889,
  3515,
  2537,
  1219,
  2207,
  3893,
  2643,
  2141,
  2373,
  4699,
  4700,
  3328,
  // 3648
  1651,
  3401,
  3627,
  5456,
  5457,
  3628,
  2488,
  3516,
  5458,
  3756,
  5459,
  5460,
  2276,
  2092,
  460,
  5461,
  // 3664
  4701,
  5462,
  3020,
  962,
  588,
  3629,
  289,
  3250,
  2644,
  1116,
  52,
  5463,
  3067,
  1797,
  5464,
  5465,
  // 3680
  5466,
  1467,
  5467,
  1598,
  1143,
  3757,
  4342,
  1985,
  1734,
  1067,
  4702,
  1280,
  3402,
  465,
  4703,
  1572,
  // 3696
  510,
  5468,
  1928,
  2245,
  1813,
  1644,
  3630,
  5469,
  4704,
  3758,
  5470,
  5471,
  2673,
  1573,
  1534,
  5472,
  // 3712
  5473,
  536,
  1808,
  1761,
  3517,
  3894,
  3175,
  2645,
  5474,
  5475,
  5476,
  4705,
  3518,
  2929,
  1912,
  2809,
  // 3728
  5477,
  3329,
  1122,
  377,
  3251,
  5478,
  360,
  5479,
  5480,
  4343,
  1529,
  551,
  5481,
  2060,
  3759,
  1769,
  // 3744
  2431,
  5482,
  2930,
  4344,
  3330,
  3120,
  2327,
  2109,
  2031,
  4706,
  1404,
  136,
  1468,
  1479,
  672,
  1171,
  // 3760
  3252,
  2308,
  271,
  3176,
  5483,
  2772,
  5484,
  2050,
  678,
  2736,
  865,
  1948,
  4707,
  5485,
  2014,
  4098,
  // 3776
  2971,
  5486,
  2737,
  2227,
  1397,
  3068,
  3760,
  4708,
  4709,
  1735,
  2931,
  3403,
  3631,
  5487,
  3895,
  509,
  // 3792
  2854,
  2458,
  2890,
  3896,
  5488,
  5489,
  3177,
  3178,
  4710,
  4345,
  2538,
  4711,
  2309,
  1166,
  1010,
  552,
  // 3808
  681,
  1888,
  5490,
  5491,
  2972,
  2973,
  4099,
  1287,
  1596,
  1862,
  3179,
  358,
  453,
  736,
  175,
  478,
  // 3824
  1117,
  905,
  1167,
  1097,
  5492,
  1854,
  1530,
  5493,
  1706,
  5494,
  2181,
  3519,
  2292,
  3761,
  3520,
  3632,
  // 3840
  4346,
  2093,
  4347,
  5495,
  3404,
  1193,
  2489,
  4348,
  1458,
  2193,
  2208,
  1863,
  1889,
  1421,
  3331,
  2932,
  // 3856
  3069,
  2182,
  3521,
  595,
  2123,
  5496,
  4100,
  5497,
  5498,
  4349,
  1707,
  2646,
  223,
  3762,
  1359,
  751,
  // 3872
  3121,
  183,
  3522,
  5499,
  2810,
  3021,
  419,
  2374,
  633,
  704,
  3897,
  2394,
  241,
  5500,
  5501,
  5502,
  // 3888
  838,
  3022,
  3763,
  2277,
  2773,
  2459,
  3898,
  1939,
  2051,
  4101,
  1309,
  3122,
  2246,
  1181,
  5503,
  1136,
  // 3904
  2209,
  3899,
  2375,
  1446,
  4350,
  2310,
  4712,
  5504,
  5505,
  4351,
  1055,
  2615,
  484,
  3764,
  5506,
  4102,
  // 3920
  625,
  4352,
  2278,
  3405,
  1499,
  4353,
  4103,
  5507,
  4104,
  4354,
  3253,
  2279,
  2280,
  3523,
  5508,
  5509,
  // 3936
  2774,
  808,
  2616,
  3765,
  3406,
  4105,
  4355,
  3123,
  2539,
  526,
  3407,
  3900,
  4356,
  955,
  5510,
  1620,
  // 3952
  4357,
  2647,
  2432,
  5511,
  1429,
  3766,
  1669,
  1832,
  994,
  928,
  5512,
  3633,
  1260,
  5513,
  5514,
  5515,
  // 3968
  1949,
  2293,
  741,
  2933,
  1626,
  4358,
  2738,
  2460,
  867,
  1184,
  362,
  3408,
  1392,
  5516,
  5517,
  4106,
  // 3984
  4359,
  1770,
  1736,
  3254,
  2934,
  4713,
  4714,
  1929,
  2707,
  1459,
  1158,
  5518,
  3070,
  3409,
  2891,
  1292,
  // 4000
  1930,
  2513,
  2855,
  3767,
  1986,
  1187,
  2072,
  2015,
  2617,
  4360,
  5519,
  2574,
  2514,
  2170,
  3768,
  2490,
  // 4016
  3332,
  5520,
  3769,
  4715,
  5521,
  5522,
  666,
  1003,
  3023,
  1022,
  3634,
  4361,
  5523,
  4716,
  1814,
  2257,
  // 4032
  574,
  3901,
  1603,
  295,
  1535,
  705,
  3902,
  4362,
  283,
  858,
  417,
  5524,
  5525,
  3255,
  4717,
  4718,
  // 4048
  3071,
  1220,
  1890,
  1046,
  2281,
  2461,
  4107,
  1393,
  1599,
  689,
  2575,
  388,
  4363,
  5526,
  2491,
  802,
  // 4064
  5527,
  2811,
  3903,
  2061,
  1405,
  2258,
  5528,
  4719,
  3904,
  2110,
  1052,
  1345,
  3256,
  1585,
  5529,
  809,
  // 4080
  5530,
  5531,
  5532,
  575,
  2739,
  3524,
  956,
  1552,
  1469,
  1144,
  2328,
  5533,
  2329,
  1560,
  2462,
  3635,
  // 4096
  3257,
  4108,
  616,
  2210,
  4364,
  3180,
  2183,
  2294,
  5534,
  1833,
  5535,
  3525,
  4720,
  5536,
  1319,
  3770,
  // 4112
  3771,
  1211,
  3636,
  1023,
  3258,
  1293,
  2812,
  5537,
  5538,
  5539,
  3905,
  607,
  2311,
  3906,
  762,
  2892,
  // 4128
  1439,
  4365,
  1360,
  4721,
  1485,
  3072,
  5540,
  4722,
  1038,
  4366,
  1450,
  2062,
  2648,
  4367,
  1379,
  4723,
  // 4144
  2593,
  5541,
  5542,
  4368,
  1352,
  1414,
  2330,
  2935,
  1172,
  5543,
  5544,
  3907,
  3908,
  4724,
  1798,
  1451,
  // 4160
  5545,
  5546,
  5547,
  5548,
  2936,
  4109,
  4110,
  2492,
  2351,
  411,
  4111,
  4112,
  3637,
  3333,
  3124,
  4725,
  // 4176
  1561,
  2674,
  1452,
  4113,
  1375,
  5549,
  5550,
  47,
  2974,
  316,
  5551,
  1406,
  1591,
  2937,
  3181,
  5552,
  // 4192
  1025,
  2142,
  3125,
  3182,
  354,
  2740,
  884,
  2228,
  4369,
  2412,
  508,
  3772,
  726,
  3638,
  996,
  2433,
  // 4208
  3639,
  729,
  5553,
  392,
  2194,
  1453,
  4114,
  4726,
  3773,
  5554,
  5555,
  2463,
  3640,
  2618,
  1675,
  2813,
  // 4224
  919,
  2352,
  2975,
  2353,
  1270,
  4727,
  4115,
  73,
  5556,
  5557,
  647,
  5558,
  3259,
  2856,
  2259,
  1550,
  // 4240
  1346,
  3024,
  5559,
  1332,
  883,
  3526,
  5560,
  5561,
  5562,
  5563,
  3334,
  2775,
  5564,
  1212,
  831,
  1347,
  // 4256
  4370,
  4728,
  2331,
  3909,
  1864,
  3073,
  720,
  3910,
  4729,
  4730,
  3911,
  5565,
  4371,
  5566,
  5567,
  4731,
  // 4272
  5568,
  5569,
  1799,
  4732,
  3774,
  2619,
  4733,
  3641,
  1645,
  2376,
  4734,
  5570,
  2938,
  669,
  2211,
  2675,
  // 4288
  2434,
  5571,
  2893,
  5572,
  5573,
  1028,
  3260,
  5574,
  4372,
  2413,
  5575,
  2260,
  1353,
  5576,
  5577,
  4735,
  // 4304
  3183,
  518,
  5578,
  4116,
  5579,
  4373,
  1961,
  5580,
  2143,
  4374,
  5581,
  5582,
  3025,
  2354,
  2355,
  3912,
  // 4320
  516,
  1834,
  1454,
  4117,
  2708,
  4375,
  4736,
  2229,
  2620,
  1972,
  1129,
  3642,
  5583,
  2776,
  5584,
  2976,
  // 4336
  1422,
  577,
  1470,
  3026,
  1524,
  3410,
  5585,
  5586,
  432,
  4376,
  3074,
  3527,
  5587,
  2594,
  1455,
  2515,
  // 4352
  2230,
  1973,
  1175,
  5588,
  1020,
  2741,
  4118,
  3528,
  4737,
  5589,
  2742,
  5590,
  1743,
  1361,
  3075,
  3529,
  // 4368
  2649,
  4119,
  4377,
  4738,
  2295,
  895,
  924,
  4378,
  2171,
  331,
  2247,
  3076,
  166,
  1627,
  3077,
  1098,
  // 4384
  5591,
  1232,
  2894,
  2231,
  3411,
  4739,
  657,
  403,
  1196,
  2377,
  542,
  3775,
  3412,
  1600,
  4379,
  3530,
  // 4400
  5592,
  4740,
  2777,
  3261,
  576,
  530,
  1362,
  4741,
  4742,
  2540,
  2676,
  3776,
  4120,
  5593,
  842,
  3913,
  // 4416
  5594,
  2814,
  2032,
  1014,
  4121,
  213,
  2709,
  3413,
  665,
  621,
  4380,
  5595,
  3777,
  2939,
  2435,
  5596,
  // 4432
  2436,
  3335,
  3643,
  3414,
  4743,
  4381,
  2541,
  4382,
  4744,
  3644,
  1682,
  4383,
  3531,
  1380,
  5597,
  724,
  // 4448
  2282,
  600,
  1670,
  5598,
  1337,
  1233,
  4745,
  3126,
  2248,
  5599,
  1621,
  4746,
  5600,
  651,
  4384,
  5601,
  // 4464
  1612,
  4385,
  2621,
  5602,
  2857,
  5603,
  2743,
  2312,
  3078,
  5604,
  716,
  2464,
  3079,
  174,
  1255,
  2710,
  // 4480
  4122,
  3645,
  548,
  1320,
  1398,
  728,
  4123,
  1574,
  5605,
  1891,
  1197,
  3080,
  4124,
  5606,
  3081,
  3082,
  // 4496
  3778,
  3646,
  3779,
  747,
  5607,
  635,
  4386,
  4747,
  5608,
  5609,
  5610,
  4387,
  5611,
  5612,
  4748,
  5613,
  // 4512
  3415,
  4749,
  2437,
  451,
  5614,
  3780,
  2542,
  2073,
  4388,
  2744,
  4389,
  4125,
  5615,
  1764,
  4750,
  5616,
  // 4528
  4390,
  350,
  4751,
  2283,
  2395,
  2493,
  5617,
  4391,
  4126,
  2249,
  1434,
  4127,
  488,
  4752,
  458,
  4392,
  // 4544
  4128,
  3781,
  771,
  1330,
  2396,
  3914,
  2576,
  3184,
  2160,
  2414,
  1553,
  2677,
  3185,
  4393,
  5618,
  2494,
  // 4560
  2895,
  2622,
  1720,
  2711,
  4394,
  3416,
  4753,
  5619,
  2543,
  4395,
  5620,
  3262,
  4396,
  2778,
  5621,
  2016,
  // 4576
  2745,
  5622,
  1155,
  1017,
  3782,
  3915,
  5623,
  3336,
  2313,
  201,
  1865,
  4397,
  1430,
  5624,
  4129,
  5625,
  // 4592
  5626,
  5627,
  5628,
  5629,
  4398,
  1604,
  5630,
  414,
  1866,
  371,
  2595,
  4754,
  4755,
  3532,
  2017,
  3127,
  // 4608
  4756,
  1708,
  960,
  4399,
  887,
  389,
  2172,
  1536,
  1663,
  1721,
  5631,
  2232,
  4130,
  2356,
  2940,
  1580,
  // 4624
  5632,
  5633,
  1744,
  4757,
  2544,
  4758,
  4759,
  5634,
  4760,
  5635,
  2074,
  5636,
  4761,
  3647,
  3417,
  2896,
  // 4640
  4400,
  5637,
  4401,
  2650,
  3418,
  2815,
  673,
  2712,
  2465,
  709,
  3533,
  4131,
  3648,
  4402,
  5638,
  1148,
  // 4656
  502,
  634,
  5639,
  5640,
  1204,
  4762,
  3649,
  1575,
  4763,
  2623,
  3783,
  5641,
  3784,
  3128,
  948,
  3263,
  // 4672
  121,
  1745,
  3916,
  1110,
  5642,
  4403,
  3083,
  2516,
  3027,
  4132,
  3785,
  1151,
  1771,
  3917,
  1488,
  4133,
  // 4688
  1987,
  5643,
  2438,
  3534,
  5644,
  5645,
  2094,
  5646,
  4404,
  3918,
  1213,
  1407,
  2816,
  531,
  2746,
  2545,
  // 4704
  3264,
  1011,
  1537,
  4764,
  2779,
  4405,
  3129,
  1061,
  5647,
  3786,
  3787,
  1867,
  2897,
  5648,
  2018,
  120,
  // 4720
  4406,
  4407,
  2063,
  3650,
  3265,
  2314,
  3919,
  2678,
  3419,
  1955,
  4765,
  4134,
  5649,
  3535,
  1047,
  2713,
  // 4736
  1266,
  5650,
  1368,
  4766,
  2858,
  649,
  3420,
  3920,
  2546,
  2747,
  1102,
  2859,
  2679,
  5651,
  5652,
  2e3,
  // 4752
  5653,
  1111,
  3651,
  2977,
  5654,
  2495,
  3921,
  3652,
  2817,
  1855,
  3421,
  3788,
  5655,
  5656,
  3422,
  2415,
  // 4768
  2898,
  3337,
  3266,
  3653,
  5657,
  2577,
  5658,
  3654,
  2818,
  4135,
  1460,
  856,
  5659,
  3655,
  5660,
  2899,
  // 4784
  2978,
  5661,
  2900,
  3922,
  5662,
  4408,
  632,
  2517,
  875,
  3923,
  1697,
  3924,
  2296,
  5663,
  5664,
  4767,
  // 4800
  3028,
  1239,
  580,
  4768,
  4409,
  5665,
  914,
  936,
  2075,
  1190,
  4136,
  1039,
  2124,
  5666,
  5667,
  5668,
  // 4816
  5669,
  3423,
  1473,
  5670,
  1354,
  4410,
  3925,
  4769,
  2173,
  3084,
  4137,
  915,
  3338,
  4411,
  4412,
  3339,
  // 4832
  1605,
  1835,
  5671,
  2748,
  398,
  3656,
  4413,
  3926,
  4138,
  328,
  1913,
  2860,
  4139,
  3927,
  1331,
  4414,
  // 4848
  3029,
  937,
  4415,
  5672,
  3657,
  4140,
  4141,
  3424,
  2161,
  4770,
  3425,
  524,
  742,
  538,
  3085,
  1012,
  // 4864
  5673,
  5674,
  3928,
  2466,
  5675,
  658,
  1103,
  225,
  3929,
  5676,
  5677,
  4771,
  5678,
  4772,
  5679,
  3267,
  // 4880
  1243,
  5680,
  4142,
  963,
  2250,
  4773,
  5681,
  2714,
  3658,
  3186,
  5682,
  5683,
  2596,
  2332,
  5684,
  4774,
  // 4896
  5685,
  5686,
  5687,
  3536,
  957,
  3426,
  2547,
  2033,
  1931,
  2941,
  2467,
  870,
  2019,
  3659,
  1746,
  2780,
  // 4912
  2781,
  2439,
  2468,
  5688,
  3930,
  5689,
  3789,
  3130,
  3790,
  3537,
  3427,
  3791,
  5690,
  1179,
  3086,
  5691,
  // 4928
  3187,
  2378,
  4416,
  3792,
  2548,
  3188,
  3131,
  2749,
  4143,
  5692,
  3428,
  1556,
  2549,
  2297,
  977,
  2901,
  // 4944
  2034,
  4144,
  1205,
  3429,
  5693,
  1765,
  3430,
  3189,
  2125,
  1271,
  714,
  1689,
  4775,
  3538,
  5694,
  2333,
  // 4960
  3931,
  533,
  4417,
  3660,
  2184,
  617,
  5695,
  2469,
  3340,
  3539,
  2315,
  5696,
  5697,
  3190,
  5698,
  5699,
  // 4976
  3932,
  1988,
  618,
  427,
  2651,
  3540,
  3431,
  5700,
  5701,
  1244,
  1690,
  5702,
  2819,
  4418,
  4776,
  5703,
  // 4992
  3541,
  4777,
  5704,
  2284,
  1576,
  473,
  3661,
  4419,
  3432,
  972,
  5705,
  3662,
  5706,
  3087,
  5707,
  5708,
  // 5008
  4778,
  4779,
  5709,
  3793,
  4145,
  4146,
  5710,
  153,
  4780,
  356,
  5711,
  1892,
  2902,
  4420,
  2144,
  408,
  // 5024
  803,
  2357,
  5712,
  3933,
  5713,
  4421,
  1646,
  2578,
  2518,
  4781,
  4782,
  3934,
  5714,
  3935,
  4422,
  5715,
  // 5040
  2416,
  3433,
  752,
  5716,
  5717,
  1962,
  3341,
  2979,
  5718,
  746,
  3030,
  2470,
  4783,
  4423,
  3794,
  698,
  // 5056
  4784,
  1893,
  4424,
  3663,
  2550,
  4785,
  3664,
  3936,
  5719,
  3191,
  3434,
  5720,
  1824,
  1302,
  4147,
  2715,
  // 5072
  3937,
  1974,
  4425,
  5721,
  4426,
  3192,
  823,
  1303,
  1288,
  1236,
  2861,
  3542,
  4148,
  3435,
  774,
  3938,
  // 5088
  5722,
  1581,
  4786,
  1304,
  2862,
  3939,
  4787,
  5723,
  2440,
  2162,
  1083,
  3268,
  4427,
  4149,
  4428,
  344,
  // 5104
  1173,
  288,
  2316,
  454,
  1683,
  5724,
  5725,
  1461,
  4788,
  4150,
  2597,
  5726,
  5727,
  4789,
  985,
  894,
  // 5120
  5728,
  3436,
  3193,
  5729,
  1914,
  2942,
  3795,
  1989,
  5730,
  2111,
  1975,
  5731,
  4151,
  5732,
  2579,
  1194,
  // 5136
  425,
  5733,
  4790,
  3194,
  1245,
  3796,
  4429,
  5734,
  5735,
  2863,
  5736,
  636,
  4791,
  1856,
  3940,
  760,
  // 5152
  1800,
  5737,
  4430,
  2212,
  1508,
  4792,
  4152,
  1894,
  1684,
  2298,
  5738,
  5739,
  4793,
  4431,
  4432,
  2213,
  // 5168
  479,
  5740,
  5741,
  832,
  5742,
  4153,
  2496,
  5743,
  2980,
  2497,
  3797,
  990,
  3132,
  627,
  1815,
  2652,
  // 5184
  4433,
  1582,
  4434,
  2126,
  2112,
  3543,
  4794,
  5744,
  799,
  4435,
  3195,
  5745,
  4795,
  2113,
  1737,
  3031,
  // 5200
  1018,
  543,
  754,
  4436,
  3342,
  1676,
  4796,
  4797,
  4154,
  4798,
  1489,
  5746,
  3544,
  5747,
  2624,
  2903,
  // 5216
  4155,
  5748,
  5749,
  2981,
  5750,
  5751,
  5752,
  5753,
  3196,
  4799,
  4800,
  2185,
  1722,
  5754,
  3269,
  3270,
  // 5232
  1843,
  3665,
  1715,
  481,
  365,
  1976,
  1857,
  5755,
  5756,
  1963,
  2498,
  4801,
  5757,
  2127,
  3666,
  3271,
  // 5248
  433,
  1895,
  2064,
  2076,
  5758,
  602,
  2750,
  5759,
  5760,
  5761,
  5762,
  5763,
  3032,
  1628,
  3437,
  5764,
  // 5264
  3197,
  4802,
  4156,
  2904,
  4803,
  2519,
  5765,
  2551,
  2782,
  5766,
  5767,
  5768,
  3343,
  4804,
  2905,
  5769,
  // 5280
  4805,
  5770,
  2864,
  4806,
  4807,
  1221,
  2982,
  4157,
  2520,
  5771,
  5772,
  5773,
  1868,
  1990,
  5774,
  5775,
  // 5296
  5776,
  1896,
  5777,
  5778,
  4808,
  1897,
  4158,
  318,
  5779,
  2095,
  4159,
  4437,
  5780,
  5781,
  485,
  5782,
  // 5312
  938,
  3941,
  553,
  2680,
  116,
  5783,
  3942,
  3667,
  5784,
  3545,
  2681,
  2783,
  3438,
  3344,
  2820,
  5785,
  // 5328
  3668,
  2943,
  4160,
  1747,
  2944,
  2983,
  5786,
  5787,
  207,
  5788,
  4809,
  5789,
  4810,
  2521,
  5790,
  3033,
  // 5344
  890,
  3669,
  3943,
  5791,
  1878,
  3798,
  3439,
  5792,
  2186,
  2358,
  3440,
  1652,
  5793,
  5794,
  5795,
  941,
  // 5360
  2299,
  208,
  3546,
  4161,
  2020,
  330,
  4438,
  3944,
  2906,
  2499,
  3799,
  4439,
  4811,
  5796,
  5797,
  5798,
  // 5376  //last 512
  //Everything below is of no interest for detection purpose
  2522,
  1613,
  4812,
  5799,
  3345,
  3945,
  2523,
  5800,
  4162,
  5801,
  1637,
  4163,
  2471,
  4813,
  3946,
  5802,
  // 5392
  2500,
  3034,
  3800,
  5803,
  5804,
  2195,
  4814,
  5805,
  2163,
  5806,
  5807,
  5808,
  5809,
  5810,
  5811,
  5812,
  // 5408
  5813,
  5814,
  5815,
  5816,
  5817,
  5818,
  5819,
  5820,
  5821,
  5822,
  5823,
  5824,
  5825,
  5826,
  5827,
  5828,
  // 5424
  5829,
  5830,
  5831,
  5832,
  5833,
  5834,
  5835,
  5836,
  5837,
  5838,
  5839,
  5840,
  5841,
  5842,
  5843,
  5844,
  // 5440
  5845,
  5846,
  5847,
  5848,
  5849,
  5850,
  5851,
  5852,
  5853,
  5854,
  5855,
  5856,
  5857,
  5858,
  5859,
  5860,
  // 5456
  5861,
  5862,
  5863,
  5864,
  5865,
  5866,
  5867,
  5868,
  5869,
  5870,
  5871,
  5872,
  5873,
  5874,
  5875,
  5876,
  // 5472
  5877,
  5878,
  5879,
  5880,
  5881,
  5882,
  5883,
  5884,
  5885,
  5886,
  5887,
  5888,
  5889,
  5890,
  5891,
  5892,
  // 5488
  5893,
  5894,
  5895,
  5896,
  5897,
  5898,
  5899,
  5900,
  5901,
  5902,
  5903,
  5904,
  5905,
  5906,
  5907,
  5908,
  // 5504
  5909,
  5910,
  5911,
  5912,
  5913,
  5914,
  5915,
  5916,
  5917,
  5918,
  5919,
  5920,
  5921,
  5922,
  5923,
  5924,
  // 5520
  5925,
  5926,
  5927,
  5928,
  5929,
  5930,
  5931,
  5932,
  5933,
  5934,
  5935,
  5936,
  5937,
  5938,
  5939,
  5940,
  // 5536
  5941,
  5942,
  5943,
  5944,
  5945,
  5946,
  5947,
  5948,
  5949,
  5950,
  5951,
  5952,
  5953,
  5954,
  5955,
  5956,
  // 5552
  5957,
  5958,
  5959,
  5960,
  5961,
  5962,
  5963,
  5964,
  5965,
  5966,
  5967,
  5968,
  5969,
  5970,
  5971,
  5972,
  // 5568
  5973,
  5974,
  5975,
  5976,
  5977,
  5978,
  5979,
  5980,
  5981,
  5982,
  5983,
  5984,
  5985,
  5986,
  5987,
  5988,
  // 5584
  5989,
  5990,
  5991,
  5992,
  5993,
  5994,
  5995,
  5996,
  5997,
  5998,
  5999,
  6e3,
  6001,
  6002,
  6003,
  6004,
  // 5600
  6005,
  6006,
  6007,
  6008,
  6009,
  6010,
  6011,
  6012,
  6013,
  6014,
  6015,
  6016,
  6017,
  6018,
  6019,
  6020,
  // 5616
  6021,
  6022,
  6023,
  6024,
  6025,
  6026,
  6027,
  6028,
  6029,
  6030,
  6031,
  6032,
  6033,
  6034,
  6035,
  6036,
  // 5632
  6037,
  6038,
  6039,
  6040,
  6041,
  6042,
  6043,
  6044,
  6045,
  6046,
  6047,
  6048,
  6049,
  6050,
  6051,
  6052,
  // 5648
  6053,
  6054,
  6055,
  6056,
  6057,
  6058,
  6059,
  6060,
  6061,
  6062,
  6063,
  6064,
  6065,
  6066,
  6067,
  6068,
  // 5664
  6069,
  6070,
  6071,
  6072,
  6073,
  6074,
  6075,
  6076,
  6077,
  6078,
  6079,
  6080,
  6081,
  6082,
  6083,
  6084,
  // 5680
  6085,
  6086,
  6087,
  6088,
  6089,
  6090,
  6091,
  6092,
  6093,
  6094,
  6095,
  6096,
  6097,
  6098,
  6099,
  6100,
  // 5696
  6101,
  6102,
  6103,
  6104,
  6105,
  6106,
  6107,
  6108,
  6109,
  6110,
  6111,
  6112,
  6113,
  6114,
  6115,
  6116,
  // 5712
  6117,
  6118,
  6119,
  6120,
  6121,
  6122,
  6123,
  6124,
  6125,
  6126,
  6127,
  6128,
  6129,
  6130,
  6131,
  6132,
  // 5728
  6133,
  6134,
  6135,
  6136,
  6137,
  6138,
  6139,
  6140,
  6141,
  6142,
  6143,
  6144,
  6145,
  6146,
  6147,
  6148,
  // 5744
  6149,
  6150,
  6151,
  6152,
  6153,
  6154,
  6155,
  6156,
  6157,
  6158,
  6159,
  6160,
  6161,
  6162,
  6163,
  6164,
  // 5760
  6165,
  6166,
  6167,
  6168,
  6169,
  6170,
  6171,
  6172,
  6173,
  6174,
  6175,
  6176,
  6177,
  6178,
  6179,
  6180,
  // 5776
  6181,
  6182,
  6183,
  6184,
  6185,
  6186,
  6187,
  6188,
  6189,
  6190,
  6191,
  6192,
  6193,
  6194,
  6195,
  6196,
  // 5792
  6197,
  6198,
  6199,
  6200,
  6201,
  6202,
  6203,
  6204,
  6205,
  6206,
  6207,
  6208,
  6209,
  6210,
  6211,
  6212,
  // 5808
  6213,
  6214,
  6215,
  6216,
  6217,
  6218,
  6219,
  6220,
  6221,
  6222,
  6223,
  3670,
  6224,
  6225,
  6226,
  6227,
  // 5824
  6228,
  6229,
  6230,
  6231,
  6232,
  6233,
  6234,
  6235,
  6236,
  6237,
  6238,
  6239,
  6240,
  6241,
  6242,
  6243,
  // 5840
  6244,
  6245,
  6246,
  6247,
  6248,
  6249,
  6250,
  6251,
  6252,
  6253,
  6254,
  6255,
  6256,
  6257,
  6258,
  6259,
  // 5856
  6260,
  6261,
  6262,
  6263,
  6264,
  6265,
  6266,
  6267,
  6268,
  6269,
  6270,
  6271,
  6272,
  6273,
  6274,
  6275,
  // 5872
  6276,
  6277,
  6278,
  6279,
  6280,
  6281,
  6282,
  6283,
  6284,
  6285,
  4815,
  6286,
  6287,
  6288,
  6289,
  6290,
  // 5888
  6291,
  6292,
  4816,
  6293,
  6294,
  6295,
  6296,
  6297,
  6298,
  6299,
  6300,
  6301,
  6302,
  6303,
  6304,
  6305,
  // 5904
  6306,
  6307,
  6308,
  6309,
  6310,
  6311,
  4817,
  4818,
  6312,
  6313,
  6314,
  6315,
  6316,
  6317,
  6318,
  4819,
  // 5920
  6319,
  6320,
  6321,
  6322,
  6323,
  6324,
  6325,
  6326,
  6327,
  6328,
  6329,
  6330,
  6331,
  6332,
  6333,
  6334,
  // 5936
  6335,
  6336,
  6337,
  4820,
  6338,
  6339,
  6340,
  6341,
  6342,
  6343,
  6344,
  6345,
  6346,
  6347,
  6348,
  6349,
  // 5952
  6350,
  6351,
  6352,
  6353,
  6354,
  6355,
  6356,
  6357,
  6358,
  6359,
  6360,
  6361,
  6362,
  6363,
  6364,
  6365,
  // 5968
  6366,
  6367,
  6368,
  6369,
  6370,
  6371,
  6372,
  6373,
  6374,
  6375,
  6376,
  6377,
  6378,
  6379,
  6380,
  6381,
  // 5984
  6382,
  6383,
  6384,
  6385,
  6386,
  6387,
  6388,
  6389,
  6390,
  6391,
  6392,
  6393,
  6394,
  6395,
  6396,
  6397,
  // 6000
  6398,
  6399,
  6400,
  6401,
  6402,
  6403,
  6404,
  6405,
  6406,
  6407,
  6408,
  6409,
  6410,
  3441,
  6411,
  6412,
  // 6016
  6413,
  6414,
  6415,
  6416,
  6417,
  6418,
  6419,
  6420,
  6421,
  6422,
  6423,
  6424,
  6425,
  4440,
  6426,
  6427,
  // 6032
  6428,
  6429,
  6430,
  6431,
  6432,
  6433,
  6434,
  6435,
  6436,
  6437,
  6438,
  6439,
  6440,
  6441,
  6442,
  6443,
  // 6048
  6444,
  6445,
  6446,
  6447,
  6448,
  6449,
  6450,
  6451,
  6452,
  6453,
  6454,
  4821,
  6455,
  6456,
  6457,
  6458,
  // 6064
  6459,
  6460,
  6461,
  6462,
  6463,
  6464,
  6465,
  6466,
  6467,
  6468,
  6469,
  6470,
  6471,
  6472,
  6473,
  6474,
  // 6080
  6475,
  6476,
  6477,
  3947,
  3948,
  6478,
  6479,
  6480,
  6481,
  3272,
  4441,
  6482,
  6483,
  6484,
  6485,
  4442,
  // 6096
  6486,
  6487,
  6488,
  6489,
  6490,
  6491,
  6492,
  6493,
  6494,
  6495,
  6496,
  4822,
  6497,
  6498,
  6499,
  6500,
  // 6112
  6501,
  6502,
  6503,
  6504,
  6505,
  6506,
  6507,
  6508,
  6509,
  6510,
  6511,
  6512,
  6513,
  6514,
  6515,
  6516,
  // 6128
  6517,
  6518,
  6519,
  6520,
  6521,
  6522,
  6523,
  6524,
  6525,
  6526,
  6527,
  6528,
  6529,
  6530,
  6531,
  6532,
  // 6144
  6533,
  6534,
  6535,
  6536,
  6537,
  6538,
  6539,
  6540,
  6541,
  6542,
  6543,
  6544,
  6545,
  6546,
  6547,
  6548,
  // 6160
  6549,
  6550,
  6551,
  6552,
  6553,
  6554,
  6555,
  6556,
  2784,
  6557,
  4823,
  6558,
  6559,
  6560,
  6561,
  6562,
  // 6176
  6563,
  6564,
  6565,
  6566,
  6567,
  6568,
  6569,
  3949,
  6570,
  6571,
  6572,
  4824,
  6573,
  6574,
  6575,
  6576,
  // 6192
  6577,
  6578,
  6579,
  6580,
  6581,
  6582,
  6583,
  4825,
  6584,
  6585,
  6586,
  3950,
  2785,
  6587,
  6588,
  6589,
  // 6208
  6590,
  6591,
  6592,
  6593,
  6594,
  6595,
  6596,
  6597,
  6598,
  6599,
  6600,
  6601,
  6602,
  6603,
  6604,
  6605,
  // 6224
  6606,
  6607,
  6608,
  6609,
  6610,
  6611,
  6612,
  4826,
  6613,
  6614,
  6615,
  4827,
  6616,
  6617,
  6618,
  6619,
  // 6240
  6620,
  6621,
  6622,
  6623,
  6624,
  6625,
  4164,
  6626,
  6627,
  6628,
  6629,
  6630,
  6631,
  6632,
  6633,
  6634,
  // 6256
  3547,
  6635,
  4828,
  6636,
  6637,
  6638,
  6639,
  6640,
  6641,
  6642,
  3951,
  2984,
  6643,
  6644,
  6645,
  6646,
  // 6272
  6647,
  6648,
  6649,
  4165,
  6650,
  4829,
  6651,
  6652,
  4830,
  6653,
  6654,
  6655,
  6656,
  6657,
  6658,
  6659,
  // 6288
  6660,
  6661,
  6662,
  4831,
  6663,
  6664,
  6665,
  6666,
  6667,
  6668,
  6669,
  6670,
  6671,
  4166,
  6672,
  4832,
  // 6304
  3952,
  6673,
  6674,
  6675,
  6676,
  4833,
  6677,
  6678,
  6679,
  4167,
  6680,
  6681,
  6682,
  3198,
  6683,
  6684,
  // 6320
  6685,
  6686,
  6687,
  6688,
  6689,
  6690,
  6691,
  6692,
  6693,
  6694,
  6695,
  6696,
  6697,
  4834,
  6698,
  6699,
  // 6336
  6700,
  6701,
  6702,
  6703,
  6704,
  6705,
  6706,
  6707,
  6708,
  6709,
  6710,
  6711,
  6712,
  6713,
  6714,
  6715,
  // 6352
  6716,
  6717,
  6718,
  6719,
  6720,
  6721,
  6722,
  6723,
  6724,
  6725,
  6726,
  6727,
  6728,
  6729,
  6730,
  6731,
  // 6368
  6732,
  6733,
  6734,
  4443,
  6735,
  6736,
  6737,
  6738,
  6739,
  6740,
  6741,
  6742,
  6743,
  6744,
  6745,
  4444,
  // 6384
  6746,
  6747,
  6748,
  6749,
  6750,
  6751,
  6752,
  6753,
  6754,
  6755,
  6756,
  6757,
  6758,
  6759,
  6760,
  6761,
  // 6400
  6762,
  6763,
  6764,
  6765,
  6766,
  6767,
  6768,
  6769,
  6770,
  6771,
  6772,
  6773,
  6774,
  6775,
  6776,
  6777,
  // 6416
  6778,
  6779,
  6780,
  6781,
  4168,
  6782,
  6783,
  3442,
  6784,
  6785,
  6786,
  6787,
  6788,
  6789,
  6790,
  6791,
  // 6432
  4169,
  6792,
  6793,
  6794,
  6795,
  6796,
  6797,
  6798,
  6799,
  6800,
  6801,
  6802,
  6803,
  6804,
  6805,
  6806,
  // 6448
  6807,
  6808,
  6809,
  6810,
  6811,
  4835,
  6812,
  6813,
  6814,
  4445,
  6815,
  6816,
  4446,
  6817,
  6818,
  6819,
  // 6464
  6820,
  6821,
  6822,
  6823,
  6824,
  6825,
  6826,
  6827,
  6828,
  6829,
  6830,
  6831,
  6832,
  6833,
  6834,
  6835,
  // 6480
  3548,
  6836,
  6837,
  6838,
  6839,
  6840,
  6841,
  6842,
  6843,
  6844,
  6845,
  6846,
  4836,
  6847,
  6848,
  6849,
  // 6496
  6850,
  6851,
  6852,
  6853,
  6854,
  3953,
  6855,
  6856,
  6857,
  6858,
  6859,
  6860,
  6861,
  6862,
  6863,
  6864,
  // 6512
  6865,
  6866,
  6867,
  6868,
  6869,
  6870,
  6871,
  6872,
  6873,
  6874,
  6875,
  6876,
  6877,
  3199,
  6878,
  6879,
  // 6528
  6880,
  6881,
  6882,
  4447,
  6883,
  6884,
  6885,
  6886,
  6887,
  6888,
  6889,
  6890,
  6891,
  6892,
  6893,
  6894,
  // 6544
  6895,
  6896,
  6897,
  6898,
  6899,
  6900,
  6901,
  6902,
  6903,
  6904,
  4170,
  6905,
  6906,
  6907,
  6908,
  6909,
  // 6560
  6910,
  6911,
  6912,
  6913,
  6914,
  6915,
  6916,
  6917,
  6918,
  6919,
  6920,
  6921,
  6922,
  6923,
  6924,
  6925,
  // 6576
  6926,
  6927,
  4837,
  6928,
  6929,
  6930,
  6931,
  6932,
  6933,
  6934,
  6935,
  6936,
  3346,
  6937,
  6938,
  4838,
  // 6592
  6939,
  6940,
  6941,
  4448,
  6942,
  6943,
  6944,
  6945,
  6946,
  4449,
  6947,
  6948,
  6949,
  6950,
  6951,
  6952,
  // 6608
  6953,
  6954,
  6955,
  6956,
  6957,
  6958,
  6959,
  6960,
  6961,
  6962,
  6963,
  6964,
  6965,
  6966,
  6967,
  6968,
  // 6624
  6969,
  6970,
  6971,
  6972,
  6973,
  6974,
  6975,
  6976,
  6977,
  6978,
  6979,
  6980,
  6981,
  6982,
  6983,
  6984,
  // 6640
  6985,
  6986,
  6987,
  6988,
  6989,
  6990,
  6991,
  6992,
  6993,
  6994,
  3671,
  6995,
  6996,
  6997,
  6998,
  4839,
  // 6656
  6999,
  7e3,
  7001,
  7002,
  3549,
  7003,
  7004,
  7005,
  7006,
  7007,
  7008,
  7009,
  7010,
  7011,
  7012,
  7013,
  // 6672
  7014,
  7015,
  7016,
  7017,
  7018,
  7019,
  7020,
  7021,
  7022,
  7023,
  7024,
  7025,
  7026,
  7027,
  7028,
  7029,
  // 6688
  7030,
  4840,
  7031,
  7032,
  7033,
  7034,
  7035,
  7036,
  7037,
  7038,
  4841,
  7039,
  7040,
  7041,
  7042,
  7043,
  // 6704
  7044,
  7045,
  7046,
  7047,
  7048,
  7049,
  7050,
  7051,
  7052,
  7053,
  7054,
  7055,
  7056,
  7057,
  7058,
  7059,
  // 6720
  7060,
  7061,
  7062,
  7063,
  7064,
  7065,
  7066,
  7067,
  7068,
  7069,
  7070,
  2985,
  7071,
  7072,
  7073,
  7074,
  // 6736
  7075,
  7076,
  7077,
  7078,
  7079,
  7080,
  4842,
  7081,
  7082,
  7083,
  7084,
  7085,
  7086,
  7087,
  7088,
  7089,
  // 6752
  7090,
  7091,
  7092,
  7093,
  7094,
  7095,
  7096,
  7097,
  7098,
  7099,
  7100,
  7101,
  7102,
  7103,
  7104,
  7105,
  // 6768
  7106,
  7107,
  7108,
  7109,
  7110,
  7111,
  7112,
  7113,
  7114,
  7115,
  7116,
  7117,
  7118,
  4450,
  7119,
  7120,
  // 6784
  7121,
  7122,
  7123,
  7124,
  7125,
  7126,
  7127,
  7128,
  7129,
  7130,
  7131,
  7132,
  7133,
  7134,
  7135,
  7136,
  // 6800
  7137,
  7138,
  7139,
  7140,
  7141,
  7142,
  7143,
  4843,
  7144,
  7145,
  7146,
  7147,
  7148,
  7149,
  7150,
  7151,
  // 6816
  7152,
  7153,
  7154,
  7155,
  7156,
  7157,
  7158,
  7159,
  7160,
  7161,
  7162,
  7163,
  7164,
  7165,
  7166,
  7167,
  // 6832
  7168,
  7169,
  7170,
  7171,
  7172,
  7173,
  7174,
  7175,
  7176,
  7177,
  7178,
  7179,
  7180,
  7181,
  7182,
  7183,
  // 6848
  7184,
  7185,
  7186,
  7187,
  7188,
  4171,
  4172,
  7189,
  7190,
  7191,
  7192,
  7193,
  7194,
  7195,
  7196,
  7197,
  // 6864
  7198,
  7199,
  7200,
  7201,
  7202,
  7203,
  7204,
  7205,
  7206,
  7207,
  7208,
  7209,
  7210,
  7211,
  7212,
  7213,
  // 6880
  7214,
  7215,
  7216,
  7217,
  7218,
  7219,
  7220,
  7221,
  7222,
  7223,
  7224,
  7225,
  7226,
  7227,
  7228,
  7229,
  // 6896
  7230,
  7231,
  7232,
  7233,
  7234,
  7235,
  7236,
  7237,
  7238,
  7239,
  7240,
  7241,
  7242,
  7243,
  7244,
  7245,
  // 6912
  7246,
  7247,
  7248,
  7249,
  7250,
  7251,
  7252,
  7253,
  7254,
  7255,
  7256,
  7257,
  7258,
  7259,
  7260,
  7261,
  // 6928
  7262,
  7263,
  7264,
  7265,
  7266,
  7267,
  7268,
  7269,
  7270,
  7271,
  7272,
  7273,
  7274,
  7275,
  7276,
  7277,
  // 6944
  7278,
  7279,
  7280,
  7281,
  7282,
  7283,
  7284,
  7285,
  7286,
  7287,
  7288,
  7289,
  7290,
  7291,
  7292,
  7293,
  // 6960
  7294,
  7295,
  7296,
  4844,
  7297,
  7298,
  7299,
  7300,
  7301,
  7302,
  7303,
  7304,
  7305,
  7306,
  7307,
  7308,
  // 6976
  7309,
  7310,
  7311,
  7312,
  7313,
  7314,
  7315,
  7316,
  4451,
  7317,
  7318,
  7319,
  7320,
  7321,
  7322,
  7323,
  // 6992
  7324,
  7325,
  7326,
  7327,
  7328,
  7329,
  7330,
  7331,
  7332,
  7333,
  7334,
  7335,
  7336,
  7337,
  7338,
  7339,
  // 7008
  7340,
  7341,
  7342,
  7343,
  7344,
  7345,
  7346,
  7347,
  7348,
  7349,
  7350,
  7351,
  7352,
  7353,
  4173,
  7354,
  // 7024
  7355,
  4845,
  7356,
  7357,
  7358,
  7359,
  7360,
  7361,
  7362,
  7363,
  7364,
  7365,
  7366,
  7367,
  7368,
  7369,
  // 7040
  7370,
  7371,
  7372,
  7373,
  7374,
  7375,
  7376,
  7377,
  7378,
  7379,
  7380,
  7381,
  7382,
  7383,
  7384,
  7385,
  // 7056
  7386,
  7387,
  7388,
  4846,
  7389,
  7390,
  7391,
  7392,
  7393,
  7394,
  7395,
  7396,
  7397,
  7398,
  7399,
  7400,
  // 7072
  7401,
  7402,
  7403,
  7404,
  7405,
  3672,
  7406,
  7407,
  7408,
  7409,
  7410,
  7411,
  7412,
  7413,
  7414,
  7415,
  // 7088
  7416,
  7417,
  7418,
  7419,
  7420,
  7421,
  7422,
  7423,
  7424,
  7425,
  7426,
  7427,
  7428,
  7429,
  7430,
  7431,
  // 7104
  7432,
  7433,
  7434,
  7435,
  7436,
  7437,
  7438,
  7439,
  7440,
  7441,
  7442,
  7443,
  7444,
  7445,
  7446,
  7447,
  // 7120
  7448,
  7449,
  7450,
  7451,
  7452,
  7453,
  4452,
  7454,
  3200,
  7455,
  7456,
  7457,
  7458,
  7459,
  7460,
  7461,
  // 7136
  7462,
  7463,
  7464,
  7465,
  7466,
  7467,
  7468,
  7469,
  7470,
  7471,
  7472,
  7473,
  7474,
  4847,
  7475,
  7476,
  // 7152
  7477,
  3133,
  7478,
  7479,
  7480,
  7481,
  7482,
  7483,
  7484,
  7485,
  7486,
  7487,
  7488,
  7489,
  7490,
  7491,
  // 7168
  7492,
  7493,
  7494,
  7495,
  7496,
  7497,
  7498,
  7499,
  7500,
  7501,
  7502,
  3347,
  7503,
  7504,
  7505,
  7506,
  // 7184
  7507,
  7508,
  7509,
  7510,
  7511,
  7512,
  7513,
  7514,
  7515,
  7516,
  7517,
  7518,
  7519,
  7520,
  7521,
  4848,
  // 7200
  7522,
  7523,
  7524,
  7525,
  7526,
  7527,
  7528,
  7529,
  7530,
  7531,
  7532,
  7533,
  7534,
  7535,
  7536,
  7537,
  // 7216
  7538,
  7539,
  7540,
  7541,
  7542,
  7543,
  7544,
  7545,
  7546,
  7547,
  7548,
  7549,
  3801,
  4849,
  7550,
  7551,
  // 7232
  7552,
  7553,
  7554,
  7555,
  7556,
  7557,
  7558,
  7559,
  7560,
  7561,
  7562,
  7563,
  7564,
  7565,
  7566,
  7567,
  // 7248
  7568,
  7569,
  3035,
  7570,
  7571,
  7572,
  7573,
  7574,
  7575,
  7576,
  7577,
  7578,
  7579,
  7580,
  7581,
  7582,
  // 7264
  7583,
  7584,
  7585,
  7586,
  7587,
  7588,
  7589,
  7590,
  7591,
  7592,
  7593,
  7594,
  7595,
  7596,
  7597,
  7598,
  // 7280
  7599,
  7600,
  7601,
  7602,
  7603,
  7604,
  7605,
  7606,
  7607,
  7608,
  7609,
  7610,
  7611,
  7612,
  7613,
  7614,
  // 7296
  7615,
  7616,
  4850,
  7617,
  7618,
  3802,
  7619,
  7620,
  7621,
  7622,
  7623,
  7624,
  7625,
  7626,
  7627,
  7628,
  // 7312
  7629,
  7630,
  7631,
  7632,
  4851,
  7633,
  7634,
  7635,
  7636,
  7637,
  7638,
  7639,
  7640,
  7641,
  7642,
  7643,
  // 7328
  7644,
  7645,
  7646,
  7647,
  7648,
  7649,
  7650,
  7651,
  7652,
  7653,
  7654,
  7655,
  7656,
  7657,
  7658,
  7659,
  // 7344
  7660,
  7661,
  7662,
  7663,
  7664,
  7665,
  7666,
  7667,
  7668,
  7669,
  7670,
  4453,
  7671,
  7672,
  7673,
  7674,
  // 7360
  7675,
  7676,
  7677,
  7678,
  7679,
  7680,
  7681,
  7682,
  7683,
  7684,
  7685,
  7686,
  7687,
  7688,
  7689,
  7690,
  // 7376
  7691,
  7692,
  7693,
  7694,
  7695,
  7696,
  7697,
  3443,
  7698,
  7699,
  7700,
  7701,
  7702,
  4454,
  7703,
  7704,
  // 7392
  7705,
  7706,
  7707,
  7708,
  7709,
  7710,
  7711,
  7712,
  7713,
  2472,
  7714,
  7715,
  7716,
  7717,
  7718,
  7719,
  // 7408
  7720,
  7721,
  7722,
  7723,
  7724,
  7725,
  7726,
  7727,
  7728,
  7729,
  7730,
  7731,
  3954,
  7732,
  7733,
  7734,
  // 7424
  7735,
  7736,
  7737,
  7738,
  7739,
  7740,
  7741,
  7742,
  7743,
  7744,
  7745,
  7746,
  7747,
  7748,
  7749,
  7750,
  // 7440
  3134,
  7751,
  7752,
  4852,
  7753,
  7754,
  7755,
  4853,
  7756,
  7757,
  7758,
  7759,
  7760,
  4174,
  7761,
  7762,
  // 7456
  7763,
  7764,
  7765,
  7766,
  7767,
  7768,
  7769,
  7770,
  7771,
  7772,
  7773,
  7774,
  7775,
  7776,
  7777,
  7778,
  // 7472
  7779,
  7780,
  7781,
  7782,
  7783,
  7784,
  7785,
  7786,
  7787,
  7788,
  7789,
  7790,
  7791,
  7792,
  7793,
  7794,
  // 7488
  7795,
  7796,
  7797,
  7798,
  7799,
  7800,
  7801,
  7802,
  7803,
  7804,
  7805,
  4854,
  7806,
  7807,
  7808,
  7809,
  // 7504
  7810,
  7811,
  7812,
  7813,
  7814,
  7815,
  7816,
  7817,
  7818,
  7819,
  7820,
  7821,
  7822,
  7823,
  7824,
  7825,
  // 7520
  4855,
  7826,
  7827,
  7828,
  7829,
  7830,
  7831,
  7832,
  7833,
  7834,
  7835,
  7836,
  7837,
  7838,
  7839,
  7840,
  // 7536
  7841,
  7842,
  7843,
  7844,
  7845,
  7846,
  7847,
  3955,
  7848,
  7849,
  7850,
  7851,
  7852,
  7853,
  7854,
  7855,
  // 7552
  7856,
  7857,
  7858,
  7859,
  7860,
  3444,
  7861,
  7862,
  7863,
  7864,
  7865,
  7866,
  7867,
  7868,
  7869,
  7870,
  // 7568
  7871,
  7872,
  7873,
  7874,
  7875,
  7876,
  7877,
  7878,
  7879,
  7880,
  7881,
  7882,
  7883,
  7884,
  7885,
  7886,
  // 7584
  7887,
  7888,
  7889,
  7890,
  7891,
  4175,
  7892,
  7893,
  7894,
  7895,
  7896,
  4856,
  4857,
  7897,
  7898,
  7899,
  // 7600
  7900,
  2598,
  7901,
  7902,
  7903,
  7904,
  7905,
  7906,
  7907,
  7908,
  4455,
  7909,
  7910,
  7911,
  7912,
  7913,
  // 7616
  7914,
  3201,
  7915,
  7916,
  7917,
  7918,
  7919,
  7920,
  7921,
  4858,
  7922,
  7923,
  7924,
  7925,
  7926,
  7927,
  // 7632
  7928,
  7929,
  7930,
  7931,
  7932,
  7933,
  7934,
  7935,
  7936,
  7937,
  7938,
  7939,
  7940,
  7941,
  7942,
  7943,
  // 7648
  7944,
  7945,
  7946,
  7947,
  7948,
  7949,
  7950,
  7951,
  7952,
  7953,
  7954,
  7955,
  7956,
  7957,
  7958,
  7959,
  // 7664
  7960,
  7961,
  7962,
  7963,
  7964,
  7965,
  7966,
  7967,
  7968,
  7969,
  7970,
  7971,
  7972,
  7973,
  7974,
  7975,
  // 7680
  7976,
  7977,
  7978,
  7979,
  7980,
  7981,
  4859,
  7982,
  7983,
  7984,
  7985,
  7986,
  7987,
  7988,
  7989,
  7990,
  // 7696
  7991,
  7992,
  7993,
  7994,
  7995,
  7996,
  4860,
  7997,
  7998,
  7999,
  8e3,
  8001,
  8002,
  8003,
  8004,
  8005,
  // 7712
  8006,
  8007,
  8008,
  8009,
  8010,
  8011,
  8012,
  8013,
  8014,
  8015,
  8016,
  4176,
  8017,
  8018,
  8019,
  8020,
  // 7728
  8021,
  8022,
  8023,
  4861,
  8024,
  8025,
  8026,
  8027,
  8028,
  8029,
  8030,
  8031,
  8032,
  8033,
  8034,
  8035,
  // 7744
  8036,
  4862,
  4456,
  8037,
  8038,
  8039,
  8040,
  4863,
  8041,
  8042,
  8043,
  8044,
  8045,
  8046,
  8047,
  8048,
  // 7760
  8049,
  8050,
  8051,
  8052,
  8053,
  8054,
  8055,
  8056,
  8057,
  8058,
  8059,
  8060,
  8061,
  8062,
  8063,
  8064,
  // 7776
  8065,
  8066,
  8067,
  8068,
  8069,
  8070,
  8071,
  8072,
  8073,
  8074,
  8075,
  8076,
  8077,
  8078,
  8079,
  8080,
  // 7792
  8081,
  8082,
  8083,
  8084,
  8085,
  8086,
  8087,
  8088,
  8089,
  8090,
  8091,
  8092,
  8093,
  8094,
  8095,
  8096,
  // 7808
  8097,
  8098,
  8099,
  4864,
  4177,
  8100,
  8101,
  8102,
  8103,
  8104,
  8105,
  8106,
  8107,
  8108,
  8109,
  8110,
  // 7824
  8111,
  8112,
  8113,
  8114,
  8115,
  8116,
  8117,
  8118,
  8119,
  8120,
  4178,
  8121,
  8122,
  8123,
  8124,
  8125,
  // 7840
  8126,
  8127,
  8128,
  8129,
  8130,
  8131,
  8132,
  8133,
  8134,
  8135,
  8136,
  8137,
  8138,
  8139,
  8140,
  8141,
  // 7856
  8142,
  8143,
  8144,
  8145,
  4865,
  4866,
  8146,
  8147,
  8148,
  8149,
  8150,
  8151,
  8152,
  8153,
  8154,
  8155,
  // 7872
  8156,
  8157,
  8158,
  8159,
  8160,
  8161,
  8162,
  8163,
  8164,
  8165,
  4179,
  8166,
  8167,
  8168,
  8169,
  8170,
  // 7888
  8171,
  8172,
  8173,
  8174,
  8175,
  8176,
  8177,
  8178,
  8179,
  8180,
  8181,
  4457,
  8182,
  8183,
  8184,
  8185,
  // 7904
  8186,
  8187,
  8188,
  8189,
  8190,
  8191,
  8192,
  8193,
  8194,
  8195,
  8196,
  8197,
  8198,
  8199,
  8200,
  8201,
  // 7920
  8202,
  8203,
  8204,
  8205,
  8206,
  8207,
  8208,
  8209,
  8210,
  8211,
  8212,
  8213,
  8214,
  8215,
  8216,
  8217,
  // 7936
  8218,
  8219,
  8220,
  8221,
  8222,
  8223,
  8224,
  8225,
  8226,
  8227,
  8228,
  8229,
  8230,
  8231,
  8232,
  8233,
  // 7952
  8234,
  8235,
  8236,
  8237,
  8238,
  8239,
  8240,
  8241,
  8242,
  8243,
  8244,
  8245,
  8246,
  8247,
  8248,
  8249,
  // 7968
  8250,
  8251,
  8252,
  8253,
  8254,
  8255,
  8256,
  3445,
  8257,
  8258,
  8259,
  8260,
  8261,
  8262,
  4458,
  8263,
  // 7984
  8264,
  8265,
  8266,
  8267,
  8268,
  8269,
  8270,
  8271,
  8272,
  4459,
  8273,
  8274,
  8275,
  8276,
  3550,
  8277,
  // 8000
  8278,
  8279,
  8280,
  8281,
  8282,
  8283,
  8284,
  8285,
  8286,
  8287,
  8288,
  8289,
  4460,
  8290,
  8291,
  8292,
  // 8016
  8293,
  8294,
  8295,
  8296,
  8297,
  8298,
  8299,
  8300,
  8301,
  8302,
  8303,
  8304,
  8305,
  8306,
  8307,
  4867,
  // 8032
  8308,
  8309,
  8310,
  8311,
  8312,
  3551,
  8313,
  8314,
  8315,
  8316,
  8317,
  8318,
  8319,
  8320,
  8321,
  8322,
  // 8048
  8323,
  8324,
  8325,
  8326,
  4868,
  8327,
  8328,
  8329,
  8330,
  8331,
  8332,
  8333,
  8334,
  8335,
  8336,
  8337,
  // 8064
  8338,
  8339,
  8340,
  8341,
  8342,
  8343,
  8344,
  8345,
  8346,
  8347,
  8348,
  8349,
  8350,
  8351,
  8352,
  8353,
  // 8080
  8354,
  8355,
  8356,
  8357,
  8358,
  8359,
  8360,
  8361,
  8362,
  8363,
  4869,
  4461,
  8364,
  8365,
  8366,
  8367,
  // 8096
  8368,
  8369,
  8370,
  4870,
  8371,
  8372,
  8373,
  8374,
  8375,
  8376,
  8377,
  8378,
  8379,
  8380,
  8381,
  8382,
  // 8112
  8383,
  8384,
  8385,
  8386,
  8387,
  8388,
  8389,
  8390,
  8391,
  8392,
  8393,
  8394,
  8395,
  8396,
  8397,
  8398,
  // 8128
  8399,
  8400,
  8401,
  8402,
  8403,
  8404,
  8405,
  8406,
  8407,
  8408,
  8409,
  8410,
  4871,
  8411,
  8412,
  8413,
  // 8144
  8414,
  8415,
  8416,
  8417,
  8418,
  8419,
  8420,
  8421,
  8422,
  4462,
  8423,
  8424,
  8425,
  8426,
  8427,
  8428,
  // 8160
  8429,
  8430,
  8431,
  8432,
  8433,
  2986,
  8434,
  8435,
  8436,
  8437,
  8438,
  8439,
  8440,
  8441,
  8442,
  8443,
  // 8176
  8444,
  8445,
  8446,
  8447,
  8448,
  8449,
  8450,
  8451,
  8452,
  8453,
  8454,
  8455,
  8456,
  8457,
  8458,
  8459,
  // 8192
  8460,
  8461,
  8462,
  8463,
  8464,
  8465,
  8466,
  8467,
  8468,
  8469,
  8470,
  8471,
  8472,
  8473,
  8474,
  8475,
  // 8208
  8476,
  8477,
  8478,
  4180,
  8479,
  8480,
  8481,
  8482,
  8483,
  8484,
  8485,
  8486,
  8487,
  8488,
  8489,
  8490,
  // 8224
  8491,
  8492,
  8493,
  8494,
  8495,
  8496,
  8497,
  8498,
  8499,
  8500,
  8501,
  8502,
  8503,
  8504,
  8505,
  8506,
  // 8240
  8507,
  8508,
  8509,
  8510,
  8511,
  8512,
  8513,
  8514,
  8515,
  8516,
  8517,
  8518,
  8519,
  8520,
  8521,
  8522,
  // 8256
  8523,
  8524,
  8525,
  8526,
  8527,
  8528,
  8529,
  8530,
  8531,
  8532,
  8533,
  8534,
  8535,
  8536,
  8537,
  8538,
  // 8272
  8539,
  8540,
  8541,
  8542,
  8543,
  8544,
  8545,
  8546,
  8547,
  8548,
  8549,
  8550,
  8551,
  8552,
  8553,
  8554,
  // 8288
  8555,
  8556,
  8557,
  8558,
  8559,
  8560,
  8561,
  8562,
  8563,
  8564,
  4872,
  8565,
  8566,
  8567,
  8568,
  8569,
  // 8304
  8570,
  8571,
  8572,
  8573,
  4873,
  8574,
  8575,
  8576,
  8577,
  8578,
  8579,
  8580,
  8581,
  8582,
  8583,
  8584,
  // 8320
  8585,
  8586,
  8587,
  8588,
  8589,
  8590,
  8591,
  8592,
  8593,
  8594,
  8595,
  8596,
  8597,
  8598,
  8599,
  8600,
  // 8336
  8601,
  8602,
  8603,
  8604,
  8605,
  3803,
  8606,
  8607,
  8608,
  8609,
  8610,
  8611,
  8612,
  8613,
  4874,
  3804,
  // 8352
  8614,
  8615,
  8616,
  8617,
  8618,
  8619,
  8620,
  8621,
  3956,
  8622,
  8623,
  8624,
  8625,
  8626,
  8627,
  8628,
  // 8368
  8629,
  8630,
  8631,
  8632,
  8633,
  8634,
  8635,
  8636,
  8637,
  8638,
  2865,
  8639,
  8640,
  8641,
  8642,
  8643,
  // 8384
  8644,
  8645,
  8646,
  8647,
  8648,
  8649,
  8650,
  8651,
  8652,
  8653,
  8654,
  8655,
  8656,
  4463,
  8657,
  8658,
  // 8400
  8659,
  4875,
  4876,
  8660,
  8661,
  8662,
  8663,
  8664,
  8665,
  8666,
  8667,
  8668,
  8669,
  8670,
  8671,
  8672,
  // 8416
  8673,
  8674,
  8675,
  8676,
  8677,
  8678,
  8679,
  8680,
  8681,
  4464,
  8682,
  8683,
  8684,
  8685,
  8686,
  8687,
  // 8432
  8688,
  8689,
  8690,
  8691,
  8692,
  8693,
  8694,
  8695,
  8696,
  8697,
  8698,
  8699,
  8700,
  8701,
  8702,
  8703,
  // 8448
  8704,
  8705,
  8706,
  8707,
  8708,
  8709,
  2261,
  8710,
  8711,
  8712,
  8713,
  8714,
  8715,
  8716,
  8717,
  8718,
  // 8464
  8719,
  8720,
  8721,
  8722,
  8723,
  8724,
  8725,
  8726,
  8727,
  8728,
  8729,
  8730,
  8731,
  8732,
  8733,
  4181,
  // 8480
  8734,
  8735,
  8736,
  8737,
  8738,
  8739,
  8740,
  8741,
  8742,
  8743,
  8744,
  8745,
  8746,
  8747,
  8748,
  8749,
  // 8496
  8750,
  8751,
  8752,
  8753,
  8754,
  8755,
  8756,
  8757,
  8758,
  8759,
  8760,
  8761,
  8762,
  8763,
  4877,
  8764,
  // 8512
  8765,
  8766,
  8767,
  8768,
  8769,
  8770,
  8771,
  8772,
  8773,
  8774,
  8775,
  8776,
  8777,
  8778,
  8779,
  8780,
  // 8528
  8781,
  8782,
  8783,
  8784,
  8785,
  8786,
  8787,
  8788,
  4878,
  8789,
  4879,
  8790,
  8791,
  8792,
  4880,
  8793,
  // 8544
  8794,
  8795,
  8796,
  8797,
  8798,
  8799,
  8800,
  8801,
  4881,
  8802,
  8803,
  8804,
  8805,
  8806,
  8807,
  8808,
  // 8560
  8809,
  8810,
  8811,
  8812,
  8813,
  8814,
  8815,
  3957,
  8816,
  8817,
  8818,
  8819,
  8820,
  8821,
  8822,
  8823,
  // 8576
  8824,
  8825,
  8826,
  8827,
  8828,
  8829,
  8830,
  8831,
  8832,
  8833,
  8834,
  8835,
  8836,
  8837,
  8838,
  8839,
  // 8592
  8840,
  8841,
  8842,
  8843,
  8844,
  8845,
  8846,
  8847,
  4882,
  8848,
  8849,
  8850,
  8851,
  8852,
  8853,
  8854,
  // 8608
  8855,
  8856,
  8857,
  8858,
  8859,
  8860,
  8861,
  8862,
  8863,
  8864,
  8865,
  8866,
  8867,
  8868,
  8869,
  8870,
  // 8624
  8871,
  8872,
  8873,
  8874,
  8875,
  8876,
  8877,
  8878,
  8879,
  8880,
  8881,
  8882,
  8883,
  8884,
  3202,
  8885,
  // 8640
  8886,
  8887,
  8888,
  8889,
  8890,
  8891,
  8892,
  8893,
  8894,
  8895,
  8896,
  8897,
  8898,
  8899,
  8900,
  8901,
  // 8656
  8902,
  8903,
  8904,
  8905,
  8906,
  8907,
  8908,
  8909,
  8910,
  8911,
  8912,
  8913,
  8914,
  8915,
  8916,
  8917,
  // 8672
  8918,
  8919,
  8920,
  8921,
  8922,
  8923,
  8924,
  4465,
  8925,
  8926,
  8927,
  8928,
  8929,
  8930,
  8931,
  8932,
  // 8688
  4883,
  8933,
  8934,
  8935,
  8936,
  8937,
  8938,
  8939,
  8940,
  8941,
  8942,
  8943,
  2214,
  8944,
  8945,
  8946,
  // 8704
  8947,
  8948,
  8949,
  8950,
  8951,
  8952,
  8953,
  8954,
  8955,
  8956,
  8957,
  8958,
  8959,
  8960,
  8961,
  8962,
  // 8720
  8963,
  8964,
  8965,
  4884,
  8966,
  8967,
  8968,
  8969,
  8970,
  8971,
  8972,
  8973,
  8974,
  8975,
  8976,
  8977,
  // 8736
  8978,
  8979,
  8980,
  8981,
  8982,
  8983,
  8984,
  8985,
  8986,
  8987,
  8988,
  8989,
  8990,
  8991,
  8992,
  4885,
  // 8752
  8993,
  8994,
  8995,
  8996,
  8997,
  8998,
  8999,
  9e3,
  9001,
  9002,
  9003,
  9004,
  9005,
  9006,
  9007,
  9008,
  // 8768
  9009,
  9010,
  9011,
  9012,
  9013,
  9014,
  9015,
  9016,
  9017,
  9018,
  9019,
  9020,
  9021,
  4182,
  9022,
  9023,
  // 8784
  9024,
  9025,
  9026,
  9027,
  9028,
  9029,
  9030,
  9031,
  9032,
  9033,
  9034,
  9035,
  9036,
  9037,
  9038,
  9039,
  // 8800
  9040,
  9041,
  9042,
  9043,
  9044,
  9045,
  9046,
  9047,
  9048,
  9049,
  9050,
  9051,
  9052,
  9053,
  9054,
  9055,
  // 8816
  9056,
  9057,
  9058,
  9059,
  9060,
  9061,
  9062,
  9063,
  4886,
  9064,
  9065,
  9066,
  9067,
  9068,
  9069,
  4887,
  // 8832
  9070,
  9071,
  9072,
  9073,
  9074,
  9075,
  9076,
  9077,
  9078,
  9079,
  9080,
  9081,
  9082,
  9083,
  9084,
  9085,
  // 8848
  9086,
  9087,
  9088,
  9089,
  9090,
  9091,
  9092,
  9093,
  9094,
  9095,
  9096,
  9097,
  9098,
  9099,
  9100,
  9101,
  // 8864
  9102,
  9103,
  9104,
  9105,
  9106,
  9107,
  9108,
  9109,
  9110,
  9111,
  9112,
  9113,
  9114,
  9115,
  9116,
  9117,
  // 8880
  9118,
  9119,
  9120,
  9121,
  9122,
  9123,
  9124,
  9125,
  9126,
  9127,
  9128,
  9129,
  9130,
  9131,
  9132,
  9133,
  // 8896
  9134,
  9135,
  9136,
  9137,
  9138,
  9139,
  9140,
  9141,
  3958,
  9142,
  9143,
  9144,
  9145,
  9146,
  9147,
  9148,
  // 8912
  9149,
  9150,
  9151,
  4888,
  9152,
  9153,
  9154,
  9155,
  9156,
  9157,
  9158,
  9159,
  9160,
  9161,
  9162,
  9163,
  // 8928
  9164,
  9165,
  9166,
  9167,
  9168,
  9169,
  9170,
  9171,
  9172,
  9173,
  9174,
  9175,
  4889,
  9176,
  9177,
  9178,
  // 8944
  9179,
  9180,
  9181,
  9182,
  9183,
  9184,
  9185,
  9186,
  9187,
  9188,
  9189,
  9190,
  9191,
  9192,
  9193,
  9194,
  // 8960
  9195,
  9196,
  9197,
  9198,
  9199,
  9200,
  9201,
  9202,
  9203,
  4890,
  9204,
  9205,
  9206,
  9207,
  9208,
  9209,
  // 8976
  9210,
  9211,
  9212,
  9213,
  9214,
  9215,
  9216,
  9217,
  9218,
  9219,
  9220,
  9221,
  9222,
  4466,
  9223,
  9224,
  // 8992
  9225,
  9226,
  9227,
  9228,
  9229,
  9230,
  9231,
  9232,
  9233,
  9234,
  9235,
  9236,
  9237,
  9238,
  9239,
  9240,
  // 9008
  9241,
  9242,
  9243,
  9244,
  9245,
  4891,
  9246,
  9247,
  9248,
  9249,
  9250,
  9251,
  9252,
  9253,
  9254,
  9255,
  // 9024
  9256,
  9257,
  4892,
  9258,
  9259,
  9260,
  9261,
  4893,
  4894,
  9262,
  9263,
  9264,
  9265,
  9266,
  9267,
  9268,
  // 9040
  9269,
  9270,
  9271,
  9272,
  9273,
  4467,
  9274,
  9275,
  9276,
  9277,
  9278,
  9279,
  9280,
  9281,
  9282,
  9283,
  // 9056
  9284,
  9285,
  3673,
  9286,
  9287,
  9288,
  9289,
  9290,
  9291,
  9292,
  9293,
  9294,
  9295,
  9296,
  9297,
  9298,
  // 9072
  9299,
  9300,
  9301,
  9302,
  9303,
  9304,
  9305,
  9306,
  9307,
  9308,
  9309,
  9310,
  9311,
  9312,
  9313,
  9314,
  // 9088
  9315,
  9316,
  9317,
  9318,
  9319,
  9320,
  9321,
  9322,
  4895,
  9323,
  9324,
  9325,
  9326,
  9327,
  9328,
  9329,
  // 9104
  9330,
  9331,
  9332,
  9333,
  9334,
  9335,
  9336,
  9337,
  9338,
  9339,
  9340,
  9341,
  9342,
  9343,
  9344,
  9345,
  // 9120
  9346,
  9347,
  4468,
  9348,
  9349,
  9350,
  9351,
  9352,
  9353,
  9354,
  9355,
  9356,
  9357,
  9358,
  9359,
  9360,
  // 9136
  9361,
  9362,
  9363,
  9364,
  9365,
  9366,
  9367,
  9368,
  9369,
  9370,
  9371,
  9372,
  9373,
  4896,
  9374,
  4469,
  // 9152
  9375,
  9376,
  9377,
  9378,
  9379,
  4897,
  9380,
  9381,
  9382,
  9383,
  9384,
  9385,
  9386,
  9387,
  9388,
  9389,
  // 9168
  9390,
  9391,
  9392,
  9393,
  9394,
  9395,
  9396,
  9397,
  9398,
  9399,
  9400,
  9401,
  9402,
  9403,
  9404,
  9405,
  // 9184
  9406,
  4470,
  9407,
  2751,
  9408,
  9409,
  3674,
  3552,
  9410,
  9411,
  9412,
  9413,
  9414,
  9415,
  9416,
  9417,
  // 9200
  9418,
  9419,
  9420,
  9421,
  4898,
  9422,
  9423,
  9424,
  9425,
  9426,
  9427,
  9428,
  9429,
  3959,
  9430,
  9431,
  // 9216
  9432,
  9433,
  9434,
  9435,
  9436,
  4471,
  9437,
  9438,
  9439,
  9440,
  9441,
  9442,
  9443,
  9444,
  9445,
  9446,
  // 9232
  9447,
  9448,
  9449,
  9450,
  3348,
  9451,
  9452,
  9453,
  9454,
  9455,
  9456,
  9457,
  9458,
  9459,
  9460,
  9461,
  // 9248
  9462,
  9463,
  9464,
  9465,
  9466,
  9467,
  9468,
  9469,
  9470,
  9471,
  9472,
  4899,
  9473,
  9474,
  9475,
  9476,
  // 9264
  9477,
  4900,
  9478,
  9479,
  9480,
  9481,
  9482,
  9483,
  9484,
  9485,
  9486,
  9487,
  9488,
  3349,
  9489,
  9490,
  // 9280
  9491,
  9492,
  9493,
  9494,
  9495,
  9496,
  9497,
  9498,
  9499,
  9500,
  9501,
  9502,
  9503,
  9504,
  9505,
  9506,
  // 9296
  9507,
  9508,
  9509,
  9510,
  9511,
  9512,
  9513,
  9514,
  9515,
  9516,
  9517,
  9518,
  9519,
  9520,
  4901,
  9521,
  // 9312
  9522,
  9523,
  9524,
  9525,
  9526,
  4902,
  9527,
  9528,
  9529,
  9530,
  9531,
  9532,
  9533,
  9534,
  9535,
  9536,
  // 9328
  9537,
  9538,
  9539,
  9540,
  9541,
  9542,
  9543,
  9544,
  9545,
  9546,
  9547,
  9548,
  9549,
  9550,
  9551,
  9552,
  // 9344
  9553,
  9554,
  9555,
  9556,
  9557,
  9558,
  9559,
  9560,
  9561,
  9562,
  9563,
  9564,
  9565,
  9566,
  9567,
  9568,
  // 9360
  9569,
  9570,
  9571,
  9572,
  9573,
  9574,
  9575,
  9576,
  9577,
  9578,
  9579,
  9580,
  9581,
  9582,
  9583,
  9584,
  // 9376
  3805,
  9585,
  9586,
  9587,
  9588,
  9589,
  9590,
  9591,
  9592,
  9593,
  9594,
  9595,
  9596,
  9597,
  9598,
  9599,
  // 9392
  9600,
  9601,
  9602,
  4903,
  9603,
  9604,
  9605,
  9606,
  9607,
  4904,
  9608,
  9609,
  9610,
  9611,
  9612,
  9613,
  // 9408
  9614,
  4905,
  9615,
  9616,
  9617,
  9618,
  9619,
  9620,
  9621,
  9622,
  9623,
  9624,
  9625,
  9626,
  9627,
  9628,
  // 9424
  9629,
  9630,
  9631,
  9632,
  4906,
  9633,
  9634,
  9635,
  9636,
  9637,
  9638,
  9639,
  9640,
  9641,
  9642,
  9643,
  // 9440
  4907,
  9644,
  9645,
  9646,
  9647,
  9648,
  9649,
  9650,
  9651,
  9652,
  9653,
  9654,
  9655,
  9656,
  9657,
  9658,
  // 9456
  9659,
  9660,
  9661,
  9662,
  9663,
  9664,
  9665,
  9666,
  9667,
  9668,
  9669,
  9670,
  9671,
  9672,
  4183,
  9673,
  // 9472
  9674,
  9675,
  9676,
  9677,
  4908,
  9678,
  9679,
  9680,
  9681,
  4909,
  9682,
  9683,
  9684,
  9685,
  9686,
  9687,
  // 9488
  9688,
  9689,
  9690,
  4910,
  9691,
  9692,
  9693,
  3675,
  9694,
  9695,
  9696,
  2945,
  9697,
  9698,
  9699,
  9700,
  // 9504
  9701,
  9702,
  9703,
  9704,
  9705,
  4911,
  9706,
  9707,
  9708,
  9709,
  9710,
  9711,
  9712,
  9713,
  9714,
  9715,
  // 9520
  9716,
  9717,
  9718,
  9719,
  9720,
  9721,
  9722,
  9723,
  9724,
  9725,
  9726,
  9727,
  9728,
  9729,
  9730,
  9731,
  // 9536
  9732,
  9733,
  9734,
  9735,
  4912,
  9736,
  9737,
  9738,
  9739,
  9740,
  4913,
  9741,
  9742,
  9743,
  9744,
  9745,
  // 9552
  9746,
  9747,
  9748,
  9749,
  9750,
  9751,
  9752,
  9753,
  9754,
  9755,
  9756,
  9757,
  9758,
  4914,
  9759,
  9760,
  // 9568
  9761,
  9762,
  9763,
  9764,
  9765,
  9766,
  9767,
  9768,
  9769,
  9770,
  9771,
  9772,
  9773,
  9774,
  9775,
  9776,
  // 9584
  9777,
  9778,
  9779,
  9780,
  9781,
  9782,
  4915,
  9783,
  9784,
  9785,
  9786,
  9787,
  9788,
  9789,
  9790,
  9791,
  // 9600
  9792,
  9793,
  4916,
  9794,
  9795,
  9796,
  9797,
  9798,
  9799,
  9800,
  9801,
  9802,
  9803,
  9804,
  9805,
  9806,
  // 9616
  9807,
  9808,
  9809,
  9810,
  9811,
  9812,
  9813,
  9814,
  9815,
  9816,
  9817,
  9818,
  9819,
  9820,
  9821,
  9822,
  // 9632
  9823,
  9824,
  9825,
  9826,
  9827,
  9828,
  9829,
  9830,
  9831,
  9832,
  9833,
  9834,
  9835,
  9836,
  9837,
  9838,
  // 9648
  9839,
  9840,
  9841,
  9842,
  9843,
  9844,
  9845,
  9846,
  9847,
  9848,
  9849,
  9850,
  9851,
  9852,
  9853,
  9854,
  // 9664
  9855,
  9856,
  9857,
  9858,
  9859,
  9860,
  9861,
  9862,
  9863,
  9864,
  9865,
  9866,
  9867,
  9868,
  4917,
  9869,
  // 9680
  9870,
  9871,
  9872,
  9873,
  9874,
  9875,
  9876,
  9877,
  9878,
  9879,
  9880,
  9881,
  9882,
  9883,
  9884,
  9885,
  // 9696
  9886,
  9887,
  9888,
  9889,
  9890,
  9891,
  9892,
  4472,
  9893,
  9894,
  9895,
  9896,
  9897,
  3806,
  9898,
  9899,
  // 9712
  9900,
  9901,
  9902,
  9903,
  9904,
  9905,
  9906,
  9907,
  9908,
  9909,
  9910,
  9911,
  9912,
  9913,
  9914,
  4918,
  // 9728
  9915,
  9916,
  9917,
  4919,
  9918,
  9919,
  9920,
  9921,
  4184,
  9922,
  9923,
  9924,
  9925,
  9926,
  9927,
  9928,
  // 9744
  9929,
  9930,
  9931,
  9932,
  9933,
  9934,
  9935,
  9936,
  9937,
  9938,
  9939,
  9940,
  9941,
  9942,
  9943,
  9944,
  // 9760
  9945,
  9946,
  4920,
  9947,
  9948,
  9949,
  9950,
  9951,
  9952,
  9953,
  9954,
  9955,
  4185,
  9956,
  9957,
  9958,
  // 9776
  9959,
  9960,
  9961,
  9962,
  9963,
  9964,
  9965,
  4921,
  9966,
  9967,
  9968,
  4473,
  9969,
  9970,
  9971,
  9972,
  // 9792
  9973,
  9974,
  9975,
  9976,
  9977,
  4474,
  9978,
  9979,
  9980,
  9981,
  9982,
  9983,
  9984,
  9985,
  9986,
  9987,
  // 9808
  9988,
  9989,
  9990,
  9991,
  9992,
  9993,
  9994,
  9995,
  9996,
  9997,
  9998,
  9999,
  1e4,
  10001,
  10002,
  10003,
  // 9824
  10004,
  10005,
  10006,
  10007,
  10008,
  10009,
  10010,
  10011,
  10012,
  10013,
  10014,
  10015,
  10016,
  10017,
  10018,
  10019,
  // 9840
  10020,
  10021,
  4922,
  10022,
  4923,
  10023,
  10024,
  10025,
  10026,
  10027,
  10028,
  10029,
  10030,
  10031,
  10032,
  10033,
  // 9856
  10034,
  10035,
  10036,
  10037,
  10038,
  10039,
  10040,
  10041,
  10042,
  10043,
  10044,
  10045,
  10046,
  10047,
  10048,
  4924,
  // 9872
  10049,
  10050,
  10051,
  10052,
  10053,
  10054,
  10055,
  10056,
  10057,
  10058,
  10059,
  10060,
  10061,
  10062,
  10063,
  10064,
  // 9888
  10065,
  10066,
  10067,
  10068,
  10069,
  10070,
  10071,
  10072,
  10073,
  10074,
  10075,
  10076,
  10077,
  10078,
  10079,
  10080,
  // 9904
  10081,
  10082,
  10083,
  10084,
  10085,
  10086,
  10087,
  4475,
  10088,
  10089,
  10090,
  10091,
  10092,
  10093,
  10094,
  10095,
  // 9920
  10096,
  10097,
  4476,
  10098,
  10099,
  10100,
  10101,
  10102,
  10103,
  10104,
  10105,
  10106,
  10107,
  10108,
  10109,
  10110,
  // 9936
  10111,
  2174,
  10112,
  10113,
  10114,
  10115,
  10116,
  10117,
  10118,
  10119,
  10120,
  10121,
  10122,
  10123,
  10124,
  10125,
  // 9952
  10126,
  10127,
  10128,
  10129,
  10130,
  10131,
  10132,
  10133,
  10134,
  10135,
  10136,
  10137,
  10138,
  10139,
  10140,
  3807,
  // 9968
  4186,
  4925,
  10141,
  10142,
  10143,
  10144,
  10145,
  10146,
  10147,
  4477,
  4187,
  10148,
  10149,
  10150,
  10151,
  10152,
  // 9984
  10153,
  4188,
  10154,
  10155,
  10156,
  10157,
  10158,
  10159,
  10160,
  10161,
  4926,
  10162,
  10163,
  10164,
  10165,
  10166,
  //10000
  10167,
  10168,
  10169,
  10170,
  10171,
  10172,
  10173,
  10174,
  10175,
  10176,
  10177,
  10178,
  10179,
  10180,
  10181,
  10182,
  //10016
  10183,
  10184,
  10185,
  10186,
  10187,
  10188,
  10189,
  10190,
  10191,
  10192,
  3203,
  10193,
  10194,
  10195,
  10196,
  10197,
  //10032
  10198,
  10199,
  10200,
  4478,
  10201,
  10202,
  10203,
  10204,
  4479,
  10205,
  10206,
  10207,
  10208,
  10209,
  10210,
  10211,
  //10048
  10212,
  10213,
  10214,
  10215,
  10216,
  10217,
  10218,
  10219,
  10220,
  10221,
  10222,
  10223,
  10224,
  10225,
  10226,
  10227,
  //10064
  10228,
  10229,
  10230,
  10231,
  10232,
  10233,
  10234,
  4927,
  10235,
  10236,
  10237,
  10238,
  10239,
  10240,
  10241,
  10242,
  //10080
  10243,
  10244,
  10245,
  10246,
  10247,
  10248,
  10249,
  10250,
  10251,
  10252,
  10253,
  10254,
  10255,
  10256,
  10257,
  10258,
  //10096
  10259,
  10260,
  10261,
  10262,
  10263,
  10264,
  10265,
  10266,
  10267,
  10268,
  10269,
  10270,
  10271,
  10272,
  10273,
  4480,
  //10112
  4928,
  4929,
  10274,
  10275,
  10276,
  10277,
  10278,
  10279,
  10280,
  10281,
  10282,
  10283,
  10284,
  10285,
  10286,
  10287,
  //10128
  10288,
  10289,
  10290,
  10291,
  10292,
  10293,
  10294,
  10295,
  10296,
  10297,
  10298,
  10299,
  10300,
  10301,
  10302,
  10303,
  //10144
  10304,
  10305,
  10306,
  10307,
  10308,
  10309,
  10310,
  10311,
  10312,
  10313,
  10314,
  10315,
  10316,
  10317,
  10318,
  10319,
  //10160
  10320,
  10321,
  10322,
  10323,
  10324,
  10325,
  10326,
  10327,
  10328,
  10329,
  10330,
  10331,
  10332,
  10333,
  10334,
  4930,
  //10176
  10335,
  10336,
  10337,
  10338,
  10339,
  10340,
  10341,
  10342,
  4931,
  10343,
  10344,
  10345,
  10346,
  10347,
  10348,
  10349,
  //10192
  10350,
  10351,
  10352,
  10353,
  10354,
  10355,
  3088,
  10356,
  2786,
  10357,
  10358,
  10359,
  10360,
  4189,
  10361,
  10362,
  //10208
  10363,
  10364,
  10365,
  10366,
  10367,
  10368,
  10369,
  10370,
  10371,
  10372,
  10373,
  10374,
  10375,
  4932,
  10376,
  10377,
  //10224
  10378,
  10379,
  10380,
  10381,
  10382,
  10383,
  10384,
  10385,
  10386,
  10387,
  10388,
  10389,
  10390,
  10391,
  10392,
  4933,
  //10240
  10393,
  10394,
  10395,
  4934,
  10396,
  10397,
  10398,
  10399,
  10400,
  10401,
  10402,
  10403,
  10404,
  10405,
  10406,
  10407,
  //10256
  10408,
  10409,
  10410,
  10411,
  10412,
  3446,
  10413,
  10414,
  10415,
  10416,
  10417,
  10418,
  10419,
  10420,
  10421,
  10422,
  //10272
  10423,
  4935,
  10424,
  10425,
  10426,
  10427,
  10428,
  10429,
  10430,
  4936,
  10431,
  10432,
  10433,
  10434,
  10435,
  10436,
  //10288
  10437,
  10438,
  10439,
  10440,
  10441,
  10442,
  10443,
  4937,
  10444,
  10445,
  10446,
  10447,
  4481,
  10448,
  10449,
  10450,
  //10304
  10451,
  10452,
  10453,
  10454,
  10455,
  10456,
  10457,
  10458,
  10459,
  10460,
  10461,
  10462,
  10463,
  10464,
  10465,
  10466,
  //10320
  10467,
  10468,
  10469,
  10470,
  10471,
  10472,
  10473,
  10474,
  10475,
  10476,
  10477,
  10478,
  10479,
  10480,
  10481,
  10482,
  //10336
  10483,
  10484,
  10485,
  10486,
  10487,
  10488,
  10489,
  10490,
  10491,
  10492,
  10493,
  10494,
  10495,
  10496,
  10497,
  10498,
  //10352
  10499,
  10500,
  10501,
  10502,
  10503,
  10504,
  10505,
  4938,
  10506,
  10507,
  10508,
  10509,
  10510,
  2552,
  10511,
  10512,
  //10368
  10513,
  10514,
  10515,
  10516,
  3447,
  10517,
  10518,
  10519,
  10520,
  10521,
  10522,
  10523,
  10524,
  10525,
  10526,
  10527,
  //10384
  10528,
  10529,
  10530,
  10531,
  10532,
  10533,
  10534,
  10535,
  10536,
  10537,
  10538,
  10539,
  10540,
  10541,
  10542,
  10543,
  //10400
  4482,
  10544,
  4939,
  10545,
  10546,
  10547,
  10548,
  10549,
  10550,
  10551,
  10552,
  10553,
  10554,
  10555,
  10556,
  10557,
  //10416
  10558,
  10559,
  10560,
  10561,
  10562,
  10563,
  10564,
  10565,
  10566,
  10567,
  3676,
  4483,
  10568,
  10569,
  10570,
  10571,
  //10432
  10572,
  3448,
  10573,
  10574,
  10575,
  10576,
  10577,
  10578,
  10579,
  10580,
  10581,
  10582,
  10583,
  10584,
  10585,
  10586,
  //10448
  10587,
  10588,
  10589,
  10590,
  10591,
  10592,
  10593,
  10594,
  10595,
  10596,
  10597,
  10598,
  10599,
  10600,
  10601,
  10602,
  //10464
  10603,
  10604,
  10605,
  10606,
  10607,
  10608,
  10609,
  10610,
  10611,
  10612,
  10613,
  10614,
  10615,
  10616,
  10617,
  10618,
  //10480
  10619,
  10620,
  10621,
  10622,
  10623,
  10624,
  10625,
  10626,
  10627,
  4484,
  10628,
  10629,
  10630,
  10631,
  10632,
  4940,
  //10496
  10633,
  10634,
  10635,
  10636,
  10637,
  10638,
  10639,
  10640,
  10641,
  10642,
  10643,
  10644,
  10645,
  10646,
  10647,
  10648,
  //10512
  10649,
  10650,
  10651,
  10652,
  10653,
  10654,
  10655,
  10656,
  4941,
  10657,
  10658,
  10659,
  2599,
  10660,
  10661,
  10662,
  //10528
  10663,
  10664,
  10665,
  10666,
  3089,
  10667,
  10668,
  10669,
  10670,
  10671,
  10672,
  10673,
  10674,
  10675,
  10676,
  10677,
  //10544
  10678,
  10679,
  10680,
  4942,
  10681,
  10682,
  10683,
  10684,
  10685,
  10686,
  10687,
  10688,
  10689,
  10690,
  10691,
  10692,
  //10560
  10693,
  10694,
  10695,
  10696,
  10697,
  4485,
  10698,
  10699,
  10700,
  10701,
  10702,
  10703,
  10704,
  4943,
  10705,
  3677,
  //10576
  10706,
  10707,
  10708,
  10709,
  10710,
  10711,
  10712,
  4944,
  10713,
  10714,
  10715,
  10716,
  10717,
  10718,
  10719,
  10720,
  //10592
  10721,
  10722,
  10723,
  10724,
  10725,
  10726,
  10727,
  10728,
  4945,
  10729,
  10730,
  10731,
  10732,
  10733,
  10734,
  10735,
  //10608
  10736,
  10737,
  10738,
  10739,
  10740,
  10741,
  10742,
  10743,
  10744,
  10745,
  10746,
  10747,
  10748,
  10749,
  10750,
  10751,
  //10624
  10752,
  10753,
  10754,
  10755,
  10756,
  10757,
  10758,
  10759,
  10760,
  10761,
  4946,
  10762,
  10763,
  10764,
  10765,
  10766,
  //10640
  10767,
  4947,
  4948,
  10768,
  10769,
  10770,
  10771,
  10772,
  10773,
  10774,
  10775,
  10776,
  10777,
  10778,
  10779,
  10780,
  //10656
  10781,
  10782,
  10783,
  10784,
  10785,
  10786,
  10787,
  10788,
  10789,
  10790,
  10791,
  10792,
  10793,
  10794,
  10795,
  10796,
  //10672
  10797,
  10798,
  10799,
  10800,
  10801,
  10802,
  10803,
  10804,
  10805,
  10806,
  10807,
  10808,
  10809,
  10810,
  10811,
  10812,
  //10688
  10813,
  10814,
  10815,
  10816,
  10817,
  10818,
  10819,
  10820,
  10821,
  10822,
  10823,
  10824,
  10825,
  10826,
  10827,
  10828,
  //10704
  10829,
  10830,
  10831,
  10832,
  10833,
  10834,
  10835,
  10836,
  10837,
  10838,
  10839,
  10840,
  10841,
  10842,
  10843,
  10844,
  //10720
  10845,
  10846,
  10847,
  10848,
  10849,
  10850,
  10851,
  10852,
  10853,
  10854,
  10855,
  10856,
  10857,
  10858,
  10859,
  10860,
  //10736
  10861,
  10862,
  10863,
  10864,
  10865,
  10866,
  10867,
  10868,
  10869,
  10870,
  10871,
  10872,
  10873,
  10874,
  10875,
  10876,
  //10752
  10877,
  10878,
  4486,
  10879,
  10880,
  10881,
  10882,
  10883,
  10884,
  10885,
  4949,
  10886,
  10887,
  10888,
  10889,
  10890,
  //10768
  10891,
  10892,
  10893,
  10894,
  10895,
  10896,
  10897,
  10898,
  10899,
  10900,
  10901,
  10902,
  10903,
  10904,
  10905,
  10906,
  //10784
  10907,
  10908,
  10909,
  10910,
  10911,
  10912,
  10913,
  10914,
  10915,
  10916,
  10917,
  10918,
  10919,
  4487,
  10920,
  10921,
  //10800
  10922,
  10923,
  10924,
  10925,
  10926,
  10927,
  10928,
  10929,
  10930,
  10931,
  10932,
  4950,
  10933,
  10934,
  10935,
  10936,
  //10816
  10937,
  10938,
  10939,
  10940,
  10941,
  10942,
  10943,
  10944,
  10945,
  10946,
  10947,
  10948,
  10949,
  4488,
  10950,
  10951,
  //10832
  10952,
  10953,
  10954,
  10955,
  10956,
  10957,
  10958,
  10959,
  4190,
  10960,
  10961,
  10962,
  10963,
  10964,
  10965,
  10966,
  //10848
  10967,
  10968,
  10969,
  10970,
  10971,
  10972,
  10973,
  10974,
  10975,
  10976,
  10977,
  10978,
  10979,
  10980,
  10981,
  10982,
  //10864
  10983,
  10984,
  10985,
  10986,
  10987,
  10988,
  10989,
  10990,
  10991,
  10992,
  10993,
  10994,
  10995,
  10996,
  10997,
  10998,
  //10880
  10999,
  11e3,
  11001,
  11002,
  11003,
  11004,
  11005,
  11006,
  3960,
  11007,
  11008,
  11009,
  11010,
  11011,
  11012,
  11013,
  //10896
  11014,
  11015,
  11016,
  11017,
  11018,
  11019,
  11020,
  11021,
  11022,
  11023,
  11024,
  11025,
  11026,
  11027,
  11028,
  11029,
  //10912
  11030,
  11031,
  11032,
  4951,
  11033,
  11034,
  11035,
  11036,
  11037,
  11038,
  11039,
  11040,
  11041,
  11042,
  11043,
  11044,
  //10928
  11045,
  11046,
  11047,
  4489,
  11048,
  11049,
  11050,
  11051,
  4952,
  11052,
  11053,
  11054,
  11055,
  11056,
  11057,
  11058,
  //10944
  4953,
  11059,
  11060,
  11061,
  11062,
  11063,
  11064,
  11065,
  11066,
  11067,
  11068,
  11069,
  11070,
  11071,
  4954,
  11072,
  //10960
  11073,
  11074,
  11075,
  11076,
  11077,
  11078,
  11079,
  11080,
  11081,
  11082,
  11083,
  11084,
  11085,
  11086,
  11087,
  11088,
  //10976
  11089,
  11090,
  11091,
  11092,
  11093,
  11094,
  11095,
  11096,
  11097,
  11098,
  11099,
  11100,
  11101,
  11102,
  11103,
  11104,
  //10992
  11105,
  11106,
  11107,
  11108,
  11109,
  11110,
  11111,
  11112,
  11113,
  11114,
  11115,
  3808,
  11116,
  11117,
  11118,
  11119,
  //11008
  11120,
  11121,
  11122,
  11123,
  11124,
  11125,
  11126,
  11127,
  11128,
  11129,
  11130,
  11131,
  11132,
  11133,
  11134,
  4955,
  //11024
  11135,
  11136,
  11137,
  11138,
  11139,
  11140,
  11141,
  11142,
  11143,
  11144,
  11145,
  11146,
  11147,
  11148,
  11149,
  11150,
  //11040
  11151,
  11152,
  11153,
  11154,
  11155,
  11156,
  11157,
  11158,
  11159,
  11160,
  11161,
  4956,
  11162,
  11163,
  11164,
  11165,
  //11056
  11166,
  11167,
  11168,
  11169,
  11170,
  11171,
  11172,
  11173,
  11174,
  11175,
  11176,
  11177,
  11178,
  11179,
  11180,
  4957,
  //11072
  11181,
  11182,
  11183,
  11184,
  11185,
  11186,
  4958,
  11187,
  11188,
  11189,
  11190,
  11191,
  11192,
  11193,
  11194,
  11195,
  //11088
  11196,
  11197,
  11198,
  11199,
  11200,
  3678,
  11201,
  11202,
  11203,
  11204,
  11205,
  11206,
  4191,
  11207,
  11208,
  11209,
  //11104
  11210,
  11211,
  11212,
  11213,
  11214,
  11215,
  11216,
  11217,
  11218,
  11219,
  11220,
  11221,
  11222,
  11223,
  11224,
  11225,
  //11120
  11226,
  11227,
  11228,
  11229,
  11230,
  11231,
  11232,
  11233,
  11234,
  11235,
  11236,
  11237,
  11238,
  11239,
  11240,
  11241,
  //11136
  11242,
  11243,
  11244,
  11245,
  11246,
  11247,
  11248,
  11249,
  11250,
  11251,
  4959,
  11252,
  11253,
  11254,
  11255,
  11256,
  //11152
  11257,
  11258,
  11259,
  11260,
  11261,
  11262,
  11263,
  11264,
  11265,
  11266,
  11267,
  11268,
  11269,
  11270,
  11271,
  11272,
  //11168
  11273,
  11274,
  11275,
  11276,
  11277,
  11278,
  11279,
  11280,
  11281,
  11282,
  11283,
  11284,
  11285,
  11286,
  11287,
  11288,
  //11184
  11289,
  11290,
  11291,
  11292,
  11293,
  11294,
  11295,
  11296,
  11297,
  11298,
  11299,
  11300,
  11301,
  11302,
  11303,
  11304,
  //11200
  11305,
  11306,
  11307,
  11308,
  11309,
  11310,
  11311,
  11312,
  11313,
  11314,
  3679,
  11315,
  11316,
  11317,
  11318,
  4490,
  //11216
  11319,
  11320,
  11321,
  11322,
  11323,
  11324,
  11325,
  11326,
  11327,
  11328,
  11329,
  11330,
  11331,
  11332,
  11333,
  11334,
  //11232
  11335,
  11336,
  11337,
  11338,
  11339,
  11340,
  11341,
  11342,
  11343,
  11344,
  11345,
  11346,
  11347,
  4960,
  11348,
  11349,
  //11248
  11350,
  11351,
  11352,
  11353,
  11354,
  11355,
  11356,
  11357,
  11358,
  11359,
  11360,
  11361,
  11362,
  11363,
  11364,
  11365,
  //11264
  11366,
  11367,
  11368,
  11369,
  11370,
  11371,
  11372,
  11373,
  11374,
  11375,
  11376,
  11377,
  3961,
  4961,
  11378,
  11379,
  //11280
  11380,
  11381,
  11382,
  11383,
  11384,
  11385,
  11386,
  11387,
  11388,
  11389,
  11390,
  11391,
  11392,
  11393,
  11394,
  11395,
  //11296
  11396,
  11397,
  4192,
  11398,
  11399,
  11400,
  11401,
  11402,
  11403,
  11404,
  11405,
  11406,
  11407,
  11408,
  11409,
  11410,
  //11312
  11411,
  4962,
  11412,
  11413,
  11414,
  11415,
  11416,
  11417,
  11418,
  11419,
  11420,
  11421,
  11422,
  11423,
  11424,
  11425,
  //11328
  11426,
  11427,
  11428,
  11429,
  11430,
  11431,
  11432,
  11433,
  11434,
  11435,
  11436,
  11437,
  11438,
  11439,
  11440,
  11441,
  //11344
  11442,
  11443,
  11444,
  11445,
  11446,
  11447,
  11448,
  11449,
  11450,
  11451,
  11452,
  11453,
  11454,
  11455,
  11456,
  11457,
  //11360
  11458,
  11459,
  11460,
  11461,
  11462,
  11463,
  11464,
  11465,
  11466,
  11467,
  11468,
  11469,
  4963,
  11470,
  11471,
  4491,
  //11376
  11472,
  11473,
  11474,
  11475,
  4964,
  11476,
  11477,
  11478,
  11479,
  11480,
  11481,
  11482,
  11483,
  11484,
  11485,
  11486,
  //11392
  11487,
  11488,
  11489,
  11490,
  11491,
  11492,
  4965,
  11493,
  11494,
  11495,
  11496,
  11497,
  11498,
  11499,
  11500,
  11501,
  //11408
  11502,
  11503,
  11504,
  11505,
  11506,
  11507,
  11508,
  11509,
  11510,
  11511,
  11512,
  11513,
  11514,
  11515,
  11516,
  11517,
  //11424
  11518,
  11519,
  11520,
  11521,
  11522,
  11523,
  11524,
  11525,
  11526,
  11527,
  11528,
  11529,
  3962,
  11530,
  11531,
  11532,
  //11440
  11533,
  11534,
  11535,
  11536,
  11537,
  11538,
  11539,
  11540,
  11541,
  11542,
  11543,
  11544,
  11545,
  11546,
  11547,
  11548,
  //11456
  11549,
  11550,
  11551,
  11552,
  11553,
  11554,
  11555,
  11556,
  11557,
  11558,
  11559,
  11560,
  11561,
  11562,
  11563,
  11564,
  //11472
  4193,
  4194,
  11565,
  11566,
  11567,
  11568,
  11569,
  11570,
  11571,
  11572,
  11573,
  11574,
  11575,
  11576,
  11577,
  11578,
  //11488
  11579,
  11580,
  11581,
  11582,
  11583,
  11584,
  11585,
  11586,
  11587,
  11588,
  11589,
  11590,
  11591,
  4966,
  4195,
  11592,
  //11504
  11593,
  11594,
  11595,
  11596,
  11597,
  11598,
  11599,
  11600,
  11601,
  11602,
  11603,
  11604,
  3090,
  11605,
  11606,
  11607,
  //11520
  11608,
  11609,
  11610,
  4967,
  11611,
  11612,
  11613,
  11614,
  11615,
  11616,
  11617,
  11618,
  11619,
  11620,
  11621,
  11622,
  //11536
  11623,
  11624,
  11625,
  11626,
  11627,
  11628,
  11629,
  11630,
  11631,
  11632,
  11633,
  11634,
  11635,
  11636,
  11637,
  11638,
  //11552
  11639,
  11640,
  11641,
  11642,
  11643,
  11644,
  11645,
  11646,
  11647,
  11648,
  11649,
  11650,
  11651,
  11652,
  11653,
  11654,
  //11568
  11655,
  11656,
  11657,
  11658,
  11659,
  11660,
  11661,
  11662,
  11663,
  11664,
  11665,
  11666,
  11667,
  11668,
  11669,
  11670,
  //11584
  11671,
  11672,
  11673,
  11674,
  4968,
  11675,
  11676,
  11677,
  11678,
  11679,
  11680,
  11681,
  11682,
  11683,
  11684,
  11685,
  //11600
  11686,
  11687,
  11688,
  11689,
  11690,
  11691,
  11692,
  11693,
  3809,
  11694,
  11695,
  11696,
  11697,
  11698,
  11699,
  11700,
  //11616
  11701,
  11702,
  11703,
  11704,
  11705,
  11706,
  11707,
  11708,
  11709,
  11710,
  11711,
  11712,
  11713,
  11714,
  11715,
  11716,
  //11632
  11717,
  11718,
  3553,
  11719,
  11720,
  11721,
  11722,
  11723,
  11724,
  11725,
  11726,
  11727,
  11728,
  11729,
  11730,
  4969,
  //11648
  11731,
  11732,
  11733,
  11734,
  11735,
  11736,
  11737,
  11738,
  11739,
  11740,
  4492,
  11741,
  11742,
  11743,
  11744,
  11745,
  //11664
  11746,
  11747,
  11748,
  11749,
  11750,
  11751,
  11752,
  4970,
  11753,
  11754,
  11755,
  11756,
  11757,
  11758,
  11759,
  11760,
  //11680
  11761,
  11762,
  11763,
  11764,
  11765,
  11766,
  11767,
  11768,
  11769,
  11770,
  11771,
  11772,
  11773,
  11774,
  11775,
  11776,
  //11696
  11777,
  11778,
  11779,
  11780,
  11781,
  11782,
  11783,
  11784,
  11785,
  11786,
  11787,
  11788,
  11789,
  11790,
  4971,
  11791,
  //11712
  11792,
  11793,
  11794,
  11795,
  11796,
  11797,
  4972,
  11798,
  11799,
  11800,
  11801,
  11802,
  11803,
  11804,
  11805,
  11806,
  //11728
  11807,
  11808,
  11809,
  11810,
  4973,
  11811,
  11812,
  11813,
  11814,
  11815,
  11816,
  11817,
  11818,
  11819,
  11820,
  11821,
  //11744
  11822,
  11823,
  11824,
  11825,
  11826,
  11827,
  11828,
  11829,
  11830,
  11831,
  11832,
  11833,
  11834,
  3680,
  3810,
  11835,
  //11760
  11836,
  4974,
  11837,
  11838,
  11839,
  11840,
  11841,
  11842,
  11843,
  11844,
  11845,
  11846,
  11847,
  11848,
  11849,
  11850,
  //11776
  11851,
  11852,
  11853,
  11854,
  11855,
  11856,
  11857,
  11858,
  11859,
  11860,
  11861,
  11862,
  11863,
  11864,
  11865,
  11866,
  //11792
  11867,
  11868,
  11869,
  11870,
  11871,
  11872,
  11873,
  11874,
  11875,
  11876,
  11877,
  11878,
  11879,
  11880,
  11881,
  11882,
  //11808
  11883,
  11884,
  4493,
  11885,
  11886,
  11887,
  11888,
  11889,
  11890,
  11891,
  11892,
  11893,
  11894,
  11895,
  11896,
  11897,
  //11824
  11898,
  11899,
  11900,
  11901,
  11902,
  11903,
  11904,
  11905,
  11906,
  11907,
  11908,
  11909,
  11910,
  11911,
  11912,
  11913,
  //11840
  11914,
  11915,
  4975,
  11916,
  11917,
  11918,
  11919,
  11920,
  11921,
  11922,
  11923,
  11924,
  11925,
  11926,
  11927,
  11928,
  //11856
  11929,
  11930,
  11931,
  11932,
  11933,
  11934,
  11935,
  11936,
  11937,
  11938,
  11939,
  11940,
  11941,
  11942,
  11943,
  11944,
  //11872
  11945,
  11946,
  11947,
  11948,
  11949,
  4976,
  11950,
  11951,
  11952,
  11953,
  11954,
  11955,
  11956,
  11957,
  11958,
  11959,
  //11888
  11960,
  11961,
  11962,
  11963,
  11964,
  11965,
  11966,
  11967,
  11968,
  11969,
  11970,
  11971,
  11972,
  11973,
  11974,
  11975,
  //11904
  11976,
  11977,
  11978,
  11979,
  11980,
  11981,
  11982,
  11983,
  11984,
  11985,
  11986,
  11987,
  4196,
  11988,
  11989,
  11990,
  //11920
  11991,
  11992,
  4977,
  11993,
  11994,
  11995,
  11996,
  11997,
  11998,
  11999,
  12e3,
  12001,
  12002,
  12003,
  12004,
  12005,
  //11936
  12006,
  12007,
  12008,
  12009,
  12010,
  12011,
  12012,
  12013,
  12014,
  12015,
  12016,
  12017,
  12018,
  12019,
  12020,
  12021,
  //11952
  12022,
  12023,
  12024,
  12025,
  12026,
  12027,
  12028,
  12029,
  12030,
  12031,
  12032,
  12033,
  12034,
  12035,
  12036,
  12037,
  //11968
  12038,
  12039,
  12040,
  12041,
  12042,
  12043,
  12044,
  12045,
  12046,
  12047,
  12048,
  12049,
  12050,
  12051,
  12052,
  12053,
  //11984
  12054,
  12055,
  12056,
  12057,
  12058,
  12059,
  12060,
  12061,
  4978,
  12062,
  12063,
  12064,
  12065,
  12066,
  12067,
  12068,
  //12000
  12069,
  12070,
  12071,
  12072,
  12073,
  12074,
  12075,
  12076,
  12077,
  12078,
  12079,
  12080,
  12081,
  12082,
  12083,
  12084,
  //12016
  12085,
  12086,
  12087,
  12088,
  12089,
  12090,
  12091,
  12092,
  12093,
  12094,
  12095,
  12096,
  12097,
  12098,
  12099,
  12100,
  //12032
  12101,
  12102,
  12103,
  12104,
  12105,
  12106,
  12107,
  12108,
  12109,
  12110,
  12111,
  12112,
  12113,
  12114,
  12115,
  12116,
  //12048
  12117,
  12118,
  12119,
  12120,
  12121,
  12122,
  12123,
  4979,
  12124,
  12125,
  12126,
  12127,
  12128,
  4197,
  12129,
  12130,
  //12064
  12131,
  12132,
  12133,
  12134,
  12135,
  12136,
  12137,
  12138,
  12139,
  12140,
  12141,
  12142,
  12143,
  12144,
  12145,
  12146,
  //12080
  12147,
  12148,
  12149,
  12150,
  12151,
  12152,
  12153,
  12154,
  4980,
  12155,
  12156,
  12157,
  12158,
  12159,
  12160,
  4494,
  //12096
  12161,
  12162,
  12163,
  12164,
  3811,
  12165,
  12166,
  12167,
  12168,
  12169,
  4495,
  12170,
  12171,
  4496,
  12172,
  12173,
  //12112
  12174,
  12175,
  12176,
  3812,
  12177,
  12178,
  12179,
  12180,
  12181,
  12182,
  12183,
  12184,
  12185,
  12186,
  12187,
  12188,
  //12128
  12189,
  12190,
  12191,
  12192,
  12193,
  12194,
  12195,
  12196,
  12197,
  12198,
  12199,
  12200,
  12201,
  12202,
  12203,
  12204,
  //12144
  12205,
  12206,
  12207,
  12208,
  12209,
  12210,
  12211,
  12212,
  12213,
  12214,
  12215,
  12216,
  12217,
  12218,
  12219,
  12220,
  //12160
  12221,
  4981,
  12222,
  12223,
  12224,
  12225,
  12226,
  12227,
  12228,
  12229,
  12230,
  12231,
  12232,
  12233,
  12234,
  12235,
  //12176
  4982,
  12236,
  12237,
  12238,
  12239,
  12240,
  12241,
  12242,
  12243,
  12244,
  12245,
  4983,
  12246,
  12247,
  12248,
  12249,
  //12192
  4984,
  12250,
  12251,
  12252,
  12253,
  12254,
  12255,
  12256,
  12257,
  12258,
  12259,
  12260,
  12261,
  12262,
  12263,
  12264,
  //12208
  4985,
  12265,
  4497,
  12266,
  12267,
  12268,
  12269,
  12270,
  12271,
  12272,
  12273,
  12274,
  12275,
  12276,
  12277,
  12278,
  //12224
  12279,
  12280,
  12281,
  12282,
  12283,
  12284,
  12285,
  12286,
  12287,
  4986,
  12288,
  12289,
  12290,
  12291,
  12292,
  12293,
  //12240
  12294,
  12295,
  12296,
  2473,
  12297,
  12298,
  12299,
  12300,
  12301,
  12302,
  12303,
  12304,
  12305,
  12306,
  12307,
  12308,
  //12256
  12309,
  12310,
  12311,
  12312,
  12313,
  12314,
  12315,
  12316,
  12317,
  12318,
  12319,
  3963,
  12320,
  12321,
  12322,
  12323,
  //12272
  12324,
  12325,
  12326,
  12327,
  12328,
  12329,
  12330,
  12331,
  12332,
  4987,
  12333,
  12334,
  12335,
  12336,
  12337,
  12338,
  //12288
  12339,
  12340,
  12341,
  12342,
  12343,
  12344,
  12345,
  12346,
  12347,
  12348,
  12349,
  12350,
  12351,
  12352,
  12353,
  12354,
  //12304
  12355,
  12356,
  12357,
  12358,
  12359,
  3964,
  12360,
  12361,
  12362,
  12363,
  12364,
  12365,
  12366,
  12367,
  12368,
  12369,
  //12320
  12370,
  3965,
  12371,
  12372,
  12373,
  12374,
  12375,
  12376,
  12377,
  12378,
  12379,
  12380,
  12381,
  12382,
  12383,
  12384,
  //12336
  12385,
  12386,
  12387,
  12388,
  12389,
  12390,
  12391,
  12392,
  12393,
  12394,
  12395,
  12396,
  12397,
  12398,
  12399,
  12400,
  //12352
  12401,
  12402,
  12403,
  12404,
  12405,
  12406,
  12407,
  12408,
  4988,
  12409,
  12410,
  12411,
  12412,
  12413,
  12414,
  12415,
  //12368
  12416,
  12417,
  12418,
  12419,
  12420,
  12421,
  12422,
  12423,
  12424,
  12425,
  12426,
  12427,
  12428,
  12429,
  12430,
  12431,
  //12384
  12432,
  12433,
  12434,
  12435,
  12436,
  12437,
  12438,
  3554,
  12439,
  12440,
  12441,
  12442,
  12443,
  12444,
  12445,
  12446,
  //12400
  12447,
  12448,
  12449,
  12450,
  12451,
  12452,
  12453,
  12454,
  12455,
  12456,
  12457,
  12458,
  12459,
  12460,
  12461,
  12462,
  //12416
  12463,
  12464,
  4989,
  12465,
  12466,
  12467,
  12468,
  12469,
  12470,
  12471,
  12472,
  12473,
  12474,
  12475,
  12476,
  12477,
  //12432
  12478,
  12479,
  12480,
  4990,
  12481,
  12482,
  12483,
  12484,
  12485,
  12486,
  12487,
  12488,
  12489,
  4498,
  12490,
  12491,
  //12448
  12492,
  12493,
  12494,
  12495,
  12496,
  12497,
  12498,
  12499,
  12500,
  12501,
  12502,
  12503,
  12504,
  12505,
  12506,
  12507,
  //12464
  12508,
  12509,
  12510,
  12511,
  12512,
  12513,
  12514,
  12515,
  12516,
  12517,
  12518,
  12519,
  12520,
  12521,
  12522,
  12523,
  //12480
  12524,
  12525,
  12526,
  12527,
  12528,
  12529,
  12530,
  12531,
  12532,
  12533,
  12534,
  12535,
  12536,
  12537,
  12538,
  12539,
  //12496
  12540,
  12541,
  12542,
  12543,
  12544,
  12545,
  12546,
  12547,
  12548,
  12549,
  12550,
  12551,
  4991,
  12552,
  12553,
  12554,
  //12512
  12555,
  12556,
  12557,
  12558,
  12559,
  12560,
  12561,
  12562,
  12563,
  12564,
  12565,
  12566,
  12567,
  12568,
  12569,
  12570,
  //12528
  12571,
  12572,
  12573,
  12574,
  12575,
  12576,
  12577,
  12578,
  3036,
  12579,
  12580,
  12581,
  12582,
  12583,
  3966,
  12584,
  //12544
  12585,
  12586,
  12587,
  12588,
  12589,
  12590,
  12591,
  12592,
  12593,
  12594,
  12595,
  12596,
  12597,
  12598,
  12599,
  12600,
  //12560
  12601,
  12602,
  12603,
  12604,
  12605,
  12606,
  12607,
  12608,
  12609,
  12610,
  12611,
  12612,
  12613,
  12614,
  12615,
  12616,
  //12576
  12617,
  12618,
  12619,
  12620,
  12621,
  12622,
  12623,
  12624,
  12625,
  12626,
  12627,
  12628,
  12629,
  12630,
  12631,
  12632,
  //12592
  12633,
  12634,
  12635,
  12636,
  12637,
  12638,
  12639,
  12640,
  12641,
  12642,
  12643,
  12644,
  12645,
  12646,
  4499,
  12647,
  //12608
  12648,
  12649,
  12650,
  12651,
  12652,
  12653,
  12654,
  12655,
  12656,
  12657,
  12658,
  12659,
  12660,
  12661,
  12662,
  12663,
  //12624
  12664,
  12665,
  12666,
  12667,
  12668,
  12669,
  12670,
  12671,
  12672,
  12673,
  12674,
  12675,
  12676,
  12677,
  12678,
  12679,
  //12640
  12680,
  12681,
  12682,
  12683,
  12684,
  12685,
  12686,
  12687,
  12688,
  12689,
  12690,
  12691,
  12692,
  12693,
  12694,
  12695,
  //12656
  12696,
  12697,
  12698,
  4992,
  12699,
  12700,
  12701,
  12702,
  12703,
  12704,
  12705,
  12706,
  12707,
  12708,
  12709,
  12710,
  //12672
  12711,
  12712,
  12713,
  12714,
  12715,
  12716,
  12717,
  12718,
  12719,
  12720,
  12721,
  12722,
  12723,
  12724,
  12725,
  12726,
  //12688
  12727,
  12728,
  12729,
  12730,
  12731,
  12732,
  12733,
  12734,
  12735,
  12736,
  12737,
  12738,
  12739,
  12740,
  12741,
  12742,
  //12704
  12743,
  12744,
  12745,
  12746,
  12747,
  12748,
  12749,
  12750,
  12751,
  12752,
  12753,
  12754,
  12755,
  12756,
  12757,
  12758,
  //12720
  12759,
  12760,
  12761,
  12762,
  12763,
  12764,
  12765,
  12766,
  12767,
  12768,
  12769,
  12770,
  12771,
  12772,
  12773,
  12774,
  //12736
  12775,
  12776,
  12777,
  12778,
  4993,
  2175,
  12779,
  12780,
  12781,
  12782,
  12783,
  12784,
  12785,
  12786,
  4500,
  12787,
  //12752
  12788,
  12789,
  12790,
  12791,
  12792,
  12793,
  12794,
  12795,
  12796,
  12797,
  12798,
  12799,
  12800,
  12801,
  12802,
  12803,
  //12768
  12804,
  12805,
  12806,
  12807,
  12808,
  12809,
  12810,
  12811,
  12812,
  12813,
  12814,
  12815,
  12816,
  12817,
  12818,
  12819,
  //12784
  12820,
  12821,
  12822,
  12823,
  12824,
  12825,
  12826,
  4198,
  3967,
  12827,
  12828,
  12829,
  12830,
  12831,
  12832,
  12833,
  //12800
  12834,
  12835,
  12836,
  12837,
  12838,
  12839,
  12840,
  12841,
  12842,
  12843,
  12844,
  12845,
  12846,
  12847,
  12848,
  12849,
  //12816
  12850,
  12851,
  12852,
  12853,
  12854,
  12855,
  12856,
  12857,
  12858,
  12859,
  12860,
  12861,
  4199,
  12862,
  12863,
  12864,
  //12832
  12865,
  12866,
  12867,
  12868,
  12869,
  12870,
  12871,
  12872,
  12873,
  12874,
  12875,
  12876,
  12877,
  12878,
  12879,
  12880,
  //12848
  12881,
  12882,
  12883,
  12884,
  12885,
  12886,
  12887,
  4501,
  12888,
  12889,
  12890,
  12891,
  12892,
  12893,
  12894,
  12895,
  //12864
  12896,
  12897,
  12898,
  12899,
  12900,
  12901,
  12902,
  12903,
  12904,
  12905,
  12906,
  12907,
  12908,
  12909,
  12910,
  12911,
  //12880
  12912,
  4994,
  12913,
  12914,
  12915,
  12916,
  12917,
  12918,
  12919,
  12920,
  12921,
  12922,
  12923,
  12924,
  12925,
  12926,
  //12896
  12927,
  12928,
  12929,
  12930,
  12931,
  12932,
  12933,
  12934,
  12935,
  12936,
  12937,
  12938,
  12939,
  12940,
  12941,
  12942,
  //12912
  12943,
  12944,
  12945,
  12946,
  12947,
  12948,
  12949,
  12950,
  12951,
  12952,
  12953,
  12954,
  12955,
  12956,
  1772,
  12957,
  //12928
  12958,
  12959,
  12960,
  12961,
  12962,
  12963,
  12964,
  12965,
  12966,
  12967,
  12968,
  12969,
  12970,
  12971,
  12972,
  12973,
  //12944
  12974,
  12975,
  12976,
  12977,
  12978,
  12979,
  12980,
  12981,
  12982,
  12983,
  12984,
  12985,
  12986,
  12987,
  12988,
  12989,
  //12960
  12990,
  12991,
  12992,
  12993,
  12994,
  12995,
  12996,
  12997,
  4502,
  12998,
  4503,
  12999,
  13e3,
  13001,
  13002,
  13003,
  //12976
  4504,
  13004,
  13005,
  13006,
  13007,
  13008,
  13009,
  13010,
  13011,
  13012,
  13013,
  13014,
  13015,
  13016,
  13017,
  13018,
  //12992
  13019,
  13020,
  13021,
  13022,
  13023,
  13024,
  13025,
  13026,
  13027,
  13028,
  13029,
  3449,
  13030,
  13031,
  13032,
  13033,
  //13008
  13034,
  13035,
  13036,
  13037,
  13038,
  13039,
  13040,
  13041,
  13042,
  13043,
  13044,
  13045,
  13046,
  13047,
  13048,
  13049,
  //13024
  13050,
  13051,
  13052,
  13053,
  13054,
  13055,
  13056,
  13057,
  13058,
  13059,
  13060,
  13061,
  13062,
  13063,
  13064,
  13065,
  //13040
  13066,
  13067,
  13068,
  13069,
  13070,
  13071,
  13072,
  13073,
  13074,
  13075,
  13076,
  13077,
  13078,
  13079,
  13080,
  13081,
  //13056
  13082,
  13083,
  13084,
  13085,
  13086,
  13087,
  13088,
  13089,
  13090,
  13091,
  13092,
  13093,
  13094,
  13095,
  13096,
  13097,
  //13072
  13098,
  13099,
  13100,
  13101,
  13102,
  13103,
  13104,
  13105,
  13106,
  13107,
  13108,
  13109,
  13110,
  13111,
  13112,
  13113,
  //13088
  13114,
  13115,
  13116,
  13117,
  13118,
  3968,
  13119,
  4995,
  13120,
  13121,
  13122,
  13123,
  13124,
  13125,
  13126,
  13127,
  //13104
  4505,
  13128,
  13129,
  13130,
  13131,
  13132,
  13133,
  13134,
  4996,
  4506,
  13135,
  13136,
  13137,
  13138,
  13139,
  4997,
  //13120
  13140,
  13141,
  13142,
  13143,
  13144,
  13145,
  13146,
  13147,
  13148,
  13149,
  13150,
  13151,
  13152,
  13153,
  13154,
  13155,
  //13136
  13156,
  13157,
  13158,
  13159,
  4998,
  13160,
  13161,
  13162,
  13163,
  13164,
  13165,
  13166,
  13167,
  13168,
  13169,
  13170,
  //13152
  13171,
  13172,
  13173,
  13174,
  13175,
  13176,
  4999,
  13177,
  13178,
  13179,
  13180,
  13181,
  13182,
  13183,
  13184,
  13185,
  //13168
  13186,
  13187,
  13188,
  13189,
  13190,
  13191,
  13192,
  13193,
  13194,
  13195,
  13196,
  13197,
  13198,
  13199,
  13200,
  13201,
  //13184
  13202,
  13203,
  13204,
  13205,
  13206,
  5e3,
  13207,
  13208,
  13209,
  13210,
  13211,
  13212,
  13213,
  13214,
  13215,
  13216,
  //13200
  13217,
  13218,
  13219,
  13220,
  13221,
  13222,
  13223,
  13224,
  13225,
  13226,
  13227,
  4200,
  5001,
  13228,
  13229,
  13230,
  //13216
  13231,
  13232,
  13233,
  13234,
  13235,
  13236,
  13237,
  13238,
  13239,
  13240,
  3969,
  13241,
  13242,
  13243,
  13244,
  3970,
  //13232
  13245,
  13246,
  13247,
  13248,
  13249,
  13250,
  13251,
  13252,
  13253,
  13254,
  13255,
  13256,
  13257,
  13258,
  13259,
  13260,
  //13248
  13261,
  13262,
  13263,
  13264,
  13265,
  13266,
  13267,
  13268,
  3450,
  13269,
  13270,
  13271,
  13272,
  13273,
  13274,
  13275,
  //13264
  13276,
  5002,
  13277,
  13278,
  13279,
  13280,
  13281,
  13282,
  13283,
  13284,
  13285,
  13286,
  13287,
  13288,
  13289,
  13290,
  //13280
  13291,
  13292,
  13293,
  13294,
  13295,
  13296,
  13297,
  13298,
  13299,
  13300,
  13301,
  13302,
  3813,
  13303,
  13304,
  13305,
  //13296
  13306,
  13307,
  13308,
  13309,
  13310,
  13311,
  13312,
  13313,
  13314,
  13315,
  13316,
  13317,
  13318,
  13319,
  13320,
  13321,
  //13312
  13322,
  13323,
  13324,
  13325,
  13326,
  13327,
  13328,
  4507,
  13329,
  13330,
  13331,
  13332,
  13333,
  13334,
  13335,
  13336,
  //13328
  13337,
  13338,
  13339,
  13340,
  13341,
  5003,
  13342,
  13343,
  13344,
  13345,
  13346,
  13347,
  13348,
  13349,
  13350,
  13351,
  //13344
  13352,
  13353,
  13354,
  13355,
  13356,
  13357,
  13358,
  13359,
  13360,
  13361,
  13362,
  13363,
  13364,
  13365,
  13366,
  13367,
  //13360
  5004,
  13368,
  13369,
  13370,
  13371,
  13372,
  13373,
  13374,
  13375,
  13376,
  13377,
  13378,
  13379,
  13380,
  13381,
  13382,
  //13376
  13383,
  13384,
  13385,
  13386,
  13387,
  13388,
  13389,
  13390,
  13391,
  13392,
  13393,
  13394,
  13395,
  13396,
  13397,
  13398,
  //13392
  13399,
  13400,
  13401,
  13402,
  13403,
  13404,
  13405,
  13406,
  13407,
  13408,
  13409,
  13410,
  13411,
  13412,
  13413,
  13414,
  //13408
  13415,
  13416,
  13417,
  13418,
  13419,
  13420,
  13421,
  13422,
  13423,
  13424,
  13425,
  13426,
  13427,
  13428,
  13429,
  13430,
  //13424
  13431,
  13432,
  4508,
  13433,
  13434,
  13435,
  4201,
  13436,
  13437,
  13438,
  13439,
  13440,
  13441,
  13442,
  13443,
  13444,
  //13440
  13445,
  13446,
  13447,
  13448,
  13449,
  13450,
  13451,
  13452,
  13453,
  13454,
  13455,
  13456,
  13457,
  5005,
  13458,
  13459,
  //13456
  13460,
  13461,
  13462,
  13463,
  13464,
  13465,
  13466,
  13467,
  13468,
  13469,
  13470,
  4509,
  13471,
  13472,
  13473,
  13474,
  //13472
  13475,
  13476,
  13477,
  13478,
  13479,
  13480,
  13481,
  13482,
  13483,
  13484,
  13485,
  13486,
  13487,
  13488,
  13489,
  13490,
  //13488
  13491,
  13492,
  13493,
  13494,
  13495,
  13496,
  13497,
  13498,
  13499,
  13500,
  13501,
  13502,
  13503,
  13504,
  13505,
  13506,
  //13504
  13507,
  13508,
  13509,
  13510,
  13511,
  13512,
  13513,
  13514,
  13515,
  13516,
  13517,
  13518,
  13519,
  13520,
  13521,
  13522,
  //13520
  13523,
  13524,
  13525,
  13526,
  13527,
  13528,
  13529,
  13530,
  13531,
  13532,
  13533,
  13534,
  13535,
  13536,
  13537,
  13538,
  //13536
  13539,
  13540,
  13541,
  13542,
  13543,
  13544,
  13545,
  13546,
  13547,
  13548,
  13549,
  13550,
  13551,
  13552,
  13553,
  13554,
  //13552
  13555,
  13556,
  13557,
  13558,
  13559,
  13560,
  13561,
  13562,
  13563,
  13564,
  13565,
  13566,
  13567,
  13568,
  13569,
  13570,
  //13568
  13571,
  13572,
  13573,
  13574,
  13575,
  13576,
  13577,
  13578,
  13579,
  13580,
  13581,
  13582,
  13583,
  13584,
  13585,
  13586,
  //13584
  13587,
  13588,
  13589,
  13590,
  13591,
  13592,
  13593,
  13594,
  13595,
  13596,
  13597,
  13598,
  13599,
  13600,
  13601,
  13602,
  //13600
  13603,
  13604,
  13605,
  13606,
  13607,
  13608,
  13609,
  13610,
  13611,
  13612,
  13613,
  13614,
  13615,
  13616,
  13617,
  13618,
  //13616
  13619,
  13620,
  13621,
  13622,
  13623,
  13624,
  13625,
  13626,
  13627,
  13628,
  13629,
  13630,
  13631,
  13632,
  13633,
  13634,
  //13632
  13635,
  13636,
  13637,
  13638,
  13639,
  13640,
  13641,
  13642,
  5006,
  13643,
  13644,
  13645,
  13646,
  13647,
  13648,
  13649,
  //13648
  13650,
  13651,
  5007,
  13652,
  13653,
  13654,
  13655,
  13656,
  13657,
  13658,
  13659,
  13660,
  13661,
  13662,
  13663,
  13664,
  //13664
  13665,
  13666,
  13667,
  13668,
  13669,
  13670,
  13671,
  13672,
  13673,
  13674,
  13675,
  13676,
  13677,
  13678,
  13679,
  13680,
  //13680
  13681,
  13682,
  13683,
  13684,
  13685,
  13686,
  13687,
  13688,
  13689,
  13690,
  13691,
  13692,
  13693,
  13694,
  13695,
  13696,
  //13696
  13697,
  13698,
  13699,
  13700,
  13701,
  13702,
  13703,
  13704,
  13705,
  13706,
  13707,
  13708,
  13709,
  13710,
  13711,
  13712,
  //13712
  13713,
  13714,
  13715,
  13716,
  13717,
  13718,
  13719,
  13720,
  13721,
  13722,
  13723,
  13724,
  13725,
  13726,
  13727,
  13728,
  //13728
  13729,
  13730,
  13731,
  13732,
  13733,
  13734,
  13735,
  13736,
  13737,
  13738,
  13739,
  13740,
  13741,
  13742,
  13743,
  13744,
  //13744
  13745,
  13746,
  13747,
  13748,
  13749,
  13750,
  13751,
  13752,
  13753,
  13754,
  13755,
  13756,
  13757,
  13758,
  13759,
  13760,
  //13760
  13761,
  13762,
  13763,
  13764,
  13765,
  13766,
  13767,
  13768,
  13769,
  13770,
  13771,
  13772,
  13773,
  13774,
  3273,
  13775,
  //13776
  13776,
  13777,
  13778,
  13779,
  13780,
  13781,
  13782,
  13783,
  13784,
  13785,
  13786,
  13787,
  13788,
  13789,
  13790,
  13791,
  //13792
  13792,
  13793,
  13794,
  13795,
  13796,
  13797,
  13798,
  13799,
  13800,
  13801,
  13802,
  13803,
  13804,
  13805,
  13806,
  13807,
  //13808
  13808,
  13809,
  13810,
  13811,
  13812,
  13813,
  13814,
  13815,
  13816,
  13817,
  13818,
  13819,
  13820,
  13821,
  13822,
  13823,
  //13824
  13824,
  13825,
  13826,
  13827,
  13828,
  13829,
  13830,
  13831,
  13832,
  13833,
  13834,
  13835,
  13836,
  13837,
  13838,
  13839,
  //13840
  13840,
  13841,
  13842,
  13843,
  13844,
  13845,
  13846,
  13847,
  13848,
  13849,
  13850,
  13851,
  13852,
  13853,
  13854,
  13855,
  //13856
  13856,
  13857,
  13858,
  13859,
  13860,
  13861,
  13862,
  13863,
  13864,
  13865,
  13866,
  13867,
  13868,
  13869,
  13870,
  13871,
  //13872
  13872,
  13873,
  13874,
  13875,
  13876,
  13877,
  13878,
  13879,
  13880,
  13881,
  13882,
  13883,
  13884,
  13885,
  13886,
  13887,
  //13888
  13888,
  13889,
  13890,
  13891,
  13892,
  13893,
  13894,
  13895,
  13896,
  13897,
  13898,
  13899,
  13900,
  13901,
  13902,
  13903,
  //13904
  13904,
  13905,
  13906,
  13907,
  13908,
  13909,
  13910,
  13911,
  13912,
  13913,
  13914,
  13915,
  13916,
  13917,
  13918,
  13919,
  //13920
  13920,
  13921,
  13922,
  13923,
  13924,
  13925,
  13926,
  13927,
  13928,
  13929,
  13930,
  13931,
  13932,
  13933,
  13934,
  13935,
  //13936
  13936,
  13937,
  13938,
  13939,
  13940,
  13941,
  13942,
  13943,
  13944,
  13945,
  13946,
  13947,
  13948,
  13949,
  13950,
  13951,
  //13952
  13952,
  13953,
  13954,
  13955,
  13956,
  13957,
  13958,
  13959,
  13960,
  13961,
  13962,
  13963,
  13964,
  13965,
  13966,
  13967,
  //13968
  13968,
  13969,
  13970,
  13971,
  13972
];
var h3 = We, t4 = Ve, a4 = Ge, n4 = je, i4 = ze;
function J1() {
  var e = 1024, t = 0.99, r = 0.01, a = 3, n = this;
  function i() {
    n._mCharToFreqOrder = null, n._mTableSize = null, n._mTypicalDistributionRatio = null, n.reset();
  }
  this.reset = function() {
    this._mDone = !1, this._mTotalChars = 0, this._mFreqChars = 0;
  }, this.feed = function(c, s) {
    if (s == 2)
      var f = this.getOrder(c);
    else
      f = -1;
    f >= 0 && (this._mTotalChars++, f < this._mTableSize && 512 > this._mCharToFreqOrder[f] && this._mFreqChars++);
  }, this.getConfidence = function() {
    if (this._mTotalChars <= 0 || this._mFreqChars <= a)
      return r;
    if (this._mTotalChars != this._mFreqChars) {
      var c = this._mFreqChars / ((this._mTotalChars - this._mFreqChars) * this._mTypicalDistributionRatio);
      if (c < t)
        return c;
    }
    return t;
  }, this.gotEnoughData = function() {
    return this._mTotalChars > e;
  }, this.getOrder = function(c) {
    return -1;
  }, i();
}
Y1.CharDistributionAnalysis = J1;
function Ur() {
  J1.apply(this);
  var e = this;
  function t() {
    e._mCharToFreqOrder = t4.EUCTWCharToFreqOrder, e._mTableSize = t4.EUCTW_TABLE_SIZE, e._mTypicalDistributionRatio = t4.EUCTW_TYPICAL_DISTRIBUTION_RATIO;
  }
  this.getOrder = function(r) {
    return r.charCodeAt(0) >= 196 ? 94 * (r.charCodeAt(0) - 196) + r.charCodeAt(1) - 161 : -1;
  }, t();
}
Ur.prototype = new J1();
Y1.EUCTWDistributionAnalysis = Ur;
function Hr() {
  J1.apply(this);
  var e = this;
  function t() {
    e._mCharToFreqOrder = a4.EUCKRCharToFreqOrder, e._mTableSize = a4.EUCKR_TABLE_SIZE, e._mTypicalDistributionRatio = a4.EUCKR_TYPICAL_DISTRIBUTION_RATIO;
  }
  this.getOrder = function(r) {
    return r.charCodeAt(0) >= 176 ? 94 * (r.charCodeAt(0) - 176) + r.charCodeAt(1) - 161 : -1;
  }, t();
}
Hr.prototype = new J1();
Y1.EUCKRDistributionAnalysis = Hr;
function Wr() {
  J1.apply(this);
  var e = this;
  function t() {
    e._mCharToFreqOrder = n4.GB2312CharToFreqOrder, e._mTableSize = n4.GB2312_TABLE_SIZE, e._mTypicalDistributionRatio = n4.GB2312_TYPICAL_DISTRIBUTION_RATIO;
  }
  this.getOrder = function(r) {
    return r.charCodeAt(0) >= 176 && r.charCodeAt(1) >= 161 ? 94 * (r.charCodeAt(0) - 176) + r.charCodeAt(1) - 161 : -1;
  }, t();
}
Wr.prototype = new J1();
Y1.GB2312DistributionAnalysis = Wr;
function Vr() {
  J1.apply(this);
  var e = this;
  function t() {
    e._mCharToFreqOrder = i4.Big5CharToFreqOrder, e._mTableSize = i4.BIG5_TABLE_SIZE, e._mTypicalDistributionRatio = i4.BIG5_TYPICAL_DISTRIBUTION_RATIO;
  }
  this.getOrder = function(r) {
    return r.charCodeAt(0) >= 164 ? r.charCodeAt(1) >= 161 ? 157 * (r.charCodeAt(0) - 164) + r.charCodeAt(1) - 161 + 63 : 157 * (r.charCodeAt(0) - 164) + r.charCodeAt(1) - 64 : -1;
  }, t();
}
Vr.prototype = new J1();
Y1.Big5DistributionAnalysis = Vr;
function Gr() {
  J1.apply(this);
  var e = this;
  function t() {
    e._mCharToFreqOrder = h3.JISCharToFreqOrder, e._mTableSize = h3.JIS_TABLE_SIZE, e._mTypicalDistributionRatio = h3.JIS_TYPICAL_DISTRIBUTION_RATIO;
  }
  this.getOrder = function(r) {
    if (r.charCodeAt(0) >= 129 && r.charCodeAt(0) <= 159)
      var a = 188 * (r.charCodeAt(0) - 129);
    else if (r.charCodeAt(0) >= 224 && r.charCodeAt(0) <= 239)
      a = 188 * (r.charCodeAt(0) - 224 + 31);
    else
      return -1;
    return a += r.charCodeAt(1) - 64, (r.charCodeAt(1) < 64 || r.charCodeAt(1) === 127 || r.charCodeAt(1) > 252) && (a = -1), a;
  }, t();
}
Gr.prototype = new J1();
Y1.SJISDistributionAnalysis = Gr;
function jr() {
  J1.apply(this);
  var e = this;
  function t() {
    e._mCharToFreqOrder = h3.JISCharToFreqOrder, e._mTableSize = h3.JIS_TABLE_SIZE, e._mTypicalDistributionRatio = h3.JIS_TYPICAL_DISTRIBUTION_RATIO;
  }
  this.getOrder = function(r) {
    return r[0] >= " " ? 94 * (r.charCodeAt(0) - 161) + r.charCodeAt(1) - 161 : -1;
  }, t();
}
jr.prototype = new J1();
Y1.EUCJPDistributionAnalysis = jr;
var $t = P2, zr = T3, Xt = zt, Kt = Y1.Big5DistributionAnalysis;
function $r() {
  zr.apply(this);
  var e = this;
  function t() {
    e._mCodingSM = new $t(Xt), e._mDistributionAnalyzer = new Kt(), e.reset();
  }
  this.getCharsetName = function() {
    return "Big5";
  }, t();
}
$r.prototype = new zr();
var Yt = $r, U = d1, Jt = [
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 00 - 07  //allow 0x00 as a legal value
  1,
  1,
  1,
  1,
  1,
  1,
  0,
  0,
  // 08 - 0f
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 10 - 17
  1,
  1,
  1,
  0,
  1,
  1,
  1,
  1,
  // 18 - 1f
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 20 - 27
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 28 - 2f
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 30 - 37
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 38 - 3f
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 40 - 47
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 48 - 4f
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 50 - 57
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 58 - 5f
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 60 - 67
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 68 - 6f
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 70 - 77
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 78 - 7f
  2,
  2,
  2,
  2,
  3,
  3,
  3,
  3,
  // 80 - 87
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  // 88 - 8f
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  // 90 - 97
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  // 98 - 9f
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  // a0 - a7
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  // a8 - af
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  // b0 - b7
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  // b8 - bf
  0,
  0,
  6,
  6,
  6,
  6,
  6,
  6,
  // c0 - c7
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  // c8 - cf
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  // d0 - d7
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  // d8 - df
  7,
  8,
  8,
  8,
  8,
  8,
  8,
  8,
  // e0 - e7
  8,
  8,
  8,
  8,
  8,
  9,
  8,
  8,
  // e8 - ef
  10,
  11,
  11,
  11,
  11,
  11,
  11,
  11,
  // f0 - f7
  12,
  13,
  13,
  13,
  14,
  15,
  0,
  0
  // f8 - ff
], qt = [
  U.error,
  U.start,
  U.error,
  U.error,
  U.error,
  U.error,
  12,
  10,
  //00-07
  9,
  11,
  8,
  7,
  6,
  5,
  4,
  3,
  //08-0f
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  //10-17
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  //18-1f
  U.itsMe,
  U.itsMe,
  U.itsMe,
  U.itsMe,
  U.itsMe,
  U.itsMe,
  U.itsMe,
  U.itsMe,
  //20-27
  U.itsMe,
  U.itsMe,
  U.itsMe,
  U.itsMe,
  U.itsMe,
  U.itsMe,
  U.itsMe,
  U.itsMe,
  //28-2f
  U.error,
  U.error,
  5,
  5,
  5,
  5,
  U.error,
  U.error,
  //30-37
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  //38-3f
  U.error,
  U.error,
  U.error,
  5,
  5,
  5,
  U.error,
  U.error,
  //40-47
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  //48-4f
  U.error,
  U.error,
  7,
  7,
  7,
  7,
  U.error,
  U.error,
  //50-57
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  //58-5f
  U.error,
  U.error,
  U.error,
  U.error,
  7,
  7,
  U.error,
  U.error,
  //60-67
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  //68-6f
  U.error,
  U.error,
  9,
  9,
  9,
  9,
  U.error,
  U.error,
  //70-77
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  //78-7f
  U.error,
  U.error,
  U.error,
  U.error,
  9,
  9,
  U.error,
  U.error,
  //80-87
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  //88-8f
  U.error,
  U.error,
  12,
  12,
  12,
  12,
  U.error,
  U.error,
  //90-97
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  //98-9f
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  12,
  U.error,
  U.error,
  //a0-a7
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  //a8-af
  U.error,
  U.error,
  12,
  12,
  12,
  U.error,
  U.error,
  U.error,
  //b0-b7
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  //b8-bf
  U.error,
  U.error,
  U.start,
  U.start,
  U.start,
  U.start,
  U.error,
  U.error,
  //c0-c7
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  U.error,
  U.error
  //c8-cf
], Zt = [0, 1, 0, 0, 0, 0, 2, 3, 3, 3, 4, 4, 5, 5, 6, 6], Qt = {
  classTable: Jt,
  classFactor: 16,
  stateTable: qt,
  charLenTable: Zt,
  name: "UTF-8"
}, ea = P2, Xr = Z2, S2 = d1, ra = Qt;
function y4() {
  Xr.apply(this);
  var e = 0.5, t = this;
  function r() {
    t._mCodingSM = new ea(ra), t.reset();
  }
  this.reset = function() {
    y4.prototype.reset.apply(this), this._mCodingSM.reset(), this._mNumOfMBChar = 0, this._mMBCharLen = 0, this._mFullLen = 0, this._mBasicAsciiLen = 0;
  }, this.getCharsetName = function() {
    return "UTF-8";
  }, this.feed = function(a) {
    this._mFullLen += a.length;
    for (var n = 0, i; n < a.length; n++) {
      i = a[n];
      var c = this._mCodingSM.nextState(i);
      if (c == S2.error) {
        this._mState = S2.notMe;
        break;
      } else if (c == S2.itsMe) {
        this._mState = S2.foundIt;
        break;
      } else
        c == S2.start && (this._mCodingSM.getCurrentCharLen() >= 2 ? (this._mNumOfMBChar++, this._mMBCharLen += this._mCodingSM.getCurrentCharLen()) : i.charCodeAt(0) < 128 && this._mBasicAsciiLen++);
    }
    return this.getState() == S2.detecting && this.getConfidence() > S2.SHORTCUT_THRESHOLD && (this._mState = S2.foundIt), this.getState();
  }, this.getConfidence = function() {
    var a = 0.99, n = 0, i = this._mFullLen - this._mBasicAsciiLen;
    return i > 0 && (n = this._mMBCharLen / i), this._mNumOfMBChar < 6 && n <= 0.6 ? (a *= Math.pow(e, this._mNumOfMBChar), 1 - a) : a;
  }, r();
}
y4.prototype = new Xr();
var ta = y4, n1 = d1, aa = [
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 00 - 07
  1,
  1,
  1,
  1,
  1,
  1,
  0,
  0,
  // 08 - 0f
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 10 - 17
  1,
  1,
  1,
  0,
  1,
  1,
  1,
  1,
  // 18 - 1f
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 20 - 27
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 28 - 2f
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 30 - 37
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 38 - 3f
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 40 - 47
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 48 - 4f
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 50 - 57
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 58 - 5f
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 60 - 67
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 68 - 6f
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 70 - 77
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  1,
  // 78 - 7f
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  // 80 - 87
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  // 88 - 8f
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  // 90 - 97
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  // 98 - 9f
  // 0xa0 is illegal in sjis encoding, but some pages does
  // contain such byte. We need to be more consts.error forgiven.
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // a0 - a7
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // a8 - af
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // b0 - b7
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // b8 - bf
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // c0 - c7
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // c8 - cf
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // d0 - d7
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // d8 - df
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  // e0 - e7
  3,
  3,
  3,
  3,
  3,
  4,
  4,
  4,
  // e8 - ef
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  // f0 - f7
  3,
  3,
  3,
  3,
  3,
  0,
  0,
  0
  // f8 - ff
], na = [
  n1.error,
  n1.start,
  n1.start,
  3,
  n1.error,
  n1.error,
  n1.error,
  n1.error,
  //00-07
  n1.error,
  n1.error,
  n1.error,
  n1.error,
  n1.itsMe,
  n1.itsMe,
  n1.itsMe,
  n1.itsMe,
  //08-0f
  n1.itsMe,
  n1.itsMe,
  n1.error,
  n1.error,
  n1.start,
  n1.start,
  n1.start,
  n1.start
  //10-17
], ia = [0, 1, 1, 2, 0, 0], sa = {
  classTable: aa,
  classFactor: 6,
  stateTable: na,
  charLenTable: ia,
  name: "Shift_JIS"
}, I4 = {};
(function(e) {
  e.jp2CharContext = [
    [0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1],
    [2, 4, 0, 4, 0, 3, 0, 4, 0, 3, 4, 4, 4, 2, 4, 3, 3, 4, 3, 2, 3, 3, 4, 2, 3, 3, 3, 2, 4, 1, 4, 3, 3, 1, 5, 4, 3, 4, 3, 4, 3, 5, 3, 0, 3, 5, 4, 2, 0, 3, 1, 0, 3, 3, 0, 3, 3, 0, 1, 1, 0, 4, 3, 0, 3, 3, 0, 4, 0, 2, 0, 3, 5, 5, 5, 5, 4, 0, 4, 1, 0, 3, 4],
    [0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2],
    [0, 4, 0, 5, 0, 5, 0, 4, 0, 4, 5, 4, 4, 3, 5, 3, 5, 1, 5, 3, 4, 3, 4, 4, 3, 4, 3, 3, 4, 3, 5, 4, 4, 3, 5, 5, 3, 5, 5, 5, 3, 5, 5, 3, 4, 5, 5, 3, 1, 3, 2, 0, 3, 4, 0, 4, 2, 0, 4, 2, 1, 5, 3, 2, 3, 5, 0, 4, 0, 2, 0, 5, 4, 4, 5, 4, 5, 0, 4, 0, 0, 4, 4],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 3, 0, 4, 0, 3, 0, 3, 0, 4, 5, 4, 3, 3, 3, 3, 4, 3, 5, 4, 4, 3, 5, 4, 4, 3, 4, 3, 4, 4, 4, 4, 5, 3, 4, 4, 3, 4, 5, 5, 4, 5, 5, 1, 4, 5, 4, 3, 0, 3, 3, 1, 3, 3, 0, 4, 4, 0, 3, 3, 1, 5, 3, 3, 3, 5, 0, 4, 0, 3, 0, 4, 4, 3, 4, 3, 3, 0, 4, 1, 1, 3, 4],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 4, 0, 3, 0, 3, 0, 4, 0, 3, 4, 4, 3, 2, 2, 1, 2, 1, 3, 1, 3, 3, 3, 3, 3, 4, 3, 1, 3, 3, 5, 3, 3, 0, 4, 3, 0, 5, 4, 3, 3, 5, 4, 4, 3, 4, 4, 5, 0, 1, 2, 0, 1, 2, 0, 2, 2, 0, 1, 0, 0, 5, 2, 2, 1, 4, 0, 3, 0, 1, 0, 4, 4, 3, 5, 4, 3, 0, 2, 1, 0, 4, 3],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 3, 0, 5, 0, 4, 0, 2, 1, 4, 4, 2, 4, 1, 4, 2, 4, 2, 4, 3, 3, 3, 4, 3, 3, 3, 3, 1, 4, 2, 3, 3, 3, 1, 4, 4, 1, 1, 1, 4, 3, 3, 2, 0, 2, 4, 3, 2, 0, 3, 3, 0, 3, 1, 1, 0, 0, 0, 3, 3, 0, 4, 2, 2, 3, 4, 0, 4, 0, 3, 0, 4, 4, 5, 3, 4, 4, 0, 3, 0, 0, 1, 4],
    [1, 4, 0, 4, 0, 4, 0, 4, 0, 3, 5, 4, 4, 3, 4, 3, 5, 4, 3, 3, 4, 3, 5, 4, 4, 4, 4, 3, 4, 2, 4, 3, 3, 1, 5, 4, 3, 2, 4, 5, 4, 5, 5, 4, 4, 5, 4, 4, 0, 3, 2, 2, 3, 3, 0, 4, 3, 1, 3, 2, 1, 4, 3, 3, 4, 5, 0, 3, 0, 2, 0, 4, 5, 5, 4, 5, 4, 0, 4, 0, 0, 5, 4],
    [0, 5, 0, 5, 0, 4, 0, 3, 0, 4, 4, 3, 4, 3, 3, 3, 4, 0, 4, 4, 4, 3, 4, 3, 4, 3, 3, 1, 4, 2, 4, 3, 4, 0, 5, 4, 1, 4, 5, 4, 4, 5, 3, 2, 4, 3, 4, 3, 2, 4, 1, 3, 3, 3, 2, 3, 2, 0, 4, 3, 3, 4, 3, 3, 3, 4, 0, 4, 0, 3, 0, 4, 5, 4, 4, 4, 3, 0, 4, 1, 0, 1, 3],
    [0, 3, 1, 4, 0, 3, 0, 2, 0, 3, 4, 4, 3, 1, 4, 2, 3, 3, 4, 3, 4, 3, 4, 3, 4, 4, 3, 2, 3, 1, 5, 4, 4, 1, 4, 4, 3, 5, 4, 4, 3, 5, 5, 4, 3, 4, 4, 3, 1, 2, 3, 1, 2, 2, 0, 3, 2, 0, 3, 1, 0, 5, 3, 3, 3, 4, 3, 3, 3, 3, 4, 4, 4, 4, 5, 4, 2, 0, 3, 3, 2, 4, 3],
    [0, 2, 0, 3, 0, 1, 0, 1, 0, 0, 3, 2, 0, 0, 2, 0, 1, 0, 2, 1, 3, 3, 3, 1, 2, 3, 1, 0, 1, 0, 4, 2, 1, 1, 3, 3, 0, 4, 3, 3, 1, 4, 3, 3, 0, 3, 3, 2, 0, 0, 0, 0, 1, 0, 0, 2, 0, 0, 0, 0, 0, 4, 1, 0, 2, 3, 2, 2, 2, 1, 3, 3, 3, 4, 4, 3, 2, 0, 3, 1, 0, 3, 3],
    [0, 4, 0, 4, 0, 3, 0, 3, 0, 4, 4, 4, 3, 3, 3, 3, 3, 3, 4, 3, 4, 2, 4, 3, 4, 3, 3, 2, 4, 3, 4, 5, 4, 1, 4, 5, 3, 5, 4, 5, 3, 5, 4, 0, 3, 5, 5, 3, 1, 3, 3, 2, 2, 3, 0, 3, 4, 1, 3, 3, 2, 4, 3, 3, 3, 4, 0, 4, 0, 3, 0, 4, 5, 4, 4, 5, 3, 0, 4, 1, 0, 3, 4],
    [0, 2, 0, 3, 0, 3, 0, 0, 0, 2, 2, 2, 1, 0, 1, 0, 0, 0, 3, 0, 3, 0, 3, 0, 1, 3, 1, 0, 3, 1, 3, 3, 3, 1, 3, 3, 3, 0, 1, 3, 1, 3, 4, 0, 0, 3, 1, 1, 0, 3, 2, 0, 0, 0, 0, 1, 3, 0, 1, 0, 0, 3, 3, 2, 0, 3, 0, 0, 0, 0, 0, 3, 4, 3, 4, 3, 3, 0, 3, 0, 0, 2, 3],
    [2, 3, 0, 3, 0, 2, 0, 1, 0, 3, 3, 4, 3, 1, 3, 1, 1, 1, 3, 1, 4, 3, 4, 3, 3, 3, 0, 0, 3, 1, 5, 4, 3, 1, 4, 3, 2, 5, 5, 4, 4, 4, 4, 3, 3, 4, 4, 4, 0, 2, 1, 1, 3, 2, 0, 1, 2, 0, 0, 1, 0, 4, 1, 3, 3, 3, 0, 3, 0, 1, 0, 4, 4, 4, 5, 5, 3, 0, 2, 0, 0, 4, 4],
    [0, 2, 0, 1, 0, 3, 1, 3, 0, 2, 3, 3, 3, 0, 3, 1, 0, 0, 3, 0, 3, 2, 3, 1, 3, 2, 1, 1, 0, 0, 4, 2, 1, 0, 2, 3, 1, 4, 3, 2, 0, 4, 4, 3, 1, 3, 1, 3, 0, 1, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 0, 4, 1, 1, 1, 2, 0, 3, 0, 0, 0, 3, 4, 2, 4, 3, 2, 0, 1, 0, 0, 3, 3],
    [0, 1, 0, 4, 0, 5, 0, 4, 0, 2, 4, 4, 2, 3, 3, 2, 3, 3, 5, 3, 3, 3, 4, 3, 4, 2, 3, 0, 4, 3, 3, 3, 4, 1, 4, 3, 2, 1, 5, 5, 3, 4, 5, 1, 3, 5, 4, 2, 0, 3, 3, 0, 1, 3, 0, 4, 2, 0, 1, 3, 1, 4, 3, 3, 3, 3, 0, 3, 0, 1, 0, 3, 4, 4, 4, 5, 5, 0, 3, 0, 1, 4, 5],
    [0, 2, 0, 3, 0, 3, 0, 0, 0, 2, 3, 1, 3, 0, 4, 0, 1, 1, 3, 0, 3, 4, 3, 2, 3, 1, 0, 3, 3, 2, 3, 1, 3, 0, 2, 3, 0, 2, 1, 4, 1, 2, 2, 0, 0, 3, 3, 0, 0, 2, 0, 0, 0, 1, 0, 0, 0, 0, 2, 2, 0, 3, 2, 1, 3, 3, 0, 2, 0, 2, 0, 0, 3, 3, 1, 2, 4, 0, 3, 0, 2, 2, 3],
    [2, 4, 0, 5, 0, 4, 0, 4, 0, 2, 4, 4, 4, 3, 4, 3, 3, 3, 1, 2, 4, 3, 4, 3, 4, 4, 5, 0, 3, 3, 3, 3, 2, 0, 4, 3, 1, 4, 3, 4, 1, 4, 4, 3, 3, 4, 4, 3, 1, 2, 3, 0, 4, 2, 0, 4, 1, 0, 3, 3, 0, 4, 3, 3, 3, 4, 0, 4, 0, 2, 0, 3, 5, 3, 4, 5, 2, 0, 3, 0, 0, 4, 5],
    [0, 3, 0, 4, 0, 1, 0, 1, 0, 1, 3, 2, 2, 1, 3, 0, 3, 0, 2, 0, 2, 0, 3, 0, 2, 0, 0, 0, 1, 0, 1, 1, 0, 0, 3, 1, 0, 0, 0, 4, 0, 3, 1, 0, 2, 1, 3, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 4, 2, 2, 3, 1, 0, 3, 0, 0, 0, 1, 4, 4, 4, 3, 0, 0, 4, 0, 0, 1, 4],
    [1, 4, 1, 5, 0, 3, 0, 3, 0, 4, 5, 4, 4, 3, 5, 3, 3, 4, 4, 3, 4, 1, 3, 3, 3, 3, 2, 1, 4, 1, 5, 4, 3, 1, 4, 4, 3, 5, 4, 4, 3, 5, 4, 3, 3, 4, 4, 4, 0, 3, 3, 1, 2, 3, 0, 3, 1, 0, 3, 3, 0, 5, 4, 4, 4, 4, 4, 4, 3, 3, 5, 4, 4, 3, 3, 5, 4, 0, 3, 2, 0, 4, 4],
    [0, 2, 0, 3, 0, 1, 0, 0, 0, 1, 3, 3, 3, 2, 4, 1, 3, 0, 3, 1, 3, 0, 2, 2, 1, 1, 0, 0, 2, 0, 4, 3, 1, 0, 4, 3, 0, 4, 4, 4, 1, 4, 3, 1, 1, 3, 3, 1, 0, 2, 0, 0, 1, 3, 0, 0, 0, 0, 2, 0, 0, 4, 3, 2, 4, 3, 5, 4, 3, 3, 3, 4, 3, 3, 4, 3, 3, 0, 2, 1, 0, 3, 3],
    [0, 2, 0, 4, 0, 3, 0, 2, 0, 2, 5, 5, 3, 4, 4, 4, 4, 1, 4, 3, 3, 0, 4, 3, 4, 3, 1, 3, 3, 2, 4, 3, 0, 3, 4, 3, 0, 3, 4, 4, 2, 4, 4, 0, 4, 5, 3, 3, 2, 2, 1, 1, 1, 2, 0, 1, 5, 0, 3, 3, 2, 4, 3, 3, 3, 4, 0, 3, 0, 2, 0, 4, 4, 3, 5, 5, 0, 0, 3, 0, 2, 3, 3],
    [0, 3, 0, 4, 0, 3, 0, 1, 0, 3, 4, 3, 3, 1, 3, 3, 3, 0, 3, 1, 3, 0, 4, 3, 3, 1, 1, 0, 3, 0, 3, 3, 0, 0, 4, 4, 0, 1, 5, 4, 3, 3, 5, 0, 3, 3, 4, 3, 0, 2, 0, 1, 1, 1, 0, 1, 3, 0, 1, 2, 1, 3, 3, 2, 3, 3, 0, 3, 0, 1, 0, 1, 3, 3, 4, 4, 1, 0, 1, 2, 2, 1, 3],
    [0, 1, 0, 4, 0, 4, 0, 3, 0, 1, 3, 3, 3, 2, 3, 1, 1, 0, 3, 0, 3, 3, 4, 3, 2, 4, 2, 0, 1, 0, 4, 3, 2, 0, 4, 3, 0, 5, 3, 3, 2, 4, 4, 4, 3, 3, 3, 4, 0, 1, 3, 0, 0, 1, 0, 0, 1, 0, 0, 0, 0, 4, 2, 3, 3, 3, 0, 3, 0, 0, 0, 4, 4, 4, 5, 3, 2, 0, 3, 3, 0, 3, 5],
    [0, 2, 0, 3, 0, 0, 0, 3, 0, 1, 3, 0, 2, 0, 0, 0, 1, 0, 3, 1, 1, 3, 3, 0, 0, 3, 0, 0, 3, 0, 2, 3, 1, 0, 3, 1, 0, 3, 3, 2, 0, 4, 2, 2, 0, 2, 0, 0, 0, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 1, 2, 0, 1, 0, 1, 0, 0, 0, 1, 3, 1, 2, 0, 0, 0, 1, 0, 0, 1, 4],
    [0, 3, 0, 3, 0, 5, 0, 1, 0, 2, 4, 3, 1, 3, 3, 2, 1, 1, 5, 2, 1, 0, 5, 1, 2, 0, 0, 0, 3, 3, 2, 2, 3, 2, 4, 3, 0, 0, 3, 3, 1, 3, 3, 0, 2, 5, 3, 4, 0, 3, 3, 0, 1, 2, 0, 2, 2, 0, 3, 2, 0, 2, 2, 3, 3, 3, 0, 2, 0, 1, 0, 3, 4, 4, 2, 5, 4, 0, 3, 0, 0, 3, 5],
    [0, 3, 0, 3, 0, 3, 0, 1, 0, 3, 3, 3, 3, 0, 3, 0, 2, 0, 2, 1, 1, 0, 2, 0, 1, 0, 0, 0, 2, 1, 0, 0, 1, 0, 3, 2, 0, 0, 3, 3, 1, 2, 3, 1, 0, 3, 3, 0, 0, 1, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 2, 3, 1, 2, 3, 0, 3, 0, 1, 0, 3, 2, 1, 0, 4, 3, 0, 1, 1, 0, 3, 3],
    [0, 4, 0, 5, 0, 3, 0, 3, 0, 4, 5, 5, 4, 3, 5, 3, 4, 3, 5, 3, 3, 2, 5, 3, 4, 4, 4, 3, 4, 3, 4, 5, 5, 3, 4, 4, 3, 4, 4, 5, 4, 4, 4, 3, 4, 5, 5, 4, 2, 3, 4, 2, 3, 4, 0, 3, 3, 1, 4, 3, 2, 4, 3, 3, 5, 5, 0, 3, 0, 3, 0, 5, 5, 5, 5, 4, 4, 0, 4, 0, 1, 4, 4],
    [0, 4, 0, 4, 0, 3, 0, 3, 0, 3, 5, 4, 4, 2, 3, 2, 5, 1, 3, 2, 5, 1, 4, 2, 3, 2, 3, 3, 4, 3, 3, 3, 3, 2, 5, 4, 1, 3, 3, 5, 3, 4, 4, 0, 4, 4, 3, 1, 1, 3, 1, 0, 2, 3, 0, 2, 3, 0, 3, 0, 0, 4, 3, 1, 3, 4, 0, 3, 0, 2, 0, 4, 4, 4, 3, 4, 5, 0, 4, 0, 0, 3, 4],
    [0, 3, 0, 3, 0, 3, 1, 2, 0, 3, 4, 4, 3, 3, 3, 0, 2, 2, 4, 3, 3, 1, 3, 3, 3, 1, 1, 0, 3, 1, 4, 3, 2, 3, 4, 4, 2, 4, 4, 4, 3, 4, 4, 3, 2, 4, 4, 3, 1, 3, 3, 1, 3, 3, 0, 4, 1, 0, 2, 2, 1, 4, 3, 2, 3, 3, 5, 4, 3, 3, 5, 4, 4, 3, 3, 0, 4, 0, 3, 2, 2, 4, 4],
    [0, 2, 0, 1, 0, 0, 0, 0, 0, 1, 2, 1, 3, 0, 0, 0, 0, 0, 2, 0, 1, 2, 1, 0, 0, 1, 0, 0, 0, 0, 3, 0, 0, 1, 0, 1, 1, 3, 1, 0, 0, 0, 1, 1, 0, 1, 1, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 2, 2, 0, 3, 4, 0, 0, 0, 1, 1, 0, 0, 1, 0, 0, 0, 0, 0, 1, 1],
    [0, 1, 0, 0, 0, 1, 0, 0, 0, 0, 4, 0, 4, 1, 4, 0, 3, 0, 4, 0, 3, 0, 4, 0, 3, 0, 3, 0, 4, 1, 5, 1, 4, 0, 0, 3, 0, 5, 0, 5, 2, 0, 1, 0, 0, 0, 2, 1, 4, 0, 1, 3, 0, 0, 3, 0, 0, 3, 1, 1, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0],
    [1, 4, 0, 5, 0, 3, 0, 2, 0, 3, 5, 4, 4, 3, 4, 3, 5, 3, 4, 3, 3, 0, 4, 3, 3, 3, 3, 3, 3, 2, 4, 4, 3, 1, 3, 4, 4, 5, 4, 4, 3, 4, 4, 1, 3, 5, 4, 3, 3, 3, 1, 2, 2, 3, 3, 1, 3, 1, 3, 3, 3, 5, 3, 3, 4, 5, 0, 3, 0, 3, 0, 3, 4, 3, 4, 4, 3, 0, 3, 0, 2, 4, 3],
    [0, 1, 0, 4, 0, 0, 0, 0, 0, 1, 4, 0, 4, 1, 4, 2, 4, 0, 3, 0, 1, 0, 1, 0, 0, 0, 0, 0, 2, 0, 3, 1, 1, 1, 0, 3, 0, 0, 0, 1, 2, 1, 0, 0, 1, 1, 1, 1, 0, 1, 0, 0, 0, 1, 0, 0, 3, 0, 0, 0, 0, 3, 2, 0, 2, 2, 0, 1, 0, 0, 0, 2, 3, 2, 3, 3, 0, 0, 0, 0, 2, 1, 0],
    [0, 5, 1, 5, 0, 3, 0, 3, 0, 5, 4, 4, 5, 1, 5, 3, 3, 0, 4, 3, 4, 3, 5, 3, 4, 3, 3, 2, 4, 3, 4, 3, 3, 0, 3, 3, 1, 4, 4, 3, 4, 4, 4, 3, 4, 5, 5, 3, 2, 3, 1, 1, 3, 3, 1, 3, 1, 1, 3, 3, 2, 4, 5, 3, 3, 5, 0, 4, 0, 3, 0, 4, 4, 3, 5, 3, 3, 0, 3, 4, 0, 4, 3],
    [0, 5, 0, 5, 0, 3, 0, 2, 0, 4, 4, 3, 5, 2, 4, 3, 3, 3, 4, 4, 4, 3, 5, 3, 5, 3, 3, 1, 4, 0, 4, 3, 3, 0, 3, 3, 0, 4, 4, 4, 4, 5, 4, 3, 3, 5, 5, 3, 2, 3, 1, 2, 3, 2, 0, 1, 0, 0, 3, 2, 2, 4, 4, 3, 1, 5, 0, 4, 0, 3, 0, 4, 3, 1, 3, 2, 1, 0, 3, 3, 0, 3, 3],
    [0, 4, 0, 5, 0, 5, 0, 4, 0, 4, 5, 5, 5, 3, 4, 3, 3, 2, 5, 4, 4, 3, 5, 3, 5, 3, 4, 0, 4, 3, 4, 4, 3, 2, 4, 4, 3, 4, 5, 4, 4, 5, 5, 0, 3, 5, 5, 4, 1, 3, 3, 2, 3, 3, 1, 3, 1, 0, 4, 3, 1, 4, 4, 3, 4, 5, 0, 4, 0, 2, 0, 4, 3, 4, 4, 3, 3, 0, 4, 0, 0, 5, 5],
    [0, 4, 0, 4, 0, 5, 0, 1, 1, 3, 3, 4, 4, 3, 4, 1, 3, 0, 5, 1, 3, 0, 3, 1, 3, 1, 1, 0, 3, 0, 3, 3, 4, 0, 4, 3, 0, 4, 4, 4, 3, 4, 4, 0, 3, 5, 4, 1, 0, 3, 0, 0, 2, 3, 0, 3, 1, 0, 3, 1, 0, 3, 2, 1, 3, 5, 0, 3, 0, 1, 0, 3, 2, 3, 3, 4, 4, 0, 2, 2, 0, 4, 4],
    [2, 4, 0, 5, 0, 4, 0, 3, 0, 4, 5, 5, 4, 3, 5, 3, 5, 3, 5, 3, 5, 2, 5, 3, 4, 3, 3, 4, 3, 4, 5, 3, 2, 1, 5, 4, 3, 2, 3, 4, 5, 3, 4, 1, 2, 5, 4, 3, 0, 3, 3, 0, 3, 2, 0, 2, 3, 0, 4, 1, 0, 3, 4, 3, 3, 5, 0, 3, 0, 1, 0, 4, 5, 5, 5, 4, 3, 0, 4, 2, 0, 3, 5],
    [0, 5, 0, 4, 0, 4, 0, 2, 0, 5, 4, 3, 4, 3, 4, 3, 3, 3, 4, 3, 4, 2, 5, 3, 5, 3, 4, 1, 4, 3, 4, 4, 4, 0, 3, 5, 0, 4, 4, 4, 4, 5, 3, 1, 3, 4, 5, 3, 3, 3, 3, 3, 3, 3, 0, 2, 2, 0, 3, 3, 2, 4, 3, 3, 3, 5, 3, 4, 1, 3, 3, 5, 3, 2, 0, 0, 0, 0, 4, 3, 1, 3, 3],
    [0, 1, 0, 3, 0, 3, 0, 1, 0, 1, 3, 3, 3, 2, 3, 3, 3, 0, 3, 0, 0, 0, 3, 1, 3, 0, 0, 0, 2, 2, 2, 3, 0, 0, 3, 2, 0, 1, 2, 4, 1, 3, 3, 0, 0, 3, 3, 3, 0, 1, 0, 0, 2, 1, 0, 0, 3, 0, 3, 1, 0, 3, 0, 0, 1, 3, 0, 2, 0, 1, 0, 3, 3, 1, 3, 3, 0, 0, 1, 1, 0, 3, 3],
    [0, 2, 0, 3, 0, 2, 1, 4, 0, 2, 2, 3, 1, 1, 3, 1, 1, 0, 2, 0, 3, 1, 2, 3, 1, 3, 0, 0, 1, 0, 4, 3, 2, 3, 3, 3, 1, 4, 2, 3, 3, 3, 3, 1, 0, 3, 1, 4, 0, 1, 1, 0, 1, 2, 0, 1, 1, 0, 1, 1, 0, 3, 1, 3, 2, 2, 0, 1, 0, 0, 0, 2, 3, 3, 3, 1, 0, 0, 0, 0, 0, 2, 3],
    [0, 5, 0, 4, 0, 5, 0, 2, 0, 4, 5, 5, 3, 3, 4, 3, 3, 1, 5, 4, 4, 2, 4, 4, 4, 3, 4, 2, 4, 3, 5, 5, 4, 3, 3, 4, 3, 3, 5, 5, 4, 5, 5, 1, 3, 4, 5, 3, 1, 4, 3, 1, 3, 3, 0, 3, 3, 1, 4, 3, 1, 4, 5, 3, 3, 5, 0, 4, 0, 3, 0, 5, 3, 3, 1, 4, 3, 0, 4, 0, 1, 5, 3],
    [0, 5, 0, 5, 0, 4, 0, 2, 0, 4, 4, 3, 4, 3, 3, 3, 3, 3, 5, 4, 4, 4, 4, 4, 4, 5, 3, 3, 5, 2, 4, 4, 4, 3, 4, 4, 3, 3, 4, 4, 5, 5, 3, 3, 4, 3, 4, 3, 3, 4, 3, 3, 3, 3, 1, 2, 2, 1, 4, 3, 3, 5, 4, 4, 3, 4, 0, 4, 0, 3, 0, 4, 4, 4, 4, 4, 1, 0, 4, 2, 0, 2, 4],
    [0, 4, 0, 4, 0, 3, 0, 1, 0, 3, 5, 2, 3, 0, 3, 0, 2, 1, 4, 2, 3, 3, 4, 1, 4, 3, 3, 2, 4, 1, 3, 3, 3, 0, 3, 3, 0, 0, 3, 3, 3, 5, 3, 3, 3, 3, 3, 2, 0, 2, 0, 0, 2, 0, 0, 2, 0, 0, 1, 0, 0, 3, 1, 2, 2, 3, 0, 3, 0, 2, 0, 4, 4, 3, 3, 4, 1, 0, 3, 0, 0, 2, 4],
    [0, 0, 0, 4, 0, 0, 0, 0, 0, 0, 1, 0, 1, 0, 2, 0, 0, 0, 0, 0, 1, 0, 2, 0, 1, 0, 0, 0, 0, 0, 3, 1, 3, 0, 3, 2, 0, 0, 0, 1, 0, 3, 2, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 4, 0, 2, 0, 0, 0, 0, 0, 0, 2],
    [0, 2, 1, 3, 0, 2, 0, 2, 0, 3, 3, 3, 3, 1, 3, 1, 3, 3, 3, 3, 3, 3, 4, 2, 2, 1, 2, 1, 4, 0, 4, 3, 1, 3, 3, 3, 2, 4, 3, 5, 4, 3, 3, 3, 3, 3, 3, 3, 0, 1, 3, 0, 2, 0, 0, 1, 0, 0, 1, 0, 0, 4, 2, 0, 2, 3, 0, 3, 3, 0, 3, 3, 4, 2, 3, 1, 4, 0, 1, 2, 0, 2, 3],
    [0, 3, 0, 3, 0, 1, 0, 3, 0, 2, 3, 3, 3, 0, 3, 1, 2, 0, 3, 3, 2, 3, 3, 2, 3, 2, 3, 1, 3, 0, 4, 3, 2, 0, 3, 3, 1, 4, 3, 3, 2, 3, 4, 3, 1, 3, 3, 1, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 4, 1, 1, 0, 3, 0, 3, 1, 0, 2, 3, 3, 3, 3, 3, 1, 0, 0, 2, 0, 3, 3],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 0, 2, 0, 3, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 3, 0, 3, 0, 3, 1, 0, 1, 0, 1, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 0, 2, 0, 2, 3, 0, 0, 0, 0, 0, 0, 0, 0, 3],
    [0, 2, 0, 3, 1, 3, 0, 3, 0, 2, 3, 3, 3, 1, 3, 1, 3, 1, 3, 1, 3, 3, 3, 1, 3, 0, 2, 3, 1, 1, 4, 3, 3, 2, 3, 3, 1, 2, 2, 4, 1, 3, 3, 0, 1, 4, 2, 3, 0, 1, 3, 0, 3, 0, 0, 1, 3, 0, 2, 0, 0, 3, 3, 2, 1, 3, 0, 3, 0, 2, 0, 3, 4, 4, 4, 3, 1, 0, 3, 0, 0, 3, 3],
    [0, 2, 0, 1, 0, 2, 0, 0, 0, 1, 3, 2, 2, 1, 3, 0, 1, 1, 3, 0, 3, 2, 3, 1, 2, 0, 2, 0, 1, 1, 3, 3, 3, 0, 3, 3, 1, 1, 2, 3, 2, 3, 3, 1, 2, 3, 2, 0, 0, 1, 0, 0, 0, 0, 0, 0, 3, 0, 1, 0, 0, 2, 1, 2, 1, 3, 0, 3, 0, 0, 0, 3, 4, 4, 4, 3, 2, 0, 2, 0, 0, 2, 4],
    [0, 0, 0, 1, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0, 0, 0, 0, 0, 3],
    [0, 3, 0, 3, 0, 2, 0, 3, 0, 3, 3, 3, 2, 3, 2, 2, 2, 0, 3, 1, 3, 3, 3, 2, 3, 3, 0, 0, 3, 0, 3, 2, 2, 0, 2, 3, 1, 4, 3, 4, 3, 3, 2, 3, 1, 5, 4, 4, 0, 3, 1, 2, 1, 3, 0, 3, 1, 1, 2, 0, 2, 3, 1, 3, 1, 3, 0, 3, 0, 1, 0, 3, 3, 4, 4, 2, 1, 0, 2, 1, 0, 2, 4],
    [0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 4, 2, 5, 1, 4, 0, 2, 0, 2, 1, 3, 1, 4, 0, 2, 1, 0, 0, 2, 1, 4, 1, 1, 0, 3, 3, 0, 5, 1, 3, 2, 3, 3, 1, 0, 3, 2, 3, 0, 1, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 4, 0, 1, 0, 3, 0, 2, 0, 1, 0, 3, 3, 3, 4, 3, 3, 0, 0, 0, 0, 2, 3],
    [0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 2, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 1, 0, 0, 1, 0, 0, 0, 0, 0, 3],
    [0, 1, 0, 3, 0, 4, 0, 3, 0, 2, 4, 3, 1, 0, 3, 2, 2, 1, 3, 1, 2, 2, 3, 1, 1, 1, 2, 1, 3, 0, 1, 2, 0, 1, 3, 2, 1, 3, 0, 5, 5, 1, 0, 0, 1, 3, 2, 1, 0, 3, 0, 0, 1, 0, 0, 0, 0, 0, 3, 4, 0, 1, 1, 1, 3, 2, 0, 2, 0, 1, 0, 2, 3, 3, 1, 2, 3, 0, 1, 0, 1, 0, 4],
    [0, 0, 0, 1, 0, 3, 0, 3, 0, 2, 2, 1, 0, 0, 4, 0, 3, 0, 3, 1, 3, 0, 3, 0, 3, 0, 1, 0, 3, 0, 3, 1, 3, 0, 3, 3, 0, 0, 1, 2, 1, 1, 1, 0, 1, 2, 0, 0, 0, 1, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2, 1, 2, 0, 0, 2, 0, 0, 0, 0, 2, 3, 3, 3, 3, 0, 0, 0, 0, 1, 4],
    [0, 0, 0, 3, 0, 3, 0, 0, 0, 0, 3, 1, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0, 0, 0, 0, 0, 0, 0, 1, 0, 3, 0, 2, 0, 2, 3, 0, 0, 2, 2, 3, 1, 2, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0, 2, 0, 0, 0, 0, 2, 3],
    [2, 4, 0, 5, 0, 5, 0, 4, 0, 3, 4, 3, 3, 3, 4, 3, 3, 3, 4, 3, 4, 4, 5, 4, 5, 5, 5, 2, 3, 0, 5, 5, 4, 1, 5, 4, 3, 1, 5, 4, 3, 4, 4, 3, 3, 4, 3, 3, 0, 3, 2, 0, 2, 3, 0, 3, 0, 0, 3, 3, 0, 5, 3, 2, 3, 3, 0, 3, 0, 3, 0, 3, 4, 5, 4, 5, 3, 0, 4, 3, 0, 3, 4],
    [0, 3, 0, 3, 0, 3, 0, 3, 0, 3, 3, 4, 3, 2, 3, 2, 3, 0, 4, 3, 3, 3, 3, 3, 3, 3, 3, 0, 3, 2, 4, 3, 3, 1, 3, 4, 3, 4, 4, 4, 3, 4, 4, 3, 2, 4, 4, 1, 0, 2, 0, 0, 1, 1, 0, 2, 0, 0, 3, 1, 0, 5, 3, 2, 1, 3, 0, 3, 0, 1, 2, 4, 3, 2, 4, 3, 3, 0, 3, 2, 0, 4, 4],
    [0, 3, 0, 3, 0, 1, 0, 0, 0, 1, 4, 3, 3, 2, 3, 1, 3, 1, 4, 2, 3, 2, 4, 2, 3, 4, 3, 0, 2, 2, 3, 3, 3, 0, 3, 3, 3, 0, 3, 4, 1, 3, 3, 0, 3, 4, 3, 3, 0, 1, 1, 0, 1, 0, 0, 0, 4, 0, 3, 0, 0, 3, 1, 2, 1, 3, 0, 4, 0, 1, 0, 4, 3, 3, 4, 3, 3, 0, 2, 0, 0, 3, 3],
    [0, 3, 0, 4, 0, 1, 0, 3, 0, 3, 4, 3, 3, 0, 3, 3, 3, 1, 3, 1, 3, 3, 4, 3, 3, 3, 0, 0, 3, 1, 5, 3, 3, 1, 3, 3, 2, 5, 4, 3, 3, 4, 5, 3, 2, 5, 3, 4, 0, 1, 0, 0, 0, 0, 0, 2, 0, 0, 1, 1, 0, 4, 2, 2, 1, 3, 0, 3, 0, 2, 0, 4, 4, 3, 5, 3, 2, 0, 1, 1, 0, 3, 4],
    [0, 5, 0, 4, 0, 5, 0, 2, 0, 4, 4, 3, 3, 2, 3, 3, 3, 1, 4, 3, 4, 1, 5, 3, 4, 3, 4, 0, 4, 2, 4, 3, 4, 1, 5, 4, 0, 4, 4, 4, 4, 5, 4, 1, 3, 5, 4, 2, 1, 4, 1, 1, 3, 2, 0, 3, 1, 0, 3, 2, 1, 4, 3, 3, 3, 4, 0, 4, 0, 3, 0, 4, 4, 4, 3, 3, 3, 0, 4, 2, 0, 3, 4],
    [1, 4, 0, 4, 0, 3, 0, 1, 0, 3, 3, 3, 1, 1, 3, 3, 2, 2, 3, 3, 1, 0, 3, 2, 2, 1, 2, 0, 3, 1, 2, 1, 2, 0, 3, 2, 0, 2, 2, 3, 3, 4, 3, 0, 3, 3, 1, 2, 0, 1, 1, 3, 1, 2, 0, 0, 3, 0, 1, 1, 0, 3, 2, 2, 3, 3, 0, 3, 0, 0, 0, 2, 3, 3, 4, 3, 3, 0, 1, 0, 0, 1, 4],
    [0, 4, 0, 4, 0, 4, 0, 0, 0, 3, 4, 4, 3, 1, 4, 2, 3, 2, 3, 3, 3, 1, 4, 3, 4, 0, 3, 0, 4, 2, 3, 3, 2, 2, 5, 4, 2, 1, 3, 4, 3, 4, 3, 1, 3, 3, 4, 2, 0, 2, 1, 0, 3, 3, 0, 0, 2, 0, 3, 1, 0, 4, 4, 3, 4, 3, 0, 4, 0, 1, 0, 2, 4, 4, 4, 4, 4, 0, 3, 2, 0, 3, 3],
    [0, 0, 0, 1, 0, 4, 0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 1, 0, 3, 2, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 2],
    [0, 2, 0, 3, 0, 4, 0, 4, 0, 1, 3, 3, 3, 0, 4, 0, 2, 1, 2, 1, 1, 1, 2, 0, 3, 1, 1, 0, 1, 0, 3, 1, 0, 0, 3, 3, 2, 0, 1, 1, 0, 0, 0, 0, 0, 1, 0, 2, 0, 2, 2, 0, 3, 1, 0, 0, 1, 0, 1, 1, 0, 1, 2, 0, 3, 0, 0, 0, 0, 1, 0, 0, 3, 3, 4, 3, 1, 0, 1, 0, 3, 0, 2],
    [0, 0, 0, 3, 0, 5, 0, 0, 0, 0, 1, 0, 2, 0, 3, 1, 0, 1, 3, 0, 0, 0, 2, 0, 0, 0, 1, 0, 0, 0, 1, 1, 0, 0, 4, 0, 0, 0, 2, 3, 0, 1, 4, 1, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 3, 0, 0, 0, 0, 0, 3],
    [0, 2, 0, 5, 0, 5, 0, 1, 0, 2, 4, 3, 3, 2, 5, 1, 3, 2, 3, 3, 3, 0, 4, 1, 2, 0, 3, 0, 4, 0, 2, 2, 1, 1, 5, 3, 0, 0, 1, 4, 2, 3, 2, 0, 3, 3, 3, 2, 0, 2, 4, 1, 1, 2, 0, 1, 1, 0, 3, 1, 0, 1, 3, 1, 2, 3, 0, 2, 0, 0, 0, 1, 3, 5, 4, 4, 4, 0, 3, 0, 0, 1, 3],
    [0, 4, 0, 5, 0, 4, 0, 4, 0, 4, 5, 4, 3, 3, 4, 3, 3, 3, 4, 3, 4, 4, 5, 3, 4, 5, 4, 2, 4, 2, 3, 4, 3, 1, 4, 4, 1, 3, 5, 4, 4, 5, 5, 4, 4, 5, 5, 5, 2, 3, 3, 1, 4, 3, 1, 3, 3, 0, 3, 3, 1, 4, 3, 4, 4, 4, 0, 3, 0, 4, 0, 3, 3, 4, 4, 5, 0, 0, 4, 3, 0, 4, 5],
    [0, 4, 0, 4, 0, 3, 0, 3, 0, 3, 4, 4, 4, 3, 3, 2, 4, 3, 4, 3, 4, 3, 5, 3, 4, 3, 2, 1, 4, 2, 4, 4, 3, 1, 3, 4, 2, 4, 5, 5, 3, 4, 5, 4, 1, 5, 4, 3, 0, 3, 2, 2, 3, 2, 1, 3, 1, 0, 3, 3, 3, 5, 3, 3, 3, 5, 4, 4, 2, 3, 3, 4, 3, 3, 3, 2, 1, 0, 3, 2, 1, 4, 3],
    [0, 4, 0, 5, 0, 4, 0, 3, 0, 3, 5, 5, 3, 2, 4, 3, 4, 0, 5, 4, 4, 1, 4, 4, 4, 3, 3, 3, 4, 3, 5, 5, 2, 3, 3, 4, 1, 2, 5, 5, 3, 5, 5, 2, 3, 5, 5, 4, 0, 3, 2, 0, 3, 3, 1, 1, 5, 1, 4, 1, 0, 4, 3, 2, 3, 5, 0, 4, 0, 3, 0, 5, 4, 3, 4, 3, 0, 0, 4, 1, 0, 4, 4],
    [1, 3, 0, 4, 0, 2, 0, 2, 0, 2, 5, 5, 3, 3, 3, 3, 3, 0, 4, 2, 3, 4, 4, 4, 3, 4, 0, 0, 3, 4, 5, 4, 3, 3, 3, 3, 2, 5, 5, 4, 5, 5, 5, 4, 3, 5, 5, 5, 1, 3, 1, 0, 1, 0, 0, 3, 2, 0, 4, 2, 0, 5, 2, 3, 2, 4, 1, 3, 0, 3, 0, 4, 5, 4, 5, 4, 3, 0, 4, 2, 0, 5, 4],
    [0, 3, 0, 4, 0, 5, 0, 3, 0, 3, 4, 4, 3, 2, 3, 2, 3, 3, 3, 3, 3, 2, 4, 3, 3, 2, 2, 0, 3, 3, 3, 3, 3, 1, 3, 3, 3, 0, 4, 4, 3, 4, 4, 1, 1, 4, 4, 2, 0, 3, 1, 0, 1, 1, 0, 4, 1, 0, 2, 3, 1, 3, 3, 1, 3, 4, 0, 3, 0, 1, 0, 3, 1, 3, 0, 0, 1, 0, 2, 0, 0, 4, 4],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 3, 0, 3, 0, 2, 0, 3, 0, 1, 5, 4, 3, 3, 3, 1, 4, 2, 1, 2, 3, 4, 4, 2, 4, 4, 5, 0, 3, 1, 4, 3, 4, 0, 4, 3, 3, 3, 2, 3, 2, 5, 3, 4, 3, 2, 2, 3, 0, 0, 3, 0, 2, 1, 0, 1, 2, 0, 0, 0, 0, 2, 1, 1, 3, 1, 0, 2, 0, 4, 0, 3, 4, 4, 4, 5, 2, 0, 2, 0, 0, 1, 3],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 1, 1, 0, 0, 1, 1, 0, 0, 0, 4, 2, 1, 1, 0, 1, 0, 3, 2, 0, 0, 3, 1, 1, 1, 2, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 0, 1, 0, 0, 0, 2, 0, 0, 0, 1, 4, 0, 4, 2, 1, 0, 0, 0, 0, 0, 1],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 1, 0, 1, 0, 0, 0, 0, 3, 1, 0, 0, 0, 2, 0, 2, 1, 0, 0, 1, 2, 1, 0, 1, 1, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0, 0, 0, 1, 0, 0, 2, 1, 0, 0, 0, 0, 0, 0, 0, 0, 2],
    [0, 4, 0, 4, 0, 4, 0, 3, 0, 4, 4, 3, 4, 2, 4, 3, 2, 0, 4, 4, 4, 3, 5, 3, 5, 3, 3, 2, 4, 2, 4, 3, 4, 3, 1, 4, 0, 2, 3, 4, 4, 4, 3, 3, 3, 4, 4, 4, 3, 4, 1, 3, 4, 3, 2, 1, 2, 1, 3, 3, 3, 4, 4, 3, 3, 5, 0, 4, 0, 3, 0, 4, 3, 3, 3, 2, 1, 0, 3, 0, 0, 3, 3],
    [0, 4, 0, 3, 0, 3, 0, 3, 0, 3, 5, 5, 3, 3, 3, 3, 4, 3, 4, 3, 3, 3, 4, 4, 4, 3, 3, 3, 3, 4, 3, 5, 3, 3, 1, 3, 2, 4, 5, 5, 5, 5, 4, 3, 4, 5, 5, 3, 2, 2, 3, 3, 3, 3, 2, 3, 3, 1, 2, 3, 2, 4, 3, 3, 3, 4, 0, 4, 0, 2, 0, 4, 3, 2, 2, 1, 2, 0, 3, 0, 0, 4, 1]
  ];
  function t() {
    var n = 6, i = -1, c = 100, s = 1e3, f = 4, o = this;
    function l() {
      o.reset();
    }
    this.reset = function() {
      this._mTotalRel = 0, this._mRelSample = [];
      for (var d = 0; d < n; this._mRelSample[d++] = 0)
        ;
      this._mNeedToSkipCharNum = 0, this._mLastCharOrder = -1, this._mDone = !1;
    }, this.feed = function(d, u) {
      if (!this._mDone)
        for (var h = this._mNeedToSkipCharNum; h < u; ) {
          var p = this.getOrder(d.slice(h, h + 2)), v = p[0], x = p[1];
          if (h += x, h > u)
            this._mNeedToSkipCharNum = h - u, this._mLastCharOrder = -1;
          else {
            if (v != -1 && this._mLastCharOrder != -1) {
              if (this._mTotalRel += 1, this._mTotalRel > s) {
                this._mDone = !0;
                break;
              }
              this._mRelSample[e.jp2CharContext[this._mLastCharOrder][v]] += 1;
            }
            this._mLastCharOrder = v;
          }
        }
    }, this.gotEnoughData = function() {
      return this._mTotalRel > c;
    }, this.getConfidence = function() {
      return this._mTotalRel > f ? (this._mTotalRel - this._mRelSample[0]) / this._mTotalRel : i;
    }, this.getOrder = function(d) {
      return [-1, 1];
    }, l();
  }
  function r() {
    this.getOrder = function(n) {
      if (!n)
        return [-1, 1];
      if (n.charCodeAt(0) >= 129 && n.charCodeAt(0) <= 159 || n.charCodeAt(0) >= 224 && n.charCodeAt(0) <= 252)
        var i = 2;
      else
        i = 1;
      return n.length > 1 && n.charCodeAt(0) == 130 && n.charCodeAt(1) >= 159 && n.charCodeAt(0) <= 241 ? [n.charCodeAt(1) - 159, i] : [-1, i];
    };
  }
  r.prototype = new t(), e.SJISContextAnalysis = r;
  function a() {
    this.getOrder = function(n) {
      if (!n)
        return [-1, 1];
      if (n.charCodeAt(0) >= 142 || n.charCodeAt(0) >= 161 && n.charCodeAt(0) <= 254)
        var i = 2;
      else
        n.charCodeAt(0) == 143 ? i = 3 : i = 1;
      return n.length > 1 && n.charCodeAt(0) == 164 && n.charCodeAt(1) >= 161 && n.charCodeAt(1) <= 243 ? [n.charCodeAt(1) - 161, i] : [-1, i];
    };
  }
  a.prototype = new t(), e.EUCJPContextAnalysis = a;
})(I4);
var ca = P2, Kr = T3, fa = sa, oa = Y1.SJISDistributionAnalysis, la = I4.SJISContextAnalysis, A2 = d1, ha = h2;
function b4() {
  Kr.apply(this);
  var e = this;
  function t() {
    e._mCodingSM = new ca(fa), e._mDistributionAnalyzer = new oa(), e._mContextAnalyzer = new la(), e.reset();
  }
  this.reset = function() {
    b4.prototype.reset.apply(this), this._mContextAnalyzer.reset();
  }, this.getCharsetName = function() {
    return "SHIFT_JIS";
  }, this.feed = function(r) {
    for (var a = r.length, n = 0; n < a; n++) {
      var i = this._mCodingSM.nextState(r[n]);
      if (i == A2.error) {
        ha.log(this.getCharsetName() + " prober hit error at byte " + n + `
`), this._mState = A2.notMe;
        break;
      } else if (i == A2.itsMe) {
        this._mState = A2.foundIt;
        break;
      } else if (i == A2.start) {
        var c = this._mCodingSM.getCurrentCharLen();
        n == 0 ? (this._mLastChar[1] = r[0], this._mContextAnalyzer.feed(this._mLastChar.slice(2 - c).join(""), c), this._mDistributionAnalyzer.feed(this._mLastChar.join(""), c)) : (this._mContextAnalyzer.feed(r.slice(n + 1 - c, n + 3 - c), c), this._mDistributionAnalyzer.feed(r.slice(n - 1, n + 1), c));
      }
    }
    return this._mLastChar[0] = r[a - 1], this.getState() == A2.detecting && this._mContextAnalyzer.gotEnoughData() && this.getConfidence() > A2.SHORTCUT_THRESHOLD && (this._mState = A2.foundIt), this.getState();
  }, this.getConfidence = function() {
    var r = this._mContextAnalyzer.getConfidence(), a = this._mDistributionAnalyzer.getConfidence();
    return Math.max(r, a);
  }, t();
}
b4.prototype = new Kr();
var ua = b4, U0 = d1, xa = [
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  // 00 - 07
  4,
  4,
  4,
  4,
  4,
  4,
  5,
  5,
  // 08 - 0f
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  // 10 - 17
  4,
  4,
  4,
  5,
  4,
  4,
  4,
  4,
  // 18 - 1f
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  // 20 - 27
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  // 28 - 2f
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  // 30 - 37
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  // 38 - 3f
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  // 40 - 47
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  // 48 - 4f
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  // 50 - 57
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  // 58 - 5f
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  // 60 - 67
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  // 68 - 6f
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  // 70 - 77
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  // 78 - 7f
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  // 80 - 87
  5,
  5,
  5,
  5,
  5,
  5,
  1,
  3,
  // 88 - 8f
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  // 90 - 97
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  // 98 - 9f
  5,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // a0 - a7
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // a8 - af
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // b0 - b7
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // b8 - bf
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // c0 - c7
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // c8 - cf
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // d0 - d7
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // d8 - df
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // e0 - e7
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // e8 - ef
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // f0 - f7
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  5
  // f8 - ff
], da = [
  3,
  4,
  3,
  5,
  U0.start,
  U0.error,
  U0.error,
  U0.error,
  //00-07
  U0.error,
  U0.error,
  U0.error,
  U0.error,
  U0.itsMe,
  U0.itsMe,
  U0.itsMe,
  U0.itsMe,
  //08-0f
  U0.itsMe,
  U0.itsMe,
  U0.start,
  U0.error,
  U0.start,
  U0.error,
  U0.error,
  U0.error,
  //10-17
  U0.error,
  U0.error,
  U0.start,
  U0.error,
  U0.error,
  U0.error,
  3,
  U0.error,
  //18-1f
  3,
  U0.error,
  U0.error,
  U0.error,
  U0.start,
  U0.start,
  U0.start,
  U0.start
  //20-27
], pa = [2, 2, 2, 3, 1, 0], ma = {
  classTable: xa,
  classFactor: 6,
  stateTable: da,
  charLenTable: pa,
  name: "EUC-JP"
}, va = P2, Yr = T3, ga = Y1.EUCJPDistributionAnalysis, _a = I4.EUCJPContextAnalysis, Ta = ma, F2 = d1, Ea = h2;
function D4() {
  Yr.apply(this);
  var e = this;
  function t() {
    e._mCodingSM = new va(Ta), e._mDistributionAnalyzer = new ga(), e._mContextAnalyzer = new _a(), e.reset();
  }
  this.reset = function() {
    D4.prototype.reset.apply(this), this._mContextAnalyzer.reset();
  }, this.getCharsetName = function() {
    return "EUC-JP";
  }, this.feed = function(r) {
    for (var a = r.length, n = 0; n < a; n++) {
      var i = this._mCodingSM.nextState(r[n]);
      if (i == F2.error) {
        Ea.log(this.getCharsetName() + " prober hit error at byte " + n + `
`), this._mState = F2.notMe;
        break;
      } else if (i == F2.itsMe) {
        this._mState = F2.foundIt;
        break;
      } else if (i == F2.start) {
        var c = this._mCodingSM.getCurrentCharLen();
        if (n == 0) {
          this._mLastChar[1] = r[0];
          var s = this._mLastChar.join("");
          this._mContextAnalyzer.feed(s, c), this._mDistributionAnalyzer.feed(s, c);
        } else
          this._mContextAnalyzer.feed(r.slice(n - 1, n + 1), c), this._mDistributionAnalyzer.feed(r.slice(n - 1, n + 1), c);
      }
    }
    return this._mLastChar[0] = r[a - 1], this.getState() == F2.detecting && this._mContextAnalyzer.gotEnoughData() && this.getConfidence() > F2.SHORTCUT_THRESHOLD && (this._mState = F2.foundIt), this.getState();
  }, this.getConfidence = function() {
    var r = this._mContextAnalyzer.getConfidence(), a = this._mDistributionAnalyzer.getConfidence();
    return Math.max(r, a);
  }, t();
}
D4.prototype = new Yr();
var wa = D4, C0 = d1, ka = [
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 00 - 07
  1,
  1,
  1,
  1,
  1,
  1,
  0,
  0,
  // 08 - 0f
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 10 - 17
  1,
  1,
  1,
  0,
  1,
  1,
  1,
  1,
  // 18 - 1f
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 20 - 27
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 28 - 2f
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  // 30 - 37
  3,
  3,
  1,
  1,
  1,
  1,
  1,
  1,
  // 38 - 3f
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 40 - 47
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 48 - 4f
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 50 - 57
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 58 - 5f
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 60 - 67
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 68 - 6f
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 70 - 77
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  4,
  // 78 - 7f
  5,
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  // 80 - 87
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  // 88 - 8f
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  // 90 - 97
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  // 98 - 9f
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  // a0 - a7
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  // a8 - af
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  // b0 - b7
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  // b8 - bf
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  // c0 - c7
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  // c8 - cf
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  // d0 - d7
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  // d8 - df
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  // e0 - e7
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  // e8 - ef
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  // f0 - f7
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  0
  // f8 - ff
], Ca = [
  C0.error,
  C0.start,
  C0.start,
  C0.start,
  C0.start,
  C0.start,
  3,
  C0.error,
  //00-07
  C0.error,
  C0.error,
  C0.error,
  C0.error,
  C0.error,
  C0.error,
  C0.itsMe,
  C0.itsMe,
  //08-0f
  C0.itsMe,
  C0.itsMe,
  C0.itsMe,
  C0.itsMe,
  C0.itsMe,
  C0.error,
  C0.error,
  C0.start,
  //10-17
  4,
  C0.error,
  C0.start,
  C0.start,
  C0.error,
  C0.error,
  C0.error,
  C0.error,
  //18-1f
  C0.error,
  C0.error,
  5,
  C0.error,
  C0.error,
  C0.error,
  C0.itsMe,
  C0.error,
  //20-27
  C0.error,
  C0.error,
  C0.start,
  C0.start,
  C0.start,
  C0.start,
  C0.start,
  C0.start
  //28-2f
], Sa = [0, 1, 1, 1, 1, 1, 2], Aa = {
  classTable: ka,
  classFactor: 7,
  stateTable: Ca,
  charLenTable: Sa,
  name: "GB2312"
}, Jr = T3, Fa = P2, ya = Aa, Ia = Y1.GB2312DistributionAnalysis;
function qr() {
  Jr.apply(this);
  var e = this;
  function t() {
    e._mCodingSM = new Fa(ya), e._mDistributionAnalyzer = new Ia(), e.reset();
  }
  this.getCharsetName = function() {
    return "GB2312";
  }, t();
}
qr.prototype = new Jr();
var ba = qr, O1 = d1, Da = [
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 00 - 07
  1,
  1,
  1,
  1,
  1,
  1,
  0,
  0,
  // 08 - 0f
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 10 - 17
  1,
  1,
  1,
  0,
  1,
  1,
  1,
  1,
  // 18 - 1f
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 20 - 27
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 28 - 2f
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 30 - 37
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 38 - 3f
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 40 - 47
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 48 - 4f
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 50 - 57
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 58 - 5f
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 60 - 67
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 68 - 6f
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 70 - 77
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 78 - 7f
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 80 - 87
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 88 - 8f
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 90 - 97
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 98 - 9f
  0,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // a0 - a7
  2,
  2,
  2,
  2,
  2,
  3,
  3,
  3,
  // a8 - af
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // b0 - b7
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // b8 - bf
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // c0 - c7
  2,
  3,
  2,
  2,
  2,
  2,
  2,
  2,
  // c8 - cf
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // d0 - d7
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // d8 - df
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // e0 - e7
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // e8 - ef
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // f0 - f7
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  0
  // f8 - ff
], Oa = [
  O1.error,
  O1.start,
  3,
  O1.error,
  O1.error,
  O1.error,
  O1.error,
  O1.error,
  //00-07
  O1.itsMe,
  O1.itsMe,
  O1.itsMe,
  O1.itsMe,
  O1.error,
  O1.error,
  O1.start,
  O1.start
  //08-0f
], Ra = [0, 1, 2, 0], Ma = {
  classTable: Da,
  classFactor: 4,
  stateTable: Oa,
  charLenTable: Ra,
  name: "EUC-KR"
}, Na = P2, Zr = T3, Pa = Y1.EUCKRDistributionAnalysis, La = Ma;
function Qr() {
  Zr.apply(this);
  var e = this;
  function t() {
    e._mCodingSM = new Na(La), e._mDistributionAnalyzer = new Pa(), e.reset();
  }
  this.getCharsetName = function() {
    return "EUC-KR";
  }, t();
}
Qr.prototype = new Zr();
var Ba = Qr, y0 = d1, Ua = [
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 00 - 07
  2,
  2,
  2,
  2,
  2,
  2,
  0,
  0,
  // 08 - 0f
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 10 - 17
  2,
  2,
  2,
  0,
  2,
  2,
  2,
  2,
  // 18 - 1f
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 20 - 27
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 28 - 2f
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 30 - 37
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 38 - 3f
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 40 - 47
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 48 - 4f
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 50 - 57
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 58 - 5f
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 60 - 67
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 68 - 6f
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 70 - 77
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 78 - 7f
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 80 - 87
  0,
  0,
  0,
  0,
  0,
  0,
  6,
  0,
  // 88 - 8f
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 90 - 97
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 98 - 9f
  0,
  3,
  4,
  4,
  4,
  4,
  4,
  4,
  // a0 - a7
  5,
  5,
  1,
  1,
  1,
  1,
  1,
  1,
  // a8 - af
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // b0 - b7
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // b8 - bf
  1,
  1,
  3,
  1,
  3,
  3,
  3,
  3,
  // c0 - c7
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  // c8 - cf
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  // d0 - d7
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  // d8 - df
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  // e0 - e7
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  // e8 - ef
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  // f0 - f7
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  0
  // f8 - ff
], Ha = [
  y0.error,
  y0.error,
  y0.start,
  3,
  3,
  3,
  4,
  y0.error,
  //00-07
  y0.error,
  y0.error,
  y0.error,
  y0.error,
  y0.error,
  y0.error,
  y0.itsMe,
  y0.itsMe,
  //08-0f
  y0.itsMe,
  y0.itsMe,
  y0.itsMe,
  y0.itsMe,
  y0.itsMe,
  y0.error,
  y0.start,
  y0.error,
  //10-17
  y0.start,
  y0.start,
  y0.start,
  y0.error,
  y0.error,
  y0.error,
  y0.error,
  y0.error,
  //18-1f
  5,
  y0.error,
  y0.error,
  y0.error,
  y0.start,
  y0.error,
  y0.start,
  y0.start,
  //20-27
  y0.start,
  y0.error,
  y0.start,
  y0.start,
  y0.start,
  y0.start,
  y0.start,
  y0.start
  //28-2f
], Wa = [0, 0, 1, 2, 2, 2, 3], Va = {
  classTable: Ua,
  classFactor: 7,
  stateTable: Ha,
  charLenTable: Wa,
  name: "x-euc-tw"
}, Ga = P2, e6 = T3, ja = Y1.EUCTWDistributionAnalysis, za = Va;
function r6() {
  e6.apply(this);
  var e = this;
  function t() {
    e._mCodingSM = new Ga(za), e._mDistributionAnalyzer = new ja(), e.reset();
  }
  this.getCharsetName = function() {
    return "EUC-TW";
  }, t();
}
r6.prototype = new e6();
var $a = r6, t6 = Lr, Xa = Yt, Ka = ta, Ya = ua, Ja = wa, qa = ba, Za = Ba, Qa = $a;
function a6() {
  t6.apply(this), this._mProbers = [
    new Ka(),
    new Ya(),
    new Ja(),
    new qa(),
    new Za(),
    new Xa(),
    new Qa()
  ];
  const e = this._mProbers.map((t) => t.getCharsetName());
  this.getSupportedCharsetNames = function() {
    return e;
  }, this.reset();
}
a6.prototype = new t6();
var e9 = a6, n6 = Z2, m5 = d1, v5 = h2;
function O4(e, t, r) {
  n6.apply(this);
  var a = 64, n = 1024, i = 0.95, c = 0.05, s = 250, f = 4, o = f - 1, l = this;
  function d(u, h, p) {
    l._mModel = u, l._mReversed = h, l._mNameProber = p, l.reset();
  }
  this.reset = function() {
    O4.prototype.reset.apply(this), this._mLastOrder = 255, this._mSeqCounters = [];
    for (var u = 0; u < f; this._mSeqCounters[u++] = 0)
      ;
    this._mTotalSeqs = 0, this._mTotalChar = 0, this._mFreqChar = 0;
  }, this.getCharsetName = function() {
    return this._mNameProber ? this._mNameProber.getCharsetName() : this._mModel.charsetName;
  }, this.feed = function(u) {
    this._mModel.keepEnglishLetter || (u = this.filterWithoutEnglishLetters(u));
    var h = u.length;
    if (!h)
      return this.getState();
    for (var p = 0, v; p < h; p++) {
      v = u.charCodeAt(p);
      var x = this._mModel.charToOrderMap[v];
      x < s && this._mTotalChar++, x < a && (this._mFreqChar++, this._mLastOrder < a && (this._mTotalSeqs++, this._mReversed ? this._mSeqCounters[this._mModel.precedenceMatrix[x * a + this._mLastOrder]]++ : this._mSeqCounters[this._mModel.precedenceMatrix[this._mLastOrder * a + x]]++)), this._mLastOrder = x;
    }
    if (this.getState() == m5.detecting && l._mTotalSeqs > n) {
      var m = this.getConfidence();
      m > i ? v5.log(this._mModel.charsetName + " confidence = " + m + `, we have a winner
`) : m < c && (v5.log(this._mModel.charsetName + " confidence = " + m + ", below negative shortcut threshhold " + c + `
`), this._mState = m5.notMe);
    }
    return this.getState();
  }, this.getConfidence = function() {
    var u = 0.01;
    return this._mTotalSeqs > 0 && (u = 1 * this._mSeqCounters[o] / this._mTotalSeqs / this._mModel.mTypicalPositiveRatio, u *= this._mFreqChar / this._mTotalChar, u >= 1 && (u = 0.99)), u;
  }, t = t !== void 0 ? t : !1, r = r !== void 0 ? r : null, d(e, t, r);
}
O4.prototype = new n6();
var r9 = O4, i6 = {};
(function(e) {
  e.win1255_CharToOrderMap = [
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    254,
    255,
    255,
    254,
    255,
    255,
    // 00
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    // 10
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    // 20
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    253,
    253,
    253,
    253,
    253,
    253,
    // 30
    253,
    69,
    91,
    79,
    80,
    92,
    89,
    97,
    90,
    68,
    111,
    112,
    82,
    73,
    95,
    85,
    // 40
    78,
    121,
    86,
    71,
    67,
    102,
    107,
    84,
    114,
    103,
    115,
    253,
    253,
    253,
    253,
    253,
    // 50
    253,
    50,
    74,
    60,
    61,
    42,
    76,
    70,
    64,
    53,
    105,
    93,
    56,
    65,
    54,
    49,
    // 60
    66,
    110,
    51,
    43,
    44,
    63,
    81,
    77,
    98,
    75,
    108,
    253,
    253,
    253,
    253,
    253,
    // 70
    124,
    202,
    203,
    204,
    205,
    40,
    58,
    206,
    207,
    208,
    209,
    210,
    211,
    212,
    213,
    214,
    215,
    83,
    52,
    47,
    46,
    72,
    32,
    94,
    216,
    113,
    217,
    109,
    218,
    219,
    220,
    221,
    34,
    116,
    222,
    118,
    100,
    223,
    224,
    117,
    119,
    104,
    125,
    225,
    226,
    87,
    99,
    227,
    106,
    122,
    123,
    228,
    55,
    229,
    230,
    101,
    231,
    232,
    120,
    233,
    48,
    39,
    57,
    234,
    30,
    59,
    41,
    88,
    33,
    37,
    36,
    31,
    29,
    35,
    235,
    62,
    28,
    236,
    126,
    237,
    238,
    38,
    45,
    239,
    240,
    241,
    242,
    243,
    127,
    244,
    245,
    246,
    247,
    248,
    249,
    250,
    9,
    8,
    20,
    16,
    3,
    2,
    24,
    14,
    22,
    1,
    25,
    15,
    4,
    11,
    6,
    23,
    12,
    19,
    13,
    26,
    18,
    27,
    21,
    17,
    7,
    10,
    5,
    251,
    252,
    128,
    96,
    253
  ], e.HebrewLangModel = [
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    2,
    1,
    2,
    0,
    1,
    0,
    0,
    3,
    0,
    3,
    1,
    0,
    0,
    1,
    3,
    2,
    0,
    1,
    1,
    2,
    0,
    2,
    2,
    2,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    2,
    0,
    0,
    2,
    2,
    0,
    1,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    2,
    2,
    1,
    2,
    1,
    2,
    1,
    2,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    2,
    1,
    2,
    1,
    3,
    1,
    1,
    0,
    0,
    2,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    0,
    1,
    2,
    2,
    1,
    3,
    1,
    2,
    1,
    1,
    2,
    2,
    0,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    2,
    2,
    2,
    2,
    3,
    2,
    1,
    2,
    1,
    2,
    2,
    2,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    2,
    3,
    2,
    2,
    3,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    1,
    2,
    1,
    1,
    2,
    2,
    0,
    1,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    0,
    2,
    2,
    2,
    2,
    2,
    0,
    2,
    0,
    2,
    2,
    2,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    0,
    2,
    2,
    2,
    0,
    2,
    1,
    2,
    2,
    2,
    0,
    0,
    2,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    1,
    2,
    3,
    2,
    2,
    2,
    1,
    2,
    1,
    2,
    2,
    2,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    0,
    2,
    0,
    2,
    0,
    2,
    1,
    2,
    2,
    2,
    0,
    0,
    1,
    2,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    2,
    0,
    0,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    2,
    3,
    2,
    2,
    3,
    2,
    1,
    2,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    3,
    0,
    1,
    0,
    0,
    0,
    0,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    0,
    2,
    0,
    1,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    2,
    1,
    2,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    2,
    3,
    2,
    1,
    2,
    0,
    2,
    1,
    2,
    0,
    2,
    0,
    2,
    2,
    2,
    0,
    0,
    1,
    2,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    1,
    2,
    2,
    3,
    3,
    2,
    3,
    2,
    3,
    2,
    2,
    3,
    1,
    2,
    2,
    0,
    2,
    2,
    2,
    0,
    2,
    1,
    2,
    2,
    2,
    0,
    0,
    1,
    2,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    2,
    3,
    3,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    1,
    3,
    2,
    2,
    2,
    0,
    2,
    0,
    1,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    3,
    3,
    3,
    2,
    3,
    2,
    2,
    2,
    1,
    2,
    2,
    0,
    2,
    2,
    2,
    2,
    0,
    2,
    0,
    2,
    2,
    2,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    1,
    3,
    2,
    3,
    3,
    2,
    3,
    3,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    0,
    2,
    1,
    2,
    1,
    2,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    2,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    2,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    0,
    2,
    0,
    1,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    1,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    2,
    3,
    2,
    1,
    2,
    3,
    0,
    2,
    1,
    2,
    2,
    0,
    2,
    1,
    1,
    2,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    2,
    1,
    3,
    1,
    2,
    2,
    2,
    1,
    2,
    3,
    3,
    1,
    2,
    1,
    2,
    2,
    2,
    2,
    0,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    2,
    3,
    3,
    3,
    1,
    3,
    3,
    3,
    1,
    2,
    2,
    2,
    2,
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    0,
    2,
    0,
    1,
    1,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    2,
    2,
    3,
    3,
    3,
    2,
    1,
    2,
    3,
    2,
    3,
    2,
    2,
    2,
    2,
    1,
    2,
    1,
    1,
    1,
    2,
    2,
    0,
    2,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    2,
    3,
    1,
    2,
    2,
    2,
    2,
    3,
    2,
    3,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    1,
    1,
    0,
    2,
    2,
    2,
    2,
    0,
    1,
    0,
    1,
    2,
    2,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    0,
    0,
    1,
    1,
    0,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    1,
    0,
    1,
    0,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    1,
    2,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    0,
    3,
    3,
    3,
    0,
    3,
    0,
    2,
    2,
    2,
    2,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    2,
    2,
    2,
    3,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    1,
    2,
    2,
    2,
    1,
    1,
    1,
    2,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    1,
    0,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    1,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    2,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    2,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    2,
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    1,
    2,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    1,
    2,
    1,
    1,
    2,
    1,
    1,
    1,
    2,
    1,
    2,
    1,
    2,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    1,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    2,
    1,
    1,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    1,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    2,
    0,
    2,
    0,
    1,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    1,
    1,
    1,
    2,
    1,
    2,
    2,
    2,
    0,
    2,
    0,
    2,
    0,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    2,
    1,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    2,
    2,
    0,
    1,
    0,
    0,
    1,
    1,
    2,
    2,
    1,
    2,
    0,
    2,
    0,
    0,
    0,
    1,
    2,
    0,
    1,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    2,
    1,
    2,
    0,
    2,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    2,
    1,
    1,
    0,
    1,
    0,
    0,
    1,
    1,
    1,
    2,
    2,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    1,
    1,
    2,
    1,
    0,
    1,
    1,
    1,
    0,
    1,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    1,
    0,
    2,
    0,
    1,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    1,
    0,
    0,
    1,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    2,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    1,
    1,
    2,
    1,
    1,
    2,
    0,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    1,
    2,
    0,
    1,
    0,
    0,
    0,
    0,
    2,
    1,
    1,
    2,
    0,
    2,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    2,
    1,
    1,
    0,
    1,
    0,
    0,
    2,
    2,
    1,
    2,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    2,
    0,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    2,
    2,
    0,
    0,
    0,
    0,
    2,
    1,
    1,
    1,
    0,
    2,
    1,
    1,
    0,
    0,
    0,
    2,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    1,
    2,
    0,
    1,
    0,
    0,
    1,
    1,
    0,
    2,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    2,
    2,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    2,
    1,
    1,
    0,
    1,
    0,
    0,
    1,
    1,
    0,
    1,
    2,
    1,
    0,
    2,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    2,
    0,
    2,
    1,
    1,
    0,
    1,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    1,
    2,
    0,
    1,
    0,
    0,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    2,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    0
  ], e.Win1255HebrewModel = {
    charToOrderMap: e.win1255_CharToOrderMap,
    precedenceMatrix: e.HebrewLangModel,
    mTypicalPositiveRatio: 0.984004,
    keepEnglishLetter: !1,
    charsetName: "windows-1255"
  };
})(i6);
var s6 = Z2, W2 = d1;
Array.prototype.indexOf || (Array.prototype.indexOf = function(e) {
  var t = this.length >>> 0, r = Number(arguments[1]) || 0;
  for (r = r < 0 ? Math.ceil(r) : Math.floor(r), r < 0 && (r += t); r < t; r++)
    if (r in this && this[r] === e)
      return r;
  return -1;
});
function c6() {
  s6.apply(this);
  var e = "ê", t = "ë", r = "í", a = "î", n = "ï", i = "ð", c = "ó", s = "ô", f = "õ", o = 5, l = 0.01, d = "ISO-8859-8", u = "windows-1255", h = this;
  function p() {
    h._mLogicalProber = null, h._mVisualProber = null, h.reset();
  }
  this.reset = function() {
    this._mFinalCharLogicalScore = 0, this._mFinalCharVisualScore = 0, this._mPrev = " ", this._mBeforePrev = " ";
  }, this.setModelProbers = function(v, x) {
    this._mLogicalProber = v, this._mVisualProber = x;
  }, this.isFinal = function(v) {
    return [e, r, n, c, f].indexOf(v) != -1;
  }, this.isNonFinal = function(v) {
    return [t, a, i, s].indexOf(v) != -1;
  }, this.feed = function(v) {
    if (this.getState() == W2.notMe)
      return W2.notMe;
    v = this.filterHighBitOnly(v);
    for (var x = 0, m; x < v.length; x++)
      m = v[x], m == " " ? this._mBeforePrev != " " && (this.isFinal(this._mPrev) ? this._mFinalCharLogicalScore++ : this.isNonFinal(this._mPrev) && this._mFinalCharVisualScore++) : this._mBeforePrev == " " && this.isFinal(this._mPrev) && m != " " && this._mFinalCharVisualScore++, this._mBeforePrev = this._mPrev, this._mPrev = m;
    return W2.detecting;
  }, this.getCharsetName = function() {
    var v = this._mFinalCharLogicalScore - this._mFinalCharVisualScore;
    if (v >= o)
      return u;
    if (v <= -o)
      return d;
    var x = this._mLogicalProber.getConfidence() - this._mVisualProber.getConfidence();
    return x > l ? u : x < -l || v < 0 ? d : u;
  }, this.getState = function() {
    return this._mLogicalProber.getState() == W2.notMe && this._mVisualProber.getState() == W2.notMe ? W2.notMe : W2.detecting;
  }, p();
}
c6.prototype = new s6();
var t9 = c6, f6 = {};
(function(e) {
  e.KOI8R_CharToOrderMap = [
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    254,
    255,
    255,
    254,
    255,
    255,
    // 00
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    // 10
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    // 20
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    253,
    253,
    253,
    253,
    253,
    253,
    // 30
    253,
    142,
    143,
    144,
    145,
    146,
    147,
    148,
    149,
    150,
    151,
    152,
    74,
    153,
    75,
    154,
    // 40
    155,
    156,
    157,
    158,
    159,
    160,
    161,
    162,
    163,
    164,
    165,
    253,
    253,
    253,
    253,
    253,
    // 50
    253,
    71,
    172,
    66,
    173,
    65,
    174,
    76,
    175,
    64,
    176,
    177,
    77,
    72,
    178,
    69,
    // 60
    67,
    179,
    78,
    73,
    180,
    181,
    79,
    182,
    183,
    184,
    185,
    253,
    253,
    253,
    253,
    253,
    // 70
    191,
    192,
    193,
    194,
    195,
    196,
    197,
    198,
    199,
    200,
    201,
    202,
    203,
    204,
    205,
    206,
    // 80
    207,
    208,
    209,
    210,
    211,
    212,
    213,
    214,
    215,
    216,
    217,
    218,
    219,
    220,
    221,
    222,
    // 90
    223,
    224,
    225,
    68,
    226,
    227,
    228,
    229,
    230,
    231,
    232,
    233,
    234,
    235,
    236,
    237,
    // a0
    238,
    239,
    240,
    241,
    242,
    243,
    244,
    245,
    246,
    247,
    248,
    249,
    250,
    251,
    252,
    253,
    // b0
    27,
    3,
    21,
    28,
    13,
    2,
    39,
    19,
    26,
    4,
    23,
    11,
    8,
    12,
    5,
    1,
    // c0
    15,
    16,
    9,
    7,
    6,
    14,
    24,
    10,
    17,
    18,
    20,
    25,
    30,
    29,
    22,
    54,
    // d0
    59,
    37,
    44,
    58,
    41,
    48,
    53,
    46,
    55,
    42,
    60,
    36,
    49,
    38,
    31,
    34,
    // e0
    35,
    43,
    45,
    32,
    40,
    52,
    56,
    33,
    61,
    62,
    51,
    57,
    47,
    63,
    50,
    70
    // f0
  ], e.win1251_CharToOrderMap = [
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    254,
    255,
    255,
    254,
    255,
    255,
    // 00
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    // 10
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    // 20
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    253,
    253,
    253,
    253,
    253,
    253,
    // 30
    253,
    142,
    143,
    144,
    145,
    146,
    147,
    148,
    149,
    150,
    151,
    152,
    74,
    153,
    75,
    154,
    // 40
    155,
    156,
    157,
    158,
    159,
    160,
    161,
    162,
    163,
    164,
    165,
    253,
    253,
    253,
    253,
    253,
    // 50
    253,
    71,
    172,
    66,
    173,
    65,
    174,
    76,
    175,
    64,
    176,
    177,
    77,
    72,
    178,
    69,
    // 60
    67,
    179,
    78,
    73,
    180,
    181,
    79,
    182,
    183,
    184,
    185,
    253,
    253,
    253,
    253,
    253,
    // 70
    191,
    192,
    193,
    194,
    195,
    196,
    197,
    198,
    199,
    200,
    201,
    202,
    203,
    204,
    205,
    206,
    207,
    208,
    209,
    210,
    211,
    212,
    213,
    214,
    215,
    216,
    217,
    218,
    219,
    220,
    221,
    222,
    223,
    224,
    225,
    226,
    227,
    228,
    229,
    230,
    231,
    232,
    233,
    234,
    235,
    236,
    237,
    238,
    239,
    240,
    241,
    242,
    243,
    244,
    245,
    246,
    68,
    247,
    248,
    249,
    250,
    251,
    252,
    253,
    37,
    44,
    33,
    46,
    41,
    48,
    56,
    51,
    42,
    60,
    36,
    49,
    38,
    31,
    34,
    35,
    45,
    32,
    40,
    52,
    53,
    55,
    58,
    50,
    57,
    63,
    70,
    62,
    61,
    47,
    59,
    43,
    3,
    21,
    10,
    19,
    13,
    2,
    24,
    20,
    4,
    23,
    11,
    8,
    12,
    5,
    1,
    15,
    9,
    7,
    6,
    14,
    39,
    26,
    28,
    22,
    25,
    29,
    54,
    18,
    17,
    30,
    27,
    16
  ], e.latin5_CharToOrderMap = [
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    254,
    255,
    255,
    254,
    255,
    255,
    // 00
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    // 10
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    // 20
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    253,
    253,
    253,
    253,
    253,
    253,
    // 30
    253,
    142,
    143,
    144,
    145,
    146,
    147,
    148,
    149,
    150,
    151,
    152,
    74,
    153,
    75,
    154,
    // 40
    155,
    156,
    157,
    158,
    159,
    160,
    161,
    162,
    163,
    164,
    165,
    253,
    253,
    253,
    253,
    253,
    // 50
    253,
    71,
    172,
    66,
    173,
    65,
    174,
    76,
    175,
    64,
    176,
    177,
    77,
    72,
    178,
    69,
    // 60
    67,
    179,
    78,
    73,
    180,
    181,
    79,
    182,
    183,
    184,
    185,
    253,
    253,
    253,
    253,
    253,
    // 70
    191,
    192,
    193,
    194,
    195,
    196,
    197,
    198,
    199,
    200,
    201,
    202,
    203,
    204,
    205,
    206,
    207,
    208,
    209,
    210,
    211,
    212,
    213,
    214,
    215,
    216,
    217,
    218,
    219,
    220,
    221,
    222,
    223,
    224,
    225,
    226,
    227,
    228,
    229,
    230,
    231,
    232,
    233,
    234,
    235,
    236,
    237,
    238,
    37,
    44,
    33,
    46,
    41,
    48,
    56,
    51,
    42,
    60,
    36,
    49,
    38,
    31,
    34,
    35,
    45,
    32,
    40,
    52,
    53,
    55,
    58,
    50,
    57,
    63,
    70,
    62,
    61,
    47,
    59,
    43,
    3,
    21,
    10,
    19,
    13,
    2,
    24,
    20,
    4,
    23,
    11,
    8,
    12,
    5,
    1,
    15,
    9,
    7,
    6,
    14,
    39,
    26,
    28,
    22,
    25,
    29,
    54,
    18,
    17,
    30,
    27,
    16,
    239,
    68,
    240,
    241,
    242,
    243,
    244,
    245,
    246,
    247,
    248,
    249,
    250,
    251,
    252,
    255
  ], e.macCyrillic_CharToOrderMap = [
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    254,
    255,
    255,
    254,
    255,
    255,
    // 00
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    // 10
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    // 20
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    253,
    253,
    253,
    253,
    253,
    253,
    // 30
    253,
    142,
    143,
    144,
    145,
    146,
    147,
    148,
    149,
    150,
    151,
    152,
    74,
    153,
    75,
    154,
    // 40
    155,
    156,
    157,
    158,
    159,
    160,
    161,
    162,
    163,
    164,
    165,
    253,
    253,
    253,
    253,
    253,
    // 50
    253,
    71,
    172,
    66,
    173,
    65,
    174,
    76,
    175,
    64,
    176,
    177,
    77,
    72,
    178,
    69,
    // 60
    67,
    179,
    78,
    73,
    180,
    181,
    79,
    182,
    183,
    184,
    185,
    253,
    253,
    253,
    253,
    253,
    // 70
    37,
    44,
    33,
    46,
    41,
    48,
    56,
    51,
    42,
    60,
    36,
    49,
    38,
    31,
    34,
    35,
    45,
    32,
    40,
    52,
    53,
    55,
    58,
    50,
    57,
    63,
    70,
    62,
    61,
    47,
    59,
    43,
    191,
    192,
    193,
    194,
    195,
    196,
    197,
    198,
    199,
    200,
    201,
    202,
    203,
    204,
    205,
    206,
    207,
    208,
    209,
    210,
    211,
    212,
    213,
    214,
    215,
    216,
    217,
    218,
    219,
    220,
    221,
    222,
    223,
    224,
    225,
    226,
    227,
    228,
    229,
    230,
    231,
    232,
    233,
    234,
    235,
    236,
    237,
    238,
    239,
    240,
    241,
    242,
    243,
    244,
    245,
    246,
    247,
    248,
    249,
    250,
    251,
    252,
    68,
    16,
    3,
    21,
    10,
    19,
    13,
    2,
    24,
    20,
    4,
    23,
    11,
    8,
    12,
    5,
    1,
    15,
    9,
    7,
    6,
    14,
    39,
    26,
    28,
    22,
    25,
    29,
    54,
    18,
    17,
    30,
    27,
    255
  ], e.IBM855_CharToOrderMap = [
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    254,
    255,
    255,
    254,
    255,
    255,
    // 00
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    // 10
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    // 20
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    253,
    253,
    253,
    253,
    253,
    253,
    // 30
    253,
    142,
    143,
    144,
    145,
    146,
    147,
    148,
    149,
    150,
    151,
    152,
    74,
    153,
    75,
    154,
    // 40
    155,
    156,
    157,
    158,
    159,
    160,
    161,
    162,
    163,
    164,
    165,
    253,
    253,
    253,
    253,
    253,
    // 50
    253,
    71,
    172,
    66,
    173,
    65,
    174,
    76,
    175,
    64,
    176,
    177,
    77,
    72,
    178,
    69,
    // 60
    67,
    179,
    78,
    73,
    180,
    181,
    79,
    182,
    183,
    184,
    185,
    253,
    253,
    253,
    253,
    253,
    // 70
    191,
    192,
    193,
    194,
    68,
    195,
    196,
    197,
    198,
    199,
    200,
    201,
    202,
    203,
    204,
    205,
    206,
    207,
    208,
    209,
    210,
    211,
    212,
    213,
    214,
    215,
    216,
    217,
    27,
    59,
    54,
    70,
    3,
    37,
    21,
    44,
    28,
    58,
    13,
    41,
    2,
    48,
    39,
    53,
    19,
    46,
    218,
    219,
    220,
    221,
    222,
    223,
    224,
    26,
    55,
    4,
    42,
    225,
    226,
    227,
    228,
    23,
    60,
    229,
    230,
    231,
    232,
    233,
    234,
    235,
    11,
    36,
    236,
    237,
    238,
    239,
    240,
    241,
    242,
    243,
    8,
    49,
    12,
    38,
    5,
    31,
    1,
    34,
    15,
    244,
    245,
    246,
    247,
    35,
    16,
    248,
    43,
    9,
    45,
    7,
    32,
    6,
    40,
    14,
    52,
    24,
    56,
    10,
    33,
    17,
    61,
    249,
    250,
    18,
    62,
    20,
    51,
    25,
    57,
    30,
    47,
    29,
    63,
    22,
    50,
    251,
    252,
    255
  ], e.IBM866_CharToOrderMap = [
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    254,
    255,
    255,
    254,
    255,
    255,
    // 00
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    // 10
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    // 20
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    253,
    253,
    253,
    253,
    253,
    253,
    // 30
    253,
    142,
    143,
    144,
    145,
    146,
    147,
    148,
    149,
    150,
    151,
    152,
    74,
    153,
    75,
    154,
    // 40
    155,
    156,
    157,
    158,
    159,
    160,
    161,
    162,
    163,
    164,
    165,
    253,
    253,
    253,
    253,
    253,
    // 50
    253,
    71,
    172,
    66,
    173,
    65,
    174,
    76,
    175,
    64,
    176,
    177,
    77,
    72,
    178,
    69,
    // 60
    67,
    179,
    78,
    73,
    180,
    181,
    79,
    182,
    183,
    184,
    185,
    253,
    253,
    253,
    253,
    253,
    // 70
    37,
    44,
    33,
    46,
    41,
    48,
    56,
    51,
    42,
    60,
    36,
    49,
    38,
    31,
    34,
    35,
    45,
    32,
    40,
    52,
    53,
    55,
    58,
    50,
    57,
    63,
    70,
    62,
    61,
    47,
    59,
    43,
    3,
    21,
    10,
    19,
    13,
    2,
    24,
    20,
    4,
    23,
    11,
    8,
    12,
    5,
    1,
    15,
    191,
    192,
    193,
    194,
    195,
    196,
    197,
    198,
    199,
    200,
    201,
    202,
    203,
    204,
    205,
    206,
    207,
    208,
    209,
    210,
    211,
    212,
    213,
    214,
    215,
    216,
    217,
    218,
    219,
    220,
    221,
    222,
    223,
    224,
    225,
    226,
    227,
    228,
    229,
    230,
    231,
    232,
    233,
    234,
    235,
    236,
    237,
    238,
    9,
    7,
    6,
    14,
    39,
    26,
    28,
    22,
    25,
    29,
    54,
    18,
    17,
    30,
    27,
    16,
    239,
    68,
    240,
    241,
    242,
    243,
    244,
    245,
    246,
    247,
    248,
    249,
    250,
    251,
    252,
    255
  ], e.RussianLangModel = [
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    1,
    3,
    3,
    3,
    3,
    1,
    3,
    3,
    3,
    2,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    3,
    2,
    2,
    2,
    2,
    2,
    0,
    0,
    2,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    2,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    2,
    3,
    1,
    3,
    3,
    1,
    3,
    3,
    3,
    3,
    2,
    2,
    3,
    0,
    2,
    2,
    2,
    3,
    3,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    3,
    2,
    3,
    3,
    3,
    2,
    1,
    2,
    2,
    0,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    2,
    3,
    0,
    2,
    2,
    3,
    3,
    2,
    1,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    1,
    2,
    3,
    2,
    2,
    3,
    2,
    3,
    3,
    3,
    3,
    2,
    2,
    3,
    0,
    3,
    2,
    2,
    3,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    2,
    2,
    2,
    0,
    3,
    3,
    3,
    2,
    2,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    2,
    2,
    0,
    1,
    3,
    2,
    1,
    2,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    1,
    1,
    3,
    0,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    0,
    2,
    2,
    2,
    1,
    2,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    2,
    2,
    2,
    2,
    1,
    3,
    2,
    3,
    2,
    3,
    2,
    1,
    2,
    2,
    0,
    1,
    1,
    2,
    1,
    2,
    1,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    3,
    2,
    3,
    3,
    3,
    2,
    2,
    2,
    2,
    0,
    2,
    2,
    2,
    2,
    3,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    2,
    3,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    3,
    2,
    0,
    0,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    2,
    3,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    3,
    3,
    0,
    2,
    1,
    0,
    3,
    2,
    3,
    2,
    3,
    0,
    0,
    1,
    2,
    0,
    0,
    1,
    0,
    1,
    2,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    3,
    0,
    2,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    1,
    2,
    2,
    0,
    0,
    2,
    3,
    2,
    2,
    2,
    3,
    2,
    3,
    2,
    2,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    2,
    3,
    0,
    2,
    3,
    2,
    3,
    0,
    1,
    2,
    3,
    3,
    2,
    0,
    2,
    3,
    0,
    0,
    2,
    3,
    2,
    2,
    0,
    1,
    3,
    1,
    3,
    2,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    1,
    3,
    0,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    1,
    3,
    2,
    0,
    0,
    2,
    2,
    3,
    3,
    3,
    2,
    3,
    3,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    3,
    3,
    2,
    2,
    2,
    3,
    3,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    2,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    3,
    2,
    3,
    3,
    2,
    3,
    2,
    0,
    2,
    1,
    0,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    2,
    2,
    2,
    2,
    3,
    1,
    3,
    2,
    3,
    1,
    1,
    2,
    1,
    0,
    2,
    2,
    2,
    2,
    1,
    3,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    1,
    2,
    2,
    1,
    3,
    1,
    0,
    3,
    0,
    0,
    3,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    2,
    2,
    1,
    1,
    3,
    3,
    3,
    2,
    2,
    1,
    2,
    2,
    3,
    1,
    1,
    2,
    0,
    0,
    2,
    2,
    1,
    3,
    0,
    0,
    2,
    1,
    1,
    2,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    2,
    3,
    3,
    3,
    3,
    1,
    2,
    2,
    2,
    1,
    2,
    1,
    3,
    3,
    1,
    1,
    2,
    1,
    2,
    1,
    2,
    2,
    0,
    2,
    0,
    0,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    3,
    3,
    3,
    3,
    2,
    1,
    3,
    2,
    2,
    3,
    2,
    0,
    3,
    2,
    0,
    3,
    0,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    2,
    3,
    3,
    3,
    2,
    2,
    2,
    3,
    3,
    1,
    2,
    1,
    2,
    1,
    0,
    1,
    0,
    1,
    1,
    0,
    1,
    0,
    0,
    2,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    1,
    1,
    2,
    1,
    2,
    3,
    3,
    2,
    2,
    1,
    2,
    2,
    3,
    0,
    2,
    1,
    0,
    0,
    2,
    2,
    3,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    3,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    1,
    1,
    0,
    1,
    1,
    2,
    2,
    1,
    1,
    3,
    0,
    0,
    1,
    3,
    1,
    1,
    1,
    0,
    0,
    0,
    1,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    1,
    3,
    3,
    3,
    2,
    0,
    0,
    0,
    2,
    1,
    0,
    1,
    0,
    2,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    1,
    0,
    0,
    2,
    3,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    1,
    2,
    1,
    0,
    0,
    1,
    1,
    1,
    0,
    2,
    0,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    2,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    3,
    3,
    3,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    3,
    0,
    1,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    0,
    1,
    0,
    1,
    2,
    0,
    0,
    1,
    1,
    2,
    1,
    0,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    1,
    1,
    0,
    2,
    2,
    3,
    2,
    2,
    2,
    3,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    1,
    1,
    1,
    0,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    3,
    3,
    3,
    2,
    2,
    2,
    2,
    3,
    2,
    2,
    1,
    1,
    2,
    2,
    2,
    2,
    1,
    1,
    3,
    1,
    2,
    1,
    2,
    0,
    0,
    1,
    1,
    0,
    1,
    0,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    0,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    2,
    0,
    0,
    1,
    0,
    3,
    2,
    2,
    2,
    2,
    1,
    2,
    1,
    2,
    1,
    2,
    0,
    0,
    0,
    2,
    1,
    2,
    2,
    1,
    1,
    2,
    2,
    0,
    1,
    1,
    0,
    2,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    2,
    1,
    0,
    1,
    2,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    1,
    1,
    3,
    2,
    2,
    2,
    1,
    1,
    1,
    2,
    3,
    0,
    0,
    0,
    0,
    2,
    0,
    2,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    1,
    0,
    1,
    1,
    0,
    1,
    1,
    0,
    2,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    2,
    3,
    2,
    3,
    2,
    1,
    2,
    2,
    2,
    2,
    1,
    0,
    0,
    0,
    2,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    2,
    1,
    1,
    1,
    2,
    1,
    0,
    2,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    1,
    0,
    2,
    2,
    2,
    3,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    0,
    0,
    0,
    2,
    1,
    2,
    1,
    1,
    1,
    2,
    2,
    0,
    0,
    0,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    2,
    3,
    2,
    3,
    3,
    2,
    0,
    1,
    1,
    1,
    0,
    0,
    1,
    0,
    2,
    0,
    1,
    1,
    3,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    2,
    3,
    3,
    3,
    3,
    1,
    2,
    2,
    2,
    2,
    0,
    1,
    1,
    0,
    2,
    1,
    1,
    1,
    2,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    3,
    3,
    2,
    0,
    0,
    1,
    1,
    2,
    2,
    1,
    0,
    0,
    2,
    0,
    1,
    1,
    3,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    2,
    1,
    1,
    1,
    2,
    0,
    1,
    1,
    1,
    0,
    1,
    0,
    1,
    1,
    0,
    1,
    0,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    1,
    0,
    1,
    3,
    2,
    3,
    2,
    1,
    0,
    0,
    2,
    2,
    2,
    0,
    1,
    0,
    2,
    0,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    3,
    0,
    1,
    1,
    0,
    0,
    2,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    0,
    0,
    2,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    1,
    1,
    0,
    3,
    1,
    2,
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    1,
    1,
    0,
    0,
    0,
    2,
    2,
    2,
    0,
    0,
    0,
    1,
    2,
    1,
    0,
    1,
    0,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    2,
    1,
    1,
    1,
    0,
    1,
    0,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    0,
    1,
    3,
    0,
    0,
    0,
    0,
    2,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    1,
    1,
    1,
    0,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    1,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    1,
    3,
    3,
    2,
    2,
    0,
    0,
    0,
    2,
    2,
    0,
    0,
    0,
    1,
    2,
    0,
    1,
    1,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    2,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    2,
    3,
    2,
    3,
    2,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    2,
    0,
    2,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    0,
    1,
    2,
    1,
    0,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    0,
    1,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    1,
    3,
    2,
    2,
    2,
    1,
    0,
    0,
    2,
    2,
    1,
    0,
    1,
    2,
    2,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    2,
    3,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    1,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    2,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    2,
    0,
    2,
    0,
    0,
    1,
    0,
    3,
    2,
    1,
    2,
    1,
    2,
    2,
    0,
    1,
    0,
    0,
    0,
    2,
    1,
    0,
    0,
    2,
    1,
    1,
    1,
    1,
    0,
    2,
    0,
    2,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    1,
    1,
    2,
    2,
    2,
    2,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    2,
    0,
    0,
    2,
    0,
    1,
    0,
    1,
    1,
    1,
    2,
    1,
    0,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    1,
    1,
    0,
    2,
    1,
    2,
    2,
    2,
    0,
    3,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    1,
    1,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    2,
    2,
    3,
    2,
    2,
    0,
    0,
    1,
    1,
    2,
    0,
    1,
    2,
    1,
    0,
    1,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    2,
    2,
    1,
    1,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    0,
    1,
    0,
    0,
    0,
    1,
    2,
    2,
    2,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    1,
    2,
    2,
    2,
    2,
    0,
    1,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    2,
    2,
    2,
    2,
    0,
    0,
    0,
    2,
    2,
    2,
    0,
    1,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    2,
    2,
    2,
    2,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    1,
    2,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    2,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    2,
    2,
    2,
    1,
    1,
    2,
    0,
    2,
    1,
    1,
    1,
    1,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    2,
    1,
    2,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    2,
    0,
    1,
    2,
    1,
    0,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    2,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    1,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0
  ], e.Koi8rModel = {
    charToOrderMap: e.KOI8R_CharToOrderMap,
    precedenceMatrix: e.RussianLangModel,
    mTypicalPositiveRatio: 0.976601,
    keepEnglishLetter: !1,
    charsetName: "KOI8-R"
  }, e.Win1251CyrillicModel = {
    charToOrderMap: e.win1251_CharToOrderMap,
    precedenceMatrix: e.RussianLangModel,
    mTypicalPositiveRatio: 0.976601,
    keepEnglishLetter: !1,
    charsetName: "windows-1251"
  }, e.Latin5CyrillicModel = {
    charToOrderMap: e.latin5_CharToOrderMap,
    precedenceMatrix: e.RussianLangModel,
    mTypicalPositiveRatio: 0.976601,
    keepEnglishLetter: !1,
    charsetName: "ISO-8859-5"
  }, e.MacCyrillicModel = {
    charToOrderMap: e.macCyrillic_CharToOrderMap,
    precedenceMatrix: e.RussianLangModel,
    mTypicalPositiveRatio: 0.976601,
    keepEnglishLetter: !1,
    charsetName: "x-mac-cyrillic"
  }, e.Ibm866Model = {
    charToOrderMap: e.IBM866_CharToOrderMap,
    precedenceMatrix: e.RussianLangModel,
    mTypicalPositiveRatio: 0.976601,
    keepEnglishLetter: !1,
    charsetName: "IBM866"
  }, e.Ibm855Model = {
    charToOrderMap: e.IBM855_CharToOrderMap,
    precedenceMatrix: e.RussianLangModel,
    mTypicalPositiveRatio: 0.976601,
    keepEnglishLetter: !1,
    charsetName: "IBM855"
  };
})(f6);
var o6 = {};
(function(e) {
  e.Latin7_CharToOrderMap = [
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    254,
    255,
    255,
    254,
    255,
    255,
    // 00
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    // 10
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    // 20
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    253,
    253,
    253,
    253,
    253,
    253,
    // 30
    253,
    82,
    100,
    104,
    94,
    98,
    101,
    116,
    102,
    111,
    187,
    117,
    92,
    88,
    113,
    85,
    // 40
    79,
    118,
    105,
    83,
    67,
    114,
    119,
    95,
    99,
    109,
    188,
    253,
    253,
    253,
    253,
    253,
    // 50
    253,
    72,
    70,
    80,
    81,
    60,
    96,
    93,
    89,
    68,
    120,
    97,
    77,
    86,
    69,
    55,
    // 60
    78,
    115,
    65,
    66,
    58,
    76,
    106,
    103,
    87,
    107,
    112,
    253,
    253,
    253,
    253,
    253,
    // 70
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    // 80
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    // 90
    253,
    233,
    90,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    74,
    253,
    253,
    // a0
    253,
    253,
    253,
    253,
    247,
    248,
    61,
    36,
    46,
    71,
    73,
    253,
    54,
    253,
    108,
    123,
    // b0
    110,
    31,
    51,
    43,
    41,
    34,
    91,
    40,
    52,
    47,
    44,
    53,
    38,
    49,
    59,
    39,
    // c0
    35,
    48,
    250,
    37,
    33,
    45,
    56,
    50,
    84,
    57,
    120,
    121,
    17,
    18,
    22,
    15,
    // d0
    124,
    1,
    29,
    20,
    21,
    3,
    32,
    13,
    25,
    5,
    11,
    16,
    10,
    6,
    30,
    4,
    // e0
    9,
    8,
    14,
    7,
    2,
    12,
    28,
    23,
    42,
    24,
    64,
    75,
    19,
    26,
    27,
    253
    // f0
  ], e.win1253_CharToOrderMap = [
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    254,
    255,
    255,
    254,
    255,
    255,
    // 00
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    // 10
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    // 20
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    253,
    253,
    253,
    253,
    253,
    253,
    // 30
    253,
    82,
    100,
    104,
    94,
    98,
    101,
    116,
    102,
    111,
    187,
    117,
    92,
    88,
    113,
    85,
    // 40
    79,
    118,
    105,
    83,
    67,
    114,
    119,
    95,
    99,
    109,
    188,
    253,
    253,
    253,
    253,
    253,
    // 50
    253,
    72,
    70,
    80,
    81,
    60,
    96,
    93,
    89,
    68,
    120,
    97,
    77,
    86,
    69,
    55,
    // 60
    78,
    115,
    65,
    66,
    58,
    76,
    106,
    103,
    87,
    107,
    112,
    253,
    253,
    253,
    253,
    253,
    // 70
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    // 80
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    // 90
    253,
    233,
    61,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    74,
    253,
    253,
    // a0
    253,
    253,
    253,
    253,
    247,
    253,
    253,
    36,
    46,
    71,
    73,
    253,
    54,
    253,
    108,
    123,
    // b0
    110,
    31,
    51,
    43,
    41,
    34,
    91,
    40,
    52,
    47,
    44,
    53,
    38,
    49,
    59,
    39,
    // c0
    35,
    48,
    250,
    37,
    33,
    45,
    56,
    50,
    84,
    57,
    120,
    121,
    17,
    18,
    22,
    15,
    // d0
    124,
    1,
    29,
    20,
    21,
    3,
    32,
    13,
    25,
    5,
    11,
    16,
    10,
    6,
    30,
    4,
    // e0
    9,
    8,
    14,
    7,
    2,
    12,
    28,
    23,
    42,
    24,
    64,
    75,
    19,
    26,
    27,
    253
    // f0
  ], e.GreekLangModel = [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    3,
    3,
    3,
    0,
    2,
    2,
    3,
    3,
    0,
    3,
    0,
    3,
    2,
    0,
    3,
    3,
    3,
    0,
    3,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    0,
    3,
    3,
    0,
    3,
    2,
    3,
    3,
    0,
    3,
    2,
    3,
    3,
    3,
    0,
    0,
    3,
    0,
    3,
    0,
    3,
    3,
    2,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    3,
    3,
    3,
    3,
    0,
    2,
    3,
    3,
    0,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    0,
    2,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    2,
    1,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    2,
    3,
    3,
    2,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    3,
    3,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    3,
    2,
    3,
    3,
    0,
    2,
    0,
    1,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    0,
    0,
    0,
    0,
    3,
    3,
    0,
    3,
    1,
    3,
    3,
    3,
    0,
    3,
    3,
    0,
    3,
    3,
    3,
    3,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    0,
    3,
    0,
    3,
    3,
    3,
    3,
    3,
    0,
    3,
    2,
    2,
    2,
    3,
    0,
    2,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    0,
    3,
    1,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    2,
    0,
    3,
    0,
    0,
    0,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    0,
    0,
    3,
    2,
    3,
    0,
    2,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    3,
    3,
    3,
    3,
    0,
    0,
    3,
    3,
    0,
    2,
    3,
    0,
    3,
    0,
    3,
    3,
    3,
    0,
    0,
    3,
    0,
    3,
    0,
    2,
    2,
    3,
    3,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    2,
    0,
    3,
    2,
    3,
    3,
    3,
    3,
    0,
    3,
    3,
    3,
    3,
    3,
    0,
    3,
    3,
    2,
    3,
    2,
    3,
    3,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    2,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    2,
    3,
    2,
    3,
    2,
    2,
    2,
    3,
    2,
    3,
    3,
    2,
    3,
    0,
    2,
    2,
    2,
    3,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    3,
    3,
    3,
    2,
    3,
    3,
    0,
    0,
    3,
    0,
    3,
    0,
    0,
    0,
    3,
    2,
    0,
    3,
    0,
    3,
    0,
    0,
    2,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    3,
    3,
    0,
    3,
    0,
    0,
    0,
    3,
    3,
    0,
    3,
    3,
    3,
    0,
    0,
    1,
    2,
    3,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    2,
    0,
    0,
    3,
    2,
    2,
    3,
    3,
    0,
    3,
    3,
    3,
    3,
    3,
    2,
    1,
    3,
    0,
    3,
    2,
    3,
    3,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    0,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    0,
    3,
    0,
    3,
    0,
    0,
    0,
    3,
    3,
    0,
    3,
    2,
    3,
    0,
    0,
    3,
    3,
    3,
    0,
    3,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    0,
    3,
    0,
    3,
    0,
    0,
    0,
    3,
    2,
    0,
    3,
    2,
    3,
    0,
    0,
    3,
    2,
    3,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    1,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    2,
    3,
    0,
    3,
    0,
    0,
    0,
    3,
    3,
    0,
    3,
    0,
    2,
    0,
    0,
    2,
    3,
    1,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    3,
    3,
    3,
    3,
    0,
    3,
    0,
    3,
    3,
    2,
    3,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    3,
    3,
    3,
    0,
    2,
    3,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    3,
    3,
    3,
    0,
    0,
    3,
    0,
    0,
    0,
    3,
    3,
    0,
    3,
    0,
    2,
    3,
    3,
    0,
    0,
    3,
    0,
    3,
    0,
    3,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    0,
    3,
    0,
    2,
    0,
    0,
    0,
    3,
    3,
    0,
    3,
    0,
    3,
    0,
    0,
    2,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    3,
    0,
    2,
    0,
    3,
    2,
    0,
    3,
    2,
    3,
    2,
    3,
    0,
    0,
    3,
    2,
    3,
    2,
    3,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    2,
    3,
    3,
    3,
    3,
    3,
    0,
    0,
    0,
    3,
    0,
    2,
    1,
    0,
    0,
    3,
    2,
    2,
    2,
    0,
    3,
    0,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    3,
    3,
    3,
    2,
    0,
    3,
    0,
    3,
    0,
    3,
    3,
    0,
    2,
    1,
    2,
    3,
    3,
    0,
    0,
    3,
    0,
    3,
    0,
    3,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    3,
    3,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    2,
    3,
    0,
    3,
    0,
    0,
    0,
    2,
    1,
    0,
    2,
    2,
    3,
    0,
    0,
    2,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    2,
    3,
    3,
    3,
    2,
    3,
    0,
    0,
    1,
    3,
    0,
    2,
    0,
    0,
    0,
    0,
    3,
    0,
    1,
    0,
    2,
    0,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    1,
    0,
    3,
    0,
    0,
    0,
    3,
    2,
    0,
    3,
    2,
    3,
    3,
    3,
    0,
    0,
    3,
    0,
    3,
    2,
    2,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    3,
    3,
    3,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    2,
    0,
    2,
    3,
    3,
    2,
    2,
    2,
    2,
    3,
    0,
    2,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    0,
    2,
    0,
    2,
    3,
    2,
    0,
    0,
    3,
    0,
    3,
    0,
    3,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    2,
    3,
    3,
    2,
    2,
    3,
    0,
    2,
    0,
    3,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    1,
    2,
    0,
    2,
    0,
    2,
    0,
    0,
    2,
    0,
    2,
    0,
    2,
    2,
    0,
    0,
    1,
    0,
    2,
    2,
    2,
    0,
    2,
    2,
    2,
    0,
    2,
    2,
    2,
    0,
    0,
    2,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    3,
    3,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    0,
    2,
    0,
    2,
    2,
    2,
    0,
    0,
    2,
    0,
    3,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    2,
    3,
    2,
    0,
    2,
    2,
    0,
    2,
    0,
    2,
    2,
    0,
    2,
    0,
    2,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    0,
    0,
    0,
    2,
    0,
    1,
    2,
    0,
    0,
    0,
    0,
    2,
    2,
    0,
    0,
    0,
    2,
    1,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    1,
    0,
    2,
    3,
    2,
    2,
    3,
    2,
    3,
    2,
    0,
    0,
    3,
    3,
    3,
    0,
    0,
    3,
    2,
    0,
    0,
    0,
    1,
    1,
    0,
    2,
    0,
    2,
    2,
    0,
    2,
    0,
    2,
    0,
    2,
    2,
    0,
    0,
    2,
    0,
    2,
    2,
    2,
    0,
    2,
    2,
    2,
    2,
    0,
    0,
    2,
    0,
    0,
    0,
    2,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    3,
    3,
    2,
    2,
    0,
    3,
    0,
    0,
    0,
    2,
    2,
    0,
    2,
    2,
    2,
    1,
    2,
    0,
    0,
    1,
    2,
    2,
    0,
    0,
    3,
    0,
    0,
    0,
    2,
    0,
    1,
    2,
    0,
    0,
    0,
    1,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    0,
    1,
    0,
    0,
    2,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    3,
    2,
    2,
    0,
    0,
    0,
    2,
    0,
    2,
    3,
    3,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    2,
    0,
    2,
    2,
    0,
    2,
    0,
    2,
    0,
    2,
    2,
    0,
    0,
    2,
    2,
    2,
    2,
    1,
    0,
    0,
    2,
    2,
    0,
    2,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    3,
    2,
    3,
    0,
    0,
    0,
    3,
    0,
    0,
    2,
    2,
    0,
    2,
    0,
    2,
    2,
    2,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    2,
    2,
    0,
    0,
    2,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    3,
    2,
    0,
    2,
    2,
    2,
    2,
    2,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    2,
    0,
    1,
    0,
    0,
    2,
    0,
    1,
    0,
    0,
    0,
    0,
    2,
    2,
    2,
    0,
    2,
    2,
    0,
    1,
    2,
    0,
    2,
    2,
    2,
    0,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    2,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    1,
    2,
    1,
    0,
    0,
    2,
    2,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    2,
    3,
    0,
    0,
    2,
    0,
    0,
    0,
    2,
    2,
    0,
    2,
    0,
    0,
    0,
    1,
    0,
    0,
    2,
    0,
    2,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    3,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    0,
    2,
    0,
    2,
    2,
    0,
    0,
    0,
    1,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    2,
    0,
    3,
    2,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    2,
    1,
    2,
    0,
    2,
    2,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    2,
    2,
    2,
    0,
    0,
    2,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    2,
    3,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    0,
    0,
    0,
    2,
    0,
    1,
    2,
    0,
    0,
    0,
    1,
    2,
    2,
    1,
    0,
    0,
    0,
    2,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    1,
    2,
    0,
    2,
    2,
    0,
    2,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    1,
    2,
    1,
    0,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    3,
    1,
    2,
    2,
    0,
    2,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    2,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    2,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    1,
    0,
    2,
    0,
    1,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    2,
    2,
    0,
    0,
    2,
    2,
    2,
    2,
    2,
    0,
    1,
    2,
    0,
    0,
    0,
    2,
    2,
    0,
    1,
    0,
    2,
    0,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    2,
    0,
    0,
    0,
    0,
    2,
    0,
    1,
    2,
    0,
    0,
    0,
    0,
    2,
    2,
    1,
    0,
    1,
    0,
    1,
    0,
    2,
    2,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    1,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    2,
    2,
    2,
    2,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    1,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    2,
    2,
    2,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    2,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    2,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    2,
    0,
    2,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    2,
    0,
    0,
    2,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    2,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    2,
    2,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    2,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    2,
    2,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    2,
    0,
    0,
    0,
    0,
    2,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    2,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    1,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0
  ], e.Latin7GreekModel = {
    charToOrderMap: e.Latin7_CharToOrderMap,
    precedenceMatrix: e.GreekLangModel,
    mTypicalPositiveRatio: 0.982851,
    keepEnglishLetter: !1,
    charsetName: "ISO-8859-7"
  }, e.Win1253GreekModel = {
    charToOrderMap: e.win1253_CharToOrderMap,
    precedenceMatrix: e.GreekLangModel,
    mTypicalPositiveRatio: 0.982851,
    keepEnglishLetter: !1,
    charsetName: "windows-1253"
  };
})(o6);
var l6 = {};
(function(e) {
  e.TIS620CharToOrderMap = [
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    254,
    255,
    255,
    254,
    255,
    255,
    // 00
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    // 10
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    // 20
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    253,
    253,
    253,
    253,
    253,
    253,
    // 30
    253,
    182,
    106,
    107,
    100,
    183,
    184,
    185,
    101,
    94,
    186,
    187,
    108,
    109,
    110,
    111,
    // 40
    188,
    189,
    190,
    89,
    95,
    112,
    113,
    191,
    192,
    193,
    194,
    253,
    253,
    253,
    253,
    253,
    // 50
    253,
    64,
    72,
    73,
    114,
    74,
    115,
    116,
    102,
    81,
    201,
    117,
    90,
    103,
    78,
    82,
    // 60
    96,
    202,
    91,
    79,
    84,
    104,
    105,
    97,
    98,
    92,
    203,
    253,
    253,
    253,
    253,
    253,
    // 70
    209,
    210,
    211,
    212,
    213,
    88,
    214,
    215,
    216,
    217,
    218,
    219,
    220,
    118,
    221,
    222,
    223,
    224,
    99,
    85,
    83,
    225,
    226,
    227,
    228,
    229,
    230,
    231,
    232,
    233,
    234,
    235,
    236,
    5,
    30,
    237,
    24,
    238,
    75,
    8,
    26,
    52,
    34,
    51,
    119,
    47,
    58,
    57,
    49,
    53,
    55,
    43,
    20,
    19,
    44,
    14,
    48,
    3,
    17,
    25,
    39,
    62,
    31,
    54,
    45,
    9,
    16,
    2,
    61,
    15,
    239,
    12,
    42,
    46,
    18,
    21,
    76,
    4,
    66,
    63,
    22,
    10,
    1,
    36,
    23,
    13,
    40,
    27,
    32,
    35,
    86,
    240,
    241,
    242,
    243,
    244,
    11,
    28,
    41,
    29,
    33,
    245,
    50,
    37,
    6,
    7,
    67,
    77,
    38,
    93,
    246,
    247,
    68,
    56,
    59,
    65,
    69,
    60,
    70,
    80,
    71,
    87,
    248,
    249,
    250,
    251,
    252,
    253
  ], e.ThaiLangModel = [
    0,
    1,
    3,
    3,
    3,
    3,
    0,
    0,
    3,
    3,
    0,
    3,
    3,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    0,
    3,
    3,
    3,
    0,
    3,
    3,
    3,
    3,
    0,
    3,
    3,
    0,
    0,
    0,
    1,
    3,
    0,
    3,
    3,
    2,
    3,
    3,
    0,
    1,
    2,
    3,
    3,
    3,
    3,
    0,
    2,
    0,
    2,
    0,
    0,
    3,
    2,
    1,
    2,
    2,
    3,
    0,
    3,
    3,
    2,
    3,
    0,
    0,
    3,
    3,
    0,
    3,
    3,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    3,
    2,
    3,
    0,
    2,
    2,
    2,
    3,
    0,
    2,
    3,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    2,
    3,
    1,
    1,
    3,
    2,
    2,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    3,
    3,
    2,
    3,
    2,
    3,
    3,
    2,
    2,
    2,
    3,
    1,
    2,
    3,
    0,
    3,
    3,
    2,
    2,
    1,
    2,
    3,
    3,
    1,
    2,
    0,
    1,
    3,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    3,
    3,
    2,
    2,
    3,
    3,
    3,
    3,
    1,
    2,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    2,
    2,
    3,
    3,
    2,
    2,
    3,
    3,
    2,
    2,
    3,
    2,
    3,
    2,
    2,
    3,
    3,
    1,
    2,
    3,
    1,
    2,
    2,
    3,
    3,
    1,
    0,
    2,
    1,
    0,
    0,
    3,
    1,
    2,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    3,
    3,
    3,
    3,
    2,
    3,
    2,
    2,
    3,
    3,
    2,
    2,
    3,
    2,
    2,
    2,
    2,
    1,
    1,
    3,
    1,
    2,
    1,
    1,
    3,
    2,
    1,
    0,
    2,
    1,
    0,
    1,
    0,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    2,
    3,
    2,
    3,
    3,
    2,
    2,
    3,
    2,
    3,
    3,
    2,
    3,
    1,
    1,
    2,
    3,
    2,
    2,
    2,
    3,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    1,
    2,
    2,
    1,
    1,
    3,
    3,
    2,
    1,
    0,
    1,
    2,
    2,
    0,
    1,
    3,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    0,
    0,
    2,
    1,
    1,
    3,
    3,
    2,
    3,
    3,
    2,
    0,
    0,
    3,
    3,
    0,
    3,
    3,
    0,
    2,
    2,
    3,
    1,
    2,
    2,
    1,
    1,
    1,
    0,
    2,
    2,
    2,
    0,
    2,
    2,
    1,
    1,
    0,
    2,
    1,
    0,
    2,
    0,
    0,
    2,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    3,
    2,
    3,
    3,
    2,
    0,
    0,
    3,
    3,
    0,
    2,
    3,
    0,
    2,
    1,
    2,
    2,
    2,
    2,
    1,
    2,
    0,
    0,
    2,
    2,
    2,
    0,
    2,
    2,
    1,
    1,
    0,
    2,
    1,
    0,
    2,
    0,
    0,
    2,
    0,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    2,
    3,
    2,
    3,
    2,
    0,
    2,
    2,
    1,
    3,
    2,
    1,
    3,
    2,
    1,
    2,
    3,
    2,
    2,
    3,
    0,
    2,
    3,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    0,
    0,
    0,
    0,
    2,
    0,
    1,
    2,
    0,
    1,
    1,
    1,
    0,
    1,
    0,
    3,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    3,
    2,
    3,
    3,
    2,
    3,
    2,
    2,
    2,
    3,
    2,
    2,
    3,
    2,
    2,
    1,
    2,
    3,
    2,
    2,
    3,
    1,
    3,
    2,
    2,
    2,
    3,
    2,
    2,
    2,
    3,
    3,
    2,
    1,
    3,
    0,
    1,
    1,
    1,
    0,
    2,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    1,
    0,
    0,
    3,
    0,
    3,
    3,
    3,
    3,
    3,
    0,
    0,
    3,
    0,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    0,
    0,
    0,
    1,
    1,
    3,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    0,
    0,
    0,
    3,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    3,
    3,
    3,
    3,
    0,
    0,
    2,
    3,
    0,
    0,
    3,
    0,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    0,
    0,
    3,
    3,
    3,
    0,
    0,
    0,
    3,
    3,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    2,
    1,
    1,
    3,
    0,
    0,
    1,
    0,
    0,
    2,
    3,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    2,
    1,
    3,
    3,
    2,
    2,
    1,
    2,
    2,
    2,
    3,
    1,
    1,
    2,
    0,
    2,
    1,
    2,
    1,
    2,
    2,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    2,
    1,
    2,
    3,
    3,
    3,
    0,
    2,
    0,
    2,
    2,
    0,
    2,
    1,
    3,
    2,
    2,
    1,
    2,
    1,
    0,
    0,
    2,
    2,
    1,
    0,
    2,
    1,
    2,
    2,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    2,
    1,
    3,
    3,
    1,
    1,
    3,
    0,
    2,
    3,
    1,
    1,
    3,
    2,
    1,
    1,
    2,
    0,
    2,
    2,
    3,
    2,
    1,
    1,
    1,
    1,
    1,
    2,
    3,
    0,
    0,
    1,
    3,
    1,
    2,
    1,
    2,
    0,
    3,
    0,
    0,
    0,
    1,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    3,
    3,
    1,
    1,
    3,
    2,
    3,
    3,
    3,
    1,
    3,
    2,
    1,
    3,
    2,
    1,
    3,
    2,
    2,
    2,
    2,
    1,
    3,
    3,
    1,
    2,
    1,
    3,
    1,
    2,
    3,
    0,
    2,
    1,
    1,
    3,
    2,
    2,
    2,
    1,
    2,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    3,
    2,
    3,
    2,
    3,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    3,
    2,
    1,
    0,
    3,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    1,
    2,
    2,
    1,
    2,
    1,
    1,
    2,
    2,
    2,
    3,
    0,
    1,
    3,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    2,
    1,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    2,
    3,
    2,
    2,
    1,
    1,
    3,
    2,
    3,
    2,
    3,
    2,
    0,
    3,
    2,
    2,
    1,
    2,
    0,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    1,
    3,
    2,
    1,
    2,
    2,
    1,
    0,
    2,
    0,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    1,
    2,
    3,
    3,
    2,
    2,
    3,
    0,
    1,
    1,
    2,
    0,
    3,
    3,
    2,
    2,
    3,
    0,
    1,
    1,
    3,
    0,
    0,
    0,
    0,
    3,
    1,
    0,
    3,
    3,
    0,
    2,
    0,
    2,
    1,
    0,
    0,
    3,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    2,
    3,
    2,
    3,
    3,
    0,
    1,
    3,
    1,
    1,
    2,
    1,
    2,
    1,
    1,
    3,
    1,
    1,
    0,
    2,
    3,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    3,
    1,
    1,
    2,
    2,
    2,
    2,
    1,
    1,
    1,
    0,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    2,
    2,
    1,
    1,
    2,
    1,
    3,
    3,
    2,
    3,
    2,
    2,
    3,
    2,
    2,
    3,
    1,
    2,
    2,
    1,
    2,
    0,
    3,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    1,
    3,
    2,
    1,
    2,
    2,
    2,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    3,
    3,
    0,
    2,
    1,
    0,
    3,
    2,
    0,
    0,
    3,
    1,
    0,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    3,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    2,
    2,
    2,
    3,
    0,
    0,
    1,
    3,
    0,
    3,
    2,
    0,
    3,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    1,
    0,
    2,
    2,
    2,
    0,
    2,
    2,
    1,
    2,
    0,
    2,
    3,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    0,
    2,
    3,
    1,
    3,
    3,
    2,
    3,
    3,
    0,
    3,
    3,
    0,
    3,
    2,
    2,
    3,
    2,
    3,
    3,
    3,
    0,
    0,
    2,
    2,
    3,
    0,
    1,
    1,
    1,
    3,
    0,
    0,
    3,
    0,
    0,
    0,
    2,
    2,
    0,
    1,
    3,
    0,
    1,
    2,
    2,
    2,
    3,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    2,
    3,
    3,
    2,
    0,
    3,
    3,
    2,
    2,
    3,
    1,
    3,
    2,
    1,
    3,
    2,
    0,
    1,
    2,
    2,
    0,
    2,
    3,
    2,
    1,
    0,
    3,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    2,
    3,
    1,
    3,
    0,
    0,
    3,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    1,
    3,
    2,
    2,
    2,
    1,
    2,
    0,
    1,
    3,
    1,
    1,
    3,
    1,
    3,
    0,
    0,
    2,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    0,
    2,
    1,
    0,
    1,
    1,
    2,
    0,
    0,
    0,
    3,
    1,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    3,
    1,
    0,
    0,
    0,
    1,
    0,
    3,
    3,
    3,
    3,
    2,
    2,
    2,
    2,
    2,
    1,
    3,
    1,
    1,
    1,
    2,
    0,
    1,
    1,
    2,
    1,
    2,
    1,
    3,
    2,
    0,
    0,
    3,
    1,
    1,
    1,
    1,
    1,
    3,
    1,
    0,
    2,
    3,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    0,
    3,
    3,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    1,
    3,
    0,
    0,
    1,
    2,
    0,
    0,
    2,
    0,
    3,
    3,
    2,
    3,
    3,
    3,
    2,
    3,
    0,
    0,
    2,
    2,
    2,
    0,
    0,
    0,
    2,
    2,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    2,
    3,
    1,
    3,
    3,
    0,
    0,
    1,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    1,
    2,
    3,
    1,
    2,
    3,
    1,
    0,
    3,
    0,
    2,
    2,
    1,
    0,
    2,
    1,
    1,
    2,
    0,
    1,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    3,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    2,
    1,
    0,
    1,
    1,
    1,
    3,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    1,
    1,
    1,
    0,
    3,
    1,
    0,
    1,
    3,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    2,
    0,
    1,
    3,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    1,
    3,
    0,
    2,
    2,
    1,
    3,
    3,
    2,
    3,
    3,
    0,
    1,
    1,
    0,
    2,
    2,
    1,
    2,
    1,
    3,
    3,
    1,
    0,
    0,
    3,
    2,
    0,
    0,
    0,
    0,
    2,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    2,
    0,
    1,
    1,
    3,
    1,
    1,
    2,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    1,
    0,
    0,
    0,
    3,
    0,
    0,
    3,
    0,
    3,
    1,
    0,
    1,
    1,
    1,
    3,
    2,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    1,
    3,
    2,
    1,
    3,
    3,
    1,
    2,
    2,
    0,
    1,
    2,
    1,
    0,
    1,
    2,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    1,
    2,
    0,
    3,
    3,
    3,
    2,
    2,
    0,
    1,
    1,
    0,
    1,
    3,
    0,
    0,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    3,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    2,
    3,
    1,
    2,
    0,
    0,
    2,
    1,
    0,
    3,
    1,
    0,
    1,
    2,
    0,
    1,
    1,
    1,
    1,
    3,
    0,
    0,
    3,
    1,
    1,
    0,
    2,
    2,
    1,
    1,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    3,
    1,
    2,
    0,
    0,
    2,
    2,
    0,
    1,
    2,
    0,
    1,
    0,
    1,
    3,
    1,
    2,
    1,
    0,
    0,
    0,
    2,
    0,
    3,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    1,
    1,
    2,
    2,
    0,
    0,
    0,
    2,
    0,
    2,
    1,
    0,
    1,
    1,
    0,
    1,
    1,
    1,
    2,
    1,
    0,
    0,
    1,
    1,
    1,
    0,
    2,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    2,
    0,
    1,
    3,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    3,
    2,
    0,
    1,
    0,
    0,
    0,
    1,
    2,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    2,
    3,
    2,
    2,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    2,
    3,
    2,
    1,
    2,
    2,
    3,
    0,
    0,
    0,
    2,
    3,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    2,
    2,
    0,
    1,
    0,
    0,
    0,
    0,
    2,
    0,
    2,
    0,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    2,
    1,
    0,
    1,
    0,
    1,
    1,
    0,
    0,
    0,
    1,
    0,
    2,
    0,
    0,
    1,
    0,
    3,
    0,
    1,
    0,
    0,
    0,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    3,
    1,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    1,
    1,
    1,
    1,
    2,
    3,
    0,
    0,
    2,
    1,
    1,
    1,
    1,
    1,
    0,
    2,
    1,
    1,
    0,
    0,
    0,
    2,
    1,
    0,
    1,
    2,
    1,
    1,
    0,
    1,
    2,
    1,
    0,
    3,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    2,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    2,
    1,
    0,
    1,
    1,
    0,
    2,
    0,
    0,
    1,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    1,
    3,
    0,
    1,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    2,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    0,
    0,
    1,
    1,
    2,
    0,
    0,
    1,
    2,
    1,
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    2,
    1,
    1,
    0,
    1,
    0,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    2,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    2,
    0,
    1,
    2,
    0,
    0,
    1,
    1,
    0,
    2,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    1,
    1,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    1,
    0,
    2,
    1,
    3,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    1,
    0,
    1,
    0,
    0,
    2,
    0,
    0,
    2,
    0,
    0,
    1,
    1,
    2,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    3,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    2,
    1,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0
  ], e.TIS620ThaiModel = {
    charToOrderMap: e.TIS620CharToOrderMap,
    precedenceMatrix: e.ThaiLangModel,
    mTypicalPositiveRatio: 0.926386,
    keepEnglishLetter: !1,
    charsetName: "TIS-620"
  };
})(l6);
var h6 = {};
(function(e) {
  e.Latin2_HungarianCharToOrderMap = [
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    254,
    255,
    255,
    254,
    255,
    255,
    // 00
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    // 10
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    // 20
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    253,
    253,
    253,
    253,
    253,
    253,
    // 30
    253,
    28,
    40,
    54,
    45,
    32,
    50,
    49,
    38,
    39,
    53,
    36,
    41,
    34,
    35,
    47,
    46,
    71,
    43,
    33,
    37,
    57,
    48,
    64,
    68,
    55,
    52,
    253,
    253,
    253,
    253,
    253,
    253,
    2,
    18,
    26,
    17,
    1,
    27,
    12,
    20,
    9,
    22,
    7,
    6,
    13,
    4,
    8,
    23,
    67,
    10,
    5,
    3,
    21,
    19,
    65,
    62,
    16,
    11,
    253,
    253,
    253,
    253,
    253,
    159,
    160,
    161,
    162,
    163,
    164,
    165,
    166,
    167,
    168,
    169,
    170,
    171,
    172,
    173,
    174,
    175,
    176,
    177,
    178,
    179,
    180,
    181,
    182,
    183,
    184,
    185,
    186,
    187,
    188,
    189,
    190,
    191,
    192,
    193,
    194,
    195,
    196,
    197,
    75,
    198,
    199,
    200,
    201,
    202,
    203,
    204,
    205,
    79,
    206,
    207,
    208,
    209,
    210,
    211,
    212,
    213,
    214,
    215,
    216,
    217,
    218,
    219,
    220,
    221,
    51,
    81,
    222,
    78,
    223,
    224,
    225,
    226,
    44,
    227,
    228,
    229,
    61,
    230,
    231,
    232,
    233,
    234,
    58,
    235,
    66,
    59,
    236,
    237,
    238,
    60,
    69,
    63,
    239,
    240,
    241,
    82,
    14,
    74,
    242,
    70,
    80,
    243,
    72,
    244,
    15,
    83,
    77,
    84,
    30,
    76,
    85,
    245,
    246,
    247,
    25,
    73,
    42,
    24,
    248,
    249,
    250,
    31,
    56,
    29,
    251,
    252,
    253
  ], e.win1250HungarianCharToOrderMap = [
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    254,
    255,
    255,
    254,
    255,
    255,
    // 00
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    // 10
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    // 20
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    253,
    253,
    253,
    253,
    253,
    253,
    // 30
    253,
    28,
    40,
    54,
    45,
    32,
    50,
    49,
    38,
    39,
    53,
    36,
    41,
    34,
    35,
    47,
    46,
    72,
    43,
    33,
    37,
    57,
    48,
    64,
    68,
    55,
    52,
    253,
    253,
    253,
    253,
    253,
    253,
    2,
    18,
    26,
    17,
    1,
    27,
    12,
    20,
    9,
    22,
    7,
    6,
    13,
    4,
    8,
    23,
    67,
    10,
    5,
    3,
    21,
    19,
    65,
    62,
    16,
    11,
    253,
    253,
    253,
    253,
    253,
    161,
    162,
    163,
    164,
    165,
    166,
    167,
    168,
    169,
    170,
    171,
    172,
    173,
    174,
    175,
    176,
    177,
    178,
    179,
    180,
    78,
    181,
    69,
    182,
    183,
    184,
    185,
    186,
    187,
    188,
    189,
    190,
    191,
    192,
    193,
    194,
    195,
    196,
    197,
    76,
    198,
    199,
    200,
    201,
    202,
    203,
    204,
    205,
    81,
    206,
    207,
    208,
    209,
    210,
    211,
    212,
    213,
    214,
    215,
    216,
    217,
    218,
    219,
    220,
    221,
    51,
    83,
    222,
    80,
    223,
    224,
    225,
    226,
    44,
    227,
    228,
    229,
    61,
    230,
    231,
    232,
    233,
    234,
    58,
    235,
    66,
    59,
    236,
    237,
    238,
    60,
    70,
    63,
    239,
    240,
    241,
    84,
    14,
    75,
    242,
    71,
    82,
    243,
    73,
    244,
    15,
    85,
    79,
    86,
    30,
    77,
    87,
    245,
    246,
    247,
    25,
    74,
    42,
    24,
    248,
    249,
    250,
    31,
    56,
    29,
    251,
    252,
    253
  ], e.HungarianLangModel = [
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    3,
    3,
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    3,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    2,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    1,
    1,
    3,
    3,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    3,
    2,
    1,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    1,
    1,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    1,
    3,
    2,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    1,
    2,
    3,
    3,
    3,
    1,
    3,
    3,
    3,
    3,
    3,
    1,
    3,
    3,
    2,
    2,
    0,
    3,
    2,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    2,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    2,
    2,
    3,
    2,
    3,
    2,
    0,
    3,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    1,
    2,
    3,
    2,
    2,
    3,
    1,
    2,
    3,
    3,
    2,
    2,
    0,
    3,
    3,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    0,
    2,
    3,
    2,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    1,
    1,
    3,
    3,
    2,
    1,
    3,
    2,
    2,
    3,
    2,
    1,
    3,
    2,
    2,
    1,
    0,
    3,
    3,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    1,
    2,
    3,
    3,
    3,
    3,
    1,
    2,
    1,
    3,
    3,
    3,
    3,
    2,
    2,
    3,
    1,
    1,
    3,
    2,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    2,
    1,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    1,
    3,
    3,
    3,
    0,
    1,
    1,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    2,
    3,
    3,
    2,
    3,
    3,
    3,
    2,
    0,
    3,
    2,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    2,
    3,
    2,
    3,
    3,
    3,
    1,
    3,
    2,
    2,
    2,
    3,
    1,
    1,
    3,
    3,
    1,
    1,
    0,
    3,
    3,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    2,
    3,
    2,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    1,
    2,
    3,
    2,
    2,
    0,
    2,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    2,
    2,
    2,
    3,
    1,
    3,
    3,
    2,
    2,
    1,
    3,
    3,
    3,
    1,
    1,
    3,
    1,
    2,
    3,
    2,
    3,
    2,
    2,
    2,
    1,
    0,
    2,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    1,
    1,
    3,
    3,
    3,
    3,
    3,
    1,
    2,
    3,
    3,
    3,
    3,
    1,
    2,
    1,
    3,
    3,
    3,
    2,
    2,
    3,
    2,
    1,
    0,
    3,
    2,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    1,
    1,
    3,
    3,
    3,
    3,
    3,
    1,
    2,
    3,
    3,
    3,
    3,
    1,
    1,
    0,
    3,
    3,
    3,
    3,
    0,
    2,
    3,
    0,
    0,
    2,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    3,
    3,
    2,
    2,
    2,
    2,
    3,
    3,
    0,
    1,
    2,
    3,
    2,
    3,
    2,
    2,
    3,
    2,
    1,
    2,
    0,
    2,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    2,
    3,
    3,
    3,
    2,
    1,
    2,
    3,
    3,
    2,
    2,
    2,
    3,
    2,
    3,
    3,
    1,
    3,
    3,
    1,
    1,
    0,
    2,
    3,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    1,
    1,
    1,
    3,
    3,
    1,
    1,
    3,
    1,
    1,
    3,
    2,
    1,
    2,
    3,
    1,
    1,
    0,
    2,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    2,
    1,
    2,
    1,
    1,
    3,
    3,
    1,
    1,
    1,
    1,
    3,
    3,
    1,
    1,
    2,
    2,
    1,
    2,
    1,
    1,
    2,
    2,
    1,
    1,
    0,
    2,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    1,
    1,
    2,
    1,
    1,
    3,
    3,
    1,
    0,
    1,
    1,
    3,
    3,
    2,
    0,
    1,
    1,
    2,
    3,
    1,
    0,
    2,
    2,
    1,
    0,
    0,
    1,
    3,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    2,
    1,
    3,
    3,
    3,
    3,
    3,
    1,
    2,
    3,
    2,
    3,
    3,
    2,
    1,
    1,
    3,
    2,
    3,
    2,
    1,
    2,
    2,
    0,
    1,
    2,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    3,
    3,
    3,
    2,
    2,
    2,
    2,
    3,
    1,
    2,
    2,
    1,
    1,
    3,
    3,
    0,
    3,
    2,
    1,
    2,
    3,
    2,
    1,
    3,
    3,
    1,
    1,
    0,
    2,
    1,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    2,
    2,
    2,
    3,
    2,
    3,
    3,
    3,
    2,
    1,
    1,
    3,
    3,
    1,
    1,
    1,
    2,
    2,
    3,
    2,
    3,
    2,
    2,
    2,
    1,
    0,
    2,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    0,
    0,
    3,
    3,
    2,
    3,
    0,
    0,
    0,
    2,
    3,
    3,
    1,
    0,
    1,
    2,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    1,
    2,
    3,
    3,
    3,
    3,
    3,
    1,
    2,
    3,
    3,
    2,
    2,
    1,
    1,
    0,
    3,
    3,
    2,
    2,
    1,
    2,
    2,
    1,
    0,
    2,
    2,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    2,
    2,
    1,
    3,
    1,
    2,
    3,
    3,
    2,
    2,
    1,
    1,
    2,
    2,
    1,
    1,
    1,
    1,
    3,
    2,
    1,
    1,
    1,
    1,
    2,
    1,
    0,
    1,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    3,
    1,
    1,
    1,
    1,
    1,
    3,
    3,
    3,
    0,
    1,
    1,
    3,
    3,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    0,
    3,
    1,
    1,
    2,
    0,
    2,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    1,
    0,
    1,
    2,
    1,
    2,
    2,
    0,
    1,
    2,
    3,
    1,
    2,
    0,
    0,
    0,
    2,
    1,
    1,
    1,
    1,
    1,
    2,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    1,
    2,
    1,
    2,
    2,
    2,
    1,
    2,
    1,
    2,
    0,
    2,
    0,
    2,
    2,
    1,
    1,
    2,
    1,
    1,
    2,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    1,
    1,
    2,
    3,
    2,
    3,
    3,
    0,
    1,
    2,
    2,
    3,
    1,
    0,
    1,
    0,
    2,
    1,
    2,
    2,
    0,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    3,
    3,
    2,
    2,
    1,
    0,
    0,
    3,
    2,
    3,
    2,
    0,
    0,
    0,
    1,
    1,
    3,
    0,
    0,
    1,
    1,
    0,
    0,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    1,
    1,
    2,
    2,
    3,
    3,
    1,
    0,
    1,
    3,
    2,
    3,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    3,
    1,
    0,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    1,
    1,
    1,
    2,
    2,
    2,
    1,
    0,
    1,
    2,
    3,
    3,
    2,
    0,
    0,
    0,
    2,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    1,
    2,
    2,
    2,
    2,
    2,
    1,
    1,
    1,
    2,
    0,
    2,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    3,
    2,
    2,
    1,
    0,
    0,
    1,
    1,
    2,
    2,
    0,
    3,
    0,
    1,
    2,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    0,
    2,
    1,
    1,
    1,
    2,
    2,
    1,
    1,
    1,
    2,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    2,
    3,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    2,
    3,
    3,
    0,
    1,
    0,
    0,
    0,
    3,
    3,
    1,
    0,
    0,
    1,
    2,
    2,
    1,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    1,
    1,
    1,
    0,
    2,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    0,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    1,
    2,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    2,
    3,
    3,
    0,
    1,
    0,
    0,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    1,
    2,
    2,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    2,
    0,
    1,
    0,
    2,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    0,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    3,
    2,
    2,
    0,
    1,
    0,
    1,
    0,
    2,
    3,
    2,
    0,
    0,
    1,
    2,
    2,
    1,
    0,
    0,
    1,
    1,
    1,
    0,
    0,
    2,
    1,
    0,
    1,
    2,
    2,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    2,
    1,
    0,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    2,
    1,
    1,
    0,
    1,
    2,
    2,
    2,
    0,
    0,
    1,
    0,
    0,
    2,
    2,
    1,
    1,
    0,
    0,
    2,
    1,
    1,
    0,
    0,
    0,
    1,
    2,
    0,
    0,
    2,
    1,
    0,
    0,
    2,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    2,
    1,
    2,
    1,
    1,
    1,
    2,
    2,
    1,
    1,
    2,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    2,
    3,
    0,
    0,
    0,
    1,
    0,
    3,
    2,
    1,
    0,
    0,
    1,
    2,
    1,
    1,
    0,
    0,
    0,
    0,
    2,
    1,
    0,
    1,
    1,
    0,
    0,
    2,
    1,
    2,
    1,
    1,
    1,
    0,
    0,
    0,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    2,
    0,
    0,
    1,
    0,
    0,
    0,
    2,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    3,
    0,
    0,
    2,
    1,
    2,
    2,
    1,
    0,
    0,
    2,
    1,
    2,
    2,
    0,
    0,
    0,
    2,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    1,
    2,
    0,
    0,
    0,
    1,
    2,
    1,
    2,
    2,
    1,
    1,
    2,
    1,
    2,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    3,
    2,
    0,
    0,
    0,
    1,
    0,
    2,
    2,
    2,
    0,
    0,
    0,
    2,
    2,
    1,
    0,
    0,
    0,
    0,
    3,
    1,
    1,
    1,
    1,
    0,
    0,
    2,
    1,
    1,
    1,
    2,
    1,
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    2,
    1,
    0,
    0,
    1,
    0,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    2,
    3,
    2,
    0,
    0,
    0,
    1,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    2,
    1,
    1,
    0,
    0,
    0,
    0,
    2,
    1,
    0,
    1,
    1,
    0,
    0,
    2,
    1,
    1,
    0,
    2,
    1,
    1,
    1,
    1,
    2,
    1,
    2,
    1,
    2,
    0,
    1,
    1,
    1,
    0,
    2,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    3,
    1,
    1,
    2,
    2,
    2,
    3,
    2,
    1,
    1,
    2,
    2,
    1,
    1,
    0,
    1,
    0,
    2,
    2,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    2,
    2,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    2,
    0,
    0,
    2,
    1,
    1,
    1,
    2,
    2,
    1,
    1,
    1,
    2,
    1,
    2,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    0,
    1,
    2,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    2,
    3,
    2,
    1,
    0,
    0,
    2,
    0,
    1,
    1,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    2,
    1,
    2,
    1,
    2,
    1,
    1,
    1,
    2,
    0,
    2,
    1,
    1,
    1,
    0,
    1,
    2,
    0,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    2,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    1,
    0,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    1,
    1,
    0,
    0,
    2,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    0,
    1,
    1,
    1,
    1,
    0,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    2,
    2,
    0,
    1,
    1,
    1,
    0,
    2,
    2,
    2,
    0,
    0,
    0,
    3,
    2,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    0,
    1,
    0,
    1,
    2,
    1,
    0,
    2,
    1,
    1,
    2,
    2,
    1,
    1,
    2,
    1,
    1,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    1,
    2,
    2,
    2,
    2,
    2,
    1,
    1,
    1,
    2,
    0,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    0,
    1,
    0,
    1,
    2,
    3,
    0,
    0,
    0,
    1,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    2,
    0,
    1,
    0,
    2,
    1,
    1,
    1,
    1,
    1,
    0,
    2,
    0,
    0,
    0,
    1,
    2,
    1,
    1,
    1,
    1,
    0,
    1,
    2,
    0,
    1,
    0,
    1,
    0,
    1,
    1,
    1,
    0,
    1,
    0,
    1,
    2,
    2,
    2,
    0,
    0,
    0,
    1,
    0,
    2,
    1,
    2,
    0,
    0,
    0,
    1,
    1,
    2,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    2,
    1,
    0,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    0,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    2,
    2,
    0,
    0,
    0,
    1,
    0,
    2,
    2,
    2,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    2,
    0,
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    1,
    1,
    0,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    1,
    2,
    1,
    0,
    0,
    1,
    1,
    1,
    2,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    2,
    0,
    2,
    0,
    1,
    1,
    0,
    1,
    2,
    1,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    2,
    1,
    1,
    0,
    1,
    2,
    0,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    2,
    1,
    0,
    1,
    2,
    2,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    2,
    1,
    1,
    0,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    2,
    2,
    0,
    0,
    2,
    0,
    0,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    2,
    0,
    0,
    3,
    1,
    0,
    2,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    1,
    0,
    1,
    2,
    1,
    0,
    1,
    1,
    1,
    2,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    2,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    2,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    0,
    1,
    1,
    2,
    1,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    2,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    2,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    2,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    0,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    2,
    1,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    1,
    0,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    1,
    0,
    1,
    0,
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    1,
    1,
    0,
    1,
    0,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    1,
    0,
    1,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    1,
    0,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0
  ], e.Latin2HungarianModel = {
    charToOrderMap: e.Latin2_HungarianCharToOrderMap,
    precedenceMatrix: e.HungarianLangModel,
    mTypicalPositiveRatio: 0.947368,
    keepEnglishLetter: !0,
    charsetName: "ISO-8859-2"
  }, e.Win1250HungarianModel = {
    charToOrderMap: e.win1250HungarianCharToOrderMap,
    precedenceMatrix: e.HungarianLangModel,
    mTypicalPositiveRatio: 0.947368,
    keepEnglishLetter: !0,
    charsetName: "windows-1250"
  };
})(h6);
var u6 = {};
(function(e) {
  e.Latin5_BulgarianCharToOrderMap = [
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    254,
    255,
    255,
    254,
    255,
    255,
    // 00
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    // 10
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    // 20
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    253,
    253,
    253,
    253,
    253,
    253,
    // 30
    253,
    77,
    90,
    99,
    100,
    72,
    109,
    107,
    101,
    79,
    185,
    81,
    102,
    76,
    94,
    82,
    // 40
    110,
    186,
    108,
    91,
    74,
    119,
    84,
    96,
    111,
    187,
    115,
    253,
    253,
    253,
    253,
    253,
    // 50
    253,
    65,
    69,
    70,
    66,
    63,
    68,
    112,
    103,
    92,
    194,
    104,
    95,
    86,
    87,
    71,
    // 60
    116,
    195,
    85,
    93,
    97,
    113,
    196,
    197,
    198,
    199,
    200,
    253,
    253,
    253,
    253,
    253,
    // 70
    194,
    195,
    196,
    197,
    198,
    199,
    200,
    201,
    202,
    203,
    204,
    205,
    206,
    207,
    208,
    209,
    // 80
    210,
    211,
    212,
    213,
    214,
    215,
    216,
    217,
    218,
    219,
    220,
    221,
    222,
    223,
    224,
    225,
    // 90
    81,
    226,
    227,
    228,
    229,
    230,
    105,
    231,
    232,
    233,
    234,
    235,
    236,
    45,
    237,
    238,
    // a0
    31,
    32,
    35,
    43,
    37,
    44,
    55,
    47,
    40,
    59,
    33,
    46,
    38,
    36,
    41,
    30,
    // b0
    39,
    28,
    34,
    51,
    48,
    49,
    53,
    50,
    54,
    57,
    61,
    239,
    67,
    240,
    60,
    56,
    // c0
    1,
    18,
    9,
    20,
    11,
    3,
    23,
    15,
    2,
    26,
    12,
    10,
    14,
    6,
    4,
    13,
    // d0
    7,
    8,
    5,
    19,
    29,
    25,
    22,
    21,
    27,
    24,
    17,
    75,
    52,
    241,
    42,
    16,
    // e0
    62,
    242,
    243,
    244,
    58,
    245,
    98,
    246,
    247,
    248,
    249,
    250,
    251,
    91,
    252,
    253
    // f0
  ], e.win1251BulgarianCharToOrderMap = [
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    254,
    255,
    255,
    254,
    255,
    255,
    // 00
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    // 10
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    // 20
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    253,
    253,
    253,
    253,
    253,
    253,
    // 30
    253,
    77,
    90,
    99,
    100,
    72,
    109,
    107,
    101,
    79,
    185,
    81,
    102,
    76,
    94,
    82,
    // 40
    110,
    186,
    108,
    91,
    74,
    119,
    84,
    96,
    111,
    187,
    115,
    253,
    253,
    253,
    253,
    253,
    // 50
    253,
    65,
    69,
    70,
    66,
    63,
    68,
    112,
    103,
    92,
    194,
    104,
    95,
    86,
    87,
    71,
    // 60
    116,
    195,
    85,
    93,
    97,
    113,
    196,
    197,
    198,
    199,
    200,
    253,
    253,
    253,
    253,
    253,
    // 70
    206,
    207,
    208,
    209,
    210,
    211,
    212,
    213,
    120,
    214,
    215,
    216,
    217,
    218,
    219,
    220,
    // 80
    221,
    78,
    64,
    83,
    121,
    98,
    117,
    105,
    222,
    223,
    224,
    225,
    226,
    227,
    228,
    229,
    // 90
    88,
    230,
    231,
    232,
    233,
    122,
    89,
    106,
    234,
    235,
    236,
    237,
    238,
    45,
    239,
    240,
    // a0
    73,
    80,
    118,
    114,
    241,
    242,
    243,
    244,
    245,
    62,
    58,
    246,
    247,
    248,
    249,
    250,
    // b0
    31,
    32,
    35,
    43,
    37,
    44,
    55,
    47,
    40,
    59,
    33,
    46,
    38,
    36,
    41,
    30,
    // c0
    39,
    28,
    34,
    51,
    48,
    49,
    53,
    50,
    54,
    57,
    61,
    251,
    67,
    252,
    60,
    56,
    // d0
    1,
    18,
    9,
    20,
    11,
    3,
    23,
    15,
    2,
    26,
    12,
    10,
    14,
    6,
    4,
    13,
    // e0
    7,
    8,
    5,
    19,
    29,
    25,
    22,
    21,
    27,
    24,
    17,
    75,
    52,
    253,
    42,
    16
    // f0
  ], e.BulgarianLangModel = [
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    3,
    3,
    3,
    2,
    2,
    3,
    2,
    2,
    1,
    2,
    2,
    3,
    1,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    3,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    3,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    2,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    2,
    2,
    1,
    3,
    3,
    3,
    3,
    2,
    2,
    2,
    1,
    1,
    2,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    2,
    2,
    3,
    3,
    1,
    1,
    2,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    2,
    1,
    2,
    0,
    2,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    1,
    3,
    0,
    3,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    3,
    3,
    2,
    3,
    3,
    3,
    1,
    3,
    3,
    2,
    3,
    2,
    2,
    2,
    0,
    0,
    2,
    0,
    2,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    3,
    3,
    3,
    2,
    2,
    3,
    3,
    3,
    1,
    2,
    2,
    3,
    2,
    1,
    1,
    2,
    0,
    2,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    1,
    2,
    3,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    3,
    1,
    2,
    0,
    2,
    1,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    3,
    3,
    3,
    3,
    1,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    2,
    3,
    3,
    2,
    3,
    2,
    2,
    2,
    3,
    1,
    2,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    1,
    1,
    2,
    2,
    1,
    3,
    1,
    3,
    2,
    2,
    3,
    0,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    3,
    2,
    2,
    3,
    1,
    2,
    1,
    1,
    1,
    2,
    3,
    1,
    3,
    1,
    2,
    2,
    0,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    3,
    3,
    3,
    3,
    1,
    3,
    2,
    2,
    3,
    3,
    1,
    2,
    3,
    1,
    1,
    3,
    3,
    3,
    3,
    1,
    2,
    2,
    1,
    1,
    1,
    0,
    2,
    0,
    2,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    2,
    2,
    3,
    3,
    3,
    2,
    2,
    1,
    1,
    2,
    0,
    2,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    0,
    1,
    2,
    1,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    2,
    1,
    0,
    3,
    1,
    2,
    1,
    2,
    1,
    2,
    3,
    2,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    0,
    3,
    1,
    3,
    3,
    2,
    3,
    3,
    2,
    2,
    2,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    3,
    3,
    3,
    0,
    3,
    3,
    3,
    3,
    3,
    2,
    1,
    1,
    2,
    1,
    3,
    3,
    0,
    3,
    1,
    1,
    1,
    1,
    3,
    2,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    3,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    1,
    3,
    1,
    3,
    3,
    2,
    3,
    2,
    2,
    2,
    3,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    2,
    2,
    3,
    2,
    1,
    1,
    1,
    1,
    1,
    3,
    1,
    3,
    1,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    2,
    0,
    3,
    2,
    0,
    3,
    0,
    2,
    0,
    0,
    2,
    1,
    3,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    3,
    3,
    3,
    2,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    2,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    3,
    3,
    3,
    2,
    1,
    3,
    1,
    1,
    2,
    1,
    3,
    2,
    1,
    1,
    0,
    1,
    2,
    3,
    2,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    3,
    3,
    3,
    2,
    2,
    1,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    2,
    1,
    0,
    3,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    3,
    3,
    2,
    3,
    2,
    3,
    3,
    1,
    3,
    2,
    1,
    1,
    1,
    2,
    1,
    1,
    2,
    1,
    3,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    1,
    1,
    2,
    2,
    3,
    3,
    2,
    3,
    2,
    2,
    2,
    3,
    1,
    2,
    2,
    1,
    1,
    2,
    1,
    1,
    2,
    2,
    0,
    1,
    1,
    0,
    1,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    2,
    1,
    3,
    1,
    0,
    2,
    2,
    1,
    3,
    2,
    1,
    0,
    0,
    2,
    0,
    2,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    2,
    0,
    2,
    3,
    1,
    2,
    3,
    2,
    0,
    1,
    3,
    1,
    2,
    1,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    2,
    2,
    2,
    3,
    2,
    2,
    2,
    2,
    1,
    2,
    1,
    1,
    2,
    2,
    1,
    1,
    2,
    0,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    3,
    3,
    3,
    3,
    3,
    2,
    1,
    2,
    2,
    1,
    2,
    0,
    2,
    0,
    1,
    0,
    1,
    2,
    1,
    2,
    1,
    1,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    3,
    2,
    3,
    3,
    1,
    1,
    3,
    1,
    0,
    3,
    2,
    1,
    0,
    0,
    0,
    1,
    2,
    0,
    2,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    1,
    2,
    1,
    2,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    2,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    3,
    1,
    0,
    1,
    0,
    2,
    3,
    2,
    2,
    2,
    3,
    2,
    2,
    2,
    2,
    2,
    1,
    0,
    2,
    1,
    2,
    1,
    1,
    1,
    0,
    1,
    2,
    1,
    2,
    2,
    2,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    1,
    2,
    1,
    1,
    0,
    1,
    2,
    1,
    2,
    2,
    2,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    2,
    0,
    1,
    0,
    0,
    0,
    0,
    2,
    3,
    2,
    3,
    3,
    0,
    0,
    2,
    1,
    0,
    2,
    1,
    0,
    0,
    0,
    0,
    2,
    3,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    2,
    0,
    1,
    2,
    2,
    1,
    2,
    1,
    2,
    2,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    0,
    1,
    2,
    2,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    0,
    1,
    2,
    0,
    0,
    3,
    3,
    2,
    2,
    3,
    0,
    2,
    3,
    1,
    1,
    2,
    0,
    0,
    0,
    1,
    0,
    0,
    2,
    0,
    2,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    1,
    2,
    0,
    2,
    2,
    1,
    1,
    1,
    1,
    2,
    1,
    0,
    1,
    2,
    2,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    2,
    3,
    2,
    3,
    3,
    0,
    0,
    3,
    0,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    2,
    2,
    1,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    1,
    2,
    2,
    2,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    1,
    0,
    2,
    0,
    1,
    0,
    1,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    3,
    3,
    3,
    3,
    2,
    2,
    2,
    2,
    2,
    0,
    2,
    1,
    1,
    1,
    1,
    2,
    1,
    2,
    1,
    1,
    0,
    2,
    0,
    1,
    0,
    1,
    0,
    0,
    2,
    0,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    1,
    0,
    2,
    0,
    1,
    0,
    2,
    0,
    0,
    1,
    1,
    1,
    0,
    0,
    2,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    2,
    3,
    3,
    3,
    3,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    2,
    0,
    1,
    2,
    2,
    2,
    2,
    1,
    1,
    2,
    1,
    1,
    2,
    2,
    2,
    1,
    2,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    0,
    0,
    2,
    3,
    3,
    3,
    3,
    0,
    2,
    2,
    0,
    2,
    1,
    0,
    0,
    0,
    1,
    1,
    1,
    2,
    0,
    2,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    2,
    0,
    2,
    2,
    1,
    1,
    1,
    2,
    1,
    2,
    1,
    1,
    2,
    2,
    2,
    1,
    2,
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    0,
    2,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    2,
    3,
    3,
    3,
    3,
    0,
    2,
    1,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    1,
    2,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    1,
    2,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    0,
    1,
    0,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    3,
    3,
    2,
    2,
    3,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    2,
    2,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    3,
    1,
    0,
    1,
    0,
    2,
    2,
    2,
    2,
    3,
    2,
    1,
    1,
    1,
    2,
    3,
    0,
    0,
    1,
    0,
    2,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    1,
    2,
    2,
    1,
    1,
    0,
    1,
    2,
    1,
    2,
    2,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    2,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    2,
    1,
    0,
    1,
    0,
    3,
    1,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    1,
    1,
    1,
    0,
    2,
    1,
    2,
    2,
    1,
    1,
    2,
    1,
    1,
    0,
    2,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    0,
    1,
    1,
    0,
    2,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    2,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    1,
    2,
    2,
    1,
    1,
    2,
    1,
    2,
    3,
    2,
    2,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    2,
    3,
    2,
    0,
    1,
    2,
    0,
    1,
    2,
    1,
    1,
    0,
    1,
    0,
    1,
    2,
    1,
    2,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    2,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    0,
    2,
    0,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    1,
    1,
    2,
    1,
    2,
    1,
    1,
    1,
    0,
    2,
    1,
    2,
    1,
    1,
    1,
    0,
    2,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    1,
    1,
    0,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    2,
    3,
    2,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    2,
    2,
    2,
    2,
    2,
    0,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    2,
    3,
    1,
    2,
    1,
    0,
    1,
    1,
    0,
    2,
    2,
    2,
    0,
    0,
    1,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    2,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    2,
    2,
    2,
    2,
    2,
    0,
    0,
    2,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    2,
    2,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    2,
    1,
    1,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    2,
    2,
    2,
    2,
    0,
    0,
    2,
    0,
    1,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    2,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    2,
    2,
    3,
    2,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    2,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    1,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    1,
    2,
    2,
    2,
    1,
    2,
    1,
    2,
    2,
    1,
    1,
    2,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    2,
    0,
    1,
    0,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    3,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    2,
    2,
    1,
    0,
    0,
    1,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    1,
    0,
    2,
    0,
    1,
    0,
    0,
    1,
    1,
    2,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    2,
    2,
    2,
    2,
    0,
    1,
    1,
    0,
    2,
    1,
    0,
    1,
    1,
    1,
    0,
    0,
    1,
    0,
    2,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    2,
    2,
    2,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    1,
    0,
    0,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    1,
    2,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    0,
    2,
    0,
    0,
    2,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1
  ], e.Latin5BulgarianModel = {
    charToOrderMap: e.Latin5_BulgarianCharToOrderMap,
    precedenceMatrix: e.BulgarianLangModel,
    mTypicalPositiveRatio: 0.969392,
    keepEnglishLetter: !1,
    charsetName: "ISO-8859-5"
  }, e.Win1251BulgarianModel = {
    charToOrderMap: e.win1251BulgarianCharToOrderMap,
    precedenceMatrix: e.BulgarianLangModel,
    mTypicalPositiveRatio: 0.969392,
    keepEnglishLetter: !1,
    charsetName: "windows-1251"
  };
})(u6);
var R1 = r9, x6 = Lr, g5 = i6.Win1255HebrewModel, a9 = t9, n3 = f6, _5 = o6, n9 = l6.TIS620ThaiModel, T5 = h6, E5 = u6;
function d6() {
  x6.apply(this);
  var e = this;
  function t() {
    e._mProbers = [
      new R1(n3.Win1251CyrillicModel),
      new R1(n3.Koi8rModel),
      new R1(n3.Latin5CyrillicModel),
      new R1(n3.MacCyrillicModel),
      new R1(n3.Ibm866Model),
      new R1(n3.Ibm855Model),
      new R1(_5.Latin7GreekModel),
      new R1(_5.Win1253GreekModel),
      new R1(E5.Latin5BulgarianModel),
      new R1(E5.Win1251BulgarianModel),
      new R1(T5.Latin2HungarianModel),
      new R1(T5.Win1250HungarianModel),
      new R1(n9)
    ];
    var r = new a9(), a = new R1(g5, !1, r), n = new R1(g5, !0, r);
    r.setModelProbers(a, n), e._mProbers.push(r, a, n), e._supportedCharsetNames = [];
    for (const i of e._mProbers)
      e._supportedCharsetNames.push(i.getCharsetName());
    e.reset();
  }
  this.getSupportedCharsetNames = function() {
    return e._supportedCharsetNames;
  }, t();
}
d6.prototype = new x6();
var i9 = d6, p6 = Z2, w5 = d1, F3 = 0, J = 1, K0 = 2, Y0 = 3, Q0 = 4, s2 = 5, e1 = 6, c2 = 7, s9 = [
  J,
  J,
  J,
  J,
  J,
  J,
  J,
  J,
  // 00 - 07
  J,
  J,
  J,
  J,
  J,
  J,
  J,
  J,
  // 08 - 0F
  J,
  J,
  J,
  J,
  J,
  J,
  J,
  J,
  // 10 - 17
  J,
  J,
  J,
  J,
  J,
  J,
  J,
  J,
  // 18 - 1F
  J,
  J,
  J,
  J,
  J,
  J,
  J,
  J,
  // 20 - 27
  J,
  J,
  J,
  J,
  J,
  J,
  J,
  J,
  // 28 - 2F
  J,
  J,
  J,
  J,
  J,
  J,
  J,
  J,
  // 30 - 37
  J,
  J,
  J,
  J,
  J,
  J,
  J,
  J,
  // 38 - 3F
  J,
  K0,
  K0,
  K0,
  K0,
  K0,
  K0,
  K0,
  // 40 - 47
  K0,
  K0,
  K0,
  K0,
  K0,
  K0,
  K0,
  K0,
  // 48 - 4F
  K0,
  K0,
  K0,
  K0,
  K0,
  K0,
  K0,
  K0,
  // 50 - 57
  K0,
  K0,
  K0,
  J,
  J,
  J,
  J,
  J,
  // 58 - 5F
  J,
  Y0,
  Y0,
  Y0,
  Y0,
  Y0,
  Y0,
  Y0,
  // 60 - 67
  Y0,
  Y0,
  Y0,
  Y0,
  Y0,
  Y0,
  Y0,
  Y0,
  // 68 - 6F
  Y0,
  Y0,
  Y0,
  Y0,
  Y0,
  Y0,
  Y0,
  Y0,
  // 70 - 77
  Y0,
  Y0,
  Y0,
  J,
  J,
  J,
  J,
  J,
  // 78 - 7F
  J,
  F3,
  J,
  c2,
  J,
  J,
  J,
  J,
  // 80 - 87
  J,
  J,
  s2,
  J,
  s2,
  F3,
  s2,
  F3,
  // 88 - 8F
  F3,
  J,
  J,
  J,
  J,
  J,
  J,
  J,
  // 90 - 97
  J,
  J,
  c2,
  J,
  c2,
  F3,
  c2,
  s2,
  // 98 - 9F
  J,
  J,
  J,
  J,
  J,
  J,
  J,
  J,
  // A0 - A7
  J,
  J,
  J,
  J,
  J,
  J,
  J,
  J,
  // A8 - AF
  J,
  J,
  J,
  J,
  J,
  J,
  J,
  J,
  // B0 - B7
  J,
  J,
  J,
  J,
  J,
  J,
  J,
  J,
  // B8 - BF
  Q0,
  Q0,
  Q0,
  Q0,
  Q0,
  Q0,
  s2,
  s2,
  // C0 - C7
  Q0,
  Q0,
  Q0,
  Q0,
  Q0,
  Q0,
  Q0,
  Q0,
  // C8 - CF
  s2,
  s2,
  Q0,
  Q0,
  Q0,
  Q0,
  Q0,
  J,
  // D0 - D7
  Q0,
  Q0,
  Q0,
  Q0,
  Q0,
  s2,
  s2,
  s2,
  // D8 - DF
  e1,
  e1,
  e1,
  e1,
  e1,
  e1,
  c2,
  c2,
  // E0 - E7
  e1,
  e1,
  e1,
  e1,
  e1,
  e1,
  e1,
  e1,
  // E8 - EF
  c2,
  c2,
  e1,
  e1,
  e1,
  e1,
  e1,
  J,
  // F0 - F7
  e1,
  e1,
  e1,
  e1,
  e1,
  c2,
  c2,
  c2
  // F8 - FF
], c9 = [
  // UDF OTH ASC ASS ACV ACO ASV ASO
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // UDF
  0,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  // OTH
  0,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  // ASC
  0,
  3,
  3,
  3,
  1,
  1,
  3,
  3,
  // ASS
  0,
  3,
  3,
  3,
  1,
  2,
  1,
  2,
  // ACV
  0,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  // ACO
  0,
  3,
  1,
  3,
  1,
  1,
  1,
  3,
  // ASV
  0,
  3,
  1,
  3,
  1,
  1,
  3,
  3
  // ASO
];
function R4() {
  p6.apply(this);
  var e = 4, t = 8, r = this;
  function a() {
    r.reset();
  }
  this.reset = function() {
    this._mLastCharClass = J, this._mFreqCounter = [];
    for (var n = 0; n < e; this._mFreqCounter[n++] = 0)
      ;
    R4.prototype.reset.apply(this);
  }, this.getCharsetName = function() {
    return "windows-1252";
  }, this.getSupportedCharsetNames = function() {
    return [this.getCharsetName()];
  }, this.feed = function(n) {
    n = this.removeXmlTags(n);
    for (var i = 0; i < n.length; i++) {
      var c = n.charCodeAt(i), s = s9[c], f = c9[this._mLastCharClass * t + s];
      if (f == 0) {
        this._mState = w5.notMe;
        break;
      }
      this._mFreqCounter[f]++, this._mLastCharClass = s;
    }
    return this.getState();
  }, this.getConfidence = function() {
    var n;
    if (this.getState() == w5.notMe)
      return 0.01;
    for (var i = 0, c = 0; c < this._mFreqCounter.length; c++)
      i += this._mFreqCounter[c];
    return i < 0.01 ? n = 0 : n = this._mFreqCounter[3] / i - this._mFreqCounter[1] * 20 / i, n < 0 && (n = 0), n = n * 0.95, n;
  }, a();
}
R4.prototype = new p6();
var f9 = R4, ee = {}, M = d1, o9 = [
  1,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 00 - 07
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 08 - 0f
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 10 - 17
  0,
  0,
  0,
  1,
  0,
  0,
  0,
  0,
  // 18 - 1f
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 20 - 27
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 28 - 2f
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 30 - 37
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 38 - 3f
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 40 - 47
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 48 - 4f
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 50 - 57
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 58 - 5f
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 60 - 67
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 68 - 6f
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 70 - 77
  0,
  0,
  0,
  4,
  0,
  5,
  2,
  0,
  // 78 - 7f
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 80 - 87
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 88 - 8f
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 90 - 97
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // 98 - 9f
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // a0 - a7
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // a8 - af
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // b0 - b7
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // b8 - bf
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // c0 - c7
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // c8 - cf
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // d0 - d7
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // d8 - df
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // e0 - e7
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // e8 - ef
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  // f0 - f7
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1
  // f8 - ff
], l9 = [
  M.start,
  M.error,
  3,
  M.start,
  M.start,
  M.start,
  M.error,
  M.error,
  // 00-07
  M.error,
  M.error,
  M.error,
  M.error,
  M.itsMe,
  M.itsMe,
  M.itsMe,
  M.itsMe,
  // 08-0f
  M.itsMe,
  M.itsMe,
  M.error,
  M.error,
  M.start,
  M.start,
  4,
  M.error,
  // 10-17
  5,
  M.error,
  6,
  M.error,
  5,
  5,
  4,
  M.error,
  // 18-1f
  4,
  M.error,
  4,
  4,
  4,
  M.error,
  4,
  M.error,
  // 20-27
  4,
  M.itsMe,
  M.start,
  M.start,
  M.start,
  M.start,
  M.start,
  M.start
  // 28-2f
], h9 = [0, 0, 0, 0, 0, 0];
ee.HZSMModel = {
  classTable: o9,
  classFactor: 6,
  stateTable: l9,
  charLenTable: h9,
  name: "HZ-GB-2312"
};
var u9 = [
  2,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 00 - 07
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 08 - 0f
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 10 - 17
  0,
  0,
  0,
  1,
  0,
  0,
  0,
  0,
  // 18 - 1f
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 20 - 27
  0,
  3,
  0,
  0,
  0,
  0,
  0,
  0,
  // 28 - 2f
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 30 - 37
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 38 - 3f
  0,
  0,
  0,
  4,
  0,
  0,
  0,
  0,
  // 40 - 47
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 48 - 4f
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 50 - 57
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 58 - 5f
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 60 - 67
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 68 - 6f
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 70 - 77
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 78 - 7f
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 80 - 87
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 88 - 8f
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 90 - 97
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 98 - 9f
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // a0 - a7
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // a8 - af
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // b0 - b7
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // b8 - bf
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // c0 - c7
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // c8 - cf
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // d0 - d7
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // d8 - df
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // e0 - e7
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // e8 - ef
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // f0 - f7
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2
  // f8 - ff
], x9 = [
  M.start,
  3,
  M.error,
  M.start,
  M.start,
  M.start,
  M.start,
  M.start,
  // 00-07
  M.start,
  M.error,
  M.error,
  M.error,
  M.error,
  M.error,
  M.error,
  M.error,
  // 08-0f
  M.error,
  M.error,
  M.itsMe,
  M.itsMe,
  M.itsMe,
  M.itsMe,
  M.itsMe,
  M.itsMe,
  // 10-17
  M.itsMe,
  M.itsMe,
  M.itsMe,
  M.error,
  M.error,
  M.error,
  4,
  M.error,
  // 18-1f
  M.error,
  M.error,
  M.error,
  M.itsMe,
  M.error,
  M.error,
  M.error,
  M.error,
  // 20-27
  5,
  6,
  M.error,
  M.error,
  M.error,
  M.error,
  M.error,
  M.error,
  // 28-2f
  M.error,
  M.error,
  M.error,
  M.itsMe,
  M.error,
  M.error,
  M.error,
  M.error,
  // 30-37
  M.error,
  M.error,
  M.error,
  M.error,
  M.error,
  M.itsMe,
  M.error,
  M.start
  // 38-3f
], d9 = [0, 0, 0, 0, 0, 0, 0, 0, 0];
ee.ISO2022CNSMModel = {
  classTable: u9,
  classFactor: 9,
  stateTable: x9,
  charLenTable: d9,
  name: "ISO-2022-CN"
};
var p9 = [
  2,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 00 - 07
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2,
  // 08 - 0f
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 10 - 17
  0,
  0,
  0,
  1,
  0,
  0,
  0,
  0,
  // 18 - 1f
  0,
  0,
  0,
  0,
  7,
  0,
  0,
  0,
  // 20 - 27
  3,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 28 - 2f
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 30 - 37
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 38 - 3f
  6,
  0,
  4,
  0,
  8,
  0,
  0,
  0,
  // 40 - 47
  0,
  9,
  5,
  0,
  0,
  0,
  0,
  0,
  // 48 - 4f
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 50 - 57
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 58 - 5f
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 60 - 67
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 68 - 6f
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 70 - 77
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 78 - 7f
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 80 - 87
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 88 - 8f
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 90 - 97
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 98 - 9f
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // a0 - a7
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // a8 - af
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // b0 - b7
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // b8 - bf
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // c0 - c7
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // c8 - cf
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // d0 - d7
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // d8 - df
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // e0 - e7
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // e8 - ef
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // f0 - f7
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2
  // f8 - ff
], m9 = [
  M.start,
  3,
  M.error,
  M.start,
  M.start,
  M.start,
  M.start,
  M.start,
  // 00-07
  M.start,
  M.start,
  M.error,
  M.error,
  M.error,
  M.error,
  M.error,
  M.error,
  // 08-0f
  M.error,
  M.error,
  M.error,
  M.error,
  M.itsMe,
  M.itsMe,
  M.itsMe,
  M.itsMe,
  // 10-17
  M.itsMe,
  M.itsMe,
  M.itsMe,
  M.itsMe,
  M.itsMe,
  M.itsMe,
  M.error,
  M.error,
  // 18-1f
  M.error,
  5,
  M.error,
  M.error,
  M.error,
  4,
  M.error,
  M.error,
  // 20-27
  M.error,
  M.error,
  M.error,
  6,
  M.itsMe,
  M.error,
  M.itsMe,
  M.error,
  // 28-2f
  M.error,
  M.error,
  M.error,
  M.error,
  M.error,
  M.error,
  M.itsMe,
  M.itsMe,
  // 30-37
  M.error,
  M.error,
  M.error,
  M.itsMe,
  M.error,
  M.error,
  M.error,
  M.error,
  // 38-3f
  M.error,
  M.error,
  M.error,
  M.error,
  M.itsMe,
  M.error,
  M.start,
  M.start
  // 40-47
], v9 = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
ee.ISO2022JPSMModel = {
  classTable: p9,
  classFactor: 10,
  stateTable: m9,
  charLenTable: v9,
  name: "ISO-2022-JP"
};
var g9 = [
  2,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 00 - 07
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 08 - 0f
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 10 - 17
  0,
  0,
  0,
  1,
  0,
  0,
  0,
  0,
  // 18 - 1f
  0,
  0,
  0,
  0,
  3,
  0,
  0,
  0,
  // 20 - 27
  0,
  4,
  0,
  0,
  0,
  0,
  0,
  0,
  // 28 - 2f
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 30 - 37
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 38 - 3f
  0,
  0,
  0,
  5,
  0,
  0,
  0,
  0,
  // 40 - 47
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 48 - 4f
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 50 - 57
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 58 - 5f
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 60 - 67
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 68 - 6f
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 70 - 77
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  // 78 - 7f
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 80 - 87
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 88 - 8f
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 90 - 97
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // 98 - 9f
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // a0 - a7
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // a8 - af
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // b0 - b7
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // b8 - bf
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // c0 - c7
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // c8 - cf
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // d0 - d7
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // d8 - df
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // e0 - e7
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // e8 - ef
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  // f0 - f7
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2
  // f8 - ff
], _9 = [
  M.start,
  3,
  M.error,
  M.start,
  M.start,
  M.start,
  M.error,
  M.error,
  // 00-07
  M.error,
  M.error,
  M.error,
  M.error,
  M.itsMe,
  M.itsMe,
  M.itsMe,
  M.itsMe,
  // 08-0f
  M.itsMe,
  M.itsMe,
  M.error,
  M.error,
  M.error,
  4,
  M.error,
  M.error,
  // 10-17
  M.error,
  M.error,
  M.error,
  M.error,
  5,
  M.error,
  M.error,
  M.error,
  // 18-1f
  M.error,
  M.error,
  M.error,
  M.itsMe,
  M.start,
  M.start,
  M.start,
  M.start
  // 20-27
], T9 = [0, 0, 0, 0, 0, 0];
ee.ISO2022KRSMModel = {
  classTable: g9,
  classFactor: 6,
  stateTable: _9,
  charLenTable: T9,
  name: "ISO-2022-KR"
};
var m6 = Z2, le = P2, he = ee, ue = d1;
function M4() {
  m6.apply(this);
  var e = this;
  function t() {
    e._mCodingSM = [
      new le(he.HZSMModel),
      new le(he.ISO2022CNSMModel),
      new le(he.ISO2022JPSMModel),
      new le(he.ISO2022KRSMModel)
    ], e._supportedCharsetNames = [];
    for (const r of e._mCodingSM)
      e._supportedCharsetNames.push(r.getCodingStateMachine());
    e.reset();
  }
  this.reset = function() {
    M4.prototype.reset.apply(this);
    for (var r = 0, a; a = this._mCodingSM[r]; r++)
      a && (a.active = !0, a.reset());
    this._mActiveSM = e._mCodingSM.length, this._mDetectedCharset = null;
  }, this.getCharsetName = function() {
    return this._mDetectedCharset;
  }, this.getSupportedCharsetNames = function() {
    return e._supportedCharsetNames;
  }, this.getConfidence = function() {
    return this._mDetectedCharset ? 0.99 : 0;
  }, this.feed = function(r) {
    for (var a = 0, n; a < r.length; a++) {
      n = r[a];
      for (var i = 0, c; c = this._mCodingSM[i]; i++)
        if (!(!c || !c.active)) {
          var s = c.nextState(n);
          if (s == ue.error) {
            if (c.active = !1, this._mActiveSM--, this._mActiveSM <= 0)
              return this._mState = ue.notMe, this.getState();
          } else if (s == ue.itsMe)
            return this._mState = ue.foundIt, this._mDetectedCharset = c.getCodingStateMachine(), this.getState();
        }
    }
    return this.getState();
  }, t();
}
M4.prototype = new m6();
var E9 = M4, k5 = d1, v6 = e9, g6 = i9, _6 = f9, T6 = E9, i3 = h2;
const E6 = function() {
  const e = [
    "UTF-8",
    "UTF-32LE",
    "UTF-32BE",
    "UTF-32BE",
    "UTF-16LE",
    "UTF-16BE",
    "X-ISO-10646-UCS-4-3412",
    "X-ISO-10646-UCS-4-2143"
  ], t = [
    new T6(),
    new v6(),
    new g6(),
    new _6()
  ], r = e.slice(0);
  for (const a of t)
    [].push.apply(r, a.getSupportedCharsetNames());
  return r;
}(), w9 = function() {
  const e = [];
  for (const t of E6)
    e.push(
      t.toLocaleLowerCase(),
      t.toLocaleLowerCase().replace(/-/g, "")
    );
  return e;
}();
function k9(e) {
  if (e || (e = {}), typeof e.minimumThreshold != "number" && (e.detectEncodings ? e.minimumThreshold = 0 : e.minimumThreshold = 0.2), e.detectEncodings) {
    for (const i of e.detectEncodings)
      if (!w9.includes(i.toLowerCase()))
        throw new Error(`Encoding ${i} is not supported. Supported encodings: ${E6}.`);
  }
  var t = {
    pureAscii: 0,
    escAscii: 1,
    highbyte: 2
  }, r = this;
  function a() {
    r._highBitDetector = /[\x80-\xFF]/, r._escDetector = /(\x1B|~\{)/, r._mEscCharsetProber = null, r._mCharsetProbers = [], r.reset();
  }
  function n(i) {
    if (!e.detectEncodings)
      return !0;
    var c = e.detectEncodings.map((s) => s.toLowerCase());
    return c.includes(i.toLowerCase());
  }
  this.reset = function() {
    this.result = { encoding: null, confidence: 0 }, this.results = [], this.done = !1, this._mStart = !0, this._mGotData = !1, this._mInputState = t.pureAscii, this._mLastChar = [], this._mBOM = "", this._mEscCharsetProber && this._mEscCharsetProber.reset();
    for (var i = 0, c; c = this._mCharsetProbers[i]; i++)
      c.reset();
  }, this.feed = function(i) {
    if (!this.done) {
      var c = i.length;
      if (c) {
        if (this._mGotData || (this._mBOM += i, this._mBOM.slice(0, 3) == "ï»¿" && n("UTF-8") ? this.result = { encoding: "UTF-8", confidence: 1 } : this._mBOM.slice(0, 4) == "ÿþ\0\0" && n("UTF-32LE") ? this.result = { encoding: "UTF-32LE", confidence: 1 } : this._mBOM.slice(0, 4) == "\0\0þÿ" && n("UTF-32BE") ? this.result = { encoding: "UTF-32BE", confidence: 1 } : this._mBOM.slice(0, 4) == "þÿ\0\0" && n("X-ISO-10646-UCS-4-3412") ? this.result = { encoding: "X-ISO-10646-UCS-4-3412", confidence: 1 } : this._mBOM.slice(0, 4) == "\0\0ÿþ" && n("X-ISO-10646-UCS-4-2143") ? this.result = { encoding: "X-ISO-10646-UCS-4-2143", confidence: 1 } : this._mBOM.slice(0, 2) == "ÿþ" && n("UTF-16LE") ? this.result = { encoding: "UTF-16LE", confidence: 1 } : this._mBOM.slice(0, 2) == "þÿ" && n("UTF-16BE") && (this.result = { encoding: "UTF-16BE", confidence: 1 }), this.result.confidence > 0 && (this.results = [this.result]), this._mBOM.length > 3 && (this._mGotData = !0)), this.result.encoding && this.result.confidence > 0) {
          this.done = !0;
          return;
        }
        if (this._mInputState == t.pureAscii && (this._highBitDetector.test(i) ? this._mInputState = t.highbyte : this._escDetector.test(this._mLastChar.join("") + i) && (this._mInputState = t.escAscii)), this._mLastChar = i.slice(-1).split(""), this._mInputState == t.escAscii)
          this._mEscCharsetProber || (this._mEscCharsetProber = new T6()), this._mEscCharsetProber.feed(i) == k5.foundIt && n(this._mEscCharsetProber.getCharsetName()) && (this.result = {
            encoding: this._mEscCharsetProber.getCharsetName(),
            confidence: this._mEscCharsetProber.getConfidence()
          }, this.results = [this.result], this.done = !0);
        else if (this._mInputState == t.highbyte) {
          this._mCharsetProbers.length == 0 && (this._mCharsetProbers = [
            new v6(),
            new g6(),
            new _6()
          ]);
          for (var s = 0, f; f = this._mCharsetProbers[s]; s++)
            if (f.feed(i) == k5.foundIt && n(f.getCharsetName())) {
              this.result = {
                encoding: f.getCharsetName(),
                confidence: f.getConfidence()
              }, this.results = [this.result], this.done = !0;
              break;
            }
        }
      }
    }
  }, this.close = function() {
    if (!this.done) {
      if (this._mBOM.length === 0) {
        i3.log(`no data received!
`);
        return;
      }
      if (this.done = !0, this._mInputState == t.pureAscii && n("ascii"))
        return i3.log("pure ascii"), this.result = { encoding: "ascii", confidence: 1 }, this.results.push(this.result), this.result;
      if (this._mInputState == t.highbyte) {
        let f = 0, o = !1;
        for (var i = 0, c; c = this._mCharsetProbers[i]; i++) {
          if (!c)
            continue;
          const l = c.getCharsetName(), d = c.getConfidence();
          c.getCharsetName() === "windows-1252" && (f = d), !(!l || !n(l)) && (this.results.push({
            encoding: c.getCharsetName(),
            confidence: d
          }), c.getCharsetName() === "windows-1250" && (o = !0), i3.log(c.getCharsetName() + " confidence " + d));
        }
        if (f && !o && n("windows-1250") && this.results.push({
          encoding: "windows-1250",
          // Report the confidence just a bit under windows-1252's.
          confidence: f - Math.pow(5 / 10, String(f).length - 1)
        }), this.results.sort(function(l, d) {
          return d.confidence - l.confidence;
        }), this.results.length > 0) {
          var s = this.results[0];
          if (s.confidence >= e.minimumThreshold)
            return this.result = s, s;
        }
      }
      if (i3.enabled) {
        i3.log(`no probers hit minimum threshhold
`);
        for (var i = 0, c; c = this._mCharsetProbers[i]; i++)
          !c || !n(c.getCharsetName()) || i3.log(c.getCharsetName() + " confidence = " + c.getConfidence() + `
`);
      }
    }
  }, a();
}
var C9 = k9, w6 = C9, S9 = h2.setLogger;
Q3.detect = function(e, t) {
  var r = k6(e, t);
  return r.result;
};
Q3.detectAll = function(e, t) {
  var r = k6(e, t);
  return r.results;
};
Q3.UniversalDetector = w6;
Q3.enableDebug = function() {
  S9(console.log.bind(console));
};
function k6(e, t) {
  var r = new w6(t);
  return r.reset(), typeof Buffer == "function" && e instanceof Buffer ? r.feed(e.toString("binary")) : r.feed(e), r.close(), r;
}
var A9 = Q3;
const C6 = /* @__PURE__ */ Y8(A9);
/*! xlsx.js (C) 2013-present SheetJS -- http://sheetjs.com */
var e2 = 1200, F9 = [874, 932, 936, 949, 950, 1250, 1251, 1252, 1253, 1254, 1255, 1256, 1257, 1258, 1e4], N4 = {
  /*::[*/
  0: 1252,
  /* ANSI */
  /*::[*/
  1: 65001,
  /* DEFAULT */
  /*::[*/
  2: 65001,
  /* SYMBOL */
  /*::[*/
  77: 1e4,
  /* MAC */
  /*::[*/
  128: 932,
  /* SHIFTJIS */
  /*::[*/
  129: 949,
  /* HANGUL */
  /*::[*/
  130: 1361,
  /* JOHAB */
  /*::[*/
  134: 936,
  /* GB2312 */
  /*::[*/
  136: 950,
  /* CHINESEBIG5 */
  /*::[*/
  161: 1253,
  /* GREEK */
  /*::[*/
  162: 1254,
  /* TURKISH */
  /*::[*/
  163: 1258,
  /* VIETNAMESE */
  /*::[*/
  177: 1255,
  /* HEBREW */
  /*::[*/
  178: 1256,
  /* ARABIC */
  /*::[*/
  186: 1257,
  /* BALTIC */
  /*::[*/
  204: 1251,
  /* RUSSIAN */
  /*::[*/
  222: 874,
  /* THAI */
  /*::[*/
  238: 1250,
  /* EASTEUROPE */
  /*::[*/
  255: 1252,
  /* OEM */
  /*::[*/
  69: 6969
  /* MISC */
}, P4 = function(e) {
  F9.indexOf(e) != -1 && (N4[0] = e);
};
function y9() {
  P4(1252);
}
var o2 = function(e) {
  e2 = e, P4(e);
};
function S6() {
  o2(1200), y9();
}
function C5(e) {
  for (var t = [], r = 0, a = e.length; r < a; ++r)
    t[r] = e.charCodeAt(r);
  return t;
}
function A6(e) {
  for (var t = [], r = 0; r < e.length >> 1; ++r)
    t[r] = String.fromCharCode(e.charCodeAt(2 * r) + (e.charCodeAt(2 * r + 1) << 8));
  return t.join("");
}
function I9(e) {
  for (var t = [], r = 0; r < e.length >> 1; ++r)
    t[r] = String.fromCharCode(e[2 * r] + (e[2 * r + 1] << 8));
  return t.join("");
}
function F6(e) {
  for (var t = [], r = 0; r < e.length >> 1; ++r)
    t[r] = String.fromCharCode(e.charCodeAt(2 * r + 1) + (e.charCodeAt(2 * r) << 8));
  return t.join("");
}
var y3 = function(e) {
  var t = e.charCodeAt(0), r = e.charCodeAt(1);
  return t == 255 && r == 254 ? A6(e.slice(2)) : t == 254 && r == 255 ? F6(e.slice(2)) : t == 65279 ? e.slice(1) : e;
}, xe = function(t) {
  return String.fromCharCode(t);
}, S5 = function(t) {
  return String.fromCharCode(t);
}, b9 = null, D2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
function A5(e) {
  for (var t = "", r = 0, a = 0, n = 0, i = 0, c = 0, s = 0, f = 0, o = 0; o < e.length; )
    r = e.charCodeAt(o++), i = r >> 2, a = e.charCodeAt(o++), c = (r & 3) << 4 | a >> 4, n = e.charCodeAt(o++), s = (a & 15) << 2 | n >> 6, f = n & 63, isNaN(a) ? s = f = 64 : isNaN(n) && (f = 64), t += D2.charAt(i) + D2.charAt(c) + D2.charAt(s) + D2.charAt(f);
  return t;
}
function $1(e) {
  var t = "", r = 0, a = 0, n = 0, i = 0, c = 0, s = 0, f = 0;
  e = e.replace(/^data:([^\/]+\/[^\/]+)?;base64\,/, "").replace(/[^\w\+\/\=]/g, "");
  for (var o = 0; o < e.length; )
    i = D2.indexOf(e.charAt(o++)), c = D2.indexOf(e.charAt(o++)), r = i << 2 | c >> 4, t += String.fromCharCode(r), s = D2.indexOf(e.charAt(o++)), a = (c & 15) << 4 | s >> 2, s !== 64 && (t += String.fromCharCode(a)), f = D2.indexOf(e.charAt(o++)), n = (s & 3) << 6 | f, f !== 64 && (t += String.fromCharCode(n));
  return t;
}
var O0 = /* @__PURE__ */ function() {
  return typeof Buffer < "u" && typeof process < "u" && typeof process.versions < "u" && !!process.versions.node;
}(), L2 = /* @__PURE__ */ function() {
  if (typeof Buffer < "u") {
    var e = !Buffer.from;
    if (!e)
      try {
        Buffer.from("foo", "utf8");
      } catch {
        e = !0;
      }
    return e ? function(t, r) {
      return r ? new Buffer(t, r) : new Buffer(t);
    } : Buffer.from.bind(Buffer);
  }
  return function() {
  };
}(), j3 = /* @__PURE__ */ function() {
  if (typeof Buffer > "u")
    return !1;
  var e = L2([65, 0]);
  if (!e)
    return !1;
  var t = e.toString("utf16le");
  return t.length == 1;
}();
function R2(e) {
  return O0 ? Buffer.alloc ? Buffer.alloc(e) : new Buffer(e) : typeof Uint8Array < "u" ? new Uint8Array(e) : new Array(e);
}
function F5(e) {
  return O0 ? Buffer.allocUnsafe ? Buffer.allocUnsafe(e) : new Buffer(e) : typeof Uint8Array < "u" ? new Uint8Array(e) : new Array(e);
}
var G1 = function(t) {
  return O0 ? L2(t, "binary") : t.split("").map(function(r) {
    return r.charCodeAt(0) & 255;
  });
};
function w2(e) {
  if (Array.isArray(e))
    return e.map(function(a) {
      return String.fromCharCode(a);
    }).join("");
  for (var t = [], r = 0; r < e.length; ++r)
    t[r] = String.fromCharCode(e[r]);
  return t.join("");
}
function L4(e) {
  if (typeof ArrayBuffer > "u")
    throw new Error("Unsupported");
  if (e instanceof ArrayBuffer)
    return L4(new Uint8Array(e));
  for (var t = new Array(e.length), r = 0; r < e.length; ++r)
    t[r] = e[r];
  return t;
}
var b2 = O0 ? function(e) {
  return Buffer.concat(e.map(function(t) {
    return Buffer.isBuffer(t) ? t : L2(t);
  }));
} : function(e) {
  if (typeof Uint8Array < "u") {
    var t = 0, r = 0;
    for (t = 0; t < e.length; ++t)
      r += e[t].length;
    var a = new Uint8Array(r), n = 0;
    for (t = 0, r = 0; t < e.length; r += n, ++t)
      n = e[t].length, e[t] instanceof Uint8Array ? a.set(e[t], r) : typeof e[t] == "string" ? a.set(new Uint8Array(G1(e[t])), r) : a.set(new Uint8Array(e[t]), r);
    return a;
  }
  return [].concat.apply([], e.map(function(i) {
    return Array.isArray(i) ? i : [].slice.call(i);
  }));
};
function D9(e) {
  for (var t = [], r = 0, a = e.length + 250, n = R2(e.length + 255), i = 0; i < e.length; ++i) {
    var c = e.charCodeAt(i);
    if (c < 128)
      n[r++] = c;
    else if (c < 2048)
      n[r++] = 192 | c >> 6 & 31, n[r++] = 128 | c & 63;
    else if (c >= 55296 && c < 57344) {
      c = (c & 1023) + 64;
      var s = e.charCodeAt(++i) & 1023;
      n[r++] = 240 | c >> 8 & 7, n[r++] = 128 | c >> 2 & 63, n[r++] = 128 | s >> 6 & 15 | (c & 3) << 4, n[r++] = 128 | s & 63;
    } else
      n[r++] = 224 | c >> 12 & 15, n[r++] = 128 | c >> 6 & 63, n[r++] = 128 | c & 63;
    r > a && (t.push(n.slice(0, r)), r = 0, n = R2(65535), a = 65530);
  }
  return t.push(n.slice(0, r)), b2(t);
}
var L1 = /\u0000/g, I3 = /[\u0001-\u0006]/g;
function u3(e) {
  for (var t = "", r = e.length - 1; r >= 0; )
    t += e.charAt(r--);
  return t;
}
function l2(e, t) {
  var r = "" + e;
  return r.length >= t ? r : P0("0", t - r.length) + r;
}
function B4(e, t) {
  var r = "" + e;
  return r.length >= t ? r : P0(" ", t - r.length) + r;
}
function Se(e, t) {
  var r = "" + e;
  return r.length >= t ? r : r + P0(" ", t - r.length);
}
function O9(e, t) {
  var r = "" + Math.round(e);
  return r.length >= t ? r : P0("0", t - r.length) + r;
}
function R9(e, t) {
  var r = "" + e;
  return r.length >= t ? r : P0("0", t - r.length) + r;
}
var y5 = /* @__PURE__ */ Math.pow(2, 32);
function s3(e, t) {
  if (e > y5 || e < -y5)
    return O9(e, t);
  var r = Math.round(e);
  return R9(r, t);
}
function Ae(e, t) {
  return t = t || 0, e.length >= 7 + t && (e.charCodeAt(t) | 32) === 103 && (e.charCodeAt(t + 1) | 32) === 101 && (e.charCodeAt(t + 2) | 32) === 110 && (e.charCodeAt(t + 3) | 32) === 101 && (e.charCodeAt(t + 4) | 32) === 114 && (e.charCodeAt(t + 5) | 32) === 97 && (e.charCodeAt(t + 6) | 32) === 108;
}
var I5 = [
  ["Sun", "Sunday"],
  ["Mon", "Monday"],
  ["Tue", "Tuesday"],
  ["Wed", "Wednesday"],
  ["Thu", "Thursday"],
  ["Fri", "Friday"],
  ["Sat", "Saturday"]
], s4 = [
  ["J", "Jan", "January"],
  ["F", "Feb", "February"],
  ["M", "Mar", "March"],
  ["A", "Apr", "April"],
  ["M", "May", "May"],
  ["J", "Jun", "June"],
  ["J", "Jul", "July"],
  ["A", "Aug", "August"],
  ["S", "Sep", "September"],
  ["O", "Oct", "October"],
  ["N", "Nov", "November"],
  ["D", "Dec", "December"]
];
function M9(e) {
  return e || (e = {}), e[0] = "General", e[1] = "0", e[2] = "0.00", e[3] = "#,##0", e[4] = "#,##0.00", e[9] = "0%", e[10] = "0.00%", e[11] = "0.00E+00", e[12] = "# ?/?", e[13] = "# ??/??", e[14] = "m/d/yy", e[15] = "d-mmm-yy", e[16] = "d-mmm", e[17] = "mmm-yy", e[18] = "h:mm AM/PM", e[19] = "h:mm:ss AM/PM", e[20] = "h:mm", e[21] = "h:mm:ss", e[22] = "m/d/yy h:mm", e[37] = "#,##0 ;(#,##0)", e[38] = "#,##0 ;[Red](#,##0)", e[39] = "#,##0.00;(#,##0.00)", e[40] = "#,##0.00;[Red](#,##0.00)", e[45] = "mm:ss", e[46] = "[h]:mm:ss", e[47] = "mmss.0", e[48] = "##0.0E+0", e[49] = "@", e[56] = '"上午/下午 "hh"時"mm"分"ss"秒 "', e;
}
var k0 = {
  0: "General",
  1: "0",
  2: "0.00",
  3: "#,##0",
  4: "#,##0.00",
  9: "0%",
  10: "0.00%",
  11: "0.00E+00",
  12: "# ?/?",
  13: "# ??/??",
  14: "m/d/yy",
  15: "d-mmm-yy",
  16: "d-mmm",
  17: "mmm-yy",
  18: "h:mm AM/PM",
  19: "h:mm:ss AM/PM",
  20: "h:mm",
  21: "h:mm:ss",
  22: "m/d/yy h:mm",
  37: "#,##0 ;(#,##0)",
  38: "#,##0 ;[Red](#,##0)",
  39: "#,##0.00;(#,##0.00)",
  40: "#,##0.00;[Red](#,##0.00)",
  45: "mm:ss",
  46: "[h]:mm:ss",
  47: "mmss.0",
  48: "##0.0E+0",
  49: "@",
  56: '"上午/下午 "hh"時"mm"分"ss"秒 "'
}, b5 = {
  5: 37,
  6: 38,
  7: 39,
  8: 40,
  //  5 -> 37 ...  8 -> 40
  23: 0,
  24: 0,
  25: 0,
  26: 0,
  // 23 ->  0 ... 26 ->  0
  27: 14,
  28: 14,
  29: 14,
  30: 14,
  31: 14,
  // 27 -> 14 ... 31 -> 14
  50: 14,
  51: 14,
  52: 14,
  53: 14,
  54: 14,
  // 50 -> 14 ... 58 -> 14
  55: 14,
  56: 14,
  57: 14,
  58: 14,
  59: 1,
  60: 2,
  61: 3,
  62: 4,
  // 59 ->  1 ... 62 ->  4
  67: 9,
  68: 10,
  // 67 ->  9 ... 68 -> 10
  69: 12,
  70: 13,
  71: 14,
  // 69 -> 12 ... 71 -> 14
  72: 14,
  73: 15,
  74: 16,
  75: 17,
  // 72 -> 14 ... 75 -> 17
  76: 20,
  77: 21,
  78: 22,
  // 76 -> 20 ... 78 -> 22
  79: 45,
  80: 46,
  81: 47,
  // 79 -> 45 ... 81 -> 47
  82: 0
  // 82 ->  0 ... 65536 -> 0 (omitted)
}, N9 = {
  //  5 -- Currency,   0 decimal, black negative
  5: '"$"#,##0_);\\("$"#,##0\\)',
  63: '"$"#,##0_);\\("$"#,##0\\)',
  //  6 -- Currency,   0 decimal, red   negative
  6: '"$"#,##0_);[Red]\\("$"#,##0\\)',
  64: '"$"#,##0_);[Red]\\("$"#,##0\\)',
  //  7 -- Currency,   2 decimal, black negative
  7: '"$"#,##0.00_);\\("$"#,##0.00\\)',
  65: '"$"#,##0.00_);\\("$"#,##0.00\\)',
  //  8 -- Currency,   2 decimal, red   negative
  8: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
  66: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
  // 41 -- Accounting, 0 decimal, No Symbol
  41: '_(* #,##0_);_(* \\(#,##0\\);_(* "-"_);_(@_)',
  // 42 -- Accounting, 0 decimal, $  Symbol
  42: '_("$"* #,##0_);_("$"* \\(#,##0\\);_("$"* "-"_);_(@_)',
  // 43 -- Accounting, 2 decimal, No Symbol
  43: '_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)',
  // 44 -- Accounting, 2 decimal, $  Symbol
  44: '_("$"* #,##0.00_);_("$"* \\(#,##0.00\\);_("$"* "-"??_);_(@_)'
};
function Fe(e, t, r) {
  for (var a = e < 0 ? -1 : 1, n = e * a, i = 0, c = 1, s = 0, f = 1, o = 0, l = 0, d = Math.floor(n); o < t && (d = Math.floor(n), s = d * c + i, l = d * o + f, !(n - d < 5e-8)); )
    n = 1 / (n - d), i = c, c = s, f = o, o = l;
  if (l > t && (o > t ? (l = f, s = i) : (l = o, s = c)), !r)
    return [0, a * s, l];
  var u = Math.floor(a * s / l);
  return [u, a * s - u * l, l];
}
function P9(e) {
  var t = e.toPrecision(16);
  if (t.indexOf("e") > -1) {
    var r = t.slice(0, t.indexOf("e"));
    return r = r.indexOf(".") > -1 ? r.slice(0, r.slice(0, 2) == "0." ? 17 : 16) : r.slice(0, 15) + P0("0", r.length - 15), r + t.slice(t.indexOf("e"));
  }
  var a = t.indexOf(".") > -1 ? t.slice(0, t.slice(0, 2) == "0." ? 17 : 16) : t.slice(0, 15) + P0("0", t.length - 15);
  return Number(a);
}
function v2(e, t, r) {
  if (e > 2958465 || e < 0)
    return null;
  e = P9(e);
  var a = e | 0, n = Math.floor(86400 * (e - a)), i = 0, c = [], s = { D: a, T: n, u: 86400 * (e - a) - n, y: 0, m: 0, d: 0, H: 0, M: 0, S: 0, q: 0 };
  if (Math.abs(s.u) < 1e-6 && (s.u = 0), t && t.date1904 && (a += 1462), s.u > 0.9999 && (s.u = 0, ++n == 86400 && (s.T = n = 0, ++a, ++s.D)), a === 60)
    c = r ? [1317, 10, 29] : [1900, 2, 29], i = 3;
  else if (a === 0)
    c = r ? [1317, 8, 29] : [1900, 1, 0], i = 6;
  else {
    a > 60 && --a;
    var f = new Date(1900, 0, 1);
    f.setDate(f.getDate() + a - 1), c = [f.getFullYear(), f.getMonth() + 1, f.getDate()], i = f.getDay(), a < 60 && (i = (i + 6) % 7), r && (i = H9(f, c));
  }
  return s.y = c[0], s.m = c[1], s.d = c[2], s.S = n % 60, n = Math.floor(n / 60), s.M = n % 60, n = Math.floor(n / 60), s.H = n, s.q = i, s;
}
function U4(e) {
  return e.indexOf(".") == -1 ? e : e.replace(/(?:\.0*|(\.\d*[1-9])0+)$/, "$1");
}
function L9(e) {
  return e.indexOf("E") == -1 ? e : e.replace(/(?:\.0*|(\.\d*[1-9])0+)[Ee]/, "$1E").replace(/(E[+-])(\d)$/, "$10$2");
}
function B9(e) {
  var t = e < 0 ? 12 : 11, r = U4(e.toFixed(12));
  return r.length <= t || (r = e.toPrecision(10), r.length <= t) ? r : e.toExponential(5);
}
function U9(e) {
  var t = U4(e.toFixed(11));
  return t.length > (e < 0 ? 12 : 11) || t === "0" || t === "-0" ? e.toPrecision(6) : t;
}
function z3(e) {
  var t = Math.floor(Math.log(Math.abs(e)) * Math.LOG10E), r;
  return t >= -4 && t <= -1 ? r = e.toPrecision(10 + t) : Math.abs(t) <= 9 ? r = B9(e) : t === 10 ? r = e.toFixed(10).substr(0, 12) : r = U9(e), U4(L9(r.toUpperCase()));
}
function K2(e, t) {
  switch (typeof e) {
    case "string":
      return e;
    case "boolean":
      return e ? "TRUE" : "FALSE";
    case "number":
      return (e | 0) === e ? e.toString(10) : z3(e);
    case "undefined":
      return "";
    case "object":
      if (e == null)
        return "";
      if (e instanceof Date)
        return X1(14, v1(e, t && t.date1904), t);
  }
  throw new Error("unsupported value in General format: " + e);
}
function H9(e, t) {
  t[0] -= 581;
  var r = e.getDay();
  return e < 60 && (r = (r + 6) % 7), r;
}
function W9(e, t, r, a) {
  var n = "", i = 0, c = 0, s = r.y, f, o = 0;
  switch (e) {
    case 98:
      s = r.y + 543;
    case 121:
      switch (t.length) {
        case 1:
        case 2:
          f = s % 100, o = 2;
          break;
        default:
          f = s % 1e4, o = 4;
          break;
      }
      break;
    case 109:
      switch (t.length) {
        case 1:
        case 2:
          f = r.m, o = t.length;
          break;
        case 3:
          return s4[r.m - 1][1];
        case 5:
          return s4[r.m - 1][0];
        default:
          return s4[r.m - 1][2];
      }
      break;
    case 100:
      switch (t.length) {
        case 1:
        case 2:
          f = r.d, o = t.length;
          break;
        case 3:
          return I5[r.q][0];
        default:
          return I5[r.q][1];
      }
      break;
    case 104:
      switch (t.length) {
        case 1:
        case 2:
          f = 1 + (r.H + 11) % 12, o = t.length;
          break;
        default:
          throw "bad hour format: " + t;
      }
      break;
    case 72:
      switch (t.length) {
        case 1:
        case 2:
          f = r.H, o = t.length;
          break;
        default:
          throw "bad hour format: " + t;
      }
      break;
    case 77:
      switch (t.length) {
        case 1:
        case 2:
          f = r.M, o = t.length;
          break;
        default:
          throw "bad minute format: " + t;
      }
      break;
    case 115:
      if (t != "s" && t != "ss" && t != ".0" && t != ".00" && t != ".000")
        throw "bad second format: " + t;
      return r.u === 0 && (t == "s" || t == "ss") ? l2(r.S, t.length) : (a >= 2 ? c = a === 3 ? 1e3 : 100 : c = a === 1 ? 10 : 1, i = Math.round(c * (r.S + r.u)), i >= 60 * c && (i = 0), t === "s" ? i === 0 ? "0" : "" + i / c : (n = l2(i, 2 + a), t === "ss" ? n.substr(0, 2) : "." + n.substr(2, t.length - 1)));
    case 90:
      switch (t) {
        case "[h]":
        case "[hh]":
          f = r.D * 24 + r.H;
          break;
        case "[m]":
        case "[mm]":
          f = (r.D * 24 + r.H) * 60 + r.M;
          break;
        case "[s]":
        case "[ss]":
          f = ((r.D * 24 + r.H) * 60 + r.M) * 60 + (a == 0 ? Math.round(r.S + r.u) : r.S);
          break;
        default:
          throw "bad abstime format: " + t;
      }
      o = t.length === 3 ? 1 : 2;
      break;
    case 101:
      f = s, o = 1;
      break;
  }
  var l = o > 0 ? l2(f, o) : "";
  return l;
}
function g2(e) {
  var t = 3;
  if (e.length <= t)
    return e;
  for (var r = e.length % t, a = e.substr(0, r); r != e.length; r += t)
    a += (a.length > 0 ? "," : "") + e.substr(r, t);
  return a;
}
var y6 = /%/g;
function V9(e, t, r) {
  var a = t.replace(y6, ""), n = t.length - a.length;
  return T2(e, a, r * Math.pow(10, 2 * n)) + P0("%", n);
}
function G9(e, t, r) {
  for (var a = t.length - 1; t.charCodeAt(a - 1) === 44; )
    --a;
  return T2(e, t.substr(0, a), r / Math.pow(10, 3 * (t.length - a)));
}
function I6(e, t) {
  var r, a = e.indexOf("E") - e.indexOf(".") - 1;
  if (e.match(/^#+0.0E\+0$/)) {
    if (t == 0)
      return "0.0E+0";
    if (t < 0)
      return "-" + I6(e, -t);
    var n = e.indexOf(".");
    n === -1 && (n = e.indexOf("E"));
    var i = Math.floor(Math.log(t) * Math.LOG10E) % n;
    if (i < 0 && (i += n), r = (t / Math.pow(10, i)).toPrecision(a + 1 + (n + i) % n), r.indexOf("e") === -1) {
      var c = Math.floor(Math.log(t) * Math.LOG10E);
      for (r.indexOf(".") === -1 ? r = r.charAt(0) + "." + r.substr(1) + "E+" + (c - r.length + i) : r += "E+" + (c - i); r.substr(0, 2) === "0."; )
        r = r.charAt(0) + r.substr(2, n) + "." + r.substr(2 + n), r = r.replace(/^0+([1-9])/, "$1").replace(/^0+\./, "0.");
      r = r.replace(/\+-/, "-");
    }
    r = r.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function(s, f, o, l) {
      return f + o + l.substr(0, (n + i) % n) + "." + l.substr(i) + "E";
    });
  } else
    r = t.toExponential(a);
  return e.match(/E\+00$/) && r.match(/e[+-]\d$/) && (r = r.substr(0, r.length - 1) + "0" + r.charAt(r.length - 1)), e.match(/E\-/) && r.match(/e\+/) && (r = r.replace(/e\+/, "e")), r.replace("e", "E");
}
var b6 = /# (\?+)( ?)\/( ?)(\d+)/;
function j9(e, t, r) {
  var a = parseInt(e[4], 10), n = Math.round(t * a), i = Math.floor(n / a), c = n - i * a, s = a;
  return r + (i === 0 ? "" : "" + i) + " " + (c === 0 ? P0(" ", e[1].length + 1 + e[4].length) : B4(c, e[1].length) + e[2] + "/" + e[3] + l2(s, e[4].length));
}
function z9(e, t, r) {
  return r + (t === 0 ? "" : "" + t) + P0(" ", e[1].length + 2 + e[4].length);
}
var D6 = /^#*0*\.([0#]+)/, O6 = /\).*[0#]/, R6 = /\(###\) ###\\?-####/;
function M1(e) {
  for (var t = "", r, a = 0; a != e.length; ++a)
    switch (r = e.charCodeAt(a)) {
      case 35:
        break;
      case 63:
        t += " ";
        break;
      case 48:
        t += "0";
        break;
      default:
        t += String.fromCharCode(r);
    }
  return t;
}
function D5(e, t) {
  var r = Math.pow(10, t);
  return "" + Math.round(e * r) / r;
}
function O5(e, t) {
  var r = e - Math.floor(e), a = Math.pow(10, t);
  return t < ("" + Math.round(r * a)).length ? 0 : Math.round(r * a);
}
function $9(e, t) {
  return t < ("" + Math.round((e - Math.floor(e)) * Math.pow(10, t))).length ? 1 : 0;
}
function X9(e) {
  return e < 2147483647 && e > -2147483648 ? "" + (e >= 0 ? e | 0 : e - 1 | 0) : "" + Math.floor(e);
}
function Z1(e, t, r) {
  if (e.charCodeAt(0) === 40 && !t.match(O6)) {
    var a = t.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
    return r >= 0 ? Z1("n", a, r) : "(" + Z1("n", a, -r) + ")";
  }
  if (t.charCodeAt(t.length - 1) === 44)
    return G9(e, t, r);
  if (t.indexOf("%") !== -1)
    return V9(e, t, r);
  if (t.indexOf("E") !== -1)
    return I6(t, r);
  if (t.charCodeAt(0) === 36)
    return "$" + Z1(e, t.substr(t.charAt(1) == " " ? 2 : 1), r);
  var n, i, c, s, f = Math.abs(r), o = r < 0 ? "-" : "";
  if (t.match(/^00+$/))
    return o + s3(f, t.length);
  if (t.match(/^[#?]+$/))
    return n = s3(r, 0), n === "0" && (n = ""), n.length > t.length ? n : M1(t.substr(0, t.length - n.length)) + n;
  if (i = t.match(b6))
    return j9(i, f, o);
  if (t.match(/^#+0+$/))
    return o + s3(f, t.length - t.indexOf("0"));
  if (i = t.match(D6))
    return n = D5(r, i[1].length).replace(/^([^\.]+)$/, "$1." + M1(i[1])).replace(/\.$/, "." + M1(i[1])).replace(/\.(\d*)$/, function(p, v) {
      return "." + v + P0("0", M1(
        /*::(*/
        i[1]
      ).length - v.length);
    }), t.indexOf("0.") !== -1 ? n : n.replace(/^0\./, ".");
  if (t = t.replace(/^#+([0.])/, "$1"), i = t.match(/^(0*)\.(#*)$/))
    return o + D5(f, i[2].length).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, i[1].length ? "0." : ".");
  if (i = t.match(/^#{1,3},##0(\.?)$/))
    return o + g2(s3(f, 0));
  if (i = t.match(/^#,##0\.([#0]*0)$/))
    return r < 0 ? "-" + Z1(e, t, -r) : g2("" + (Math.floor(r) + $9(r, i[1].length))) + "." + l2(O5(r, i[1].length), i[1].length);
  if (i = t.match(/^#,#*,#0/))
    return Z1(e, t.replace(/^#,#*,/, ""), r);
  if (i = t.match(/^([0#]+)(\\?-([0#]+))+$/))
    return n = u3(Z1(e, t.replace(/[\\-]/g, ""), r)), c = 0, u3(u3(t.replace(/\\/g, "")).replace(/[0#]/g, function(p) {
      return c < n.length ? n.charAt(c++) : p === "0" ? "0" : "";
    }));
  if (t.match(R6))
    return n = Z1(e, "##########", r), "(" + n.substr(0, 3) + ") " + n.substr(3, 3) + "-" + n.substr(6);
  var l = "";
  if (i = t.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))
    return c = Math.min(
      /*::String(*/
      i[4].length,
      7
    ), s = Fe(f, Math.pow(10, c) - 1, !1), n = "" + o, l = T2(
      "n",
      /*::String(*/
      i[1],
      s[1]
    ), l.charAt(l.length - 1) == " " && (l = l.substr(0, l.length - 1) + "0"), n += l + /*::String(*/
    i[2] + "/" + /*::String(*/
    i[3], l = Se(s[2], c), l.length < i[4].length && (l = M1(i[4].substr(i[4].length - l.length)) + l), n += l, n;
  if (i = t.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))
    return c = Math.min(Math.max(i[1].length, i[4].length), 7), s = Fe(f, Math.pow(10, c) - 1, !0), o + (s[0] || (s[1] ? "" : "0")) + " " + (s[1] ? B4(s[1], c) + i[2] + "/" + i[3] + Se(s[2], c) : P0(" ", 2 * c + 1 + i[2].length + i[3].length));
  if (i = t.match(/^[#0?]+$/))
    return n = s3(r, 0), t.length <= n.length ? n : M1(t.substr(0, t.length - n.length)) + n;
  if (i = t.match(/^([#0?]+)\.([#0]+)$/)) {
    n = "" + r.toFixed(Math.min(i[2].length, 10)).replace(/([^0])0+$/, "$1"), c = n.indexOf(".");
    var d = t.indexOf(".") - c, u = t.length - n.length - d;
    return M1(t.substr(0, d) + n + t.substr(t.length - u));
  }
  if (i = t.match(/^00,000\.([#0]*0)$/))
    return c = O5(r, i[1].length), r < 0 ? "-" + Z1(e, t, -r) : g2(X9(r)).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function(p) {
      return "00," + (p.length < 3 ? l2(0, 3 - p.length) : "") + p;
    }) + "." + l2(c, i[1].length);
  switch (t) {
    case "###,##0.00":
      return Z1(e, "#,##0.00", r);
    case "###,###":
    case "##,###":
    case "#,###":
      var h = g2(s3(f, 0));
      return h !== "0" ? o + h : "";
    case "###,###.00":
      return Z1(e, "###,##0.00", r).replace(/^0\./, ".");
    case "#,###.00":
      return Z1(e, "#,##0.00", r).replace(/^0\./, ".");
  }
  throw new Error("unsupported format |" + t + "|");
}
function K9(e, t, r) {
  for (var a = t.length - 1; t.charCodeAt(a - 1) === 44; )
    --a;
  return T2(e, t.substr(0, a), r / Math.pow(10, 3 * (t.length - a)));
}
function Y9(e, t, r) {
  var a = t.replace(y6, ""), n = t.length - a.length;
  return T2(e, a, r * Math.pow(10, 2 * n)) + P0("%", n);
}
function M6(e, t) {
  var r, a = e.indexOf("E") - e.indexOf(".") - 1;
  if (e.match(/^#+0.0E\+0$/)) {
    if (t == 0)
      return "0.0E+0";
    if (t < 0)
      return "-" + M6(e, -t);
    var n = e.indexOf(".");
    n === -1 && (n = e.indexOf("E"));
    var i = Math.floor(Math.log(t) * Math.LOG10E) % n;
    if (i < 0 && (i += n), r = (t / Math.pow(10, i)).toPrecision(a + 1 + (n + i) % n), !r.match(/[Ee]/)) {
      var c = Math.floor(Math.log(t) * Math.LOG10E);
      r.indexOf(".") === -1 ? r = r.charAt(0) + "." + r.substr(1) + "E+" + (c - r.length + i) : r += "E+" + (c - i), r = r.replace(/\+-/, "-");
    }
    r = r.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function(s, f, o, l) {
      return f + o + l.substr(0, (n + i) % n) + "." + l.substr(i) + "E";
    });
  } else
    r = t.toExponential(a);
  return e.match(/E\+00$/) && r.match(/e[+-]\d$/) && (r = r.substr(0, r.length - 1) + "0" + r.charAt(r.length - 1)), e.match(/E\-/) && r.match(/e\+/) && (r = r.replace(/e\+/, "e")), r.replace("e", "E");
}
function p2(e, t, r) {
  if (e.charCodeAt(0) === 40 && !t.match(O6)) {
    var a = t.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
    return r >= 0 ? p2("n", a, r) : "(" + p2("n", a, -r) + ")";
  }
  if (t.charCodeAt(t.length - 1) === 44)
    return K9(e, t, r);
  if (t.indexOf("%") !== -1)
    return Y9(e, t, r);
  if (t.indexOf("E") !== -1)
    return M6(t, r);
  if (t.charCodeAt(0) === 36)
    return "$" + p2(e, t.substr(t.charAt(1) == " " ? 2 : 1), r);
  var n, i, c, s, f = Math.abs(r), o = r < 0 ? "-" : "";
  if (t.match(/^00+$/))
    return o + l2(f, t.length);
  if (t.match(/^[#?]+$/))
    return n = "" + r, r === 0 && (n = ""), n.length > t.length ? n : M1(t.substr(0, t.length - n.length)) + n;
  if (i = t.match(b6))
    return z9(i, f, o);
  if (t.match(/^#+0+$/))
    return o + l2(f, t.length - t.indexOf("0"));
  if (i = t.match(D6))
    return n = ("" + r).replace(/^([^\.]+)$/, "$1." + M1(i[1])).replace(/\.$/, "." + M1(i[1])), n = n.replace(/\.(\d*)$/, function(p, v) {
      return "." + v + P0("0", M1(i[1]).length - v.length);
    }), t.indexOf("0.") !== -1 ? n : n.replace(/^0\./, ".");
  if (t = t.replace(/^#+([0.])/, "$1"), i = t.match(/^(0*)\.(#*)$/))
    return o + ("" + f).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, i[1].length ? "0." : ".");
  if (i = t.match(/^#{1,3},##0(\.?)$/))
    return o + g2("" + f);
  if (i = t.match(/^#,##0\.([#0]*0)$/))
    return r < 0 ? "-" + p2(e, t, -r) : g2("" + r) + "." + P0("0", i[1].length);
  if (i = t.match(/^#,#*,#0/))
    return p2(e, t.replace(/^#,#*,/, ""), r);
  if (i = t.match(/^([0#]+)(\\?-([0#]+))+$/))
    return n = u3(p2(e, t.replace(/[\\-]/g, ""), r)), c = 0, u3(u3(t.replace(/\\/g, "")).replace(/[0#]/g, function(p) {
      return c < n.length ? n.charAt(c++) : p === "0" ? "0" : "";
    }));
  if (t.match(R6))
    return n = p2(e, "##########", r), "(" + n.substr(0, 3) + ") " + n.substr(3, 3) + "-" + n.substr(6);
  var l = "";
  if (i = t.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))
    return c = Math.min(
      /*::String(*/
      i[4].length,
      7
    ), s = Fe(f, Math.pow(10, c) - 1, !1), n = "" + o, l = T2(
      "n",
      /*::String(*/
      i[1],
      s[1]
    ), l.charAt(l.length - 1) == " " && (l = l.substr(0, l.length - 1) + "0"), n += l + /*::String(*/
    i[2] + "/" + /*::String(*/
    i[3], l = Se(s[2], c), l.length < i[4].length && (l = M1(i[4].substr(i[4].length - l.length)) + l), n += l, n;
  if (i = t.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))
    return c = Math.min(Math.max(i[1].length, i[4].length), 7), s = Fe(f, Math.pow(10, c) - 1, !0), o + (s[0] || (s[1] ? "" : "0")) + " " + (s[1] ? B4(s[1], c) + i[2] + "/" + i[3] + Se(s[2], c) : P0(" ", 2 * c + 1 + i[2].length + i[3].length));
  if (i = t.match(/^[#0?]+$/))
    return n = "" + r, t.length <= n.length ? n : M1(t.substr(0, t.length - n.length)) + n;
  if (i = t.match(/^([#0]+)\.([#0]+)$/)) {
    n = "" + r.toFixed(Math.min(i[2].length, 10)).replace(/([^0])0+$/, "$1"), c = n.indexOf(".");
    var d = t.indexOf(".") - c, u = t.length - n.length - d;
    return M1(t.substr(0, d) + n + t.substr(t.length - u));
  }
  if (i = t.match(/^00,000\.([#0]*0)$/))
    return r < 0 ? "-" + p2(e, t, -r) : g2("" + r).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function(p) {
      return "00," + (p.length < 3 ? l2(0, 3 - p.length) : "") + p;
    }) + "." + l2(0, i[1].length);
  switch (t) {
    case "###,###":
    case "##,###":
    case "#,###":
      var h = g2("" + f);
      return h !== "0" ? o + h : "";
    default:
      if (t.match(/\.[0#?]*$/))
        return p2(e, t.slice(0, t.lastIndexOf(".")), r) + M1(t.slice(t.lastIndexOf(".")));
  }
  throw new Error("unsupported format |" + t + "|");
}
function T2(e, t, r) {
  return (r | 0) === r ? p2(e, t, r) : Z1(e, t, r);
}
function J9(e) {
  for (var t = [], r = !1, a = 0, n = 0; a < e.length; ++a)
    switch (
      /*cc=*/
      e.charCodeAt(a)
    ) {
      case 34:
        r = !r;
        break;
      case 95:
      case 42:
      case 92:
        ++a;
        break;
      case 59:
        t[t.length] = e.substr(n, a - n), n = a + 1;
    }
  if (t[t.length] = e.substr(n), r === !0)
    throw new Error("Format |" + e + "| unterminated string ");
  return t;
}
var N6 = /\[[HhMmSs\u0E0A\u0E19\u0E17]*\]/;
function u2(e) {
  for (var t = 0, r = "", a = ""; t < e.length; )
    switch (r = e.charAt(t)) {
      case "G":
        Ae(e, t) && (t += 6), t++;
        break;
      case '"':
        for (
          ;
          /*cc=*/
          e.charCodeAt(++t) !== 34 && t < e.length;
        )
          ;
        ++t;
        break;
      case "\\":
        t += 2;
        break;
      case "_":
        t += 2;
        break;
      case "@":
        ++t;
        break;
      case "B":
      case "b":
        if (e.charAt(t + 1) === "1" || e.charAt(t + 1) === "2")
          return !0;
      case "M":
      case "D":
      case "Y":
      case "H":
      case "S":
      case "E":
      case "m":
      case "d":
      case "y":
      case "h":
      case "s":
      case "e":
      case "g":
        return !0;
      case "A":
      case "a":
      case "上":
        if (e.substr(t, 3).toUpperCase() === "A/P" || e.substr(t, 5).toUpperCase() === "AM/PM" || e.substr(t, 5).toUpperCase() === "上午/下午")
          return !0;
        ++t;
        break;
      case "[":
        for (a = r; e.charAt(t++) !== "]" && t < e.length; )
          a += e.charAt(t);
        if (a.match(N6))
          return !0;
        break;
      case ".":
      case "0":
      case "#":
        for (; t < e.length && ("0#?.,E+-%".indexOf(r = e.charAt(++t)) > -1 || r == "\\" && e.charAt(t + 1) == "-" && "0#".indexOf(e.charAt(t + 2)) > -1); )
          ;
        break;
      case "?":
        for (; e.charAt(++t) === r; )
          ;
        break;
      case "*":
        ++t, (e.charAt(t) == " " || e.charAt(t) == "*") && ++t;
        break;
      case "(":
      case ")":
        ++t;
        break;
      case "1":
      case "2":
      case "3":
      case "4":
      case "5":
      case "6":
      case "7":
      case "8":
      case "9":
        for (; t < e.length && "0123456789".indexOf(e.charAt(++t)) > -1; )
          ;
        break;
      case " ":
        ++t;
        break;
      default:
        ++t;
        break;
    }
  return !1;
}
function q9(e, t, r, a) {
  for (var n = [], i = "", c = 0, s = "", f = "t", o, l, d, u = "H"; c < e.length; )
    switch (s = e.charAt(c)) {
      case "G":
        if (!Ae(e, c))
          throw new Error("unrecognized character " + s + " in " + e);
        n[n.length] = { t: "G", v: "General" }, c += 7;
        break;
      case '"':
        for (i = ""; (d = e.charCodeAt(++c)) !== 34 && c < e.length; )
          i += String.fromCharCode(d);
        n[n.length] = { t: "t", v: i }, ++c;
        break;
      case "\\":
        var h = e.charAt(++c), p = h === "(" || h === ")" ? h : "t";
        n[n.length] = { t: p, v: h }, ++c;
        break;
      case "_":
        n[n.length] = { t: "t", v: " " }, c += 2;
        break;
      case "@":
        n[n.length] = { t: "T", v: t }, ++c;
        break;
      case "B":
      case "b":
        if (e.charAt(c + 1) === "1" || e.charAt(c + 1) === "2") {
          if (o == null && (o = v2(t, r, e.charAt(c + 1) === "2"), o == null))
            return "";
          n[n.length] = { t: "X", v: e.substr(c, 2) }, f = s, c += 2;
          break;
        }
      case "M":
      case "D":
      case "Y":
      case "H":
      case "S":
      case "E":
        s = s.toLowerCase();
      case "m":
      case "d":
      case "y":
      case "h":
      case "s":
      case "e":
      case "g":
        if (t < 0 || o == null && (o = v2(t, r), o == null))
          return "";
        for (i = s; ++c < e.length && e.charAt(c).toLowerCase() === s; )
          i += s;
        s === "m" && f.toLowerCase() === "h" && (s = "M"), s === "h" && (s = u), n[n.length] = { t: s, v: i }, f = s;
        break;
      case "A":
      case "a":
      case "上":
        var v = { t: s, v: s };
        if (o == null && (o = v2(t, r)), e.substr(c, 3).toUpperCase() === "A/P" ? (o != null && (v.v = o.H >= 12 ? e.charAt(c + 2) : s), v.t = "T", u = "h", c += 3) : e.substr(c, 5).toUpperCase() === "AM/PM" ? (o != null && (v.v = o.H >= 12 ? "PM" : "AM"), v.t = "T", c += 5, u = "h") : e.substr(c, 5).toUpperCase() === "上午/下午" ? (o != null && (v.v = o.H >= 12 ? "下午" : "上午"), v.t = "T", c += 5, u = "h") : (v.t = "t", ++c), o == null && v.t === "T")
          return "";
        n[n.length] = v, f = s;
        break;
      case "[":
        for (i = s; e.charAt(c++) !== "]" && c < e.length; )
          i += e.charAt(c);
        if (i.slice(-1) !== "]")
          throw 'unterminated "[" block: |' + i + "|";
        if (i.match(N6)) {
          if (o == null && (o = v2(t, r), o == null))
            return "";
          n[n.length] = { t: "Z", v: i.toLowerCase() }, f = i.charAt(1);
        } else
          i.indexOf("$") > -1 && (i = (i.match(/\$([^-\[\]]*)/) || [])[1] || "$", u2(e) || (n[n.length] = { t: "t", v: i }));
        break;
      case ".":
        if (o != null) {
          for (i = s; ++c < e.length && (s = e.charAt(c)) === "0"; )
            i += s;
          n[n.length] = { t: "s", v: i };
          break;
        }
      case "0":
      case "#":
        for (i = s; ++c < e.length && "0#?.,E+-%".indexOf(s = e.charAt(c)) > -1; )
          i += s;
        n[n.length] = { t: "n", v: i };
        break;
      case "?":
        for (i = s; e.charAt(++c) === s; )
          i += s;
        n[n.length] = { t: s, v: i }, f = s;
        break;
      case "*":
        ++c, (e.charAt(c) == " " || e.charAt(c) == "*") && ++c;
        break;
      case "(":
      case ")":
        n[n.length] = { t: a === 1 ? "t" : s, v: s }, ++c;
        break;
      case "1":
      case "2":
      case "3":
      case "4":
      case "5":
      case "6":
      case "7":
      case "8":
      case "9":
        for (i = s; c < e.length && "0123456789".indexOf(e.charAt(++c)) > -1; )
          i += e.charAt(c);
        n[n.length] = { t: "D", v: i };
        break;
      case " ":
        n[n.length] = { t: s, v: s }, ++c;
        break;
      case "$":
        n[n.length] = { t: "t", v: "$" }, ++c;
        break;
      default:
        if (",$-+/():!^&'~{}<>=€acfijklopqrtuvwxzP".indexOf(s) === -1)
          throw new Error("unrecognized character " + s + " in " + e);
        n[n.length] = { t: "t", v: s }, ++c;
        break;
    }
  var x = 0, m = 0, T;
  for (c = n.length - 1, f = "t"; c >= 0; --c)
    switch (n[c].t) {
      case "h":
      case "H":
        n[c].t = u, f = "h", x < 1 && (x = 1);
        break;
      case "s":
        (T = n[c].v.match(/\.0+$/)) && (m = Math.max(m, T[0].length - 1), x = 4), x < 3 && (x = 3);
      case "d":
      case "y":
      case "e":
        f = n[c].t;
        break;
      case "M":
        f = n[c].t, x < 2 && (x = 2);
        break;
      case "m":
        f === "s" && (n[c].t = "M", x < 2 && (x = 2));
        break;
      case "X":
        break;
      case "Z":
        x < 1 && n[c].v.match(/[Hh]/) && (x = 1), x < 2 && n[c].v.match(/[Mm]/) && (x = 2), x < 3 && n[c].v.match(/[Ss]/) && (x = 3);
    }
  var g;
  switch (x) {
    case 0:
      break;
    case 1:
    case 2:
    case 3:
      o.u >= 0.5 && (o.u = 0, ++o.S), o.S >= 60 && (o.S = 0, ++o.M), o.M >= 60 && (o.M = 0, ++o.H), o.H >= 24 && (o.H = 0, ++o.D, g = v2(o.D), g.u = o.u, g.S = o.S, g.M = o.M, g.H = o.H, o = g);
      break;
    case 4:
      switch (m) {
        case 1:
          o.u = Math.round(o.u * 10) / 10;
          break;
        case 2:
          o.u = Math.round(o.u * 100) / 100;
          break;
        case 3:
          o.u = Math.round(o.u * 1e3) / 1e3;
          break;
      }
      o.u >= 1 && (o.u = 0, ++o.S), o.S >= 60 && (o.S = 0, ++o.M), o.M >= 60 && (o.M = 0, ++o.H), o.H >= 24 && (o.H = 0, ++o.D, g = v2(o.D), g.u = o.u, g.S = o.S, g.M = o.M, g.H = o.H, o = g);
      break;
  }
  var O = "", H;
  for (c = 0; c < n.length; ++c)
    switch (n[c].t) {
      case "t":
      case "T":
      case " ":
      case "D":
        break;
      case "X":
        n[c].v = "", n[c].t = ";";
        break;
      case "d":
      case "m":
      case "y":
      case "h":
      case "H":
      case "M":
      case "s":
      case "e":
      case "b":
      case "Z":
        n[c].v = W9(n[c].t.charCodeAt(0), n[c].v, o, m), n[c].t = "t";
        break;
      case "n":
      case "?":
        for (H = c + 1; n[H] != null && ((s = n[H].t) === "?" || s === "D" || (s === " " || s === "t") && n[H + 1] != null && (n[H + 1].t === "?" || n[H + 1].t === "t" && n[H + 1].v === "/") || n[c].t === "(" && (s === " " || s === "n" || s === ")") || s === "t" && (n[H].v === "/" || n[H].v === " " && n[H + 1] != null && n[H + 1].t == "?")); )
          n[c].v += n[H].v, n[H] = { v: "", t: ";" }, ++H;
        O += n[c].v, c = H - 1;
        break;
      case "G":
        n[c].t = "t", n[c].v = K2(t, r);
        break;
    }
  var W = "", E, b;
  if (O.length > 0) {
    O.charCodeAt(0) == 40 ? (E = t < 0 && O.charCodeAt(0) === 45 ? -t : t, b = T2("n", O, E)) : (E = t < 0 && a > 1 ? -t : t, b = T2("n", O, E), E < 0 && n[0] && n[0].t == "t" && (b = b.substr(1), n[0].v = "-" + n[0].v)), H = b.length - 1;
    var I = n.length;
    for (c = 0; c < n.length; ++c)
      if (n[c] != null && n[c].t != "t" && n[c].v.indexOf(".") > -1) {
        I = c;
        break;
      }
    var P = n.length;
    if (I === n.length && b.indexOf("E") === -1) {
      for (c = n.length - 1; c >= 0; --c)
        n[c] == null || "n?".indexOf(n[c].t) === -1 || (H >= n[c].v.length - 1 ? (H -= n[c].v.length, n[c].v = b.substr(H + 1, n[c].v.length)) : H < 0 ? n[c].v = "" : (n[c].v = b.substr(0, H + 1), H = -1), n[c].t = "t", P = c);
      H >= 0 && P < n.length && (n[P].v = b.substr(0, H + 1) + n[P].v);
    } else if (I !== n.length && b.indexOf("E") === -1) {
      for (H = b.indexOf(".") - 1, c = I; c >= 0; --c)
        if (!(n[c] == null || "n?".indexOf(n[c].t) === -1)) {
          for (l = n[c].v.indexOf(".") > -1 && c === I ? n[c].v.indexOf(".") - 1 : n[c].v.length - 1, W = n[c].v.substr(l + 1); l >= 0; --l)
            H >= 0 && (n[c].v.charAt(l) === "0" || n[c].v.charAt(l) === "#") && (W = b.charAt(H--) + W);
          n[c].v = W, n[c].t = "t", P = c;
        }
      for (H >= 0 && P < n.length && (n[P].v = b.substr(0, H + 1) + n[P].v), H = b.indexOf(".") + 1, c = I; c < n.length; ++c)
        if (!(n[c] == null || "n?(".indexOf(n[c].t) === -1 && c !== I)) {
          for (l = n[c].v.indexOf(".") > -1 && c === I ? n[c].v.indexOf(".") + 1 : 0, W = n[c].v.substr(0, l); l < n[c].v.length; ++l)
            H < b.length && (W += b.charAt(H++));
          n[c].v = W, n[c].t = "t", P = c;
        }
    }
  }
  for (c = 0; c < n.length; ++c)
    n[c] != null && "n?".indexOf(n[c].t) > -1 && (E = a > 1 && t < 0 && c > 0 && n[c - 1].v === "-" ? -t : t, n[c].v = T2(n[c].t, n[c].v, E), n[c].t = "t");
  var L = "";
  for (c = 0; c !== n.length; ++c)
    n[c] != null && (L += n[c].v);
  return L;
}
var R5 = /\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;
function M5(e, t) {
  if (t == null)
    return !1;
  var r = parseFloat(t[2]);
  switch (t[1]) {
    case "=":
      if (e == r)
        return !0;
      break;
    case ">":
      if (e > r)
        return !0;
      break;
    case "<":
      if (e < r)
        return !0;
      break;
    case "<>":
      if (e != r)
        return !0;
      break;
    case ">=":
      if (e >= r)
        return !0;
      break;
    case "<=":
      if (e <= r)
        return !0;
      break;
  }
  return !1;
}
function Z9(e, t) {
  var r = J9(e), a = r.length, n = r[a - 1].indexOf("@");
  if (a < 4 && n > -1 && --a, r.length > 4)
    throw new Error("cannot find right format for |" + r.join("|") + "|");
  if (typeof t != "number")
    return [4, r.length === 4 || n > -1 ? r[r.length - 1] : "@"];
  switch (r.length) {
    case 1:
      r = n > -1 ? ["General", "General", "General", r[0]] : [r[0], r[0], r[0], "@"];
      break;
    case 2:
      r = n > -1 ? [r[0], r[0], r[0], r[1]] : [r[0], r[1], r[0], "@"];
      break;
    case 3:
      r = n > -1 ? [r[0], r[1], r[0], r[2]] : [r[0], r[1], r[2], "@"];
      break;
  }
  var i = t > 0 ? r[0] : t < 0 ? r[1] : r[2];
  if (r[0].indexOf("[") === -1 && r[1].indexOf("[") === -1)
    return [a, i];
  if (r[0].match(/\[[=<>]/) != null || r[1].match(/\[[=<>]/) != null) {
    var c = r[0].match(R5), s = r[1].match(R5);
    return M5(t, c) ? [a, r[0]] : M5(t, s) ? [a, r[1]] : [a, r[c != null && s != null ? 2 : 1]];
  }
  return [a, i];
}
function X1(e, t, r) {
  r == null && (r = {});
  var a = "";
  switch (typeof e) {
    case "string":
      e == "m/d/yy" && r.dateNF ? a = r.dateNF : a = e;
      break;
    case "number":
      e == 14 && r.dateNF ? a = r.dateNF : a = (r.table != null ? r.table : k0)[e], a == null && (a = r.table && r.table[b5[e]] || k0[b5[e]]), a == null && (a = N9[e] || "General");
      break;
  }
  if (Ae(a, 0))
    return K2(t, r);
  t instanceof Date && (t = v1(t, r.date1904));
  var n = Z9(a, t);
  if (Ae(n[1]))
    return K2(t, r);
  if (t === !0)
    t = "TRUE";
  else if (t === !1)
    t = "FALSE";
  else if (t === "" || t == null)
    return "";
  return q9(n[1], t, r, n[0]);
}
function Q9(e, t) {
  if (typeof t != "number") {
    t = +t || -1;
    for (var r = 0; r < 392; ++r) {
      if (k0[r] == null) {
        t < 0 && (t = r);
        continue;
      }
      if (k0[r] == e) {
        t = r;
        break;
      }
    }
    t < 0 && (t = 391);
  }
  return k0[t] = e, t;
}
function P6() {
  k0 = M9();
}
var en = {
  5: '"$"#,##0_);\\("$"#,##0\\)',
  6: '"$"#,##0_);[Red]\\("$"#,##0\\)',
  7: '"$"#,##0.00_);\\("$"#,##0.00\\)',
  8: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
  23: "General",
  24: "General",
  25: "General",
  26: "General",
  27: "m/d/yy",
  28: "m/d/yy",
  29: "m/d/yy",
  30: "m/d/yy",
  31: "m/d/yy",
  32: "h:mm:ss",
  33: "h:mm:ss",
  34: "h:mm:ss",
  35: "h:mm:ss",
  36: "m/d/yy",
  41: '_(* #,##0_);_(* (#,##0);_(* "-"_);_(@_)',
  42: '_("$"* #,##0_);_("$"* (#,##0);_("$"* "-"_);_(@_)',
  43: '_(* #,##0.00_);_(* (#,##0.00);_(* "-"??_);_(@_)',
  44: '_("$"* #,##0.00_);_("$"* (#,##0.00);_("$"* "-"??_);_(@_)',
  50: "m/d/yy",
  51: "m/d/yy",
  52: "m/d/yy",
  53: "m/d/yy",
  54: "m/d/yy",
  55: "m/d/yy",
  56: "m/d/yy",
  57: "m/d/yy",
  58: "m/d/yy",
  59: "0",
  60: "0.00",
  61: "#,##0",
  62: "#,##0.00",
  63: '"$"#,##0_);\\("$"#,##0\\)',
  64: '"$"#,##0_);[Red]\\("$"#,##0\\)',
  65: '"$"#,##0.00_);\\("$"#,##0.00\\)',
  66: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
  67: "0%",
  68: "0.00%",
  69: "# ?/?",
  70: "# ??/??",
  71: "m/d/yy",
  72: "m/d/yy",
  73: "d-mmm-yy",
  74: "d-mmm",
  75: "mmm-yy",
  76: "h:mm",
  77: "h:mm:ss",
  78: "m/d/yy h:mm",
  79: "mm:ss",
  80: "[h]:mm:ss",
  81: "mmss.0"
}, ye = /[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;
function rn(e) {
  var t = typeof e == "number" ? k0[e] : e;
  return t = t.replace(ye, "(\\d+)"), ye.lastIndex = 0, new RegExp("^" + t + "$");
}
function tn(e, t, r) {
  var a = -1, n = -1, i = -1, c = -1, s = -1, f = -1;
  (t.match(ye) || []).forEach(function(d, u) {
    var h = parseInt(r[u + 1], 10);
    switch (d.toLowerCase().charAt(0)) {
      case "y":
        a = h;
        break;
      case "d":
        i = h;
        break;
      case "h":
        c = h;
        break;
      case "s":
        f = h;
        break;
      case "m":
        c >= 0 ? s = h : n = h;
        break;
    }
  }), ye.lastIndex = 0, f >= 0 && s == -1 && n >= 0 && (s = n, n = -1);
  var o = ("" + (a >= 0 ? a : (/* @__PURE__ */ new Date()).getFullYear())).slice(-4) + "-" + ("00" + (n >= 1 ? n : 1)).slice(-2) + "-" + ("00" + (i >= 1 ? i : 1)).slice(-2);
  o.length == 7 && (o = "0" + o), o.length == 8 && (o = "20" + o);
  var l = ("00" + (c >= 0 ? c : 0)).slice(-2) + ":" + ("00" + (s >= 0 ? s : 0)).slice(-2) + ":" + ("00" + (f >= 0 ? f : 0)).slice(-2);
  return c == -1 && s == -1 && f == -1 ? o : a == -1 && n == -1 && i == -1 ? l : o + "T" + l;
}
var an = {
  "d.m": "d\\.m"
  // Issue #2571 Google Sheets writes invalid format 'd.m', correct format is 'd"."m' or 'd\\.m'
};
function z2(e, t) {
  return Q9(an[e] || e, t);
}
var N5 = /* @__PURE__ */ function() {
  var e = {};
  e.version = "1.2.0";
  function t() {
    for (var E = 0, b = new Array(256), I = 0; I != 256; ++I)
      E = I, E = E & 1 ? -306674912 ^ E >>> 1 : E >>> 1, E = E & 1 ? -306674912 ^ E >>> 1 : E >>> 1, E = E & 1 ? -306674912 ^ E >>> 1 : E >>> 1, E = E & 1 ? -306674912 ^ E >>> 1 : E >>> 1, E = E & 1 ? -306674912 ^ E >>> 1 : E >>> 1, E = E & 1 ? -306674912 ^ E >>> 1 : E >>> 1, E = E & 1 ? -306674912 ^ E >>> 1 : E >>> 1, E = E & 1 ? -306674912 ^ E >>> 1 : E >>> 1, b[I] = E;
    return typeof Int32Array < "u" ? new Int32Array(b) : b;
  }
  var r = t();
  function a(E) {
    var b = 0, I = 0, P = 0, L = typeof Int32Array < "u" ? new Int32Array(4096) : new Array(4096);
    for (P = 0; P != 256; ++P)
      L[P] = E[P];
    for (P = 0; P != 256; ++P)
      for (I = E[P], b = 256 + P; b < 4096; b += 256)
        I = L[b] = I >>> 8 ^ E[I & 255];
    var z = [];
    for (P = 1; P != 16; ++P)
      z[P - 1] = typeof Int32Array < "u" && typeof L.subarray == "function" ? L.subarray(P * 256, P * 256 + 256) : L.slice(P * 256, P * 256 + 256);
    return z;
  }
  var n = a(r), i = n[0], c = n[1], s = n[2], f = n[3], o = n[4], l = n[5], d = n[6], u = n[7], h = n[8], p = n[9], v = n[10], x = n[11], m = n[12], T = n[13], g = n[14];
  function O(E, b) {
    for (var I = b ^ -1, P = 0, L = E.length; P < L; )
      I = I >>> 8 ^ r[(I ^ E.charCodeAt(P++)) & 255];
    return ~I;
  }
  function H(E, b) {
    for (var I = b ^ -1, P = E.length - 15, L = 0; L < P; )
      I = g[E[L++] ^ I & 255] ^ T[E[L++] ^ I >> 8 & 255] ^ m[E[L++] ^ I >> 16 & 255] ^ x[E[L++] ^ I >>> 24] ^ v[E[L++]] ^ p[E[L++]] ^ h[E[L++]] ^ u[E[L++]] ^ d[E[L++]] ^ l[E[L++]] ^ o[E[L++]] ^ f[E[L++]] ^ s[E[L++]] ^ c[E[L++]] ^ i[E[L++]] ^ r[E[L++]];
    for (P += 15; L < P; )
      I = I >>> 8 ^ r[(I ^ E[L++]) & 255];
    return ~I;
  }
  function W(E, b) {
    for (var I = b ^ -1, P = 0, L = E.length, z = 0, Y = 0; P < L; )
      z = E.charCodeAt(P++), z < 128 ? I = I >>> 8 ^ r[(I ^ z) & 255] : z < 2048 ? (I = I >>> 8 ^ r[(I ^ (192 | z >> 6 & 31)) & 255], I = I >>> 8 ^ r[(I ^ (128 | z & 63)) & 255]) : z >= 55296 && z < 57344 ? (z = (z & 1023) + 64, Y = E.charCodeAt(P++) & 1023, I = I >>> 8 ^ r[(I ^ (240 | z >> 8 & 7)) & 255], I = I >>> 8 ^ r[(I ^ (128 | z >> 2 & 63)) & 255], I = I >>> 8 ^ r[(I ^ (128 | Y >> 6 & 15 | (z & 3) << 4)) & 255], I = I >>> 8 ^ r[(I ^ (128 | Y & 63)) & 255]) : (I = I >>> 8 ^ r[(I ^ (224 | z >> 12 & 15)) & 255], I = I >>> 8 ^ r[(I ^ (128 | z >> 6 & 63)) & 255], I = I >>> 8 ^ r[(I ^ (128 | z & 63)) & 255]);
    return ~I;
  }
  return e.table = r, e.bstr = O, e.buf = H, e.str = W, e;
}(), L0 = /* @__PURE__ */ function() {
  var t = (
    /*::(*/
    {}
  );
  t.version = "1.2.2";
  function r(_, C) {
    for (var w = _.split("/"), k = C.split("/"), S = 0, y = 0, G = Math.min(w.length, k.length); S < G; ++S) {
      if (y = w[S].length - k[S].length)
        return y;
      if (w[S] != k[S])
        return w[S] < k[S] ? -1 : 1;
    }
    return w.length - k.length;
  }
  function a(_) {
    if (_.charAt(_.length - 1) == "/")
      return _.slice(0, -1).indexOf("/") === -1 ? _ : a(_.slice(0, -1));
    var C = _.lastIndexOf("/");
    return C === -1 ? _ : _.slice(0, C + 1);
  }
  function n(_) {
    if (_.charAt(_.length - 1) == "/")
      return n(_.slice(0, -1));
    var C = _.lastIndexOf("/");
    return C === -1 ? _ : _.slice(C + 1);
  }
  function i(_, C) {
    typeof C == "string" && (C = new Date(C));
    var w = C.getHours();
    w = w << 6 | C.getMinutes(), w = w << 5 | C.getSeconds() >>> 1, _.write_shift(2, w);
    var k = C.getFullYear() - 1980;
    k = k << 4 | C.getMonth() + 1, k = k << 5 | C.getDate(), _.write_shift(2, k);
  }
  function c(_) {
    var C = _.read_shift(2) & 65535, w = _.read_shift(2) & 65535, k = /* @__PURE__ */ new Date(), S = w & 31;
    w >>>= 5;
    var y = w & 15;
    w >>>= 4, k.setMilliseconds(0), k.setFullYear(w + 1980), k.setMonth(y - 1), k.setDate(S);
    var G = C & 31;
    C >>>= 5;
    var q = C & 63;
    return C >>>= 6, k.setHours(C), k.setMinutes(q), k.setSeconds(G << 1), k;
  }
  function s(_) {
    m1(_, 0);
    for (var C = (
      /*::(*/
      {}
    ), w = 0; _.l <= _.length - 4; ) {
      var k = _.read_shift(2), S = _.read_shift(2), y = _.l + S, G = {};
      switch (k) {
        case 21589:
          w = _.read_shift(1), w & 1 && (G.mtime = _.read_shift(4)), S > 5 && (w & 2 && (G.atime = _.read_shift(4)), w & 4 && (G.ctime = _.read_shift(4))), G.mtime && (G.mt = new Date(G.mtime * 1e3));
          break;
        case 1:
          {
            var q = _.read_shift(4), V = _.read_shift(4);
            G.usz = V * Math.pow(2, 32) + q, q = _.read_shift(4), V = _.read_shift(4), G.csz = V * Math.pow(2, 32) + q;
          }
          break;
      }
      _.l = y, C[k] = G;
    }
    return C;
  }
  var f;
  function o() {
    return f || (f = nn);
  }
  function l(_, C) {
    if (_[0] == 80 && _[1] == 75)
      return c5(_, C);
    if ((_[0] | 32) == 109 && (_[1] | 32) == 105)
      return S8(_, C);
    if (_.length < 512)
      throw new Error("CFB file size " + _.length + " < 512");
    var w = 3, k = 512, S = 0, y = 0, G = 0, q = 0, V = 0, X = [], j = (
      /*::(*/
      _.slice(0, 512)
    );
    m1(j, 0);
    var e0 = d(j);
    switch (w = e0[0], w) {
      case 3:
        k = 512;
        break;
      case 4:
        k = 4096;
        break;
      case 0:
        if (e0[1] == 0)
          return c5(_, C);
      default:
        throw new Error("Major Version: Expected 3 or 4 saw " + w);
    }
    k !== 512 && (j = /*::(*/
    _.slice(0, k), m1(
      j,
      28
      /* blob.l */
    ));
    var s0 = _.slice(0, k);
    u(j, w);
    var u0 = j.read_shift(4, "i");
    if (w === 3 && u0 !== 0)
      throw new Error("# Directory Sectors: Expected 0 saw " + u0);
    j.l += 4, G = j.read_shift(4, "i"), j.l += 4, j.chk("00100000", "Mini Stream Cutoff Size: "), q = j.read_shift(4, "i"), S = j.read_shift(4, "i"), V = j.read_shift(4, "i"), y = j.read_shift(4, "i");
    for (var t0 = -1, c0 = 0; c0 < 109 && (t0 = j.read_shift(4, "i"), !(t0 < 0)); ++c0)
      X[c0] = t0;
    var F0 = h(_, k);
    x(V, y, F0, k, X);
    var Z0 = T(F0, G, X, k);
    G < Z0.length && (Z0[G].name = "!Directory"), S > 0 && q !== Y && (Z0[q].name = "!MiniFAT"), Z0[X[0]].name = "!FAT", Z0.fat_addrs = X, Z0.ssz = k;
    var t1 = {}, C1 = [], w3 = [], k3 = [];
    g(G, Z0, F0, C1, S, t1, w3, q), p(w3, k3, C1), C1.shift();
    var C3 = {
      FileIndex: w3,
      FullPaths: k3
    };
    return C && C.raw && (C3.raw = { header: s0, sectors: F0 }), C3;
  }
  function d(_) {
    if (_[_.l] == 80 && _[_.l + 1] == 75)
      return [0, 0];
    _.chk(f0, "Header Signature: "), _.l += 16;
    var C = _.read_shift(2, "u");
    return [_.read_shift(2, "u"), C];
  }
  function u(_, C) {
    var w = 9;
    switch (_.l += 2, w = _.read_shift(2)) {
      case 9:
        if (C != 3)
          throw new Error("Sector Shift: Expected 9 saw " + w);
        break;
      case 12:
        if (C != 4)
          throw new Error("Sector Shift: Expected 12 saw " + w);
        break;
      default:
        throw new Error("Sector Shift: Expected 9 or 12 saw " + w);
    }
    _.chk("0600", "Mini Sector Shift: "), _.chk("000000000000", "Reserved: ");
  }
  function h(_, C) {
    for (var w = Math.ceil(_.length / C) - 1, k = [], S = 1; S < w; ++S)
      k[S - 1] = _.slice(S * C, (S + 1) * C);
    return k[w - 1] = _.slice(w * C), k;
  }
  function p(_, C, w) {
    for (var k = 0, S = 0, y = 0, G = 0, q = 0, V = w.length, X = [], j = []; k < V; ++k)
      X[k] = j[k] = k, C[k] = w[k];
    for (; q < j.length; ++q)
      k = j[q], S = _[k].L, y = _[k].R, G = _[k].C, X[k] === k && (S !== -1 && X[S] !== S && (X[k] = X[S]), y !== -1 && X[y] !== y && (X[k] = X[y])), G !== -1 && (X[G] = k), S !== -1 && k != X[k] && (X[S] = X[k], j.lastIndexOf(S) < q && j.push(S)), y !== -1 && k != X[k] && (X[y] = X[k], j.lastIndexOf(y) < q && j.push(y));
    for (k = 1; k < V; ++k)
      X[k] === k && (y !== -1 && X[y] !== y ? X[k] = X[y] : S !== -1 && X[S] !== S && (X[k] = X[S]));
    for (k = 1; k < V; ++k)
      if (_[k].type !== 0) {
        if (q = k, q != X[q])
          do
            q = X[q], C[k] = C[q] + "/" + C[k];
          while (q !== 0 && X[q] !== -1 && q != X[q]);
        X[k] = -1;
      }
    for (C[0] += "/", k = 1; k < V; ++k)
      _[k].type !== 2 && (C[k] += "/");
  }
  function v(_, C, w) {
    for (var k = _.start, S = _.size, y = [], G = k; w && S > 0 && G >= 0; )
      y.push(C.slice(G * z, G * z + z)), S -= z, G = j2(w, G * 4);
    return y.length === 0 ? p1(0) : b2(y).slice(0, _.size);
  }
  function x(_, C, w, k, S) {
    var y = Y;
    if (_ === Y) {
      if (C !== 0)
        throw new Error("DIFAT chain shorter than expected");
    } else if (_ !== -1) {
      var G = w[_], q = (k >>> 2) - 1;
      if (!G)
        return;
      for (var V = 0; V < q && (y = j2(G, V * 4)) !== Y; ++V)
        S.push(y);
      C >= 1 && x(j2(G, k - 4), C - 1, w, k, S);
    }
  }
  function m(_, C, w, k, S) {
    var y = [], G = [];
    S || (S = []);
    var q = k - 1, V = 0, X = 0;
    for (V = C; V >= 0; ) {
      S[V] = !0, y[y.length] = V, G.push(_[V]);
      var j = w[Math.floor(V * 4 / k)];
      if (X = V * 4 & q, k < 4 + X)
        throw new Error("FAT boundary crossed: " + V + " 4 " + k);
      if (!_[j])
        break;
      V = j2(_[j], X);
    }
    return { nodes: y, data: G5([G]) };
  }
  function T(_, C, w, k) {
    var S = _.length, y = [], G = [], q = [], V = [], X = k - 1, j = 0, e0 = 0, s0 = 0, u0 = 0;
    for (j = 0; j < S; ++j)
      if (q = [], s0 = j + C, s0 >= S && (s0 -= S), !G[s0]) {
        V = [];
        var t0 = [];
        for (e0 = s0; e0 >= 0; ) {
          t0[e0] = !0, G[e0] = !0, q[q.length] = e0, V.push(_[e0]);
          var c0 = w[Math.floor(e0 * 4 / k)];
          if (u0 = e0 * 4 & X, k < 4 + u0)
            throw new Error("FAT boundary crossed: " + e0 + " 4 " + k);
          if (!_[c0] || (e0 = j2(_[c0], u0), t0[e0]))
            break;
        }
        y[s0] = { nodes: q, data: G5([V]) };
      }
    return y;
  }
  function g(_, C, w, k, S, y, G, q) {
    for (var V = 0, X = k.length ? 2 : 0, j = C[_].data, e0 = 0, s0 = 0, u0; e0 < j.length; e0 += 128) {
      var t0 = (
        /*::(*/
        j.slice(e0, e0 + 128)
      );
      m1(t0, 64), s0 = t0.read_shift(2), u0 = V4(t0, 0, s0 - X), k.push(u0);
      var c0 = {
        name: u0,
        type: t0.read_shift(1),
        color: t0.read_shift(1),
        L: t0.read_shift(4, "i"),
        R: t0.read_shift(4, "i"),
        C: t0.read_shift(4, "i"),
        clsid: t0.read_shift(16),
        state: t0.read_shift(4, "i"),
        start: 0,
        size: 0
      }, F0 = t0.read_shift(2) + t0.read_shift(2) + t0.read_shift(2) + t0.read_shift(2);
      F0 !== 0 && (c0.ct = O(t0, t0.l - 8));
      var Z0 = t0.read_shift(2) + t0.read_shift(2) + t0.read_shift(2) + t0.read_shift(2);
      Z0 !== 0 && (c0.mt = O(t0, t0.l - 8)), c0.start = t0.read_shift(4, "i"), c0.size = t0.read_shift(4, "i"), c0.size < 0 && c0.start < 0 && (c0.size = c0.type = 0, c0.start = Y, c0.name = ""), c0.type === 5 ? (V = c0.start, S > 0 && V !== Y && (C[V].name = "!StreamData")) : c0.size >= 4096 ? (c0.storage = "fat", C[c0.start] === void 0 && (C[c0.start] = m(w, c0.start, C.fat_addrs, C.ssz)), C[c0.start].name = c0.name, c0.content = C[c0.start].data.slice(0, c0.size)) : (c0.storage = "minifat", c0.size < 0 ? c0.size = 0 : V !== Y && c0.start !== Y && C[V] && (c0.content = v(c0, C[V].data, (C[q] || {}).data))), c0.content && m1(c0.content, 0), y[u0] = c0, G.push(c0);
    }
  }
  function O(_, C) {
    return new Date((j1(_, C + 4) / 1e7 * Math.pow(2, 32) + j1(_, C) / 1e7 - 11644473600) * 1e3);
  }
  function H(_, C) {
    return o(), l(f.readFileSync(_), C);
  }
  function W(_, C) {
    var w = C && C.type;
    switch (w || O0 && Buffer.isBuffer(_) && (w = "buffer"), w || "base64") {
      case "file":
        return H(_, C);
      case "base64":
        return l(G1($1(_)), C);
      case "binary":
        return l(G1(_), C);
    }
    return l(
      /*::typeof blob == 'string' ? new Buffer(blob, 'utf-8') : */
      _,
      C
    );
  }
  function E(_, C) {
    var w = C || {}, k = w.root || "Root Entry";
    if (_.FullPaths || (_.FullPaths = []), _.FileIndex || (_.FileIndex = []), _.FullPaths.length !== _.FileIndex.length)
      throw new Error("inconsistent CFB structure");
    _.FullPaths.length === 0 && (_.FullPaths[0] = k + "/", _.FileIndex[0] = { name: k, type: 5 }), w.CLSID && (_.FileIndex[0].clsid = w.CLSID), b(_);
  }
  function b(_) {
    var C = "Sh33tJ5";
    if (!L0.find(_, "/" + C)) {
      var w = p1(4);
      w[0] = 55, w[1] = w[3] = 50, w[2] = 54, _.FileIndex.push({ name: C, type: 2, content: w, size: 4, L: 69, R: 69, C: 69 }), _.FullPaths.push(_.FullPaths[0] + C), I(_);
    }
  }
  function I(_, C) {
    E(_);
    for (var w = !1, k = !1, S = _.FullPaths.length - 1; S >= 0; --S) {
      var y = _.FileIndex[S];
      switch (y.type) {
        case 0:
          k ? w = !0 : (_.FileIndex.pop(), _.FullPaths.pop());
          break;
        case 1:
        case 2:
        case 5:
          k = !0, isNaN(y.R * y.L * y.C) && (w = !0), y.R > -1 && y.L > -1 && y.R == y.L && (w = !0);
          break;
        default:
          w = !0;
          break;
      }
    }
    if (!(!w && !C)) {
      var G = new Date(1987, 1, 19), q = 0, V = Object.create ? /* @__PURE__ */ Object.create(null) : {}, X = [];
      for (S = 0; S < _.FullPaths.length; ++S)
        V[_.FullPaths[S]] = !0, _.FileIndex[S].type !== 0 && X.push([_.FullPaths[S], _.FileIndex[S]]);
      for (S = 0; S < X.length; ++S) {
        var j = a(X[S][0]);
        for (k = V[j]; !k; ) {
          for (; a(j) && !V[a(j)]; )
            j = a(j);
          X.push([j, {
            name: n(j).replace("/", ""),
            type: 1,
            clsid: p0,
            ct: G,
            mt: G,
            content: null
          }]), V[j] = !0, j = a(X[S][0]), k = V[j];
        }
      }
      for (X.sort(function(u0, t0) {
        return r(u0[0], t0[0]);
      }), _.FullPaths = [], _.FileIndex = [], S = 0; S < X.length; ++S)
        _.FullPaths[S] = X[S][0], _.FileIndex[S] = X[S][1];
      for (S = 0; S < X.length; ++S) {
        var e0 = _.FileIndex[S], s0 = _.FullPaths[S];
        if (e0.name = n(s0).replace("/", ""), e0.L = e0.R = e0.C = -(e0.color = 1), e0.size = e0.content ? e0.content.length : 0, e0.start = 0, e0.clsid = e0.clsid || p0, S === 0)
          e0.C = X.length > 1 ? 1 : -1, e0.size = 0, e0.type = 5;
        else if (s0.slice(-1) == "/") {
          for (q = S + 1; q < X.length && a(_.FullPaths[q]) != s0; ++q)
            ;
          for (e0.C = q >= X.length ? -1 : q, q = S + 1; q < X.length && a(_.FullPaths[q]) != a(s0); ++q)
            ;
          e0.R = q >= X.length ? -1 : q, e0.type = 1;
        } else
          a(_.FullPaths[S + 1] || "") == a(s0) && (e0.R = S + 1), e0.type = 2;
      }
    }
  }
  function P(_, C) {
    var w = C || {};
    if (w.fileType == "mad")
      return A8(_, w);
    switch (I(_), w.fileType) {
      case "zip":
        return _8(_, w);
    }
    var k = function(u0) {
      for (var t0 = 0, c0 = 0, F0 = 0; F0 < u0.FileIndex.length; ++F0) {
        var Z0 = u0.FileIndex[F0];
        if (Z0.content) {
          var t1 = Z0.content.length;
          t1 > 0 && (t1 < 4096 ? t0 += t1 + 63 >> 6 : c0 += t1 + 511 >> 9);
        }
      }
      for (var C1 = u0.FullPaths.length + 3 >> 2, w3 = t0 + 7 >> 3, k3 = t0 + 127 >> 7, C3 = w3 + c0 + C1 + k3, H2 = C3 + 127 >> 7, e4 = H2 <= 109 ? 0 : Math.ceil((H2 - 109) / 127); C3 + H2 + e4 + 127 >> 7 > H2; )
        e4 = ++H2 <= 109 ? 0 : Math.ceil((H2 - 109) / 127);
      var m2 = [1, e4, H2, k3, C1, c0, t0, 0];
      return u0.FileIndex[0].size = t0 << 6, m2[7] = (u0.FileIndex[0].start = m2[0] + m2[1] + m2[2] + m2[3] + m2[4] + m2[5]) + (m2[6] + 7 >> 3), m2;
    }(_), S = p1(k[7] << 9), y = 0, G = 0;
    {
      for (y = 0; y < 8; ++y)
        S.write_shift(1, i0[y]);
      for (y = 0; y < 8; ++y)
        S.write_shift(2, 0);
      for (S.write_shift(2, 62), S.write_shift(2, 3), S.write_shift(2, 65534), S.write_shift(2, 9), S.write_shift(2, 6), y = 0; y < 3; ++y)
        S.write_shift(2, 0);
      for (S.write_shift(4, 0), S.write_shift(4, k[2]), S.write_shift(4, k[0] + k[1] + k[2] + k[3] - 1), S.write_shift(4, 0), S.write_shift(4, 4096), S.write_shift(4, k[3] ? k[0] + k[1] + k[2] - 1 : Y), S.write_shift(4, k[3]), S.write_shift(-4, k[1] ? k[0] - 1 : Y), S.write_shift(4, k[1]), y = 0; y < 109; ++y)
        S.write_shift(-4, y < k[2] ? k[1] + y : -1);
    }
    if (k[1])
      for (G = 0; G < k[1]; ++G) {
        for (; y < 236 + G * 127; ++y)
          S.write_shift(-4, y < k[2] ? k[1] + y : -1);
        S.write_shift(-4, G === k[1] - 1 ? Y : G + 1);
      }
    var q = function(u0) {
      for (G += u0; y < G - 1; ++y)
        S.write_shift(-4, y + 1);
      u0 && (++y, S.write_shift(-4, Y));
    };
    for (G = y = 0, G += k[1]; y < G; ++y)
      S.write_shift(-4, n0.DIFSECT);
    for (G += k[2]; y < G; ++y)
      S.write_shift(-4, n0.FATSECT);
    q(k[3]), q(k[4]);
    for (var V = 0, X = 0, j = _.FileIndex[0]; V < _.FileIndex.length; ++V)
      j = _.FileIndex[V], j.content && (X = j.content.length, !(X < 4096) && (j.start = G, q(X + 511 >> 9)));
    for (q(k[6] + 7 >> 3); S.l & 511; )
      S.write_shift(-4, n0.ENDOFCHAIN);
    for (G = y = 0, V = 0; V < _.FileIndex.length; ++V)
      j = _.FileIndex[V], j.content && (X = j.content.length, !(!X || X >= 4096) && (j.start = G, q(X + 63 >> 6)));
    for (; S.l & 511; )
      S.write_shift(-4, n0.ENDOFCHAIN);
    for (y = 0; y < k[4] << 2; ++y) {
      var e0 = _.FullPaths[y];
      if (!e0 || e0.length === 0) {
        for (V = 0; V < 17; ++V)
          S.write_shift(4, 0);
        for (V = 0; V < 3; ++V)
          S.write_shift(4, -1);
        for (V = 0; V < 12; ++V)
          S.write_shift(4, 0);
        continue;
      }
      j = _.FileIndex[y], y === 0 && (j.start = j.size ? j.start - 1 : Y);
      var s0 = y === 0 && w.root || j.name;
      if (s0.length > 32 && (console.error("Name " + s0 + " will be truncated to " + s0.slice(0, 32)), s0 = s0.slice(0, 32)), X = 2 * (s0.length + 1), S.write_shift(64, s0, "utf16le"), S.write_shift(2, X), S.write_shift(1, j.type), S.write_shift(1, j.color), S.write_shift(-4, j.L), S.write_shift(-4, j.R), S.write_shift(-4, j.C), j.clsid)
        S.write_shift(16, j.clsid, "hex");
      else
        for (V = 0; V < 4; ++V)
          S.write_shift(4, 0);
      S.write_shift(4, j.state || 0), S.write_shift(4, 0), S.write_shift(4, 0), S.write_shift(4, 0), S.write_shift(4, 0), S.write_shift(4, j.start), S.write_shift(4, j.size), S.write_shift(4, 0);
    }
    for (y = 1; y < _.FileIndex.length; ++y)
      if (j = _.FileIndex[y], j.size >= 4096)
        if (S.l = j.start + 1 << 9, O0 && Buffer.isBuffer(j.content))
          j.content.copy(S, S.l, 0, j.size), S.l += j.size + 511 & -512;
        else {
          for (V = 0; V < j.size; ++V)
            S.write_shift(1, j.content[V]);
          for (; V & 511; ++V)
            S.write_shift(1, 0);
        }
    for (y = 1; y < _.FileIndex.length; ++y)
      if (j = _.FileIndex[y], j.size > 0 && j.size < 4096)
        if (O0 && Buffer.isBuffer(j.content))
          j.content.copy(S, S.l, 0, j.size), S.l += j.size + 63 & -64;
        else {
          for (V = 0; V < j.size; ++V)
            S.write_shift(1, j.content[V]);
          for (; V & 63; ++V)
            S.write_shift(1, 0);
        }
    if (O0)
      S.l = S.length;
    else
      for (; S.l < S.length; )
        S.write_shift(1, 0);
    return S;
  }
  function L(_, C) {
    var w = _.FullPaths.map(function(V) {
      return V.toUpperCase();
    }), k = w.map(function(V) {
      var X = V.split("/");
      return X[X.length - (V.slice(-1) == "/" ? 2 : 1)];
    }), S = !1;
    C.charCodeAt(0) === 47 ? (S = !0, C = w[0].slice(0, -1) + C) : S = C.indexOf("/") !== -1;
    var y = C.toUpperCase(), G = S === !0 ? w.indexOf(y) : k.indexOf(y);
    if (G !== -1)
      return _.FileIndex[G];
    var q = !y.match(I3);
    for (y = y.replace(L1, ""), q && (y = y.replace(I3, "!")), G = 0; G < w.length; ++G)
      if ((q ? w[G].replace(I3, "!") : w[G]).replace(L1, "") == y || (q ? k[G].replace(I3, "!") : k[G]).replace(L1, "") == y)
        return _.FileIndex[G];
    return null;
  }
  var z = 64, Y = -2, f0 = "d0cf11e0a1b11ae1", i0 = [208, 207, 17, 224, 161, 177, 26, 225], p0 = "00000000000000000000000000000000", n0 = {
    /* 2.1 Compund File Sector Numbers and Types */
    MAXREGSECT: -6,
    DIFSECT: -4,
    FATSECT: -3,
    ENDOFCHAIN: Y,
    FREESECT: -1,
    /* 2.2 Compound File Header */
    HEADER_SIGNATURE: f0,
    HEADER_MINOR_VERSION: "3e00",
    MAXREGSID: -6,
    NOSTREAM: -1,
    HEADER_CLSID: p0,
    /* 2.6.1 Compound File Directory Entry */
    EntryTypes: ["unknown", "storage", "stream", "lockbytes", "property", "root"]
  };
  function v0(_, C, w) {
    o();
    var k = P(_, w);
    f.writeFileSync(C, k);
  }
  function I0(_) {
    for (var C = new Array(_.length), w = 0; w < _.length; ++w)
      C[w] = String.fromCharCode(_[w]);
    return C.join("");
  }
  function K(_, C) {
    var w = P(_, C);
    switch (C && C.type || "buffer") {
      case "file":
        return o(), f.writeFileSync(C.filename, w), w;
      case "binary":
        return typeof w == "string" ? w : I0(w);
      case "base64":
        return A5(typeof w == "string" ? w : I0(w));
      case "buffer":
        if (O0)
          return Buffer.isBuffer(w) ? w : L2(w);
      case "array":
        return typeof w == "string" ? G1(w) : w;
    }
    return w;
  }
  var T0;
  function S0(_) {
    try {
      var C = _.InflateRaw, w = new C();
      if (w._processChunk(new Uint8Array([3, 0]), w._finishFlushFlag), w.bytesRead)
        T0 = _;
      else
        throw new Error("zlib does not expose bytesRead");
    } catch (k) {
      console.error("cannot use native zlib: " + (k.message || k));
    }
  }
  function w0(_, C) {
    if (!T0)
      return i5(_, C);
    var w = T0.InflateRaw, k = new w(), S = k._processChunk(_.slice(_.l), k._finishFlushFlag);
    return _.l += k.bytesRead, S;
  }
  function r0(_) {
    return T0 ? T0.deflateRawSync(_) : B1(_);
  }
  var E0 = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], b0 = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258], D0 = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577];
  function F(_) {
    var C = (_ << 1 | _ << 11) & 139536 | (_ << 5 | _ << 15) & 558144;
    return (C >> 16 | C >> 8 | C) & 255;
  }
  for (var B = typeof Uint8Array < "u", R = B ? new Uint8Array(256) : [], D = 0; D < 256; ++D)
    R[D] = F(D);
  function Z(_, C) {
    var w = R[_ & 255];
    return C <= 8 ? w >>> 8 - C : (w = w << 8 | R[_ >> 8 & 255], C <= 16 ? w >>> 16 - C : (w = w << 8 | R[_ >> 16 & 255], w >>> 24 - C));
  }
  function A(_, C) {
    var w = C & 7, k = C >>> 3;
    return (_[k] | (w <= 6 ? 0 : _[k + 1] << 8)) >>> w & 3;
  }
  function Q(_, C) {
    var w = C & 7, k = C >>> 3;
    return (_[k] | (w <= 5 ? 0 : _[k + 1] << 8)) >>> w & 7;
  }
  function m0(_, C) {
    var w = C & 7, k = C >>> 3;
    return (_[k] | (w <= 4 ? 0 : _[k + 1] << 8)) >>> w & 15;
  }
  function a0(_, C) {
    var w = C & 7, k = C >>> 3;
    return (_[k] | (w <= 3 ? 0 : _[k + 1] << 8)) >>> w & 31;
  }
  function g0(_, C) {
    var w = C & 7, k = C >>> 3;
    return (_[k] | (w <= 1 ? 0 : _[k + 1] << 8)) >>> w & 127;
  }
  function _0(_, C, w) {
    var k = C & 7, S = C >>> 3, y = (1 << w) - 1, G = _[S] >>> k;
    return w < 8 - k || (G |= _[S + 1] << 8 - k, w < 16 - k) || (G |= _[S + 2] << 16 - k, w < 24 - k) || (G |= _[S + 3] << 24 - k), G & y;
  }
  function A0(_, C, w) {
    var k = C & 7, S = C >>> 3;
    return k <= 5 ? _[S] |= (w & 7) << k : (_[S] |= w << k & 255, _[S + 1] = (w & 7) >> 8 - k), C + 3;
  }
  function V0(_, C, w) {
    var k = C & 7, S = C >>> 3;
    return w = (w & 1) << k, _[S] |= w, C + 1;
  }
  function J0(_, C, w) {
    var k = C & 7, S = C >>> 3;
    return w <<= k, _[S] |= w & 255, w >>>= 8, _[S + 1] = w, C + 8;
  }
  function s1(_, C, w) {
    var k = C & 7, S = C >>> 3;
    return w <<= k, _[S] |= w & 255, w >>>= 8, _[S + 1] = w & 255, _[S + 2] = w >>> 8, C + 16;
  }
  function d0(_, C) {
    var w = _.length, k = 2 * w > C ? 2 * w : C + 5, S = 0;
    if (w >= C)
      return _;
    if (O0) {
      var y = F5(k);
      if (_.copy)
        _.copy(y);
      else
        for (; S < _.length; ++S)
          y[S] = _[S];
      return y;
    } else if (B) {
      var G = new Uint8Array(k);
      if (G.set)
        G.set(_);
      else
        for (; S < w; ++S)
          G[S] = _[S];
      return G;
    }
    return _.length = k, _;
  }
  function N0(_) {
    for (var C = new Array(_), w = 0; w < _; ++w)
      C[w] = 0;
    return C;
  }
  function o0(_, C, w) {
    var k = 1, S = 0, y = 0, G = 0, q = 0, V = _.length, X = B ? new Uint16Array(32) : N0(32);
    for (y = 0; y < 32; ++y)
      X[y] = 0;
    for (y = V; y < w; ++y)
      _[y] = 0;
    V = _.length;
    var j = B ? new Uint16Array(V) : N0(V);
    for (y = 0; y < V; ++y)
      X[S = _[y]]++, k < S && (k = S), j[y] = 0;
    for (X[0] = 0, y = 1; y <= k; ++y)
      X[y + 16] = q = q + X[y - 1] << 1;
    for (y = 0; y < V; ++y)
      q = _[y], q != 0 && (j[y] = X[q + 16]++);
    var e0 = 0;
    for (y = 0; y < V; ++y)
      if (e0 = _[y], e0 != 0)
        for (q = Z(j[y], k) >> k - e0, G = (1 << k + 4 - e0) - 1; G >= 0; --G)
          C[q | G << e0] = e0 & 15 | y << 4;
    return k;
  }
  var W1 = B ? new Uint16Array(512) : N0(512), D1 = B ? new Uint16Array(32) : N0(32);
  if (!B) {
    for (var q0 = 0; q0 < 512; ++q0)
      W1[q0] = 0;
    for (q0 = 0; q0 < 32; ++q0)
      D1[q0] = 0;
  }
  (function() {
    for (var _ = [], C = 0; C < 32; C++)
      _.push(5);
    o0(_, D1, 32);
    var w = [];
    for (C = 0; C <= 143; C++)
      w.push(8);
    for (; C <= 255; C++)
      w.push(9);
    for (; C <= 279; C++)
      w.push(7);
    for (; C <= 287; C++)
      w.push(8);
    o0(w, W1, 288);
  })();
  var i2 = /* @__PURE__ */ function() {
    for (var C = B ? new Uint8Array(32768) : [], w = 0, k = 0; w < D0.length - 1; ++w)
      for (; k < D0[w + 1]; ++k)
        C[k] = w;
    for (; k < 32768; ++k)
      C[k] = 29;
    var S = B ? new Uint8Array(259) : [];
    for (w = 0, k = 0; w < b0.length - 1; ++w)
      for (; k < b0[w + 1]; ++k)
        S[k] = w;
    function y(q, V) {
      for (var X = 0; X < q.length; ) {
        var j = Math.min(65535, q.length - X), e0 = X + j == q.length;
        for (V.write_shift(1, +e0), V.write_shift(2, j), V.write_shift(2, ~j & 65535); j-- > 0; )
          V[V.l++] = q[X++];
      }
      return V.l;
    }
    function G(q, V) {
      for (var X = 0, j = 0, e0 = B ? new Uint16Array(32768) : []; j < q.length; ) {
        var s0 = (
          /* data.length - boff; */
          Math.min(65535, q.length - j)
        );
        if (s0 < 10) {
          for (X = A0(V, X, +(j + s0 == q.length)), X & 7 && (X += 8 - (X & 7)), V.l = X / 8 | 0, V.write_shift(2, s0), V.write_shift(2, ~s0 & 65535); s0-- > 0; )
            V[V.l++] = q[j++];
          X = V.l * 8;
          continue;
        }
        X = A0(V, X, +(j + s0 == q.length) + 2);
        for (var u0 = 0; s0-- > 0; ) {
          var t0 = q[j];
          u0 = (u0 << 5 ^ t0) & 32767;
          var c0 = -1, F0 = 0;
          if ((c0 = e0[u0]) && (c0 |= j & -32768, c0 > j && (c0 -= 32768), c0 < j))
            for (; q[c0 + F0] == q[j + F0] && F0 < 250; )
              ++F0;
          if (F0 > 2) {
            t0 = S[F0], t0 <= 22 ? X = J0(V, X, R[t0 + 1] >> 1) - 1 : (J0(V, X, 3), X += 5, J0(V, X, R[t0 - 23] >> 5), X += 3);
            var Z0 = t0 < 8 ? 0 : t0 - 4 >> 2;
            Z0 > 0 && (s1(V, X, F0 - b0[t0]), X += Z0), t0 = C[j - c0], X = J0(V, X, R[t0] >> 3), X -= 3;
            var t1 = t0 < 4 ? 0 : t0 - 2 >> 1;
            t1 > 0 && (s1(V, X, j - c0 - D0[t0]), X += t1);
            for (var C1 = 0; C1 < F0; ++C1)
              e0[u0] = j & 32767, u0 = (u0 << 5 ^ q[j]) & 32767, ++j;
            s0 -= F0 - 1;
          } else
            t0 <= 143 ? t0 = t0 + 48 : X = V0(V, X, 1), X = J0(V, X, R[t0]), e0[u0] = j & 32767, ++j;
        }
        X = J0(V, X, 0) - 1;
      }
      return V.l = (X + 7) / 8 | 0, V.l;
    }
    return function(V, X) {
      return V.length < 8 ? y(V, X) : G(V, X);
    };
  }();
  function B1(_) {
    var C = p1(50 + Math.floor(_.length * 1.1)), w = i2(_, C);
    return C.slice(0, w);
  }
  var h0 = B ? new Uint16Array(32768) : N0(32768), B0 = B ? new Uint16Array(32768) : N0(32768), T1 = B ? new Uint16Array(128) : N0(128), c1 = 1, U1 = 1;
  function U2(_, C) {
    var w = a0(_, C) + 257;
    C += 5;
    var k = a0(_, C) + 1;
    C += 5;
    var S = m0(_, C) + 4;
    C += 4;
    for (var y = 0, G = B ? new Uint8Array(19) : N0(19), q = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], V = 1, X = B ? new Uint8Array(8) : N0(8), j = B ? new Uint8Array(8) : N0(8), e0 = G.length, s0 = 0; s0 < S; ++s0)
      G[E0[s0]] = y = Q(_, C), V < y && (V = y), X[y]++, C += 3;
    var u0 = 0;
    for (X[0] = 0, s0 = 1; s0 <= V; ++s0)
      j[s0] = u0 = u0 + X[s0 - 1] << 1;
    for (s0 = 0; s0 < e0; ++s0)
      (u0 = G[s0]) != 0 && (q[s0] = j[u0]++);
    var t0 = 0;
    for (s0 = 0; s0 < e0; ++s0)
      if (t0 = G[s0], t0 != 0) {
        u0 = R[q[s0]] >> 8 - t0;
        for (var c0 = (1 << 7 - t0) - 1; c0 >= 0; --c0)
          T1[u0 | c0 << t0] = t0 & 7 | s0 << 3;
      }
    var F0 = [];
    for (V = 1; F0.length < w + k; )
      switch (u0 = T1[g0(_, C)], C += u0 & 7, u0 >>>= 3) {
        case 16:
          for (y = 3 + A(_, C), C += 2, u0 = F0[F0.length - 1]; y-- > 0; )
            F0.push(u0);
          break;
        case 17:
          for (y = 3 + Q(_, C), C += 3; y-- > 0; )
            F0.push(0);
          break;
        case 18:
          for (y = 11 + g0(_, C), C += 7; y-- > 0; )
            F0.push(0);
          break;
        default:
          F0.push(u0), V < u0 && (V = u0);
          break;
      }
    var Z0 = F0.slice(0, w), t1 = F0.slice(w);
    for (s0 = w; s0 < 286; ++s0)
      Z0[s0] = 0;
    for (s0 = k; s0 < 30; ++s0)
      t1[s0] = 0;
    return c1 = o0(Z0, h0, 286), U1 = o0(t1, B0, 30), C;
  }
  function ce(_, C) {
    if (_[0] == 3 && !(_[1] & 3))
      return [R2(C), 2];
    for (var w = 0, k = 0, S = F5(C || 1 << 18), y = 0, G = S.length >>> 0, q = 0, V = 0; !(k & 1); ) {
      if (k = Q(_, w), w += 3, k >>> 1)
        k >> 1 == 1 ? (q = 9, V = 5) : (w = U2(_, w), q = c1, V = U1);
      else {
        w & 7 && (w += 8 - (w & 7));
        var X = _[w >>> 3] | _[(w >>> 3) + 1] << 8;
        if (w += 32, X > 0)
          for (!C && G < y + X && (S = d0(S, y + X), G = S.length); X-- > 0; )
            S[y++] = _[w >>> 3], w += 8;
        continue;
      }
      for (; ; ) {
        !C && G < y + 32767 && (S = d0(S, y + 32767), G = S.length);
        var j = _0(_, w, q), e0 = k >>> 1 == 1 ? W1[j] : h0[j];
        if (w += e0 & 15, e0 >>>= 4, !(e0 >>> 8 & 255))
          S[y++] = e0;
        else {
          if (e0 == 256)
            break;
          e0 -= 257;
          var s0 = e0 < 8 ? 0 : e0 - 4 >> 2;
          s0 > 5 && (s0 = 0);
          var u0 = y + b0[e0];
          s0 > 0 && (u0 += _0(_, w, s0), w += s0), j = _0(_, w, V), e0 = k >>> 1 == 1 ? D1[j] : B0[j], w += e0 & 15, e0 >>>= 4;
          var t0 = e0 < 4 ? 0 : e0 - 2 >> 1, c0 = D0[e0];
          for (t0 > 0 && (c0 += _0(_, w, t0), w += t0), !C && G < u0 && (S = d0(S, u0 + 100), G = S.length); y < u0; )
            S[y] = S[y - c0], ++y;
        }
      }
    }
    return C ? [S, w + 7 >>> 3] : [S.slice(0, y), w + 7 >>> 3];
  }
  function i5(_, C) {
    var w = _.slice(_.l || 0), k = ce(w, C);
    return _.l += k[1], k[0];
  }
  function s5(_, C) {
    if (_)
      typeof console < "u" && console.error(C);
    else
      throw new Error(C);
  }
  function c5(_, C) {
    var w = (
      /*::(*/
      _
    );
    m1(w, 0);
    var k = [], S = [], y = {
      FileIndex: k,
      FullPaths: S
    };
    E(y, { root: C.root });
    for (var G = w.length - 4; (w[G] != 80 || w[G + 1] != 75 || w[G + 2] != 5 || w[G + 3] != 6) && G >= 0; )
      --G;
    w.l = G + 4, w.l += 4;
    var q = w.read_shift(2);
    w.l += 6;
    var V = w.read_shift(4);
    for (w.l = V, G = 0; G < q; ++G) {
      w.l += 20;
      var X = w.read_shift(4), j = w.read_shift(4), e0 = w.read_shift(2), s0 = w.read_shift(2), u0 = w.read_shift(2);
      w.l += 8;
      var t0 = w.read_shift(4), c0 = s(
        /*::(*/
        w.slice(w.l + e0, w.l + e0 + s0)
        /*:: :any)*/
      );
      w.l += e0 + s0 + u0;
      var F0 = w.l;
      w.l = t0 + 4, c0 && c0[1] && ((c0[1] || {}).usz && (j = c0[1].usz), (c0[1] || {}).csz && (X = c0[1].csz)), g8(w, X, j, y, c0), w.l = F0;
    }
    return y;
  }
  function g8(_, C, w, k, S) {
    _.l += 2;
    var y = _.read_shift(2), G = _.read_shift(2), q = c(_);
    if (y & 8257)
      throw new Error("Unsupported ZIP encryption");
    for (var V = _.read_shift(4), X = _.read_shift(4), j = _.read_shift(4), e0 = _.read_shift(2), s0 = _.read_shift(2), u0 = "", t0 = 0; t0 < e0; ++t0)
      u0 += String.fromCharCode(_[_.l++]);
    if (s0) {
      var c0 = s(
        /*::(*/
        _.slice(_.l, _.l + s0)
        /*:: :any)*/
      );
      (c0[21589] || {}).mt && (q = c0[21589].mt), (c0[1] || {}).usz && (j = c0[1].usz), (c0[1] || {}).csz && (X = c0[1].csz), S && ((S[21589] || {}).mt && (q = S[21589].mt), (S[1] || {}).usz && (j = c0[1].usz), (S[1] || {}).csz && (X = c0[1].csz));
    }
    _.l += s0;
    var F0 = _.slice(_.l, _.l + X);
    switch (G) {
      case 8:
        F0 = w0(_, j);
        break;
      case 0:
        break;
      default:
        throw new Error("Unsupported ZIP Compression method " + G);
    }
    var Z0 = !1;
    y & 8 && (V = _.read_shift(4), V == 134695760 && (V = _.read_shift(4), Z0 = !0), X = _.read_shift(4), j = _.read_shift(4)), X != C && s5(Z0, "Bad compressed size: " + C + " != " + X), j != w && s5(Z0, "Bad uncompressed size: " + w + " != " + j), Qe(k, u0, F0, { unsafe: !0, mt: q });
  }
  function _8(_, C) {
    var w = C || {}, k = [], S = [], y = p1(1), G = w.compression ? 8 : 0, q = 0, V = 0, X = 0, j = 0, e0 = 0, s0 = _.FullPaths[0], u0 = s0, t0 = _.FileIndex[0], c0 = [], F0 = 0;
    for (V = 1; V < _.FullPaths.length; ++V)
      if (u0 = _.FullPaths[V].slice(s0.length), t0 = _.FileIndex[V], !(!t0.size || !t0.content || u0 == "Sh33tJ5")) {
        var Z0 = j, t1 = p1(u0.length);
        for (X = 0; X < u0.length; ++X)
          t1.write_shift(1, u0.charCodeAt(X) & 127);
        t1 = t1.slice(0, t1.l), c0[e0] = typeof t0.content == "string" ? N5.bstr(t0.content, 0) : N5.buf(
          /*::((*/
          t0.content,
          0
        );
        var C1 = typeof t0.content == "string" ? G1(t0.content) : t0.content;
        G == 8 && (C1 = r0(C1)), y = p1(30), y.write_shift(4, 67324752), y.write_shift(2, 20), y.write_shift(2, q), y.write_shift(2, G), t0.mt ? i(y, t0.mt) : y.write_shift(4, 0), y.write_shift(-4, c0[e0]), y.write_shift(4, C1.length), y.write_shift(
          4,
          /*::(*/
          t0.content.length
        ), y.write_shift(2, t1.length), y.write_shift(2, 0), j += y.length, k.push(y), j += t1.length, k.push(t1), j += C1.length, k.push(C1), y = p1(46), y.write_shift(4, 33639248), y.write_shift(2, 0), y.write_shift(2, 20), y.write_shift(2, q), y.write_shift(2, G), y.write_shift(4, 0), y.write_shift(-4, c0[e0]), y.write_shift(4, C1.length), y.write_shift(
          4,
          /*::(*/
          t0.content.length
        ), y.write_shift(2, t1.length), y.write_shift(2, 0), y.write_shift(2, 0), y.write_shift(2, 0), y.write_shift(2, 0), y.write_shift(4, 0), y.write_shift(4, Z0), F0 += y.l, S.push(y), F0 += t1.length, S.push(t1), ++e0;
      }
    return y = p1(22), y.write_shift(4, 101010256), y.write_shift(2, 0), y.write_shift(2, 0), y.write_shift(2, e0), y.write_shift(2, e0), y.write_shift(4, F0), y.write_shift(4, j), y.write_shift(2, 0), b2([b2(k), b2(S), y]);
  }
  var fe = {
    htm: "text/html",
    xml: "text/xml",
    gif: "image/gif",
    jpg: "image/jpeg",
    png: "image/png",
    mso: "application/x-mso",
    thmx: "application/vnd.ms-officetheme",
    sh33tj5: "application/octet-stream"
  };
  function T8(_, C) {
    if (_.ctype)
      return _.ctype;
    var w = _.name || "", k = w.match(/\.([^\.]+)$/);
    return k && fe[k[1]] || C && (k = (w = C).match(/[\.\\]([^\.\\])+$/), k && fe[k[1]]) ? fe[k[1]] : "application/octet-stream";
  }
  function E8(_) {
    for (var C = A5(_), w = [], k = 0; k < C.length; k += 76)
      w.push(C.slice(k, k + 76));
    return w.join(`\r
`) + `\r
`;
  }
  function w8(_) {
    var C = _.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF=]/g, function(X) {
      var j = X.charCodeAt(0).toString(16).toUpperCase();
      return "=" + (j.length == 1 ? "0" + j : j);
    });
    C = C.replace(/ $/mg, "=20").replace(/\t$/mg, "=09"), C.charAt(0) == `
` && (C = "=0D" + C.slice(1)), C = C.replace(/\r(?!\n)/mg, "=0D").replace(/\n\n/mg, `
=0A`).replace(/([^\r\n])\n/mg, "$1=0A");
    for (var w = [], k = C.split(`\r
`), S = 0; S < k.length; ++S) {
      var y = k[S];
      if (y.length == 0) {
        w.push("");
        continue;
      }
      for (var G = 0; G < y.length; ) {
        var q = 76, V = y.slice(G, G + q);
        V.charAt(q - 1) == "=" ? q-- : V.charAt(q - 2) == "=" ? q -= 2 : V.charAt(q - 3) == "=" && (q -= 3), V = y.slice(G, G + q), G += q, G < y.length && (V += "="), w.push(V);
      }
    }
    return w.join(`\r
`);
  }
  function k8(_) {
    for (var C = [], w = 0; w < _.length; ++w) {
      for (var k = _[w]; w <= _.length && k.charAt(k.length - 1) == "="; )
        k = k.slice(0, k.length - 1) + _[++w];
      C.push(k);
    }
    for (var S = 0; S < C.length; ++S)
      C[S] = C[S].replace(/[=][0-9A-Fa-f]{2}/g, function(y) {
        return String.fromCharCode(parseInt(y.slice(1), 16));
      });
    return G1(C.join(`\r
`));
  }
  function C8(_, C, w) {
    for (var k = "", S = "", y = "", G, q = 0; q < 10; ++q) {
      var V = C[q];
      if (!V || V.match(/^\s*$/))
        break;
      var X = V.match(/^(.*?):\s*([^\s].*)$/);
      if (X)
        switch (X[1].toLowerCase()) {
          case "content-location":
            k = X[2].trim();
            break;
          case "content-type":
            y = X[2].trim();
            break;
          case "content-transfer-encoding":
            S = X[2].trim();
            break;
        }
    }
    switch (++q, S.toLowerCase()) {
      case "base64":
        G = G1($1(C.slice(q).join("")));
        break;
      case "quoted-printable":
        G = k8(C.slice(q));
        break;
      default:
        throw new Error("Unsupported Content-Transfer-Encoding " + S);
    }
    var j = Qe(_, k.slice(w.length), G, { unsafe: !0 });
    y && (j.ctype = y);
  }
  function S8(_, C) {
    if (I0(_.slice(0, 13)).toLowerCase() != "mime-version:")
      throw new Error("Unsupported MAD header");
    var w = C && C.root || "", k = (O0 && Buffer.isBuffer(_) ? _.toString("binary") : I0(_)).split(`\r
`), S = 0, y = "";
    for (S = 0; S < k.length; ++S)
      if (y = k[S], !!/^Content-Location:/i.test(y) && (y = y.slice(y.indexOf("file")), w || (w = y.slice(0, y.lastIndexOf("/") + 1)), y.slice(0, w.length) != w))
        for (; w.length > 0 && (w = w.slice(0, w.length - 1), w = w.slice(0, w.lastIndexOf("/") + 1), y.slice(0, w.length) != w); )
          ;
    var G = (k[1] || "").match(/boundary="(.*?)"/);
    if (!G)
      throw new Error("MAD cannot find boundary");
    var q = "--" + (G[1] || ""), V = [], X = [], j = {
      FileIndex: V,
      FullPaths: X
    };
    E(j);
    var e0, s0 = 0;
    for (S = 0; S < k.length; ++S) {
      var u0 = k[S];
      u0 !== q && u0 !== q + "--" || (s0++ && C8(j, k.slice(e0, S), w), e0 = S);
    }
    return j;
  }
  function A8(_, C) {
    var w = C || {}, k = w.boundary || "SheetJS";
    k = "------=" + k;
    for (var S = [
      "MIME-Version: 1.0",
      'Content-Type: multipart/related; boundary="' + k.slice(2) + '"',
      "",
      "",
      ""
    ], y = _.FullPaths[0], G = y, q = _.FileIndex[0], V = 1; V < _.FullPaths.length; ++V)
      if (G = _.FullPaths[V].slice(y.length), q = _.FileIndex[V], !(!q.size || !q.content || G == "Sh33tJ5")) {
        G = G.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF]/g, function(F0) {
          return "_x" + F0.charCodeAt(0).toString(16) + "_";
        }).replace(/[\u0080-\uFFFF]/g, function(F0) {
          return "_u" + F0.charCodeAt(0).toString(16) + "_";
        });
        for (var X = q.content, j = O0 && Buffer.isBuffer(X) ? X.toString("binary") : I0(X), e0 = 0, s0 = Math.min(1024, j.length), u0 = 0, t0 = 0; t0 <= s0; ++t0)
          (u0 = j.charCodeAt(t0)) >= 32 && u0 < 128 && ++e0;
        var c0 = e0 >= s0 * 4 / 5;
        S.push(k), S.push("Content-Location: " + (w.root || "file:///C:/SheetJS/") + G), S.push("Content-Transfer-Encoding: " + (c0 ? "quoted-printable" : "base64")), S.push("Content-Type: " + T8(q, G)), S.push(""), S.push(c0 ? w8(j) : E8(j));
      }
    return S.push(k + `--\r
`), S.join(`\r
`);
  }
  function F8(_) {
    var C = {};
    return E(C, _), C;
  }
  function Qe(_, C, w, k) {
    var S = k && k.unsafe;
    S || E(_);
    var y = !S && L0.find(_, C);
    if (!y) {
      var G = _.FullPaths[0];
      C.slice(0, G.length) == G ? G = C : (G.slice(-1) != "/" && (G += "/"), G = (G + C).replace("//", "/")), y = { name: n(C), type: 2 }, _.FileIndex.push(y), _.FullPaths.push(G), S || L0.utils.cfb_gc(_);
    }
    return y.content = w, y.size = w ? w.length : 0, k && (k.CLSID && (y.clsid = k.CLSID), k.mt && (y.mt = k.mt), k.ct && (y.ct = k.ct)), y;
  }
  function y8(_, C) {
    E(_);
    var w = L0.find(_, C);
    if (w) {
      for (var k = 0; k < _.FileIndex.length; ++k)
        if (_.FileIndex[k] == w)
          return _.FileIndex.splice(k, 1), _.FullPaths.splice(k, 1), !0;
    }
    return !1;
  }
  function I8(_, C, w) {
    E(_);
    var k = L0.find(_, C);
    if (k) {
      for (var S = 0; S < _.FileIndex.length; ++S)
        if (_.FileIndex[S] == k)
          return _.FileIndex[S].name = n(w), _.FullPaths[S] = w, !0;
    }
    return !1;
  }
  function b8(_) {
    I(_, !0);
  }
  return t.find = L, t.read = W, t.parse = l, t.write = K, t.writeFile = v0, t.utils = {
    cfb_new: F8,
    cfb_add: Qe,
    cfb_del: y8,
    cfb_mov: I8,
    cfb_gc: b8,
    ReadShift: R3,
    CheckField: n7,
    prep_blob: m1,
    bconcat: b2,
    use_zlib: S0,
    _deflateRaw: B1,
    _inflateRaw: i5,
    consts: n0
  }, t;
}(), nn;
function sn(e) {
  if (typeof Deno < "u")
    return Deno.readFileSync(e);
  if (typeof $ < "u" && typeof File < "u" && typeof Folder < "u")
    try {
      var t = File(e);
      t.open("r"), t.encoding = "binary";
      var r = t.read();
      return t.close(), r;
    } catch (a) {
      if (!a.message || !a.message.match(/onstruct/))
        throw a;
    }
  throw new Error("Cannot access file " + e);
}
function t2(e) {
  for (var t = Object.keys(e), r = [], a = 0; a < t.length; ++a)
    Object.prototype.hasOwnProperty.call(e, t[a]) && r.push(t[a]);
  return r;
}
function H4(e) {
  for (var t = [], r = t2(e), a = 0; a !== r.length; ++a)
    t[e[r[a]]] = r[a];
  return t;
}
var L6 = /* @__PURE__ */ Date.UTC(1899, 11, 30, 0, 0, 0), cn = /* @__PURE__ */ Date.UTC(1899, 11, 31, 0, 0, 0), fn = /* @__PURE__ */ Date.UTC(1904, 0, 1, 0, 0, 0);
function v1(e, t) {
  var r = /* @__PURE__ */ e.getTime(), a = (r - L6) / (24 * 60 * 60 * 1e3);
  return t ? (a -= 1462, a < -1402 ? a - 1 : a) : a < 60 ? a - 1 : a;
}
function O2(e) {
  if (e >= 60 && e < 61)
    return e;
  var t = /* @__PURE__ */ new Date();
  return t.setTime((e > 60 ? e : e + 1) * 24 * 60 * 60 * 1e3 + L6), t;
}
function on(e) {
  var t = 0, r = 0, a = !1, n = e.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);
  if (!n)
    throw new Error("|" + e + "| is not an ISO8601 Duration");
  for (var i = 1; i != n.length; ++i)
    if (n[i]) {
      switch (r = 1, i > 3 && (a = !0), n[i].slice(n[i].length - 1)) {
        case "Y":
          throw new Error("Unsupported ISO Duration Field: " + n[i].slice(n[i].length - 1));
        case "D":
          r *= 24;
        case "H":
          r *= 60;
        case "M":
          if (a)
            r *= 60;
          else
            throw new Error("Unsupported ISO Duration Field: M");
      }
      t += r * parseInt(n[i], 10);
    }
  return t;
}
var ln = /^(\d+):(\d+)(:\d+)?(\.\d+)?$/, hn = /^(\d+)-(\d+)-(\d+)$/, B6 = /^(\d+)-(\d+)-(\d+)[T ](\d+):(\d+)(:\d+)?(\.\d+)?$/;
function w1(e, t) {
  if (e instanceof Date)
    return e;
  var r = e.match(ln);
  if (r)
    return new Date((t ? fn : cn) + ((parseInt(r[1], 10) * 60 + parseInt(r[2], 10)) * 60 + (r[3] ? parseInt(r[3].slice(1), 10) : 0)) * 1e3 + (r[4] ? parseInt((r[4] + "000").slice(1, 4), 10) : 0));
  if (r = e.match(hn), r)
    return new Date(Date.UTC(+r[1], +r[2] - 1, +r[3], 0, 0, 0, 0));
  if (r = e.match(B6), r)
    return new Date(Date.UTC(+r[1], +r[2] - 1, +r[3], +r[4], +r[5], r[6] && parseInt(r[6].slice(1), 10) || 0, r[7] && parseInt(r[7].slice(1), 10) || 0));
  var a = new Date(e);
  return a;
}
function Y2(e, t) {
  if (O0 && Buffer.isBuffer(e)) {
    if (t && j3) {
      if (e[0] == 255 && e[1] == 254)
        return b3(e.slice(2).toString("utf16le"));
      if (e[1] == 254 && e[2] == 255)
        return b3(F6(e.slice(2).toString("binary")));
    }
    return e.toString("binary");
  }
  if (typeof TextDecoder < "u")
    try {
      if (t) {
        if (e[0] == 255 && e[1] == 254)
          return b3(new TextDecoder("utf-16le").decode(e.slice(2)));
        if (e[0] == 254 && e[1] == 255)
          return b3(new TextDecoder("utf-16be").decode(e.slice(2)));
      }
      var r = {
        "€": "",
        "‚": "",
        ƒ: "",
        "„": "",
        "…": "",
        "†": "",
        "‡": "",
        "ˆ": "",
        "‰": "",
        Š: "",
        "‹": "",
        Œ: "",
        Ž: "",
        "‘": "",
        "’": "",
        "“": "",
        "”": "",
        "•": "",
        "–": "",
        "—": "",
        "˜": "",
        "™": "",
        š: "",
        "›": "",
        œ: "",
        ž: "",
        Ÿ: ""
      };
      return Array.isArray(e) && (e = new Uint8Array(e)), new TextDecoder("latin1").decode(e).replace(/[€‚ƒ„…†‡ˆ‰Š‹ŒŽ‘’“”•–—˜™š›œžŸ]/g, function(i) {
        return r[i] || i;
      });
    } catch {
    }
  var a = [], n = 0;
  try {
    for (n = 0; n < e.length - 65536; n += 65536)
      a.push(String.fromCharCode.apply(0, e.slice(n, n + 65536)));
    a.push(String.fromCharCode.apply(0, e.slice(n)));
  } catch {
    try {
      for (; n < e.length - 16384; n += 16384)
        a.push(String.fromCharCode.apply(0, e.slice(n, n + 16384)));
      a.push(String.fromCharCode.apply(0, e.slice(n)));
    } catch {
      for (; n != e.length; ++n)
        a.push(String.fromCharCode(e[n]));
    }
  }
  return a.join("");
}
function x1(e) {
  if (typeof JSON < "u" && !Array.isArray(e))
    return JSON.parse(JSON.stringify(e));
  if (typeof e != "object" || e == null)
    return e;
  if (e instanceof Date)
    return new Date(e.getTime());
  var t = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && (t[r] = x1(e[r]));
  return t;
}
function P0(e, t) {
  for (var r = ""; r.length < t; )
    r += e;
  return r;
}
function z1(e) {
  var t = Number(e);
  if (!isNaN(t))
    return isFinite(t) ? t : NaN;
  if (!/\d/.test(e))
    return t;
  var r = 1, a = e.replace(/([\d]),([\d])/g, "$1$2").replace(/[$]/g, "").replace(/[%]/g, function() {
    return r *= 100, "";
  });
  return !isNaN(t = Number(a)) || (a = a.replace(/[(](.*)[)]/, function(n, i) {
    return r = -r, i;
  }), !isNaN(t = Number(a))) ? t / r : t;
}
var un = /^(0?\d|1[0-2])(?:|:([0-5]?\d)(?:|(\.\d+)(?:|:([0-5]?\d))|:([0-5]?\d)(|\.\d+)))\s+([ap])m?$/, xn = /^([01]?\d|2[0-3])(?:|:([0-5]?\d)(?:|(\.\d+)(?:|:([0-5]?\d))|:([0-5]?\d)(|\.\d+)))$/, dn = /^(\d+)-(\d+)-(\d+)[T ](\d+):(\d+)(:\d+)(\.\d+)?[Z]?$/, pn = (/* @__PURE__ */ new Date("6/9/69 00:00 UTC")).valueOf() == -177984e5;
function mn(e) {
  return e[2] ? e[3] ? e[4] ? new Date(Date.UTC(1899, 11, 31, +e[1] % 12 + (e[7] == "p" ? 12 : 0), +e[2], +e[4], parseFloat(e[3]) * 1e3)) : new Date(Date.UTC(1899, 11, 31, e[7] == "p" ? 12 : 0, +e[1], +e[2], parseFloat(e[3]) * 1e3)) : e[5] ? new Date(Date.UTC(1899, 11, 31, +e[1] % 12 + (e[7] == "p" ? 12 : 0), +e[2], +e[5], e[6] ? parseFloat(e[6]) * 1e3 : 0)) : new Date(Date.UTC(1899, 11, 31, +e[1] % 12 + (e[7] == "p" ? 12 : 0), +e[2], 0, 0)) : new Date(Date.UTC(1899, 11, 31, +e[1] % 12 + (e[7] == "p" ? 12 : 0), 0, 0, 0));
}
function vn(e) {
  return e[2] ? e[3] ? e[4] ? new Date(Date.UTC(1899, 11, 31, +e[1], +e[2], +e[4], parseFloat(e[3]) * 1e3)) : new Date(Date.UTC(1899, 11, 31, 0, +e[1], +e[2], parseFloat(e[3]) * 1e3)) : e[5] ? new Date(Date.UTC(1899, 11, 31, +e[1], +e[2], +e[5], e[6] ? parseFloat(e[6]) * 1e3 : 0)) : new Date(Date.UTC(1899, 11, 31, +e[1], +e[2], 0, 0)) : new Date(Date.UTC(1899, 11, 31, +e[1], 0, 0, 0));
}
var gn = ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"];
function $3(e) {
  if (dn.test(e))
    return e.indexOf("Z") == -1 ? $e(new Date(e)) : new Date(e);
  var t = e.toLowerCase(), r = t.replace(/\s+/g, " ").trim(), a = r.match(un);
  if (a)
    return mn(a);
  if (a = r.match(xn), a)
    return vn(a);
  if (a = r.match(B6), a)
    return new Date(Date.UTC(+a[1], +a[2] - 1, +a[3], +a[4], +a[5], a[6] && parseInt(a[6].slice(1), 10) || 0, a[7] && parseInt(a[7].slice(1), 10) || 0));
  var n = new Date(pn && e.indexOf("UTC") == -1 ? e + " UTC" : e), i = /* @__PURE__ */ new Date(NaN), c = n.getYear();
  n.getMonth();
  var s = n.getDate();
  if (isNaN(s))
    return i;
  if (t.match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/)) {
    if (t = t.replace(/[^a-z]/g, "").replace(/([^a-z]|^)[ap]m?([^a-z]|$)/, ""), t.length > 3 && gn.indexOf(t) == -1)
      return i;
  } else if (t.replace(/[ap]m?/, "").match(/[a-z]/))
    return i;
  return c < 0 || c > 8099 || e.match(/[^-0-9:,\/\\\ ]/) ? i : n;
}
var _n = /* @__PURE__ */ function() {
  var e = "abacaba".split(/(:?b)/i).length == 5;
  return function(r, a, n) {
    if (e || typeof a == "string")
      return r.split(a);
    for (var i = r.split(a), c = [i[0]], s = 1; s < i.length; ++s)
      c.push(n), c.push(i[s]);
    return c;
  };
}();
function J2(e) {
  return new Date(e.getUTCFullYear(), e.getUTCMonth(), e.getUTCDate(), e.getUTCHours(), e.getUTCMinutes(), e.getUTCSeconds(), e.getUTCMilliseconds());
}
function $e(e) {
  return new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
}
function U6(e) {
  return e ? e.content && e.type ? Y2(e.content, !0) : e.data ? y3(e.data) : e.asNodeBuffer && O0 ? y3(e.asNodeBuffer().toString("binary")) : e.asBinary ? y3(e.asBinary()) : e._data && e._data.getContent ? y3(Y2(Array.prototype.slice.call(e._data.getContent(), 0))) : null : null;
}
function H6(e) {
  if (!e)
    return null;
  if (e.data)
    return C5(e.data);
  if (e.asNodeBuffer && O0)
    return e.asNodeBuffer();
  if (e._data && e._data.getContent) {
    var t = e._data.getContent();
    return typeof t == "string" ? C5(t) : Array.prototype.slice.call(t);
  }
  return e.content && e.type ? e.content : null;
}
function Tn(e) {
  return e && e.name.slice(-4) === ".bin" ? H6(e) : U6(e);
}
function Q1(e, t) {
  for (var r = e.FullPaths || t2(e.files), a = t.toLowerCase().replace(/[\/]/g, "\\"), n = a.replace(/\\/g, "/"), i = 0; i < r.length; ++i) {
    var c = r[i].replace(/^Root Entry[\/]/, "").toLowerCase();
    if (a == c || n == c)
      return e.files ? e.files[r[i]] : e.FileIndex[i];
  }
  return null;
}
function W4(e, t) {
  var r = Q1(e, t);
  if (r == null)
    throw new Error("Cannot find file " + t + " in zip");
  return r;
}
function h1(e, t, r) {
  if (!r)
    return Tn(W4(e, t));
  if (!t)
    return null;
  try {
    return h1(e, t);
  } catch {
    return null;
  }
}
function P1(e, t, r) {
  if (!r)
    return U6(W4(e, t));
  if (!t)
    return null;
  try {
    return P1(e, t);
  } catch {
    return null;
  }
}
function En(e, t, r) {
  return H6(W4(e, t));
}
function P5(e) {
  for (var t = e.FullPaths || t2(e.files), r = [], a = 0; a < t.length; ++a)
    t[a].slice(-1) != "/" && r.push(t[a].replace(/^Root Entry[\/]/, ""));
  return r.sort();
}
function wn(e, t, r) {
  if (e.FullPaths) {
    if (typeof r == "string") {
      var a;
      return O0 ? a = L2(r) : a = D9(r), L0.utils.cfb_add(e, t, a);
    }
    L0.utils.cfb_add(e, t, r);
  } else
    e.file(t, r);
}
function W6(e, t) {
  switch (t.type) {
    case "base64":
      return L0.read(e, { type: "base64" });
    case "binary":
      return L0.read(e, { type: "binary" });
    case "buffer":
    case "array":
      return L0.read(e, { type: "buffer" });
  }
  throw new Error("Unrecognized type " + t.type);
}
function o3(e, t) {
  if (e.charAt(0) == "/")
    return e.slice(1);
  var r = t.split("/");
  t.slice(-1) != "/" && r.pop();
  for (var a = e.split("/"); a.length !== 0; ) {
    var n = a.shift();
    n === ".." ? r.pop() : n !== "." && r.push(n);
  }
  return r.join("/");
}
var V6 = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r
`, kn = /([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g, L5 = /<[\/\?]?[a-zA-Z0-9:_-]+(?:\s+[^"\s?>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'">\s=]+))*\s*[\/\?]?>/mg, Cn = /<[^>]*>/g, k1 = /* @__PURE__ */ V6.match(L5) ? L5 : Cn, Sn = /<\w*:/, An = /<(\/?)\w+:/;
function x0(e, t, r) {
  for (var a = {}, n = 0, i = 0; n !== e.length && !((i = e.charCodeAt(n)) === 32 || i === 10 || i === 13); ++n)
    ;
  if (t || (a[0] = e.slice(0, n)), n === e.length)
    return a;
  var c = e.match(kn), s = 0, f = "", o = 0, l = "", d = "", u = 1;
  if (c)
    for (o = 0; o != c.length; ++o) {
      for (d = c[o], i = 0; i != d.length && d.charCodeAt(i) !== 61; ++i)
        ;
      for (l = d.slice(0, i).trim(); d.charCodeAt(i + 1) == 32; )
        ++i;
      for (u = (n = d.charCodeAt(i + 1)) == 34 || n == 39 ? 1 : 0, f = d.slice(i + 1 + u, d.length - u), s = 0; s != l.length && l.charCodeAt(s) !== 58; ++s)
        ;
      if (s === l.length)
        l.indexOf("_") > 0 && (l = l.slice(0, l.indexOf("_"))), a[l] = f, a[l.toLowerCase()] = f;
      else {
        var h = (s === 5 && l.slice(0, 5) === "xmlns" ? "xmlns" : "") + l.slice(s + 1);
        if (a[h] && l.slice(s - 3, s) == "ext")
          continue;
        a[h] = f, a[h.toLowerCase()] = f;
      }
    }
  return a;
}
function a2(e) {
  return e.replace(An, "<$1");
}
var G6 = {
  "&quot;": '"',
  "&apos;": "'",
  "&gt;": ">",
  "&lt;": "<",
  "&amp;": "&"
}, Fn = /* @__PURE__ */ H4(G6), R0 = /* @__PURE__ */ function() {
  var e = /&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/ig, t = /_x([\da-fA-F]{4})_/ig;
  function r(a) {
    var n = a + "", i = n.indexOf("<![CDATA[");
    if (i == -1)
      return n.replace(e, function(s, f) {
        return G6[s] || String.fromCharCode(parseInt(f, s.indexOf("x") > -1 ? 16 : 10)) || s;
      }).replace(t, function(s, f) {
        return String.fromCharCode(parseInt(f, 16));
      });
    var c = n.indexOf("]]>");
    return r(n.slice(0, i)) + n.slice(i + 9, c) + r(n.slice(c + 3));
  }
  return function(n, i) {
    var c = r(n);
    return i ? c.replace(/\r\n/g, `
`) : c;
  };
}(), yn = /[&<>'"]/g, In = /[\u0000-\u001f]/g;
function Ie(e) {
  var t = e + "";
  return t.replace(yn, function(r) {
    return Fn[r];
  }).replace(/\n/g, "<br/>").replace(In, function(r) {
    return "&#x" + ("000" + r.charCodeAt(0).toString(16)).slice(-4) + ";";
  });
}
var B5 = /* @__PURE__ */ function() {
  var e = /&#(\d+);/g;
  function t(r, a) {
    return String.fromCharCode(parseInt(a, 10));
  }
  return function(a) {
    return a.replace(e, t);
  };
}();
function G0(e) {
  switch (e) {
    case 1:
    case !0:
    case "1":
    case "true":
      return !0;
    case 0:
    case !1:
    case "0":
    case "false":
      return !1;
  }
  return !1;
}
function c4(e) {
  for (var t = "", r = 0, a = 0, n = 0, i = 0, c = 0, s = 0; r < e.length; ) {
    if (a = e.charCodeAt(r++), a < 128) {
      t += String.fromCharCode(a);
      continue;
    }
    if (n = e.charCodeAt(r++), a > 191 && a < 224) {
      c = (a & 31) << 6, c |= n & 63, t += String.fromCharCode(c);
      continue;
    }
    if (i = e.charCodeAt(r++), a < 240) {
      t += String.fromCharCode((a & 15) << 12 | (n & 63) << 6 | i & 63);
      continue;
    }
    c = e.charCodeAt(r++), s = ((a & 7) << 18 | (n & 63) << 12 | (i & 63) << 6 | c & 63) - 65536, t += String.fromCharCode(55296 + (s >>> 10 & 1023)), t += String.fromCharCode(56320 + (s & 1023));
  }
  return t;
}
function U5(e) {
  var t = R2(2 * e.length), r, a, n = 1, i = 0, c = 0, s;
  for (a = 0; a < e.length; a += n)
    n = 1, (s = e.charCodeAt(a)) < 128 ? r = s : s < 224 ? (r = (s & 31) * 64 + (e.charCodeAt(a + 1) & 63), n = 2) : s < 240 ? (r = (s & 15) * 4096 + (e.charCodeAt(a + 1) & 63) * 64 + (e.charCodeAt(a + 2) & 63), n = 3) : (n = 4, r = (s & 7) * 262144 + (e.charCodeAt(a + 1) & 63) * 4096 + (e.charCodeAt(a + 2) & 63) * 64 + (e.charCodeAt(a + 3) & 63), r -= 65536, c = 55296 + (r >>> 10 & 1023), r = 56320 + (r & 1023)), c !== 0 && (t[i++] = c & 255, t[i++] = c >>> 8, c = 0), t[i++] = r % 256, t[i++] = r >>> 8;
  return t.slice(0, i).toString("ucs2");
}
function H5(e) {
  return L2(e, "binary").toString("utf8");
}
var de = "foo bar bazâð£", X0 = O0 && (/* @__PURE__ */ H5(de) == /* @__PURE__ */ c4(de) && H5 || /* @__PURE__ */ U5(de) == /* @__PURE__ */ c4(de) && U5) || c4, b3 = O0 ? function(e) {
  return L2(e, "utf8").toString("binary");
} : function(e) {
  for (var t = [], r = 0, a = 0, n = 0; r < e.length; )
    switch (a = e.charCodeAt(r++), !0) {
      case a < 128:
        t.push(String.fromCharCode(a));
        break;
      case a < 2048:
        t.push(String.fromCharCode(192 + (a >> 6))), t.push(String.fromCharCode(128 + (a & 63)));
        break;
      case (a >= 55296 && a < 57344):
        a -= 55296, n = e.charCodeAt(r++) - 56320 + (a << 10), t.push(String.fromCharCode(240 + (n >> 18 & 7))), t.push(String.fromCharCode(144 + (n >> 12 & 63))), t.push(String.fromCharCode(128 + (n >> 6 & 63))), t.push(String.fromCharCode(128 + (n & 63)));
        break;
      default:
        t.push(String.fromCharCode(224 + (a >> 12))), t.push(String.fromCharCode(128 + (a >> 6 & 63))), t.push(String.fromCharCode(128 + (a & 63)));
    }
  return t.join("");
}, X3 = /* @__PURE__ */ function() {
  var e = {};
  return function(r, a) {
    var n = r + "|" + (a || "");
    return e[n] ? e[n] : e[n] = new RegExp("<(?:\\w+:)?" + r + '(?: xml:space="preserve")?(?:[^>]*)>([\\s\\S]*?)</(?:\\w+:)?' + r + ">", a || "");
  };
}(), j6 = /* @__PURE__ */ function() {
  var e = [
    ["nbsp", " "],
    ["middot", "·"],
    ["quot", '"'],
    ["apos", "'"],
    ["gt", ">"],
    ["lt", "<"],
    ["amp", "&"]
  ].map(function(t) {
    return [new RegExp("&" + t[0] + ";", "ig"), t[1]];
  });
  return function(r) {
    for (var a = r.replace(/^[\t\n\r ]+/, "").replace(/[\t\n\r ]+$/, "").replace(/>\s+/g, ">").replace(/\s+</g, "<").replace(/[\t\n\r ]+/g, " ").replace(/<\s*[bB][rR]\s*\/?>/g, `
`).replace(/<[^>]*>/g, ""), n = 0; n < e.length; ++n)
      a = a.replace(e[n][0], e[n][1]);
    return a;
  };
}(), bn = /* @__PURE__ */ function() {
  var e = {};
  return function(r) {
    return e[r] !== void 0 ? e[r] : e[r] = new RegExp("<(?:vt:)?" + r + ">([\\s\\S]*?)</(?:vt:)?" + r + ">", "g");
  };
}(), Dn = /<\/?(?:vt:)?variant>/g, On = /<(?:vt:)([^>]*)>([\s\S]*)</;
function W5(e, t) {
  var r = x0(e), a = e.match(bn(r.baseType)) || [], n = [];
  if (a.length != r.size) {
    if (t.WTF)
      throw new Error("unexpected vector length " + a.length + " != " + r.size);
    return n;
  }
  return a.forEach(function(i) {
    var c = i.replace(Dn, "").match(On);
    c && n.push({ v: X0(c[2]), t: c[1] });
  }), n;
}
var Rn = /(^\s|\s$|\n)/;
function Mn(e) {
  return t2(e).map(function(t) {
    return " " + t + '="' + e[t] + '"';
  }).join("");
}
function Nn(e, t, r) {
  return "<" + e + (r != null ? Mn(r) : "") + (t != null ? (t.match(Rn) ? ' xml:space="preserve"' : "") + ">" + t + "</" + e : "/") + ">";
}
function Xe(e) {
  if (O0 && /*::typeof Buffer !== "undefined" && d != null && d instanceof Buffer &&*/
  Buffer.isBuffer(e))
    return e.toString("utf8");
  if (typeof e == "string")
    return e;
  if (typeof Uint8Array < "u" && e instanceof Uint8Array)
    return X0(w2(L4(e)));
  throw new Error("Bad input format: expected Buffer or string");
}
var u1 = /<(\/?)([^\s?><!\/:]*:|)([^\s?<>:\/]+)(?:[\s?:\/](?:[^>=]|="[^"]*?")*)?>/mg, Pn = {
  CT: "http://schemas.openxmlformats.org/package/2006/content-types"
}, Ln = [
  "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
  "http://purl.oclc.org/ooxml/spreadsheetml/main",
  "http://schemas.microsoft.com/office/excel/2006/main",
  "http://schemas.microsoft.com/office/excel/2006/2"
];
function Bn(e, t) {
  for (var r = 1 - 2 * (e[t + 7] >>> 7), a = ((e[t + 7] & 127) << 4) + (e[t + 6] >>> 4 & 15), n = e[t + 6] & 15, i = 5; i >= 0; --i)
    n = n * 256 + e[t + i];
  return a == 2047 ? n == 0 ? r * (1 / 0) : NaN : (a == 0 ? a = -1022 : (a -= 1023, n += Math.pow(2, 52)), r * Math.pow(2, a - 52) * n);
}
function Un(e, t, r) {
  var a = (t < 0 || 1 / t == -1 / 0 ? 1 : 0) << 7, n = 0, i = 0, c = a ? -t : t;
  isFinite(c) ? c == 0 ? n = i = 0 : (n = Math.floor(Math.log(c) / Math.LN2), i = c * Math.pow(2, 52 - n), n <= -1023 && (!isFinite(i) || i < Math.pow(2, 52)) ? n = -1022 : (i -= Math.pow(2, 52), n += 1023)) : (n = 2047, i = isNaN(t) ? 26985 : 0);
  for (var s = 0; s <= 5; ++s, i /= 256)
    e[r + s] = i & 255;
  e[r + 6] = (n & 15) << 4 | i & 15, e[r + 7] = n >> 4 | a;
}
var V5 = function(e) {
  for (var t = [], r = 10240, a = 0; a < e[0].length; ++a)
    if (e[0][a])
      for (var n = 0, i = e[0][a].length; n < i; n += r)
        t.push.apply(t, e[0][a].slice(n, n + r));
  return t;
}, G5 = O0 ? function(e) {
  return e[0].length > 0 && Buffer.isBuffer(e[0][0]) ? Buffer.concat(e[0].map(function(t) {
    return Buffer.isBuffer(t) ? t : L2(t);
  })) : V5(e);
} : V5, j5 = function(e, t, r) {
  for (var a = [], n = t; n < r; n += 2)
    a.push(String.fromCharCode(_2(e, n)));
  return a.join("").replace(L1, "");
}, V4 = O0 ? function(e, t, r) {
  return !Buffer.isBuffer(e) || !j3 ? j5(e, t, r) : e.toString("utf16le", t, r).replace(L1, "");
} : j5, z5 = function(e, t, r) {
  for (var a = [], n = t; n < t + r; ++n)
    a.push(("0" + e[n].toString(16)).slice(-2));
  return a.join("");
}, z6 = O0 ? function(e, t, r) {
  return Buffer.isBuffer(e) ? e.toString("hex", t, t + r) : z5(e, t, r);
} : z5, $5 = function(e, t, r) {
  for (var a = [], n = t; n < r; n++)
    a.push(String.fromCharCode(f3(e, n)));
  return a.join("");
}, re = O0 ? function(t, r, a) {
  return Buffer.isBuffer(t) ? t.toString("utf8", r, a) : $5(t, r, a);
} : $5, $6 = function(e, t) {
  var r = j1(e, t);
  return r > 0 ? re(e, t + 4, t + 4 + r - 1) : "";
}, X6 = $6, K6 = function(e, t) {
  var r = j1(e, t);
  return r > 0 ? re(e, t + 4, t + 4 + r - 1) : "";
}, Y6 = K6, J6 = function(e, t) {
  var r = 2 * j1(e, t);
  return r > 0 ? re(e, t + 4, t + 4 + r - 1) : "";
}, q6 = J6, Z6 = function(t, r) {
  var a = j1(t, r);
  return a > 0 ? V4(t, r + 4, r + 4 + a) : "";
}, Q6 = Z6, e7 = function(e, t) {
  var r = j1(e, t);
  return r > 0 ? re(e, t + 4, t + 4 + r) : "";
}, r7 = e7, t7 = function(e, t) {
  return Bn(e, t);
}, be = t7, a7 = function(t) {
  return Array.isArray(t) || typeof Uint8Array < "u" && t instanceof Uint8Array;
};
O0 && (X6 = function(t, r) {
  if (!Buffer.isBuffer(t))
    return $6(t, r);
  var a = t.readUInt32LE(r);
  return a > 0 ? t.toString("utf8", r + 4, r + 4 + a - 1) : "";
}, Y6 = function(t, r) {
  if (!Buffer.isBuffer(t))
    return K6(t, r);
  var a = t.readUInt32LE(r);
  return a > 0 ? t.toString("utf8", r + 4, r + 4 + a - 1) : "";
}, q6 = function(t, r) {
  if (!Buffer.isBuffer(t) || !j3)
    return J6(t, r);
  var a = 2 * t.readUInt32LE(r);
  return t.toString("utf16le", r + 4, r + 4 + a - 1);
}, Q6 = function(t, r) {
  if (!Buffer.isBuffer(t) || !j3)
    return Z6(t, r);
  var a = t.readUInt32LE(r);
  return t.toString("utf16le", r + 4, r + 4 + a);
}, r7 = function(t, r) {
  if (!Buffer.isBuffer(t))
    return e7(t, r);
  var a = t.readUInt32LE(r);
  return t.toString("utf8", r + 4, r + 4 + a);
}, be = function(t, r) {
  return Buffer.isBuffer(t) ? t.readDoubleLE(r) : t7(t, r);
}, a7 = function(t) {
  return Buffer.isBuffer(t) || Array.isArray(t) || typeof Uint8Array < "u" && t instanceof Uint8Array;
});
var f3 = function(e, t) {
  return e[t];
}, _2 = function(e, t) {
  return e[t + 1] * 256 + e[t];
}, Hn = function(e, t) {
  var r = e[t + 1] * 256 + e[t];
  return r < 32768 ? r : (65535 - r + 1) * -1;
}, j1 = function(e, t) {
  return e[t + 3] * (1 << 24) + (e[t + 2] << 16) + (e[t + 1] << 8) + e[t];
}, j2 = function(e, t) {
  return e[t + 3] << 24 | e[t + 2] << 16 | e[t + 1] << 8 | e[t];
}, Wn = function(e, t) {
  return e[t] << 24 | e[t + 1] << 16 | e[t + 2] << 8 | e[t + 3];
};
function R3(e, t) {
  var r = "", a, n, i = [], c, s, f, o;
  switch (t) {
    case "dbcs":
      if (o = this.l, O0 && Buffer.isBuffer(this) && j3)
        r = this.slice(this.l, this.l + 2 * e).toString("utf16le");
      else
        for (f = 0; f < e; ++f)
          r += String.fromCharCode(_2(this, o)), o += 2;
      e *= 2;
      break;
    case "utf8":
      r = re(this, this.l, this.l + e);
      break;
    case "utf16le":
      e *= 2, r = V4(this, this.l, this.l + e);
      break;
    case "wstr":
      return R3.call(this, e, "dbcs");
    case "lpstr-ansi":
      r = X6(this, this.l), e = 4 + j1(this, this.l);
      break;
    case "lpstr-cp":
      r = Y6(this, this.l), e = 4 + j1(this, this.l);
      break;
    case "lpwstr":
      r = q6(this, this.l), e = 4 + 2 * j1(this, this.l);
      break;
    case "lpp4":
      e = 4 + j1(this, this.l), r = Q6(this, this.l), e & 2 && (e += 2);
      break;
    case "8lpp4":
      e = 4 + j1(this, this.l), r = r7(this, this.l), e & 3 && (e += 4 - (e & 3));
      break;
    case "cstr":
      for (e = 0, r = ""; (c = f3(this, this.l + e++)) !== 0; )
        i.push(xe(c));
      r = i.join("");
      break;
    case "_wstr":
      for (e = 0, r = ""; (c = _2(this, this.l + e)) !== 0; )
        i.push(xe(c)), e += 2;
      e += 2, r = i.join("");
      break;
    case "dbcs-cont":
      for (r = "", o = this.l, f = 0; f < e; ++f) {
        if (this.lens && this.lens.indexOf(o) !== -1)
          return c = f3(this, o), this.l = o + 1, s = R3.call(this, e - f, c ? "dbcs-cont" : "sbcs-cont"), i.join("") + s;
        i.push(xe(_2(this, o))), o += 2;
      }
      r = i.join(""), e *= 2;
      break;
    case "cpstr":
    case "sbcs-cont":
      for (r = "", o = this.l, f = 0; f != e; ++f) {
        if (this.lens && this.lens.indexOf(o) !== -1)
          return c = f3(this, o), this.l = o + 1, s = R3.call(this, e - f, c ? "dbcs-cont" : "sbcs-cont"), i.join("") + s;
        i.push(xe(f3(this, o))), o += 1;
      }
      r = i.join("");
      break;
    default:
      switch (e) {
        case 1:
          return a = f3(this, this.l), this.l++, a;
        case 2:
          return a = (t === "i" ? Hn : _2)(this, this.l), this.l += 2, a;
        case 4:
        case -4:
          return t === "i" || !(this[this.l + 3] & 128) ? (a = (e > 0 ? j2 : Wn)(this, this.l), this.l += 4, a) : (n = j1(this, this.l), this.l += 4, n);
        case 8:
        case -8:
          if (t === "f")
            return e == 8 ? n = be(this, this.l) : n = be([this[this.l + 7], this[this.l + 6], this[this.l + 5], this[this.l + 4], this[this.l + 3], this[this.l + 2], this[this.l + 1], this[this.l + 0]], 0), this.l += 8, n;
          e = 8;
        case 16:
          r = z6(this, this.l, e);
          break;
      }
  }
  return this.l += e, r;
}
var Vn = function(e, t, r) {
  e[r] = t & 255, e[r + 1] = t >>> 8 & 255, e[r + 2] = t >>> 16 & 255, e[r + 3] = t >>> 24 & 255;
}, Gn = function(e, t, r) {
  e[r] = t & 255, e[r + 1] = t >> 8 & 255, e[r + 2] = t >> 16 & 255, e[r + 3] = t >> 24 & 255;
}, jn = function(e, t, r) {
  e[r] = t & 255, e[r + 1] = t >>> 8 & 255;
};
function zn(e, t, r) {
  var a = 0, n = 0;
  if (r === "dbcs") {
    for (n = 0; n != t.length; ++n)
      jn(this, t.charCodeAt(n), this.l + 2 * n);
    a = 2 * t.length;
  } else if (r === "sbcs" || r == "cpstr") {
    for (t = t.replace(/[^\x00-\x7F]/g, "_"), n = 0; n != t.length; ++n)
      this[this.l + n] = t.charCodeAt(n) & 255;
    a = t.length;
  } else if (r === "hex") {
    for (; n < e; ++n)
      this[this.l++] = parseInt(t.slice(2 * n, 2 * n + 2), 16) || 0;
    return this;
  } else if (r === "utf16le") {
    var i = Math.min(this.l + e, this.length);
    for (n = 0; n < Math.min(t.length, e); ++n) {
      var c = t.charCodeAt(n);
      this[this.l++] = c & 255, this[this.l++] = c >> 8;
    }
    for (; this.l < i; )
      this[this.l++] = 0;
    return this;
  } else
    switch (e) {
      case 1:
        a = 1, this[this.l] = t & 255;
        break;
      case 2:
        a = 2, this[this.l] = t & 255, t >>>= 8, this[this.l + 1] = t & 255;
        break;
      case 3:
        a = 3, this[this.l] = t & 255, t >>>= 8, this[this.l + 1] = t & 255, t >>>= 8, this[this.l + 2] = t & 255;
        break;
      case 4:
        a = 4, Vn(this, t, this.l);
        break;
      case 8:
        if (a = 8, r === "f") {
          Un(this, t, this.l);
          break;
        }
      case 16:
        break;
      case -4:
        a = 4, Gn(this, t, this.l);
        break;
    }
  return this.l += a, this;
}
function n7(e, t) {
  var r = z6(this, this.l, e.length >> 1);
  if (r !== e)
    throw new Error(t + "Expected " + e + " saw " + r);
  this.l += e.length >> 1;
}
function m1(e, t) {
  e.l = t, e.read_shift = /*::(*/
  R3, e.chk = n7, e.write_shift = zn;
}
function b1(e, t) {
  e.l += t;
}
function p1(e) {
  var t = R2(e);
  return m1(t, 0), t;
}
function k2(e, t, r) {
  if (e) {
    var a, n, i;
    m1(e, e.l || 0);
    for (var c = e.length, s = 0, f = 0; e.l < c; ) {
      s = e.read_shift(1), s & 128 && (s = (s & 127) + ((e.read_shift(1) & 127) << 7));
      var o = Pe[s] || Pe[65535];
      for (a = e.read_shift(1), i = a & 127, n = 1; n < 4 && a & 128; ++n)
        i += ((a = e.read_shift(1)) & 127) << 7 * n;
      f = e.l + i;
      var l = o.f && o.f(e, i, r);
      if (e.l = f, t(l, o, s))
        return;
    }
  }
}
function v4() {
  var e = [], t = O0 ? 256 : 2048, r = function(o) {
    var l = p1(o);
    return m1(l, 0), l;
  }, a = r(t), n = function() {
    a && (a.l && (a.length > a.l && (a = a.slice(0, a.l), a.l = a.length), a.length > 0 && e.push(a)), a = null);
  }, i = function(o) {
    return a && o < a.length - a.l ? a : (n(), a = r(Math.max(o + 1, t)));
  }, c = function() {
    return n(), b2(e);
  }, s = function(o) {
    n(), a = o, a.l == null && (a.l = a.length), i(t);
  };
  return { next: i, push: s, end: c, _bufs: e };
}
function M3(e, t, r) {
  var a = x1(e);
  if (t.s ? (a.cRel && (a.c += t.s.c), a.rRel && (a.r += t.s.r)) : (a.cRel && (a.c += t.c), a.rRel && (a.r += t.r)), !r || r.biff < 12) {
    for (; a.c >= 256; )
      a.c -= 256;
    for (; a.r >= 65536; )
      a.r -= 65536;
  }
  return a;
}
function X5(e, t, r) {
  var a = x1(e);
  return a.s = M3(a.s, t.s, r), a.e = M3(a.e, t.s, r), a;
}
function N3(e, t) {
  if (e.cRel && e.c < 0)
    for (e = x1(e); e.c < 0; )
      e.c += t > 8 ? 16384 : 256;
  if (e.rRel && e.r < 0)
    for (e = x1(e); e.r < 0; )
      e.r += t > 8 ? 1048576 : t > 5 ? 65536 : 16384;
  var r = H0(e);
  return !e.cRel && e.cRel != null && (r = Kn(r)), !e.rRel && e.rRel != null && (r = $n(r)), r;
}
function f4(e, t) {
  return e.s.r == 0 && !e.s.rRel && e.e.r == (t.biff >= 12 ? 1048575 : t.biff >= 8 ? 65536 : 16384) && !e.e.rRel ? (e.s.cRel ? "" : "$") + W0(e.s.c) + ":" + (e.e.cRel ? "" : "$") + W0(e.e.c) : e.s.c == 0 && !e.s.cRel && e.e.c == (t.biff >= 12 ? 16383 : 255) && !e.e.cRel ? (e.s.rRel ? "" : "$") + j0(e.s.r) + ":" + (e.e.rRel ? "" : "$") + j0(e.e.r) : N3(e.s, t.biff) + ":" + N3(e.e, t.biff);
}
function G4(e) {
  return parseInt(Xn(e), 10) - 1;
}
function j0(e) {
  return "" + (e + 1);
}
function $n(e) {
  return e.replace(/([A-Z]|^)(\d+)$/, "$1$$$2");
}
function Xn(e) {
  return e.replace(/\$(\d+)$/, "$1");
}
function j4(e) {
  for (var t = Yn(e), r = 0, a = 0; a !== t.length; ++a)
    r = 26 * r + t.charCodeAt(a) - 64;
  return r - 1;
}
function W0(e) {
  if (e < 0)
    throw new Error("invalid column " + e);
  var t = "";
  for (++e; e; e = Math.floor((e - 1) / 26))
    t = String.fromCharCode((e - 1) % 26 + 65) + t;
  return t;
}
function Kn(e) {
  return e.replace(/^([A-Z])/, "$$$1");
}
function Yn(e) {
  return e.replace(/^\$([A-Z])/, "$1");
}
function Jn(e) {
  return e.replace(/(\$?[A-Z]*)(\$?\d*)/, "$1,$2").split(",");
}
function y1(e) {
  for (var t = 0, r = 0, a = 0; a < e.length; ++a) {
    var n = e.charCodeAt(a);
    n >= 48 && n <= 57 ? t = 10 * t + (n - 48) : n >= 65 && n <= 90 && (r = 26 * r + (n - 64));
  }
  return { c: r - 1, r: t - 1 };
}
function H0(e) {
  for (var t = e.c + 1, r = ""; t; t = (t - 1) / 26 | 0)
    r = String.fromCharCode((t - 1) % 26 + 65) + r;
  return r + (e.r + 1);
}
function Q2(e) {
  var t = e.indexOf(":");
  return t == -1 ? { s: y1(e), e: y1(e) } : { s: y1(e.slice(0, t)), e: y1(e.slice(t + 1)) };
}
function M0(e, t) {
  return typeof t > "u" || typeof t == "number" ? M0(e.s, e.e) : (typeof e != "string" && (e = H0(e)), typeof t != "string" && (t = H0(t)), e == t ? e : e + ":" + t);
}
function qn(e, t) {
  if (!e && !(t && t.biff <= 5 && t.biff >= 2))
    throw new Error("empty sheet name");
  return /[^\w\u4E00-\u9FFF\u3040-\u30FF]/.test(e) ? "'" + e.replace(/'/g, "''") + "'" : e;
}
function o1(e) {
  var t = { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } }, r = 0, a = 0, n = 0, i = e.length;
  for (r = 0; a < i && !((n = e.charCodeAt(a) - 64) < 1 || n > 26); ++a)
    r = 26 * r + n;
  for (t.s.c = --r, r = 0; a < i && !((n = e.charCodeAt(a) - 48) < 0 || n > 9); ++a)
    r = 10 * r + n;
  if (t.s.r = --r, a === i || n != 10)
    return t.e.c = t.s.c, t.e.r = t.s.r, t;
  for (++a, r = 0; a != i && !((n = e.charCodeAt(a) - 64) < 1 || n > 26); ++a)
    r = 26 * r + n;
  for (t.e.c = --r, r = 0; a != i && !((n = e.charCodeAt(a) - 48) < 0 || n > 9); ++a)
    r = 10 * r + n;
  return t.e.r = --r, t;
}
function K5(e, t) {
  var r = e.t == "d" && t instanceof Date;
  if (e.z != null)
    try {
      return e.w = X1(e.z, r ? v1(t) : t);
    } catch {
    }
  try {
    return e.w = X1((e.XF || {}).numFmtId || (r ? 14 : 0), r ? v1(t) : t);
  } catch {
    return "" + t;
  }
}
function M2(e, t, r) {
  return e == null || e.t == null || e.t == "z" ? "" : e.w !== void 0 ? e.w : (e.t == "d" && !e.z && r && r.dateNF && (e.z = r.dateNF), e.t == "e" ? t3[e.v] || e.v : t == null ? K5(e, e.v) : K5(e, t));
}
function B2(e, t) {
  var r = t && t.sheet ? t.sheet : "Sheet1", a = {};
  return a[r] = e, { SheetNames: [r], Sheets: a };
}
function Zn(e) {
  var t = {}, r = e || {};
  return r.dense && (t["!data"] = []), t;
}
function i7(e, t, r) {
  var a = r || {}, n = e ? e["!data"] != null : a.dense, i = e || {};
  n && !i["!data"] && (i["!data"] = []);
  var c = 0, s = 0;
  if (i && a.origin != null) {
    if (typeof a.origin == "number")
      c = a.origin;
    else {
      var f = typeof a.origin == "string" ? y1(a.origin) : a.origin;
      c = f.r, s = f.c;
    }
    i["!ref"] || (i["!ref"] = "A1:A1");
  }
  var o = { s: { c: 1e7, r: 1e7 }, e: { c: 0, r: 0 } };
  if (i["!ref"]) {
    var l = o1(i["!ref"]);
    o.s.c = l.s.c, o.s.r = l.s.r, o.e.c = Math.max(o.e.c, l.e.c), o.e.r = Math.max(o.e.r, l.e.r), c == -1 && (o.e.r = c = l.e.r + 1);
  }
  for (var d = [], u = 0; u != t.length; ++u)
    if (t[u]) {
      if (!Array.isArray(t[u]))
        throw new Error("aoa_to_sheet expects an array of arrays");
      var h = c + u, p = "" + (h + 1);
      n && (i["!data"][h] || (i["!data"][h] = []), d = i["!data"][h]);
      for (var v = 0; v != t[u].length; ++v)
        if (!(typeof t[u][v] > "u")) {
          var x = { v: t[u][v] }, m = s + v;
          if (o.s.r > h && (o.s.r = h), o.s.c > m && (o.s.c = m), o.e.r < h && (o.e.r = h), o.e.c < m && (o.e.c = m), t[u][v] && typeof t[u][v] == "object" && !Array.isArray(t[u][v]) && !(t[u][v] instanceof Date))
            x = t[u][v];
          else if (Array.isArray(x.v) && (x.f = t[u][v][1], x.v = x.v[0]), x.v === null)
            if (x.f)
              x.t = "n";
            else if (a.nullError)
              x.t = "e", x.v = 0;
            else if (a.sheetStubs)
              x.t = "z";
            else
              continue;
          else
            typeof x.v == "number" ? x.t = "n" : typeof x.v == "boolean" ? x.t = "b" : x.v instanceof Date ? (x.z = a.dateNF || k0[14], a.UTC || (x.v = $e(x.v)), a.cellDates ? (x.t = "d", x.w = X1(x.z, v1(x.v, a.date1904))) : (x.t = "n", x.v = v1(x.v, a.date1904), x.w = X1(x.z, x.v))) : x.t = "s";
          if (n)
            d[m] && d[m].z && (x.z = d[m].z), d[m] = x;
          else {
            var T = W0(m) + p;
            i[T] && i[T].z && (x.z = i[T].z), i[T] = x;
          }
        }
    }
  return o.s.c < 1e7 && (i["!ref"] = M0(o)), i;
}
function E3(e, t) {
  return i7(null, e, t);
}
function Qn(e) {
  return e.read_shift(4, "i");
}
function I1(e) {
  var t = e.read_shift(4);
  return t === 0 ? "" : e.read_shift(t, "dbcs");
}
function ei(e) {
  return { ich: e.read_shift(2), ifnt: e.read_shift(2) };
}
function z4(e, t) {
  var r = e.l, a = e.read_shift(1), n = I1(e), i = [], c = { t: n, h: n };
  if (a & 1) {
    for (var s = e.read_shift(4), f = 0; f != s; ++f)
      i.push(ei(e));
    c.r = i;
  } else
    c.r = [{ ich: 0, ifnt: 0 }];
  return e.l = r + t, c;
}
var ri = z4;
function n2(e) {
  var t = e.read_shift(4), r = e.read_shift(2);
  return r += e.read_shift(1) << 16, e.l++, { c: t, iStyleRef: r };
}
function e3(e) {
  var t = e.read_shift(2);
  return t += e.read_shift(1) << 16, e.l++, { c: -1, iStyleRef: t };
}
var ti = I1;
function Ke(e) {
  var t = e.read_shift(4);
  return t === 0 || t === 4294967295 ? "" : e.read_shift(t, "dbcs");
}
var ai = I1, g4 = Ke;
function Ye(e) {
  var t = e.slice(e.l, e.l + 4), r = t[0] & 1, a = t[0] & 2;
  e.l += 4;
  var n = a === 0 ? be([0, 0, 0, 0, t[0] & 252, t[1], t[2], t[3]], 0) : j2(t, 0) >> 2;
  return r ? n / 100 : n;
}
function s7(e) {
  var t = { s: {}, e: {} };
  return t.s.r = e.read_shift(4), t.e.r = e.read_shift(4), t.s.c = e.read_shift(4), t.e.c = e.read_shift(4), t;
}
var r3 = s7;
function F1(e) {
  if (e.length - e.l < 8)
    throw "XLS Xnum Buffer underflow";
  return e.read_shift(8, "f");
}
function ni(e) {
  var t = {}, r = e.read_shift(1), a = r >>> 1, n = e.read_shift(1), i = e.read_shift(2, "i"), c = e.read_shift(1), s = e.read_shift(1), f = e.read_shift(1);
  switch (e.l++, a) {
    case 0:
      t.auto = 1;
      break;
    case 1:
      t.index = n;
      var o = $2[n];
      o && (t.rgb = Y3(o));
      break;
    case 2:
      t.rgb = Y3([c, s, f]);
      break;
    case 3:
      t.theme = n;
      break;
  }
  return i != 0 && (t.tint = i > 0 ? i / 32767 : i / 32768), t;
}
function ii(e) {
  var t = e.read_shift(1);
  e.l++;
  var r = {
    fBold: t & 1,
    fItalic: t & 2,
    fUnderline: t & 4,
    fStrikeout: t & 8,
    fOutline: t & 16,
    fShadow: t & 32,
    fCondense: t & 64,
    fExtend: t & 128
  };
  return r;
}
function c7(e, t) {
  var r = { 2: "BITMAP", 3: "METAFILEPICT", 8: "DIB", 14: "ENHMETAFILE" }, a = e.read_shift(4);
  switch (a) {
    case 0:
      return "";
    case 4294967295:
    case 4294967294:
      return r[e.read_shift(4)] || "";
  }
  if (a > 400)
    throw new Error("Unsupported Clipboard: " + a.toString(16));
  return e.l -= 4, e.read_shift(0, t == 1 ? "lpstr" : "lpwstr");
}
function si(e) {
  return c7(e, 1);
}
function ci(e) {
  return c7(e, 2);
}
var $4 = 2, H1 = 3, pe = 11, Y5 = 12, De = 19, me = 64, fi = 65, oi = 71, li = 4108, hi = 4126, g1 = 80, f7 = 81, ui = [g1, f7], xi = {
  /*::[*/
  1: { n: "CodePage", t: $4 },
  /*::[*/
  2: { n: "Category", t: g1 },
  /*::[*/
  3: { n: "PresentationFormat", t: g1 },
  /*::[*/
  4: { n: "ByteCount", t: H1 },
  /*::[*/
  5: { n: "LineCount", t: H1 },
  /*::[*/
  6: { n: "ParagraphCount", t: H1 },
  /*::[*/
  7: { n: "SlideCount", t: H1 },
  /*::[*/
  8: { n: "NoteCount", t: H1 },
  /*::[*/
  9: { n: "HiddenCount", t: H1 },
  /*::[*/
  10: { n: "MultimediaClipCount", t: H1 },
  /*::[*/
  11: { n: "ScaleCrop", t: pe },
  /*::[*/
  12: {
    n: "HeadingPairs",
    t: li
    /* VT_VECTOR | VT_VARIANT */
  },
  /*::[*/
  13: {
    n: "TitlesOfParts",
    t: hi
    /* VT_VECTOR | VT_LPSTR */
  },
  /*::[*/
  14: { n: "Manager", t: g1 },
  /*::[*/
  15: { n: "Company", t: g1 },
  /*::[*/
  16: { n: "LinksUpToDate", t: pe },
  /*::[*/
  17: { n: "CharacterCount", t: H1 },
  /*::[*/
  19: { n: "SharedDoc", t: pe },
  /*::[*/
  22: { n: "HyperlinksChanged", t: pe },
  /*::[*/
  23: { n: "AppVersion", t: H1, p: "version" },
  /*::[*/
  24: { n: "DigSig", t: fi },
  /*::[*/
  26: { n: "ContentType", t: g1 },
  /*::[*/
  27: { n: "ContentStatus", t: g1 },
  /*::[*/
  28: { n: "Language", t: g1 },
  /*::[*/
  29: { n: "Version", t: g1 },
  /*::[*/
  255: {},
  /* [MS-OLEPS] 2.18 */
  /*::[*/
  2147483648: { n: "Locale", t: De },
  /*::[*/
  2147483651: { n: "Behavior", t: De },
  /*::[*/
  1919054434: {}
}, di = {
  /*::[*/
  1: { n: "CodePage", t: $4 },
  /*::[*/
  2: { n: "Title", t: g1 },
  /*::[*/
  3: { n: "Subject", t: g1 },
  /*::[*/
  4: { n: "Author", t: g1 },
  /*::[*/
  5: { n: "Keywords", t: g1 },
  /*::[*/
  6: { n: "Comments", t: g1 },
  /*::[*/
  7: { n: "Template", t: g1 },
  /*::[*/
  8: { n: "LastAuthor", t: g1 },
  /*::[*/
  9: { n: "RevNumber", t: g1 },
  /*::[*/
  10: { n: "EditTime", t: me },
  /*::[*/
  11: { n: "LastPrinted", t: me },
  /*::[*/
  12: { n: "CreatedDate", t: me },
  /*::[*/
  13: { n: "ModifiedDate", t: me },
  /*::[*/
  14: { n: "PageCount", t: H1 },
  /*::[*/
  15: { n: "WordCount", t: H1 },
  /*::[*/
  16: { n: "CharCount", t: H1 },
  /*::[*/
  17: { n: "Thumbnail", t: oi },
  /*::[*/
  18: { n: "Application", t: g1 },
  /*::[*/
  19: { n: "DocSecurity", t: H1 },
  /*::[*/
  255: {},
  /* [MS-OLEPS] 2.18 */
  /*::[*/
  2147483648: { n: "Locale", t: De },
  /*::[*/
  2147483651: { n: "Behavior", t: De },
  /*::[*/
  1919054434: {}
}, J5 = {
  /*::[*/
  1: "US",
  // United States
  /*::[*/
  2: "CA",
  // Canada
  /*::[*/
  3: "",
  // Latin America (except Brazil)
  /*::[*/
  7: "RU",
  // Russia
  /*::[*/
  20: "EG",
  // Egypt
  /*::[*/
  30: "GR",
  // Greece
  /*::[*/
  31: "NL",
  // Netherlands
  /*::[*/
  32: "BE",
  // Belgium
  /*::[*/
  33: "FR",
  // France
  /*::[*/
  34: "ES",
  // Spain
  /*::[*/
  36: "HU",
  // Hungary
  /*::[*/
  39: "IT",
  // Italy
  /*::[*/
  41: "CH",
  // Switzerland
  /*::[*/
  43: "AT",
  // Austria
  /*::[*/
  44: "GB",
  // United Kingdom
  /*::[*/
  45: "DK",
  // Denmark
  /*::[*/
  46: "SE",
  // Sweden
  /*::[*/
  47: "NO",
  // Norway
  /*::[*/
  48: "PL",
  // Poland
  /*::[*/
  49: "DE",
  // Germany
  /*::[*/
  52: "MX",
  // Mexico
  /*::[*/
  55: "BR",
  // Brazil
  /*::[*/
  61: "AU",
  // Australia
  /*::[*/
  64: "NZ",
  // New Zealand
  /*::[*/
  66: "TH",
  // Thailand
  /*::[*/
  81: "JP",
  // Japan
  /*::[*/
  82: "KR",
  // Korea
  /*::[*/
  84: "VN",
  // Viet Nam
  /*::[*/
  86: "CN",
  // China
  /*::[*/
  90: "TR",
  // Turkey
  /*::[*/
  105: "JS",
  // Ramastan
  /*::[*/
  213: "DZ",
  // Algeria
  /*::[*/
  216: "MA",
  // Morocco
  /*::[*/
  218: "LY",
  // Libya
  /*::[*/
  351: "PT",
  // Portugal
  /*::[*/
  354: "IS",
  // Iceland
  /*::[*/
  358: "FI",
  // Finland
  /*::[*/
  420: "CZ",
  // Czech Republic
  /*::[*/
  886: "TW",
  // Taiwan
  /*::[*/
  961: "LB",
  // Lebanon
  /*::[*/
  962: "JO",
  // Jordan
  /*::[*/
  963: "SY",
  // Syria
  /*::[*/
  964: "IQ",
  // Iraq
  /*::[*/
  965: "KW",
  // Kuwait
  /*::[*/
  966: "SA",
  // Saudi Arabia
  /*::[*/
  971: "AE",
  // United Arab Emirates
  /*::[*/
  972: "IL",
  // Israel
  /*::[*/
  974: "QA",
  // Qatar
  /*::[*/
  981: "IR",
  // Iran
  /*::[*/
  65535: "US"
  // United States
}, pi = [
  null,
  "solid",
  "mediumGray",
  "darkGray",
  "lightGray",
  "darkHorizontal",
  "darkVertical",
  "darkDown",
  "darkUp",
  "darkGrid",
  "darkTrellis",
  "lightHorizontal",
  "lightVertical",
  "lightDown",
  "lightUp",
  "lightGrid",
  "lightTrellis",
  "gray125",
  "gray0625"
];
function mi(e) {
  return e.map(function(t) {
    return [t >> 16 & 255, t >> 8 & 255, t & 255];
  });
}
var vi = /* @__PURE__ */ mi([
  /* Color Constants */
  0,
  16777215,
  16711680,
  65280,
  255,
  16776960,
  16711935,
  65535,
  /* Overridable Defaults */
  0,
  16777215,
  16711680,
  65280,
  255,
  16776960,
  16711935,
  65535,
  8388608,
  32768,
  128,
  8421376,
  8388736,
  32896,
  12632256,
  8421504,
  10066431,
  10040166,
  16777164,
  13434879,
  6684774,
  16744576,
  26316,
  13421823,
  128,
  16711935,
  16776960,
  65535,
  8388736,
  8388608,
  32896,
  255,
  52479,
  13434879,
  13434828,
  16777113,
  10079487,
  16751052,
  13408767,
  16764057,
  3368703,
  3394764,
  10079232,
  16763904,
  16750848,
  16737792,
  6710937,
  9868950,
  13158,
  3381606,
  13056,
  3355392,
  10040064,
  10040166,
  3355545,
  3355443,
  /* Other entries to appease BIFF8/12 */
  0,
  /* 0x40 icvForeground ?? */
  16777215,
  /* 0x41 icvBackground ?? */
  0,
  /* 0x42 icvFrame ?? */
  0,
  /* 0x43 icv3D ?? */
  0,
  /* 0x44 icv3DText ?? */
  0,
  /* 0x45 icv3DHilite ?? */
  0,
  /* 0x46 icv3DShadow ?? */
  0,
  /* 0x47 icvHilite ?? */
  0,
  /* 0x48 icvCtlText ?? */
  0,
  /* 0x49 icvCtlScrl ?? */
  0,
  /* 0x4A icvCtlInv ?? */
  0,
  /* 0x4B icvCtlBody ?? */
  0,
  /* 0x4C icvCtlFrame ?? */
  0,
  /* 0x4D icvCtlFore ?? */
  0,
  /* 0x4E icvCtlBack ?? */
  0,
  /* 0x4F icvCtlNeutral */
  0,
  /* 0x50 icvInfoBk ?? */
  0
  /* 0x51 icvInfoText ?? */
]), $2 = /* @__PURE__ */ x1(vi), t3 = {
  /*::[*/
  0: "#NULL!",
  /*::[*/
  7: "#DIV/0!",
  /*::[*/
  15: "#VALUE!",
  /*::[*/
  23: "#REF!",
  /*::[*/
  29: "#NAME?",
  /*::[*/
  36: "#NUM!",
  /*::[*/
  42: "#N/A",
  /*::[*/
  43: "#GETTING_DATA",
  /*::[*/
  255: "#WTF?"
}, o7 = {
  "#NULL!": 0,
  "#DIV/0!": 7,
  "#VALUE!": 15,
  "#REF!": 23,
  "#NAME?": 29,
  "#NUM!": 36,
  "#N/A": 42,
  "#GETTING_DATA": 43,
  "#WTF?": 255
}, l7 = [
  "_xlnm.Consolidate_Area",
  "_xlnm.Auto_Open",
  "_xlnm.Auto_Close",
  "_xlnm.Extract",
  "_xlnm.Database",
  "_xlnm.Criteria",
  "_xlnm.Print_Area",
  "_xlnm.Print_Titles",
  "_xlnm.Recorder",
  "_xlnm.Data_Form",
  "_xlnm.Auto_Activate",
  "_xlnm.Auto_Deactivate",
  "_xlnm.Sheet_Title",
  "_xlnm._FilterDatabase"
], q5 = {
  /* Workbook */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": "workbooks",
  "application/vnd.ms-excel.sheet.macroEnabled.main+xml": "workbooks",
  "application/vnd.ms-excel.sheet.binary.macroEnabled.main": "workbooks",
  "application/vnd.ms-excel.addin.macroEnabled.main+xml": "workbooks",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml": "workbooks",
  /* Worksheet */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml": "sheets",
  "application/vnd.ms-excel.worksheet": "sheets",
  "application/vnd.ms-excel.binIndexWs": "TODO",
  /* Binary Index */
  /* Chartsheet */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml": "charts",
  "application/vnd.ms-excel.chartsheet": "charts",
  /* Macrosheet */
  "application/vnd.ms-excel.macrosheet+xml": "macros",
  "application/vnd.ms-excel.macrosheet": "macros",
  "application/vnd.ms-excel.intlmacrosheet": "TODO",
  "application/vnd.ms-excel.binIndexMs": "TODO",
  /* Binary Index */
  /* Dialogsheet */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml": "dialogs",
  "application/vnd.ms-excel.dialogsheet": "dialogs",
  /* Shared Strings */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml": "strs",
  "application/vnd.ms-excel.sharedStrings": "strs",
  /* Styles */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml": "styles",
  "application/vnd.ms-excel.styles": "styles",
  /* File Properties */
  "application/vnd.openxmlformats-package.core-properties+xml": "coreprops",
  "application/vnd.openxmlformats-officedocument.custom-properties+xml": "custprops",
  "application/vnd.openxmlformats-officedocument.extended-properties+xml": "extprops",
  /* Custom Data Properties */
  "application/vnd.openxmlformats-officedocument.customXmlProperties+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty": "TODO",
  /* Comments */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml": "comments",
  "application/vnd.ms-excel.comments": "comments",
  "application/vnd.ms-excel.threadedcomments+xml": "threadedcomments",
  "application/vnd.ms-excel.person+xml": "people",
  /* Metadata (Stock/Geography and Dynamic Array) */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml": "metadata",
  "application/vnd.ms-excel.sheetMetadata": "metadata",
  /* PivotTable */
  "application/vnd.ms-excel.pivotTable": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml": "TODO",
  /* Chart Objects */
  "application/vnd.openxmlformats-officedocument.drawingml.chart+xml": "TODO",
  /* Chart Colors */
  "application/vnd.ms-office.chartcolorstyle+xml": "TODO",
  /* Chart Style */
  "application/vnd.ms-office.chartstyle+xml": "TODO",
  /* Chart Advanced */
  "application/vnd.ms-office.chartex+xml": "TODO",
  /* Calculation Chain */
  "application/vnd.ms-excel.calcChain": "calcchains",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml": "calcchains",
  /* Printer Settings */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings": "TODO",
  /* ActiveX */
  "application/vnd.ms-office.activeX": "TODO",
  "application/vnd.ms-office.activeX+xml": "TODO",
  /* Custom Toolbars */
  "application/vnd.ms-excel.attachedToolbars": "TODO",
  /* External Data Connections */
  "application/vnd.ms-excel.connections": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": "TODO",
  /* External Links */
  "application/vnd.ms-excel.externalLink": "links",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml": "links",
  /* PivotCache */
  "application/vnd.ms-excel.pivotCacheDefinition": "TODO",
  "application/vnd.ms-excel.pivotCacheRecords": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml": "TODO",
  /* Query Table */
  "application/vnd.ms-excel.queryTable": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml": "TODO",
  /* Shared Workbook */
  "application/vnd.ms-excel.userNames": "TODO",
  "application/vnd.ms-excel.revisionHeaders": "TODO",
  "application/vnd.ms-excel.revisionLog": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml": "TODO",
  /* Single Cell Table */
  "application/vnd.ms-excel.tableSingleCells": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml": "TODO",
  /* Slicer */
  "application/vnd.ms-excel.slicer": "TODO",
  "application/vnd.ms-excel.slicerCache": "TODO",
  "application/vnd.ms-excel.slicer+xml": "TODO",
  "application/vnd.ms-excel.slicerCache+xml": "TODO",
  /* Sort Map */
  "application/vnd.ms-excel.wsSortMap": "TODO",
  /* Table */
  "application/vnd.ms-excel.table": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": "TODO",
  /* Themes */
  "application/vnd.openxmlformats-officedocument.theme+xml": "themes",
  /* Theme Override */
  "application/vnd.openxmlformats-officedocument.themeOverride+xml": "TODO",
  /* Timeline */
  "application/vnd.ms-excel.Timeline+xml": "TODO",
  /* verify */
  "application/vnd.ms-excel.TimelineCache+xml": "TODO",
  /* verify */
  /* VBA */
  "application/vnd.ms-office.vbaProject": "vba",
  "application/vnd.ms-office.vbaProjectSignature": "TODO",
  /* Volatile Dependencies */
  "application/vnd.ms-office.volatileDependencies": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml": "TODO",
  /* Control Properties */
  "application/vnd.ms-excel.controlproperties+xml": "TODO",
  /* Data Model */
  "application/vnd.openxmlformats-officedocument.model+data": "TODO",
  /* Survey */
  "application/vnd.ms-excel.Survey+xml": "TODO",
  /* Drawing */
  "application/vnd.openxmlformats-officedocument.drawing+xml": "drawings",
  "application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml": "TODO",
  /* VML */
  "application/vnd.openxmlformats-officedocument.vmlDrawing": "TODO",
  "application/vnd.openxmlformats-package.relationships+xml": "rels",
  "application/vnd.openxmlformats-officedocument.oleObject": "TODO",
  /* Image */
  "image/png": "TODO",
  sheet: "js"
};
function gi() {
  return {
    workbooks: [],
    sheets: [],
    charts: [],
    dialogs: [],
    macros: [],
    rels: [],
    strs: [],
    comments: [],
    threadedcomments: [],
    links: [],
    coreprops: [],
    extprops: [],
    custprops: [],
    themes: [],
    styles: [],
    calcchains: [],
    vba: [],
    drawings: [],
    metadata: [],
    people: [],
    TODO: [],
    xmlns: ""
  };
}
function _i(e) {
  var t = gi();
  if (!e || !e.match)
    return t;
  var r = {};
  if ((e.match(k1) || []).forEach(function(a) {
    var n = x0(a);
    switch (n[0].replace(Sn, "<")) {
      case "<?xml":
        break;
      case "<Types":
        t.xmlns = n["xmlns" + (n[0].match(/<(\w+):/) || ["", ""])[1]];
        break;
      case "<Default":
        r[n.Extension.toLowerCase()] = n.ContentType;
        break;
      case "<Override":
        t[q5[n.ContentType]] !== void 0 && t[q5[n.ContentType]].push(n.PartName);
        break;
    }
  }), t.xmlns !== Pn.CT)
    throw new Error("Unknown Namespace: " + t.xmlns);
  return t.calcchain = t.calcchains.length > 0 ? t.calcchains[0] : "", t.sst = t.strs.length > 0 ? t.strs[0] : "", t.style = t.styles.length > 0 ? t.styles[0] : "", t.defaults = r, delete t.calcchains, t;
}
var l3 = {
  WB: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
  SHEET: "http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
  HLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
  VML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
  XPATH: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLinkPath",
  XMISS: "http://schemas.microsoft.com/office/2006/relationships/xlExternalLinkPath/xlPathMissing",
  XLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLink",
  CXML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml",
  CXMLP: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXmlProps",
  CMNT: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments",
  CORE_PROPS: "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties",
  EXT_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties",
  CUST_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties",
  SST: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings",
  STY: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",
  THEME: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",
  CHART: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chart",
  CHARTEX: "http://schemas.microsoft.com/office/2014/relationships/chartEx",
  CS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet",
  WS: [
    "http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
    "http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"
  ],
  DS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet",
  MS: "http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet",
  IMG: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
  DRAW: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing",
  XLMETA: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sheetMetadata",
  TCMNT: "http://schemas.microsoft.com/office/2017/10/relationships/threadedComment",
  PEOPLE: "http://schemas.microsoft.com/office/2017/10/relationships/person",
  CONN: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/connections",
  VBA: "http://schemas.microsoft.com/office/2006/relationships/vbaProject"
};
function _4(e) {
  var t = e.lastIndexOf("/");
  return e.slice(0, t + 1) + "_rels/" + e.slice(t + 1) + ".rels";
}
function P3(e, t) {
  var r = { "!id": {} };
  if (!e)
    return r;
  t.charAt(0) !== "/" && (t = "/" + t);
  var a = {};
  return (e.match(k1) || []).forEach(function(n) {
    var i = x0(n);
    if (i[0] === "<Relationship") {
      var c = {};
      c.Type = i.Type, c.Target = R0(i.Target), c.Id = i.Id, i.TargetMode && (c.TargetMode = i.TargetMode);
      var s = i.TargetMode === "External" ? i.Target : o3(i.Target, t);
      r[s] = c, a[i.Id] = c;
    }
  }), r["!id"] = a, r;
}
var Ti = "application/vnd.oasis.opendocument.spreadsheet";
function Ei(e, t) {
  for (var r = Xe(e), a, n; a = u1.exec(r); )
    switch (a[3]) {
      case "manifest":
        break;
      case "file-entry":
        if (n = x0(a[0], !1), n.path == "/" && n.type !== Ti)
          throw new Error("This OpenDocument is not a spreadsheet");
        break;
      case "encryption-data":
      case "algorithm":
      case "start-key-generation":
      case "key-derivation":
        throw new Error("Unsupported ODS Encryption");
      default:
        if (t && t.WTF)
          throw a;
    }
}
var L3 = [
  ["cp:category", "Category"],
  ["cp:contentStatus", "ContentStatus"],
  ["cp:keywords", "Keywords"],
  ["cp:lastModifiedBy", "LastAuthor"],
  ["cp:lastPrinted", "LastPrinted"],
  ["cp:revision", "RevNumber"],
  ["cp:version", "Version"],
  ["dc:creator", "Author"],
  ["dc:description", "Comments"],
  ["dc:identifier", "Identifier"],
  ["dc:language", "Language"],
  ["dc:subject", "Subject"],
  ["dc:title", "Title"],
  ["dcterms:created", "CreatedDate", "date"],
  ["dcterms:modified", "ModifiedDate", "date"]
], wi = /* @__PURE__ */ function() {
  for (var e = new Array(L3.length), t = 0; t < L3.length; ++t) {
    var r = L3[t], a = "(?:" + r[0].slice(0, r[0].indexOf(":")) + ":)" + r[0].slice(r[0].indexOf(":") + 1);
    e[t] = new RegExp("<" + a + "[^>]*>([\\s\\S]*?)</" + a + ">");
  }
  return e;
}();
function h7(e) {
  var t = {};
  e = X0(e);
  for (var r = 0; r < L3.length; ++r) {
    var a = L3[r], n = e.match(wi[r]);
    n != null && n.length > 0 && (t[a[1]] = R0(n[1])), a[2] === "date" && t[a[1]] && (t[a[1]] = w1(t[a[1]]));
  }
  return t;
}
var ki = [
  ["Application", "Application", "string"],
  ["AppVersion", "AppVersion", "string"],
  ["Company", "Company", "string"],
  ["DocSecurity", "DocSecurity", "string"],
  ["Manager", "Manager", "string"],
  ["HyperlinksChanged", "HyperlinksChanged", "bool"],
  ["SharedDoc", "SharedDoc", "bool"],
  ["LinksUpToDate", "LinksUpToDate", "bool"],
  ["ScaleCrop", "ScaleCrop", "bool"],
  ["HeadingPairs", "HeadingPairs", "raw"],
  ["TitlesOfParts", "TitlesOfParts", "raw"]
];
function u7(e, t, r, a) {
  var n = [];
  if (typeof e == "string")
    n = W5(e, a);
  else
    for (var i = 0; i < e.length; ++i)
      n = n.concat(e[i].map(function(l) {
        return { v: l };
      }));
  var c = typeof t == "string" ? W5(t, a).map(function(l) {
    return l.v;
  }) : t, s = 0, f = 0;
  if (c.length > 0)
    for (var o = 0; o !== n.length; o += 2) {
      switch (f = +n[o + 1].v, n[o].v) {
        case "Worksheets":
        case "工作表":
        case "Листы":
        case "أوراق العمل":
        case "ワークシート":
        case "גליונות עבודה":
        case "Arbeitsblätter":
        case "Çalışma Sayfaları":
        case "Feuilles de calcul":
        case "Fogli di lavoro":
        case "Folhas de cálculo":
        case "Planilhas":
        case "Regneark":
        case "Hojas de cálculo":
        case "Werkbladen":
          r.Worksheets = f, r.SheetNames = c.slice(s, s + f);
          break;
        case "Named Ranges":
        case "Rangos con nombre":
        case "名前付き一覧":
        case "Benannte Bereiche":
        case "Navngivne områder":
          r.NamedRanges = f, r.DefinedNames = c.slice(s, s + f);
          break;
        case "Charts":
        case "Diagramme":
          r.Chartsheets = f, r.ChartNames = c.slice(s, s + f);
          break;
      }
      s += f;
    }
}
function Ci(e, t, r) {
  var a = {};
  return t || (t = {}), e = X0(e), ki.forEach(function(n) {
    var i = (e.match(X3(n[0])) || [])[1];
    switch (n[2]) {
      case "string":
        i && (t[n[1]] = R0(i));
        break;
      case "bool":
        t[n[1]] = i === "true";
        break;
      case "raw":
        var c = e.match(new RegExp("<" + n[0] + "[^>]*>([\\s\\S]*?)</" + n[0] + ">"));
        c && c.length > 0 && (a[n[1]] = c[1]);
        break;
    }
  }), a.HeadingPairs && a.TitlesOfParts && u7(a.HeadingPairs, a.TitlesOfParts, t, r), t;
}
var Si = /<[^>]+>[^<]*/g;
function Ai(e, t) {
  var r = {}, a = "", n = e.match(Si);
  if (n)
    for (var i = 0; i != n.length; ++i) {
      var c = n[i], s = x0(c);
      switch (a2(s[0])) {
        case "<?xml":
          break;
        case "<Properties":
          break;
        case "<property":
          a = R0(s.name);
          break;
        case "</property>":
          a = null;
          break;
        default:
          if (c.indexOf("<vt:") === 0) {
            var f = c.split(">"), o = f[0].slice(4), l = f[1];
            switch (o) {
              case "lpstr":
              case "bstr":
              case "lpwstr":
                r[a] = R0(l);
                break;
              case "bool":
                r[a] = G0(l);
                break;
              case "i1":
              case "i2":
              case "i4":
              case "i8":
              case "int":
              case "uint":
                r[a] = parseInt(l, 10);
                break;
              case "r4":
              case "r8":
              case "decimal":
                r[a] = parseFloat(l);
                break;
              case "filetime":
              case "date":
                r[a] = w1(l);
                break;
              case "cy":
              case "error":
                r[a] = R0(l);
                break;
              default:
                if (o.slice(-1) == "/")
                  break;
                t.WTF && typeof console < "u" && console.warn("Unexpected", c, o, f);
            }
          } else if (c.slice(0, 2) !== "</") {
            if (t.WTF)
              throw new Error(c);
          }
      }
    }
  return r;
}
var Fi = {
  Title: "Title",
  Subject: "Subject",
  Author: "Author",
  Keywords: "Keywords",
  Comments: "Description",
  LastAuthor: "LastAuthor",
  RevNumber: "Revision",
  Application: "AppName",
  /* TotalTime: 'TotalTime', */
  LastPrinted: "LastPrinted",
  CreatedDate: "Created",
  ModifiedDate: "LastSaved",
  /* Pages */
  /* Words */
  /* Characters */
  Category: "Category",
  /* PresentationFormat */
  Manager: "Manager",
  Company: "Company",
  /* Guid */
  /* HyperlinkBase */
  /* Bytes */
  /* Lines */
  /* Paragraphs */
  /* CharactersWithSpaces */
  AppVersion: "Version",
  ContentStatus: "ContentStatus",
  /* NOTE: missing from schema */
  Identifier: "Identifier",
  /* NOTE: missing from schema */
  Language: "Language"
  /* NOTE: missing from schema */
}, o4;
function yi(e, t, r) {
  o4 || (o4 = H4(Fi)), t = o4[t] || t, e[t] = r;
}
function X4(e) {
  var t = e.read_shift(4), r = e.read_shift(4);
  return new Date((r / 1e7 * Math.pow(2, 32) + t / 1e7 - 11644473600) * 1e3).toISOString().replace(/\.000/, "");
}
function x7(e, t, r) {
  var a = e.l, n = e.read_shift(0, "lpstr-cp");
  if (r)
    for (; e.l - a & 3; )
      ++e.l;
  return n;
}
function d7(e, t, r) {
  var a = e.read_shift(0, "lpwstr");
  return a;
}
function p7(e, t, r) {
  return t === 31 ? d7(e) : x7(e, t, r);
}
function T4(e, t, r) {
  return p7(e, t, r === !1 ? 0 : 4);
}
function Ii(e, t) {
  if (!t)
    throw new Error("VtUnalignedString must have positive length");
  return p7(e, t, 0);
}
function bi(e) {
  for (var t = e.read_shift(4), r = [], a = 0; a != t; ++a) {
    var n = e.l;
    r[a] = e.read_shift(0, "lpwstr").replace(L1, ""), e.l - n & 2 && (e.l += 2);
  }
  return r;
}
function Di(e) {
  for (var t = e.read_shift(4), r = [], a = 0; a != t; ++a)
    r[a] = e.read_shift(0, "lpstr-cp").replace(L1, "");
  return r;
}
function Oi(e) {
  var t = e.l, r = Oe(e, f7);
  e[e.l] == 0 && e[e.l + 1] == 0 && e.l - t & 2 && (e.l += 2);
  var a = Oe(e, H1);
  return [r, a];
}
function Ri(e) {
  for (var t = e.read_shift(4), r = [], a = 0; a < t / 2; ++a)
    r.push(Oi(e));
  return r;
}
function Z5(e, t) {
  for (var r = e.read_shift(4), a = {}, n = 0; n != r; ++n) {
    var i = e.read_shift(4), c = e.read_shift(4);
    a[i] = e.read_shift(c, t === 1200 ? "utf16le" : "utf8").replace(L1, "").replace(I3, "!"), t === 1200 && c % 2 && (e.l += 2);
  }
  return e.l & 3 && (e.l = e.l >> 3 << 2), a;
}
function m7(e) {
  var t = e.read_shift(4), r = e.slice(e.l, e.l + t);
  return e.l += t, (t & 3) > 0 && (e.l += 4 - (t & 3) & 3), r;
}
function Mi(e) {
  var t = {};
  return t.Size = e.read_shift(4), e.l += t.Size + 3 - (t.Size - 1) % 4, t;
}
function Oe(e, t, r) {
  var a = e.read_shift(2), n, i = r || {};
  if (e.l += 2, t !== Y5 && a !== t && ui.indexOf(t) === -1 && !((t & 65534) == 4126 && (a & 65534) == 4126))
    throw new Error("Expected type " + t + " saw " + a);
  switch (t === Y5 ? a : t) {
    case 2:
      return n = e.read_shift(2, "i"), i.raw || (e.l += 2), n;
    case 3:
      return n = e.read_shift(4, "i"), n;
    case 11:
      return e.read_shift(4) !== 0;
    case 19:
      return n = e.read_shift(4), n;
    case 30:
      return x7(e, a, 4).replace(L1, "");
    case 31:
      return d7(e);
    case 64:
      return X4(e);
    case 65:
      return m7(e);
    case 71:
      return Mi(e);
    case 80:
      return T4(e, a, !i.raw).replace(L1, "");
    case 81:
      return Ii(
        e,
        a
        /*, 4*/
      ).replace(L1, "");
    case 4108:
      return Ri(e);
    case 4126:
    case 4127:
      return a == 4127 ? bi(e) : Di(e);
    default:
      throw new Error("TypedPropertyValue unrecognized type " + t + " " + a);
  }
}
function Q5(e, t) {
  var r = e.l, a = e.read_shift(4), n = e.read_shift(4), i = [], c = 0, s = 0, f = -1, o = {};
  for (c = 0; c != n; ++c) {
    var l = e.read_shift(4), d = e.read_shift(4);
    i[c] = [l, d + r];
  }
  i.sort(function(T, g) {
    return T[1] - g[1];
  });
  var u = {};
  for (c = 0; c != n; ++c) {
    if (e.l !== i[c][1]) {
      var h = !0;
      if (c > 0 && t)
        switch (t[i[c - 1][0]].t) {
          case 2:
            e.l + 2 === i[c][1] && (e.l += 2, h = !1);
            break;
          case 80:
            e.l <= i[c][1] && (e.l = i[c][1], h = !1);
            break;
          case 4108:
            e.l <= i[c][1] && (e.l = i[c][1], h = !1);
            break;
        }
      if ((!t || c == 0) && e.l <= i[c][1] && (h = !1, e.l = i[c][1]), h)
        throw new Error("Read Error: Expected address " + i[c][1] + " at " + e.l + " :" + c);
    }
    if (t) {
      if (i[c][0] == 0 && i.length > c + 1 && i[c][1] == i[c + 1][1])
        continue;
      var p = t[i[c][0]];
      if (u[p.n] = Oe(e, p.t, { raw: !0 }), p.p === "version" && (u[p.n] = String(u[p.n] >> 16) + "." + ("0000" + String(u[p.n] & 65535)).slice(-4)), p.n == "CodePage")
        switch (u[p.n]) {
          case 0:
            u[p.n] = 1252;
          case 874:
          case 932:
          case 936:
          case 949:
          case 950:
          case 1250:
          case 1251:
          case 1253:
          case 1254:
          case 1255:
          case 1256:
          case 1257:
          case 1258:
          case 1e4:
          case 1200:
          case 1201:
          case 1252:
          case 65e3:
          case -536:
          case 65001:
          case -535:
            o2(s = u[p.n] >>> 0 & 65535);
            break;
          default:
            throw new Error("Unsupported CodePage: " + u[p.n]);
        }
    } else if (i[c][0] === 1) {
      if (s = u.CodePage = Oe(e, $4), o2(s), f !== -1) {
        var v = e.l;
        e.l = i[f][1], o = Z5(e, s), e.l = v;
      }
    } else if (i[c][0] === 0) {
      if (s === 0) {
        f = c, e.l = i[c + 1][1];
        continue;
      }
      o = Z5(e, s);
    } else {
      var x = o[i[c][0]], m;
      switch (e[e.l]) {
        case 65:
          e.l += 4, m = m7(e);
          break;
        case 30:
          e.l += 4, m = T4(e, e[e.l - 4]).replace(/\u0000+$/, "");
          break;
        case 31:
          e.l += 4, m = T4(e, e[e.l - 4]).replace(/\u0000+$/, "");
          break;
        case 3:
          e.l += 4, m = e.read_shift(4, "i");
          break;
        case 19:
          e.l += 4, m = e.read_shift(4);
          break;
        case 5:
          e.l += 4, m = e.read_shift(8, "f");
          break;
        case 11:
          e.l += 4, m = f1(e, 4);
          break;
        case 64:
          e.l += 4, m = w1(X4(e));
          break;
        default:
          throw new Error("unparsed value: " + e[e.l]);
      }
      u[x] = m;
    }
  }
  return e.l = r + a, u;
}
function er(e, t, r) {
  var a = e.content;
  if (!a)
    return {};
  m1(a, 0);
  var n, i, c, s, f = 0;
  a.chk("feff", "Byte Order: "), a.read_shift(2);
  var o = a.read_shift(4), l = a.read_shift(16);
  if (l !== L0.utils.consts.HEADER_CLSID && l !== r)
    throw new Error("Bad PropertySet CLSID " + l);
  if (n = a.read_shift(4), n !== 1 && n !== 2)
    throw new Error("Unrecognized #Sets: " + n);
  if (i = a.read_shift(16), s = a.read_shift(4), n === 1 && s !== a.l)
    throw new Error("Length mismatch: " + s + " !== " + a.l);
  n === 2 && (c = a.read_shift(16), f = a.read_shift(4));
  var d = Q5(a, t), u = { SystemIdentifier: o };
  for (var h in d)
    u[h] = d[h];
  if (u.FMTID = i, n === 1)
    return u;
  if (f - a.l == 2 && (a.l += 2), a.l !== f)
    throw new Error("Length mismatch 2: " + a.l + " !== " + f);
  var p;
  try {
    p = Q5(a, null);
  } catch {
  }
  for (h in p)
    u[h] = p[h];
  return u.FMTID = [i, c], u;
}
function y2(e, t) {
  return e.read_shift(t), null;
}
function Ni(e, t, r) {
  for (var a = [], n = e.l + t; e.l < n; )
    a.push(r(e, n - e.l));
  if (n !== e.l)
    throw new Error("Slurp error");
  return a;
}
function f1(e, t) {
  return e.read_shift(t) === 1;
}
function i1(e) {
  return e.read_shift(2, "u");
}
function v7(e, t) {
  return Ni(e, t, i1);
}
function g7(e) {
  var t = e.read_shift(1), r = e.read_shift(1);
  return r === 1 ? t : t === 1;
}
function p3(e, t, r) {
  var a = e.read_shift(r && r.biff >= 12 ? 2 : 1), n = "sbcs-cont", i = e2;
  if (r && r.biff >= 8 && (e2 = 1200), !r || r.biff == 8) {
    var c = e.read_shift(1);
    c && (n = "dbcs-cont");
  } else
    r.biff == 12 && (n = "wstr");
  r.biff >= 2 && r.biff <= 5 && (n = "cpstr");
  var s = a ? e.read_shift(a, n) : "";
  return e2 = i, s;
}
function Pi(e) {
  var t = e2;
  e2 = 1200;
  var r = e.read_shift(2), a = e.read_shift(1), n = a & 4, i = a & 8, c = 1 + (a & 1), s = 0, f, o = {};
  i && (s = e.read_shift(2)), n && (f = e.read_shift(4));
  var l = c == 2 ? "dbcs-cont" : "sbcs-cont", d = r === 0 ? "" : e.read_shift(r, l);
  return i && (e.l += 4 * s), n && (e.l += f), o.t = d, i || (o.raw = "<t>" + o.t + "</t>", o.r = o.t), e2 = t, o;
}
function q2(e, t, r) {
  var a;
  if (r) {
    if (r.biff >= 2 && r.biff <= 5)
      return e.read_shift(t, "cpstr");
    if (r.biff >= 12)
      return e.read_shift(t, "dbcs-cont");
  }
  var n = e.read_shift(1);
  return n === 0 ? a = e.read_shift(t, "sbcs-cont") : a = e.read_shift(t, "dbcs-cont"), a;
}
function te(e, t, r) {
  var a = e.read_shift(r && r.biff == 2 ? 1 : 2);
  return a === 0 ? (e.l++, "") : q2(e, a, r);
}
function a3(e, t, r) {
  if (r.biff > 5)
    return te(e, t, r);
  var a = e.read_shift(1);
  return a === 0 ? (e.l++, "") : e.read_shift(a, r.biff <= 4 || !e.lens ? "cpstr" : "sbcs-cont");
}
function Li(e) {
  var t = e.read_shift(1);
  e.l++;
  var r = e.read_shift(2);
  return e.l += 2, [t, r];
}
function Bi(e) {
  var t = e.read_shift(4), r = e.l, a = !1;
  t > 24 && (e.l += t - 24, e.read_shift(16) === "795881f43b1d7f48af2c825dc4852763" && (a = !0), e.l = r);
  var n = e.read_shift((a ? t - 24 : t) >> 1, "utf16le").replace(L1, "");
  return a && (e.l += 24), n;
}
function Ui(e) {
  for (var t = e.read_shift(2), r = ""; t-- > 0; )
    r += "../";
  var a = e.read_shift(0, "lpstr-ansi");
  if (e.l += 2, e.read_shift(2) != 57005)
    throw new Error("Bad FileMoniker");
  var n = e.read_shift(4);
  if (n === 0)
    return r + a.replace(/\\/g, "/");
  var i = e.read_shift(4);
  if (e.read_shift(2) != 3)
    throw new Error("Bad FileMoniker");
  var c = e.read_shift(i >> 1, "utf16le").replace(L1, "");
  return r + c;
}
function Hi(e, t) {
  var r = e.read_shift(16);
  switch (r) {
    case "e0c9ea79f9bace118c8200aa004ba90b":
      return Bi(e);
    case "0303000000000000c000000000000046":
      return Ui(e);
    default:
      throw new Error("Unsupported Moniker " + r);
  }
}
function ve(e) {
  var t = e.read_shift(4), r = t > 0 ? e.read_shift(t, "utf16le").replace(L1, "") : "";
  return r;
}
function Wi(e, t) {
  var r = e.l + t, a = e.read_shift(4);
  if (a !== 2)
    throw new Error("Unrecognized streamVersion: " + a);
  var n = e.read_shift(2);
  e.l += 2;
  var i, c, s, f, o = "", l, d;
  n & 16 && (i = ve(e, r - e.l)), n & 128 && (c = ve(e, r - e.l)), (n & 257) === 257 && (s = ve(e, r - e.l)), (n & 257) === 1 && (f = Hi(e, r - e.l)), n & 8 && (o = ve(e, r - e.l)), n & 32 && (l = e.read_shift(16)), n & 64 && (d = X4(
    e
    /*, 8*/
  )), e.l = r;
  var u = c || s || f || "";
  u && o && (u += "#" + o), u || (u = "#" + o), n & 2 && u.charAt(0) == "/" && u.charAt(1) != "/" && (u = "file://" + u);
  var h = { Target: u };
  return l && (h.guid = l), d && (h.time = d), i && (h.Tooltip = i), h;
}
function _7(e) {
  var t = e.read_shift(1), r = e.read_shift(1), a = e.read_shift(1), n = e.read_shift(1);
  return [t, r, a, n];
}
function T7(e, t) {
  var r = _7(e);
  return r[3] = 0, r;
}
function x2(e, t, r) {
  var a = e.read_shift(2), n = e.read_shift(2), i = { r: a, c: n, ixfe: 0 };
  if (r && r.biff == 2 || t == 7) {
    var c = e.read_shift(1);
    i.ixfe = c & 63, e.l += 2;
  } else
    i.ixfe = e.read_shift(2);
  return i;
}
function Vi(e) {
  var t = e.read_shift(2), r = e.read_shift(2);
  return e.l += 8, { type: t, flags: r };
}
function Gi(e, t, r) {
  return t === 0 ? "" : a3(e, t, r);
}
function ji(e, t, r) {
  var a = r.biff > 8 ? 4 : 2, n = e.read_shift(a), i = e.read_shift(a, "i"), c = e.read_shift(a, "i");
  return [n, i, c];
}
function E7(e) {
  var t = e.read_shift(2), r = Ye(e);
  return [t, r];
}
function zi(e, t, r) {
  e.l += 4, t -= 4;
  var a = e.l + t, n = p3(e, t, r), i = e.read_shift(2);
  if (a -= e.l, i !== a)
    throw new Error("Malformed AddinUdf: padding = " + a + " != " + i);
  return e.l += i, n;
}
function Je(e) {
  var t = e.read_shift(2), r = e.read_shift(2), a = e.read_shift(2), n = e.read_shift(2);
  return { s: { c: a, r: t }, e: { c: n, r } };
}
function w7(e) {
  var t = e.read_shift(2), r = e.read_shift(2), a = e.read_shift(1), n = e.read_shift(1);
  return { s: { c: a, r: t }, e: { c: n, r } };
}
var $i = w7;
function k7(e) {
  e.l += 4;
  var t = e.read_shift(2), r = e.read_shift(2), a = e.read_shift(2);
  return e.l += 12, [r, t, a];
}
function Xi(e) {
  var t = {};
  return e.l += 4, e.l += 16, t.fSharedNote = e.read_shift(2), e.l += 4, t;
}
function Ki(e) {
  var t = {};
  return e.l += 4, e.cf = e.read_shift(2), t;
}
function S1(e) {
  e.l += 2, e.l += e.read_shift(2);
}
var Yi = {
  /*::[*/
  0: S1,
  /* FtEnd */
  /*::[*/
  4: S1,
  /* FtMacro */
  /*::[*/
  5: S1,
  /* FtButton */
  /*::[*/
  6: S1,
  /* FtGmo */
  /*::[*/
  7: Ki,
  /* FtCf */
  /*::[*/
  8: S1,
  /* FtPioGrbit */
  /*::[*/
  9: S1,
  /* FtPictFmla */
  /*::[*/
  10: S1,
  /* FtCbls */
  /*::[*/
  11: S1,
  /* FtRbo */
  /*::[*/
  12: S1,
  /* FtSbs */
  /*::[*/
  13: Xi,
  /* FtNts */
  /*::[*/
  14: S1,
  /* FtSbsFmla */
  /*::[*/
  15: S1,
  /* FtGboData */
  /*::[*/
  16: S1,
  /* FtEdoData */
  /*::[*/
  17: S1,
  /* FtRboData */
  /*::[*/
  18: S1,
  /* FtCblsData */
  /*::[*/
  19: S1,
  /* FtLbsData */
  /*::[*/
  20: S1,
  /* FtCblsFmla */
  /*::[*/
  21: k7
};
function Ji(e, t) {
  for (var r = e.l + t, a = []; e.l < r; ) {
    var n = e.read_shift(2);
    e.l -= 2;
    try {
      a[n] = Yi[n](e, r - e.l);
    } catch {
      return e.l = r, a;
    }
  }
  return e.l != r && (e.l = r), a;
}
function ge(e, t) {
  var r = { BIFFVer: 0, dt: 0 };
  switch (r.BIFFVer = e.read_shift(2), t -= 2, t >= 2 && (r.dt = e.read_shift(2), e.l -= 2), r.BIFFVer) {
    case 1536:
    case 1280:
    case 1024:
    case 768:
    case 512:
    case 2:
    case 7:
      break;
    default:
      if (t > 6)
        throw new Error("Unexpected BIFF Ver " + r.BIFFVer);
  }
  return e.read_shift(t), r;
}
function qi(e, t) {
  return t === 0 || e.read_shift(2), 1200;
}
function Zi(e, t, r) {
  if (r.enc)
    return e.l += t, "";
  var a = e.l, n = a3(e, 0, r);
  return e.read_shift(t + a - e.l), n;
}
function Qi(e, t, r) {
  var a = r && r.biff == 8 || t == 2 ? e.read_shift(2) : (e.l += t, 0);
  return { fDialog: a & 16, fBelow: a & 64, fRight: a & 128 };
}
function es(e, t, r) {
  var a = "";
  if (r.biff == 4)
    return a = p3(e, 0, r), a.length === 0 && (a = "Sheet1"), { name: a };
  var n = e.read_shift(4), i = e.read_shift(1) & 3, c = e.read_shift(1);
  switch (c) {
    case 0:
      c = "Worksheet";
      break;
    case 1:
      c = "Macrosheet";
      break;
    case 2:
      c = "Chartsheet";
      break;
    case 6:
      c = "VBAModule";
      break;
  }
  return a = p3(e, 0, r), a.length === 0 && (a = "Sheet1"), { pos: n, hs: i, dt: c, name: a };
}
function rs(e, t) {
  for (var r = e.l + t, a = e.read_shift(4), n = e.read_shift(4), i = [], c = 0; c != n && e.l < r; ++c)
    i.push(Pi(e));
  return i.Count = a, i.Unique = n, i;
}
function ts(e, t) {
  var r = {};
  return r.dsst = e.read_shift(2), e.l += t - 2, r;
}
function as(e) {
  var t = {};
  t.r = e.read_shift(2), t.c = e.read_shift(2), t.cnt = e.read_shift(2) - t.c;
  var r = e.read_shift(2);
  e.l += 4;
  var a = e.read_shift(1);
  return e.l += 3, a & 7 && (t.level = a & 7), a & 32 && (t.hidden = !0), a & 64 && (t.hpt = r / 20), t;
}
function ns(e) {
  var t = Vi(e);
  if (t.type != 2211)
    throw new Error("Invalid Future Record " + t.type);
  var r = e.read_shift(4);
  return r !== 0;
}
function is(e) {
  return e.read_shift(2), e.read_shift(4);
}
function rr(e, t, r) {
  var a = 0;
  r && r.biff == 2 || (a = e.read_shift(2));
  var n = e.read_shift(2);
  r && r.biff == 2 && (a = 1 - (n >> 15), n &= 32767);
  var i = { Unsynced: a & 1, DyZero: (a & 2) >> 1, ExAsc: (a & 4) >> 2, ExDsc: (a & 8) >> 3 };
  return [i, n];
}
function ss(e) {
  var t = e.read_shift(2), r = e.read_shift(2), a = e.read_shift(2), n = e.read_shift(2), i = e.read_shift(2), c = e.read_shift(2), s = e.read_shift(2), f = e.read_shift(2), o = e.read_shift(2);
  return {
    Pos: [t, r],
    Dim: [a, n],
    Flags: i,
    CurTab: c,
    FirstTab: s,
    Selected: f,
    TabRatio: o
  };
}
function cs(e, t, r) {
  if (r && r.biff >= 2 && r.biff < 5)
    return {};
  var a = e.read_shift(2);
  return { RTL: a & 64 };
}
function fs() {
}
function os(e, t, r) {
  var a = {
    dyHeight: e.read_shift(2),
    fl: e.read_shift(2)
  };
  switch (r && r.biff || 8) {
    case 2:
      break;
    case 3:
    case 4:
      e.l += 2;
      break;
    default:
      e.l += 10;
      break;
  }
  return a.name = p3(e, 0, r), a;
}
function ls(e, t, r) {
  var a = x2(e, t, r);
  return a.isst = e.read_shift(4), a;
}
function hs(e, t, r) {
  r.biffguess && r.biff == 2 && (r.biff = 5);
  var a = e.l + t, n = x2(e, t, r), i = te(e, a - e.l, r);
  return n.val = i, n;
}
function us(e, t, r) {
  var a = e.read_shift(2), n = a3(e, 0, r);
  return [a, n];
}
var xs = a3;
function tr(e, t, r) {
  var a = e.l + t, n = r.biff == 8 || !r.biff ? 4 : 2, i = e.read_shift(n), c = e.read_shift(n), s = e.read_shift(2), f = e.read_shift(2);
  return e.l = a, { s: { r: i, c: s }, e: { r: c, c: f } };
}
function ds(e) {
  var t = e.read_shift(2), r = e.read_shift(2), a = E7(e);
  return { r: t, c: r, ixfe: a[0], rknum: a[1] };
}
function ps(e, t) {
  for (var r = e.l + t - 2, a = e.read_shift(2), n = e.read_shift(2), i = []; e.l < r; )
    i.push(E7(e));
  if (e.l !== r)
    throw new Error("MulRK read error");
  var c = e.read_shift(2);
  if (i.length != c - n + 1)
    throw new Error("MulRK length mismatch");
  return { r: a, c: n, C: c, rkrec: i };
}
function ms(e, t) {
  for (var r = e.l + t - 2, a = e.read_shift(2), n = e.read_shift(2), i = []; e.l < r; )
    i.push(e.read_shift(2));
  if (e.l !== r)
    throw new Error("MulBlank read error");
  var c = e.read_shift(2);
  if (i.length != c - n + 1)
    throw new Error("MulBlank length mismatch");
  return { r: a, c: n, C: c, ixfe: i };
}
function vs(e, t, r, a) {
  var n = {}, i = e.read_shift(4), c = e.read_shift(4), s = e.read_shift(4), f = e.read_shift(2);
  return n.patternType = pi[s >> 26], a.cellStyles && (n.alc = i & 7, n.fWrap = i >> 3 & 1, n.alcV = i >> 4 & 7, n.fJustLast = i >> 7 & 1, n.trot = i >> 8 & 255, n.cIndent = i >> 16 & 15, n.fShrinkToFit = i >> 20 & 1, n.iReadOrder = i >> 22 & 2, n.fAtrNum = i >> 26 & 1, n.fAtrFnt = i >> 27 & 1, n.fAtrAlc = i >> 28 & 1, n.fAtrBdr = i >> 29 & 1, n.fAtrPat = i >> 30 & 1, n.fAtrProt = i >> 31 & 1, n.dgLeft = c & 15, n.dgRight = c >> 4 & 15, n.dgTop = c >> 8 & 15, n.dgBottom = c >> 12 & 15, n.icvLeft = c >> 16 & 127, n.icvRight = c >> 23 & 127, n.grbitDiag = c >> 30 & 3, n.icvTop = s & 127, n.icvBottom = s >> 7 & 127, n.icvDiag = s >> 14 & 127, n.dgDiag = s >> 21 & 15, n.icvFore = f & 127, n.icvBack = f >> 7 & 127, n.fsxButton = f >> 14 & 1), n;
}
function gs(e, t, r) {
  var a = {};
  return a.ifnt = e.read_shift(2), a.numFmtId = e.read_shift(2), a.flags = e.read_shift(2), a.fStyle = a.flags >> 2 & 1, t -= 6, a.data = vs(e, t, a.fStyle, r), a;
}
function _s(e) {
  var t = {};
  return t.ifnt = e.read_shift(1), e.l++, t.flags = e.read_shift(1), t.numFmtId = t.flags & 63, t.flags >>= 6, t.fStyle = 0, t.data = {}, t;
}
function Ts(e) {
  var t = {};
  return t.ifnt = e.read_shift(1), t.numFmtId = e.read_shift(1), t.flags = e.read_shift(2), t.fStyle = t.flags >> 2 & 1, t.data = {}, t;
}
function Es(e) {
  var t = {};
  return t.ifnt = e.read_shift(1), t.numFmtId = e.read_shift(1), t.flags = e.read_shift(2), t.fStyle = t.flags >> 2 & 1, t.data = {}, t;
}
function ws(e) {
  e.l += 4;
  var t = [e.read_shift(2), e.read_shift(2)];
  if (t[0] !== 0 && t[0]--, t[1] !== 0 && t[1]--, t[0] > 7 || t[1] > 7)
    throw new Error("Bad Gutters: " + t.join("|"));
  return t;
}
function ks(e, t, r) {
  var a = x2(e, 6, r), n = g7(e);
  return a.val = n, a.t = n === !0 || n === !1 ? "b" : "e", a;
}
function Cs(e, t, r) {
  r.biffguess && r.biff == 2 && (r.biff = 5);
  var a = x2(e, 6, r), n = F1(e);
  return a.val = n, a;
}
var ar = Gi;
function Ss(e, t, r) {
  var a = e.l + t, n = e.read_shift(2), i = e.read_shift(2);
  if (r.sbcch = i, i == 1025 || i == 14849)
    return [i, n];
  if (i < 1 || i > 255)
    throw new Error("Unexpected SupBook type: " + i);
  for (var c = q2(e, i), s = []; a > e.l; )
    s.push(te(e));
  return [i, n, c, s];
}
function nr(e, t, r) {
  var a = e.read_shift(2), n, i = {
    fBuiltIn: a & 1,
    fWantAdvise: a >>> 1 & 1,
    fWantPict: a >>> 2 & 1,
    fOle: a >>> 3 & 1,
    fOleLink: a >>> 4 & 1,
    cf: a >>> 5 & 1023,
    fIcon: a >>> 15 & 1
  };
  return r.sbcch === 14849 && (n = zi(e, t - 2, r)), i.body = n || e.read_shift(t - 2), typeof n == "string" && (i.Name = n), i;
}
function ir(e, t, r) {
  var a = e.l + t, n = e.read_shift(2), i = e.read_shift(1), c = e.read_shift(1), s = e.read_shift(r && r.biff == 2 ? 1 : 2), f = 0;
  (!r || r.biff >= 5) && (r.biff != 5 && (e.l += 2), f = e.read_shift(2), r.biff == 5 && (e.l += 2), e.l += 4);
  var o = q2(e, c, r);
  n & 32 && (o = l7[o.charCodeAt(0)]);
  var l = a - e.l;
  r && r.biff == 2 && --l;
  var d = a == e.l || s === 0 || !(l > 0) ? [] : hl(e, l, r, s);
  return {
    chKey: i,
    Name: o,
    itab: f,
    rgce: d
  };
}
function C7(e, t, r) {
  if (r.biff < 8 || !(r.biff > 8) && t == e[e.l] + (e[e.l + 1] == 3 ? 1 : 0) + 1)
    return sr(e, t, r);
  for (var a = [], n = e.l + t, i = e.read_shift(r.biff > 8 ? 4 : 2); i-- !== 0; )
    a.push(ji(e, r.biff > 8 ? 12 : 6, r));
  if (e.l != n)
    throw new Error("Bad ExternSheet: " + e.l + " != " + n);
  return a;
}
function sr(e, t, r) {
  e[e.l + 1] == 3 && e[e.l]++;
  var a = p3(e, t, r);
  return a.charCodeAt(0) == 3 ? a.slice(1) : a;
}
function As(e, t, r) {
  if (r.biff < 8) {
    e.l += t;
    return;
  }
  var a = e.read_shift(2), n = e.read_shift(2), i = q2(e, a, r), c = q2(e, n, r);
  return [i, c];
}
function Fs(e, t, r) {
  var a = w7(e);
  e.l++;
  var n = e.read_shift(1);
  return t -= 8, [ul(e, t, r), n, a];
}
function cr(e, t, r) {
  var a = $i(e);
  switch (r.biff) {
    case 2:
      e.l++, t -= 7;
      break;
    case 3:
    case 4:
      e.l += 2, t -= 8;
      break;
    default:
      e.l += 6, t -= 12;
  }
  return [a, ol(e, t, r)];
}
function ys(e) {
  var t = e.read_shift(4) !== 0, r = e.read_shift(4) !== 0, a = e.read_shift(4);
  return [t, r, a];
}
function Is(e, t, r) {
  var a = e.read_shift(2), n = e.read_shift(2), i = e.read_shift(2), c = e.read_shift(2), s = a3(e, 0, r);
  return [{ r: a, c: n }, s, c, i];
}
function bs(e, t, r) {
  if (r && r.biff < 8) {
    var a = e.read_shift(2), n = e.read_shift(2);
    if (a == 65535 || a == -1)
      return;
    var i = e.read_shift(2), c = e.read_shift(Math.min(i, 2048), "cpstr");
    return [{ r: a, c: n }, c];
  }
  return Is(e, t, r);
}
function Ds(e, t) {
  for (var r = [], a = e.read_shift(2); a--; )
    r.push(Je(e));
  return r;
}
function Os(e, t, r) {
  if (r && r.biff < 8)
    return Ms(e, t, r);
  var a = k7(e), n = Ji(e, t - 22, a[1]);
  return { cmo: a, ft: n };
}
var Rs = {
  8: function(e, t) {
    var r = e.l + t;
    e.l += 10;
    var a = e.read_shift(2);
    e.l += 4, e.l += 2, e.l += 2, e.l += 2, e.l += 4;
    var n = e.read_shift(1);
    return e.l += n, e.l = r, { fmt: a };
  }
};
function Ms(e, t, r) {
  e.l += 4;
  var a = e.read_shift(2), n = e.read_shift(2), i = e.read_shift(2);
  e.l += 2, e.l += 2, e.l += 2, e.l += 2, e.l += 2, e.l += 2, e.l += 2, e.l += 2, e.l += 2, e.l += 6, t -= 36;
  var c = [];
  return c.push((Rs[a] || b1)(e, t, r)), { cmo: [n, a, i], ft: c };
}
function Ns(e, t, r) {
  var a = e.l, n = "";
  try {
    e.l += 4;
    var i = (r.lastobj || { cmo: [0, 0] }).cmo[1], c;
    [0, 5, 7, 11, 12, 14].indexOf(i) == -1 ? e.l += 6 : c = Li(e, 6, r);
    var s = e.read_shift(2);
    e.read_shift(2), i1(e, 2);
    var f = e.read_shift(2);
    e.l += f;
    for (var o = 1; o < e.lens.length - 1; ++o) {
      if (e.l - a != e.lens[o])
        throw new Error("TxO: bad continue record");
      var l = e[e.l], d = q2(e, e.lens[o + 1] - e.lens[o] - 1);
      if (n += d, n.length >= (l ? s : 2 * s))
        break;
    }
    if (n.length !== s && n.length !== s * 2)
      throw new Error("cchText: " + s + " != " + n.length);
    return e.l = a + t, { t: n };
  } catch {
    return e.l = a + t, { t: n };
  }
}
function Ps(e, t) {
  var r = Je(e);
  e.l += 16;
  var a = Wi(e, t - 24);
  return [r, a];
}
function Ls(e, t) {
  e.read_shift(2);
  var r = Je(e), a = e.read_shift((t - 10) / 2, "dbcs-cont");
  return a = a.replace(L1, ""), [r, a];
}
function Bs(e) {
  var t = [0, 0], r;
  return r = e.read_shift(2), t[0] = J5[r] || r, r = e.read_shift(2), t[1] = J5[r] || r, t;
}
function Us(e) {
  for (var t = e.read_shift(2), r = []; t-- > 0; )
    r.push(T7(e));
  return r;
}
function Hs(e) {
  for (var t = e.read_shift(2), r = []; t-- > 0; )
    r.push(T7(e));
  return r;
}
function Ws(e) {
  e.l += 2;
  var t = { cxfs: 0, crc: 0 };
  return t.cxfs = e.read_shift(2), t.crc = e.read_shift(4), t;
}
function S7(e, t, r) {
  if (!r.cellStyles)
    return b1(e, t);
  var a = r && r.biff >= 12 ? 4 : 2, n = e.read_shift(a), i = e.read_shift(a), c = e.read_shift(a), s = e.read_shift(a), f = e.read_shift(2);
  a == 2 && (e.l += 2);
  var o = { s: n, e: i, w: c, ixfe: s, flags: f };
  return (r.biff >= 5 || !r.biff) && (o.level = f >> 8 & 7), o;
}
function Vs(e, t) {
  var r = {};
  return t < 32 || (e.l += 16, r.header = F1(e), r.footer = F1(e), e.l += 2), r;
}
function Gs(e, t, r) {
  var a = { area: !1 };
  if (r.biff != 5)
    return e.l += t, a;
  var n = e.read_shift(1);
  return e.l += 3, n & 16 && (a.area = !0), a;
}
var js = x2, zs = v7, $s = te;
function Xs(e) {
  var t = e.read_shift(2), r = e.read_shift(2), a = e.read_shift(4), n = { fmt: t, env: r, len: a, data: e.slice(e.l, e.l + a) };
  return e.l += a, n;
}
function Ks(e, t, r) {
  r.biffguess && r.biff == 5 && (r.biff = 2);
  var a = x2(e, 7, r), n = a3(e, t - 7, r);
  return a.t = "str", a.val = n, a;
}
function Ys(e, t, r) {
  var a = x2(e, 7, r), n = F1(e);
  return a.t = "n", a.val = n, a;
}
function Js(e, t, r) {
  var a = x2(e, 7, r), n = e.read_shift(2);
  return a.t = "n", a.val = n, a;
}
function qs(e) {
  var t = e.read_shift(1);
  return t === 0 ? (e.l++, "") : e.read_shift(t, "sbcs-cont");
}
function Zs(e, t, r) {
  var a = e.l + 7, n = x2(e, 6, r);
  e.l = a;
  var i = g7(e);
  return n.val = i, n.t = i === !0 || i === !1 ? "b" : "e", n;
}
function Qs(e, t) {
  e.l += 6, e.l += 2, e.l += 1, e.l += 3, e.l += 1, e.l += t - 13;
}
function ec(e, t, r) {
  var a = e.l + t, n = x2(e, 6, r), i = e.read_shift(2), c = q2(e, i, r);
  return e.l = a, n.t = "str", n.val = c, n;
}
function rc(e) {
  var t = e.read_shift(4), r = e.read_shift(1), a = e.read_shift(r, "sbcs");
  return a.length === 0 && (a = "Sheet1"), { flags: t, name: a };
}
var tc = [2, 3, 48, 49, 131, 139, 140, 245], fr = /* @__PURE__ */ function() {
  var e = {
    /* Code Pages Supported by Visual FoxPro */
    /*::[*/
    1: 437,
    /*::[*/
    2: 850,
    /*::[*/
    3: 1252,
    /*::[*/
    4: 1e4,
    /*::[*/
    100: 852,
    /*::[*/
    101: 866,
    /*::[*/
    102: 865,
    /*::[*/
    103: 861,
    /*::[*/
    104: 895,
    /*::[*/
    105: 620,
    /*::[*/
    106: 737,
    /*::[*/
    107: 857,
    /*::[*/
    120: 950,
    /*::[*/
    121: 949,
    /*::[*/
    122: 936,
    /*::[*/
    123: 932,
    /*::[*/
    124: 874,
    /*::[*/
    125: 1255,
    /*::[*/
    126: 1256,
    /*::[*/
    150: 10007,
    /*::[*/
    151: 10029,
    /*::[*/
    152: 10006,
    /*::[*/
    200: 1250,
    /*::[*/
    201: 1251,
    /*::[*/
    202: 1254,
    /*::[*/
    203: 1253,
    /* shapefile DBF extension */
    /*::[*/
    0: 20127,
    /*::[*/
    8: 865,
    /*::[*/
    9: 437,
    /*::[*/
    10: 850,
    /*::[*/
    11: 437,
    /*::[*/
    13: 437,
    /*::[*/
    14: 850,
    /*::[*/
    15: 437,
    /*::[*/
    16: 850,
    /*::[*/
    17: 437,
    /*::[*/
    18: 850,
    /*::[*/
    19: 932,
    /*::[*/
    20: 850,
    /*::[*/
    21: 437,
    /*::[*/
    22: 850,
    /*::[*/
    23: 865,
    /*::[*/
    24: 437,
    /*::[*/
    25: 437,
    /*::[*/
    26: 850,
    /*::[*/
    27: 437,
    /*::[*/
    28: 863,
    /*::[*/
    29: 850,
    /*::[*/
    31: 852,
    /*::[*/
    34: 852,
    /*::[*/
    35: 852,
    /*::[*/
    36: 860,
    /*::[*/
    37: 850,
    /*::[*/
    38: 866,
    /*::[*/
    55: 850,
    /*::[*/
    64: 852,
    /*::[*/
    77: 936,
    /*::[*/
    78: 949,
    /*::[*/
    79: 950,
    /*::[*/
    80: 874,
    /*::[*/
    87: 1252,
    /*::[*/
    88: 1252,
    /*::[*/
    89: 1252,
    /*::[*/
    108: 863,
    /*::[*/
    134: 737,
    /*::[*/
    135: 852,
    /*::[*/
    136: 857,
    /*::[*/
    204: 1257,
    /*::[*/
    255: 16969
  }, t = H4({
    /*::[*/
    1: 437,
    /*::[*/
    2: 850,
    /*::[*/
    3: 1252,
    /*::[*/
    4: 1e4,
    /*::[*/
    100: 852,
    /*::[*/
    101: 866,
    /*::[*/
    102: 865,
    /*::[*/
    103: 861,
    /*::[*/
    104: 895,
    /*::[*/
    105: 620,
    /*::[*/
    106: 737,
    /*::[*/
    107: 857,
    /*::[*/
    120: 950,
    /*::[*/
    121: 949,
    /*::[*/
    122: 936,
    /*::[*/
    123: 932,
    /*::[*/
    124: 874,
    /*::[*/
    125: 1255,
    /*::[*/
    126: 1256,
    /*::[*/
    150: 10007,
    /*::[*/
    151: 10029,
    /*::[*/
    152: 10006,
    /*::[*/
    200: 1250,
    /*::[*/
    201: 1251,
    /*::[*/
    202: 1254,
    /*::[*/
    203: 1253,
    /*::[*/
    0: 20127
  });
  function r(s, f) {
    var o = [], l = R2(1);
    switch (f.type) {
      case "base64":
        l = G1($1(s));
        break;
      case "binary":
        l = G1(s);
        break;
      case "buffer":
      case "array":
        l = s;
        break;
    }
    m1(l, 0);
    var d = l.read_shift(1), u = !!(d & 136), h = !1, p = !1;
    switch (d) {
      case 2:
        break;
      case 3:
        break;
      case 48:
        h = !0, u = !0;
        break;
      case 49:
        h = !0, u = !0;
        break;
      case 131:
        break;
      case 139:
        break;
      case 140:
        p = !0;
        break;
      case 245:
        break;
      default:
        throw new Error("DBF Unsupported Version: " + d.toString(16));
    }
    var v = 0, x = 521;
    d == 2 && (v = l.read_shift(2)), l.l += 3, d != 2 && (v = l.read_shift(4)), v > 1048576 && (v = 1e6), d != 2 && (x = l.read_shift(2));
    var m = l.read_shift(2);
    f.codepage, d != 2 && (l.l += 16, l.read_shift(1), l[l.l] !== 0 && e[l[l.l]], l.l += 1, l.l += 2), p && (l.l += 36);
    for (var T = [], g = {}, O = Math.min(l.length, d == 2 ? 521 : x - 10 - (h ? 264 : 0)), H = p ? 32 : 11; l.l < O && l[l.l] != 13; )
      switch (g = {}, g.name = w2(l.slice(l.l, l.l + H)).replace(/[\u0000\r\n].*$/g, ""), l.l += H, g.type = String.fromCharCode(l.read_shift(1)), d != 2 && !p && (g.offset = l.read_shift(4)), g.len = l.read_shift(1), d == 2 && (g.offset = l.read_shift(2)), g.dec = l.read_shift(1), g.name.length && T.push(g), d != 2 && (l.l += p ? 13 : 14), g.type) {
        case "B":
          (!h || g.len != 8) && f.WTF && console.log("Skipping " + g.name + ":" + g.type);
          break;
        case "G":
        case "P":
          f.WTF && console.log("Skipping " + g.name + ":" + g.type);
          break;
        case "+":
        case "0":
        case "@":
        case "C":
        case "D":
        case "F":
        case "I":
        case "L":
        case "M":
        case "N":
        case "O":
        case "T":
        case "Y":
          break;
        default:
          throw new Error("Unknown Field Type: " + g.type);
      }
    if (l[l.l] !== 13 && (l.l = x - 1), l.read_shift(1) !== 13)
      throw new Error("DBF Terminator not found " + l.l + " " + l[l.l]);
    l.l = x;
    var W = 0, E = 0;
    for (o[0] = [], E = 0; E != T.length; ++E)
      o[0][E] = T[E].name;
    for (; v-- > 0; ) {
      if (l[l.l] === 42) {
        l.l += m;
        continue;
      }
      for (++l.l, o[++W] = [], E = 0, E = 0; E != T.length; ++E) {
        var b = l.slice(l.l, l.l + T[E].len);
        l.l += T[E].len, m1(b, 0);
        var I = w2(b);
        switch (T[E].type) {
          case "C":
            I.trim().length && (o[W][E] = I.replace(/\s+$/, ""));
            break;
          case "D":
            I.length === 8 ? (o[W][E] = new Date(Date.UTC(+I.slice(0, 4), +I.slice(4, 6) - 1, +I.slice(6, 8), 0, 0, 0, 0)), f && f.UTC || (o[W][E] = J2(o[W][E]))) : o[W][E] = I;
            break;
          case "F":
            o[W][E] = parseFloat(I.trim());
            break;
          case "+":
          case "I":
            o[W][E] = p ? b.read_shift(-4, "i") ^ 2147483648 : b.read_shift(4, "i");
            break;
          case "L":
            switch (I.trim().toUpperCase()) {
              case "Y":
              case "T":
                o[W][E] = !0;
                break;
              case "N":
              case "F":
                o[W][E] = !1;
                break;
              case "":
              case "\0":
              case "?":
                break;
              default:
                throw new Error("DBF Unrecognized L:|" + I + "|");
            }
            break;
          case "M":
            if (!u)
              throw new Error("DBF Unexpected MEMO for type " + d.toString(16));
            o[W][E] = "##MEMO##" + (p ? parseInt(I.trim(), 10) : b.read_shift(4));
            break;
          case "N":
            I = I.replace(/\u0000/g, "").trim(), I && I != "." && (o[W][E] = +I || 0);
            break;
          case "@":
            o[W][E] = new Date(b.read_shift(-8, "f") - 621356832e5);
            break;
          case "T":
            {
              var P = b.read_shift(4), L = b.read_shift(4);
              if (P == 0 && L == 0)
                break;
              o[W][E] = new Date((P - 2440588) * 864e5 + L), f && f.UTC || (o[W][E] = J2(o[W][E]));
            }
            break;
          case "Y":
            o[W][E] = b.read_shift(4, "i") / 1e4 + b.read_shift(4, "i") / 1e4 * Math.pow(2, 32);
            break;
          case "O":
            o[W][E] = -b.read_shift(-8, "f");
            break;
          case "B":
            if (h && T[E].len == 8) {
              o[W][E] = b.read_shift(8, "f");
              break;
            }
          case "G":
          case "P":
            b.l += T[E].len;
            break;
          case "0":
            if (T[E].name === "_NullFlags")
              break;
          default:
            throw new Error("DBF Unsupported data type " + T[E].type);
        }
      }
    }
    if (d != 2 && l.l < l.length && l[l.l++] != 26)
      throw new Error("DBF EOF Marker missing " + (l.l - 1) + " of " + l.length + " " + l[l.l - 1].toString(16));
    return f && f.sheetRows && (o = o.slice(0, f.sheetRows)), f.DBF = T, o;
  }
  function a(s, f) {
    var o = f || {};
    o.dateNF || (o.dateNF = "yyyymmdd");
    var l = E3(r(s, o), o);
    return l["!cols"] = o.DBF.map(function(d) {
      return {
        wch: d.len,
        DBF: d
      };
    }), delete o.DBF, l;
  }
  function n(s, f) {
    try {
      var o = B2(a(s, f), f);
      return o.bookType = "dbf", o;
    } catch (l) {
      if (f && f.WTF)
        throw l;
    }
    return { SheetNames: [], Sheets: {} };
  }
  var i = { B: 8, C: 250, L: 1, D: 8, "?": 0, "": 0 };
  function c(s, f) {
    if (!s["!ref"])
      throw new Error("Cannot export empty sheet to DBF");
    var o = f || {}, l = e2;
    if (+o.codepage >= 0 && o2(+o.codepage), o.type == "string")
      throw new Error("Cannot write DBF to JS string");
    var d = v4(), u = C4(s, { header: 1, raw: !0, cellDates: !0 }), h = u[0], p = u.slice(1), v = s["!cols"] || [], x = 0, m = 0, T = 0, g = 1;
    for (x = 0; x < h.length; ++x) {
      if (((v[x] || {}).DBF || {}).name) {
        h[x] = v[x].DBF.name, ++T;
        continue;
      }
      if (h[x] != null) {
        if (++T, typeof h[x] == "number" && (h[x] = h[x].toString(10)), typeof h[x] != "string")
          throw new Error("DBF Invalid column name " + h[x] + " |" + typeof h[x] + "|");
        if (h.indexOf(h[x]) !== x) {
          for (m = 0; m < 1024; ++m)
            if (h.indexOf(h[x] + "_" + m) == -1) {
              h[x] += "_" + m;
              break;
            }
        }
      }
    }
    var O = o1(s["!ref"]), H = [], W = [], E = [];
    for (x = 0; x <= O.e.c - O.s.c; ++x) {
      var b = "", I = "", P = 0, L = [];
      for (m = 0; m < p.length; ++m)
        p[m][x] != null && L.push(p[m][x]);
      if (L.length == 0 || h[x] == null) {
        H[x] = "?";
        continue;
      }
      for (m = 0; m < L.length; ++m) {
        switch (typeof L[m]) {
          case "number":
            I = "B";
            break;
          case "string":
            I = "C";
            break;
          case "boolean":
            I = "L";
            break;
          case "object":
            I = L[m] instanceof Date ? "D" : "C";
            break;
          default:
            I = "C";
        }
        P = Math.max(P, String(L[m]).length), b = b && b != I ? "C" : I;
      }
      P > 250 && (P = 250), I = ((v[x] || {}).DBF || {}).type, I == "C" && v[x].DBF.len > P && (P = v[x].DBF.len), b == "B" && I == "N" && (b = "N", E[x] = v[x].DBF.dec, P = v[x].DBF.len), W[x] = b == "C" || I == "N" ? P : i[b] || 0, g += W[x], H[x] = b;
    }
    var z = d.next(32);
    for (z.write_shift(4, 318902576), z.write_shift(4, p.length), z.write_shift(2, 296 + 32 * T), z.write_shift(2, g), x = 0; x < 4; ++x)
      z.write_shift(4, 0);
    var Y = +t[
      /*::String(*/
      e2
      /*::)*/
    ] || 3;
    for (z.write_shift(4, 0 | Y << 8), e[Y] != +o.codepage && (o.codepage && console.error("DBF Unsupported codepage " + e2 + ", using 1252"), e2 = 1252), x = 0, m = 0; x < h.length; ++x)
      if (h[x] != null) {
        var f0 = d.next(32), i0 = (h[x].slice(-10) + "\0\0\0\0\0\0\0\0\0\0\0").slice(0, 11);
        f0.write_shift(1, i0, "sbcs"), f0.write_shift(1, H[x] == "?" ? "C" : H[x], "sbcs"), f0.write_shift(4, m), f0.write_shift(1, W[x] || i[H[x]] || 0), f0.write_shift(1, E[x] || 0), f0.write_shift(1, 2), f0.write_shift(4, 0), f0.write_shift(1, 0), f0.write_shift(4, 0), f0.write_shift(4, 0), m += W[x] || i[H[x]] || 0;
      }
    var p0 = d.next(264);
    for (p0.write_shift(4, 13), x = 0; x < 65; ++x)
      p0.write_shift(4, 0);
    for (x = 0; x < p.length; ++x) {
      var n0 = d.next(g);
      for (n0.write_shift(1, 0), m = 0; m < h.length; ++m)
        if (h[m] != null)
          switch (H[m]) {
            case "L":
              n0.write_shift(1, p[x][m] == null ? 63 : p[x][m] ? 84 : 70);
              break;
            case "B":
              n0.write_shift(8, p[x][m] || 0, "f");
              break;
            case "N":
              var v0 = "0";
              for (typeof p[x][m] == "number" && (v0 = p[x][m].toFixed(E[m] || 0)), v0.length > W[m] && (v0 = v0.slice(0, W[m])), T = 0; T < W[m] - v0.length; ++T)
                n0.write_shift(1, 32);
              n0.write_shift(1, v0, "sbcs");
              break;
            case "D":
              p[x][m] ? (n0.write_shift(4, ("0000" + p[x][m].getFullYear()).slice(-4), "sbcs"), n0.write_shift(2, ("00" + (p[x][m].getMonth() + 1)).slice(-2), "sbcs"), n0.write_shift(2, ("00" + p[x][m].getDate()).slice(-2), "sbcs")) : n0.write_shift(8, "00000000", "sbcs");
              break;
            case "C":
              var I0 = n0.l, K = String(p[x][m] != null ? p[x][m] : "").slice(0, W[m]);
              for (n0.write_shift(1, K, "cpstr"), I0 += W[m] - n0.l, T = 0; T < I0; ++T)
                n0.write_shift(1, 32);
              break;
          }
    }
    return e2 = l, d.next(1).write_shift(1, 26), d.end();
  }
  return {
    to_workbook: n,
    to_sheet: a,
    from_sheet: c
  };
}(), ac = /* @__PURE__ */ function() {
  var e = {
    AA: "À",
    BA: "Á",
    CA: "Â",
    DA: 195,
    HA: "Ä",
    JA: 197,
    AE: "È",
    BE: "É",
    CE: "Ê",
    HE: "Ë",
    AI: "Ì",
    BI: "Í",
    CI: "Î",
    HI: "Ï",
    AO: "Ò",
    BO: "Ó",
    CO: "Ô",
    DO: 213,
    HO: "Ö",
    AU: "Ù",
    BU: "Ú",
    CU: "Û",
    HU: "Ü",
    Aa: "à",
    Ba: "á",
    Ca: "â",
    Da: 227,
    Ha: "ä",
    Ja: 229,
    Ae: "è",
    Be: "é",
    Ce: "ê",
    He: "ë",
    Ai: "ì",
    Bi: "í",
    Ci: "î",
    Hi: "ï",
    Ao: "ò",
    Bo: "ó",
    Co: "ô",
    Do: 245,
    Ho: "ö",
    Au: "ù",
    Bu: "ú",
    Cu: "û",
    Hu: "ü",
    KC: "Ç",
    Kc: "ç",
    q: "æ",
    z: "œ",
    a: "Æ",
    j: "Œ",
    DN: 209,
    Dn: 241,
    Hy: 255,
    S: 169,
    c: 170,
    R: 174,
    "B ": 180,
    /*::[*/
    0: 176,
    /*::[*/
    1: 177,
    /*::[*/
    2: 178,
    /*::[*/
    3: 179,
    /*::[*/
    5: 181,
    /*::[*/
    6: 182,
    /*::[*/
    7: 183,
    Q: 185,
    k: 186,
    b: 208,
    i: 216,
    l: 222,
    s: 240,
    y: 248,
    "!": 161,
    '"': 162,
    "#": 163,
    "(": 164,
    "%": 165,
    "'": 167,
    "H ": 168,
    "+": 171,
    ";": 187,
    "<": 188,
    "=": 189,
    ">": 190,
    "?": 191,
    "{": 223
  }, t = new RegExp("\x1BN(" + t2(e).join("|").replace(/\|\|\|/, "|\\||").replace(/([?()+])/g, "\\$1").replace("{", "\\{") + "|\\|)", "gm");
  try {
    t = new RegExp("\x1BN(" + t2(e).join("|").replace(/\|\|\|/, "|\\||").replace(/([?()+])/g, "\\$1") + "|\\|)", "gm");
  } catch {
  }
  var r = function(h, p) {
    var v = e[p];
    return typeof v == "number" ? S5(v) : v;
  }, a = function(h, p, v) {
    var x = p.charCodeAt(0) - 32 << 4 | v.charCodeAt(0) - 48;
    return x == 59 ? h : S5(x);
  };
  e["|"] = 254;
  var n = function(h) {
    return h.replace(/\n/g, "\x1B :").replace(/\r/g, "\x1B =");
  };
  function i(h, p) {
    switch (p.type) {
      case "base64":
        return c($1(h), p);
      case "binary":
        return c(h, p);
      case "buffer":
        return c(O0 && Buffer.isBuffer(h) ? h.toString("binary") : w2(h), p);
      case "array":
        return c(Y2(h), p);
    }
    throw new Error("Unrecognized type " + p.type);
  }
  function c(h, p) {
    var v = h.split(/[\n\r]+/), x = -1, m = -1, T = 0, g = 0, O = [], H = [], W = null, E = {}, b = [], I = [], P = [], L = 0, z, Y = { Workbook: { WBProps: {}, Names: [] } };
    for (+p.codepage >= 0 && o2(+p.codepage); T !== v.length; ++T) {
      L = 0;
      var f0 = v[T].trim().replace(/\x1B([\x20-\x2F])([\x30-\x3F])/g, a).replace(t, r), i0 = f0.replace(/;;/g, "\0").split(";").map(function(D) {
        return D.replace(/\u0000/g, ";");
      }), p0 = i0[0], n0;
      if (f0.length > 0)
        switch (p0) {
          case "ID":
            break;
          case "E":
            break;
          case "B":
            break;
          case "O":
            for (g = 1; g < i0.length; ++g)
              switch (i0[g].charAt(0)) {
                case "V":
                  {
                    var v0 = parseInt(i0[g].slice(1), 10);
                    v0 >= 1 && v0 <= 4 && (Y.Workbook.WBProps.date1904 = !0);
                  }
                  break;
              }
            break;
          case "W":
            break;
          case "P":
            switch (i0[1].charAt(0)) {
              case "P":
                H.push(f0.slice(3).replace(/;;/g, ";"));
                break;
            }
            break;
          case "NN":
            {
              var I0 = { Sheet: 0 };
              for (g = 1; g < i0.length; ++g)
                switch (i0[g].charAt(0)) {
                  case "N":
                    I0.Name = i0[g].slice(1);
                    break;
                  case "E":
                    I0.Ref = (p && p.sheet || "Sheet1") + "!" + X2(i0[g].slice(1));
                    break;
                }
              Y.Workbook.Names.push(I0);
            }
            break;
          case "C":
            var K = !1, T0 = !1, S0 = !1, w0 = !1, r0 = -1, E0 = -1, b0 = "", D0 = "z", F = "";
            for (g = 1; g < i0.length; ++g)
              switch (i0[g].charAt(0)) {
                case "A":
                  F = i0[g].slice(1);
                  break;
                case "X":
                  m = parseInt(i0[g].slice(1), 10) - 1, T0 = !0;
                  break;
                case "Y":
                  for (x = parseInt(i0[g].slice(1), 10) - 1, T0 || (m = 0), z = O.length; z <= x; ++z)
                    O[z] = [];
                  break;
                case "K":
                  n0 = i0[g].slice(1), n0.charAt(0) === '"' ? (n0 = n0.slice(1, n0.length - 1), D0 = "s") : n0 === "TRUE" || n0 === "FALSE" ? (n0 = n0 === "TRUE", D0 = "b") : isNaN(z1(n0)) || (n0 = z1(n0), D0 = "n", W !== null && u2(W) && p.cellDates && (n0 = O2(Y.Workbook.WBProps.date1904 ? n0 + 1462 : n0), D0 = typeof n0 == "number" ? "n" : "d")), K = !0;
                  break;
                case "E":
                  w0 = !0, b0 = X2(i0[g].slice(1), { r: x, c: m });
                  break;
                case "S":
                  S0 = !0;
                  break;
                case "G":
                  break;
                case "R":
                  r0 = parseInt(i0[g].slice(1), 10) - 1;
                  break;
                case "C":
                  E0 = parseInt(i0[g].slice(1), 10) - 1;
                  break;
                default:
                  if (p && p.WTF)
                    throw new Error("SYLK bad record " + f0);
              }
            if (K && (O[x][m] ? (O[x][m].t = D0, O[x][m].v = n0) : O[x][m] = { t: D0, v: n0 }, W && (O[x][m].z = W), p.cellText !== !1 && W && (O[x][m].w = X1(O[x][m].z, O[x][m].v, { date1904: Y.Workbook.WBProps.date1904 })), W = null), S0) {
              if (w0)
                throw new Error("SYLK shared formula cannot have own formula");
              var B = r0 > -1 && O[r0][E0];
              if (!B || !B[1])
                throw new Error("SYLK shared formula cannot find base");
              b0 = M7(B[1], { r: x - r0, c: m - E0 });
            }
            b0 && (O[x][m] ? O[x][m].f = b0 : O[x][m] = { t: "n", f: b0 }), F && (O[x][m] || (O[x][m] = { t: "z" }), O[x][m].c = [{ a: "SheetJSYLK", t: F }]);
            break;
          case "F":
            var R = 0;
            for (g = 1; g < i0.length; ++g)
              switch (i0[g].charAt(0)) {
                case "X":
                  m = parseInt(i0[g].slice(1), 10) - 1, ++R;
                  break;
                case "Y":
                  for (x = parseInt(i0[g].slice(1), 10) - 1, z = O.length; z <= x; ++z)
                    O[z] = [];
                  break;
                case "M":
                  L = parseInt(i0[g].slice(1), 10) / 20;
                  break;
                case "F":
                  break;
                case "G":
                  break;
                case "P":
                  W = H[parseInt(i0[g].slice(1), 10)];
                  break;
                case "S":
                  break;
                case "D":
                  break;
                case "N":
                  break;
                case "W":
                  for (P = i0[g].slice(1).split(" "), z = parseInt(P[0], 10); z <= parseInt(P[1], 10); ++z)
                    L = parseInt(P[2], 10), I[z - 1] = L === 0 ? { hidden: !0 } : { wch: L };
                  break;
                case "C":
                  m = parseInt(i0[g].slice(1), 10) - 1, I[m] || (I[m] = {});
                  break;
                case "R":
                  x = parseInt(i0[g].slice(1), 10) - 1, b[x] || (b[x] = {}), L > 0 ? (b[x].hpt = L, b[x].hpx = J3(L)) : L === 0 && (b[x].hidden = !0);
                  break;
                default:
                  if (p && p.WTF)
                    throw new Error("SYLK bad record " + f0);
              }
            R < 1 && (W = null);
            break;
          default:
            if (p && p.WTF)
              throw new Error("SYLK bad record " + f0);
        }
    }
    return b.length > 0 && (E["!rows"] = b), I.length > 0 && (E["!cols"] = I), I.forEach(function(D) {
      m3(D);
    }), p && p.sheetRows && (O = O.slice(0, p.sheetRows)), [O, E, Y];
  }
  function s(h, p) {
    var v = i(h, p), x = v[0], m = v[1], T = v[2], g = x1(p);
    g.date1904 = (((T || {}).Workbook || {}).WBProps || {}).date1904;
    var O = E3(x, g);
    t2(m).forEach(function(W) {
      O[W] = m[W];
    });
    var H = B2(O, p);
    return t2(T).forEach(function(W) {
      H[W] = T[W];
    }), H.bookType = "sylk", H;
  }
  function f(h, p, v, x, m, T) {
    var g = "C;Y" + (v + 1) + ";X" + (x + 1) + ";K";
    switch (h.t) {
      case "n":
        g += h.v || 0, h.f && !h.F && (g += ";E" + Xf(h.f, { r: v, c: x }));
        break;
      case "b":
        g += h.v ? "TRUE" : "FALSE";
        break;
      case "e":
        g += h.w || h.v;
        break;
      case "d":
        g += v1(w1(h.v, T), T);
        break;
      case "s":
        g += '"' + (h.v == null ? "" : String(h.v)).replace(/"/g, "").replace(/;/g, ";;") + '"';
        break;
    }
    return g;
  }
  function o(h, p, v) {
    var x = "C;Y" + (p + 1) + ";X" + (v + 1) + ";A";
    return x += n(h.map(function(m) {
      return m.t;
    }).join("")), x;
  }
  function l(h, p) {
    p.forEach(function(v, x) {
      var m = "F;W" + (x + 1) + " " + (x + 1) + " ";
      v.hidden ? m += "0" : (typeof v.width == "number" && !v.wpx && (v.wpx = Me(v.width)), typeof v.wpx == "number" && !v.wch && (v.wch = Ne(v.wpx)), typeof v.wch == "number" && (m += Math.round(v.wch))), m.charAt(m.length - 1) != " " && h.push(m);
    });
  }
  function d(h, p) {
    p.forEach(function(v, x) {
      var m = "F;";
      v.hidden ? m += "M0;" : v.hpt ? m += "M" + 20 * v.hpt + ";" : v.hpx && (m += "M" + 20 * O7(v.hpx) + ";"), m.length > 2 && h.push(m + "R" + (x + 1));
    });
  }
  function u(h, p, v) {
    p || (p = {}), p._formats = ["General"];
    var x = ["ID;PSheetJS;N;E"], m = [], T = o1(h["!ref"] || "A1"), g, O = h["!data"] != null, H = `\r
`, W = (((v || {}).Workbook || {}).WBProps || {}).date1904, E = "General";
    x.push("P;PGeneral");
    var b = T.s.r, I = T.s.c, P = [];
    if (h["!ref"]) {
      for (b = T.s.r; b <= T.e.r; ++b)
        if (!(O && !h["!data"][b])) {
          for (P = [], I = T.s.c; I <= T.e.c; ++I)
            g = O ? h["!data"][b][I] : h[W0(I) + j0(b)], !(!g || !g.c) && P.push(o(g.c, b, I));
          P.length && m.push(P.join(H));
        }
    }
    if (h["!ref"]) {
      for (b = T.s.r; b <= T.e.r; ++b)
        if (!(O && !h["!data"][b])) {
          for (P = [], I = T.s.c; I <= T.e.c; ++I)
            if (g = O ? h["!data"][b][I] : h[W0(I) + j0(b)], !(!g || g.v == null && (!g.f || g.F))) {
              if ((g.z || (g.t == "d" ? k0[14] : "General")) != E) {
                var L = p._formats.indexOf(g.z);
                L == -1 && (p._formats.push(g.z), L = p._formats.length - 1, x.push("P;P" + g.z.replace(/;/g, ";;"))), P.push("F;P" + L + ";Y" + (b + 1) + ";X" + (I + 1));
              }
              P.push(f(g, h, b, I, p, W));
            }
          m.push(P.join(H));
        }
    }
    return x.push("F;P0;DG0G8;M255"), h["!cols"] && l(x, h["!cols"]), h["!rows"] && d(x, h["!rows"]), h["!ref"] && x.push("B;Y" + (T.e.r - T.s.r + 1) + ";X" + (T.e.c - T.s.c + 1) + ";D" + [T.s.c, T.s.r, T.e.c, T.e.r].join(" ")), x.push("O;L;D;B" + (W ? ";V4" : "") + ";K47;G100 0.001"), delete p._formats, x.join(H) + H + m.join(H) + H + "E" + H;
  }
  return {
    to_workbook: s,
    from_sheet: u
  };
}(), nc = /* @__PURE__ */ function() {
  function e(s, f) {
    switch (f.type) {
      case "base64":
        return t($1(s), f);
      case "binary":
        return t(s, f);
      case "buffer":
        return t(O0 && Buffer.isBuffer(s) ? s.toString("binary") : w2(s), f);
      case "array":
        return t(Y2(s), f);
    }
    throw new Error("Unrecognized type " + f.type);
  }
  function t(s, f) {
    for (var o = s.split(`
`), l = -1, d = -1, u = 0, h = []; u !== o.length; ++u) {
      if (o[u].trim() === "BOT") {
        h[++l] = [], d = 0;
        continue;
      }
      if (!(l < 0)) {
        var p = o[u].trim().split(","), v = p[0], x = p[1];
        ++u;
        for (var m = o[u] || ""; (m.match(/["]/g) || []).length & 1 && u < o.length - 1; )
          m += `
` + o[++u];
        switch (m = m.trim(), +v) {
          case -1:
            if (m === "BOT") {
              h[++l] = [], d = 0;
              continue;
            } else if (m !== "EOD")
              throw new Error("Unrecognized DIF special command " + m);
            break;
          case 0:
            m === "TRUE" ? h[l][d] = !0 : m === "FALSE" ? h[l][d] = !1 : isNaN(z1(x)) ? isNaN($3(x).getDate()) ? h[l][d] = x : (h[l][d] = w1(x), f && f.UTC || (h[l][d] = J2(h[l][d]))) : h[l][d] = z1(x), ++d;
            break;
          case 1:
            m = m.slice(1, m.length - 1), m = m.replace(/""/g, '"'), m && m.match(/^=".*"$/) && (m = m.slice(2, -1)), h[l][d++] = m !== "" ? m : null;
            break;
        }
        if (m === "EOD")
          break;
      }
    }
    return f && f.sheetRows && (h = h.slice(0, f.sheetRows)), h;
  }
  function r(s, f) {
    return E3(e(s, f), f);
  }
  function a(s, f) {
    var o = B2(r(s, f), f);
    return o.bookType = "dif", o;
  }
  function n(s, f) {
    return "0," + String(s) + `\r
` + f;
  }
  function i(s) {
    return `1,0\r
"` + s.replace(/"/g, '""') + '"';
  }
  function c(s) {
    if (!s["!ref"])
      throw new Error("Cannot export empty sheet to DIF");
    for (var f = o1(s["!ref"]), o = s["!data"] != null, l = [
      `TABLE\r
0,1\r
"sheetjs"\r
`,
      `VECTORS\r
0,` + (f.e.r - f.s.r + 1) + `\r
""\r
`,
      `TUPLES\r
0,` + (f.e.c - f.s.c + 1) + `\r
""\r
`,
      `DATA\r
0,0\r
""\r
`
    ], d = f.s.r; d <= f.e.r; ++d) {
      for (var u = o ? s["!data"][d] : [], h = `-1,0\r
BOT\r
`, p = f.s.c; p <= f.e.c; ++p) {
        var v = o ? u && u[p] : s[H0({ r: d, c: p })];
        if (v == null) {
          h += `1,0\r
""\r
`;
          continue;
        }
        switch (v.t) {
          case "n":
            v.w != null ? h += "0," + v.w + `\r
V` : v.v != null ? h += n(v.v, "V") : v.f != null && !v.F ? h += i("=" + v.f) : h += `1,0\r
""`;
            break;
          case "b":
            h += v.v ? n(1, "TRUE") : n(0, "FALSE");
            break;
          case "s":
            h += i(isNaN(+v.v) ? v.v : '="' + v.v + '"');
            break;
          case "d":
            v.w || (v.w = X1(v.z || k0[14], v1(w1(v.v)))), h += n(v.w, "V");
            break;
          default:
            h += `1,0\r
""`;
        }
        h += `\r
`;
      }
      l.push(h);
    }
    return l.join("") + `-1,0\r
EOD`;
  }
  return {
    to_workbook: a,
    to_sheet: r,
    from_sheet: c
  };
}(), ic = /* @__PURE__ */ function() {
  function e(d) {
    return d.replace(/\\b/g, "\\").replace(/\\c/g, ":").replace(/\\n/g, `
`);
  }
  function t(d) {
    return d.replace(/\\/g, "\\b").replace(/:/g, "\\c").replace(/\n/g, "\\n");
  }
  function r(d, u) {
    for (var h = d.split(`
`), p = -1, v = -1, x = 0, m = []; x !== h.length; ++x) {
      var T = h[x].trim().split(":");
      if (T[0] === "cell") {
        var g = y1(T[1]);
        if (m.length <= g.r)
          for (p = m.length; p <= g.r; ++p)
            m[p] || (m[p] = []);
        switch (p = g.r, v = g.c, T[2]) {
          case "t":
            m[p][v] = e(T[3]);
            break;
          case "v":
            m[p][v] = +T[3];
            break;
          case "vtf":
            var O = T[T.length - 1];
          case "vtc":
            switch (T[3]) {
              case "nl":
                m[p][v] = !!+T[4];
                break;
              default:
                m[p][v] = +T[4];
                break;
            }
            T[2] == "vtf" && (m[p][v] = [m[p][v], O]);
        }
      }
    }
    return u && u.sheetRows && (m = m.slice(0, u.sheetRows)), m;
  }
  function a(d, u) {
    return E3(r(d, u), u);
  }
  function n(d, u) {
    return B2(a(d, u), u);
  }
  var i = [
    "socialcalc:version:1.5",
    "MIME-Version: 1.0",
    "Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"
  ].join(`
`), c = [
    "--SocialCalcSpreadsheetControlSave",
    "Content-type: text/plain; charset=UTF-8"
  ].join(`
`) + `
`, s = [
    "# SocialCalc Spreadsheet Control Save",
    "part:sheet"
  ].join(`
`), f = "--SocialCalcSpreadsheetControlSave--";
  function o(d) {
    if (!d || !d["!ref"])
      return "";
    for (var u = [], h = [], p, v = "", x = Q2(d["!ref"]), m = d["!data"] != null, T = x.s.r; T <= x.e.r; ++T)
      for (var g = x.s.c; g <= x.e.c; ++g)
        if (v = H0({ r: T, c: g }), p = m ? (d["!data"][T] || [])[g] : d[v], !(!p || p.v == null || p.t === "z")) {
          switch (h = ["cell", v, "t"], p.t) {
            case "s":
            case "str":
              h.push(t(p.v));
              break;
            case "n":
              p.f ? (h[2] = "vtf", h[3] = "n", h[4] = p.v, h[5] = t(p.f)) : (h[2] = "v", h[3] = p.v);
              break;
            case "b":
              h[2] = "vt" + (p.f ? "f" : "c"), h[3] = "nl", h[4] = p.v ? "1" : "0", h[5] = t(p.f || (p.v ? "TRUE" : "FALSE"));
              break;
            case "d":
              var O = v1(w1(p.v));
              h[2] = "vtc", h[3] = "nd", h[4] = "" + O, h[5] = p.w || X1(p.z || k0[14], O);
              break;
            case "e":
              continue;
          }
          u.push(h.join(":"));
        }
    return u.push("sheet:c:" + (x.e.c - x.s.c + 1) + ":r:" + (x.e.r - x.s.r + 1) + ":tvf:1"), u.push("valueformat:1:text-wiki"), u.join(`
`);
  }
  function l(d) {
    return [i, c, s, c, o(d), f].join(`
`);
  }
  return {
    to_workbook: n,
    to_sheet: a,
    from_sheet: l
  };
}(), K3 = /* @__PURE__ */ function() {
  function e(l, d, u, h, p) {
    p.raw ? d[u][h] = l : l === "" || (l === "TRUE" ? d[u][h] = !0 : l === "FALSE" ? d[u][h] = !1 : isNaN(z1(l)) ? isNaN($3(l).getDate()) ? d[u][h] = l : d[u][h] = w1(l) : d[u][h] = z1(l));
  }
  function t(l, d) {
    var u = d || {}, h = [];
    if (!l || l.length === 0)
      return h;
    for (var p = l.split(/[\r\n]/), v = p.length - 1; v >= 0 && p[v].length === 0; )
      --v;
    for (var x = 10, m = 0, T = 0; T <= v; ++T)
      m = p[T].indexOf(" "), m == -1 ? m = p[T].length : m++, x = Math.max(x, m);
    for (T = 0; T <= v; ++T) {
      h[T] = [];
      var g = 0;
      for (e(p[T].slice(0, x).trim(), h, T, g, u), g = 1; g <= (p[T].length - x) / 10 + 1; ++g)
        e(p[T].slice(x + (g - 1) * 10, x + g * 10).trim(), h, T, g, u);
    }
    return u.sheetRows && (h = h.slice(0, u.sheetRows)), h;
  }
  var r = {
    /*::[*/
    44: ",",
    /*::[*/
    9: "	",
    /*::[*/
    59: ";",
    /*::[*/
    124: "|"
  }, a = {
    /*::[*/
    44: 3,
    /*::[*/
    9: 2,
    /*::[*/
    59: 1,
    /*::[*/
    124: 0
  };
  function n(l) {
    for (var d = {}, u = !1, h = 0, p = 0; h < l.length; ++h)
      (p = l.charCodeAt(h)) == 34 ? u = !u : !u && p in r && (d[p] = (d[p] || 0) + 1);
    p = [];
    for (h in d)
      Object.prototype.hasOwnProperty.call(d, h) && p.push([d[h], h]);
    if (!p.length) {
      d = a;
      for (h in d)
        Object.prototype.hasOwnProperty.call(d, h) && p.push([d[h], h]);
    }
    return p.sort(function(v, x) {
      return v[0] - x[0] || a[v[1]] - a[x[1]];
    }), r[p.pop()[1]] || 44;
  }
  function i(l, d) {
    var u = d || {}, h = "", p = {};
    u.dense && (p["!data"] = []);
    var v = { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } };
    l.slice(0, 4) == "sep=" ? l.charCodeAt(5) == 13 && l.charCodeAt(6) == 10 ? (h = l.charAt(4), l = l.slice(7)) : l.charCodeAt(5) == 13 || l.charCodeAt(5) == 10 ? (h = l.charAt(4), l = l.slice(6)) : h = n(l.slice(0, 1024)) : u && u.FS ? h = u.FS : h = n(l.slice(0, 1024));
    var x = 0, m = 0, T = 0, g = 0, O = 0, H = h.charCodeAt(0), W = !1, E = 0, b = l.charCodeAt(0), I = u.dateNF != null ? rn(u.dateNF) : null;
    function P() {
      var L = l.slice(g, O);
      L.slice(-1) == "\r" && (L = L.slice(0, -1));
      var z = {};
      if (L.charAt(0) == '"' && L.charAt(L.length - 1) == '"' && (L = L.slice(1, -1).replace(/""/g, '"')), u.cellText !== !1 && (z.w = L), L.length === 0)
        z.t = "z";
      else if (u.raw)
        z.t = "s", z.v = L;
      else if (L.trim().length === 0)
        z.t = "s", z.v = L;
      else if (L.charCodeAt(0) == 61)
        L.charCodeAt(1) == 34 && L.charCodeAt(L.length - 1) == 34 ? (z.t = "s", z.v = L.slice(2, -1).replace(/""/g, '"')) : Kf(L) ? (z.t = "s", z.f = L.slice(1), z.v = L) : (z.t = "s", z.v = L);
      else if (L == "TRUE")
        z.t = "b", z.v = !0;
      else if (L == "FALSE")
        z.t = "b", z.v = !1;
      else if (!isNaN(T = z1(L)))
        z.t = "n", z.v = T;
      else if (!isNaN((T = $3(L)).getDate()) || I && L.match(I)) {
        if (z.z = u.dateNF || k0[14], I && L.match(I)) {
          var Y = tn(L, u.dateNF, L.match(I) || []);
          T = w1(Y), u && u.UTC === !1 && (T = J2(T));
        } else
          u && u.UTC === !1 ? T = J2(T) : u.cellText !== !1 && u.dateNF && (z.w = X1(z.z, T));
        u.cellDates ? (z.t = "d", z.v = T) : (z.t = "n", z.v = v1(T)), u.cellNF || delete z.z;
      } else
        z.t = "s", z.v = L;
      if (z.t == "z" || (u.dense ? (p["!data"][x] || (p["!data"][x] = []), p["!data"][x][m] = z) : p[H0({ c: m, r: x })] = z), g = O + 1, b = l.charCodeAt(g), v.e.c < m && (v.e.c = m), v.e.r < x && (v.e.r = x), E == H)
        ++m;
      else if (m = 0, ++x, u.sheetRows && u.sheetRows <= x)
        return !0;
    }
    e:
      for (; O < l.length; ++O)
        switch (E = l.charCodeAt(O)) {
          case 34:
            b === 34 && (W = !W);
            break;
          case 13:
            if (W)
              break;
            l.charCodeAt(O + 1) == 10 && ++O;
          case H:
          case 10:
            if (!W && P())
              break e;
            break;
        }
    return O - g > 0 && P(), p["!ref"] = M0(v), p;
  }
  function c(l, d) {
    return !(d && d.PRN) || d.FS || l.slice(0, 4) == "sep=" || l.indexOf("	") >= 0 || l.indexOf(",") >= 0 || l.indexOf(";") >= 0 ? i(l, d) : E3(t(l, d), d);
  }
  function s(l, d) {
    var u = "", h = d.type == "string" ? [0, 0, 0, 0] : r5(l, d);
    switch (d.type) {
      case "base64":
        u = $1(l);
        break;
      case "binary":
        u = l;
        break;
      case "buffer":
        d.codepage == 65001 ? u = l.toString("utf8") : (d.codepage, u = O0 && Buffer.isBuffer(l) ? l.toString("binary") : w2(l));
        break;
      case "array":
        u = Y2(l);
        break;
      case "string":
        u = l;
        break;
      default:
        throw new Error("Unrecognized type " + d.type);
    }
    return h[0] == 239 && h[1] == 187 && h[2] == 191 ? u = X0(u.slice(3)) : d.type != "string" && d.type != "buffer" && d.codepage == 65001 ? u = X0(u) : d.type == "binary", u.slice(0, 19) == "socialcalc:version:" ? ic.to_sheet(d.type == "string" ? u : X0(u), d) : c(u, d);
  }
  function f(l, d) {
    return B2(s(l, d), d);
  }
  function o(l) {
    var d = [];
    if (!l["!ref"])
      return "";
    for (var u = o1(l["!ref"]), h, p = l["!data"] != null, v = u.s.r; v <= u.e.r; ++v) {
      for (var x = [], m = u.s.c; m <= u.e.c; ++m) {
        var T = H0({ r: v, c: m });
        if (h = p ? (l["!data"][v] || [])[m] : l[T], !h || h.v == null) {
          x.push("          ");
          continue;
        }
        for (var g = (h.w || (M2(h), h.w) || "").slice(0, 10); g.length < 10; )
          g += " ";
        x.push(g + (m === 0 ? " " : ""));
      }
      d.push(x.join(""));
    }
    return d.join(`
`);
  }
  return {
    to_workbook: f,
    to_sheet: s,
    from_sheet: o
  };
}();
function sc(e, t) {
  var r = t || {}, a = !!r.WTF;
  r.WTF = !0;
  try {
    var n = ac.to_workbook(e, r);
    return r.WTF = a, n;
  } catch (i) {
    if (r.WTF = a, !i.message.match(/SYLK bad record ID/) && a)
      throw i;
    return K3.to_workbook(e, t);
  }
}
var B3 = /* @__PURE__ */ function() {
  function e(F, B, R) {
    if (F) {
      m1(F, F.l || 0);
      for (var D = R.Enum || w0; F.l < F.length; ) {
        var Z = F.read_shift(2), A = D[Z] || D[65535], Q = F.read_shift(2), m0 = F.l + Q, a0 = A.f && A.f(F, Q, R);
        if (F.l = m0, B(a0, A, Z))
          return;
      }
    }
  }
  function t(F, B) {
    switch (B.type) {
      case "base64":
        return a(G1($1(F)), B);
      case "binary":
        return a(G1(F), B);
      case "buffer":
      case "array":
        return a(F, B);
    }
    throw "Unsupported type " + B.type;
  }
  var r = [
    "mmmm",
    "dd-mmm-yyyy",
    "dd-mmm",
    "mmm-yyyy",
    "@",
    // "text"?
    "mm/dd",
    "hh:mm:ss AM/PM",
    // 7
    "hh:mm AM/PM",
    "mm/dd/yyyy",
    "mm/dd",
    "hh:mm:ss",
    "hh:mm"
    // 12
  ];
  function a(F, B) {
    if (!F)
      return F;
    var R = B || {}, D = {}, Z = "Sheet1", A = "", Q = 0, m0 = {}, a0 = [], g0 = [], _0 = [];
    R.dense && (_0 = D["!data"] = []);
    var A0 = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } }, V0 = R.sheetRows || 0, J0 = {};
    if (F[4] == 81 && F[5] == 80 && F[6] == 87)
      return D0(F, B);
    if (F[2] == 0 && (F[3] == 8 || F[3] == 9) && F.length >= 16 && F[14] == 5 && F[15] === 108)
      throw new Error("Unsupported Works 3 for Mac file");
    if (F[2] == 2)
      R.Enum = w0, e(F, function(o0, W1, D1) {
        switch (D1) {
          case 0:
            R.vers = o0, o0 >= 4096 && (R.qpro = !0);
            break;
          case 255:
            R.vers = o0, R.works = !0;
            break;
          case 6:
            A0 = o0;
            break;
          case 204:
            o0 && (A = o0);
            break;
          case 222:
            A = o0;
            break;
          case 15:
          case 51:
            (!R.qpro && !R.works || D1 == 51) && o0[1].v.charCodeAt(0) < 48 && (o0[1].v = o0[1].v.slice(1)), (R.works || R.works2) && (o0[1].v = o0[1].v.replace(/\r\n/g, `
`));
          case 13:
          case 14:
          case 16:
            (o0[2] & 112) == 112 && (o0[2] & 15) > 1 && (o0[2] & 15) < 15 && (o0[1].z = R.dateNF || r[(o0[2] & 15) - 1] || k0[14], R.cellDates && (o0[1].v = O2(o0[1].v), o0[1].t = typeof o0[1].v == "number" ? "n" : "d")), R.qpro && o0[3] > Q && (D["!ref"] = M0(A0), m0[Z] = D, a0.push(Z), D = {}, R.dense && (_0 = D["!data"] = []), A0 = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } }, Q = o0[3], Z = A || "Sheet" + (Q + 1), A = "");
            var q0 = R.dense ? (_0[o0[0].r] || [])[o0[0].c] : D[H0(o0[0])];
            if (q0) {
              q0.t = o0[1].t, q0.v = o0[1].v, o0[1].z != null && (q0.z = o0[1].z), o0[1].f != null && (q0.f = o0[1].f), J0 = q0;
              break;
            }
            R.dense ? (_0[o0[0].r] || (_0[o0[0].r] = []), _0[o0[0].r][o0[0].c] = o0[1]) : D[H0(o0[0])] = o0[1], J0 = o0[1];
            break;
          case 21509:
            R.works2 = !0;
            break;
          case 21506:
            o0 == 5281 && (J0.z = "hh:mm:ss", R.cellDates && J0.t == "n" && (J0.v = O2(J0.v), J0.t = typeof J0.v == "number" ? "n" : "d"));
            break;
        }
      }, R);
    else if (F[2] == 26 || F[2] == 14)
      R.Enum = r0, F[2] == 14 && (R.qpro = !0, F.l = 0), e(F, function(o0, W1, D1) {
        switch (D1) {
          case 204:
            Z = o0;
            break;
          case 22:
            o0[1].v.charCodeAt(0) < 48 && (o0[1].v = o0[1].v.slice(1)), o0[1].v = o0[1].v.replace(/\x0F./g, function(q0) {
              return String.fromCharCode(q0.charCodeAt(1) - 32);
            }).replace(/\r\n/g, `
`);
          case 23:
          case 24:
          case 25:
          case 37:
          case 39:
          case 40:
            if (o0[3] > Q && (D["!ref"] = M0(A0), m0[Z] = D, a0.push(Z), D = {}, R.dense && (_0 = D["!data"] = []), A0 = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } }, Q = o0[3], Z = "Sheet" + (Q + 1)), V0 > 0 && o0[0].r >= V0)
              break;
            R.dense ? (_0[o0[0].r] || (_0[o0[0].r] = []), _0[o0[0].r][o0[0].c] = o0[1]) : D[H0(o0[0])] = o0[1], A0.e.c < o0[0].c && (A0.e.c = o0[0].c), A0.e.r < o0[0].r && (A0.e.r = o0[0].r);
            break;
          case 27:
            o0[14e3] && (g0[o0[14e3][0]] = o0[14e3][1]);
            break;
          case 1537:
            g0[o0[0]] = o0[1], o0[0] == Q && (Z = o0[1]);
            break;
        }
      }, R);
    else
      throw new Error("Unrecognized LOTUS BOF " + F[2]);
    if (D["!ref"] = M0(A0), m0[A || Z] = D, a0.push(A || Z), !g0.length)
      return { SheetNames: a0, Sheets: m0 };
    for (var s1 = {}, d0 = [], N0 = 0; N0 < g0.length; ++N0)
      m0[a0[N0]] ? (d0.push(g0[N0] || a0[N0]), s1[g0[N0]] = m0[g0[N0]] || m0[a0[N0]]) : (d0.push(g0[N0]), s1[g0[N0]] = { "!ref": "A1" });
    return { SheetNames: d0, Sheets: s1 };
  }
  function n(F, B) {
    var R = B || {};
    if (+R.codepage >= 0 && o2(+R.codepage), R.type == "string")
      throw new Error("Cannot write WK1 to JS string");
    var D = v4();
    if (!F["!ref"])
      throw new Error("Cannot export empty sheet to WK1");
    var Z = o1(F["!ref"]), A = F["!data"] != null, Q = [];
    V1(D, 0, c(1030)), V1(D, 6, o(Z));
    for (var m0 = Math.min(Z.e.r, 8191), a0 = Z.s.c; a0 <= Z.e.c; ++a0)
      Q[a0] = W0(a0);
    for (var g0 = Z.s.r; g0 <= m0; ++g0) {
      var _0 = j0(g0);
      for (a0 = Z.s.c; a0 <= Z.e.c; ++a0) {
        var A0 = A ? (F["!data"][g0] || [])[a0] : F[Q[a0] + _0];
        if (!(!A0 || A0.t == "z"))
          switch (A0.t) {
            case "n":
              (A0.v | 0) == A0.v && A0.v >= -32768 && A0.v <= 32767 ? V1(D, 13, x(g0, a0, A0)) : V1(D, 14, T(g0, a0, A0));
              break;
            case "d":
              var V0 = v1(A0.v);
              (V0 | 0) == V0 && V0 >= -32768 && V0 <= 32767 ? V1(D, 13, x(g0, a0, { v: V0, z: A0.z || k0[14] })) : V1(D, 14, T(g0, a0, { v: V0, z: A0.z || k0[14] }));
              break;
            default:
              var J0 = M2(A0);
              V1(D, 15, h(g0, a0, J0.slice(0, 239)));
          }
      }
    }
    return V1(D, 1), D.end();
  }
  function i(F, B) {
    var R = B || {};
    if (+R.codepage >= 0 && o2(+R.codepage), R.type == "string")
      throw new Error("Cannot write WK3 to JS string");
    var D = v4();
    V1(D, 0, s(F));
    for (var Z = 0, A = 0; Z < F.SheetNames.length; ++Z)
      (F.Sheets[F.SheetNames[Z]] || {})["!ref"] && V1(D, 27, S0(F.SheetNames[Z], A++));
    var Q = 0;
    for (Z = 0; Z < F.SheetNames.length; ++Z) {
      var m0 = F.Sheets[F.SheetNames[Z]];
      if (!(!m0 || !m0["!ref"])) {
        for (var a0 = o1(m0["!ref"]), g0 = m0["!data"] != null, _0 = [], A0 = Math.min(a0.e.r, 8191), V0 = a0.s.r; V0 <= A0; ++V0)
          for (var J0 = j0(V0), s1 = a0.s.c; s1 <= a0.e.c; ++s1) {
            V0 === a0.s.r && (_0[s1] = W0(s1));
            var d0 = _0[s1] + J0, N0 = g0 ? (m0["!data"][V0] || [])[s1] : m0[d0];
            if (!(!N0 || N0.t == "z"))
              if (N0.t == "n")
                V1(D, 23, Y(V0, s1, Q, N0.v));
              else {
                var o0 = M2(N0);
                V1(D, 22, P(V0, s1, Q, o0.slice(0, 239)));
              }
          }
        ++Q;
      }
    }
    return V1(D, 1), D.end();
  }
  function c(F) {
    var B = p1(2);
    return B.write_shift(2, F), B;
  }
  function s(F) {
    var B = p1(26);
    B.write_shift(2, 4096), B.write_shift(2, 4), B.write_shift(4, 0);
    for (var R = 0, D = 0, Z = 0, A = 0; A < F.SheetNames.length; ++A) {
      var Q = F.SheetNames[A], m0 = F.Sheets[Q];
      if (!(!m0 || !m0["!ref"])) {
        ++Z;
        var a0 = Q2(m0["!ref"]);
        R < a0.e.r && (R = a0.e.r), D < a0.e.c && (D = a0.e.c);
      }
    }
    return R > 8191 && (R = 8191), B.write_shift(2, R), B.write_shift(1, Z), B.write_shift(1, D), B.write_shift(2, 0), B.write_shift(2, 0), B.write_shift(1, 1), B.write_shift(1, 2), B.write_shift(4, 0), B.write_shift(4, 0), B;
  }
  function f(F, B, R) {
    var D = { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } };
    return B == 8 && R.qpro ? (D.s.c = F.read_shift(1), F.l++, D.s.r = F.read_shift(2), D.e.c = F.read_shift(1), F.l++, D.e.r = F.read_shift(2), D) : (D.s.c = F.read_shift(2), D.s.r = F.read_shift(2), B == 12 && R.qpro && (F.l += 2), D.e.c = F.read_shift(2), D.e.r = F.read_shift(2), B == 12 && R.qpro && (F.l += 2), D.s.c == 65535 && (D.s.c = D.e.c = D.s.r = D.e.r = 0), D);
  }
  function o(F) {
    var B = p1(8);
    return B.write_shift(2, F.s.c), B.write_shift(2, F.s.r), B.write_shift(2, F.e.c), B.write_shift(2, F.e.r), B;
  }
  function l(F, B, R) {
    var D = [{ c: 0, r: 0 }, { t: "n", v: 0 }, 0, 0];
    return R.qpro && R.vers != 20768 ? (D[0].c = F.read_shift(1), D[3] = F.read_shift(1), D[0].r = F.read_shift(2), F.l += 2) : R.works ? (D[0].c = F.read_shift(2), D[0].r = F.read_shift(2), D[2] = F.read_shift(2)) : (D[2] = F.read_shift(1), D[0].c = F.read_shift(2), D[0].r = F.read_shift(2)), D;
  }
  function d(F) {
    return F.z && u2(F.z) ? 240 | (r.indexOf(F.z) + 1 || 2) : 255;
  }
  function u(F, B, R) {
    var D = F.l + B, Z = l(F, B, R);
    if (Z[1].t = "s", (R.vers & 65534) == 20768) {
      F.l++;
      var A = F.read_shift(1);
      return Z[1].v = F.read_shift(A, "utf8"), Z;
    }
    return R.qpro && F.l++, Z[1].v = F.read_shift(D - F.l, "cstr"), Z;
  }
  function h(F, B, R) {
    var D = p1(7 + R.length);
    D.write_shift(1, 255), D.write_shift(2, B), D.write_shift(2, F), D.write_shift(1, 39);
    for (var Z = 0; Z < D.length; ++Z) {
      var A = R.charCodeAt(Z);
      D.write_shift(1, A >= 128 ? 95 : A);
    }
    return D.write_shift(1, 0), D;
  }
  function p(F, B, R) {
    var D = F.l + B, Z = l(F, B, R);
    if (Z[1].t = "s", R.vers == 20768) {
      var A = F.read_shift(1);
      return Z[1].v = F.read_shift(A, "utf8"), Z;
    }
    return Z[1].v = F.read_shift(D - F.l, "cstr"), Z;
  }
  function v(F, B, R) {
    var D = l(F, B, R);
    return D[1].v = F.read_shift(2, "i"), D;
  }
  function x(F, B, R) {
    var D = p1(7);
    return D.write_shift(1, d(R)), D.write_shift(2, B), D.write_shift(2, F), D.write_shift(2, R.v, "i"), D;
  }
  function m(F, B, R) {
    var D = l(F, B, R);
    return D[1].v = F.read_shift(8, "f"), D;
  }
  function T(F, B, R) {
    var D = p1(13);
    return D.write_shift(1, d(R)), D.write_shift(2, B), D.write_shift(2, F), D.write_shift(8, R.v, "f"), D;
  }
  function g(F, B, R) {
    var D = F.l + B, Z = l(F, B, R);
    if (Z[1].v = F.read_shift(8, "f"), R.qpro)
      F.l = D;
    else {
      var A = F.read_shift(2);
      E(F.slice(F.l, F.l + A), Z), F.l += A;
    }
    return Z;
  }
  function O(F, B, R) {
    var D = B & 32768;
    return B &= -32769, B = (D ? F : 0) + (B >= 8192 ? B - 16384 : B), (D ? "" : "$") + (R ? W0(B) : j0(B));
  }
  var H = {
    31: ["NA", 0],
    // 0x20: ["ERR", 0],
    33: ["ABS", 1],
    34: ["TRUNC", 1],
    35: ["SQRT", 1],
    36: ["LOG", 1],
    37: ["LN", 1],
    38: ["PI", 0],
    39: ["SIN", 1],
    40: ["COS", 1],
    41: ["TAN", 1],
    42: ["ATAN2", 2],
    43: ["ATAN", 1],
    44: ["ASIN", 1],
    45: ["ACOS", 1],
    46: ["EXP", 1],
    47: ["MOD", 2],
    // 0x30
    49: ["ISNA", 1],
    50: ["ISERR", 1],
    51: ["FALSE", 0],
    52: ["TRUE", 0],
    53: ["RAND", 0],
    54: ["DATE", 3],
    // 0x37 NOW
    // 0x38 PMT
    // 0x39 PV
    // 0x3A FV
    // 0x3B IF
    // 0x3C DAY
    // 0x3D MONTH
    // 0x3E YEAR
    63: ["ROUND", 2],
    64: ["TIME", 3],
    // 0x41 HOUR
    // 0x42 MINUTE
    // 0x43 SECOND
    68: ["ISNUMBER", 1],
    69: ["ISTEXT", 1],
    70: ["LEN", 1],
    71: ["VALUE", 1],
    // 0x48: ["FIXED", ?? 1],
    73: ["MID", 3],
    74: ["CHAR", 1],
    // 0x4B
    // 0x4C FIND
    // 0x4D DATEVALUE
    // 0x4E TIMEVALUE
    // 0x4F CELL
    80: ["SUM", 69],
    81: ["AVERAGEA", 69],
    82: ["COUNTA", 69],
    83: ["MINA", 69],
    84: ["MAXA", 69],
    // 0x55 VLOOKUP
    // 0x56 NPV
    // 0x57 VAR
    // 0x58 STD
    // 0x59 IRR
    // 0x5A HLOOKUP
    // 0x5B DSUM
    // 0x5C DAVERAGE
    // 0x5D DCOUNTA
    // 0x5E DMIN
    // 0x5F DMAX
    // 0x60 DVARP
    // 0x61 DSTDEVP
    // 0x62 INDEX
    // 0x63 COLS
    // 0x64 ROWS
    // 0x65 REPEAT
    102: ["UPPER", 1],
    103: ["LOWER", 1],
    // 0x68 LEFT
    // 0x69 RIGHT
    // 0x6A REPLACE
    107: ["PROPER", 1],
    // 0x6C CELL
    109: ["TRIM", 1],
    // 0x6E CLEAN
    111: ["T", 1]
    // 0x70 V
  }, W = [
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    // eslint-disable-line no-mixed-spaces-and-tabs
    "",
    "+",
    "-",
    "*",
    "/",
    "^",
    "=",
    "<>",
    // eslint-disable-line no-mixed-spaces-and-tabs
    "<=",
    ">=",
    "<",
    ">",
    "",
    "",
    "",
    "",
    // eslint-disable-line no-mixed-spaces-and-tabs
    "&",
    "",
    "",
    "",
    "",
    "",
    "",
    ""
    // eslint-disable-line no-mixed-spaces-and-tabs
  ];
  function E(F, B) {
    m1(F, 0);
    for (var R = [], D = 0, Z = "", A = "", Q = "", m0 = ""; F.l < F.length; ) {
      var a0 = F[F.l++];
      switch (a0) {
        case 0:
          R.push(F.read_shift(8, "f"));
          break;
        case 1:
          A = O(B[0].c, F.read_shift(2), !0), Z = O(B[0].r, F.read_shift(2), !1), R.push(A + Z);
          break;
        case 2:
          {
            var g0 = O(B[0].c, F.read_shift(2), !0), _0 = O(B[0].r, F.read_shift(2), !1);
            A = O(B[0].c, F.read_shift(2), !0), Z = O(B[0].r, F.read_shift(2), !1), R.push(g0 + _0 + ":" + A + Z);
          }
          break;
        case 3:
          if (F.l < F.length) {
            console.error("WK1 premature formula end");
            return;
          }
          break;
        case 4:
          R.push("(" + R.pop() + ")");
          break;
        case 5:
          R.push(F.read_shift(2));
          break;
        case 6:
          {
            for (var A0 = ""; a0 = F[F.l++]; )
              A0 += String.fromCharCode(a0);
            R.push('"' + A0.replace(/"/g, '""') + '"');
          }
          break;
        case 8:
          R.push("-" + R.pop());
          break;
        case 23:
          R.push("+" + R.pop());
          break;
        case 22:
          R.push("NOT(" + R.pop() + ")");
          break;
        case 20:
        case 21:
          m0 = R.pop(), Q = R.pop(), R.push(["AND", "OR"][a0 - 20] + "(" + Q + "," + m0 + ")");
          break;
        default:
          if (a0 < 32 && W[a0])
            m0 = R.pop(), Q = R.pop(), R.push(Q + W[a0] + m0);
          else if (H[a0]) {
            if (D = H[a0][1], D == 69 && (D = F[F.l++]), D > R.length) {
              console.error("WK1 bad formula parse 0x" + a0.toString(16) + ":|" + R.join("|") + "|");
              return;
            }
            var V0 = R.slice(-D);
            R.length -= D, R.push(H[a0][0] + "(" + V0.join(",") + ")");
          } else
            return a0 <= 7 ? console.error("WK1 invalid opcode " + a0.toString(16)) : a0 <= 24 ? console.error("WK1 unsupported op " + a0.toString(16)) : a0 <= 30 ? console.error("WK1 invalid opcode " + a0.toString(16)) : a0 <= 115 ? console.error("WK1 unsupported function opcode " + a0.toString(16)) : console.error("WK1 unrecognized opcode " + a0.toString(16));
      }
    }
    R.length == 1 ? B[1].f = "" + R[0] : console.error("WK1 bad formula parse |" + R.join("|") + "|");
  }
  function b(F) {
    var B = [{ c: 0, r: 0 }, { t: "n", v: 0 }, 0];
    return B[0].r = F.read_shift(2), B[3] = F[F.l++], B[0].c = F[F.l++], B;
  }
  function I(F, B) {
    var R = b(F);
    return R[1].t = "s", R[1].v = F.read_shift(B - 4, "cstr"), R;
  }
  function P(F, B, R, D) {
    var Z = p1(6 + D.length);
    Z.write_shift(2, F), Z.write_shift(1, R), Z.write_shift(1, B), Z.write_shift(1, 39);
    for (var A = 0; A < D.length; ++A) {
      var Q = D.charCodeAt(A);
      Z.write_shift(1, Q >= 128 ? 95 : Q);
    }
    return Z.write_shift(1, 0), Z;
  }
  function L(F, B) {
    var R = b(F);
    R[1].v = F.read_shift(2);
    var D = R[1].v >> 1;
    if (R[1].v & 1)
      switch (D & 7) {
        case 0:
          D = (D >> 3) * 5e3;
          break;
        case 1:
          D = (D >> 3) * 500;
          break;
        case 2:
          D = (D >> 3) / 20;
          break;
        case 3:
          D = (D >> 3) / 200;
          break;
        case 4:
          D = (D >> 3) / 2e3;
          break;
        case 5:
          D = (D >> 3) / 2e4;
          break;
        case 6:
          D = (D >> 3) / 16;
          break;
        case 7:
          D = (D >> 3) / 64;
          break;
      }
    return R[1].v = D, R;
  }
  function z(F, B) {
    var R = b(F), D = F.read_shift(4), Z = F.read_shift(4), A = F.read_shift(2);
    if (A == 65535)
      return D === 0 && Z === 3221225472 ? (R[1].t = "e", R[1].v = 15) : D === 0 && Z === 3489660928 ? (R[1].t = "e", R[1].v = 42) : R[1].v = 0, R;
    var Q = A & 32768;
    return A = (A & 32767) - 16446, R[1].v = (1 - Q * 2) * (Z * Math.pow(2, A + 32) + D * Math.pow(2, A)), R;
  }
  function Y(F, B, R, D) {
    var Z = p1(14);
    if (Z.write_shift(2, F), Z.write_shift(1, R), Z.write_shift(1, B), D == 0)
      return Z.write_shift(4, 0), Z.write_shift(4, 0), Z.write_shift(2, 65535), Z;
    var A = 0, Q = 0, m0 = 0, a0 = 0;
    return D < 0 && (A = 1, D = -D), Q = Math.log2(D) | 0, D /= Math.pow(2, Q - 31), a0 = D >>> 0, a0 & 2147483648 || (D /= 2, ++Q, a0 = D >>> 0), D -= a0, a0 |= 2147483648, a0 >>>= 0, D *= Math.pow(2, 32), m0 = D >>> 0, Z.write_shift(4, m0), Z.write_shift(4, a0), Q += 16383 + (A ? 32768 : 0), Z.write_shift(2, Q), Z;
  }
  function f0(F, B) {
    var R = z(F);
    return F.l += B - 14, R;
  }
  function i0(F, B) {
    var R = b(F), D = F.read_shift(4);
    return R[1].v = D >> 6, R;
  }
  function p0(F, B) {
    var R = b(F), D = F.read_shift(8, "f");
    return R[1].v = D, R;
  }
  function n0(F, B) {
    var R = p0(F);
    return F.l += B - 12, R;
  }
  function v0(F, B) {
    return F[F.l + B - 1] == 0 ? F.read_shift(B, "cstr") : "";
  }
  function I0(F, B) {
    var R = F[F.l++];
    R > B - 1 && (R = B - 1);
    for (var D = ""; D.length < R; )
      D += String.fromCharCode(F[F.l++]);
    return D;
  }
  function K(F, B, R) {
    if (!(!R.qpro || B < 21)) {
      var D = F.read_shift(1);
      F.l += 17, F.l += 1, F.l += 2;
      var Z = F.read_shift(B - 21, "cstr");
      return [D, Z];
    }
  }
  function T0(F, B) {
    for (var R = {}, D = F.l + B; F.l < D; ) {
      var Z = F.read_shift(2);
      if (Z == 14e3) {
        for (R[Z] = [0, ""], R[Z][0] = F.read_shift(2); F[F.l]; )
          R[Z][1] += String.fromCharCode(F[F.l]), F.l++;
        F.l++;
      }
    }
    return R;
  }
  function S0(F, B) {
    var R = p1(5 + F.length);
    R.write_shift(2, 14e3), R.write_shift(2, B);
    for (var D = 0; D < F.length; ++D) {
      var Z = F.charCodeAt(D);
      R[R.l++] = Z > 127 ? 95 : Z;
    }
    return R[R.l++] = 0, R;
  }
  var w0 = {
    /*::[*/
    0: { n: "BOF", f: i1 },
    /*::[*/
    1: { n: "EOF" },
    /*::[*/
    2: { n: "CALCMODE" },
    /*::[*/
    3: { n: "CALCORDER" },
    /*::[*/
    4: { n: "SPLIT" },
    /*::[*/
    5: { n: "SYNC" },
    /*::[*/
    6: { n: "RANGE", f },
    /*::[*/
    7: { n: "WINDOW1" },
    /*::[*/
    8: { n: "COLW1" },
    /*::[*/
    9: { n: "WINTWO" },
    /*::[*/
    10: { n: "COLW2" },
    /*::[*/
    11: { n: "NAME" },
    /*::[*/
    12: { n: "BLANK" },
    /*::[*/
    13: { n: "INTEGER", f: v },
    /*::[*/
    14: { n: "NUMBER", f: m },
    /*::[*/
    15: { n: "LABEL", f: u },
    /*::[*/
    16: { n: "FORMULA", f: g },
    /*::[*/
    24: { n: "TABLE" },
    /*::[*/
    25: { n: "ORANGE" },
    /*::[*/
    26: { n: "PRANGE" },
    /*::[*/
    27: { n: "SRANGE" },
    /*::[*/
    28: { n: "FRANGE" },
    /*::[*/
    29: { n: "KRANGE1" },
    /*::[*/
    32: { n: "HRANGE" },
    /*::[*/
    35: { n: "KRANGE2" },
    /*::[*/
    36: { n: "PROTEC" },
    /*::[*/
    37: { n: "FOOTER" },
    /*::[*/
    38: { n: "HEADER" },
    /*::[*/
    39: { n: "SETUP" },
    /*::[*/
    40: { n: "MARGINS" },
    /*::[*/
    41: { n: "LABELFMT" },
    /*::[*/
    42: { n: "TITLES" },
    /*::[*/
    43: { n: "SHEETJS" },
    /*::[*/
    45: { n: "GRAPH" },
    /*::[*/
    46: { n: "NGRAPH" },
    /*::[*/
    47: { n: "CALCCOUNT" },
    /*::[*/
    48: { n: "UNFORMATTED" },
    /*::[*/
    49: { n: "CURSORW12" },
    /*::[*/
    50: { n: "WINDOW" },
    /*::[*/
    51: { n: "STRING", f: p },
    /*::[*/
    55: { n: "PASSWORD" },
    /*::[*/
    56: { n: "LOCKED" },
    /*::[*/
    60: { n: "QUERY" },
    /*::[*/
    61: { n: "QUERYNAME" },
    /*::[*/
    62: { n: "PRINT" },
    /*::[*/
    63: { n: "PRINTNAME" },
    /*::[*/
    64: { n: "GRAPH2" },
    /*::[*/
    65: { n: "GRAPHNAME" },
    /*::[*/
    66: { n: "ZOOM" },
    /*::[*/
    67: { n: "SYMSPLIT" },
    /*::[*/
    68: { n: "NSROWS" },
    /*::[*/
    69: { n: "NSCOLS" },
    /*::[*/
    70: { n: "RULER" },
    /*::[*/
    71: { n: "NNAME" },
    /*::[*/
    72: { n: "ACOMM" },
    /*::[*/
    73: { n: "AMACRO" },
    /*::[*/
    74: { n: "PARSE" },
    // 0x0064
    /*::[*/
    102: { n: "PRANGES??" },
    /*::[*/
    103: { n: "RRANGES??" },
    /*::[*/
    104: { n: "FNAME??" },
    /*::[*/
    105: { n: "MRANGES??" },
    // 0x0096
    // 0x0099
    // 0x009A
    // 0x009B
    // 0x009C
    // 0x00C0
    // 0x00C7
    // 0x00C9
    /*::[*/
    204: { n: "SHEETNAMECS", f: v0 },
    // 0x00CD
    /*::[*/
    222: { n: "SHEETNAMELP", f: I0 },
    /*::[*/
    255: { n: "BOF", f: i1 },
    /*::[*/
    21506: { n: "WKSNF", f: i1 },
    /*::[*/
    65535: { n: "" }
  }, r0 = {
    /*::[*/
    0: { n: "BOF" },
    /*::[*/
    1: { n: "EOF" },
    /*::[*/
    2: { n: "PASSWORD" },
    /*::[*/
    3: { n: "CALCSET" },
    /*::[*/
    4: { n: "WINDOWSET" },
    /*::[*/
    5: { n: "SHEETCELLPTR" },
    /*::[*/
    6: { n: "SHEETLAYOUT" },
    /*::[*/
    7: { n: "COLUMNWIDTH" },
    /*::[*/
    8: { n: "HIDDENCOLUMN" },
    /*::[*/
    9: { n: "USERRANGE" },
    /*::[*/
    10: { n: "SYSTEMRANGE" },
    /*::[*/
    11: { n: "ZEROFORCE" },
    /*::[*/
    12: { n: "SORTKEYDIR" },
    /*::[*/
    13: { n: "FILESEAL" },
    /*::[*/
    14: { n: "DATAFILLNUMS" },
    /*::[*/
    15: { n: "PRINTMAIN" },
    /*::[*/
    16: { n: "PRINTSTRING" },
    /*::[*/
    17: { n: "GRAPHMAIN" },
    /*::[*/
    18: { n: "GRAPHSTRING" },
    /*::[*/
    19: { n: "??" },
    /*::[*/
    20: { n: "ERRCELL" },
    /*::[*/
    21: { n: "NACELL" },
    /*::[*/
    22: { n: "LABEL16", f: I },
    /*::[*/
    23: { n: "NUMBER17", f: z },
    /*::[*/
    24: { n: "NUMBER18", f: L },
    /*::[*/
    25: { n: "FORMULA19", f: f0 },
    /*::[*/
    26: { n: "FORMULA1A" },
    /*::[*/
    27: { n: "XFORMAT", f: T0 },
    /*::[*/
    28: { n: "DTLABELMISC" },
    /*::[*/
    29: { n: "DTLABELCELL" },
    /*::[*/
    30: { n: "GRAPHWINDOW" },
    /*::[*/
    31: { n: "CPA" },
    /*::[*/
    32: { n: "LPLAUTO" },
    /*::[*/
    33: { n: "QUERY" },
    /*::[*/
    34: { n: "HIDDENSHEET" },
    /*::[*/
    35: { n: "??" },
    /*::[*/
    37: { n: "NUMBER25", f: i0 },
    /*::[*/
    38: { n: "??" },
    /*::[*/
    39: { n: "NUMBER27", f: p0 },
    /*::[*/
    40: { n: "FORMULA28", f: n0 },
    /*::[*/
    142: { n: "??" },
    /*::[*/
    147: { n: "??" },
    /*::[*/
    150: { n: "??" },
    /*::[*/
    151: { n: "??" },
    /*::[*/
    152: { n: "??" },
    /*::[*/
    153: { n: "??" },
    /*::[*/
    154: { n: "??" },
    /*::[*/
    155: { n: "??" },
    /*::[*/
    156: { n: "??" },
    /*::[*/
    163: { n: "??" },
    /*::[*/
    174: { n: "??" },
    /*::[*/
    175: { n: "??" },
    /*::[*/
    176: { n: "??" },
    /*::[*/
    177: { n: "??" },
    /*::[*/
    184: { n: "??" },
    /*::[*/
    185: { n: "??" },
    /*::[*/
    186: { n: "??" },
    /*::[*/
    187: { n: "??" },
    /*::[*/
    188: { n: "??" },
    /*::[*/
    195: { n: "??" },
    /*::[*/
    201: { n: "??" },
    /*::[*/
    204: { n: "SHEETNAMECS", f: v0 },
    /*::[*/
    205: { n: "??" },
    /*::[*/
    206: { n: "??" },
    /*::[*/
    207: { n: "??" },
    /*::[*/
    208: { n: "??" },
    /*::[*/
    256: { n: "??" },
    /*::[*/
    259: { n: "??" },
    /*::[*/
    260: { n: "??" },
    /*::[*/
    261: { n: "??" },
    /*::[*/
    262: { n: "??" },
    /*::[*/
    263: { n: "??" },
    /*::[*/
    265: { n: "??" },
    /*::[*/
    266: { n: "??" },
    /*::[*/
    267: { n: "??" },
    /*::[*/
    268: { n: "??" },
    /*::[*/
    270: { n: "??" },
    /*::[*/
    271: { n: "??" },
    /*::[*/
    384: { n: "??" },
    /*::[*/
    389: { n: "??" },
    /*::[*/
    390: { n: "??" },
    /*::[*/
    393: { n: "??" },
    /*::[*/
    396: { n: "??" },
    /*::[*/
    512: { n: "??" },
    /*::[*/
    514: { n: "??" },
    /*::[*/
    513: { n: "??" },
    /*::[*/
    516: { n: "??" },
    /*::[*/
    517: { n: "??" },
    /*::[*/
    640: { n: "??" },
    /*::[*/
    641: { n: "??" },
    /*::[*/
    642: { n: "??" },
    /*::[*/
    643: { n: "??" },
    /*::[*/
    644: { n: "??" },
    /*::[*/
    645: { n: "??" },
    /*::[*/
    646: { n: "??" },
    /*::[*/
    647: { n: "??" },
    /*::[*/
    648: { n: "??" },
    /*::[*/
    658: { n: "??" },
    /*::[*/
    659: { n: "??" },
    /*::[*/
    660: { n: "??" },
    /*::[*/
    661: { n: "??" },
    /*::[*/
    662: { n: "??" },
    /*::[*/
    665: { n: "??" },
    /*::[*/
    666: { n: "??" },
    /*::[*/
    768: { n: "??" },
    /*::[*/
    772: { n: "??" },
    /*::[*/
    1537: { n: "SHEETINFOQP", f: K },
    /*::[*/
    1600: { n: "??" },
    /*::[*/
    1602: { n: "??" },
    /*::[*/
    1793: { n: "??" },
    /*::[*/
    1794: { n: "??" },
    /*::[*/
    1795: { n: "??" },
    /*::[*/
    1796: { n: "??" },
    /*::[*/
    1920: { n: "??" },
    /*::[*/
    2048: { n: "??" },
    /*::[*/
    2049: { n: "??" },
    /*::[*/
    2052: { n: "??" },
    /*::[*/
    2688: { n: "??" },
    /*::[*/
    10998: { n: "??" },
    /*::[*/
    12849: { n: "??" },
    /*::[*/
    28233: { n: "??" },
    /*::[*/
    28484: { n: "??" },
    /*::[*/
    65535: { n: "" }
  }, E0 = {
    /*::[*/
    5: "dd-mmm-yy",
    /*::[*/
    6: "dd-mmm",
    /*::[*/
    7: "mmm-yy",
    /*::[*/
    8: "mm/dd/yy",
    // Long Date Intl
    /*::[*/
    10: "hh:mm:ss AM/PM",
    /*::[*/
    11: "hh:mm AM/PM",
    /*::[*/
    14: "dd-mmm-yyyy",
    /*::[*/
    15: "mmm-yyyy",
    /* It is suspected that the the low nybble specifies decimal places */
    /*::[*/
    34: "0.00",
    /*::[*/
    50: "0.00;[Red]0.00",
    /*::[*/
    66: "0.00;(0.00)",
    /*::[*/
    82: "0.00;[Red](0.00)",
    /*::[*/
    162: '"$"#,##0.00;\\("$"#,##0.00\\)',
    /*::[*/
    288: "0%",
    /*::[*/
    304: "0E+00",
    /*::[*/
    320: "# ?/?"
  };
  function b0(F) {
    var B = F.read_shift(2), R = F.read_shift(1);
    if (R != 0)
      throw "unsupported QPW string type " + R.toString(16);
    return F.read_shift(B, "sbcs-cont");
  }
  function D0(F, B) {
    m1(F, 0);
    var R = B || {}, D = {};
    R.dense && (D["!data"] = []);
    var Z = [], A = "", Q = { s: { r: -1, c: -1 }, e: { r: -1, c: -1 } }, m0 = 0, a0 = 0, g0 = 0, _0 = 0, A0 = { SheetNames: [], Sheets: {} }, V0 = [];
    e:
      for (; F.l < F.length; ) {
        var J0 = F.read_shift(2), s1 = F.read_shift(2), d0 = F.slice(F.l, F.l + s1);
        switch (m1(d0, 0), J0) {
          case 1:
            if (d0.read_shift(4) != 962023505)
              throw "Bad QPW9 BOF!";
            break;
          case 2:
            break e;
          case 8:
            break;
          case 10:
            for (var N0 = d0.read_shift(4), o0 = (d0.length - d0.l) / N0 | 0, W1 = 0; W1 < N0; ++W1) {
              var D1 = d0.l + o0, q0 = {};
              d0.l += 2, q0.numFmtId = d0.read_shift(2), E0[q0.numFmtId] && (q0.z = E0[q0.numFmtId]), d0.l = D1, V0.push(q0);
            }
            break;
          case 1025:
            break;
          case 1026:
            break;
          case 1031:
            for (d0.l += 12; d0.l < d0.length; )
              m0 = d0.read_shift(2), a0 = d0.read_shift(1), Z.push(d0.read_shift(m0, "cstr"));
            break;
          case 1032:
            break;
          case 1537:
            {
              var i2 = d0.read_shift(2);
              D = {}, R.dense && (D["!data"] = []), Q.s.c = d0.read_shift(2), Q.e.c = d0.read_shift(2), Q.s.r = d0.read_shift(4), Q.e.r = d0.read_shift(4), d0.l += 4, d0.l + 2 < d0.length && (m0 = d0.read_shift(2), a0 = d0.read_shift(1), A = m0 == 0 ? "" : d0.read_shift(m0, "cstr")), A || (A = W0(i2));
            }
            break;
          case 1538:
            {
              if (Q.s.c > 255 || Q.s.r > 999999)
                break;
              Q.e.c < Q.s.c && (Q.e.c = Q.s.c), Q.e.r < Q.s.r && (Q.e.r = Q.s.r), D["!ref"] = M0(Q), se(A0, D, A);
            }
            break;
          case 2561:
            g0 = d0.read_shift(2), Q.e.c < g0 && (Q.e.c = g0), Q.s.c > g0 && (Q.s.c = g0), _0 = d0.read_shift(4), Q.s.r > _0 && (Q.s.r = _0), _0 = d0.read_shift(4), Q.e.r < _0 && (Q.e.r = _0);
            break;
          case 3073:
            {
              _0 = d0.read_shift(4), m0 = d0.read_shift(4), Q.s.r > _0 && (Q.s.r = _0), Q.e.r < _0 + m0 - 1 && (Q.e.r = _0 + m0 - 1);
              for (var B1 = W0(g0); d0.l < d0.length; ) {
                var h0 = { t: "z" }, B0 = d0.read_shift(1), T1 = -1;
                B0 & 128 && (T1 = d0.read_shift(2));
                var c1 = B0 & 64 ? d0.read_shift(2) - 1 : 0;
                switch (B0 & 31) {
                  case 0:
                    break;
                  case 1:
                    break;
                  case 2:
                    h0 = { t: "n", v: d0.read_shift(2) };
                    break;
                  case 3:
                    h0 = { t: "n", v: d0.read_shift(2, "i") };
                    break;
                  case 4:
                    h0 = { t: "n", v: Ye(d0) };
                    break;
                  case 5:
                    h0 = { t: "n", v: d0.read_shift(8, "f") };
                    break;
                  case 7:
                    h0 = { t: "s", v: Z[a0 = d0.read_shift(4) - 1] };
                    break;
                  case 8:
                    h0 = { t: "n", v: d0.read_shift(8, "f") }, d0.l += 2, d0.l += 4, isNaN(h0.v) && (h0 = { t: "e", v: 15 });
                    break;
                  default:
                    throw "Unrecognized QPW cell type " + (B0 & 31);
                }
                T1 != -1 && (V0[T1 - 1] || {}).z && (h0.z = V0[T1 - 1].z);
                var U1 = 0;
                if (B0 & 32)
                  switch (B0 & 31) {
                    case 2:
                      U1 = d0.read_shift(2);
                      break;
                    case 3:
                      U1 = d0.read_shift(2, "i");
                      break;
                    case 7:
                      U1 = d0.read_shift(2);
                      break;
                    default:
                      throw "Unsupported delta for QPW cell type " + (B0 & 31);
                  }
                if (!(!R.sheetStubs && h0.t == "z")) {
                  var U2 = x1(h0);
                  h0.t == "n" && h0.z && u2(h0.z) && R.cellDates && (U2.v = O2(h0.v), U2.t = typeof U2.v == "number" ? "n" : "d"), D["!data"] != null ? (D["!data"][_0] || (D["!data"][_0] = []), D["!data"][_0][g0] = U2) : D[B1 + j0(_0)] = U2;
                }
                for (++_0, --m0; c1-- > 0 && m0 >= 0; ) {
                  if (B0 & 32)
                    switch (B0 & 31) {
                      case 2:
                        h0 = { t: "n", v: h0.v + U1 & 65535 };
                        break;
                      case 3:
                        h0 = { t: "n", v: h0.v + U1 & 65535 }, h0.v > 32767 && (h0.v -= 65536);
                        break;
                      case 7:
                        h0 = { t: "s", v: Z[a0 = a0 + U1 >>> 0] };
                        break;
                      default:
                        throw "Cannot apply delta for QPW cell type " + (B0 & 31);
                    }
                  else
                    switch (B0 & 31) {
                      case 1:
                        h0 = { t: "z" };
                        break;
                      case 2:
                        h0 = { t: "n", v: d0.read_shift(2) };
                        break;
                      case 7:
                        h0 = { t: "s", v: Z[a0 = d0.read_shift(4) - 1] };
                        break;
                      default:
                        throw "Cannot apply repeat for QPW cell type " + (B0 & 31);
                    }
                  !R.sheetStubs && h0.t == "z" || (D["!data"] != null ? (D["!data"][_0] || (D["!data"][_0] = []), D["!data"][_0][g0] = h0) : D[B1 + j0(_0)] = h0), ++_0, --m0;
                }
              }
            }
            break;
          case 3074:
            {
              g0 = d0.read_shift(2), _0 = d0.read_shift(4);
              var ce = b0(d0);
              D["!data"] != null ? (D["!data"][_0] || (D["!data"][_0] = []), D["!data"][_0][g0] = { t: "s", v: ce }) : D[W0(g0) + j0(_0)] = { t: "s", v: ce };
            }
            break;
        }
        F.l += s1;
      }
    return A0;
  }
  return {
    sheet_to_wk1: n,
    book_to_wk3: i,
    to_workbook: t
  };
}();
function cc(e) {
  var t = {}, r = e.match(k1), a = 0, n = !1;
  if (r)
    for (; a != r.length; ++a) {
      var i = x0(r[a]);
      switch (i[0].replace(/\w*:/g, "")) {
        case "<condense":
          break;
        case "<extend":
          break;
        case "<shadow":
          if (!i.val)
            break;
        case "<shadow>":
        case "<shadow/>":
          t.shadow = 1;
          break;
        case "</shadow>":
          break;
        case "<charset":
          if (i.val == "1")
            break;
          t.cp = N4[parseInt(i.val, 10)];
          break;
        case "<outline":
          if (!i.val)
            break;
        case "<outline>":
        case "<outline/>":
          t.outline = 1;
          break;
        case "</outline>":
          break;
        case "<rFont":
          t.name = i.val;
          break;
        case "<sz":
          t.sz = i.val;
          break;
        case "<strike":
          if (!i.val)
            break;
        case "<strike>":
        case "<strike/>":
          t.strike = 1;
          break;
        case "</strike>":
          break;
        case "<u":
          if (!i.val)
            break;
          switch (i.val) {
            case "double":
              t.uval = "double";
              break;
            case "singleAccounting":
              t.uval = "single-accounting";
              break;
            case "doubleAccounting":
              t.uval = "double-accounting";
              break;
          }
        case "<u>":
        case "<u/>":
          t.u = 1;
          break;
        case "</u>":
          break;
        case "<b":
          if (i.val == "0")
            break;
        case "<b>":
        case "<b/>":
          t.b = 1;
          break;
        case "</b>":
          break;
        case "<i":
          if (i.val == "0")
            break;
        case "<i>":
        case "<i/>":
          t.i = 1;
          break;
        case "</i>":
          break;
        case "<color":
          i.rgb && (t.color = i.rgb.slice(2, 8));
          break;
        case "<color>":
        case "<color/>":
        case "</color>":
          break;
        case "<family":
          t.family = i.val;
          break;
        case "<family>":
        case "<family/>":
        case "</family>":
          break;
        case "<vertAlign":
          t.valign = i.val;
          break;
        case "<vertAlign>":
        case "<vertAlign/>":
        case "</vertAlign>":
          break;
        case "<scheme":
          break;
        case "<scheme>":
        case "<scheme/>":
        case "</scheme>":
          break;
        case "<extLst":
        case "<extLst>":
        case "</extLst>":
          break;
        case "<ext":
          n = !0;
          break;
        case "</ext>":
          n = !1;
          break;
        default:
          if (i[0].charCodeAt(1) !== 47 && !n)
            throw new Error("Unrecognized rich format " + i[0]);
      }
    }
  return t;
}
var fc = /* @__PURE__ */ function() {
  var e = X3("t"), t = X3("rPr");
  function r(i) {
    var c = i.match(e);
    if (!c)
      return { t: "s", v: "" };
    var s = { t: "s", v: R0(c[1]) }, f = i.match(t);
    return f && (s.s = cc(f[1])), s;
  }
  var a = /<(?:\w+:)?r>/g, n = /<\/(?:\w+:)?r>/;
  return function(c) {
    return c.replace(a, "").split(n).map(r).filter(function(s) {
      return s.v;
    });
  };
}(), oc = /* @__PURE__ */ function() {
  var t = /(\r\n|\n)/g;
  function r(n, i, c) {
    var s = [];
    n.u && s.push("text-decoration: underline;"), n.uval && s.push("text-underline-style:" + n.uval + ";"), n.sz && s.push("font-size:" + n.sz + "pt;"), n.outline && s.push("text-effect: outline;"), n.shadow && s.push("text-shadow: auto;"), i.push('<span style="' + s.join("") + '">'), n.b && (i.push("<b>"), c.push("</b>")), n.i && (i.push("<i>"), c.push("</i>")), n.strike && (i.push("<s>"), c.push("</s>"));
    var f = n.valign || "";
    return f == "superscript" || f == "super" ? f = "sup" : f == "subscript" && (f = "sub"), f != "" && (i.push("<" + f + ">"), c.push("</" + f + ">")), c.push("</span>"), n;
  }
  function a(n) {
    var i = [[], n.v, []];
    return n.v ? (n.s && r(n.s, i[0], i[2]), i[0].join("") + i[1].replace(t, "<br/>") + i[2].join("")) : "";
  }
  return function(i) {
    return i.map(a).join("");
  };
}(), lc = /<(?:\w+:)?t[^>]*>([^<]*)<\/(?:\w+:)?t>/g, hc = /<(?:\w+:)?r\b[^>]*>/, uc = /<(?:\w+:)?rPh.*?>([\s\S]*?)<\/(?:\w+:)?rPh>/g;
function K4(e, t) {
  var r = t ? t.cellHTML : !0, a = {};
  return e ? (e.match(/^\s*<(?:\w+:)?t[^>]*>/) ? (a.t = R0(X0(e.slice(e.indexOf(">") + 1).split(/<\/(?:\w+:)?t>/)[0] || ""), !0), a.r = X0(e), r && (a.h = Ie(a.t))) : (
    /*y = */
    e.match(hc) && (a.r = X0(e), a.t = R0(X0((e.replace(uc, "").match(lc) || []).join("").replace(k1, "")), !0), r && (a.h = oc(fc(a.r))))
  ), a) : { t: "" };
}
var xc = /<(?:\w+:)?sst([^>]*)>([\s\S]*)<\/(?:\w+:)?sst>/, dc = /<(?:\w+:)?(?:si|sstItem)>/g, pc = /<\/(?:\w+:)?(?:si|sstItem)>/;
function mc(e, t) {
  var r = [], a = "";
  if (!e)
    return r;
  var n = e.match(xc);
  if (n) {
    a = n[2].replace(dc, "").split(pc);
    for (var i = 0; i != a.length; ++i) {
      var c = K4(a[i].trim(), t);
      c != null && (r[r.length] = c);
    }
    n = x0(n[1]), r.Count = n.count, r.Unique = n.uniqueCount;
  }
  return r;
}
function vc(e) {
  return [e.read_shift(4), e.read_shift(4)];
}
function gc(e, t) {
  var r = [], a = !1;
  return k2(e, function(i, c, s) {
    switch (s) {
      case 159:
        r.Count = i[0], r.Unique = i[1];
        break;
      case 19:
        r.push(i);
        break;
      case 160:
        return !0;
      case 35:
        a = !0;
        break;
      case 36:
        a = !1;
        break;
      default:
        if (c.T, !a || t.WTF)
          throw new Error("Unexpected record 0x" + s.toString(16));
    }
  }), r;
}
function A7(e) {
  for (var t = [], r = e.split(""), a = 0; a < r.length; ++a)
    t[a] = r[a].charCodeAt(0);
  return t;
}
function E2(e, t) {
  var r = {};
  return r.Major = e.read_shift(2), r.Minor = e.read_shift(2), t >= 4 && (e.l += t - 4), r;
}
function _c(e) {
  var t = {};
  return t.id = e.read_shift(0, "lpp4"), t.R = E2(e, 4), t.U = E2(e, 4), t.W = E2(e, 4), t;
}
function Tc(e) {
  for (var t = e.read_shift(4), r = e.l + t - 4, a = {}, n = e.read_shift(4), i = []; n-- > 0; )
    i.push({ t: e.read_shift(4), v: e.read_shift(0, "lpp4") });
  if (a.name = e.read_shift(0, "lpp4"), a.comps = i, e.l != r)
    throw new Error("Bad DataSpaceMapEntry: " + e.l + " != " + r);
  return a;
}
function Ec(e) {
  var t = [];
  e.l += 4;
  for (var r = e.read_shift(4); r-- > 0; )
    t.push(Tc(e));
  return t;
}
function wc(e) {
  var t = [];
  e.l += 4;
  for (var r = e.read_shift(4); r-- > 0; )
    t.push(e.read_shift(0, "lpp4"));
  return t;
}
function kc(e) {
  var t = {};
  return e.read_shift(4), e.l += 4, t.id = e.read_shift(0, "lpp4"), t.name = e.read_shift(0, "lpp4"), t.R = E2(e, 4), t.U = E2(e, 4), t.W = E2(e, 4), t;
}
function Cc(e) {
  var t = kc(e);
  if (t.ename = e.read_shift(0, "8lpp4"), t.blksz = e.read_shift(4), t.cmode = e.read_shift(4), e.read_shift(4) != 4)
    throw new Error("Bad !Primary record");
  return t;
}
function F7(e, t) {
  var r = e.l + t, a = {};
  a.Flags = e.read_shift(4) & 63, e.l += 4, a.AlgID = e.read_shift(4);
  var n = !1;
  switch (a.AlgID) {
    case 26126:
    case 26127:
    case 26128:
      n = a.Flags == 36;
      break;
    case 26625:
      n = a.Flags == 4;
      break;
    case 0:
      n = a.Flags == 16 || a.Flags == 4 || a.Flags == 36;
      break;
    default:
      throw "Unrecognized encryption algorithm: " + a.AlgID;
  }
  if (!n)
    throw new Error("Encryption Flags/AlgID mismatch");
  return a.AlgIDHash = e.read_shift(4), a.KeySize = e.read_shift(4), a.ProviderType = e.read_shift(4), e.l += 8, a.CSPName = e.read_shift(r - e.l >> 1, "utf16le"), e.l = r, a;
}
function y7(e, t) {
  var r = {}, a = e.l + t;
  return e.l += 4, r.Salt = e.slice(e.l, e.l + 16), e.l += 16, r.Verifier = e.slice(e.l, e.l + 16), e.l += 16, e.read_shift(4), r.VerifierHash = e.slice(e.l, a), e.l = a, r;
}
function Sc(e) {
  var t = E2(e);
  switch (t.Minor) {
    case 2:
      return [t.Minor, Ac(e)];
    case 3:
      return [t.Minor, Fc()];
    case 4:
      return [t.Minor, yc(e)];
  }
  throw new Error("ECMA-376 Encrypted file unrecognized Version: " + t.Minor);
}
function Ac(e) {
  var t = e.read_shift(4);
  if ((t & 63) != 36)
    throw new Error("EncryptionInfo mismatch");
  var r = e.read_shift(4), a = F7(e, r), n = y7(e, e.length - e.l);
  return { t: "Std", h: a, v: n };
}
function Fc() {
  throw new Error("File is password-protected: ECMA-376 Extensible");
}
function yc(e) {
  var t = ["saltSize", "blockSize", "keyBits", "hashSize", "cipherAlgorithm", "cipherChaining", "hashAlgorithm", "saltValue"];
  e.l += 4;
  var r = e.read_shift(e.length - e.l, "utf8"), a = {};
  return r.replace(k1, function(i) {
    var c = x0(i);
    switch (a2(c[0])) {
      case "<?xml":
        break;
      case "<encryption":
      case "</encryption>":
        break;
      case "<keyData":
        t.forEach(function(s) {
          a[s] = c[s];
        });
        break;
      case "<dataIntegrity":
        a.encryptedHmacKey = c.encryptedHmacKey, a.encryptedHmacValue = c.encryptedHmacValue;
        break;
      case "<keyEncryptors>":
      case "<keyEncryptors":
        a.encs = [];
        break;
      case "</keyEncryptors>":
        break;
      case "<keyEncryptor":
        a.uri = c.uri;
        break;
      case "</keyEncryptor>":
        break;
      case "<encryptedKey":
        a.encs.push(c);
        break;
      default:
        throw c[0];
    }
  }), a;
}
function Ic(e, t) {
  var r = {}, a = r.EncryptionVersionInfo = E2(e, 4);
  if (t -= 4, a.Minor != 2)
    throw new Error("unrecognized minor version code: " + a.Minor);
  if (a.Major > 4 || a.Major < 2)
    throw new Error("unrecognized major version code: " + a.Major);
  r.Flags = e.read_shift(4), t -= 4;
  var n = e.read_shift(4);
  return t -= 4, r.EncryptionHeader = F7(e, n), t -= n, r.EncryptionVerifier = y7(e, t), r;
}
function bc(e) {
  var t = {}, r = t.EncryptionVersionInfo = E2(e, 4);
  if (r.Major != 1 || r.Minor != 1)
    throw "unrecognized version code " + r.Major + " : " + r.Minor;
  return t.Salt = e.read_shift(16), t.EncryptedVerifier = e.read_shift(16), t.EncryptedVerifierHash = e.read_shift(16), t;
}
function Dc(e) {
  var t = 0, r, a = A7(e), n = a.length + 1, i, c, s, f, o;
  for (r = R2(n), r[0] = a.length, i = 1; i != n; ++i)
    r[i] = a[i - 1];
  for (i = n - 1; i >= 0; --i)
    c = r[i], s = t & 16384 ? 1 : 0, f = t << 1 & 32767, o = s | f, t = o ^ c;
  return t ^ 52811;
}
var I7 = /* @__PURE__ */ function() {
  var e = [187, 255, 255, 186, 255, 255, 185, 128, 0, 190, 15, 0, 191, 15, 0], t = [57840, 7439, 52380, 33984, 4364, 3600, 61902, 12606, 6258, 57657, 54287, 34041, 10252, 43370, 20163], r = [44796, 19929, 39858, 10053, 20106, 40212, 10761, 31585, 63170, 64933, 60267, 50935, 40399, 11199, 17763, 35526, 1453, 2906, 5812, 11624, 23248, 885, 1770, 3540, 7080, 14160, 28320, 56640, 55369, 41139, 20807, 41614, 21821, 43642, 17621, 28485, 56970, 44341, 19019, 38038, 14605, 29210, 60195, 50791, 40175, 10751, 21502, 43004, 24537, 18387, 36774, 3949, 7898, 15796, 31592, 63184, 47201, 24803, 49606, 37805, 14203, 28406, 56812, 17824, 35648, 1697, 3394, 6788, 13576, 27152, 43601, 17539, 35078, 557, 1114, 2228, 4456, 30388, 60776, 51953, 34243, 7079, 14158, 28316, 14128, 28256, 56512, 43425, 17251, 34502, 7597, 13105, 26210, 52420, 35241, 883, 1766, 3532, 4129, 8258, 16516, 33032, 4657, 9314, 18628], a = function(c) {
    return (c / 2 | c * 128) & 255;
  }, n = function(c, s) {
    return a(c ^ s);
  }, i = function(c) {
    for (var s = t[c.length - 1], f = 104, o = c.length - 1; o >= 0; --o)
      for (var l = c[o], d = 0; d != 7; ++d)
        l & 64 && (s ^= r[f]), l *= 2, --f;
    return s;
  };
  return function(c) {
    for (var s = A7(c), f = i(s), o = s.length, l = R2(16), d = 0; d != 16; ++d)
      l[d] = 0;
    var u, h, p;
    for ((o & 1) === 1 && (u = f >> 8, l[o] = n(e[0], u), --o, u = f & 255, h = s[s.length - 1], l[o] = n(h, u)); o > 0; )
      --o, u = f >> 8, l[o] = n(s[o], u), --o, u = f & 255, l[o] = n(s[o], u);
    for (o = 15, p = 15 - s.length; p > 0; )
      u = f >> 8, l[o] = n(e[p], u), --o, --p, u = f & 255, l[o] = n(s[o], u), --o, --p;
    return l;
  };
}(), Oc = function(e, t, r, a, n) {
  n || (n = t), a || (a = I7(e));
  var i, c;
  for (i = 0; i != t.length; ++i)
    c = t[i], c ^= a[r], c = (c >> 5 | c << 3) & 255, n[i] = c, ++r;
  return [n, r, a];
}, Rc = function(e) {
  var t = 0, r = I7(e);
  return function(a) {
    var n = Oc("", a, t, r);
    return t = n[1], n[0];
  };
};
function Mc(e, t, r, a) {
  var n = { key: i1(e), verificationBytes: i1(e) };
  return r.password && (n.verifier = Dc(r.password)), a.valid = n.verificationBytes === n.verifier, a.valid && (a.insitu = Rc(r.password)), n;
}
function Nc(e, t, r) {
  var a = r || {};
  return a.Info = e.read_shift(2), e.l -= 2, a.Info === 1 ? a.Data = bc(e) : a.Data = Ic(e, t), a;
}
function Pc(e, t, r) {
  var a = { Type: r.biff >= 8 ? e.read_shift(2) : 0 };
  return a.Type ? Nc(e, t - 2, a) : Mc(e, r.biff >= 8 ? t : t - 2, r, a), a;
}
function Lc(e, t) {
  switch (t.type) {
    case "base64":
      return _e($1(e), t);
    case "binary":
      return _e(e, t);
    case "buffer":
      return _e(O0 && Buffer.isBuffer(e) ? e.toString("binary") : w2(e), t);
    case "array":
      return _e(Y2(e), t);
  }
  throw new Error("Unrecognized type " + t.type);
}
function _e(e, t) {
  var r = t || {}, a = {}, n = r.dense;
  n && (a["!data"] = []);
  var i = e.match(/\\trowd[\s\S]*?\\row\b/g);
  if (!i)
    throw new Error("RTF missing table");
  var c = { s: { c: 0, r: 0 }, e: { c: 0, r: i.length - 1 } }, s = [];
  return i.forEach(function(f, o) {
    n && (s = a["!data"][o] = []);
    for (var l = /\\[\w\-]+\b/g, d = 0, u, h = -1, p = []; (u = l.exec(f)) != null; ) {
      var v = f.slice(d, l.lastIndex - u[0].length);
      switch (v.charCodeAt(0) == 32 && (v = v.slice(1)), v.length && p.push(v), u[0]) {
        case "\\cell":
          if (++h, p.length) {
            var x = { v: p.join(""), t: "s" };
            x.v == "TRUE" || x.v == "FALSE" ? (x.v = x.v == "TRUE", x.t = "b") : isNaN(z1(x.v)) || (x.t = "n", r.cellText !== !1 && (x.w = x.v), x.v = z1(x.v)), n ? s[h] = x : a[H0({ r: o, c: h })] = x;
          }
          p = [];
          break;
        case "\\par":
          p.push(`
`);
          break;
      }
      d = l.lastIndex;
    }
    h > c.e.c && (c.e.c = h);
  }), a["!ref"] = M0(c), a;
}
function Bc(e, t) {
  var r = B2(Lc(e, t), t);
  return r.bookType = "rtf", r;
}
function Uc(e) {
  var t = e.slice(e[0] === "#" ? 1 : 0).slice(0, 6);
  return [parseInt(t.slice(0, 2), 16), parseInt(t.slice(2, 4), 16), parseInt(t.slice(4, 6), 16)];
}
function Y3(e) {
  for (var t = 0, r = 1; t != 3; ++t)
    r = r * 256 + (e[t] > 255 ? 255 : e[t] < 0 ? 0 : e[t]);
  return r.toString(16).toUpperCase().slice(1);
}
function Hc(e) {
  var t = e[0] / 255, r = e[1] / 255, a = e[2] / 255, n = Math.max(t, r, a), i = Math.min(t, r, a), c = n - i;
  if (c === 0)
    return [0, 0, t];
  var s = 0, f = 0, o = n + i;
  switch (f = c / (o > 1 ? 2 - o : o), n) {
    case t:
      s = ((r - a) / c + 6) % 6;
      break;
    case r:
      s = (a - t) / c + 2;
      break;
    case a:
      s = (t - r) / c + 4;
      break;
  }
  return [s / 6, f, o / 2];
}
function Wc(e) {
  var t = e[0], r = e[1], a = e[2], n = r * 2 * (a < 0.5 ? a : 1 - a), i = a - n / 2, c = [i, i, i], s = 6 * t, f;
  if (r !== 0)
    switch (s | 0) {
      case 0:
      case 6:
        f = n * s, c[0] += n, c[1] += f;
        break;
      case 1:
        f = n * (2 - s), c[0] += f, c[1] += n;
        break;
      case 2:
        f = n * (s - 2), c[1] += n, c[2] += f;
        break;
      case 3:
        f = n * (4 - s), c[1] += f, c[2] += n;
        break;
      case 4:
        f = n * (s - 4), c[2] += n, c[0] += f;
        break;
      case 5:
        f = n * (6 - s), c[2] += f, c[0] += n;
        break;
    }
  for (var o = 0; o != 3; ++o)
    c[o] = Math.round(c[o] * 255);
  return c;
}
function Re(e, t) {
  if (t === 0)
    return e;
  var r = Hc(Uc(e));
  return t < 0 ? r[2] = r[2] * (1 + t) : r[2] = 1 - (1 - r[2]) * (1 - t), Y3(Wc(r));
}
var b7 = 6, Vc = 15, Gc = 1, N1 = b7;
function Me(e) {
  return Math.floor((e + Math.round(128 / N1) / 256) * N1);
}
function Ne(e) {
  return Math.floor((e - 5) / N1 * 100 + 0.5) / 100;
}
function E4(e) {
  return Math.round((e * N1 + 5) / N1 * 256) / 256;
}
function l4(e) {
  return E4(Ne(Me(e)));
}
function Y4(e) {
  var t = Math.abs(e - l4(e)), r = N1;
  if (t > 5e-3)
    for (N1 = Gc; N1 < Vc; ++N1)
      Math.abs(e - l4(e)) <= t && (t = Math.abs(e - l4(e)), r = N1);
  N1 = r;
}
function m3(e) {
  e.width ? (e.wpx = Me(e.width), e.wch = Ne(e.wpx), e.MDW = N1) : e.wpx ? (e.wch = Ne(e.wpx), e.width = E4(e.wch), e.MDW = N1) : typeof e.wch == "number" && (e.width = E4(e.wch), e.wpx = Me(e.width), e.MDW = N1), e.customWidth && delete e.customWidth;
}
var jc = 96, D7 = jc;
function O7(e) {
  return e * 96 / D7;
}
function J3(e) {
  return e * D7 / 96;
}
var zc = {
  None: "none",
  Solid: "solid",
  Gray50: "mediumGray",
  Gray75: "darkGray",
  Gray25: "lightGray",
  HorzStripe: "darkHorizontal",
  VertStripe: "darkVertical",
  ReverseDiagStripe: "darkDown",
  DiagStripe: "darkUp",
  DiagCross: "darkGrid",
  ThickDiagCross: "darkTrellis",
  ThinHorzStripe: "lightHorizontal",
  ThinVertStripe: "lightVertical",
  ThinReverseDiagStripe: "lightDown",
  ThinHorzCross: "lightGrid"
};
function $c(e, t, r, a) {
  t.Borders = [];
  var n = {}, i = !1;
  (e[0].match(k1) || []).forEach(function(c) {
    var s = x0(c);
    switch (a2(s[0])) {
      case "<borders":
      case "<borders>":
      case "</borders>":
        break;
      case "<border":
      case "<border>":
      case "<border/>":
        n = /*::(*/
        {}, s.diagonalUp && (n.diagonalUp = G0(s.diagonalUp)), s.diagonalDown && (n.diagonalDown = G0(s.diagonalDown)), t.Borders.push(n);
        break;
      case "</border>":
        break;
      case "<left/>":
        break;
      case "<left":
      case "<left>":
        break;
      case "</left>":
        break;
      case "<right/>":
        break;
      case "<right":
      case "<right>":
        break;
      case "</right>":
        break;
      case "<top/>":
        break;
      case "<top":
      case "<top>":
        break;
      case "</top>":
        break;
      case "<bottom/>":
        break;
      case "<bottom":
      case "<bottom>":
        break;
      case "</bottom>":
        break;
      case "<diagonal":
      case "<diagonal>":
      case "<diagonal/>":
        break;
      case "</diagonal>":
        break;
      case "<horizontal":
      case "<horizontal>":
      case "<horizontal/>":
        break;
      case "</horizontal>":
        break;
      case "<vertical":
      case "<vertical>":
      case "<vertical/>":
        break;
      case "</vertical>":
        break;
      case "<start":
      case "<start>":
      case "<start/>":
        break;
      case "</start>":
        break;
      case "<end":
      case "<end>":
      case "<end/>":
        break;
      case "</end>":
        break;
      case "<color":
      case "<color>":
        break;
      case "<color/>":
      case "</color>":
        break;
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
        break;
      case "<ext":
        i = !0;
        break;
      case "</ext>":
        i = !1;
        break;
      default:
        if (a && a.WTF && !i)
          throw new Error("unrecognized " + s[0] + " in borders");
    }
  });
}
function Xc(e, t, r, a) {
  t.Fills = [];
  var n = {}, i = !1;
  (e[0].match(k1) || []).forEach(function(c) {
    var s = x0(c);
    switch (a2(s[0])) {
      case "<fills":
      case "<fills>":
      case "</fills>":
        break;
      case "<fill>":
      case "<fill":
      case "<fill/>":
        n = {}, t.Fills.push(n);
        break;
      case "</fill>":
        break;
      case "<gradientFill>":
        break;
      case "<gradientFill":
      case "</gradientFill>":
        t.Fills.push(n), n = {};
        break;
      case "<patternFill":
      case "<patternFill>":
        s.patternType && (n.patternType = s.patternType);
        break;
      case "<patternFill/>":
      case "</patternFill>":
        break;
      case "<bgColor":
        n.bgColor || (n.bgColor = {}), s.indexed && (n.bgColor.indexed = parseInt(s.indexed, 10)), s.theme && (n.bgColor.theme = parseInt(s.theme, 10)), s.tint && (n.bgColor.tint = parseFloat(s.tint)), s.rgb && (n.bgColor.rgb = s.rgb.slice(-6));
        break;
      case "<bgColor/>":
      case "</bgColor>":
        break;
      case "<fgColor":
        n.fgColor || (n.fgColor = {}), s.theme && (n.fgColor.theme = parseInt(s.theme, 10)), s.tint && (n.fgColor.tint = parseFloat(s.tint)), s.rgb != null && (n.fgColor.rgb = s.rgb.slice(-6));
        break;
      case "<fgColor/>":
      case "</fgColor>":
        break;
      case "<stop":
      case "<stop/>":
        break;
      case "</stop>":
        break;
      case "<color":
      case "<color/>":
        break;
      case "</color>":
        break;
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
        break;
      case "<ext":
        i = !0;
        break;
      case "</ext>":
        i = !1;
        break;
      default:
        if (a && a.WTF && !i)
          throw new Error("unrecognized " + s[0] + " in fills");
    }
  });
}
function Kc(e, t, r, a) {
  t.Fonts = [];
  var n = {}, i = !1;
  (e[0].match(k1) || []).forEach(function(c) {
    var s = x0(c);
    switch (a2(s[0])) {
      case "<fonts":
      case "<fonts>":
      case "</fonts>":
        break;
      case "<font":
      case "<font>":
        break;
      case "</font>":
      case "<font/>":
        t.Fonts.push(n), n = {};
        break;
      case "<name":
        s.val && (n.name = X0(s.val));
        break;
      case "<name/>":
      case "</name>":
        break;
      case "<b":
        n.bold = s.val ? G0(s.val) : 1;
        break;
      case "<b/>":
        n.bold = 1;
        break;
      case "<i":
        n.italic = s.val ? G0(s.val) : 1;
        break;
      case "<i/>":
        n.italic = 1;
        break;
      case "<u":
        switch (s.val) {
          case "none":
            n.underline = 0;
            break;
          case "single":
            n.underline = 1;
            break;
          case "double":
            n.underline = 2;
            break;
          case "singleAccounting":
            n.underline = 33;
            break;
          case "doubleAccounting":
            n.underline = 34;
            break;
        }
        break;
      case "<u/>":
        n.underline = 1;
        break;
      case "<strike":
        n.strike = s.val ? G0(s.val) : 1;
        break;
      case "<strike/>":
        n.strike = 1;
        break;
      case "<outline":
        n.outline = s.val ? G0(s.val) : 1;
        break;
      case "<outline/>":
        n.outline = 1;
        break;
      case "<shadow":
        n.shadow = s.val ? G0(s.val) : 1;
        break;
      case "<shadow/>":
        n.shadow = 1;
        break;
      case "<condense":
        n.condense = s.val ? G0(s.val) : 1;
        break;
      case "<condense/>":
        n.condense = 1;
        break;
      case "<extend":
        n.extend = s.val ? G0(s.val) : 1;
        break;
      case "<extend/>":
        n.extend = 1;
        break;
      case "<sz":
        s.val && (n.sz = +s.val);
        break;
      case "<sz/>":
      case "</sz>":
        break;
      case "<vertAlign":
        s.val && (n.vertAlign = s.val);
        break;
      case "<vertAlign/>":
      case "</vertAlign>":
        break;
      case "<family":
        s.val && (n.family = parseInt(s.val, 10));
        break;
      case "<family/>":
      case "</family>":
        break;
      case "<scheme":
        s.val && (n.scheme = s.val);
        break;
      case "<scheme/>":
      case "</scheme>":
        break;
      case "<charset":
        if (s.val == "1")
          break;
        s.codepage = N4[parseInt(s.val, 10)];
        break;
      case "<color":
        if (n.color || (n.color = {}), s.auto && (n.color.auto = G0(s.auto)), s.rgb)
          n.color.rgb = s.rgb.slice(-6);
        else if (s.indexed) {
          n.color.index = parseInt(s.indexed, 10);
          var f = $2[n.color.index];
          n.color.index == 81 && (f = $2[1]), f || (f = $2[1]), n.color.rgb = f[0].toString(16) + f[1].toString(16) + f[2].toString(16);
        } else
          s.theme && (n.color.theme = parseInt(s.theme, 10), s.tint && (n.color.tint = parseFloat(s.tint)), s.theme && r.themeElements && r.themeElements.clrScheme && (n.color.rgb = Re(r.themeElements.clrScheme[n.color.theme].rgb, n.color.tint || 0)));
        break;
      case "<color/>":
      case "</color>":
        break;
      case "<AlternateContent":
        i = !0;
        break;
      case "</AlternateContent>":
        i = !1;
        break;
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
        break;
      case "<ext":
        i = !0;
        break;
      case "</ext>":
        i = !1;
        break;
      default:
        if (a && a.WTF && !i)
          throw new Error("unrecognized " + s[0] + " in fonts");
    }
  });
}
function Yc(e, t, r) {
  t.NumberFmt = [];
  for (var a = t2(k0), n = 0; n < a.length; ++n)
    t.NumberFmt[a[n]] = k0[a[n]];
  var i = e[0].match(k1);
  if (i)
    for (n = 0; n < i.length; ++n) {
      var c = x0(i[n]);
      switch (a2(c[0])) {
        case "<numFmts":
        case "</numFmts>":
        case "<numFmts/>":
        case "<numFmts>":
          break;
        case "<numFmt":
          {
            var s = R0(X0(c.formatCode)), f = parseInt(c.numFmtId, 10);
            if (t.NumberFmt[f] = s, f > 0) {
              if (f > 392) {
                for (f = 392; f > 60 && t.NumberFmt[f] != null; --f)
                  ;
                t.NumberFmt[f] = s;
              }
              z2(s, f);
            }
          }
          break;
        case "</numFmt>":
          break;
        default:
          if (r.WTF)
            throw new Error("unrecognized " + c[0] + " in numFmts");
      }
    }
}
var Te = ["numFmtId", "fillId", "fontId", "borderId", "xfId"], Ee = ["applyAlignment", "applyBorder", "applyFill", "applyFont", "applyNumberFormat", "applyProtection", "pivotButton", "quotePrefix"];
function Jc(e, t, r) {
  t.CellXf = [];
  var a, n = !1;
  (e[0].match(k1) || []).forEach(function(i) {
    var c = x0(i), s = 0;
    switch (a2(c[0])) {
      case "<cellXfs":
      case "<cellXfs>":
      case "<cellXfs/>":
      case "</cellXfs>":
        break;
      case "<xf":
      case "<xf/>":
      case "<xf>":
        for (a = c, delete a[0], s = 0; s < Te.length; ++s)
          a[Te[s]] && (a[Te[s]] = parseInt(a[Te[s]], 10));
        for (s = 0; s < Ee.length; ++s)
          a[Ee[s]] && (a[Ee[s]] = G0(a[Ee[s]]));
        if (t.NumberFmt && a.numFmtId > 392) {
          for (s = 392; s > 60; --s)
            if (t.NumberFmt[a.numFmtId] == t.NumberFmt[s]) {
              a.numFmtId = s;
              break;
            }
        }
        t.CellXf.push(a);
        break;
      case "</xf>":
        break;
      case "<alignment":
      case "<alignment/>":
      case "<alignment>":
        var f = {};
        c.vertical && (f.vertical = c.vertical), c.horizontal && (f.horizontal = c.horizontal), c.textRotation != null && (f.textRotation = c.textRotation), c.indent && (f.indent = c.indent), c.wrapText && (f.wrapText = G0(c.wrapText)), a.alignment = f;
        break;
      case "</alignment>":
        break;
      case "<protection":
      case "<protection>":
        break;
      case "</protection>":
      case "<protection/>":
        break;
      case "<AlternateContent":
      case "<AlternateContent>":
        n = !0;
        break;
      case "</AlternateContent>":
        n = !1;
        break;
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
        break;
      case "<ext":
        n = !0;
        break;
      case "</ext>":
        n = !1;
        break;
      default:
        if (r && r.WTF && !n)
          throw new Error("unrecognized " + c[0] + " in cellXfs");
    }
  });
}
var qc = /* @__PURE__ */ function() {
  var t = /<(?:\w+:)?numFmts([^>]*)>[\S\s]*?<\/(?:\w+:)?numFmts>/, r = /<(?:\w+:)?cellXfs([^>]*)>[\S\s]*?<\/(?:\w+:)?cellXfs>/, a = /<(?:\w+:)?fills([^>]*)>[\S\s]*?<\/(?:\w+:)?fills>/, n = /<(?:\w+:)?fonts([^>]*)>[\S\s]*?<\/(?:\w+:)?fonts>/, i = /<(?:\w+:)?borders([^>]*)>[\S\s]*?<\/(?:\w+:)?borders>/;
  return function(s, f, o) {
    var l = {};
    if (!s)
      return l;
    s = s.replace(/<!--([\s\S]*?)-->/mg, "").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm, "");
    var d;
    return (d = s.match(t)) && Yc(d, l, o), (d = s.match(n)) && Kc(d, l, f, o), (d = s.match(a)) && Xc(d, l, f, o), (d = s.match(i)) && $c(d, l, f, o), (d = s.match(r)) && Jc(d, l, o), l;
  };
}();
function Zc(e, t) {
  var r = e.read_shift(2), a = I1(e);
  return [r, a];
}
function Qc(e, t, r) {
  var a = {};
  a.sz = e.read_shift(2) / 20;
  var n = ii(e);
  n.fItalic && (a.italic = 1), n.fCondense && (a.condense = 1), n.fExtend && (a.extend = 1), n.fShadow && (a.shadow = 1), n.fOutline && (a.outline = 1), n.fStrikeout && (a.strike = 1);
  var i = e.read_shift(2);
  switch (i === 700 && (a.bold = 1), e.read_shift(2)) {
    case 1:
      a.vertAlign = "superscript";
      break;
    case 2:
      a.vertAlign = "subscript";
      break;
  }
  var c = e.read_shift(1);
  c != 0 && (a.underline = c);
  var s = e.read_shift(1);
  s > 0 && (a.family = s);
  var f = e.read_shift(1);
  switch (f > 0 && (a.charset = f), e.l++, a.color = ni(e), e.read_shift(1)) {
    case 1:
      a.scheme = "major";
      break;
    case 2:
      a.scheme = "minor";
      break;
  }
  return a.name = I1(e), a;
}
var ef = b1;
function rf(e, t) {
  var r = e.l + t, a = e.read_shift(2), n = e.read_shift(2);
  return e.l = r, { ixfe: a, numFmtId: n };
}
var tf = b1;
function af(e, t, r) {
  var a = {};
  a.NumberFmt = [];
  for (var n in k0)
    a.NumberFmt[n] = k0[n];
  a.CellXf = [], a.Fonts = [];
  var i = [], c = !1;
  return k2(e, function(f, o, l) {
    switch (l) {
      case 44:
        a.NumberFmt[f[0]] = f[1], z2(f[1], f[0]);
        break;
      case 43:
        a.Fonts.push(f), f.color.theme != null && t && t.themeElements && t.themeElements.clrScheme && (f.color.rgb = Re(t.themeElements.clrScheme[f.color.theme].rgb, f.color.tint || 0));
        break;
      case 1025:
        break;
      case 45:
        break;
      case 46:
        break;
      case 47:
        i[i.length - 1] == 617 && a.CellXf.push(f);
        break;
      case 48:
      case 507:
      case 572:
      case 475:
        break;
      case 1171:
      case 2102:
      case 1130:
      case 512:
      case 2095:
      case 3072:
        break;
      case 35:
        c = !0;
        break;
      case 36:
        c = !1;
        break;
      case 37:
        i.push(l), c = !0;
        break;
      case 38:
        i.pop(), c = !1;
        break;
      default:
        if (o.T > 0)
          i.push(l);
        else if (o.T < 0)
          i.pop();
        else if (!c || r.WTF && i[i.length - 1] != 37)
          throw new Error("Unexpected record 0x" + l.toString(16));
    }
  }), a;
}
var nf = [
  "</a:lt1>",
  "</a:dk1>",
  "</a:lt2>",
  "</a:dk2>",
  "</a:accent1>",
  "</a:accent2>",
  "</a:accent3>",
  "</a:accent4>",
  "</a:accent5>",
  "</a:accent6>",
  "</a:hlink>",
  "</a:folHlink>"
];
function sf(e, t, r) {
  t.themeElements.clrScheme = [];
  var a = {};
  (e[0].match(k1) || []).forEach(function(n) {
    var i = x0(n);
    switch (i[0]) {
      case "<a:clrScheme":
      case "</a:clrScheme>":
        break;
      case "<a:srgbClr":
        a.rgb = i.val;
        break;
      case "<a:sysClr":
        a.rgb = i.lastClr;
        break;
      case "<a:dk1>":
      case "</a:dk1>":
      case "<a:lt1>":
      case "</a:lt1>":
      case "<a:dk2>":
      case "</a:dk2>":
      case "<a:lt2>":
      case "</a:lt2>":
      case "<a:accent1>":
      case "</a:accent1>":
      case "<a:accent2>":
      case "</a:accent2>":
      case "<a:accent3>":
      case "</a:accent3>":
      case "<a:accent4>":
      case "</a:accent4>":
      case "<a:accent5>":
      case "</a:accent5>":
      case "<a:accent6>":
      case "</a:accent6>":
      case "<a:hlink>":
      case "</a:hlink>":
      case "<a:folHlink>":
      case "</a:folHlink>":
        i[0].charAt(1) === "/" ? (t.themeElements.clrScheme[nf.indexOf(i[0])] = a, a = {}) : a.name = i[0].slice(3, i[0].length - 1);
        break;
      default:
        if (r && r.WTF)
          throw new Error("Unrecognized " + i[0] + " in clrScheme");
    }
  });
}
function cf() {
}
function ff() {
}
var of = /<a:clrScheme([^>]*)>[\s\S]*<\/a:clrScheme>/, lf = /<a:fontScheme([^>]*)>[\s\S]*<\/a:fontScheme>/, hf = /<a:fmtScheme([^>]*)>[\s\S]*<\/a:fmtScheme>/;
function uf(e, t, r) {
  t.themeElements = {};
  var a;
  [
    /* clrScheme CT_ColorScheme */
    ["clrScheme", of, sf],
    /* fontScheme CT_FontScheme */
    ["fontScheme", lf, cf],
    /* fmtScheme CT_StyleMatrix */
    ["fmtScheme", hf, ff]
  ].forEach(function(n) {
    if (!(a = e.match(n[1])))
      throw new Error(n[0] + " not found in themeElements");
    n[2](a, t, r);
  });
}
var xf = /<a:themeElements([^>]*)>[\s\S]*<\/a:themeElements>/;
function R7(e, t) {
  (!e || e.length === 0) && (e = df());
  var r, a = {};
  if (!(r = e.match(xf)))
    throw new Error("themeElements not found in theme");
  return uf(r[0], a, t), a.raw = e, a;
}
function df(e, t) {
  var r = [V6];
  return r[r.length] = '<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">', r[r.length] = "<a:themeElements>", r[r.length] = '<a:clrScheme name="Office">', r[r.length] = '<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>', r[r.length] = '<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>', r[r.length] = '<a:dk2><a:srgbClr val="1F497D"/></a:dk2>', r[r.length] = '<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>', r[r.length] = '<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>', r[r.length] = '<a:accent2><a:srgbClr val="C0504D"/></a:accent2>', r[r.length] = '<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>', r[r.length] = '<a:accent4><a:srgbClr val="8064A2"/></a:accent4>', r[r.length] = '<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>', r[r.length] = '<a:accent6><a:srgbClr val="F79646"/></a:accent6>', r[r.length] = '<a:hlink><a:srgbClr val="0000FF"/></a:hlink>', r[r.length] = '<a:folHlink><a:srgbClr val="800080"/></a:folHlink>', r[r.length] = "</a:clrScheme>", r[r.length] = '<a:fontScheme name="Office">', r[r.length] = "<a:majorFont>", r[r.length] = '<a:latin typeface="Cambria"/>', r[r.length] = '<a:ea typeface=""/>', r[r.length] = '<a:cs typeface=""/>', r[r.length] = '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>', r[r.length] = '<a:font script="Hang" typeface="맑은 고딕"/>', r[r.length] = '<a:font script="Hans" typeface="宋体"/>', r[r.length] = '<a:font script="Hant" typeface="新細明體"/>', r[r.length] = '<a:font script="Arab" typeface="Times New Roman"/>', r[r.length] = '<a:font script="Hebr" typeface="Times New Roman"/>', r[r.length] = '<a:font script="Thai" typeface="Tahoma"/>', r[r.length] = '<a:font script="Ethi" typeface="Nyala"/>', r[r.length] = '<a:font script="Beng" typeface="Vrinda"/>', r[r.length] = '<a:font script="Gujr" typeface="Shruti"/>', r[r.length] = '<a:font script="Khmr" typeface="MoolBoran"/>', r[r.length] = '<a:font script="Knda" typeface="Tunga"/>', r[r.length] = '<a:font script="Guru" typeface="Raavi"/>', r[r.length] = '<a:font script="Cans" typeface="Euphemia"/>', r[r.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>', r[r.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>', r[r.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>', r[r.length] = '<a:font script="Thaa" typeface="MV Boli"/>', r[r.length] = '<a:font script="Deva" typeface="Mangal"/>', r[r.length] = '<a:font script="Telu" typeface="Gautami"/>', r[r.length] = '<a:font script="Taml" typeface="Latha"/>', r[r.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>', r[r.length] = '<a:font script="Orya" typeface="Kalinga"/>', r[r.length] = '<a:font script="Mlym" typeface="Kartika"/>', r[r.length] = '<a:font script="Laoo" typeface="DokChampa"/>', r[r.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>', r[r.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>', r[r.length] = '<a:font script="Viet" typeface="Times New Roman"/>', r[r.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>', r[r.length] = '<a:font script="Geor" typeface="Sylfaen"/>', r[r.length] = "</a:majorFont>", r[r.length] = "<a:minorFont>", r[r.length] = '<a:latin typeface="Calibri"/>', r[r.length] = '<a:ea typeface=""/>', r[r.length] = '<a:cs typeface=""/>', r[r.length] = '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>', r[r.length] = '<a:font script="Hang" typeface="맑은 고딕"/>', r[r.length] = '<a:font script="Hans" typeface="宋体"/>', r[r.length] = '<a:font script="Hant" typeface="新細明體"/>', r[r.length] = '<a:font script="Arab" typeface="Arial"/>', r[r.length] = '<a:font script="Hebr" typeface="Arial"/>', r[r.length] = '<a:font script="Thai" typeface="Tahoma"/>', r[r.length] = '<a:font script="Ethi" typeface="Nyala"/>', r[r.length] = '<a:font script="Beng" typeface="Vrinda"/>', r[r.length] = '<a:font script="Gujr" typeface="Shruti"/>', r[r.length] = '<a:font script="Khmr" typeface="DaunPenh"/>', r[r.length] = '<a:font script="Knda" typeface="Tunga"/>', r[r.length] = '<a:font script="Guru" typeface="Raavi"/>', r[r.length] = '<a:font script="Cans" typeface="Euphemia"/>', r[r.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>', r[r.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>', r[r.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>', r[r.length] = '<a:font script="Thaa" typeface="MV Boli"/>', r[r.length] = '<a:font script="Deva" typeface="Mangal"/>', r[r.length] = '<a:font script="Telu" typeface="Gautami"/>', r[r.length] = '<a:font script="Taml" typeface="Latha"/>', r[r.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>', r[r.length] = '<a:font script="Orya" typeface="Kalinga"/>', r[r.length] = '<a:font script="Mlym" typeface="Kartika"/>', r[r.length] = '<a:font script="Laoo" typeface="DokChampa"/>', r[r.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>', r[r.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>', r[r.length] = '<a:font script="Viet" typeface="Arial"/>', r[r.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>', r[r.length] = '<a:font script="Geor" typeface="Sylfaen"/>', r[r.length] = "</a:minorFont>", r[r.length] = "</a:fontScheme>", r[r.length] = '<a:fmtScheme name="Office">', r[r.length] = "<a:fillStyleLst>", r[r.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>', r[r.length] = '<a:gradFill rotWithShape="1">', r[r.length] = "<a:gsLst>", r[r.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>', r[r.length] = '<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>', r[r.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>', r[r.length] = "</a:gsLst>", r[r.length] = '<a:lin ang="16200000" scaled="1"/>', r[r.length] = "</a:gradFill>", r[r.length] = '<a:gradFill rotWithShape="1">', r[r.length] = "<a:gsLst>", r[r.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>', r[r.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>', r[r.length] = "</a:gsLst>", r[r.length] = '<a:lin ang="16200000" scaled="0"/>', r[r.length] = "</a:gradFill>", r[r.length] = "</a:fillStyleLst>", r[r.length] = "<a:lnStyleLst>", r[r.length] = '<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>', r[r.length] = '<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>', r[r.length] = '<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>', r[r.length] = "</a:lnStyleLst>", r[r.length] = "<a:effectStyleLst>", r[r.length] = "<a:effectStyle>", r[r.length] = "<a:effectLst>", r[r.length] = '<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>', r[r.length] = "</a:effectLst>", r[r.length] = "</a:effectStyle>", r[r.length] = "<a:effectStyle>", r[r.length] = "<a:effectLst>", r[r.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>', r[r.length] = "</a:effectLst>", r[r.length] = "</a:effectStyle>", r[r.length] = "<a:effectStyle>", r[r.length] = "<a:effectLst>", r[r.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>', r[r.length] = "</a:effectLst>", r[r.length] = '<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>', r[r.length] = '<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>', r[r.length] = "</a:effectStyle>", r[r.length] = "</a:effectStyleLst>", r[r.length] = "<a:bgFillStyleLst>", r[r.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>', r[r.length] = '<a:gradFill rotWithShape="1">', r[r.length] = "<a:gsLst>", r[r.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>', r[r.length] = '<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>', r[r.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>', r[r.length] = "</a:gsLst>", r[r.length] = '<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>', r[r.length] = "</a:gradFill>", r[r.length] = '<a:gradFill rotWithShape="1">', r[r.length] = "<a:gsLst>", r[r.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>', r[r.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>', r[r.length] = "</a:gsLst>", r[r.length] = '<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>', r[r.length] = "</a:gradFill>", r[r.length] = "</a:bgFillStyleLst>", r[r.length] = "</a:fmtScheme>", r[r.length] = "</a:themeElements>", r[r.length] = "<a:objectDefaults>", r[r.length] = "<a:spDef>", r[r.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>', r[r.length] = "</a:spDef>", r[r.length] = "<a:lnDef>", r[r.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>', r[r.length] = "</a:lnDef>", r[r.length] = "</a:objectDefaults>", r[r.length] = "<a:extraClrSchemeLst/>", r[r.length] = "</a:theme>", r.join("");
}
function pf(e, t, r) {
  var a = e.l + t, n = e.read_shift(4);
  if (n !== 124226) {
    if (!r.cellStyles) {
      e.l = a;
      return;
    }
    var i = e.slice(e.l);
    e.l = a;
    var c;
    try {
      c = W6(i, { type: "array" });
    } catch {
      return;
    }
    var s = P1(c, "theme/theme/theme1.xml", !0);
    if (s)
      return R7(s, r);
  }
}
function mf(e) {
  return e.read_shift(4);
}
function vf(e) {
  var t = {};
  switch (t.xclrType = e.read_shift(2), t.nTintShade = e.read_shift(2), t.xclrType) {
    case 0:
      e.l += 4;
      break;
    case 1:
      t.xclrValue = gf(e, 4);
      break;
    case 2:
      t.xclrValue = _7(e);
      break;
    case 3:
      t.xclrValue = mf(e);
      break;
    case 4:
      e.l += 4;
      break;
  }
  return e.l += 8, t;
}
function gf(e, t) {
  return b1(e, t);
}
function _f(e, t) {
  return b1(e, t);
}
function Tf(e) {
  var t = e.read_shift(2), r = e.read_shift(2) - 4, a = [t];
  switch (t) {
    case 4:
    case 5:
    case 7:
    case 8:
    case 9:
    case 10:
    case 11:
    case 13:
      a[1] = vf(e);
      break;
    case 6:
      a[1] = _f(e, r);
      break;
    case 14:
    case 15:
      a[1] = e.read_shift(r === 1 ? 1 : 2);
      break;
    default:
      throw new Error("Unrecognized ExtProp type: " + t + " " + r);
  }
  return a;
}
function Ef(e, t) {
  var r = e.l + t;
  e.l += 2;
  var a = e.read_shift(2);
  e.l += 2;
  for (var n = e.read_shift(2), i = []; n-- > 0; )
    i.push(Tf(e, r - e.l));
  return { ixfe: a, ext: i };
}
function wf(e, t) {
  t.forEach(function(r) {
    switch (r[0]) {
    }
  });
}
function kf(e, t) {
  return {
    flags: e.read_shift(4),
    version: e.read_shift(4),
    name: I1(e)
  };
}
function Cf(e) {
  for (var t = [], r = e.read_shift(4); r-- > 0; )
    t.push([e.read_shift(4), e.read_shift(4)]);
  return t;
}
function Sf(e) {
  return e.l += 4, e.read_shift(4) != 0;
}
function Af(e, t, r) {
  var a = { Types: [], Cell: [], Value: [] }, n = r || {}, i = [], c = !1, s = 2;
  return k2(e, function(f, o, l) {
    switch (l) {
      case 335:
        a.Types.push({ name: f.name });
        break;
      case 51:
        f.forEach(function(d) {
          s == 1 ? a.Cell.push({ type: a.Types[d[0] - 1].name, index: d[1] }) : s == 0 && a.Value.push({ type: a.Types[d[0] - 1].name, index: d[1] });
        });
        break;
      case 337:
        s = f ? 1 : 0;
        break;
      case 338:
        s = 2;
        break;
      case 35:
        i.push(l), c = !0;
        break;
      case 36:
        i.pop(), c = !1;
        break;
      default:
        if (!o.T) {
          if (!c || n.WTF && i[i.length - 1] != 35)
            throw new Error("Unexpected record 0x" + l.toString(16));
        }
    }
  }), a;
}
function Ff(e, t, r) {
  var a = { Types: [], Cell: [], Value: [] };
  if (!e)
    return a;
  var n = !1, i = 2, c;
  return e.replace(k1, function(s) {
    var f = x0(s);
    switch (a2(f[0])) {
      case "<?xml":
        break;
      case "<metadata":
      case "</metadata>":
        break;
      case "<metadataTypes":
      case "</metadataTypes>":
        break;
      case "<metadataType":
        a.Types.push({ name: f.name });
        break;
      case "</metadataType>":
        break;
      case "<futureMetadata":
        for (var o = 0; o < a.Types.length; ++o)
          a.Types[o].name == f.name && (c = a.Types[o]);
        break;
      case "</futureMetadata>":
        break;
      case "<bk>":
        break;
      case "</bk>":
        break;
      case "<rc":
        i == 1 ? a.Cell.push({ type: a.Types[f.t - 1].name, index: +f.v }) : i == 0 && a.Value.push({ type: a.Types[f.t - 1].name, index: +f.v });
        break;
      case "</rc>":
        break;
      case "<cellMetadata":
        i = 1;
        break;
      case "</cellMetadata>":
        i = 2;
        break;
      case "<valueMetadata":
        i = 0;
        break;
      case "</valueMetadata>":
        i = 2;
        break;
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
      case "<extLst/>":
        break;
      case "<ext":
        n = !0;
        break;
      case "</ext>":
        n = !1;
        break;
      case "<rvb":
        if (!c)
          break;
        c.offsets || (c.offsets = []), c.offsets.push(+f.i);
        break;
      default:
        if (!n && r?.WTF)
          throw new Error("unrecognized " + f[0] + " in metadata");
    }
    return s;
  }), a;
}
function yf(e) {
  var t = [];
  if (!e)
    return t;
  var r = 1;
  return (e.match(k1) || []).forEach(function(a) {
    var n = x0(a);
    switch (n[0]) {
      case "<?xml":
        break;
      case "<calcChain":
      case "<calcChain>":
      case "</calcChain>":
        break;
      case "<c":
        delete n[0], n.i ? r = n.i : n.i = r, t.push(n);
        break;
    }
  }), t;
}
function If(e) {
  var t = {};
  t.i = e.read_shift(4);
  var r = {};
  r.r = e.read_shift(4), r.c = e.read_shift(4), t.r = H0(r);
  var a = e.read_shift(1);
  return a & 2 && (t.l = "1"), a & 8 && (t.a = "1"), t;
}
function bf(e, t, r) {
  var a = [];
  return k2(e, function(i, c, s) {
    switch (s) {
      case 63:
        a.push(i);
        break;
      default:
        if (!c.T)
          throw new Error("Unexpected record 0x" + s.toString(16));
    }
  }), a;
}
function Df(e, t, r, a) {
  if (!e)
    return e;
  var n = a || {}, i = !1;
  k2(e, function(s, f, o) {
    switch (o) {
      case 359:
      case 363:
      case 364:
      case 366:
      case 367:
      case 368:
      case 369:
      case 370:
      case 371:
      case 472:
      case 577:
      case 578:
      case 579:
      case 580:
      case 581:
      case 582:
      case 583:
      case 584:
      case 585:
      case 586:
      case 587:
        break;
      case 35:
        i = !0;
        break;
      case 36:
        i = !1;
        break;
      default:
        if (!f.T) {
          if (!i || n.WTF)
            throw new Error("Unexpected record 0x" + o.toString(16));
        }
    }
  }, n);
}
function Of(e, t) {
  if (!e)
    return "??";
  var r = (e.match(/<c:chart [^>]*r:id="([^"]*)"/) || ["", ""])[1];
  return t["!id"][r].Target;
}
var Rf = /<(?:\w+:)?shape(?:[^\w][^>]*)?>([\s\S]*?)<\/(?:\w+:)?shape>/g;
function Mf(e, t, r) {
  var a = 0;
  (e.match(Rf) || []).forEach(function(n) {
    var i = "", c = !0, s = -1, f = -1, o = -1;
    switch (n.replace(k1, function(d, u) {
      var h = x0(d);
      switch (a2(h[0])) {
        case "<ClientData":
          h.ObjectType && (i = h.ObjectType);
          break;
        case "<Visible":
        case "<Visible/>":
          c = !1;
          break;
        case "<Row":
        case "<Row>":
          s = u + d.length;
          break;
        case "</Row>":
          f = +n.slice(s, u).trim();
          break;
        case "<Column":
        case "<Column>":
          s = u + d.length;
          break;
        case "</Column>":
          o = +n.slice(s, u).trim();
          break;
      }
      return "";
    }), i) {
      case "Note":
        var l = Z3(t, f >= 0 && o >= 0 ? H0({ r: f, c: o }) : r[a].ref);
        l.c && (l.c.hidden = c), ++a;
        break;
    }
  });
}
function or(e, t, r, a) {
  var n = e["!data"] != null, i;
  t.forEach(function(c) {
    var s = y1(c.ref);
    if (!(s.r < 0 || s.c < 0)) {
      if (n ? (e["!data"][s.r] || (e["!data"][s.r] = []), i = e["!data"][s.r][s.c]) : i = e[c.ref], !i) {
        i = { t: "z" }, n ? e["!data"][s.r][s.c] = i : e[c.ref] = i;
        var f = o1(e["!ref"] || "BDWGO1000001:A1");
        f.s.r > s.r && (f.s.r = s.r), f.e.r < s.r && (f.e.r = s.r), f.s.c > s.c && (f.s.c = s.c), f.e.c < s.c && (f.e.c = s.c);
        var o = M0(f);
        e["!ref"] = o;
      }
      i.c || (i.c = []);
      var l = { a: c.author, t: c.t, r: c.r, T: r };
      c.h && (l.h = c.h);
      for (var d = i.c.length - 1; d >= 0; --d) {
        if (!r && i.c[d].T)
          return;
        r && !i.c[d].T && i.c.splice(d, 1);
      }
      if (r && a) {
        for (d = 0; d < a.length; ++d)
          if (l.a == a[d].id) {
            l.a = a[d].name || l.a;
            break;
          }
      }
      i.c.push(l);
    }
  });
}
function Nf(e, t) {
  if (e.match(/<(?:\w+:)?comments *\/>/))
    return [];
  var r = [], a = [], n = e.match(/<(?:\w+:)?authors>([\s\S]*)<\/(?:\w+:)?authors>/);
  n && n[1] && n[1].split(/<\/\w*:?author>/).forEach(function(c) {
    if (!(c === "" || c.trim() === "")) {
      var s = c.match(/<(?:\w+:)?author[^>]*>(.*)/);
      s && r.push(s[1]);
    }
  });
  var i = e.match(/<(?:\w+:)?commentList>([\s\S]*)<\/(?:\w+:)?commentList>/);
  return i && i[1] && i[1].split(/<\/\w*:?comment>/).forEach(function(c) {
    if (!(c === "" || c.trim() === "")) {
      var s = c.match(/<(?:\w+:)?comment[^>]*>/);
      if (s) {
        var f = x0(s[0]), o = { author: f.authorId && r[f.authorId] || "sheetjsghost", ref: f.ref, guid: f.guid }, l = y1(f.ref);
        if (!(t.sheetRows && t.sheetRows <= l.r)) {
          var d = c.match(/<(?:\w+:)?text>([\s\S]*)<\/(?:\w+:)?text>/), u = !!d && !!d[1] && K4(d[1]) || { r: "", t: "", h: "" };
          o.r = u.r, u.r == "<t></t>" && (u.t = u.h = ""), o.t = (u.t || "").replace(/\r\n/g, `
`).replace(/\r/g, `
`), t.cellHTML && (o.h = u.h), a.push(o);
        }
      }
    }
  }), a;
}
function Pf(e, t) {
  var r = [], a = !1, n = {}, i = 0;
  return e.replace(k1, function(s, f) {
    var o = x0(s);
    switch (a2(o[0])) {
      case "<?xml":
        break;
      case "<ThreadedComments":
        break;
      case "</ThreadedComments>":
        break;
      case "<threadedComment":
        n = { author: o.personId, guid: o.id, ref: o.ref, T: 1 };
        break;
      case "</threadedComment>":
        n.t != null && r.push(n);
        break;
      case "<text>":
      case "<text":
        i = f + s.length;
        break;
      case "</text>":
        n.t = e.slice(i, f).replace(/\r\n/g, `
`).replace(/\r/g, `
`);
        break;
      case "<mentions":
      case "<mentions>":
        a = !0;
        break;
      case "</mentions>":
        a = !1;
        break;
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
      case "<extLst/>":
        break;
      case "<ext":
        a = !0;
        break;
      case "</ext>":
        a = !1;
        break;
      default:
        if (!a && t.WTF)
          throw new Error("unrecognized " + o[0] + " in threaded comments");
    }
    return s;
  }), r;
}
function Lf(e, t) {
  var r = [], a = !1;
  return e.replace(k1, function(i) {
    var c = x0(i);
    switch (a2(c[0])) {
      case "<?xml":
        break;
      case "<personList":
        break;
      case "</personList>":
        break;
      case "<person":
        r.push({ name: c.displayname, id: c.id });
        break;
      case "</person>":
        break;
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
      case "<extLst/>":
        break;
      case "<ext":
        a = !0;
        break;
      case "</ext>":
        a = !1;
        break;
      default:
        if (!a && t.WTF)
          throw new Error("unrecognized " + c[0] + " in threaded comments");
    }
    return i;
  }), r;
}
function Bf(e) {
  var t = {};
  t.iauthor = e.read_shift(4);
  var r = r3(e);
  return t.rfx = r.s, t.ref = H0(r.s), e.l += 16, t;
}
var Uf = I1;
function Hf(e, t) {
  var r = [], a = [], n = {}, i = !1;
  return k2(e, function(s, f, o) {
    switch (o) {
      case 632:
        a.push(s);
        break;
      case 635:
        n = s;
        break;
      case 637:
        n.t = s.t, n.h = s.h, n.r = s.r;
        break;
      case 636:
        if (n.author = a[n.iauthor], delete n.iauthor, t.sheetRows && n.rfx && t.sheetRows <= n.rfx.r)
          break;
        n.t || (n.t = ""), delete n.rfx, r.push(n);
        break;
      case 3072:
        break;
      case 35:
        i = !0;
        break;
      case 36:
        i = !1;
        break;
      case 37:
        break;
      case 38:
        break;
      default:
        if (!f.T) {
          if (!i || t.WTF)
            throw new Error("Unexpected record 0x" + o.toString(16));
        }
    }
  }), r;
}
var Wf = "application/vnd.ms-office.vbaProject";
function Vf(e) {
  var t = L0.utils.cfb_new({ root: "R" });
  return e.FullPaths.forEach(function(r, a) {
    if (!(r.slice(-1) === "/" || !r.match(/_VBA_PROJECT_CUR/))) {
      var n = r.replace(/^[^\/]*/, "R").replace(/\/_VBA_PROJECT_CUR\u0000*/, "");
      L0.utils.cfb_add(t, n, e.FileIndex[a].content);
    }
  }), L0.write(t);
}
function Gf() {
  return { "!type": "dialog" };
}
function jf() {
  return { "!type": "dialog" };
}
function zf() {
  return { "!type": "macro" };
}
function $f() {
  return { "!type": "macro" };
}
var X2 = /* @__PURE__ */ function() {
  var e = /(^|[^A-Za-z_])R(\[?-?\d+\]|[1-9]\d*|)C(\[?-?\d+\]|[1-9]\d*|)(?![A-Za-z0-9_])/g, t = { r: 0, c: 0 };
  function r(a, n, i, c) {
    var s = !1, f = !1;
    i.length == 0 ? f = !0 : i.charAt(0) == "[" && (f = !0, i = i.slice(1, -1)), c.length == 0 ? s = !0 : c.charAt(0) == "[" && (s = !0, c = c.slice(1, -1));
    var o = i.length > 0 ? parseInt(i, 10) | 0 : 0, l = c.length > 0 ? parseInt(c, 10) | 0 : 0;
    return s ? l += t.c : --l, f ? o += t.r : --o, n + (s ? "" : "$") + W0(l) + (f ? "" : "$") + j0(o);
  }
  return function(n, i) {
    return t = i, n.replace(e, r);
  };
}(), J4 = /(^|[^._A-Z0-9])(\$?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])(\$?)(\d{1,7})(?![_.\(A-Za-z0-9])/g;
try {
  J4 = /(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})(?![_.\(A-Za-z0-9])/g;
} catch {
}
var Xf = /* @__PURE__ */ function() {
  return function(t, r) {
    return t.replace(J4, function(a, n, i, c, s, f) {
      var o = j4(c) - (i ? 0 : r.c), l = G4(f) - (s ? 0 : r.r), d = s == "$" ? l + 1 : l == 0 ? "" : "[" + l + "]", u = i == "$" ? o + 1 : o == 0 ? "" : "[" + o + "]";
      return n + "R" + d + "C" + u;
    });
  };
}();
function M7(e, t) {
  return e.replace(J4, function(r, a, n, i, c, s) {
    return a + (n == "$" ? n + i : W0(j4(i) + t.c)) + (c == "$" ? c + s : j0(G4(s) + t.r));
  });
}
function lr(e, t, r) {
  var a = Q2(t), n = a.s, i = y1(r), c = { r: i.r - n.r, c: i.c - n.c };
  return M7(e, c);
}
function Kf(e) {
  return e.length != 1;
}
function hr(e) {
  return e.replace(/_xlfn\./g, "");
}
function l1(e) {
  e.l += 1;
}
function N2(e, t) {
  var r = e.read_shift(2);
  return [r & 16383, r >> 14 & 1, r >> 15 & 1];
}
function N7(e, t, r) {
  var a = 2;
  if (r) {
    if (r.biff >= 2 && r.biff <= 5)
      return P7(e);
    r.biff == 12 && (a = 4);
  }
  var n = e.read_shift(a), i = e.read_shift(a), c = N2(e), s = N2(e);
  return { s: { r: n, c: c[0], cRel: c[1], rRel: c[2] }, e: { r: i, c: s[0], cRel: s[1], rRel: s[2] } };
}
function P7(e) {
  var t = N2(e), r = N2(e), a = e.read_shift(1), n = e.read_shift(1);
  return { s: { r: t[0], c: a, cRel: t[1], rRel: t[2] }, e: { r: r[0], c: n, cRel: r[1], rRel: r[2] } };
}
function Yf(e, t, r) {
  if (r.biff < 8)
    return P7(e);
  var a = e.read_shift(r.biff == 12 ? 4 : 2), n = e.read_shift(r.biff == 12 ? 4 : 2), i = N2(e), c = N2(e);
  return { s: { r: a, c: i[0], cRel: i[1], rRel: i[2] }, e: { r: n, c: c[0], cRel: c[1], rRel: c[2] } };
}
function L7(e, t, r) {
  if (r && r.biff >= 2 && r.biff <= 5)
    return Jf(e);
  var a = e.read_shift(r && r.biff == 12 ? 4 : 2), n = N2(e);
  return { r: a, c: n[0], cRel: n[1], rRel: n[2] };
}
function Jf(e) {
  var t = N2(e), r = e.read_shift(1);
  return { r: t[0], c: r, cRel: t[1], rRel: t[2] };
}
function qf(e) {
  var t = e.read_shift(2), r = e.read_shift(2);
  return { r: t, c: r & 255, fQuoted: !!(r & 16384), cRel: r >> 15, rRel: r >> 15 };
}
function Zf(e, t, r) {
  var a = r && r.biff ? r.biff : 8;
  if (a >= 2 && a <= 5)
    return Qf(e);
  var n = e.read_shift(a >= 12 ? 4 : 2), i = e.read_shift(2), c = (i & 16384) >> 14, s = (i & 32768) >> 15;
  if (i &= 16383, s == 1)
    for (; n > 524287; )
      n -= 1048576;
  if (c == 1)
    for (; i > 8191; )
      i = i - 16384;
  return { r: n, c: i, cRel: c, rRel: s };
}
function Qf(e) {
  var t = e.read_shift(2), r = e.read_shift(1), a = (t & 32768) >> 15, n = (t & 16384) >> 14;
  return t &= 16383, a == 1 && t >= 8192 && (t = t - 16384), n == 1 && r >= 128 && (r = r - 256), { r: t, c: r, cRel: n, rRel: a };
}
function eo(e, t, r) {
  var a = (e[e.l++] & 96) >> 5, n = N7(e, r.biff >= 2 && r.biff <= 5 ? 6 : 8, r);
  return [a, n];
}
function ro(e, t, r) {
  var a = (e[e.l++] & 96) >> 5, n = e.read_shift(2, "i"), i = 8;
  if (r)
    switch (r.biff) {
      case 5:
        e.l += 12, i = 6;
        break;
      case 12:
        i = 12;
        break;
    }
  var c = N7(e, i, r);
  return [a, n, c];
}
function to(e, t, r) {
  var a = (e[e.l++] & 96) >> 5;
  return e.l += r && r.biff > 8 ? 12 : r.biff < 8 ? 6 : 8, [a];
}
function ao(e, t, r) {
  var a = (e[e.l++] & 96) >> 5, n = e.read_shift(2), i = 8;
  if (r)
    switch (r.biff) {
      case 5:
        e.l += 12, i = 6;
        break;
      case 12:
        i = 12;
        break;
    }
  return e.l += i, [a, n];
}
function no(e, t, r) {
  var a = (e[e.l++] & 96) >> 5, n = Yf(e, t - 1, r);
  return [a, n];
}
function io(e, t, r) {
  var a = (e[e.l++] & 96) >> 5;
  return e.l += r.biff == 2 ? 6 : r.biff == 12 ? 14 : 7, [a];
}
function ur(e) {
  var t = e[e.l + 1] & 1, r = 1;
  return e.l += 4, [t, r];
}
function so(e, t, r) {
  e.l += 2;
  for (var a = e.read_shift(r && r.biff == 2 ? 1 : 2), n = [], i = 0; i <= a; ++i)
    n.push(e.read_shift(r && r.biff == 2 ? 1 : 2));
  return n;
}
function co(e, t, r) {
  var a = e[e.l + 1] & 255 ? 1 : 0;
  return e.l += 2, [a, e.read_shift(r && r.biff == 2 ? 1 : 2)];
}
function fo(e, t, r) {
  var a = e[e.l + 1] & 255 ? 1 : 0;
  return e.l += 2, [a, e.read_shift(r && r.biff == 2 ? 1 : 2)];
}
function oo(e) {
  var t = e[e.l + 1] & 255 ? 1 : 0;
  return e.l += 2, [t, e.read_shift(2)];
}
function lo(e, t, r) {
  var a = e[e.l + 1] & 255 ? 1 : 0;
  return e.l += r && r.biff == 2 ? 3 : 4, [a];
}
function B7(e) {
  var t = e.read_shift(1), r = e.read_shift(1);
  return [t, r];
}
function ho(e) {
  return e.read_shift(2), B7(e);
}
function uo(e) {
  return e.read_shift(2), B7(e);
}
function xo(e, t, r) {
  var a = (e[e.l] & 96) >> 5;
  e.l += 1;
  var n = L7(e, 0, r);
  return [a, n];
}
function po(e, t, r) {
  var a = (e[e.l] & 96) >> 5;
  e.l += 1;
  var n = Zf(e, 0, r);
  return [a, n];
}
function mo(e, t, r) {
  var a = (e[e.l] & 96) >> 5;
  e.l += 1;
  var n = e.read_shift(2);
  r && r.biff == 5 && (e.l += 12);
  var i = L7(e, 0, r);
  return [a, n, i];
}
function vo(e, t, r) {
  var a = (e[e.l] & 96) >> 5;
  e.l += 1;
  var n = e.read_shift(r && r.biff <= 3 ? 1 : 2);
  return [gl[n], W7[n], a];
}
function go(e, t, r) {
  var a = e[e.l++], n = e.read_shift(1), i = r && r.biff <= 3 ? [a == 88 ? -1 : 0, e.read_shift(1)] : _o(e);
  return [n, (i[0] === 0 ? W7 : vl)[i[1]]];
}
function _o(e) {
  return [e[e.l + 1] >> 7, e.read_shift(2) & 32767];
}
function To(e, t, r) {
  e.l += r && r.biff == 2 ? 3 : 4;
}
function Eo(e, t, r) {
  if (e.l++, r && r.biff == 12)
    return [e.read_shift(4, "i"), 0];
  var a = e.read_shift(2), n = e.read_shift(r && r.biff == 2 ? 1 : 2);
  return [a, n];
}
function wo(e) {
  return e.l++, t3[e.read_shift(1)];
}
function ko(e) {
  return e.l++, e.read_shift(2);
}
function Co(e) {
  return e.l++, e.read_shift(1) !== 0;
}
function So(e) {
  return e.l++, F1(e);
}
function Ao(e, t, r) {
  return e.l++, p3(e, t - 1, r);
}
function Fo(e, t) {
  var r = [e.read_shift(1)];
  if (t == 12)
    switch (r[0]) {
      case 2:
        r[0] = 4;
        break;
      case 4:
        r[0] = 16;
        break;
      case 0:
        r[0] = 1;
        break;
      case 1:
        r[0] = 2;
        break;
    }
  switch (r[0]) {
    case 4:
      r[1] = f1(e, 1) ? "TRUE" : "FALSE", t != 12 && (e.l += 7);
      break;
    case 37:
    case 16:
      r[1] = t3[e[e.l]], e.l += t == 12 ? 4 : 8;
      break;
    case 0:
      e.l += 8;
      break;
    case 1:
      r[1] = F1(e);
      break;
    case 2:
      r[1] = a3(e, 0, { biff: t > 0 && t < 8 ? 2 : t });
      break;
    default:
      throw new Error("Bad SerAr: " + r[0]);
  }
  return r;
}
function yo(e, t, r) {
  for (var a = e.read_shift(r.biff == 12 ? 4 : 2), n = [], i = 0; i != a; ++i)
    n.push((r.biff == 12 ? r3 : Je)(e));
  return n;
}
function Io(e, t, r) {
  var a = 0, n = 0;
  r.biff == 12 ? (a = e.read_shift(4), n = e.read_shift(4)) : (n = 1 + e.read_shift(1), a = 1 + e.read_shift(2)), r.biff >= 2 && r.biff < 8 && (--a, --n == 0 && (n = 256));
  for (var i = 0, c = []; i != a && (c[i] = []); ++i)
    for (var s = 0; s != n; ++s)
      c[i][s] = Fo(e, r.biff);
  return c;
}
function bo(e, t, r) {
  var a = e.read_shift(1) >>> 5 & 3, n = !r || r.biff >= 8 ? 4 : 2, i = e.read_shift(n);
  switch (r.biff) {
    case 2:
      e.l += 5;
      break;
    case 3:
    case 4:
      e.l += 8;
      break;
    case 5:
      e.l += 12;
      break;
  }
  return [a, 0, i];
}
function Do(e, t, r) {
  if (r.biff == 5)
    return Oo(e);
  var a = e.read_shift(1) >>> 5 & 3, n = e.read_shift(2), i = e.read_shift(4);
  return [a, n, i];
}
function Oo(e) {
  var t = e.read_shift(1) >>> 5 & 3, r = e.read_shift(2, "i");
  e.l += 8;
  var a = e.read_shift(2);
  return e.l += 12, [t, r, a];
}
function Ro(e, t, r) {
  var a = e.read_shift(1) >>> 5 & 3;
  e.l += r && r.biff == 2 ? 3 : 4;
  var n = e.read_shift(r && r.biff == 2 ? 1 : 2);
  return [a, n];
}
function Mo(e, t, r) {
  var a = e.read_shift(1) >>> 5 & 3, n = e.read_shift(r && r.biff == 2 ? 1 : 2);
  return [a, n];
}
function No(e, t, r) {
  var a = e.read_shift(1) >>> 5 & 3;
  return e.l += 4, r.biff < 8 && e.l--, r.biff == 12 && (e.l += 2), [a];
}
function Po(e, t, r) {
  var a = (e[e.l++] & 96) >> 5, n = e.read_shift(2), i = 4;
  if (r)
    switch (r.biff) {
      case 5:
        i = 15;
        break;
      case 12:
        i = 6;
        break;
    }
  return e.l += i, [a, n];
}
var Lo = b1, Bo = b1, Uo = b1;
function ae(e, t, r) {
  return e.l += 2, [qf(e)];
}
function q4(e) {
  return e.l += 6, [];
}
var Ho = ae, Wo = q4, Vo = q4, Go = ae;
function U7(e) {
  return e.l += 2, [i1(e), e.read_shift(2) & 1];
}
var jo = ae, zo = U7, $o = q4, Xo = ae, Ko = ae, Yo = [
  "Data",
  "All",
  "Headers",
  "??",
  "?Data2",
  "??",
  "?DataHeaders",
  "??",
  "Totals",
  "??",
  "??",
  "??",
  "?DataTotals",
  "??",
  "??",
  "??",
  "?Current"
];
function Jo(e) {
  e.l += 2;
  var t = e.read_shift(2), r = e.read_shift(2), a = e.read_shift(4), n = e.read_shift(2), i = e.read_shift(2), c = Yo[r >> 2 & 31];
  return { ixti: t, coltype: r & 3, rt: c, idx: a, c: n, C: i };
}
function qo(e) {
  return e.l += 2, [e.read_shift(4)];
}
function Zo(e, t, r) {
  return e.l += 5, e.l += 2, e.l += r.biff == 2 ? 1 : 4, ["PTGSHEET"];
}
function Qo(e, t, r) {
  return e.l += r.biff == 2 ? 4 : 5, ["PTGENDSHEET"];
}
function el(e) {
  var t = e.read_shift(1) >>> 5 & 3, r = e.read_shift(2);
  return [t, r];
}
function rl(e) {
  var t = e.read_shift(1) >>> 5 & 3, r = e.read_shift(2);
  return [t, r];
}
function tl(e) {
  return e.l += 4, [0, 0];
}
var xr = {
  /*::[*/
  1: { n: "PtgExp", f: Eo },
  /*::[*/
  2: { n: "PtgTbl", f: Uo },
  /*::[*/
  3: { n: "PtgAdd", f: l1 },
  /*::[*/
  4: { n: "PtgSub", f: l1 },
  /*::[*/
  5: { n: "PtgMul", f: l1 },
  /*::[*/
  6: { n: "PtgDiv", f: l1 },
  /*::[*/
  7: { n: "PtgPower", f: l1 },
  /*::[*/
  8: { n: "PtgConcat", f: l1 },
  /*::[*/
  9: { n: "PtgLt", f: l1 },
  /*::[*/
  10: { n: "PtgLe", f: l1 },
  /*::[*/
  11: { n: "PtgEq", f: l1 },
  /*::[*/
  12: { n: "PtgGe", f: l1 },
  /*::[*/
  13: { n: "PtgGt", f: l1 },
  /*::[*/
  14: { n: "PtgNe", f: l1 },
  /*::[*/
  15: { n: "PtgIsect", f: l1 },
  /*::[*/
  16: { n: "PtgUnion", f: l1 },
  /*::[*/
  17: { n: "PtgRange", f: l1 },
  /*::[*/
  18: { n: "PtgUplus", f: l1 },
  /*::[*/
  19: { n: "PtgUminus", f: l1 },
  /*::[*/
  20: { n: "PtgPercent", f: l1 },
  /*::[*/
  21: { n: "PtgParen", f: l1 },
  /*::[*/
  22: { n: "PtgMissArg", f: l1 },
  /*::[*/
  23: { n: "PtgStr", f: Ao },
  /*::[*/
  26: { n: "PtgSheet", f: Zo },
  /*::[*/
  27: { n: "PtgEndSheet", f: Qo },
  /*::[*/
  28: { n: "PtgErr", f: wo },
  /*::[*/
  29: { n: "PtgBool", f: Co },
  /*::[*/
  30: { n: "PtgInt", f: ko },
  /*::[*/
  31: { n: "PtgNum", f: So },
  /*::[*/
  32: { n: "PtgArray", f: io },
  /*::[*/
  33: { n: "PtgFunc", f: vo },
  /*::[*/
  34: { n: "PtgFuncVar", f: go },
  /*::[*/
  35: { n: "PtgName", f: bo },
  /*::[*/
  36: { n: "PtgRef", f: xo },
  /*::[*/
  37: { n: "PtgArea", f: eo },
  /*::[*/
  38: { n: "PtgMemArea", f: Ro },
  /*::[*/
  39: { n: "PtgMemErr", f: Lo },
  /*::[*/
  40: { n: "PtgMemNoMem", f: Bo },
  /*::[*/
  41: { n: "PtgMemFunc", f: Mo },
  /*::[*/
  42: { n: "PtgRefErr", f: No },
  /*::[*/
  43: { n: "PtgAreaErr", f: to },
  /*::[*/
  44: { n: "PtgRefN", f: po },
  /*::[*/
  45: { n: "PtgAreaN", f: no },
  /*::[*/
  46: { n: "PtgMemAreaN", f: el },
  /*::[*/
  47: { n: "PtgMemNoMemN", f: rl },
  /*::[*/
  57: { n: "PtgNameX", f: Do },
  /*::[*/
  58: { n: "PtgRef3d", f: mo },
  /*::[*/
  59: { n: "PtgArea3d", f: ro },
  /*::[*/
  60: { n: "PtgRefErr3d", f: Po },
  /*::[*/
  61: { n: "PtgAreaErr3d", f: ao },
  /*::[*/
  255: {}
}, al = {
  /*::[*/
  64: 32,
  /*::[*/
  96: 32,
  /*::[*/
  65: 33,
  /*::[*/
  97: 33,
  /*::[*/
  66: 34,
  /*::[*/
  98: 34,
  /*::[*/
  67: 35,
  /*::[*/
  99: 35,
  /*::[*/
  68: 36,
  /*::[*/
  100: 36,
  /*::[*/
  69: 37,
  /*::[*/
  101: 37,
  /*::[*/
  70: 38,
  /*::[*/
  102: 38,
  /*::[*/
  71: 39,
  /*::[*/
  103: 39,
  /*::[*/
  72: 40,
  /*::[*/
  104: 40,
  /*::[*/
  73: 41,
  /*::[*/
  105: 41,
  /*::[*/
  74: 42,
  /*::[*/
  106: 42,
  /*::[*/
  75: 43,
  /*::[*/
  107: 43,
  /*::[*/
  76: 44,
  /*::[*/
  108: 44,
  /*::[*/
  77: 45,
  /*::[*/
  109: 45,
  /*::[*/
  78: 46,
  /*::[*/
  110: 46,
  /*::[*/
  79: 47,
  /*::[*/
  111: 47,
  /*::[*/
  88: 34,
  /*::[*/
  120: 34,
  /*::[*/
  89: 57,
  /*::[*/
  121: 57,
  /*::[*/
  90: 58,
  /*::[*/
  122: 58,
  /*::[*/
  91: 59,
  /*::[*/
  123: 59,
  /*::[*/
  92: 60,
  /*::[*/
  124: 60,
  /*::[*/
  93: 61,
  /*::[*/
  125: 61
}, nl = {
  /*::[*/
  1: { n: "PtgElfLel", f: U7 },
  /*::[*/
  2: { n: "PtgElfRw", f: Xo },
  /*::[*/
  3: { n: "PtgElfCol", f: Ho },
  /*::[*/
  6: { n: "PtgElfRwV", f: Ko },
  /*::[*/
  7: { n: "PtgElfColV", f: Go },
  /*::[*/
  10: { n: "PtgElfRadical", f: jo },
  /*::[*/
  11: { n: "PtgElfRadicalS", f: $o },
  /*::[*/
  13: { n: "PtgElfColS", f: Wo },
  /*::[*/
  15: { n: "PtgElfColSV", f: Vo },
  /*::[*/
  16: { n: "PtgElfRadicalLel", f: zo },
  /*::[*/
  25: { n: "PtgList", f: Jo },
  /*::[*/
  29: { n: "PtgSxName", f: qo },
  /*::[*/
  255: {}
}, il = {
  /*::[*/
  0: { n: "PtgAttrNoop", f: tl },
  /*::[*/
  1: { n: "PtgAttrSemi", f: lo },
  /*::[*/
  2: { n: "PtgAttrIf", f: fo },
  /*::[*/
  4: { n: "PtgAttrChoose", f: so },
  /*::[*/
  8: { n: "PtgAttrGoto", f: co },
  /*::[*/
  16: { n: "PtgAttrSum", f: To },
  /*::[*/
  32: { n: "PtgAttrBaxcel", f: ur },
  /*::[*/
  33: { n: "PtgAttrBaxcel", f: ur },
  /*::[*/
  64: { n: "PtgAttrSpace", f: ho },
  /*::[*/
  65: { n: "PtgAttrSpaceSemi", f: uo },
  /*::[*/
  128: { n: "PtgAttrIfError", f: oo },
  /*::[*/
  255: {}
};
function ne(e, t, r, a) {
  if (a.biff < 8)
    return b1(e, t);
  for (var n = e.l + t, i = [], c = 0; c !== r.length; ++c)
    switch (r[c][0]) {
      case "PtgArray":
        r[c][1] = Io(e, 0, a), i.push(r[c][1]);
        break;
      case "PtgMemArea":
        r[c][2] = yo(e, r[c][1], a), i.push(r[c][2]);
        break;
      case "PtgExp":
        a && a.biff == 12 && (r[c][1][1] = e.read_shift(4), i.push(r[c][1]));
        break;
      case "PtgList":
      case "PtgElfRadicalS":
      case "PtgElfColS":
      case "PtgElfColSV":
        throw "Unsupported " + r[c][0];
    }
  return t = n - e.l, t !== 0 && i.push(b1(e, t)), i;
}
function ie(e, t, r) {
  for (var a = e.l + t, n, i, c = []; a != e.l; )
    t = a - e.l, i = e[e.l], n = xr[i] || xr[al[i]], (i === 24 || i === 25) && (n = (i === 24 ? nl : il)[e[e.l + 1]]), !n || !n.f ? b1(e, t) : c.push([n.n, n.f(e, t, r)]);
  return c;
}
function sl(e) {
  for (var t = [], r = 0; r < e.length; ++r) {
    for (var a = e[r], n = [], i = 0; i < a.length; ++i) {
      var c = a[i];
      if (c)
        switch (c[0]) {
          case 2:
            n.push('"' + c[1].replace(/"/g, '""') + '"');
            break;
          default:
            n.push(c[1]);
        }
      else
        n.push("");
    }
    t.push(n.join(","));
  }
  return t.join(";");
}
var cl = {
  PtgAdd: "+",
  PtgConcat: "&",
  PtgDiv: "/",
  PtgEq: "=",
  PtgGe: ">=",
  PtgGt: ">",
  PtgLe: "<=",
  PtgLt: "<",
  PtgMul: "*",
  PtgNe: "<>",
  PtgPower: "^",
  PtgSub: "-"
};
function fl(e, t) {
  var r = e.lastIndexOf("!"), a = t.lastIndexOf("!");
  return r == -1 && a == -1 ? e + ":" + t : r > 0 && a > 0 && e.slice(0, r).toLowerCase() == t.slice(0, a).toLowerCase() ? e + ":" + t.slice(a + 1) : (console.error("Cannot hydrate range", e, t), e + ":" + t);
}
function H7(e, t, r) {
  if (!e)
    return "SH33TJSERR0";
  if (r.biff > 8 && (!e.XTI || !e.XTI[t]))
    return e.SheetNames[t];
  if (!e.XTI)
    return "SH33TJSERR6";
  var a = e.XTI[t];
  if (r.biff < 8)
    return t > 1e4 && (t -= 65536), t < 0 && (t = -t), t == 0 ? "" : e.XTI[t - 1];
  if (!a)
    return "SH33TJSERR1";
  var n = "";
  if (r.biff > 8)
    switch (e[a[0]][0]) {
      case 357:
        return n = a[1] == -1 ? "#REF" : e.SheetNames[a[1]], a[1] == a[2] ? n : n + ":" + e.SheetNames[a[2]];
      case 358:
        return r.SID != null ? e.SheetNames[r.SID] : "SH33TJSSAME" + e[a[0]][0];
      case 355:
      default:
        return "SH33TJSSRC" + e[a[0]][0];
    }
  switch (e[a[0]][0][0]) {
    case 1025:
      return n = a[1] == -1 ? "#REF" : e.SheetNames[a[1]] || "SH33TJSERR3", a[1] == a[2] ? n : n + ":" + e.SheetNames[a[2]];
    case 14849:
      return e[a[0]].slice(1).map(function(i) {
        return i.Name;
      }).join(";;");
    default:
      return e[a[0]][0][3] ? (n = a[1] == -1 ? "#REF" : e[a[0]][0][3][a[1]] || "SH33TJSERR4", a[1] == a[2] ? n : n + ":" + e[a[0]][0][3][a[2]]) : "SH33TJSERR2";
  }
}
function dr(e, t, r) {
  var a = H7(e, t, r);
  return a == "#REF" ? a : qn(a, r);
}
function A1(e, t, r, a, n) {
  var i = n && n.biff || 8, c = (
    /*range != null ? range :*/
    { s: { c: 0, r: 0 } }
  ), s = [], f, o, l, d = 0, u = 0, h, p = "";
  if (!e[0] || !e[0][0])
    return "";
  for (var v = -1, x = "", m = 0, T = e[0].length; m < T; ++m) {
    var g = e[0][m];
    switch (g[0]) {
      case "PtgUminus":
        s.push("-" + s.pop());
        break;
      case "PtgUplus":
        s.push("+" + s.pop());
        break;
      case "PtgPercent":
        s.push(s.pop() + "%");
        break;
      case "PtgAdd":
      case "PtgConcat":
      case "PtgDiv":
      case "PtgEq":
      case "PtgGe":
      case "PtgGt":
      case "PtgLe":
      case "PtgLt":
      case "PtgMul":
      case "PtgNe":
      case "PtgPower":
      case "PtgSub":
        if (f = s.pop(), o = s.pop(), v >= 0) {
          switch (e[0][v][1][0]) {
            case 0:
              x = P0(" ", e[0][v][1][1]);
              break;
            case 1:
              x = P0("\r", e[0][v][1][1]);
              break;
            default:
              if (x = "", n.WTF)
                throw new Error("Unexpected PtgAttrSpaceType " + e[0][v][1][0]);
          }
          o = o + x, v = -1;
        }
        s.push(o + cl[g[0]] + f);
        break;
      case "PtgIsect":
        f = s.pop(), o = s.pop(), s.push(o + " " + f);
        break;
      case "PtgUnion":
        f = s.pop(), o = s.pop(), s.push(o + "," + f);
        break;
      case "PtgRange":
        f = s.pop(), o = s.pop(), s.push(fl(o, f));
        break;
      case "PtgAttrChoose":
        break;
      case "PtgAttrGoto":
        break;
      case "PtgAttrIf":
        break;
      case "PtgAttrIfError":
        break;
      case "PtgRef":
        l = M3(g[1][1], c, n), s.push(N3(l, i));
        break;
      case "PtgRefN":
        l = r ? M3(g[1][1], r, n) : g[1][1], s.push(N3(l, i));
        break;
      case "PtgRef3d":
        d = /*::Number(*/
        g[1][1], l = M3(g[1][2], c, n), p = dr(a, d, n), s.push(p + "!" + N3(l, i));
        break;
      case "PtgFunc":
      case "PtgFuncVar":
        var O = g[1][0], H = g[1][1];
        O || (O = 0), O &= 127;
        var W = O == 0 ? [] : s.slice(-O);
        s.length -= O, H === "User" && (H = W.shift()), s.push(H + "(" + W.join(",") + ")");
        break;
      case "PtgBool":
        s.push(g[1] ? "TRUE" : "FALSE");
        break;
      case "PtgInt":
        s.push(
          /*::String(*/
          g[1]
          /*::)*/
        );
        break;
      case "PtgNum":
        s.push(String(g[1]));
        break;
      case "PtgStr":
        s.push('"' + g[1].replace(/"/g, '""') + '"');
        break;
      case "PtgErr":
        s.push(
          /*::String(*/
          g[1]
          /*::)*/
        );
        break;
      case "PtgAreaN":
        h = X5(g[1][1], r ? { s: r } : c, n), s.push(f4(h, n));
        break;
      case "PtgArea":
        h = X5(g[1][1], c, n), s.push(f4(h, n));
        break;
      case "PtgArea3d":
        d = /*::Number(*/
        g[1][1], h = g[1][2], p = dr(a, d, n), s.push(p + "!" + f4(h, n));
        break;
      case "PtgAttrSum":
        s.push("SUM(" + s.pop() + ")");
        break;
      case "PtgAttrBaxcel":
      case "PtgAttrSemi":
        break;
      case "PtgName":
        u = g[1][2];
        var E = (a.names || [])[u - 1] || (a[0] || [])[u], b = E ? E.Name : "SH33TJSNAME" + String(u);
        b && b.slice(0, 6) == "_xlfn." && !n.xlfn && (b = b.slice(6)), s.push(b);
        break;
      case "PtgNameX":
        var I = g[1][1];
        u = g[1][2];
        var P;
        if (n.biff <= 5)
          I < 0 && (I = -I), a[I] && (P = a[I][u]);
        else {
          var L = "";
          if (((a[I] || [])[0] || [])[0] == 14849 || (((a[I] || [])[0] || [])[0] == 1025 ? a[I][u] && a[I][u].itab > 0 && (L = a.SheetNames[a[I][u].itab - 1] + "!") : L = a.SheetNames[u - 1] + "!"), a[I] && a[I][u])
            L += a[I][u].Name;
          else if (a[0] && a[0][u])
            L += a[0][u].Name;
          else {
            var z = (H7(a, I, n) || "").split(";;");
            z[u - 1] ? L = z[u - 1] : L += "SH33TJSERRX";
          }
          s.push(L);
          break;
        }
        P || (P = { Name: "SH33TJSERRY" }), s.push(P.Name);
        break;
      case "PtgParen":
        var Y = "(", f0 = ")";
        if (v >= 0) {
          switch (x = "", e[0][v][1][0]) {
            case 2:
              Y = P0(" ", e[0][v][1][1]) + Y;
              break;
            case 3:
              Y = P0("\r", e[0][v][1][1]) + Y;
              break;
            case 4:
              f0 = P0(" ", e[0][v][1][1]) + f0;
              break;
            case 5:
              f0 = P0("\r", e[0][v][1][1]) + f0;
              break;
            default:
              if (n.WTF)
                throw new Error("Unexpected PtgAttrSpaceType " + e[0][v][1][0]);
          }
          v = -1;
        }
        s.push(Y + s.pop() + f0);
        break;
      case "PtgRefErr":
        s.push("#REF!");
        break;
      case "PtgRefErr3d":
        s.push("#REF!");
        break;
      case "PtgExp":
        l = { c: g[1][1], r: g[1][0] };
        var i0 = { c: r.c, r: r.r };
        if (a.sharedf[H0(l)]) {
          var p0 = a.sharedf[H0(l)];
          s.push(A1(p0, c, i0, a, n));
        } else {
          var n0 = !1;
          for (f = 0; f != a.arrayf.length; ++f)
            if (o = a.arrayf[f], !(l.c < o[0].s.c || l.c > o[0].e.c) && !(l.r < o[0].s.r || l.r > o[0].e.r)) {
              s.push(A1(o[1], c, i0, a, n)), n0 = !0;
              break;
            }
          n0 || s.push(
            /*::String(*/
            g[1]
            /*::)*/
          );
        }
        break;
      case "PtgArray":
        s.push("{" + sl(
          /*::(*/
          g[1]
          /*:: :any)*/
        ) + "}");
        break;
      case "PtgMemArea":
        break;
      case "PtgAttrSpace":
      case "PtgAttrSpaceSemi":
        v = m;
        break;
      case "PtgTbl":
        break;
      case "PtgMemErr":
        break;
      case "PtgMissArg":
        s.push("");
        break;
      case "PtgAreaErr":
        s.push("#REF!");
        break;
      case "PtgAreaErr3d":
        s.push("#REF!");
        break;
      case "PtgList":
        s.push("Table" + g[1].idx + "[#" + g[1].rt + "]");
        break;
      case "PtgMemAreaN":
      case "PtgMemNoMemN":
      case "PtgAttrNoop":
      case "PtgSheet":
      case "PtgEndSheet":
        break;
      case "PtgMemFunc":
        break;
      case "PtgMemNoMem":
        break;
      case "PtgElfCol":
      case "PtgElfColS":
      case "PtgElfColSV":
      case "PtgElfColV":
      case "PtgElfLel":
      case "PtgElfRadical":
      case "PtgElfRadicalLel":
      case "PtgElfRadicalS":
      case "PtgElfRw":
      case "PtgElfRwV":
        throw new Error("Unsupported ELFs");
      case "PtgSxName":
        throw new Error("Unrecognized Formula Token: " + String(g));
      default:
        throw new Error("Unrecognized Formula Token: " + String(g));
    }
    var v0 = ["PtgAttrSpace", "PtgAttrSpaceSemi", "PtgAttrGoto"];
    if (n.biff != 3 && v >= 0 && v0.indexOf(e[0][m][0]) == -1) {
      g = e[0][v];
      var I0 = !0;
      switch (g[1][0]) {
        case 4:
          I0 = !1;
        case 0:
          x = P0(" ", g[1][1]);
          break;
        case 5:
          I0 = !1;
        case 1:
          x = P0("\r", g[1][1]);
          break;
        default:
          if (x = "", n.WTF)
            throw new Error("Unexpected PtgAttrSpaceType " + g[1][0]);
      }
      s.push((I0 ? x : "") + s.pop() + (I0 ? "" : x)), v = -1;
    }
  }
  if (s.length > 1 && n.WTF)
    throw new Error("bad formula stack");
  return s[0] == "TRUE" ? !0 : s[0] == "FALSE" ? !1 : s[0];
}
function ol(e, t, r) {
  var a = e.l + t, n = r.biff == 2 ? 1 : 2, i, c = e.read_shift(n);
  if (c == 65535)
    return [[], b1(e, t - 2)];
  var s = ie(e, c, r);
  return t !== c + n && (i = ne(e, t - c - n, s, r)), e.l = a, [s, i];
}
function ll(e, t, r) {
  var a = e.l + t, n = r.biff == 2 ? 1 : 2, i, c = e.read_shift(n);
  if (c == 65535)
    return [[], b1(e, t - 2)];
  var s = ie(e, c, r);
  return t !== c + n && (i = ne(e, t - c - n, s, r)), e.l = a, [s, i];
}
function hl(e, t, r, a) {
  var n = e.l + t, i = ie(e, a, r), c;
  return n !== e.l && (c = ne(e, n - e.l, i, r)), [i, c];
}
function ul(e, t, r) {
  var a = e.l + t, n, i = e.read_shift(2), c = ie(e, i, r);
  return i == 65535 ? [[], b1(e, t - 2)] : (t !== i + 2 && (n = ne(e, a - i - 2, c, r)), [c, n]);
}
function xl(e) {
  var t;
  if (_2(e, e.l + 6) !== 65535)
    return [F1(e), "n"];
  switch (e[e.l]) {
    case 0:
      return e.l += 8, ["String", "s"];
    case 1:
      return t = e[e.l + 2] === 1, e.l += 8, [t, "b"];
    case 2:
      return t = e[e.l + 2], e.l += 8, [t, "e"];
    case 3:
      return e.l += 8, ["", "s"];
  }
  return [];
}
function h4(e, t, r) {
  var a = e.l + t, n = x2(e, 6, r), i = xl(e), c = e.read_shift(1);
  r.biff != 2 && (e.read_shift(1), r.biff >= 5 && e.read_shift(4));
  var s = ll(e, a - e.l, r);
  return { cell: n, val: i[0], formula: s, shared: c >> 3 & 1, tt: i[1] };
}
function qe(e, t, r) {
  var a = e.read_shift(4), n = ie(e, a, r), i = e.read_shift(4), c = i > 0 ? ne(e, i, n, r) : null;
  return [n, c];
}
var dl = qe, Ze = qe, pl = qe, ml = qe, vl = {
  0: "BEEP",
  1: "OPEN",
  2: "OPEN.LINKS",
  3: "CLOSE.ALL",
  4: "SAVE",
  5: "SAVE.AS",
  6: "FILE.DELETE",
  7: "PAGE.SETUP",
  8: "PRINT",
  9: "PRINTER.SETUP",
  10: "QUIT",
  11: "NEW.WINDOW",
  12: "ARRANGE.ALL",
  13: "WINDOW.SIZE",
  14: "WINDOW.MOVE",
  15: "FULL",
  16: "CLOSE",
  17: "RUN",
  22: "SET.PRINT.AREA",
  23: "SET.PRINT.TITLES",
  24: "SET.PAGE.BREAK",
  25: "REMOVE.PAGE.BREAK",
  26: "FONT",
  27: "DISPLAY",
  28: "PROTECT.DOCUMENT",
  29: "PRECISION",
  30: "A1.R1C1",
  31: "CALCULATE.NOW",
  32: "CALCULATION",
  34: "DATA.FIND",
  35: "EXTRACT",
  36: "DATA.DELETE",
  37: "SET.DATABASE",
  38: "SET.CRITERIA",
  39: "SORT",
  40: "DATA.SERIES",
  41: "TABLE",
  42: "FORMAT.NUMBER",
  43: "ALIGNMENT",
  44: "STYLE",
  45: "BORDER",
  46: "CELL.PROTECTION",
  47: "COLUMN.WIDTH",
  48: "UNDO",
  49: "CUT",
  50: "COPY",
  51: "PASTE",
  52: "CLEAR",
  53: "PASTE.SPECIAL",
  54: "EDIT.DELETE",
  55: "INSERT",
  56: "FILL.RIGHT",
  57: "FILL.DOWN",
  61: "DEFINE.NAME",
  62: "CREATE.NAMES",
  63: "FORMULA.GOTO",
  64: "FORMULA.FIND",
  65: "SELECT.LAST.CELL",
  66: "SHOW.ACTIVE.CELL",
  67: "GALLERY.AREA",
  68: "GALLERY.BAR",
  69: "GALLERY.COLUMN",
  70: "GALLERY.LINE",
  71: "GALLERY.PIE",
  72: "GALLERY.SCATTER",
  73: "COMBINATION",
  74: "PREFERRED",
  75: "ADD.OVERLAY",
  76: "GRIDLINES",
  77: "SET.PREFERRED",
  78: "AXES",
  79: "LEGEND",
  80: "ATTACH.TEXT",
  81: "ADD.ARROW",
  82: "SELECT.CHART",
  83: "SELECT.PLOT.AREA",
  84: "PATTERNS",
  85: "MAIN.CHART",
  86: "OVERLAY",
  87: "SCALE",
  88: "FORMAT.LEGEND",
  89: "FORMAT.TEXT",
  90: "EDIT.REPEAT",
  91: "PARSE",
  92: "JUSTIFY",
  93: "HIDE",
  94: "UNHIDE",
  95: "WORKSPACE",
  96: "FORMULA",
  97: "FORMULA.FILL",
  98: "FORMULA.ARRAY",
  99: "DATA.FIND.NEXT",
  100: "DATA.FIND.PREV",
  101: "FORMULA.FIND.NEXT",
  102: "FORMULA.FIND.PREV",
  103: "ACTIVATE",
  104: "ACTIVATE.NEXT",
  105: "ACTIVATE.PREV",
  106: "UNLOCKED.NEXT",
  107: "UNLOCKED.PREV",
  108: "COPY.PICTURE",
  109: "SELECT",
  110: "DELETE.NAME",
  111: "DELETE.FORMAT",
  112: "VLINE",
  113: "HLINE",
  114: "VPAGE",
  115: "HPAGE",
  116: "VSCROLL",
  117: "HSCROLL",
  118: "ALERT",
  119: "NEW",
  120: "CANCEL.COPY",
  121: "SHOW.CLIPBOARD",
  122: "MESSAGE",
  124: "PASTE.LINK",
  125: "APP.ACTIVATE",
  126: "DELETE.ARROW",
  127: "ROW.HEIGHT",
  128: "FORMAT.MOVE",
  129: "FORMAT.SIZE",
  130: "FORMULA.REPLACE",
  131: "SEND.KEYS",
  132: "SELECT.SPECIAL",
  133: "APPLY.NAMES",
  134: "REPLACE.FONT",
  135: "FREEZE.PANES",
  136: "SHOW.INFO",
  137: "SPLIT",
  138: "ON.WINDOW",
  139: "ON.DATA",
  140: "DISABLE.INPUT",
  142: "OUTLINE",
  143: "LIST.NAMES",
  144: "FILE.CLOSE",
  145: "SAVE.WORKBOOK",
  146: "DATA.FORM",
  147: "COPY.CHART",
  148: "ON.TIME",
  149: "WAIT",
  150: "FORMAT.FONT",
  151: "FILL.UP",
  152: "FILL.LEFT",
  153: "DELETE.OVERLAY",
  155: "SHORT.MENUS",
  159: "SET.UPDATE.STATUS",
  161: "COLOR.PALETTE",
  162: "DELETE.STYLE",
  163: "WINDOW.RESTORE",
  164: "WINDOW.MAXIMIZE",
  166: "CHANGE.LINK",
  167: "CALCULATE.DOCUMENT",
  168: "ON.KEY",
  169: "APP.RESTORE",
  170: "APP.MOVE",
  171: "APP.SIZE",
  172: "APP.MINIMIZE",
  173: "APP.MAXIMIZE",
  174: "BRING.TO.FRONT",
  175: "SEND.TO.BACK",
  185: "MAIN.CHART.TYPE",
  186: "OVERLAY.CHART.TYPE",
  187: "SELECT.END",
  188: "OPEN.MAIL",
  189: "SEND.MAIL",
  190: "STANDARD.FONT",
  191: "CONSOLIDATE",
  192: "SORT.SPECIAL",
  193: "GALLERY.3D.AREA",
  194: "GALLERY.3D.COLUMN",
  195: "GALLERY.3D.LINE",
  196: "GALLERY.3D.PIE",
  197: "VIEW.3D",
  198: "GOAL.SEEK",
  199: "WORKGROUP",
  200: "FILL.GROUP",
  201: "UPDATE.LINK",
  202: "PROMOTE",
  203: "DEMOTE",
  204: "SHOW.DETAIL",
  206: "UNGROUP",
  207: "OBJECT.PROPERTIES",
  208: "SAVE.NEW.OBJECT",
  209: "SHARE",
  210: "SHARE.NAME",
  211: "DUPLICATE",
  212: "APPLY.STYLE",
  213: "ASSIGN.TO.OBJECT",
  214: "OBJECT.PROTECTION",
  215: "HIDE.OBJECT",
  216: "SET.EXTRACT",
  217: "CREATE.PUBLISHER",
  218: "SUBSCRIBE.TO",
  219: "ATTRIBUTES",
  220: "SHOW.TOOLBAR",
  222: "PRINT.PREVIEW",
  223: "EDIT.COLOR",
  224: "SHOW.LEVELS",
  225: "FORMAT.MAIN",
  226: "FORMAT.OVERLAY",
  227: "ON.RECALC",
  228: "EDIT.SERIES",
  229: "DEFINE.STYLE",
  240: "LINE.PRINT",
  243: "ENTER.DATA",
  249: "GALLERY.RADAR",
  250: "MERGE.STYLES",
  251: "EDITION.OPTIONS",
  252: "PASTE.PICTURE",
  253: "PASTE.PICTURE.LINK",
  254: "SPELLING",
  256: "ZOOM",
  259: "INSERT.OBJECT",
  260: "WINDOW.MINIMIZE",
  265: "SOUND.NOTE",
  266: "SOUND.PLAY",
  267: "FORMAT.SHAPE",
  268: "EXTEND.POLYGON",
  269: "FORMAT.AUTO",
  272: "GALLERY.3D.BAR",
  273: "GALLERY.3D.SURFACE",
  274: "FILL.AUTO",
  276: "CUSTOMIZE.TOOLBAR",
  277: "ADD.TOOL",
  278: "EDIT.OBJECT",
  279: "ON.DOUBLECLICK",
  280: "ON.ENTRY",
  281: "WORKBOOK.ADD",
  282: "WORKBOOK.MOVE",
  283: "WORKBOOK.COPY",
  284: "WORKBOOK.OPTIONS",
  285: "SAVE.WORKSPACE",
  288: "CHART.WIZARD",
  289: "DELETE.TOOL",
  290: "MOVE.TOOL",
  291: "WORKBOOK.SELECT",
  292: "WORKBOOK.ACTIVATE",
  293: "ASSIGN.TO.TOOL",
  295: "COPY.TOOL",
  296: "RESET.TOOL",
  297: "CONSTRAIN.NUMERIC",
  298: "PASTE.TOOL",
  302: "WORKBOOK.NEW",
  305: "SCENARIO.CELLS",
  306: "SCENARIO.DELETE",
  307: "SCENARIO.ADD",
  308: "SCENARIO.EDIT",
  309: "SCENARIO.SHOW",
  310: "SCENARIO.SHOW.NEXT",
  311: "SCENARIO.SUMMARY",
  312: "PIVOT.TABLE.WIZARD",
  313: "PIVOT.FIELD.PROPERTIES",
  314: "PIVOT.FIELD",
  315: "PIVOT.ITEM",
  316: "PIVOT.ADD.FIELDS",
  318: "OPTIONS.CALCULATION",
  319: "OPTIONS.EDIT",
  320: "OPTIONS.VIEW",
  321: "ADDIN.MANAGER",
  322: "MENU.EDITOR",
  323: "ATTACH.TOOLBARS",
  324: "VBAActivate",
  325: "OPTIONS.CHART",
  328: "VBA.INSERT.FILE",
  330: "VBA.PROCEDURE.DEFINITION",
  336: "ROUTING.SLIP",
  338: "ROUTE.DOCUMENT",
  339: "MAIL.LOGON",
  342: "INSERT.PICTURE",
  343: "EDIT.TOOL",
  344: "GALLERY.DOUGHNUT",
  350: "CHART.TREND",
  352: "PIVOT.ITEM.PROPERTIES",
  354: "WORKBOOK.INSERT",
  355: "OPTIONS.TRANSITION",
  356: "OPTIONS.GENERAL",
  370: "FILTER.ADVANCED",
  373: "MAIL.ADD.MAILER",
  374: "MAIL.DELETE.MAILER",
  375: "MAIL.REPLY",
  376: "MAIL.REPLY.ALL",
  377: "MAIL.FORWARD",
  378: "MAIL.NEXT.LETTER",
  379: "DATA.LABEL",
  380: "INSERT.TITLE",
  381: "FONT.PROPERTIES",
  382: "MACRO.OPTIONS",
  383: "WORKBOOK.HIDE",
  384: "WORKBOOK.UNHIDE",
  385: "WORKBOOK.DELETE",
  386: "WORKBOOK.NAME",
  388: "GALLERY.CUSTOM",
  390: "ADD.CHART.AUTOFORMAT",
  391: "DELETE.CHART.AUTOFORMAT",
  392: "CHART.ADD.DATA",
  393: "AUTO.OUTLINE",
  394: "TAB.ORDER",
  395: "SHOW.DIALOG",
  396: "SELECT.ALL",
  397: "UNGROUP.SHEETS",
  398: "SUBTOTAL.CREATE",
  399: "SUBTOTAL.REMOVE",
  400: "RENAME.OBJECT",
  412: "WORKBOOK.SCROLL",
  413: "WORKBOOK.NEXT",
  414: "WORKBOOK.PREV",
  415: "WORKBOOK.TAB.SPLIT",
  416: "FULL.SCREEN",
  417: "WORKBOOK.PROTECT",
  420: "SCROLLBAR.PROPERTIES",
  421: "PIVOT.SHOW.PAGES",
  422: "TEXT.TO.COLUMNS",
  423: "FORMAT.CHARTTYPE",
  424: "LINK.FORMAT",
  425: "TRACER.DISPLAY",
  430: "TRACER.NAVIGATE",
  431: "TRACER.CLEAR",
  432: "TRACER.ERROR",
  433: "PIVOT.FIELD.GROUP",
  434: "PIVOT.FIELD.UNGROUP",
  435: "CHECKBOX.PROPERTIES",
  436: "LABEL.PROPERTIES",
  437: "LISTBOX.PROPERTIES",
  438: "EDITBOX.PROPERTIES",
  439: "PIVOT.REFRESH",
  440: "LINK.COMBO",
  441: "OPEN.TEXT",
  442: "HIDE.DIALOG",
  443: "SET.DIALOG.FOCUS",
  444: "ENABLE.OBJECT",
  445: "PUSHBUTTON.PROPERTIES",
  446: "SET.DIALOG.DEFAULT",
  447: "FILTER",
  448: "FILTER.SHOW.ALL",
  449: "CLEAR.OUTLINE",
  450: "FUNCTION.WIZARD",
  451: "ADD.LIST.ITEM",
  452: "SET.LIST.ITEM",
  453: "REMOVE.LIST.ITEM",
  454: "SELECT.LIST.ITEM",
  455: "SET.CONTROL.VALUE",
  456: "SAVE.COPY.AS",
  458: "OPTIONS.LISTS.ADD",
  459: "OPTIONS.LISTS.DELETE",
  460: "SERIES.AXES",
  461: "SERIES.X",
  462: "SERIES.Y",
  463: "ERRORBAR.X",
  464: "ERRORBAR.Y",
  465: "FORMAT.CHART",
  466: "SERIES.ORDER",
  467: "MAIL.LOGOFF",
  468: "CLEAR.ROUTING.SLIP",
  469: "APP.ACTIVATE.MICROSOFT",
  470: "MAIL.EDIT.MAILER",
  471: "ON.SHEET",
  472: "STANDARD.WIDTH",
  473: "SCENARIO.MERGE",
  474: "SUMMARY.INFO",
  475: "FIND.FILE",
  476: "ACTIVE.CELL.FONT",
  477: "ENABLE.TIPWIZARD",
  478: "VBA.MAKE.ADDIN",
  480: "INSERTDATATABLE",
  481: "WORKGROUP.OPTIONS",
  482: "MAIL.SEND.MAILER",
  485: "AUTOCORRECT",
  489: "POST.DOCUMENT",
  491: "PICKLIST",
  493: "VIEW.SHOW",
  494: "VIEW.DEFINE",
  495: "VIEW.DELETE",
  509: "SHEET.BACKGROUND",
  510: "INSERT.MAP.OBJECT",
  511: "OPTIONS.MENONO",
  517: "MSOCHECKS",
  518: "NORMAL",
  519: "LAYOUT",
  520: "RM.PRINT.AREA",
  521: "CLEAR.PRINT.AREA",
  522: "ADD.PRINT.AREA",
  523: "MOVE.BRK",
  545: "HIDECURR.NOTE",
  546: "HIDEALL.NOTES",
  547: "DELETE.NOTE",
  548: "TRAVERSE.NOTES",
  549: "ACTIVATE.NOTES",
  620: "PROTECT.REVISIONS",
  621: "UNPROTECT.REVISIONS",
  647: "OPTIONS.ME",
  653: "WEB.PUBLISH",
  667: "NEWWEBQUERY",
  673: "PIVOT.TABLE.CHART",
  753: "OPTIONS.SAVE",
  755: "OPTIONS.SPELL",
  808: "HIDEALL.INKANNOTS"
}, W7 = {
  0: "COUNT",
  1: "IF",
  2: "ISNA",
  3: "ISERROR",
  4: "SUM",
  5: "AVERAGE",
  6: "MIN",
  7: "MAX",
  8: "ROW",
  9: "COLUMN",
  10: "NA",
  11: "NPV",
  12: "STDEV",
  13: "DOLLAR",
  14: "FIXED",
  15: "SIN",
  16: "COS",
  17: "TAN",
  18: "ATAN",
  19: "PI",
  20: "SQRT",
  21: "EXP",
  22: "LN",
  23: "LOG10",
  24: "ABS",
  25: "INT",
  26: "SIGN",
  27: "ROUND",
  28: "LOOKUP",
  29: "INDEX",
  30: "REPT",
  31: "MID",
  32: "LEN",
  33: "VALUE",
  34: "TRUE",
  35: "FALSE",
  36: "AND",
  37: "OR",
  38: "NOT",
  39: "MOD",
  40: "DCOUNT",
  41: "DSUM",
  42: "DAVERAGE",
  43: "DMIN",
  44: "DMAX",
  45: "DSTDEV",
  46: "VAR",
  47: "DVAR",
  48: "TEXT",
  49: "LINEST",
  50: "TREND",
  51: "LOGEST",
  52: "GROWTH",
  53: "GOTO",
  54: "HALT",
  55: "RETURN",
  56: "PV",
  57: "FV",
  58: "NPER",
  59: "PMT",
  60: "RATE",
  61: "MIRR",
  62: "IRR",
  63: "RAND",
  64: "MATCH",
  65: "DATE",
  66: "TIME",
  67: "DAY",
  68: "MONTH",
  69: "YEAR",
  70: "WEEKDAY",
  71: "HOUR",
  72: "MINUTE",
  73: "SECOND",
  74: "NOW",
  75: "AREAS",
  76: "ROWS",
  77: "COLUMNS",
  78: "OFFSET",
  79: "ABSREF",
  80: "RELREF",
  81: "ARGUMENT",
  82: "SEARCH",
  83: "TRANSPOSE",
  84: "ERROR",
  85: "STEP",
  86: "TYPE",
  87: "ECHO",
  88: "SET.NAME",
  89: "CALLER",
  90: "DEREF",
  91: "WINDOWS",
  92: "SERIES",
  93: "DOCUMENTS",
  94: "ACTIVE.CELL",
  95: "SELECTION",
  96: "RESULT",
  97: "ATAN2",
  98: "ASIN",
  99: "ACOS",
  100: "CHOOSE",
  101: "HLOOKUP",
  102: "VLOOKUP",
  103: "LINKS",
  104: "INPUT",
  105: "ISREF",
  106: "GET.FORMULA",
  107: "GET.NAME",
  108: "SET.VALUE",
  109: "LOG",
  110: "EXEC",
  111: "CHAR",
  112: "LOWER",
  113: "UPPER",
  114: "PROPER",
  115: "LEFT",
  116: "RIGHT",
  117: "EXACT",
  118: "TRIM",
  119: "REPLACE",
  120: "SUBSTITUTE",
  121: "CODE",
  122: "NAMES",
  123: "DIRECTORY",
  124: "FIND",
  125: "CELL",
  126: "ISERR",
  127: "ISTEXT",
  128: "ISNUMBER",
  129: "ISBLANK",
  130: "T",
  131: "N",
  132: "FOPEN",
  133: "FCLOSE",
  134: "FSIZE",
  135: "FREADLN",
  136: "FREAD",
  137: "FWRITELN",
  138: "FWRITE",
  139: "FPOS",
  140: "DATEVALUE",
  141: "TIMEVALUE",
  142: "SLN",
  143: "SYD",
  144: "DDB",
  145: "GET.DEF",
  146: "REFTEXT",
  147: "TEXTREF",
  148: "INDIRECT",
  149: "REGISTER",
  150: "CALL",
  151: "ADD.BAR",
  152: "ADD.MENU",
  153: "ADD.COMMAND",
  154: "ENABLE.COMMAND",
  155: "CHECK.COMMAND",
  156: "RENAME.COMMAND",
  157: "SHOW.BAR",
  158: "DELETE.MENU",
  159: "DELETE.COMMAND",
  160: "GET.CHART.ITEM",
  161: "DIALOG.BOX",
  162: "CLEAN",
  163: "MDETERM",
  164: "MINVERSE",
  165: "MMULT",
  166: "FILES",
  167: "IPMT",
  168: "PPMT",
  169: "COUNTA",
  170: "CANCEL.KEY",
  171: "FOR",
  172: "WHILE",
  173: "BREAK",
  174: "NEXT",
  175: "INITIATE",
  176: "REQUEST",
  177: "POKE",
  178: "EXECUTE",
  179: "TERMINATE",
  180: "RESTART",
  181: "HELP",
  182: "GET.BAR",
  183: "PRODUCT",
  184: "FACT",
  185: "GET.CELL",
  186: "GET.WORKSPACE",
  187: "GET.WINDOW",
  188: "GET.DOCUMENT",
  189: "DPRODUCT",
  190: "ISNONTEXT",
  191: "GET.NOTE",
  192: "NOTE",
  193: "STDEVP",
  194: "VARP",
  195: "DSTDEVP",
  196: "DVARP",
  197: "TRUNC",
  198: "ISLOGICAL",
  199: "DCOUNTA",
  200: "DELETE.BAR",
  201: "UNREGISTER",
  204: "USDOLLAR",
  205: "FINDB",
  206: "SEARCHB",
  207: "REPLACEB",
  208: "LEFTB",
  209: "RIGHTB",
  210: "MIDB",
  211: "LENB",
  212: "ROUNDUP",
  213: "ROUNDDOWN",
  214: "ASC",
  215: "DBCS",
  216: "RANK",
  219: "ADDRESS",
  220: "DAYS360",
  221: "TODAY",
  222: "VDB",
  223: "ELSE",
  224: "ELSE.IF",
  225: "END.IF",
  226: "FOR.CELL",
  227: "MEDIAN",
  228: "SUMPRODUCT",
  229: "SINH",
  230: "COSH",
  231: "TANH",
  232: "ASINH",
  233: "ACOSH",
  234: "ATANH",
  235: "DGET",
  236: "CREATE.OBJECT",
  237: "VOLATILE",
  238: "LAST.ERROR",
  239: "CUSTOM.UNDO",
  240: "CUSTOM.REPEAT",
  241: "FORMULA.CONVERT",
  242: "GET.LINK.INFO",
  243: "TEXT.BOX",
  244: "INFO",
  245: "GROUP",
  246: "GET.OBJECT",
  247: "DB",
  248: "PAUSE",
  251: "RESUME",
  252: "FREQUENCY",
  253: "ADD.TOOLBAR",
  254: "DELETE.TOOLBAR",
  255: "User",
  256: "RESET.TOOLBAR",
  257: "EVALUATE",
  258: "GET.TOOLBAR",
  259: "GET.TOOL",
  260: "SPELLING.CHECK",
  261: "ERROR.TYPE",
  262: "APP.TITLE",
  263: "WINDOW.TITLE",
  264: "SAVE.TOOLBAR",
  265: "ENABLE.TOOL",
  266: "PRESS.TOOL",
  267: "REGISTER.ID",
  268: "GET.WORKBOOK",
  269: "AVEDEV",
  270: "BETADIST",
  271: "GAMMALN",
  272: "BETAINV",
  273: "BINOMDIST",
  274: "CHIDIST",
  275: "CHIINV",
  276: "COMBIN",
  277: "CONFIDENCE",
  278: "CRITBINOM",
  279: "EVEN",
  280: "EXPONDIST",
  281: "FDIST",
  282: "FINV",
  283: "FISHER",
  284: "FISHERINV",
  285: "FLOOR",
  286: "GAMMADIST",
  287: "GAMMAINV",
  288: "CEILING",
  289: "HYPGEOMDIST",
  290: "LOGNORMDIST",
  291: "LOGINV",
  292: "NEGBINOMDIST",
  293: "NORMDIST",
  294: "NORMSDIST",
  295: "NORMINV",
  296: "NORMSINV",
  297: "STANDARDIZE",
  298: "ODD",
  299: "PERMUT",
  300: "POISSON",
  301: "TDIST",
  302: "WEIBULL",
  303: "SUMXMY2",
  304: "SUMX2MY2",
  305: "SUMX2PY2",
  306: "CHITEST",
  307: "CORREL",
  308: "COVAR",
  309: "FORECAST",
  310: "FTEST",
  311: "INTERCEPT",
  312: "PEARSON",
  313: "RSQ",
  314: "STEYX",
  315: "SLOPE",
  316: "TTEST",
  317: "PROB",
  318: "DEVSQ",
  319: "GEOMEAN",
  320: "HARMEAN",
  321: "SUMSQ",
  322: "KURT",
  323: "SKEW",
  324: "ZTEST",
  325: "LARGE",
  326: "SMALL",
  327: "QUARTILE",
  328: "PERCENTILE",
  329: "PERCENTRANK",
  330: "MODE",
  331: "TRIMMEAN",
  332: "TINV",
  334: "MOVIE.COMMAND",
  335: "GET.MOVIE",
  336: "CONCATENATE",
  337: "POWER",
  338: "PIVOT.ADD.DATA",
  339: "GET.PIVOT.TABLE",
  340: "GET.PIVOT.FIELD",
  341: "GET.PIVOT.ITEM",
  342: "RADIANS",
  343: "DEGREES",
  344: "SUBTOTAL",
  345: "SUMIF",
  346: "COUNTIF",
  347: "COUNTBLANK",
  348: "SCENARIO.GET",
  349: "OPTIONS.LISTS.GET",
  350: "ISPMT",
  351: "DATEDIF",
  352: "DATESTRING",
  353: "NUMBERSTRING",
  354: "ROMAN",
  355: "OPEN.DIALOG",
  356: "SAVE.DIALOG",
  357: "VIEW.GET",
  358: "GETPIVOTDATA",
  359: "HYPERLINK",
  360: "PHONETIC",
  361: "AVERAGEA",
  362: "MAXA",
  363: "MINA",
  364: "STDEVPA",
  365: "VARPA",
  366: "STDEVA",
  367: "VARA",
  368: "BAHTTEXT",
  369: "THAIDAYOFWEEK",
  370: "THAIDIGIT",
  371: "THAIMONTHOFYEAR",
  372: "THAINUMSOUND",
  373: "THAINUMSTRING",
  374: "THAISTRINGLENGTH",
  375: "ISTHAIDIGIT",
  376: "ROUNDBAHTDOWN",
  377: "ROUNDBAHTUP",
  378: "THAIYEAR",
  379: "RTD",
  380: "CUBEVALUE",
  381: "CUBEMEMBER",
  382: "CUBEMEMBERPROPERTY",
  383: "CUBERANKEDMEMBER",
  384: "HEX2BIN",
  385: "HEX2DEC",
  386: "HEX2OCT",
  387: "DEC2BIN",
  388: "DEC2HEX",
  389: "DEC2OCT",
  390: "OCT2BIN",
  391: "OCT2HEX",
  392: "OCT2DEC",
  393: "BIN2DEC",
  394: "BIN2OCT",
  395: "BIN2HEX",
  396: "IMSUB",
  397: "IMDIV",
  398: "IMPOWER",
  399: "IMABS",
  400: "IMSQRT",
  401: "IMLN",
  402: "IMLOG2",
  403: "IMLOG10",
  404: "IMSIN",
  405: "IMCOS",
  406: "IMEXP",
  407: "IMARGUMENT",
  408: "IMCONJUGATE",
  409: "IMAGINARY",
  410: "IMREAL",
  411: "COMPLEX",
  412: "IMSUM",
  413: "IMPRODUCT",
  414: "SERIESSUM",
  415: "FACTDOUBLE",
  416: "SQRTPI",
  417: "QUOTIENT",
  418: "DELTA",
  419: "GESTEP",
  420: "ISEVEN",
  421: "ISODD",
  422: "MROUND",
  423: "ERF",
  424: "ERFC",
  425: "BESSELJ",
  426: "BESSELK",
  427: "BESSELY",
  428: "BESSELI",
  429: "XIRR",
  430: "XNPV",
  431: "PRICEMAT",
  432: "YIELDMAT",
  433: "INTRATE",
  434: "RECEIVED",
  435: "DISC",
  436: "PRICEDISC",
  437: "YIELDDISC",
  438: "TBILLEQ",
  439: "TBILLPRICE",
  440: "TBILLYIELD",
  441: "PRICE",
  442: "YIELD",
  443: "DOLLARDE",
  444: "DOLLARFR",
  445: "NOMINAL",
  446: "EFFECT",
  447: "CUMPRINC",
  448: "CUMIPMT",
  449: "EDATE",
  450: "EOMONTH",
  451: "YEARFRAC",
  452: "COUPDAYBS",
  453: "COUPDAYS",
  454: "COUPDAYSNC",
  455: "COUPNCD",
  456: "COUPNUM",
  457: "COUPPCD",
  458: "DURATION",
  459: "MDURATION",
  460: "ODDLPRICE",
  461: "ODDLYIELD",
  462: "ODDFPRICE",
  463: "ODDFYIELD",
  464: "RANDBETWEEN",
  465: "WEEKNUM",
  466: "AMORDEGRC",
  467: "AMORLINC",
  468: "CONVERT",
  724: "SHEETJS",
  469: "ACCRINT",
  470: "ACCRINTM",
  471: "WORKDAY",
  472: "NETWORKDAYS",
  473: "GCD",
  474: "MULTINOMIAL",
  475: "LCM",
  476: "FVSCHEDULE",
  477: "CUBEKPIMEMBER",
  478: "CUBESET",
  479: "CUBESETCOUNT",
  480: "IFERROR",
  481: "COUNTIFS",
  482: "SUMIFS",
  483: "AVERAGEIF",
  484: "AVERAGEIFS"
}, gl = {
  2: 1,
  3: 1,
  10: 0,
  15: 1,
  16: 1,
  17: 1,
  18: 1,
  19: 0,
  20: 1,
  21: 1,
  22: 1,
  23: 1,
  24: 1,
  25: 1,
  26: 1,
  27: 2,
  30: 2,
  31: 3,
  32: 1,
  33: 1,
  34: 0,
  35: 0,
  38: 1,
  39: 2,
  40: 3,
  41: 3,
  42: 3,
  43: 3,
  44: 3,
  45: 3,
  47: 3,
  48: 2,
  53: 1,
  61: 3,
  63: 0,
  65: 3,
  66: 3,
  67: 1,
  68: 1,
  69: 1,
  70: 1,
  71: 1,
  72: 1,
  73: 1,
  74: 0,
  75: 1,
  76: 1,
  77: 1,
  79: 2,
  80: 2,
  83: 1,
  85: 0,
  86: 1,
  89: 0,
  90: 1,
  94: 0,
  95: 0,
  97: 2,
  98: 1,
  99: 1,
  101: 3,
  102: 3,
  105: 1,
  106: 1,
  108: 2,
  111: 1,
  112: 1,
  113: 1,
  114: 1,
  117: 2,
  118: 1,
  119: 4,
  121: 1,
  126: 1,
  127: 1,
  128: 1,
  129: 1,
  130: 1,
  131: 1,
  133: 1,
  134: 1,
  135: 1,
  136: 2,
  137: 2,
  138: 2,
  140: 1,
  141: 1,
  142: 3,
  143: 4,
  144: 4,
  161: 1,
  162: 1,
  163: 1,
  164: 1,
  165: 2,
  172: 1,
  175: 2,
  176: 2,
  177: 3,
  178: 2,
  179: 1,
  184: 1,
  186: 1,
  189: 3,
  190: 1,
  195: 3,
  196: 3,
  197: 1,
  198: 1,
  199: 3,
  201: 1,
  207: 4,
  210: 3,
  211: 1,
  212: 2,
  213: 2,
  214: 1,
  215: 1,
  225: 0,
  229: 1,
  230: 1,
  231: 1,
  232: 1,
  233: 1,
  234: 1,
  235: 3,
  244: 1,
  247: 4,
  252: 2,
  257: 1,
  261: 1,
  271: 1,
  273: 4,
  274: 2,
  275: 2,
  276: 2,
  277: 3,
  278: 3,
  279: 1,
  280: 3,
  281: 3,
  282: 3,
  283: 1,
  284: 1,
  285: 2,
  286: 4,
  287: 3,
  288: 2,
  289: 4,
  290: 3,
  291: 3,
  292: 3,
  293: 4,
  294: 1,
  295: 3,
  296: 1,
  297: 3,
  298: 1,
  299: 2,
  300: 3,
  301: 3,
  302: 4,
  303: 2,
  304: 2,
  305: 2,
  306: 2,
  307: 2,
  308: 2,
  309: 3,
  310: 2,
  311: 2,
  312: 2,
  313: 2,
  314: 2,
  315: 2,
  316: 4,
  325: 2,
  326: 2,
  327: 2,
  328: 2,
  331: 2,
  332: 2,
  337: 2,
  342: 1,
  343: 1,
  346: 2,
  347: 1,
  350: 4,
  351: 3,
  352: 1,
  353: 2,
  360: 1,
  368: 1,
  369: 1,
  370: 1,
  371: 1,
  372: 1,
  373: 1,
  374: 1,
  375: 1,
  376: 1,
  377: 1,
  378: 1,
  382: 3,
  385: 1,
  392: 1,
  393: 1,
  396: 2,
  397: 2,
  398: 2,
  399: 1,
  400: 1,
  401: 1,
  402: 1,
  403: 1,
  404: 1,
  405: 1,
  406: 1,
  407: 1,
  408: 1,
  409: 1,
  410: 1,
  414: 4,
  415: 1,
  416: 1,
  417: 2,
  420: 1,
  421: 1,
  422: 2,
  424: 1,
  425: 2,
  426: 2,
  427: 2,
  428: 2,
  430: 3,
  438: 3,
  439: 3,
  440: 3,
  443: 2,
  444: 2,
  445: 2,
  446: 2,
  447: 6,
  448: 6,
  449: 2,
  450: 2,
  464: 2,
  468: 3,
  476: 2,
  479: 1,
  480: 2,
  65535: 0
};
function pr(e) {
  return e.slice(0, 3) == "of:" && (e = e.slice(3)), e.charCodeAt(0) == 61 && (e = e.slice(1), e.charCodeAt(0) == 61 && (e = e.slice(1))), e = e.replace(/COM\.MICROSOFT\./g, ""), e = e.replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g, function(t, r) {
    return r.replace(/\./g, "");
  }), e = e.replace(/\$'([^']|'')+'/g, function(t) {
    return t.slice(1);
  }), e = e.replace(/\$([^\]\. #$]+)/g, function(t, r) {
    return r.match(/^([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])?(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})?$/) ? t : r;
  }), e = e.replace(/\[.(#[A-Z]*[?!])\]/g, "$1"), e.replace(/[;~]/g, ",").replace(/\|/g, ";");
}
function u4(e) {
  e = e.replace(/\$'([^']|'')+'/g, function(a) {
    return a.slice(1);
  }), e = e.replace(/\$([^\]\. #$]+)/g, function(a, n) {
    return n.match(/^([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])?(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})?$/) ? a : n;
  });
  var t = e.split(":"), r = t[0].split(".")[0];
  return [r, t[0].split(".")[1] + (t.length > 1 ? ":" + (t[1].split(".")[1] || t[1].split(".")[0]) : "")];
}
var U3 = {}, x3 = {};
function H3(e, t) {
  if (e) {
    var r = [0.7, 0.7, 0.75, 0.75, 0.3, 0.3];
    t == "xlml" && (r = [1, 1, 1, 1, 0.5, 0.5]), e.left == null && (e.left = r[0]), e.right == null && (e.right = r[1]), e.top == null && (e.top = r[2]), e.bottom == null && (e.bottom = r[3]), e.header == null && (e.header = r[4]), e.footer == null && (e.footer = r[5]);
  }
}
function V7(e, t, r, a, n, i, c) {
  try {
    a.cellNF && (e.z = k0[t]);
  } catch (f) {
    if (a.WTF)
      throw f;
  }
  if (!(e.t === "z" && !a.cellStyles)) {
    if (e.t === "d" && typeof e.v == "string" && (e.v = w1(e.v)), (!a || a.cellText !== !1) && e.t !== "z")
      try {
        if (k0[t] == null && z2(en[t] || "General", t), e.t === "e")
          e.w = e.w || t3[e.v];
        else if (t === 0)
          if (e.t === "n")
            (e.v | 0) === e.v ? e.w = e.v.toString(10) : e.w = z3(e.v);
          else if (e.t === "d") {
            var s = v1(e.v, !!c);
            (s | 0) === s ? e.w = s.toString(10) : e.w = z3(s);
          } else {
            if (e.v === void 0)
              return "";
            e.w = K2(e.v, x3);
          }
        else
          e.t === "d" ? e.w = X1(t, v1(e.v, !!c), x3) : e.w = X1(t, e.v, x3);
      } catch (f) {
        if (a.WTF)
          throw f;
      }
    if (a.cellStyles && r != null)
      try {
        e.s = i.Fills[r], e.s.fgColor && e.s.fgColor.theme && !e.s.fgColor.rgb && (e.s.fgColor.rgb = Re(n.themeElements.clrScheme[e.s.fgColor.theme].rgb, e.s.fgColor.tint || 0), a.WTF && (e.s.fgColor.raw_rgb = n.themeElements.clrScheme[e.s.fgColor.theme].rgb)), e.s.bgColor && e.s.bgColor.theme && (e.s.bgColor.rgb = Re(n.themeElements.clrScheme[e.s.bgColor.theme].rgb, e.s.bgColor.tint || 0), a.WTF && (e.s.bgColor.raw_rgb = n.themeElements.clrScheme[e.s.bgColor.theme].rgb));
      } catch (f) {
        if (a.WTF && i.Fills)
          throw f;
      }
  }
}
function _l(e, t) {
  var r = o1(t);
  r.s.r <= r.e.r && r.s.c <= r.e.c && r.s.r >= 0 && r.s.c >= 0 && (e["!ref"] = M0(r));
}
var Tl = /<(?:\w:)?mergeCell ref=["'][A-Z0-9:]+['"]\s*[\/]?>/g, El = /<(?:\w+:)?sheetData[^>]*>([\s\S]*)<\/(?:\w+:)?sheetData>/, wl = /<(?:\w:)?hyperlink [^>]*>/mg, kl = /"(\w*:\w*)"/, Cl = /<(?:\w:)?col\b[^>]*[\/]?>/g, Sl = /<(?:\w:)?autoFilter[^>]*([\/]|>([\s\S]*)<\/(?:\w:)?autoFilter)>/g, Al = /<(?:\w:)?pageMargins[^>]*\/>/g, G7 = /<(?:\w:)?sheetPr\b(?:[^>a-z][^>]*)?\/>/, Fl = /<(?:\w:)?sheetPr[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetPr)>/, yl = /<(?:\w:)?sheetViews[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetViews)>/;
function Il(e, t, r, a, n, i, c) {
  if (!e)
    return e;
  a || (a = { "!id": {} });
  var s = {};
  t.dense && (s["!data"] = []);
  var f = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } }, o = "", l = "", d = e.match(El);
  d ? (o = e.slice(0, d.index), l = e.slice(d.index + d[0].length)) : o = l = e;
  var u = o.match(G7);
  u ? Z4(u[0], s, n, r) : (u = o.match(Fl)) && bl(u[0], u[1] || "", s, n, r);
  var h = (o.match(/<(?:\w*:)?dimension/) || { index: -1 }).index;
  if (h > 0) {
    var p = o.slice(h, h + 50).match(kl);
    p && !(t && t.nodim) && _l(s, p[1]);
  }
  var v = o.match(yl);
  v && v[1] && Pl(v[1], n);
  var x = [];
  if (t.cellStyles) {
    var m = o.match(Cl);
    m && Rl(x, m);
  }
  d && Ll(d[1], s, t, f, i, c, n);
  var T = l.match(Sl);
  T && (s["!autofilter"] = Ml(T[0]));
  var g = [], O = l.match(Tl);
  if (O)
    for (h = 0; h != O.length; ++h)
      g[h] = o1(O[h].slice(O[h].indexOf('"') + 1));
  var H = l.match(wl);
  H && Dl(s, H, a);
  var W = l.match(Al);
  W && (s["!margins"] = Ol(x0(W[0])));
  var E;
  if ((E = l.match(/legacyDrawing r:id="(.*?)"/)) && (s["!legrel"] = E[1]), t && t.nodim && (f.s.c = f.s.r = 0), !s["!ref"] && f.e.c >= f.s.c && f.e.r >= f.s.r && (s["!ref"] = M0(f)), t.sheetRows > 0 && s["!ref"]) {
    var b = o1(s["!ref"]);
    t.sheetRows <= +b.e.r && (b.e.r = t.sheetRows - 1, b.e.r > f.e.r && (b.e.r = f.e.r), b.e.r < b.s.r && (b.s.r = b.e.r), b.e.c > f.e.c && (b.e.c = f.e.c), b.e.c < b.s.c && (b.s.c = b.e.c), s["!fullref"] = s["!ref"], s["!ref"] = M0(b));
  }
  return x.length > 0 && (s["!cols"] = x), g.length > 0 && (s["!merges"] = g), a["!id"][s["!legrel"]] && (s["!legdrawel"] = a["!id"][s["!legrel"]]), s;
}
function Z4(e, t, r, a) {
  var n = x0(e);
  r.Sheets[a] || (r.Sheets[a] = {}), n.codeName && (r.Sheets[a].CodeName = R0(X0(n.codeName)));
}
function bl(e, t, r, a, n) {
  Z4(e.slice(0, e.indexOf(">")), r, a, n);
}
function Dl(e, t, r) {
  for (var a = e["!data"] != null, n = 0; n != t.length; ++n) {
    var i = x0(X0(t[n]), !0);
    if (!i.ref)
      return;
    var c = ((r || {})["!id"] || [])[i.id];
    c ? (i.Target = c.Target, i.location && (i.Target += "#" + R0(i.location))) : (i.Target = "#" + R0(i.location), c = { Target: i.Target, TargetMode: "Internal" }), i.Rel = c, i.tooltip && (i.Tooltip = i.tooltip, delete i.tooltip);
    for (var s = o1(i.ref), f = s.s.r; f <= s.e.r; ++f)
      for (var o = s.s.c; o <= s.e.c; ++o) {
        var l = W0(o) + j0(f);
        a ? (e["!data"][f] || (e["!data"][f] = []), e["!data"][f][o] || (e["!data"][f][o] = { t: "z", v: void 0 }), e["!data"][f][o].l = i) : (e[l] || (e[l] = { t: "z", v: void 0 }), e[l].l = i);
      }
  }
}
function Ol(e) {
  var t = {};
  return ["left", "right", "top", "bottom", "header", "footer"].forEach(function(r) {
    e[r] && (t[r] = parseFloat(e[r]));
  }), t;
}
function Rl(e, t) {
  for (var r = !1, a = 0; a != t.length; ++a) {
    var n = x0(t[a], !0);
    n.hidden && (n.hidden = G0(n.hidden));
    var i = parseInt(n.min, 10) - 1, c = parseInt(n.max, 10) - 1;
    for (n.outlineLevel && (n.level = +n.outlineLevel || 0), delete n.min, delete n.max, n.width = +n.width, !r && n.width && (r = !0, Y4(n.width)), m3(n); i <= c; )
      e[i++] = x1(n);
  }
}
function Ml(e) {
  var t = { ref: (e.match(/ref="([^"]*)"/) || [])[1] };
  return t;
}
var Nl = /<(?:\w:)?sheetView(?:[^>a-z][^>]*)?\/?>/g;
function Pl(e, t) {
  t.Views || (t.Views = [{}]), (e.match(Nl) || []).forEach(function(r, a) {
    var n = x0(r);
    t.Views[a] || (t.Views[a] = {}), +n.zoomScale && (t.Views[a].zoom = +n.zoomScale), n.rightToLeft && G0(n.rightToLeft) && (t.Views[a].RTL = !0);
  });
}
var Ll = /* @__PURE__ */ function() {
  var e = /<(?:\w+:)?c[ \/>]/, t = /<\/(?:\w+:)?row>/, r = /r=["']([^"']*)["']/, a = /<(?:\w+:)?is>([\S\s]*?)<\/(?:\w+:)?is>/, n = /ref=["']([^"']*)["']/, i = X3("v"), c = X3("f");
  return function(f, o, l, d, u, h, p) {
    for (var v = 0, x = "", m = [], T = [], g = 0, O = 0, H = 0, W = "", E, b, I = 0, P = 0, L, z, Y = 0, f0 = 0, i0 = Array.isArray(h.CellXf), p0, n0 = [], v0 = [], I0 = o["!data"] != null, K = [], T0 = {}, S0 = !1, w0 = !!l.sheetStubs, r0 = !!((p || {}).WBProps || {}).date1904, E0 = f.split(t), b0 = 0, D0 = E0.length; b0 != D0; ++b0) {
      x = E0[b0].trim();
      var F = x.length;
      if (F !== 0) {
        var B = 0;
        e:
          for (v = 0; v < F; ++v)
            switch (
              /*x.charCodeAt(ri)*/
              x[v]
            ) {
              case ">":
                if (
                  /*x.charCodeAt(ri-1) != 47*/
                  x[v - 1] != "/"
                ) {
                  ++v;
                  break e;
                }
                if (l && l.cellStyles) {
                  if (b = x0(x.slice(B, v), !0), I = b.r != null ? parseInt(b.r, 10) : I + 1, P = -1, l.sheetRows && l.sheetRows < I)
                    continue;
                  T0 = {}, S0 = !1, b.ht && (S0 = !0, T0.hpt = parseFloat(b.ht), T0.hpx = J3(T0.hpt)), b.hidden && G0(b.hidden) && (S0 = !0, T0.hidden = !0), b.outlineLevel != null && (S0 = !0, T0.level = +b.outlineLevel), S0 && (K[I - 1] = T0);
                }
                break;
              case "<":
                B = v;
                break;
            }
        if (B >= v)
          break;
        if (b = x0(x.slice(B, v), !0), I = b.r != null ? parseInt(b.r, 10) : I + 1, P = -1, !(l.sheetRows && l.sheetRows < I)) {
          l.nodim || (d.s.r > I - 1 && (d.s.r = I - 1), d.e.r < I - 1 && (d.e.r = I - 1)), l && l.cellStyles && (T0 = {}, S0 = !1, b.ht && (S0 = !0, T0.hpt = parseFloat(b.ht), T0.hpx = J3(T0.hpt)), b.hidden && G0(b.hidden) && (S0 = !0, T0.hidden = !0), b.outlineLevel != null && (S0 = !0, T0.level = +b.outlineLevel), S0 && (K[I - 1] = T0)), m = x.slice(v).split(e);
          for (var R = 0; R != m.length && m[R].trim().charAt(0) == "<"; ++R)
            ;
          for (m = m.slice(R), v = 0; v != m.length; ++v)
            if (x = m[v].trim(), x.length !== 0) {
              if (T = x.match(r), g = v, O = 0, H = 0, x = "<c " + (x.slice(0, 1) == "<" ? ">" : "") + x, T != null && T.length === 2) {
                for (g = 0, W = T[1], O = 0; O != W.length && !((H = W.charCodeAt(O) - 64) < 1 || H > 26); ++O)
                  g = 26 * g + H;
                --g, P = g;
              } else
                ++P;
              for (O = 0; O != x.length && x.charCodeAt(O) !== 62; ++O)
                ;
              if (++O, b = x0(x.slice(0, O), !0), b.r || (b.r = H0({ r: I - 1, c: P })), W = x.slice(O), E = { t: "" }, (T = W.match(i)) != null && /*::cref != null && */
              T[1] !== "" && (E.v = R0(T[1])), l.cellFormula) {
                if ((T = W.match(c)) != null) {
                  if (T[1] == "")
                    /*::cref != null && cref[0] != null && */
                    T[0].indexOf('t="shared"') > -1 && (z = x0(T[0]), v0[z.si] && (E.f = lr(v0[z.si][1], v0[z.si][2], b.r)));
                  else if (E.f = R0(X0(T[1]), !0), l.xlfn || (E.f = hr(E.f)), /*::cref != null && cref[0] != null && */
                  T[0].indexOf('t="array"') > -1)
                    E.F = (W.match(n) || [])[1], E.F.indexOf(":") > -1 && n0.push([o1(E.F), E.F]);
                  else if (
                    /*::cref != null && cref[0] != null && */
                    T[0].indexOf('t="shared"') > -1
                  ) {
                    z = x0(T[0]);
                    var D = R0(X0(T[1]));
                    l.xlfn || (D = hr(D)), v0[parseInt(z.si, 10)] = [z, D, b.r];
                  }
                } else
                  (T = W.match(/<f[^>]*\/>/)) && (z = x0(T[0]), v0[z.si] && (E.f = lr(v0[z.si][1], v0[z.si][2], b.r)));
                var Z = y1(b.r);
                for (O = 0; O < n0.length; ++O)
                  Z.r >= n0[O][0].s.r && Z.r <= n0[O][0].e.r && Z.c >= n0[O][0].s.c && Z.c <= n0[O][0].e.c && (E.F = n0[O][1]);
              }
              if (b.t == null && E.v === void 0)
                if (E.f || E.F)
                  E.v = 0, E.t = "n";
                else if (w0)
                  E.t = "z";
                else
                  continue;
              else
                E.t = b.t || "n";
              switch (d.s.c > P && (d.s.c = P), d.e.c < P && (d.e.c = P), E.t) {
                case "n":
                  if (E.v == "" || E.v == null) {
                    if (!w0)
                      continue;
                    E.t = "z";
                  } else
                    E.v = parseFloat(E.v);
                  break;
                case "s":
                  if (typeof E.v > "u") {
                    if (!w0)
                      continue;
                    E.t = "z";
                  } else
                    L = U3[parseInt(E.v, 10)], E.v = L.t, E.r = L.r, l.cellHTML && (E.h = L.h);
                  break;
                case "str":
                  E.t = "s", E.v = E.v != null ? R0(X0(E.v), !0) : "", l.cellHTML && (E.h = Ie(E.v));
                  break;
                case "inlineStr":
                  T = W.match(a), E.t = "s", T != null && (L = K4(T[1])) ? (E.v = L.t, l.cellHTML && (E.h = L.h)) : E.v = "";
                  break;
                case "b":
                  E.v = G0(E.v);
                  break;
                case "d":
                  l.cellDates ? E.v = w1(E.v, r0) : (E.v = v1(w1(E.v, r0), r0), E.t = "n");
                  break;
                case "e":
                  (!l || l.cellText !== !1) && (E.w = E.v), E.v = o7[E.v];
                  break;
              }
              if (Y = f0 = 0, p0 = null, i0 && b.s !== void 0 && (p0 = h.CellXf[b.s], p0 != null && (p0.numFmtId != null && (Y = p0.numFmtId), l.cellStyles && p0.fillId != null && (f0 = p0.fillId))), V7(E, Y, f0, l, u, h, r0), l.cellDates && i0 && E.t == "n" && u2(k0[Y]) && (E.v = O2(E.v + (r0 ? 1462 : 0)), E.t = typeof E.v == "number" ? "n" : "d"), b.cm && l.xlmeta) {
                var A = (l.xlmeta.Cell || [])[+b.cm - 1];
                A && A.type == "XLDAPR" && (E.D = !0);
              }
              var Q;
              l.nodim && (Q = y1(b.r), d.s.r > Q.r && (d.s.r = Q.r), d.e.r < Q.r && (d.e.r = Q.r)), I0 ? (Q = y1(b.r), o["!data"][Q.r] || (o["!data"][Q.r] = []), o["!data"][Q.r][Q.c] = E) : o[b.r] = E;
            }
        }
      }
    }
    K.length > 0 && (o["!rows"] = K);
  };
}();
function Bl(e, t) {
  var r = {}, a = e.l + t;
  r.r = e.read_shift(4), e.l += 4;
  var n = e.read_shift(2);
  e.l += 1;
  var i = e.read_shift(1);
  return e.l = a, i & 7 && (r.level = i & 7), i & 16 && (r.hidden = !0), i & 32 && (r.hpt = n / 20), r;
}
var Ul = r3;
function Hl() {
}
function Wl(e, t) {
  var r = {}, a = e[e.l];
  return ++e.l, r.above = !(a & 64), r.left = !(a & 128), e.l += 18, r.name = ti(e), r;
}
function Vl(e) {
  var t = n2(e);
  return [t];
}
function Gl(e) {
  var t = e3(e);
  return [t];
}
function jl(e) {
  var t = n2(e), r = e.read_shift(1);
  return [t, r, "b"];
}
function zl(e) {
  var t = e3(e), r = e.read_shift(1);
  return [t, r, "b"];
}
function $l(e) {
  var t = n2(e), r = e.read_shift(1);
  return [t, r, "e"];
}
function Xl(e) {
  var t = e3(e), r = e.read_shift(1);
  return [t, r, "e"];
}
function Kl(e) {
  var t = n2(e), r = e.read_shift(4);
  return [t, r, "s"];
}
function Yl(e) {
  var t = e3(e), r = e.read_shift(4);
  return [t, r, "s"];
}
function Jl(e) {
  var t = n2(e), r = F1(e);
  return [t, r, "n"];
}
function j7(e) {
  var t = e3(e), r = F1(e);
  return [t, r, "n"];
}
function ql(e) {
  var t = n2(e), r = Ye(e);
  return [t, r, "n"];
}
function Zl(e) {
  var t = e3(e), r = Ye(e);
  return [t, r, "n"];
}
function Ql(e) {
  var t = n2(e), r = z4(e);
  return [t, r, "is"];
}
function eh(e) {
  var t = n2(e), r = I1(e);
  return [t, r, "str"];
}
function rh(e) {
  var t = e3(e), r = I1(e);
  return [t, r, "str"];
}
function th(e, t, r) {
  var a = e.l + t, n = n2(e);
  n.r = r["!row"];
  var i = e.read_shift(1), c = [n, i, "b"];
  if (r.cellFormula) {
    e.l += 2;
    var s = Ze(e, a - e.l, r);
    c[3] = A1(s, null, n, r.supbooks, r);
  } else
    e.l = a;
  return c;
}
function ah(e, t, r) {
  var a = e.l + t, n = n2(e);
  n.r = r["!row"];
  var i = e.read_shift(1), c = [n, i, "e"];
  if (r.cellFormula) {
    e.l += 2;
    var s = Ze(e, a - e.l, r);
    c[3] = A1(s, null, n, r.supbooks, r);
  } else
    e.l = a;
  return c;
}
function nh(e, t, r) {
  var a = e.l + t, n = n2(e);
  n.r = r["!row"];
  var i = F1(e), c = [n, i, "n"];
  if (r.cellFormula) {
    e.l += 2;
    var s = Ze(e, a - e.l, r);
    c[3] = A1(s, null, n, r.supbooks, r);
  } else
    e.l = a;
  return c;
}
function ih(e, t, r) {
  var a = e.l + t, n = n2(e);
  n.r = r["!row"];
  var i = I1(e), c = [n, i, "str"];
  if (r.cellFormula) {
    e.l += 2;
    var s = Ze(e, a - e.l, r);
    c[3] = A1(s, null, n, r.supbooks, r);
  } else
    e.l = a;
  return c;
}
var sh = r3;
function ch(e, t) {
  var r = e.l + t, a = r3(e), n = Ke(e), i = I1(e), c = I1(e), s = I1(e);
  e.l = r;
  var f = { rfx: a, relId: n, loc: i, display: s };
  return c && (f.Tooltip = c), f;
}
function fh() {
}
function oh(e, t, r) {
  var a = e.l + t, n = s7(e), i = e.read_shift(1), c = [n];
  if (c[2] = i, r.cellFormula) {
    var s = dl(e, a - e.l, r);
    c[1] = s;
  } else
    e.l = a;
  return c;
}
function lh(e, t, r) {
  var a = e.l + t, n = r3(e), i = [n];
  if (r.cellFormula) {
    var c = ml(e, a - e.l, r);
    i[1] = c, e.l = a;
  } else
    e.l = a;
  return i;
}
var hh = ["left", "right", "top", "bottom", "header", "footer"];
function uh(e) {
  var t = {};
  return hh.forEach(function(r) {
    t[r] = F1(e);
  }), t;
}
function xh(e) {
  var t = e.read_shift(2);
  return e.l += 28, { RTL: t & 32 };
}
function dh() {
}
function ph() {
}
function mh(e, t, r, a, n, i, c) {
  if (!e)
    return e;
  var s = t || {};
  a || (a = { "!id": {} });
  var f = {};
  s.dense && (f["!data"] = []);
  var o, l = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } }, d = !1, u = !1, h, p, v, x, m, T, g, O, H, W = [];
  s.biff = 12, s["!row"] = 0;
  var E = 0, b = !1, I = [], P = {}, L = s.supbooks || /*::(*/
  n.supbooks || [[]];
  if (L.sharedf = P, L.arrayf = I, L.SheetNames = n.SheetNames || n.Sheets.map(function(I0) {
    return I0.name;
  }), !s.supbooks && (s.supbooks = L, n.Names))
    for (var z = 0; z < n.Names.length; ++z)
      L[0][z + 1] = n.Names[z];
  var Y = [], f0 = [], i0 = !1;
  Pe[16] = { n: "BrtShortReal", f: j7 };
  var p0, n0 = 1462 * +!!((n || {}).WBProps || {}).date1904;
  if (k2(e, function(K, T0, S0) {
    if (!u)
      switch (S0) {
        case 148:
          o = K;
          break;
        case 0:
          h = K, s.sheetRows && s.sheetRows <= h.r && (u = !0), O = j0(x = h.r), s["!row"] = h.r, (K.hidden || K.hpt || K.level != null) && (K.hpt && (K.hpx = J3(K.hpt)), f0[K.r] = K);
          break;
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
        case 8:
        case 9:
        case 10:
        case 11:
        case 13:
        case 14:
        case 15:
        case 16:
        case 17:
        case 18:
        case 62:
          switch (p = { t: K[2] }, K[2]) {
            case "n":
              p.v = K[1];
              break;
            case "s":
              g = U3[K[1]], p.v = g.t, p.r = g.r;
              break;
            case "b":
              p.v = !!K[1];
              break;
            case "e":
              p.v = K[1], s.cellText !== !1 && (p.w = t3[p.v]);
              break;
            case "str":
              p.t = "s", p.v = K[1];
              break;
            case "is":
              p.t = "s", p.v = K[1].t;
              break;
          }
          if ((v = c.CellXf[K[0].iStyleRef]) && V7(p, v.numFmtId, null, s, i, c, n0 > 0), m = K[0].c == -1 ? m + 1 : K[0].c, s.dense ? (f["!data"][x] || (f["!data"][x] = []), f["!data"][x][m] = p) : f[W0(m) + O] = p, s.cellFormula) {
            for (b = !1, E = 0; E < I.length; ++E) {
              var w0 = I[E];
              h.r >= w0[0].s.r && h.r <= w0[0].e.r && m >= w0[0].s.c && m <= w0[0].e.c && (p.F = M0(w0[0]), b = !0);
            }
            !b && K.length > 3 && (p.f = K[3]);
          }
          if (l.s.r > h.r && (l.s.r = h.r), l.s.c > m && (l.s.c = m), l.e.r < h.r && (l.e.r = h.r), l.e.c < m && (l.e.c = m), s.cellDates && v && p.t == "n" && u2(k0[v.numFmtId])) {
            var r0 = v2(p.v + n0);
            r0 && (p.t = "d", p.v = new Date(Date.UTC(r0.y, r0.m - 1, r0.d, r0.H, r0.M, r0.S, r0.u)));
          }
          p0 && (p0.type == "XLDAPR" && (p.D = !0), p0 = void 0);
          break;
        case 1:
        case 12:
          if (!s.sheetStubs || d)
            break;
          p = { t: "z", v: void 0 }, m = K[0].c == -1 ? m + 1 : K[0].c, s.dense ? (f["!data"][x] || (f["!data"][x] = []), f["!data"][x][m] = p) : f[W0(m) + O] = p, l.s.r > h.r && (l.s.r = h.r), l.s.c > m && (l.s.c = m), l.e.r < h.r && (l.e.r = h.r), l.e.c < m && (l.e.c = m), p0 && (p0.type == "XLDAPR" && (p.D = !0), p0 = void 0);
          break;
        case 176:
          W.push(K);
          break;
        case 49:
          p0 = ((s.xlmeta || {}).Cell || [])[K - 1];
          break;
        case 494:
          var E0 = a["!id"][K.relId];
          for (E0 ? (K.Target = E0.Target, K.loc && (K.Target += "#" + K.loc), K.Rel = E0) : K.relId == "" && (K.Target = "#" + K.loc), x = K.rfx.s.r; x <= K.rfx.e.r; ++x)
            for (m = K.rfx.s.c; m <= K.rfx.e.c; ++m)
              s.dense ? (f["!data"][x] || (f["!data"][x] = []), f["!data"][x][m] || (f["!data"][x][m] = { t: "z", v: void 0 }), f["!data"][x][m].l = K) : (T = W0(m) + j0(x), f[T] || (f[T] = { t: "z", v: void 0 }), f[T].l = K);
          break;
        case 426:
          if (!s.cellFormula)
            break;
          I.push(K), H = s.dense ? f["!data"][x][m] : f[W0(m) + O], H.f = A1(K[1], l, { r: h.r, c: m }, L, s), H.F = M0(K[0]);
          break;
        case 427:
          if (!s.cellFormula)
            break;
          P[H0(K[0].s)] = K[1], H = s.dense ? f["!data"][x][m] : f[W0(m) + O], H.f = A1(K[1], l, { r: h.r, c: m }, L, s);
          break;
        case 60:
          if (!s.cellStyles)
            break;
          for (; K.e >= K.s; )
            Y[K.e--] = { width: K.w / 256, hidden: !!(K.flags & 1), level: K.level }, i0 || (i0 = !0, Y4(K.w / 256)), m3(Y[K.e + 1]);
          break;
        case 551:
          K && (f["!legrel"] = K);
          break;
        case 161:
          f["!autofilter"] = { ref: M0(K) };
          break;
        case 476:
          f["!margins"] = K;
          break;
        case 147:
          n.Sheets[r] || (n.Sheets[r] = {}), K.name && (n.Sheets[r].CodeName = K.name), (K.above || K.left) && (f["!outline"] = { above: K.above, left: K.left });
          break;
        case 137:
          n.Views || (n.Views = [{}]), n.Views[0] || (n.Views[0] = {}), K.RTL && (n.Views[0].RTL = !0);
          break;
        case 485:
          break;
        case 64:
        case 1053:
          break;
        case 151:
          break;
        case 152:
        case 175:
        case 644:
        case 625:
        case 562:
        case 396:
        case 1112:
        case 1146:
        case 471:
        case 1050:
        case 649:
        case 1105:
        case 589:
        case 607:
        case 564:
        case 1055:
        case 168:
        case 174:
        case 1180:
        case 499:
        case 507:
        case 550:
        case 171:
        case 167:
        case 1177:
        case 169:
        case 1181:
        case 552:
        case 661:
        case 639:
        case 478:
        case 537:
        case 477:
        case 536:
        case 1103:
        case 680:
        case 1104:
        case 1024:
        case 663:
        case 535:
        case 678:
        case 504:
        case 1043:
        case 428:
        case 170:
        case 3072:
        case 50:
        case 2070:
        case 1045:
          break;
        case 35:
          d = !0;
          break;
        case 36:
          d = !1;
          break;
        case 37:
          d = !0;
          break;
        case 38:
          d = !1;
          break;
        default:
          if (!T0.T) {
            if (!d || s.WTF)
              throw new Error("Unexpected record 0x" + S0.toString(16));
          }
      }
  }, s), delete s.supbooks, delete s["!row"], !f["!ref"] && (l.s.r < 2e6 || o && (o.e.r > 0 || o.e.c > 0 || o.s.r > 0 || o.s.c > 0)) && (f["!ref"] = M0(o || l)), s.sheetRows && f["!ref"]) {
    var v0 = o1(f["!ref"]);
    s.sheetRows <= +v0.e.r && (v0.e.r = s.sheetRows - 1, v0.e.r > l.e.r && (v0.e.r = l.e.r), v0.e.r < v0.s.r && (v0.s.r = v0.e.r), v0.e.c > l.e.c && (v0.e.c = l.e.c), v0.e.c < v0.s.c && (v0.s.c = v0.e.c), f["!fullref"] = f["!ref"], f["!ref"] = M0(v0));
  }
  return W.length > 0 && (f["!merges"] = W), Y.length > 0 && (f["!cols"] = Y), f0.length > 0 && (f["!rows"] = f0), a["!id"][f["!legrel"]] && (f["!legdrawel"] = a["!id"][f["!legrel"]]), f;
}
function vh(e) {
  var t = [], r = e.match(/^<c:numCache>/), a;
  (e.match(/<c:pt idx="(\d*)">(.*?)<\/c:pt>/mg) || []).forEach(function(i) {
    var c = i.match(/<c:pt idx="(\d*?)"><c:v>(.*)<\/c:v><\/c:pt>/);
    c && (t[+c[1]] = r ? +c[2] : c[2]);
  });
  var n = R0((e.match(/<c:formatCode>([\s\S]*?)<\/c:formatCode>/) || ["", "General"])[1]);
  return (e.match(/<c:f>(.*?)<\/c:f>/mg) || []).forEach(function(i) {
    a = i.replace(/<.*?>/g, "");
  }), [t, n, a];
}
function gh(e, t, r, a, n, i) {
  var c = i || { "!type": "chart" };
  if (!e)
    return i;
  var s = 0, f = 0, o = "A", l = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } };
  return (e.match(/<c:numCache>[\s\S]*?<\/c:numCache>/gm) || []).forEach(function(d) {
    var u = vh(d);
    l.s.r = l.s.c = 0, l.e.c = s, o = W0(s), u[0].forEach(function(h, p) {
      c["!data"] ? (c["!data"][p] || (c["!data"][p] = []), c["!data"][p][s] = { t: "n", v: h, z: u[1] }) : c[o + j0(p)] = { t: "n", v: h, z: u[1] }, f = p;
    }), l.e.r < f && (l.e.r = f), ++s;
  }), s > 0 && (c["!ref"] = M0(l)), c;
}
function _h(e, t, r, a, n) {
  if (!e)
    return e;
  a || (a = { "!id": {} });
  var i = { "!type": "chart", "!drawel": null, "!rel": "" }, c, s = e.match(G7);
  return s && Z4(s[0], i, n, r), (c = e.match(/drawing r:id="(.*?)"/)) && (i["!rel"] = c[1]), a["!id"][i["!rel"]] && (i["!drawel"] = a["!id"][i["!rel"]]), i;
}
function Th(e, t) {
  e.l += 10;
  var r = I1(e);
  return { name: r };
}
function Eh(e, t, r, a, n) {
  if (!e)
    return e;
  a || (a = { "!id": {} });
  var i = { "!type": "chart", "!drawel": null, "!rel": "" }, c = !1;
  return k2(e, function(f, o, l) {
    switch (l) {
      case 550:
        i["!rel"] = f;
        break;
      case 651:
        n.Sheets[r] || (n.Sheets[r] = {}), f.name && (n.Sheets[r].CodeName = f.name);
        break;
      case 562:
      case 652:
      case 669:
      case 679:
      case 551:
      case 552:
      case 476:
      case 3072:
        break;
      case 35:
        c = !0;
        break;
      case 36:
        c = !1;
        break;
      case 37:
        break;
      case 38:
        break;
      default:
        if (!(o.T > 0)) {
          if (!(o.T < 0)) {
            if (!c || t.WTF)
              throw new Error("Unexpected record 0x" + l.toString(16));
          }
        }
    }
  }, t), a["!id"][i["!rel"]] && (i["!drawel"] = a["!id"][i["!rel"]]), i;
}
var z7 = [
  ["allowRefreshQuery", !1, "bool"],
  ["autoCompressPictures", !0, "bool"],
  ["backupFile", !1, "bool"],
  ["checkCompatibility", !1, "bool"],
  ["CodeName", ""],
  ["date1904", !1, "bool"],
  ["defaultThemeVersion", 0, "int"],
  ["filterPrivacy", !1, "bool"],
  ["hidePivotFieldList", !1, "bool"],
  ["promptedSolutions", !1, "bool"],
  ["publishItems", !1, "bool"],
  ["refreshAllConnections", !1, "bool"],
  ["saveExternalLinkValues", !0, "bool"],
  ["showBorderUnselectedTables", !0, "bool"],
  ["showInkAnnotation", !0, "bool"],
  ["showObjects", "all"],
  ["showPivotChartFilter", !1, "bool"],
  ["updateLinks", "userSet"]
], wh = [
  ["activeTab", 0, "int"],
  ["autoFilterDateGrouping", !0, "bool"],
  ["firstSheet", 0, "int"],
  ["minimized", !1, "bool"],
  ["showHorizontalScroll", !0, "bool"],
  ["showSheetTabs", !0, "bool"],
  ["showVerticalScroll", !0, "bool"],
  ["tabRatio", 600, "int"],
  ["visibility", "visible"]
  //window{Height,Width}, {x,y}Window
], kh = [
  //['state', 'visible']
], Ch = [
  ["calcCompleted", "true"],
  ["calcMode", "auto"],
  ["calcOnSave", "true"],
  ["concurrentCalc", "true"],
  ["fullCalcOnLoad", "false"],
  ["fullPrecision", "true"],
  ["iterate", "false"],
  ["iterateCount", "100"],
  ["iterateDelta", "0.001"],
  ["refMode", "A1"]
];
function mr(e, t) {
  for (var r = 0; r != e.length; ++r)
    for (var a = e[r], n = 0; n != t.length; ++n) {
      var i = t[n];
      if (a[i[0]] == null)
        a[i[0]] = i[1];
      else
        switch (i[2]) {
          case "bool":
            typeof a[i[0]] == "string" && (a[i[0]] = G0(a[i[0]]));
            break;
          case "int":
            typeof a[i[0]] == "string" && (a[i[0]] = parseInt(a[i[0]], 10));
            break;
        }
    }
}
function vr(e, t) {
  for (var r = 0; r != t.length; ++r) {
    var a = t[r];
    if (e[a[0]] == null)
      e[a[0]] = a[1];
    else
      switch (a[2]) {
        case "bool":
          typeof e[a[0]] == "string" && (e[a[0]] = G0(e[a[0]]));
          break;
        case "int":
          typeof e[a[0]] == "string" && (e[a[0]] = parseInt(e[a[0]], 10));
          break;
      }
  }
}
function $7(e) {
  vr(e.WBProps, z7), vr(e.CalcPr, Ch), mr(e.WBView, wh), mr(e.Sheets, kh), x3.date1904 = G0(e.WBProps.date1904);
}
var Sh = /* @__PURE__ */ ":][*?/\\".split("");
function Ah(e, t) {
  try {
    if (e == "")
      throw new Error("Sheet name cannot be blank");
    if (e.length > 31)
      throw new Error("Sheet name cannot exceed 31 chars");
    if (e.charCodeAt(0) == 39 || e.charCodeAt(e.length - 1) == 39)
      throw new Error("Sheet name cannot start or end with apostrophe (')");
    if (e.toLowerCase() == "history")
      throw new Error("Sheet name cannot be 'History'");
    Sh.forEach(function(r) {
      if (e.indexOf(r) != -1)
        throw new Error("Sheet name cannot contain : \\ / ? * [ ]");
    });
  } catch (r) {
    throw r;
  }
  return !0;
}
var Fh = /<\w+:workbook/;
function yh(e, t) {
  if (!e)
    throw new Error("Could not find file");
  var r = (
    /*::(*/
    { AppVersion: {}, WBProps: {}, WBView: [], Sheets: [], CalcPr: {}, Names: [], xmlns: "" }
  ), a = !1, n = "xmlns", i = {}, c = 0;
  if (e.replace(k1, function(f, o) {
    var l = x0(f);
    switch (a2(l[0])) {
      case "<?xml":
        break;
      case "<workbook":
        f.match(Fh) && (n = "xmlns" + f.match(/<(\w+):/)[1]), r.xmlns = l[n];
        break;
      case "</workbook>":
        break;
      case "<fileVersion":
        delete l[0], r.AppVersion = l;
        break;
      case "<fileVersion/>":
      case "</fileVersion>":
        break;
      case "<fileSharing":
        break;
      case "<fileSharing/>":
        break;
      case "<workbookPr":
      case "<workbookPr/>":
        z7.forEach(function(d) {
          if (l[d[0]] != null)
            switch (d[2]) {
              case "bool":
                r.WBProps[d[0]] = G0(l[d[0]]);
                break;
              case "int":
                r.WBProps[d[0]] = parseInt(l[d[0]], 10);
                break;
              default:
                r.WBProps[d[0]] = l[d[0]];
            }
        }), l.codeName && (r.WBProps.CodeName = X0(l.codeName));
        break;
      case "</workbookPr>":
        break;
      case "<workbookProtection":
        break;
      case "<workbookProtection/>":
        break;
      case "<bookViews":
      case "<bookViews>":
      case "</bookViews>":
        break;
      case "<workbookView":
      case "<workbookView/>":
        delete l[0], r.WBView.push(l);
        break;
      case "</workbookView>":
        break;
      case "<sheets":
      case "<sheets>":
      case "</sheets>":
        break;
      case "<sheet":
        switch (l.state) {
          case "hidden":
            l.Hidden = 1;
            break;
          case "veryHidden":
            l.Hidden = 2;
            break;
          default:
            l.Hidden = 0;
        }
        delete l.state, l.name = R0(X0(l.name)), delete l[0], r.Sheets.push(l);
        break;
      case "</sheet>":
        break;
      case "<functionGroups":
      case "<functionGroups/>":
        break;
      case "<functionGroup":
        break;
      case "<externalReferences":
      case "</externalReferences>":
      case "<externalReferences>":
        break;
      case "<externalReference":
        break;
      case "<definedNames/>":
        break;
      case "<definedNames>":
      case "<definedNames":
        a = !0;
        break;
      case "</definedNames>":
        a = !1;
        break;
      case "<definedName":
        i = {}, i.Name = X0(l.name), l.comment && (i.Comment = l.comment), l.localSheetId && (i.Sheet = +l.localSheetId), G0(l.hidden || "0") && (i.Hidden = !0), c = o + f.length;
        break;
      case "</definedName>":
        i.Ref = R0(X0(e.slice(c, o))), r.Names.push(i);
        break;
      case "<definedName/>":
        break;
      case "<calcPr":
        delete l[0], r.CalcPr = l;
        break;
      case "<calcPr/>":
        delete l[0], r.CalcPr = l;
        break;
      case "</calcPr>":
        break;
      case "<oleSize":
        break;
      case "<customWorkbookViews>":
      case "</customWorkbookViews>":
      case "<customWorkbookViews":
        break;
      case "<customWorkbookView":
      case "</customWorkbookView>":
        break;
      case "<pivotCaches>":
      case "</pivotCaches>":
      case "<pivotCaches":
        break;
      case "<pivotCache":
        break;
      case "<smartTagPr":
      case "<smartTagPr/>":
        break;
      case "<smartTagTypes":
      case "<smartTagTypes>":
      case "</smartTagTypes>":
        break;
      case "<smartTagType":
        break;
      case "<webPublishing":
      case "<webPublishing/>":
        break;
      case "<fileRecoveryPr":
      case "<fileRecoveryPr/>":
        break;
      case "<webPublishObjects>":
      case "<webPublishObjects":
      case "</webPublishObjects>":
        break;
      case "<webPublishObject":
        break;
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
      case "<extLst/>":
        break;
      case "<ext":
        a = !0;
        break;
      case "</ext>":
        a = !1;
        break;
      case "<ArchID":
        break;
      case "<AlternateContent":
      case "<AlternateContent>":
        a = !0;
        break;
      case "</AlternateContent>":
        a = !1;
        break;
      case "<revisionPtr":
        break;
      default:
        if (!a && t.WTF)
          throw new Error("unrecognized " + l[0] + " in workbook");
    }
    return f;
  }), Ln.indexOf(r.xmlns) === -1)
    throw new Error("Unknown Namespace: " + r.xmlns);
  return $7(r), r;
}
function Ih(e, t) {
  var r = {};
  return r.Hidden = e.read_shift(4), r.iTabID = e.read_shift(4), r.strRelID = g4(e), r.name = I1(e), r;
}
function bh(e, t) {
  var r = {}, a = e.read_shift(4);
  r.defaultThemeVersion = e.read_shift(4);
  var n = t > 8 ? I1(e) : "";
  return n.length > 0 && (r.CodeName = n), r.autoCompressPictures = !!(a & 65536), r.backupFile = !!(a & 64), r.checkCompatibility = !!(a & 4096), r.date1904 = !!(a & 1), r.filterPrivacy = !!(a & 8), r.hidePivotFieldList = !!(a & 1024), r.promptedSolutions = !!(a & 16), r.publishItems = !!(a & 2048), r.refreshAllConnections = !!(a & 262144), r.saveExternalLinkValues = !!(a & 128), r.showBorderUnselectedTables = !!(a & 4), r.showInkAnnotation = !!(a & 32), r.showObjects = ["all", "placeholders", "none"][a >> 13 & 3], r.showPivotChartFilter = !!(a & 32768), r.updateLinks = ["userSet", "never", "always"][a >> 8 & 3], r;
}
function Dh(e, t) {
  var r = {};
  return e.read_shift(4), r.ArchID = e.read_shift(4), e.l += t - 8, r;
}
function Oh(e, t, r) {
  var a = e.l + t, n = e.read_shift(4);
  e.l += 1;
  var i = e.read_shift(4), c = ai(e), s = pl(e, 0, r), f = Ke(e);
  n & 32 && (c = "_xlnm." + c), e.l = a;
  var o = { Name: c, Ptg: s, Flags: n };
  return i < 268435455 && (o.Sheet = i), f && (o.Comment = f), o;
}
function Rh(e, t) {
  var r = { AppVersion: {}, WBProps: {}, WBView: [], Sheets: [], CalcPr: {}, xmlns: "" }, a = [], n = !1;
  t || (t = {}), t.biff = 12;
  var i = [], c = [[]];
  return c.SheetNames = [], c.XTI = [], Pe[16] = { n: "BrtFRTArchID$", f: Dh }, k2(e, function(f, o, l) {
    switch (l) {
      case 156:
        c.SheetNames.push(f.name), r.Sheets.push(f);
        break;
      case 153:
        r.WBProps = f;
        break;
      case 39:
        f.Sheet != null && (t.SID = f.Sheet), f.Ref = A1(f.Ptg, null, null, c, t), delete t.SID, delete f.Ptg, i.push(f);
        break;
      case 1036:
        break;
      case 357:
      case 358:
      case 355:
      case 667:
        c[0].length ? c.push([l, f]) : c[0] = [l, f], c[c.length - 1].XTI = [];
        break;
      case 362:
        c.length === 0 && (c[0] = [], c[0].XTI = []), c[c.length - 1].XTI = c[c.length - 1].XTI.concat(f), c.XTI = c.XTI.concat(f);
        break;
      case 361:
        break;
      case 2071:
      case 158:
      case 143:
      case 664:
      case 353:
        break;
      case 3072:
      case 3073:
      case 534:
      case 677:
      case 157:
      case 610:
      case 2050:
      case 155:
      case 548:
      case 676:
      case 128:
      case 665:
      case 2128:
      case 2125:
      case 549:
      case 2053:
      case 596:
      case 2076:
      case 2075:
      case 2082:
      case 397:
      case 154:
      case 1117:
      case 553:
      case 2091:
        break;
      case 35:
        a.push(l), n = !0;
        break;
      case 36:
        a.pop(), n = !1;
        break;
      case 37:
        a.push(l), n = !0;
        break;
      case 38:
        a.pop(), n = !1;
        break;
      case 16:
        break;
      default:
        if (!o.T) {
          if (!n || t.WTF && a[a.length - 1] != 37 && a[a.length - 1] != 35)
            throw new Error("Unexpected record 0x" + l.toString(16));
        }
    }
  }, t), $7(r), r.Names = i, r.supbooks = c, r;
}
function Mh(e, t, r) {
  return t.slice(-4) === ".bin" ? Rh(e, r) : yh(e, r);
}
function Nh(e, t, r, a, n, i, c, s) {
  return t.slice(-4) === ".bin" ? mh(e, a, r, n, i, c, s) : Il(e, a, r, n, i, c, s);
}
function Ph(e, t, r, a, n, i, c, s) {
  return t.slice(-4) === ".bin" ? Eh(e, a, r, n, i) : _h(e, a, r, n, i);
}
function Lh(e, t, r, a, n, i, c, s) {
  return t.slice(-4) === ".bin" ? zf() : $f();
}
function Bh(e, t, r, a, n, i, c, s) {
  return t.slice(-4) === ".bin" ? Gf() : jf();
}
function Uh(e, t, r, a) {
  return t.slice(-4) === ".bin" ? af(e, r, a) : qc(e, r, a);
}
function Hh(e, t, r) {
  return t.slice(-4) === ".bin" ? gc(e, r) : mc(e, r);
}
function Wh(e, t, r) {
  return t.slice(-4) === ".bin" ? Hf(e, r) : Nf(e, r);
}
function Vh(e, t, r) {
  return t.slice(-4) === ".bin" ? bf(e) : yf(e);
}
function Gh(e, t, r, a) {
  return r.slice(-4) === ".bin" ? Df(e, t, r, a) : void 0;
}
function jh(e, t, r) {
  return t.slice(-4) === ".bin" ? Af(e, t, r) : Ff(e, t, r);
}
var X7 = /([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g, K7 = /([\w:]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;
function f2(e, t) {
  var r = e.split(/\s+/), a = [];
  if (a[0] = r[0], r.length === 1)
    return a;
  var n = e.match(X7), i, c, s, f;
  if (n)
    for (f = 0; f != n.length; ++f)
      i = n[f].match(K7), (c = i[1].indexOf(":")) === -1 ? a[i[1]] = i[2].slice(1, i[2].length - 1) : (i[1].slice(0, 6) === "xmlns:" ? s = "xmlns" + i[1].slice(6) : s = i[1].slice(c + 1), a[s] = i[2].slice(1, i[2].length - 1));
  return a;
}
function zh(e) {
  var t = e.split(/\s+/), r = {};
  if (t.length === 1)
    return r;
  var a = e.match(X7), n, i, c, s;
  if (a)
    for (s = 0; s != a.length; ++s)
      n = a[s].match(K7), (i = n[1].indexOf(":")) === -1 ? r[n[1]] = n[2].slice(1, n[2].length - 1) : (n[1].slice(0, 6) === "xmlns:" ? c = "xmlns" + n[1].slice(6) : c = n[1].slice(i + 1), r[c] = n[2].slice(1, n[2].length - 1));
  return r;
}
var W3;
function $h(e, t, r) {
  var a = W3[e] || R0(e);
  return a === "General" ? K2(t) : X1(a, t, { date1904: !!r });
}
function Xh(e, t, r, a) {
  var n = a;
  switch ((r[0].match(/dt:dt="([\w.]+)"/) || ["", ""])[1]) {
    case "boolean":
      n = G0(a);
      break;
    case "i2":
    case "int":
      n = parseInt(a, 10);
      break;
    case "r4":
    case "float":
      n = parseFloat(a);
      break;
    case "date":
    case "dateTime.tz":
      n = w1(a);
      break;
    case "i8":
    case "string":
    case "fixed":
    case "uuid":
    case "bin.base64":
      break;
    default:
      throw new Error("bad custprop:" + r[0]);
  }
  e[R0(t)] = n;
}
function Kh(e, t, r, a) {
  if (e.t !== "z") {
    if (!r || r.cellText !== !1)
      try {
        e.t === "e" ? e.w = e.w || t3[e.v] : t === "General" ? e.t === "n" ? (e.v | 0) === e.v ? e.w = e.v.toString(10) : e.w = z3(e.v) : e.w = K2(e.v) : e.w = $h(t || "General", e.v, a);
      } catch (c) {
        if (r.WTF)
          throw c;
      }
    try {
      var n = W3[t] || t || "General";
      if (r.cellNF && (e.z = n), r.cellDates && e.t == "n" && u2(n)) {
        var i = v2(e.v + (a ? 1462 : 0));
        i && (e.t = "d", e.v = new Date(Date.UTC(i.y, i.m - 1, i.d, i.H, i.M, i.S, i.u)));
      }
    } catch (c) {
      if (r.WTF)
        throw c;
    }
  }
}
function Yh(e, t, r) {
  if (r.cellStyles && t.Interior) {
    var a = t.Interior;
    a.Pattern && (a.patternType = zc[a.Pattern] || a.Pattern);
  }
  e[t.ID] = t;
}
function Jh(e, t, r, a, n, i, c, s, f, o, l) {
  var d = "General", u = a.StyleID, h = {};
  o = o || {};
  var p = [], v = 0;
  for (u === void 0 && s && (u = s.StyleID), u === void 0 && c && (u = c.StyleID); i[u] !== void 0 && (i[u].nf && (d = i[u].nf), i[u].Interior && p.push(i[u].Interior), !!i[u].Parent); )
    u = i[u].Parent;
  switch (r.Type) {
    case "Boolean":
      a.t = "b", a.v = G0(e);
      break;
    case "String":
      a.t = "s", a.r = B5(R0(e)), a.v = e.indexOf("<") > -1 ? R0(t || e).replace(/<.*?>/g, "") : a.r;
      break;
    case "DateTime":
      e.slice(-1) != "Z" && (e += "Z"), a.v = v1(w1(e, l), l), a.v !== a.v && (a.v = R0(e)), (!d || d == "General") && (d = "yyyy-mm-dd");
    case "Number":
      a.v === void 0 && (a.v = +e), a.t || (a.t = "n");
      break;
    case "Error":
      a.t = "e", a.v = o7[e], o.cellText !== !1 && (a.w = e);
      break;
    default:
      e == "" && t == "" ? a.t = "z" : (a.t = "s", a.v = B5(t || e));
      break;
  }
  if (Kh(a, d, o, l), o.cellFormula !== !1)
    if (a.Formula) {
      var x = R0(a.Formula);
      x.charCodeAt(0) == 61 && (x = x.slice(1)), a.f = X2(x, n), delete a.Formula, a.ArrayRange == "RC" ? a.F = X2("RC:RC", n) : a.ArrayRange && (a.F = X2(a.ArrayRange, n), f.push([o1(a.F), a.F]));
    } else
      for (v = 0; v < f.length; ++v)
        n.r >= f[v][0].s.r && n.r <= f[v][0].e.r && n.c >= f[v][0].s.c && n.c <= f[v][0].e.c && (a.F = f[v][1]);
  o.cellStyles && (p.forEach(function(m) {
    !h.patternType && m.patternType && (h.patternType = m.patternType);
  }), a.s = h), a.StyleID !== void 0 && (a.ixfe = a.StyleID);
}
function qh(e) {
  return l7.indexOf("_xlnm." + e) > -1 ? "_xlnm." + e : e;
}
function Zh(e) {
  e.t = e.v || "", e.t = e.t.replace(/\r\n/g, `
`).replace(/\r/g, `
`), e.v = e.w = e.ixfe = void 0;
}
function x4(e, t) {
  var r = t || {};
  P6();
  var a = y3(Xe(e));
  (r.type == "binary" || r.type == "array" || r.type == "base64") && (a = X0(a));
  var n = a.slice(0, 1024).toLowerCase(), i = !1;
  if (n = n.replace(/".*?"/g, ""), (n.indexOf(">") & 1023) > Math.min(n.indexOf(",") & 1023, n.indexOf(";") & 1023)) {
    var c = x1(r);
    return c.type = "string", K3.to_workbook(a, c);
  }
  if (n.indexOf("<?xml") == -1 && ["html", "table", "head", "meta", "script", "style", "div"].forEach(function(_0) {
    n.indexOf("<" + _0) >= 0 && (i = !0);
  }), i)
    return cu(a, r);
  W3 = {
    "General Number": "General",
    "General Date": k0[22],
    "Long Date": "dddd, mmmm dd, yyyy",
    "Medium Date": k0[15],
    "Short Date": k0[14],
    "Long Time": k0[19],
    "Medium Time": k0[18],
    "Short Time": k0[20],
    Currency: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    Fixed: k0[2],
    Standard: k0[4],
    Percent: k0[10],
    Scientific: k0[11],
    "Yes/No": '"Yes";"Yes";"No";@',
    "True/False": '"True";"True";"False";@',
    "On/Off": '"Yes";"Yes";"No";@'
  };
  var s, f = [], o, l = {}, d = [], u = {}, h = "";
  r.dense && (u["!data"] = []);
  var p = {}, v = {}, x = f2('<Data ss:Type="String">'), m = 0, T = 0, g = 0, O = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } }, H = {}, W = {}, E = "", b = 0, I = [], P = {}, L = {}, z = 0, Y = [], f0 = [], i0 = {}, p0 = [], n0, v0 = !1, I0 = [], K = [], T0 = {}, S0 = 0, w0 = 0, r0 = { Sheets: [], WBProps: { date1904: !1 } }, E0 = {};
  u1.lastIndex = 0, a = a.replace(/<!--([\s\S]*?)-->/mg, "");
  for (var b0 = ""; s = u1.exec(a); )
    switch (s[3] = (b0 = s[3]).toLowerCase()) {
      case "data":
        if (b0 == "data") {
          if (s[1] === "/") {
            if ((o = f.pop())[0] !== s[3])
              throw new Error("Bad state: " + o.join("|"));
          } else
            s[0].charAt(s[0].length - 2) !== "/" && f.push([s[3], !0]);
          break;
        }
        if (f[f.length - 1][1])
          break;
        s[1] === "/" ? Jh(a.slice(m, s.index), E, x, f[f.length - 1][0] == /*"Comment"*/
        "comment" ? i0 : p, { c: T, r: g }, H, p0[T], v, I0, r, r0.WBProps.date1904) : (E = "", x = f2(s[0]), m = s.index + s[0].length);
        break;
      case "cell":
        if (s[1] === "/")
          if (f0.length > 0 && (p.c = f0), (!r.sheetRows || r.sheetRows > g) && p.v !== void 0 && (r.dense ? (u["!data"][g] || (u["!data"][g] = []), u["!data"][g][T] = p) : u[W0(T) + j0(g)] = p), p.HRef && (p.l = { Target: R0(p.HRef) }, p.HRefScreenTip && (p.l.Tooltip = p.HRefScreenTip), delete p.HRef, delete p.HRefScreenTip), (p.MergeAcross || p.MergeDown) && (S0 = T + (parseInt(p.MergeAcross, 10) | 0), w0 = g + (parseInt(p.MergeDown, 10) | 0), (S0 > T || w0 > g) && I.push({ s: { c: T, r: g }, e: { c: S0, r: w0 } })), !r.sheetStubs)
            p.MergeAcross ? T = S0 + 1 : ++T;
          else if (p.MergeAcross || p.MergeDown) {
            for (var D0 = T; D0 <= S0; ++D0)
              for (var F = g; F <= w0; ++F)
                (D0 > T || F > g) && (r.dense ? (u["!data"][F] || (u["!data"][F] = []), u["!data"][F][D0] = { t: "z" }) : u[W0(D0) + j0(F)] = { t: "z" });
            T = S0 + 1;
          } else
            ++T;
        else
          p = zh(s[0]), p.Index && (T = +p.Index - 1), T < O.s.c && (O.s.c = T), T > O.e.c && (O.e.c = T), s[0].slice(-2) === "/>" && ++T, f0 = [];
        break;
      case "row":
        s[1] === "/" || s[0].slice(-2) === "/>" ? (g < O.s.r && (O.s.r = g), g > O.e.r && (O.e.r = g), s[0].slice(-2) === "/>" && (v = f2(s[0]), v.Index && (g = +v.Index - 1)), T = 0, ++g) : (v = f2(s[0]), v.Index && (g = +v.Index - 1), T0 = {}, (v.AutoFitHeight == "0" || v.Height) && (T0.hpx = parseInt(v.Height, 10), T0.hpt = O7(T0.hpx), K[g] = T0), v.Hidden == "1" && (T0.hidden = !0, K[g] = T0));
        break;
      case "worksheet":
        if (s[1] === "/") {
          if ((o = f.pop())[0] !== s[3])
            throw new Error("Bad state: " + o.join("|"));
          d.push(h), O.s.r <= O.e.r && O.s.c <= O.e.c && (u["!ref"] = M0(O), r.sheetRows && r.sheetRows <= O.e.r && (u["!fullref"] = u["!ref"], O.e.r = r.sheetRows - 1, u["!ref"] = M0(O))), I.length && (u["!merges"] = I), p0.length > 0 && (u["!cols"] = p0), K.length > 0 && (u["!rows"] = K), l[h] = u;
        } else
          O = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } }, g = T = 0, f.push([s[3], !1]), o = f2(s[0]), h = R0(o.Name), u = {}, r.dense && (u["!data"] = []), I = [], I0 = [], K = [], E0 = { name: h, Hidden: 0 }, r0.Sheets.push(E0);
        break;
      case "table":
        if (s[1] === "/") {
          if ((o = f.pop())[0] !== s[3])
            throw new Error("Bad state: " + o.join("|"));
        } else {
          if (s[0].slice(-2) == "/>")
            break;
          f.push([s[3], !1]), p0 = [], v0 = !1;
        }
        break;
      case "style":
        s[1] === "/" ? Yh(H, W, r) : W = f2(s[0]);
        break;
      case "numberformat":
        W.nf = R0(f2(s[0]).Format || "General"), W3[W.nf] && (W.nf = W3[W.nf]);
        for (var B = 0; B != 392 && k0[B] != W.nf; ++B)
          ;
        if (B == 392) {
          for (B = 57; B != 392; ++B)
            if (k0[B] == null) {
              z2(W.nf, B);
              break;
            }
        }
        break;
      case "column":
        if (f[f.length - 1][0] !== /*'Table'*/
        "table" || s[1] === "/")
          break;
        if (n0 = f2(s[0]), n0.Hidden && (n0.hidden = !0, delete n0.Hidden), n0.Width && (n0.wpx = parseInt(n0.Width, 10)), !v0 && n0.wpx > 10) {
          v0 = !0, N1 = b7;
          for (var R = 0; R < p0.length; ++R)
            p0[R] && m3(p0[R]);
        }
        v0 && m3(n0), p0[n0.Index - 1 || p0.length] = n0;
        for (var D = 0; D < +n0.Span; ++D)
          p0[p0.length] = x1(n0);
        break;
      case "namedrange":
        if (s[1] === "/")
          break;
        r0.Names || (r0.Names = []);
        var Z = x0(s[0]), A = {
          Name: qh(Z.Name),
          Ref: X2(Z.RefersTo.slice(1), { r: 0, c: 0 })
        };
        r0.Sheets.length > 0 && (A.Sheet = r0.Sheets.length - 1), r0.Names.push(A);
        break;
      case "namedcell":
        break;
      case "b":
        break;
      case "i":
        break;
      case "u":
        break;
      case "s":
        break;
      case "em":
        break;
      case "h2":
        break;
      case "h3":
        break;
      case "sub":
        break;
      case "sup":
        break;
      case "span":
        break;
      case "alignment":
        break;
      case "borders":
        break;
      case "border":
        break;
      case "font":
        if (s[0].slice(-2) === "/>")
          break;
        s[1] === "/" ? E += a.slice(b, s.index) : b = s.index + s[0].length;
        break;
      case "interior":
        if (!r.cellStyles)
          break;
        W.Interior = f2(s[0]);
        break;
      case "protection":
        break;
      case "author":
      case "title":
      case "description":
      case "created":
      case "keywords":
      case "subject":
      case "category":
      case "company":
      case "lastauthor":
      case "lastsaved":
      case "lastprinted":
      case "version":
      case "revision":
      case "totaltime":
      case "hyperlinkbase":
      case "manager":
      case "contentstatus":
      case "identifier":
      case "language":
      case "appname":
        if (s[0].slice(-2) === "/>")
          break;
        s[1] === "/" ? yi(P, b0, a.slice(z, s.index)) : z = s.index + s[0].length;
        break;
      case "paragraphs":
        break;
      case "styles":
      case "workbook":
        if (s[1] === "/") {
          if ((o = f.pop())[0] !== s[3])
            throw new Error("Bad state: " + o.join("|"));
        } else
          f.push([s[3], !1]);
        break;
      case "comment":
        if (s[1] === "/") {
          if ((o = f.pop())[0] !== s[3])
            throw new Error("Bad state: " + o.join("|"));
          Zh(i0), f0.push(i0);
        } else
          f.push([s[3], !1]), o = f2(s[0]), G0(o.ShowAlways || "0") || (f0.hidden = !0), i0 = { a: o.Author };
        break;
      case "autofilter":
        if (s[1] === "/") {
          if ((o = f.pop())[0] !== s[3])
            throw new Error("Bad state: " + o.join("|"));
        } else if (s[0].charAt(s[0].length - 2) !== "/") {
          var Q = f2(s[0]);
          u["!autofilter"] = { ref: X2(Q.Range).replace(/\$/g, "") }, f.push([s[3], !0]);
        }
        break;
      case "name":
        break;
      case "datavalidation":
        if (s[1] === "/") {
          if ((o = f.pop())[0] !== s[3])
            throw new Error("Bad state: " + o.join("|"));
        } else
          s[0].charAt(s[0].length - 2) !== "/" && f.push([s[3], !0]);
        break;
      case "pixelsperinch":
        break;
      case "componentoptions":
      case "documentproperties":
      case "customdocumentproperties":
      case "officedocumentsettings":
      case "pivottable":
      case "pivotcache":
      case "names":
      case "mapinfo":
      case "pagebreaks":
      case "querytable":
      case "sorting":
      case "schema":
      case "conditionalformatting":
      case "smarttagtype":
      case "smarttags":
      case "excelworkbook":
      case "workbookoptions":
      case "worksheetoptions":
        if (s[1] === "/") {
          if ((o = f.pop())[0] !== s[3])
            throw new Error("Bad state: " + o.join("|"));
        } else
          s[0].charAt(s[0].length - 2) !== "/" && f.push([s[3], !0]);
        break;
      case "null":
        break;
      default:
        if (f.length == 0 && s[3] == "document" || f.length == 0 && s[3] == "uof")
          return wr(a, r);
        var m0 = !0;
        switch (f[f.length - 1][0]) {
          case "officedocumentsettings":
            switch (s[3]) {
              case "allowpng":
                break;
              case "removepersonalinformation":
                break;
              case "downloadcomponents":
                break;
              case "locationofcomponents":
                break;
              case "colors":
                break;
              case "color":
                break;
              case "index":
                break;
              case "rgb":
                break;
              case "targetscreensize":
                break;
              case "readonlyrecommended":
                break;
              default:
                m0 = !1;
            }
            break;
          case "componentoptions":
            switch (s[3]) {
              case "toolbar":
                break;
              case "hideofficelogo":
                break;
              case "spreadsheetautofit":
                break;
              case "label":
                break;
              case "caption":
                break;
              case "maxheight":
                break;
              case "maxwidth":
                break;
              case "nextsheetnumber":
                break;
              default:
                m0 = !1;
            }
            break;
          case "excelworkbook":
            switch (s[3]) {
              case "date1904":
                r0.WBProps.date1904 = !0;
                break;
              case "hidehorizontalscrollbar":
                break;
              case "hideverticalscrollbar":
                break;
              case "hideworkbooktabs":
                break;
              case "windowheight":
                break;
              case "windowwidth":
                break;
              case "windowtopx":
                break;
              case "windowtopy":
                break;
              case "tabratio":
                break;
              case "protectstructure":
                break;
              case "protectwindow":
                break;
              case "protectwindows":
                break;
              case "activesheet":
                break;
              case "displayinknotes":
                break;
              case "firstvisiblesheet":
                break;
              case "supbook":
                break;
              case "sheetname":
                break;
              case "sheetindex":
                break;
              case "sheetindexfirst":
                break;
              case "sheetindexlast":
                break;
              case "dll":
                break;
              case "acceptlabelsinformulas":
                break;
              case "donotsavelinkvalues":
                break;
              case "iteration":
                break;
              case "maxiterations":
                break;
              case "maxchange":
                break;
              case "path":
                break;
              case "xct":
                break;
              case "count":
                break;
              case "selectedsheets":
                break;
              case "calculation":
                break;
              case "uncalced":
                break;
              case "startupprompt":
                break;
              case "crn":
                break;
              case "externname":
                break;
              case "formula":
                break;
              case "colfirst":
                break;
              case "collast":
                break;
              case "wantadvise":
                break;
              case "boolean":
                break;
              case "error":
                break;
              case "text":
                break;
              case "ole":
                break;
              case "noautorecover":
                break;
              case "publishobjects":
                break;
              case "donotcalculatebeforesave":
                break;
              case "number":
                break;
              case "refmoder1c1":
                break;
              case "embedsavesmarttags":
                break;
              default:
                m0 = !1;
            }
            break;
          case "workbookoptions":
            switch (s[3]) {
              case "owcversion":
                break;
              case "height":
                break;
              case "width":
                break;
              default:
                m0 = !1;
            }
            break;
          case "worksheetoptions":
            switch (s[3]) {
              case "visible":
                if (s[0].slice(-2) !== "/>")
                  if (s[1] === "/")
                    switch (a.slice(z, s.index)) {
                      case "SheetHidden":
                        E0.Hidden = 1;
                        break;
                      case "SheetVeryHidden":
                        E0.Hidden = 2;
                        break;
                    }
                  else
                    z = s.index + s[0].length;
                break;
              case "header":
                u["!margins"] || H3(u["!margins"] = {}, "xlml"), isNaN(+x0(s[0]).Margin) || (u["!margins"].header = +x0(s[0]).Margin);
                break;
              case "footer":
                u["!margins"] || H3(u["!margins"] = {}, "xlml"), isNaN(+x0(s[0]).Margin) || (u["!margins"].footer = +x0(s[0]).Margin);
                break;
              case "pagemargins":
                var a0 = x0(s[0]);
                u["!margins"] || H3(u["!margins"] = {}, "xlml"), isNaN(+a0.Top) || (u["!margins"].top = +a0.Top), isNaN(+a0.Left) || (u["!margins"].left = +a0.Left), isNaN(+a0.Right) || (u["!margins"].right = +a0.Right), isNaN(+a0.Bottom) || (u["!margins"].bottom = +a0.Bottom);
                break;
              case "displayrighttoleft":
                r0.Views || (r0.Views = []), r0.Views[0] || (r0.Views[0] = {}), r0.Views[0].RTL = !0;
                break;
              case "freezepanes":
                break;
              case "frozennosplit":
                break;
              case "splithorizontal":
              case "splitvertical":
                break;
              case "donotdisplaygridlines":
                break;
              case "activerow":
                break;
              case "activecol":
                break;
              case "toprowbottompane":
                break;
              case "leftcolumnrightpane":
                break;
              case "unsynced":
                break;
              case "print":
                break;
              case "printerrors":
                break;
              case "panes":
                break;
              case "scale":
                break;
              case "pane":
                break;
              case "number":
                break;
              case "layout":
                break;
              case "pagesetup":
                break;
              case "selected":
                break;
              case "protectobjects":
                break;
              case "enableselection":
                break;
              case "protectscenarios":
                break;
              case "validprinterinfo":
                break;
              case "horizontalresolution":
                break;
              case "verticalresolution":
                break;
              case "numberofcopies":
                break;
              case "activepane":
                break;
              case "toprowvisible":
                break;
              case "leftcolumnvisible":
                break;
              case "fittopage":
                break;
              case "rangeselection":
                break;
              case "papersizeindex":
                break;
              case "pagelayoutzoom":
                break;
              case "pagebreakzoom":
                break;
              case "filteron":
                break;
              case "fitwidth":
                break;
              case "fitheight":
                break;
              case "commentslayout":
                break;
              case "zoom":
                break;
              case "lefttoright":
                break;
              case "gridlines":
                break;
              case "allowsort":
                break;
              case "allowfilter":
                break;
              case "allowinsertrows":
                break;
              case "allowdeleterows":
                break;
              case "allowinsertcols":
                break;
              case "allowdeletecols":
                break;
              case "allowinserthyperlinks":
                break;
              case "allowformatcells":
                break;
              case "allowsizecols":
                break;
              case "allowsizerows":
                break;
              case "nosummaryrowsbelowdetail":
                u["!outline"] || (u["!outline"] = {}), u["!outline"].above = !0;
                break;
              case "tabcolorindex":
                break;
              case "donotdisplayheadings":
                break;
              case "showpagelayoutzoom":
                break;
              case "nosummarycolumnsrightdetail":
                u["!outline"] || (u["!outline"] = {}), u["!outline"].left = !0;
                break;
              case "blackandwhite":
                break;
              case "donotdisplayzeros":
                break;
              case "displaypagebreak":
                break;
              case "rowcolheadings":
                break;
              case "donotdisplayoutline":
                break;
              case "noorientation":
                break;
              case "allowusepivottables":
                break;
              case "zeroheight":
                break;
              case "viewablerange":
                break;
              case "selection":
                break;
              case "protectcontents":
                break;
              default:
                m0 = !1;
            }
            break;
          case "pivottable":
          case "pivotcache":
            switch (s[3]) {
              case "immediateitemsondrop":
                break;
              case "showpagemultipleitemlabel":
                break;
              case "compactrowindent":
                break;
              case "location":
                break;
              case "pivotfield":
                break;
              case "orientation":
                break;
              case "layoutform":
                break;
              case "layoutsubtotallocation":
                break;
              case "layoutcompactrow":
                break;
              case "position":
                break;
              case "pivotitem":
                break;
              case "datatype":
                break;
              case "datafield":
                break;
              case "sourcename":
                break;
              case "parentfield":
                break;
              case "ptlineitems":
                break;
              case "ptlineitem":
                break;
              case "countofsameitems":
                break;
              case "item":
                break;
              case "itemtype":
                break;
              case "ptsource":
                break;
              case "cacheindex":
                break;
              case "consolidationreference":
                break;
              case "filename":
                break;
              case "reference":
                break;
              case "nocolumngrand":
                break;
              case "norowgrand":
                break;
              case "blanklineafteritems":
                break;
              case "hidden":
                break;
              case "subtotal":
                break;
              case "basefield":
                break;
              case "mapchilditems":
                break;
              case "function":
                break;
              case "refreshonfileopen":
                break;
              case "printsettitles":
                break;
              case "mergelabels":
                break;
              case "defaultversion":
                break;
              case "refreshname":
                break;
              case "refreshdate":
                break;
              case "refreshdatecopy":
                break;
              case "versionlastrefresh":
                break;
              case "versionlastupdate":
                break;
              case "versionupdateablemin":
                break;
              case "versionrefreshablemin":
                break;
              case "calculation":
                break;
              default:
                m0 = !1;
            }
            break;
          case "pagebreaks":
            switch (s[3]) {
              case "colbreaks":
                break;
              case "colbreak":
                break;
              case "rowbreaks":
                break;
              case "rowbreak":
                break;
              case "colstart":
                break;
              case "colend":
                break;
              case "rowend":
                break;
              default:
                m0 = !1;
            }
            break;
          case "autofilter":
            switch (s[3]) {
              case "autofiltercolumn":
                break;
              case "autofiltercondition":
                break;
              case "autofilterand":
                break;
              case "autofilteror":
                break;
              default:
                m0 = !1;
            }
            break;
          case "querytable":
            switch (s[3]) {
              case "id":
                break;
              case "autoformatfont":
                break;
              case "autoformatpattern":
                break;
              case "querysource":
                break;
              case "querytype":
                break;
              case "enableredirections":
                break;
              case "refreshedinxl9":
                break;
              case "urlstring":
                break;
              case "htmltables":
                break;
              case "connection":
                break;
              case "commandtext":
                break;
              case "refreshinfo":
                break;
              case "notitles":
                break;
              case "nextid":
                break;
              case "columninfo":
                break;
              case "overwritecells":
                break;
              case "donotpromptforfile":
                break;
              case "textwizardsettings":
                break;
              case "source":
                break;
              case "number":
                break;
              case "decimal":
                break;
              case "thousandseparator":
                break;
              case "trailingminusnumbers":
                break;
              case "formatsettings":
                break;
              case "fieldtype":
                break;
              case "delimiters":
                break;
              case "tab":
                break;
              case "comma":
                break;
              case "autoformatname":
                break;
              case "versionlastedit":
                break;
              case "versionlastrefresh":
                break;
              default:
                m0 = !1;
            }
            break;
          case "datavalidation":
            switch (s[3]) {
              case "range":
                break;
              case "type":
                break;
              case "min":
                break;
              case "max":
                break;
              case "sort":
                break;
              case "descending":
                break;
              case "order":
                break;
              case "casesensitive":
                break;
              case "value":
                break;
              case "errorstyle":
                break;
              case "errormessage":
                break;
              case "errortitle":
                break;
              case "inputmessage":
                break;
              case "inputtitle":
                break;
              case "combohide":
                break;
              case "inputhide":
                break;
              case "condition":
                break;
              case "qualifier":
                break;
              case "useblank":
                break;
              case "value1":
                break;
              case "value2":
                break;
              case "format":
                break;
              case "cellrangelist":
                break;
              default:
                m0 = !1;
            }
            break;
          case "sorting":
          case "conditionalformatting":
            switch (s[3]) {
              case "range":
                break;
              case "type":
                break;
              case "min":
                break;
              case "max":
                break;
              case "sort":
                break;
              case "descending":
                break;
              case "order":
                break;
              case "casesensitive":
                break;
              case "value":
                break;
              case "errorstyle":
                break;
              case "errormessage":
                break;
              case "errortitle":
                break;
              case "cellrangelist":
                break;
              case "inputmessage":
                break;
              case "inputtitle":
                break;
              case "combohide":
                break;
              case "inputhide":
                break;
              case "condition":
                break;
              case "qualifier":
                break;
              case "useblank":
                break;
              case "value1":
                break;
              case "value2":
                break;
              case "format":
                break;
              default:
                m0 = !1;
            }
            break;
          case "mapinfo":
          case "schema":
          case "data":
            switch (s[3]) {
              case "map":
                break;
              case "entry":
                break;
              case "range":
                break;
              case "xpath":
                break;
              case "field":
                break;
              case "xsdtype":
                break;
              case "filteron":
                break;
              case "aggregate":
                break;
              case "elementtype":
                break;
              case "attributetype":
                break;
              case "schema":
              case "element":
              case "complextype":
              case "datatype":
              case "all":
              case "attribute":
              case "extends":
                break;
              case "row":
                break;
              default:
                m0 = !1;
            }
            break;
          case "smarttags":
            break;
          default:
            m0 = !1;
            break;
        }
        if (m0 || s[3].match(/!\[CDATA/))
          break;
        if (!f[f.length - 1][1])
          throw "Unrecognized tag: " + s[3] + "|" + f.join("|");
        if (f[f.length - 1][0] === /*'CustomDocumentProperties'*/
        "customdocumentproperties") {
          if (s[0].slice(-2) === "/>")
            break;
          s[1] === "/" ? Xh(L, b0, Y, a.slice(z, s.index)) : (Y = s, z = s.index + s[0].length);
          break;
        }
        if (r.WTF)
          throw "Unrecognized tag: " + s[3] + "|" + f.join("|");
    }
  var g0 = {};
  return !r.bookSheets && !r.bookProps && (g0.Sheets = l), g0.SheetNames = d, g0.Workbook = r0, g0.SSF = x1(k0), g0.Props = P, g0.Custprops = L, g0.bookType = "xlml", g0;
}
function w4(e, t) {
  switch (e5(t = t || {}), t.type || "base64") {
    case "base64":
      return x4($1(e), t);
    case "binary":
    case "buffer":
    case "file":
      return x4(e, t);
    case "array":
      return x4(w2(e), t);
  }
}
function Qh(e) {
  var t = {}, r = e.content;
  if (r.l = 28, t.AnsiUserType = r.read_shift(0, "lpstr-ansi"), t.AnsiClipboardFormat = si(r), r.length - r.l <= 4)
    return t;
  var a = r.read_shift(4);
  if (a == 0 || a > 40 || (r.l -= 4, t.Reserved1 = r.read_shift(0, "lpstr-ansi"), r.length - r.l <= 4) || (a = r.read_shift(4), a !== 1907505652) || (t.UnicodeClipboardFormat = ci(r), a = r.read_shift(4), a == 0 || a > 40))
    return t;
  r.l -= 4, t.Reserved2 = r.read_shift(0, "lpwstr");
}
var eu = [60, 1084, 2066, 2165, 2175];
function ru(e, t, r, a, n) {
  var i = a, c = [], s = r.slice(r.l, r.l + i);
  if (n && n.enc && n.enc.insitu && s.length > 0)
    switch (e) {
      case 9:
      case 521:
      case 1033:
      case 2057:
      case 47:
      case 405:
      case 225:
      case 406:
      case 312:
      case 404:
      case 10:
        break;
      case 133:
        break;
      default:
        n.enc.insitu(s);
    }
  c.push(s), r.l += i;
  for (var f = _2(r, r.l), o = k4[f], l = 0; o != null && eu.indexOf(f) > -1; )
    i = _2(r, r.l + 2), l = r.l + 4, f == 2066 ? l += 4 : (f == 2165 || f == 2175) && (l += 12), s = r.slice(l, r.l + 4 + i), c.push(s), r.l += 4 + i, o = k4[f = _2(r, r.l)];
  var d = b2(c);
  m1(d, 0);
  var u = 0;
  d.lens = [];
  for (var h = 0; h < c.length; ++h)
    d.lens.push(u), u += c[h].length;
  if (d.length < a)
    throw "XLS Record 0x" + e.toString(16) + " Truncated: " + d.length + " < " + a;
  return t.f(d, d.length, n);
}
function d2(e, t, r) {
  if (e.t !== "z" && e.XF) {
    var a = 0;
    try {
      a = e.z || e.XF.numFmtId || 0, t.cellNF && e.z == null && (e.z = k0[a]);
    } catch (i) {
      if (t.WTF)
        throw i;
    }
    if (!t || t.cellText !== !1)
      try {
        e.t === "e" ? e.w = e.w || t3[e.v] : a === 0 || a == "General" ? e.t === "n" ? (e.v | 0) === e.v ? e.w = e.v.toString(10) : e.w = z3(e.v) : e.w = K2(e.v) : e.w = X1(a, e.v, { date1904: !!r, dateNF: t && t.dateNF });
      } catch (i) {
        if (t.WTF)
          throw i;
      }
    if (t.cellDates && a && e.t == "n" && u2(k0[a] || String(a))) {
      var n = v2(e.v + (r ? 1462 : 0));
      n && (e.t = "d", e.v = new Date(Date.UTC(n.y, n.m - 1, n.d, n.H, n.M, n.S, n.u)));
    }
  }
}
function we(e, t, r) {
  return { v: e, ixfe: t, t: r };
}
function tu(e, t) {
  var r = { opts: {} }, a = {}, n = {};
  t.dense && (n["!data"] = []);
  var i = {}, c = {}, s = null, f = [], o = "", l = {}, d, u = "", h, p, v, x, m = {}, T = [], g, O, H = [], W = [], E = { Sheets: [], WBProps: { date1904: !1 }, Views: [{}] }, b = {}, I = !1, P = function(h0) {
    return h0 < 8 ? $2[h0] : h0 < 64 && W[h0 - 8] || $2[h0];
  }, L = function(h0, B0, T1) {
    var c1 = B0.XF.data;
    if (!(!c1 || !c1.patternType || !T1 || !T1.cellStyles)) {
      B0.s = {}, B0.s.patternType = c1.patternType;
      var U1;
      (U1 = Y3(P(c1.icvFore))) && (B0.s.fgColor = { rgb: U1 }), (U1 = Y3(P(c1.icvBack))) && (B0.s.bgColor = { rgb: U1 });
    }
  }, z = function(h0, B0, T1) {
    if (!(!I && S0 > 1) && !(T1.sheetRows && h0.r >= T1.sheetRows)) {
      if (T1.cellStyles && B0.XF && B0.XF.data && L(h0, B0, T1), delete B0.ixfe, delete B0.XF, d = h0, u = H0(h0), (!c || !c.s || !c.e) && (c = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } }), h0.r < c.s.r && (c.s.r = h0.r), h0.c < c.s.c && (c.s.c = h0.c), h0.r + 1 > c.e.r && (c.e.r = h0.r + 1), h0.c + 1 > c.e.c && (c.e.c = h0.c + 1), T1.cellFormula && B0.f) {
        for (var c1 = 0; c1 < T.length; ++c1)
          if (!(T[c1][0].s.c > h0.c || T[c1][0].s.r > h0.r) && !(T[c1][0].e.c < h0.c || T[c1][0].e.r < h0.r)) {
            B0.F = M0(T[c1][0]), (T[c1][0].s.c != h0.c || T[c1][0].s.r != h0.r) && delete B0.f, B0.f && (B0.f = "" + A1(T[c1][1], c, h0, K, Y));
            break;
          }
      }
      T1.dense ? (n["!data"][h0.r] || (n["!data"][h0.r] = []), n["!data"][h0.r][h0.c] = B0) : n[u] = B0;
    }
  }, Y = {
    enc: !1,
    // encrypted
    sbcch: 0,
    // cch in the preceding SupBook
    snames: [],
    // sheetnames
    sharedf: m,
    // shared formulae by address
    arrayf: T,
    // array formulae array
    rrtabid: [],
    // RRTabId
    lastuser: "",
    // Last User from WriteAccess
    biff: 8,
    // BIFF version
    codepage: 0,
    // CP from CodePage record
    winlocked: 0,
    // fLockWn from WinProtect
    cellStyles: !!t && !!t.cellStyles,
    WTF: !!t && !!t.wtf
  };
  t.password && (Y.password = t.password);
  var f0, i0 = [], p0 = [], n0 = [], v0 = [], I0 = !1, K = [];
  K.SheetNames = Y.snames, K.sharedf = Y.sharedf, K.arrayf = Y.arrayf, K.names = [], K.XTI = [];
  var T0 = 0, S0 = 0, w0 = 0, r0 = [], E0 = [], b0;
  Y.codepage = 1200, o2(1200);
  for (var D0 = !1; e.l < e.length - 1; ) {
    var F = e.l, B = e.read_shift(2);
    if (B === 0 && T0 === 10)
      break;
    var R = e.l === e.length ? 0 : e.read_shift(2), D = k4[B];
    if (S0 == 0 && [9, 521, 1033, 2057].indexOf(B) == -1)
      break;
    if (D && D.f) {
      if (t.bookSheets && T0 === 133 && B !== 133)
        break;
      if (T0 = B, D.r === 2 || D.r == 12) {
        var Z = e.read_shift(2);
        if (R -= 2, !Y.enc && Z !== B && ((Z & 255) << 8 | Z >> 8) !== B)
          throw new Error("rt mismatch: " + Z + "!=" + B);
        D.r == 12 && (e.l += 10, R -= 10);
      }
      var A = {};
      if (B === 10 ? A = /*::(*/
      D.f(e, R, Y) : A = /*::(*/
      ru(B, D, e, R, Y), S0 == 0 && [9, 521, 1033, 2057].indexOf(T0) === -1)
        continue;
      switch (B) {
        case 34:
          r.opts.Date1904 = E.WBProps.date1904 = A;
          break;
        case 134:
          r.opts.WriteProtect = !0;
          break;
        case 47:
          if (Y.enc || (e.l = 0), Y.enc = A, !t.password)
            throw new Error("File is password-protected");
          if (A.valid == null)
            throw new Error("Encryption scheme unsupported");
          if (!A.valid)
            throw new Error("Password is incorrect");
          break;
        case 92:
          Y.lastuser = A;
          break;
        case 66:
          var Q = Number(A);
          switch (Q) {
            case 21010:
              Q = 1200;
              break;
            case 32768:
              Q = 1e4;
              break;
            case 32769:
              Q = 1252;
              break;
          }
          o2(Y.codepage = Q), D0 = !0;
          break;
        case 317:
          Y.rrtabid = A;
          break;
        case 25:
          Y.winlocked = A;
          break;
        case 439:
          r.opts.RefreshAll = A;
          break;
        case 12:
          r.opts.CalcCount = A;
          break;
        case 16:
          r.opts.CalcDelta = A;
          break;
        case 17:
          r.opts.CalcIter = A;
          break;
        case 13:
          r.opts.CalcMode = A;
          break;
        case 14:
          r.opts.CalcPrecision = A;
          break;
        case 95:
          r.opts.CalcSaveRecalc = A;
          break;
        case 15:
          Y.CalcRefMode = A;
          break;
        case 2211:
          r.opts.FullCalc = A;
          break;
        case 129:
          A.fDialog && (n["!type"] = "dialog"), A.fBelow || ((n["!outline"] || (n["!outline"] = {})).above = !0), A.fRight || ((n["!outline"] || (n["!outline"] = {})).left = !0);
          break;
        case 67:
        case 579:
        case 1091:
        case 224:
          H.push(A);
          break;
        case 430:
          K.push([A]), K[K.length - 1].XTI = [];
          break;
        case 35:
        case 547:
          K[K.length - 1].push(A);
          break;
        case 24:
        case 536:
          b0 = {
            Name: A.Name,
            Ref: A1(A.rgce, c, null, K, Y)
          }, A.itab > 0 && (b0.Sheet = A.itab - 1), K.names.push(b0), K[0] || (K[0] = [], K[0].XTI = []), K[K.length - 1].push(A), A.Name == "_xlnm._FilterDatabase" && A.itab > 0 && A.rgce && A.rgce[0] && A.rgce[0][0] && A.rgce[0][0][0] == "PtgArea3d" && (E0[A.itab - 1] = { ref: M0(A.rgce[0][0][1][2]) });
          break;
        case 22:
          Y.ExternCount = A;
          break;
        case 23:
          K.length == 0 && (K[0] = [], K[0].XTI = []), K[K.length - 1].XTI = K[K.length - 1].XTI.concat(A), K.XTI = K.XTI.concat(A);
          break;
        case 2196:
          if (Y.biff < 8)
            break;
          b0 != null && (b0.Comment = A[1]);
          break;
        case 18:
          n["!protect"] = A;
          break;
        case 19:
          A !== 0 && Y.WTF && console.error("Password verifier: " + A);
          break;
        case 133:
          i[Y.biff == 4 ? Y.snames.length : A.pos] = A, Y.snames.push(A.name);
          break;
        case 10:
          {
            if (--S0 ? !I : I)
              break;
            if (c.e) {
              if (c.e.r > 0 && c.e.c > 0) {
                if (c.e.r--, c.e.c--, n["!ref"] = M0(c), t.sheetRows && t.sheetRows <= c.e.r) {
                  var m0 = c.e.r;
                  c.e.r = t.sheetRows - 1, n["!fullref"] = n["!ref"], n["!ref"] = M0(c), c.e.r = m0;
                }
                c.e.r++, c.e.c++;
              }
              i0.length > 0 && (n["!merges"] = i0), p0.length > 0 && (n["!objects"] = p0), n0.length > 0 && (n["!cols"] = n0), v0.length > 0 && (n["!rows"] = v0), E.Sheets.push(b);
            }
            o === "" ? l = n : a[o] = n, n = {}, t.dense && (n["!data"] = []);
          }
          break;
        case 9:
        case 521:
        case 1033:
        case 2057:
          {
            if (Y.biff === 8 && (Y.biff = {
              /*::[*/
              9: 2,
              /*::[*/
              521: 3,
              /*::[*/
              1033: 4
            }[B] || {
              /*::[*/
              512: 2,
              /*::[*/
              768: 3,
              /*::[*/
              1024: 4,
              /*::[*/
              1280: 5,
              /*::[*/
              1536: 8,
              /*::[*/
              2: 2,
              /*::[*/
              7: 2
            }[A.BIFFVer] || 8), Y.biffguess = A.BIFFVer == 0, A.BIFFVer == 0 && A.dt == 4096 && (Y.biff = 5, D0 = !0, o2(Y.codepage = 28591)), Y.biff == 4 && A.dt & 256 && (I = !0), Y.biff == 8 && A.BIFFVer == 0 && A.dt == 16 && (Y.biff = 2), S0++ && !I)
              break;
            if (n = {}, t.dense && (n["!data"] = []), Y.biff < 8 && !D0 && (D0 = !0, o2(Y.codepage = t.codepage || 1252)), Y.biff == 4 && I)
              o = (i[Y.snames.indexOf(o) + 1] || { name: "" }).name;
            else if (Y.biff < 5 || A.BIFFVer == 0 && A.dt == 4096) {
              o === "" && (o = "Sheet1"), c = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } };
              var a0 = { pos: e.l - R, name: o };
              i[a0.pos] = a0, Y.snames.push(o);
            } else
              o = (i[F] || { name: "" }).name;
            A.dt == 32 && (n["!type"] = "chart"), A.dt == 64 && (n["!type"] = "macro"), i0 = [], p0 = [], Y.arrayf = T = [], n0 = [], v0 = [], I0 = !1, b = { Hidden: (i[F] || { hs: 0 }).hs, name: o };
          }
          break;
        case 515:
        case 3:
        case 2:
          n["!type"] == "chart" && (t.dense ? (n["!data"][A.r] || [])[A.c] : n[W0(A.c) + j0(A.r)]) && ++A.c, g = { ixfe: A.ixfe, XF: H[A.ixfe] || {}, v: A.val, t: "n" }, w0 > 0 && (g.z = g.XF && g.XF.numFmtId && r0[g.XF.numFmtId] || r0[g.ixfe >> 8 & 63]), d2(g, t, r.opts.Date1904), z({ c: A.c, r: A.r }, g, t);
          break;
        case 5:
        case 517:
          g = { ixfe: A.ixfe, XF: H[A.ixfe], v: A.val, t: A.t }, w0 > 0 && (g.z = g.XF && g.XF.numFmtId && r0[g.XF.numFmtId] || r0[g.ixfe >> 8 & 63]), d2(g, t, r.opts.Date1904), z({ c: A.c, r: A.r }, g, t);
          break;
        case 638:
          g = { ixfe: A.ixfe, XF: H[A.ixfe], v: A.rknum, t: "n" }, w0 > 0 && (g.z = g.XF && g.XF.numFmtId && r0[g.XF.numFmtId] || r0[g.ixfe >> 8 & 63]), d2(g, t, r.opts.Date1904), z({ c: A.c, r: A.r }, g, t);
          break;
        case 189:
          for (var g0 = A.c; g0 <= A.C; ++g0) {
            var _0 = A.rkrec[g0 - A.c][0];
            g = { ixfe: _0, XF: H[_0], v: A.rkrec[g0 - A.c][1], t: "n" }, w0 > 0 && (g.z = g.XF && g.XF.numFmtId && r0[g.XF.numFmtId] || r0[g.ixfe >> 8 & 63]), d2(g, t, r.opts.Date1904), z({ c: g0, r: A.r }, g, t);
          }
          break;
        case 6:
        case 518:
        case 1030:
          {
            if (A.val == "String") {
              s = A;
              break;
            }
            if (g = we(A.val, A.cell.ixfe, A.tt), g.XF = H[g.ixfe], t.cellFormula) {
              var A0 = A.formula;
              if (A0 && A0[0] && A0[0][0] && A0[0][0][0] == "PtgExp") {
                var V0 = A0[0][0][1][0], J0 = A0[0][0][1][1], s1 = H0({ r: V0, c: J0 });
                m[s1] ? g.f = "" + A1(A.formula, c, A.cell, K, Y) : g.F = ((t.dense ? (n["!data"][V0] || [])[J0] : n[s1]) || {}).F;
              } else
                g.f = "" + A1(A.formula, c, A.cell, K, Y);
            }
            w0 > 0 && (g.z = g.XF && g.XF.numFmtId && r0[g.XF.numFmtId] || r0[g.ixfe >> 8 & 63]), d2(g, t, r.opts.Date1904), z(A.cell, g, t), s = A;
          }
          break;
        case 7:
        case 519:
          if (s)
            s.val = A, g = we(A, s.cell.ixfe, "s"), g.XF = H[g.ixfe], t.cellFormula && (g.f = "" + A1(s.formula, c, s.cell, K, Y)), w0 > 0 && (g.z = g.XF && g.XF.numFmtId && r0[g.XF.numFmtId] || r0[g.ixfe >> 8 & 63]), d2(g, t, r.opts.Date1904), z(s.cell, g, t), s = null;
          else
            throw new Error("String record expects Formula");
          break;
        case 33:
        case 545:
          {
            T.push(A);
            var d0 = H0(A[0].s);
            if (h = t.dense ? (n["!data"][A[0].s.r] || [])[A[0].s.c] : n[d0], t.cellFormula && h) {
              if (!s || !d0 || !h)
                break;
              h.f = "" + A1(A[1], c, A[0], K, Y), h.F = M0(A[0]);
            }
          }
          break;
        case 1212:
          {
            if (!t.cellFormula)
              break;
            if (u) {
              if (!s)
                break;
              m[H0(s.cell)] = A[0], h = t.dense ? (n["!data"][s.cell.r] || [])[s.cell.c] : n[H0(s.cell)], (h || {}).f = "" + A1(A[0], c, d, K, Y);
            }
          }
          break;
        case 253:
          g = we(f[A.isst].t, A.ixfe, "s"), f[A.isst].h && (g.h = f[A.isst].h), g.XF = H[g.ixfe], w0 > 0 && (g.z = g.XF && g.XF.numFmtId && r0[g.XF.numFmtId] || r0[g.ixfe >> 8 & 63]), d2(g, t, r.opts.Date1904), z({ c: A.c, r: A.r }, g, t);
          break;
        case 513:
          t.sheetStubs && (g = { ixfe: A.ixfe, XF: H[A.ixfe], t: "z" }, w0 > 0 && (g.z = g.XF && g.XF.numFmtId && r0[g.XF.numFmtId] || r0[g.ixfe >> 8 & 63]), d2(g, t, r.opts.Date1904), z({ c: A.c, r: A.r }, g, t));
          break;
        case 190:
          if (t.sheetStubs)
            for (var N0 = A.c; N0 <= A.C; ++N0) {
              var o0 = A.ixfe[N0 - A.c];
              g = { ixfe: o0, XF: H[o0], t: "z" }, w0 > 0 && (g.z = g.XF && g.XF.numFmtId && r0[g.XF.numFmtId] || r0[g.ixfe >> 8 & 63]), d2(g, t, r.opts.Date1904), z({ c: N0, r: A.r }, g, t);
            }
          break;
        case 214:
        case 516:
        case 4:
          g = we(A.val, A.ixfe, "s"), g.XF = H[g.ixfe], w0 > 0 && (g.z = g.XF && g.XF.numFmtId && r0[g.XF.numFmtId] || r0[g.ixfe >> 8 & 63]), d2(g, t, r.opts.Date1904), z({ c: A.c, r: A.r }, g, t);
          break;
        case 0:
        case 512:
          S0 === 1 && (c = A);
          break;
        case 252:
          f = A;
          break;
        case 1054:
          if (Y.biff >= 3 && Y.biff <= 4) {
            r0[w0++] = A[1];
            for (var W1 = 0; W1 < w0 + 163 && k0[W1] != A[1]; ++W1)
              ;
            W1 >= 163 && z2(A[1], w0 + 163);
          } else
            z2(A[1], A[0]);
          break;
        case 30:
          {
            r0[w0++] = A;
            for (var D1 = 0; D1 < w0 + 163 && k0[D1] != A; ++D1)
              ;
            D1 >= 163 && z2(A, w0 + 163);
          }
          break;
        case 229:
          i0 = i0.concat(A);
          break;
        case 93:
          p0[A.cmo[0]] = Y.lastobj = A;
          break;
        case 438:
          Y.lastobj.TxO = A;
          break;
        case 127:
          Y.lastobj.ImData = A;
          break;
        case 440:
          for (x = A[0].s.r; x <= A[0].e.r; ++x)
            for (v = A[0].s.c; v <= A[0].e.c; ++v)
              h = t.dense ? (n["!data"][x] || [])[v] : n[H0({ c: v, r: x })], h && (h.l = A[1]);
          break;
        case 2048:
          for (x = A[0].s.r; x <= A[0].e.r; ++x)
            for (v = A[0].s.c; v <= A[0].e.c; ++v)
              h = t.dense ? (n["!data"][x] || [])[v] : n[H0({ c: v, r: x })], h && h.l && (h.l.Tooltip = A[1]);
          break;
        case 28:
          {
            if (h = t.dense ? (n["!data"][A[0].r] || [])[A[0].c] : n[H0(A[0])], h || (t.dense ? (n["!data"][A[0].r] || (n["!data"][A[0].r] = []), h = n["!data"][A[0].r][A[0].c] = { t: "z" }) : h = n[H0(A[0])] = { t: "z" }, c.e.r = Math.max(c.e.r, A[0].r), c.s.r = Math.min(c.s.r, A[0].r), c.e.c = Math.max(c.e.c, A[0].c), c.s.c = Math.min(c.s.c, A[0].c)), h.c || (h.c = []), Y.biff <= 5 && Y.biff >= 2)
              p = { a: "SheetJ5", t: A[1] };
            else {
              var q0 = p0[A[2]];
              p = { a: A[1], t: q0.TxO.t }, A[3] != null && !(A[3] & 2) && (h.c.hidden = !0);
            }
            h.c.push(p);
          }
          break;
        case 2173:
          wf(H[A.ixfe], A.ext);
          break;
        case 125:
          {
            if (!Y.cellStyles)
              break;
            for (; A.e >= A.s; )
              n0[A.e--] = { width: A.w / 256, level: A.level || 0, hidden: !!(A.flags & 1) }, I0 || (I0 = !0, Y4(A.w / 256)), m3(n0[A.e + 1]);
          }
          break;
        case 520:
          {
            var i2 = {};
            A.level != null && (v0[A.r] = i2, i2.level = A.level), A.hidden && (v0[A.r] = i2, i2.hidden = !0), A.hpt && (v0[A.r] = i2, i2.hpt = A.hpt, i2.hpx = J3(A.hpt));
          }
          break;
        case 38:
        case 39:
        case 40:
        case 41:
          n["!margins"] || H3(n["!margins"] = {}), n["!margins"][{ 38: "left", 39: "right", 40: "top", 41: "bottom" }[B]] = A;
          break;
        case 161:
          n["!margins"] || H3(n["!margins"] = {}), n["!margins"].header = A.header, n["!margins"].footer = A.footer;
          break;
        case 574:
          A.RTL && (E.Views[0].RTL = !0);
          break;
        case 146:
          W = A;
          break;
        case 2198:
          f0 = A;
          break;
        case 140:
          O = A;
          break;
        case 442:
          o ? b.CodeName = A || b.name : E.WBProps.CodeName = A || "ThisWorkbook";
          break;
      }
    } else
      D || console.error("Missing Info for XLS Record 0x" + B.toString(16)), e.l += R;
  }
  return r.SheetNames = t2(i).sort(function(B1, h0) {
    return Number(B1) - Number(h0);
  }).map(function(B1) {
    return i[B1].name;
  }), t.bookSheets || (r.Sheets = a), !r.SheetNames.length && l["!ref"] ? (r.SheetNames.push("Sheet1"), r.Sheets && (r.Sheets.Sheet1 = l)) : r.Preamble = l, r.Sheets && E0.forEach(function(B1, h0) {
    r.Sheets[r.SheetNames[h0]]["!autofilter"] = B1;
  }), r.Strings = f, r.SSF = x1(k0), Y.enc && (r.Encryption = Y.enc), f0 && (r.Themes = f0), r.Metadata = {}, O !== void 0 && (r.Metadata.Country = O), K.names.length > 0 && (E.Names = K.names), r.Workbook = E, r;
}
var gr = {
  SI: "e0859ff2f94f6810ab9108002b27b3d9",
  DSI: "02d5cdd59c2e1b10939708002b2cf9ae",
  UDI: "05d5cdd59c2e1b10939708002b2cf9ae"
};
function au(e, t, r) {
  var a = L0.find(e, "/!DocumentSummaryInformation");
  if (a && a.size > 0)
    try {
      var n = er(a, xi, gr.DSI);
      for (var i in n)
        t[i] = n[i];
    } catch (o) {
      if (r.WTF)
        throw o;
    }
  var c = L0.find(e, "/!SummaryInformation");
  if (c && c.size > 0)
    try {
      var s = er(c, di, gr.SI);
      for (var f in s)
        t[f] == null && (t[f] = s[f]);
    } catch (o) {
      if (r.WTF)
        throw o;
    }
  t.HeadingPairs && t.TitlesOfParts && (u7(t.HeadingPairs, t.TitlesOfParts, t, r), delete t.HeadingPairs, delete t.TitlesOfParts);
}
function Y7(e, t) {
  t || (t = {}), e5(t), S6(), t.codepage && P4(t.codepage);
  var r, a;
  if (e.FullPaths) {
    if (L0.find(e, "/encryption"))
      throw new Error("File is password-protected");
    r = L0.find(e, "!CompObj"), a = L0.find(e, "/Workbook") || L0.find(e, "/Book");
  } else {
    switch (t.type) {
      case "base64":
        e = G1($1(e));
        break;
      case "binary":
        e = G1(e);
        break;
      case "buffer":
        break;
      case "array":
        Array.isArray(e) || (e = Array.prototype.slice.call(e));
        break;
    }
    m1(e, 0), a = { content: e };
  }
  var n, i;
  if (r && Qh(r), t.bookProps && !t.bookSheets)
    n = {};
  else {
    var c = O0 ? "buffer" : "array";
    if (a && a.content)
      n = tu(a.content, t);
    else if ((i = L0.find(e, "PerfectOffice_MAIN")) && i.content)
      n = B3.to_workbook(i.content, (t.type = c, t));
    else if ((i = L0.find(e, "NativeContent_MAIN")) && i.content)
      n = B3.to_workbook(i.content, (t.type = c, t));
    else
      throw (i = L0.find(e, "MN0")) && i.content ? new Error("Unsupported Works 4 for Mac file") : new Error("Cannot find Workbook stream");
    t.bookVBA && e.FullPaths && L0.find(e, "/_VBA_PROJECT_CUR/VBA/dir") && (n.vbaraw = Vf(e));
  }
  var s = {};
  return e.FullPaths && au(
    /*::((*/
    e,
    s,
    t
  ), n.Props = n.Custprops = s, t.bookFiles && (n.cfb = e), n;
}
var Pe = {
  /*::[*/
  0: {
    /* n:"BrtRowHdr", */
    f: Bl
  },
  /*::[*/
  1: {
    /* n:"BrtCellBlank", */
    f: Vl
  },
  /*::[*/
  2: {
    /* n:"BrtCellRk", */
    f: ql
  },
  /*::[*/
  3: {
    /* n:"BrtCellError", */
    f: $l
  },
  /*::[*/
  4: {
    /* n:"BrtCellBool", */
    f: jl
  },
  /*::[*/
  5: {
    /* n:"BrtCellReal", */
    f: Jl
  },
  /*::[*/
  6: {
    /* n:"BrtCellSt", */
    f: eh
  },
  /*::[*/
  7: {
    /* n:"BrtCellIsst", */
    f: Kl
  },
  /*::[*/
  8: {
    /* n:"BrtFmlaString", */
    f: ih
  },
  /*::[*/
  9: {
    /* n:"BrtFmlaNum", */
    f: nh
  },
  /*::[*/
  10: {
    /* n:"BrtFmlaBool", */
    f: th
  },
  /*::[*/
  11: {
    /* n:"BrtFmlaError", */
    f: ah
  },
  /*::[*/
  12: {
    /* n:"BrtShortBlank", */
    f: Gl
  },
  /*::[*/
  13: {
    /* n:"BrtShortRk", */
    f: Zl
  },
  /*::[*/
  14: {
    /* n:"BrtShortError", */
    f: Xl
  },
  /*::[*/
  15: {
    /* n:"BrtShortBool", */
    f: zl
  },
  /*::[*/
  16: {
    /* n:"BrtShortReal", */
    f: j7
  },
  /*::[*/
  17: {
    /* n:"BrtShortSt", */
    f: rh
  },
  /*::[*/
  18: {
    /* n:"BrtShortIsst", */
    f: Yl
  },
  /*::[*/
  19: {
    /* n:"BrtSSTItem", */
    f: z4
  },
  /*::[*/
  20: {
    /* n:"BrtPCDIMissing" */
  },
  /*::[*/
  21: {
    /* n:"BrtPCDINumber" */
  },
  /*::[*/
  22: {
    /* n:"BrtPCDIBoolean" */
  },
  /*::[*/
  23: {
    /* n:"BrtPCDIError" */
  },
  /*::[*/
  24: {
    /* n:"BrtPCDIString" */
  },
  /*::[*/
  25: {
    /* n:"BrtPCDIDatetime" */
  },
  /*::[*/
  26: {
    /* n:"BrtPCDIIndex" */
  },
  /*::[*/
  27: {
    /* n:"BrtPCDIAMissing" */
  },
  /*::[*/
  28: {
    /* n:"BrtPCDIANumber" */
  },
  /*::[*/
  29: {
    /* n:"BrtPCDIABoolean" */
  },
  /*::[*/
  30: {
    /* n:"BrtPCDIAError" */
  },
  /*::[*/
  31: {
    /* n:"BrtPCDIAString" */
  },
  /*::[*/
  32: {
    /* n:"BrtPCDIADatetime" */
  },
  /*::[*/
  33: {
    /* n:"BrtPCRRecord" */
  },
  /*::[*/
  34: {
    /* n:"BrtPCRRecordDt" */
  },
  /*::[*/
  35: {
    /* n:"BrtFRTBegin", */
    T: 1
  },
  /*::[*/
  36: {
    /* n:"BrtFRTEnd", */
    T: -1
  },
  /*::[*/
  37: {
    /* n:"BrtACBegin", */
    T: 1
  },
  /*::[*/
  38: {
    /* n:"BrtACEnd", */
    T: -1
  },
  /*::[*/
  39: {
    /* n:"BrtName", */
    f: Oh
  },
  /*::[*/
  40: {
    /* n:"BrtIndexRowBlock" */
  },
  /*::[*/
  42: {
    /* n:"BrtIndexBlock" */
  },
  /*::[*/
  43: {
    /* n:"BrtFont", */
    f: Qc
  },
  /*::[*/
  44: {
    /* n:"BrtFmt", */
    f: Zc
  },
  /*::[*/
  45: {
    /* n:"BrtFill", */
    f: ef
  },
  /*::[*/
  46: {
    /* n:"BrtBorder", */
    f: tf
  },
  /*::[*/
  47: {
    /* n:"BrtXF", */
    f: rf
  },
  /*::[*/
  48: {
    /* n:"BrtStyle" */
  },
  /*::[*/
  49: {
    /* n:"BrtCellMeta", */
    f: Qn
  },
  /*::[*/
  50: {
    /* n:"BrtValueMeta" */
  },
  /*::[*/
  51: {
    /* n:"BrtMdb" */
    f: Cf
  },
  /*::[*/
  52: {
    /* n:"BrtBeginFmd", */
    T: 1
  },
  /*::[*/
  53: {
    /* n:"BrtEndFmd", */
    T: -1
  },
  /*::[*/
  54: {
    /* n:"BrtBeginMdx", */
    T: 1
  },
  /*::[*/
  55: {
    /* n:"BrtEndMdx", */
    T: -1
  },
  /*::[*/
  56: {
    /* n:"BrtBeginMdxTuple", */
    T: 1
  },
  /*::[*/
  57: {
    /* n:"BrtEndMdxTuple", */
    T: -1
  },
  /*::[*/
  58: {
    /* n:"BrtMdxMbrIstr" */
  },
  /*::[*/
  59: {
    /* n:"BrtStr" */
  },
  /*::[*/
  60: {
    /* n:"BrtColInfo", */
    f: S7
  },
  /*::[*/
  62: {
    /* n:"BrtCellRString", */
    f: Ql
  },
  /*::[*/
  63: {
    /* n:"BrtCalcChainItem$", */
    f: If
  },
  /*::[*/
  64: {
    /* n:"BrtDVal", */
    f: dh
  },
  /*::[*/
  65: {
    /* n:"BrtSxvcellNum" */
  },
  /*::[*/
  66: {
    /* n:"BrtSxvcellStr" */
  },
  /*::[*/
  67: {
    /* n:"BrtSxvcellBool" */
  },
  /*::[*/
  68: {
    /* n:"BrtSxvcellErr" */
  },
  /*::[*/
  69: {
    /* n:"BrtSxvcellDate" */
  },
  /*::[*/
  70: {
    /* n:"BrtSxvcellNil" */
  },
  /*::[*/
  128: {
    /* n:"BrtFileVersion" */
  },
  /*::[*/
  129: {
    /* n:"BrtBeginSheet", */
    T: 1
  },
  /*::[*/
  130: {
    /* n:"BrtEndSheet", */
    T: -1
  },
  /*::[*/
  131: {
    /* n:"BrtBeginBook", */
    T: 1,
    f: b1,
    p: 0
  },
  /*::[*/
  132: {
    /* n:"BrtEndBook", */
    T: -1
  },
  /*::[*/
  133: {
    /* n:"BrtBeginWsViews", */
    T: 1
  },
  /*::[*/
  134: {
    /* n:"BrtEndWsViews", */
    T: -1
  },
  /*::[*/
  135: {
    /* n:"BrtBeginBookViews", */
    T: 1
  },
  /*::[*/
  136: {
    /* n:"BrtEndBookViews", */
    T: -1
  },
  /*::[*/
  137: {
    /* n:"BrtBeginWsView", */
    T: 1,
    f: xh
  },
  /*::[*/
  138: {
    /* n:"BrtEndWsView", */
    T: -1
  },
  /*::[*/
  139: {
    /* n:"BrtBeginCsViews", */
    T: 1
  },
  /*::[*/
  140: {
    /* n:"BrtEndCsViews", */
    T: -1
  },
  /*::[*/
  141: {
    /* n:"BrtBeginCsView", */
    T: 1
  },
  /*::[*/
  142: {
    /* n:"BrtEndCsView", */
    T: -1
  },
  /*::[*/
  143: {
    /* n:"BrtBeginBundleShs", */
    T: 1
  },
  /*::[*/
  144: {
    /* n:"BrtEndBundleShs", */
    T: -1
  },
  /*::[*/
  145: {
    /* n:"BrtBeginSheetData", */
    T: 1
  },
  /*::[*/
  146: {
    /* n:"BrtEndSheetData", */
    T: -1
  },
  /*::[*/
  147: {
    /* n:"BrtWsProp", */
    f: Wl
  },
  /*::[*/
  148: {
    /* n:"BrtWsDim", */
    f: Ul,
    p: 16
  },
  /*::[*/
  151: {
    /* n:"BrtPane", */
    f: fh
  },
  /*::[*/
  152: {
    /* n:"BrtSel" */
  },
  /*::[*/
  153: {
    /* n:"BrtWbProp", */
    f: bh
  },
  /*::[*/
  154: {
    /* n:"BrtWbFactoid" */
  },
  /*::[*/
  155: {
    /* n:"BrtFileRecover" */
  },
  /*::[*/
  156: {
    /* n:"BrtBundleSh", */
    f: Ih
  },
  /*::[*/
  157: {
    /* n:"BrtCalcProp" */
  },
  /*::[*/
  158: {
    /* n:"BrtBookView" */
  },
  /*::[*/
  159: {
    /* n:"BrtBeginSst", */
    T: 1,
    f: vc
  },
  /*::[*/
  160: {
    /* n:"BrtEndSst", */
    T: -1
  },
  /*::[*/
  161: {
    /* n:"BrtBeginAFilter", */
    T: 1,
    f: r3
  },
  /*::[*/
  162: {
    /* n:"BrtEndAFilter", */
    T: -1
  },
  /*::[*/
  163: {
    /* n:"BrtBeginFilterColumn", */
    T: 1
  },
  /*::[*/
  164: {
    /* n:"BrtEndFilterColumn", */
    T: -1
  },
  /*::[*/
  165: {
    /* n:"BrtBeginFilters", */
    T: 1
  },
  /*::[*/
  166: {
    /* n:"BrtEndFilters", */
    T: -1
  },
  /*::[*/
  167: {
    /* n:"BrtFilter" */
  },
  /*::[*/
  168: {
    /* n:"BrtColorFilter" */
  },
  /*::[*/
  169: {
    /* n:"BrtIconFilter" */
  },
  /*::[*/
  170: {
    /* n:"BrtTop10Filter" */
  },
  /*::[*/
  171: {
    /* n:"BrtDynamicFilter" */
  },
  /*::[*/
  172: {
    /* n:"BrtBeginCustomFilters", */
    T: 1
  },
  /*::[*/
  173: {
    /* n:"BrtEndCustomFilters", */
    T: -1
  },
  /*::[*/
  174: {
    /* n:"BrtCustomFilter" */
  },
  /*::[*/
  175: {
    /* n:"BrtAFilterDateGroupItem" */
  },
  /*::[*/
  176: {
    /* n:"BrtMergeCell", */
    f: sh
  },
  /*::[*/
  177: {
    /* n:"BrtBeginMergeCells", */
    T: 1
  },
  /*::[*/
  178: {
    /* n:"BrtEndMergeCells", */
    T: -1
  },
  /*::[*/
  179: {
    /* n:"BrtBeginPivotCacheDef", */
    T: 1
  },
  /*::[*/
  180: {
    /* n:"BrtEndPivotCacheDef", */
    T: -1
  },
  /*::[*/
  181: {
    /* n:"BrtBeginPCDFields", */
    T: 1
  },
  /*::[*/
  182: {
    /* n:"BrtEndPCDFields", */
    T: -1
  },
  /*::[*/
  183: {
    /* n:"BrtBeginPCDField", */
    T: 1
  },
  /*::[*/
  184: {
    /* n:"BrtEndPCDField", */
    T: -1
  },
  /*::[*/
  185: {
    /* n:"BrtBeginPCDSource", */
    T: 1
  },
  /*::[*/
  186: {
    /* n:"BrtEndPCDSource", */
    T: -1
  },
  /*::[*/
  187: {
    /* n:"BrtBeginPCDSRange", */
    T: 1
  },
  /*::[*/
  188: {
    /* n:"BrtEndPCDSRange", */
    T: -1
  },
  /*::[*/
  189: {
    /* n:"BrtBeginPCDFAtbl", */
    T: 1
  },
  /*::[*/
  190: {
    /* n:"BrtEndPCDFAtbl", */
    T: -1
  },
  /*::[*/
  191: {
    /* n:"BrtBeginPCDIRun", */
    T: 1
  },
  /*::[*/
  192: {
    /* n:"BrtEndPCDIRun", */
    T: -1
  },
  /*::[*/
  193: {
    /* n:"BrtBeginPivotCacheRecords", */
    T: 1
  },
  /*::[*/
  194: {
    /* n:"BrtEndPivotCacheRecords", */
    T: -1
  },
  /*::[*/
  195: {
    /* n:"BrtBeginPCDHierarchies", */
    T: 1
  },
  /*::[*/
  196: {
    /* n:"BrtEndPCDHierarchies", */
    T: -1
  },
  /*::[*/
  197: {
    /* n:"BrtBeginPCDHierarchy", */
    T: 1
  },
  /*::[*/
  198: {
    /* n:"BrtEndPCDHierarchy", */
    T: -1
  },
  /*::[*/
  199: {
    /* n:"BrtBeginPCDHFieldsUsage", */
    T: 1
  },
  /*::[*/
  200: {
    /* n:"BrtEndPCDHFieldsUsage", */
    T: -1
  },
  /*::[*/
  201: {
    /* n:"BrtBeginExtConnection", */
    T: 1
  },
  /*::[*/
  202: {
    /* n:"BrtEndExtConnection", */
    T: -1
  },
  /*::[*/
  203: {
    /* n:"BrtBeginECDbProps", */
    T: 1
  },
  /*::[*/
  204: {
    /* n:"BrtEndECDbProps", */
    T: -1
  },
  /*::[*/
  205: {
    /* n:"BrtBeginECOlapProps", */
    T: 1
  },
  /*::[*/
  206: {
    /* n:"BrtEndECOlapProps", */
    T: -1
  },
  /*::[*/
  207: {
    /* n:"BrtBeginPCDSConsol", */
    T: 1
  },
  /*::[*/
  208: {
    /* n:"BrtEndPCDSConsol", */
    T: -1
  },
  /*::[*/
  209: {
    /* n:"BrtBeginPCDSCPages", */
    T: 1
  },
  /*::[*/
  210: {
    /* n:"BrtEndPCDSCPages", */
    T: -1
  },
  /*::[*/
  211: {
    /* n:"BrtBeginPCDSCPage", */
    T: 1
  },
  /*::[*/
  212: {
    /* n:"BrtEndPCDSCPage", */
    T: -1
  },
  /*::[*/
  213: {
    /* n:"BrtBeginPCDSCPItem", */
    T: 1
  },
  /*::[*/
  214: {
    /* n:"BrtEndPCDSCPItem", */
    T: -1
  },
  /*::[*/
  215: {
    /* n:"BrtBeginPCDSCSets", */
    T: 1
  },
  /*::[*/
  216: {
    /* n:"BrtEndPCDSCSets", */
    T: -1
  },
  /*::[*/
  217: {
    /* n:"BrtBeginPCDSCSet", */
    T: 1
  },
  /*::[*/
  218: {
    /* n:"BrtEndPCDSCSet", */
    T: -1
  },
  /*::[*/
  219: {
    /* n:"BrtBeginPCDFGroup", */
    T: 1
  },
  /*::[*/
  220: {
    /* n:"BrtEndPCDFGroup", */
    T: -1
  },
  /*::[*/
  221: {
    /* n:"BrtBeginPCDFGItems", */
    T: 1
  },
  /*::[*/
  222: {
    /* n:"BrtEndPCDFGItems", */
    T: -1
  },
  /*::[*/
  223: {
    /* n:"BrtBeginPCDFGRange", */
    T: 1
  },
  /*::[*/
  224: {
    /* n:"BrtEndPCDFGRange", */
    T: -1
  },
  /*::[*/
  225: {
    /* n:"BrtBeginPCDFGDiscrete", */
    T: 1
  },
  /*::[*/
  226: {
    /* n:"BrtEndPCDFGDiscrete", */
    T: -1
  },
  /*::[*/
  227: {
    /* n:"BrtBeginPCDSDTupleCache", */
    T: 1
  },
  /*::[*/
  228: {
    /* n:"BrtEndPCDSDTupleCache", */
    T: -1
  },
  /*::[*/
  229: {
    /* n:"BrtBeginPCDSDTCEntries", */
    T: 1
  },
  /*::[*/
  230: {
    /* n:"BrtEndPCDSDTCEntries", */
    T: -1
  },
  /*::[*/
  231: {
    /* n:"BrtBeginPCDSDTCEMembers", */
    T: 1
  },
  /*::[*/
  232: {
    /* n:"BrtEndPCDSDTCEMembers", */
    T: -1
  },
  /*::[*/
  233: {
    /* n:"BrtBeginPCDSDTCEMember", */
    T: 1
  },
  /*::[*/
  234: {
    /* n:"BrtEndPCDSDTCEMember", */
    T: -1
  },
  /*::[*/
  235: {
    /* n:"BrtBeginPCDSDTCQueries", */
    T: 1
  },
  /*::[*/
  236: {
    /* n:"BrtEndPCDSDTCQueries", */
    T: -1
  },
  /*::[*/
  237: {
    /* n:"BrtBeginPCDSDTCQuery", */
    T: 1
  },
  /*::[*/
  238: {
    /* n:"BrtEndPCDSDTCQuery", */
    T: -1
  },
  /*::[*/
  239: {
    /* n:"BrtBeginPCDSDTCSets", */
    T: 1
  },
  /*::[*/
  240: {
    /* n:"BrtEndPCDSDTCSets", */
    T: -1
  },
  /*::[*/
  241: {
    /* n:"BrtBeginPCDSDTCSet", */
    T: 1
  },
  /*::[*/
  242: {
    /* n:"BrtEndPCDSDTCSet", */
    T: -1
  },
  /*::[*/
  243: {
    /* n:"BrtBeginPCDCalcItems", */
    T: 1
  },
  /*::[*/
  244: {
    /* n:"BrtEndPCDCalcItems", */
    T: -1
  },
  /*::[*/
  245: {
    /* n:"BrtBeginPCDCalcItem", */
    T: 1
  },
  /*::[*/
  246: {
    /* n:"BrtEndPCDCalcItem", */
    T: -1
  },
  /*::[*/
  247: {
    /* n:"BrtBeginPRule", */
    T: 1
  },
  /*::[*/
  248: {
    /* n:"BrtEndPRule", */
    T: -1
  },
  /*::[*/
  249: {
    /* n:"BrtBeginPRFilters", */
    T: 1
  },
  /*::[*/
  250: {
    /* n:"BrtEndPRFilters", */
    T: -1
  },
  /*::[*/
  251: {
    /* n:"BrtBeginPRFilter", */
    T: 1
  },
  /*::[*/
  252: {
    /* n:"BrtEndPRFilter", */
    T: -1
  },
  /*::[*/
  253: {
    /* n:"BrtBeginPNames", */
    T: 1
  },
  /*::[*/
  254: {
    /* n:"BrtEndPNames", */
    T: -1
  },
  /*::[*/
  255: {
    /* n:"BrtBeginPName", */
    T: 1
  },
  /*::[*/
  256: {
    /* n:"BrtEndPName", */
    T: -1
  },
  /*::[*/
  257: {
    /* n:"BrtBeginPNPairs", */
    T: 1
  },
  /*::[*/
  258: {
    /* n:"BrtEndPNPairs", */
    T: -1
  },
  /*::[*/
  259: {
    /* n:"BrtBeginPNPair", */
    T: 1
  },
  /*::[*/
  260: {
    /* n:"BrtEndPNPair", */
    T: -1
  },
  /*::[*/
  261: {
    /* n:"BrtBeginECWebProps", */
    T: 1
  },
  /*::[*/
  262: {
    /* n:"BrtEndECWebProps", */
    T: -1
  },
  /*::[*/
  263: {
    /* n:"BrtBeginEcWpTables", */
    T: 1
  },
  /*::[*/
  264: {
    /* n:"BrtEndECWPTables", */
    T: -1
  },
  /*::[*/
  265: {
    /* n:"BrtBeginECParams", */
    T: 1
  },
  /*::[*/
  266: {
    /* n:"BrtEndECParams", */
    T: -1
  },
  /*::[*/
  267: {
    /* n:"BrtBeginECParam", */
    T: 1
  },
  /*::[*/
  268: {
    /* n:"BrtEndECParam", */
    T: -1
  },
  /*::[*/
  269: {
    /* n:"BrtBeginPCDKPIs", */
    T: 1
  },
  /*::[*/
  270: {
    /* n:"BrtEndPCDKPIs", */
    T: -1
  },
  /*::[*/
  271: {
    /* n:"BrtBeginPCDKPI", */
    T: 1
  },
  /*::[*/
  272: {
    /* n:"BrtEndPCDKPI", */
    T: -1
  },
  /*::[*/
  273: {
    /* n:"BrtBeginDims", */
    T: 1
  },
  /*::[*/
  274: {
    /* n:"BrtEndDims", */
    T: -1
  },
  /*::[*/
  275: {
    /* n:"BrtBeginDim", */
    T: 1
  },
  /*::[*/
  276: {
    /* n:"BrtEndDim", */
    T: -1
  },
  /*::[*/
  277: {
    /* n:"BrtIndexPartEnd" */
  },
  /*::[*/
  278: {
    /* n:"BrtBeginStyleSheet", */
    T: 1
  },
  /*::[*/
  279: {
    /* n:"BrtEndStyleSheet", */
    T: -1
  },
  /*::[*/
  280: {
    /* n:"BrtBeginSXView", */
    T: 1
  },
  /*::[*/
  281: {
    /* n:"BrtEndSXVI", */
    T: -1
  },
  /*::[*/
  282: {
    /* n:"BrtBeginSXVI", */
    T: 1
  },
  /*::[*/
  283: {
    /* n:"BrtBeginSXVIs", */
    T: 1
  },
  /*::[*/
  284: {
    /* n:"BrtEndSXVIs", */
    T: -1
  },
  /*::[*/
  285: {
    /* n:"BrtBeginSXVD", */
    T: 1
  },
  /*::[*/
  286: {
    /* n:"BrtEndSXVD", */
    T: -1
  },
  /*::[*/
  287: {
    /* n:"BrtBeginSXVDs", */
    T: 1
  },
  /*::[*/
  288: {
    /* n:"BrtEndSXVDs", */
    T: -1
  },
  /*::[*/
  289: {
    /* n:"BrtBeginSXPI", */
    T: 1
  },
  /*::[*/
  290: {
    /* n:"BrtEndSXPI", */
    T: -1
  },
  /*::[*/
  291: {
    /* n:"BrtBeginSXPIs", */
    T: 1
  },
  /*::[*/
  292: {
    /* n:"BrtEndSXPIs", */
    T: -1
  },
  /*::[*/
  293: {
    /* n:"BrtBeginSXDI", */
    T: 1
  },
  /*::[*/
  294: {
    /* n:"BrtEndSXDI", */
    T: -1
  },
  /*::[*/
  295: {
    /* n:"BrtBeginSXDIs", */
    T: 1
  },
  /*::[*/
  296: {
    /* n:"BrtEndSXDIs", */
    T: -1
  },
  /*::[*/
  297: {
    /* n:"BrtBeginSXLI", */
    T: 1
  },
  /*::[*/
  298: {
    /* n:"BrtEndSXLI", */
    T: -1
  },
  /*::[*/
  299: {
    /* n:"BrtBeginSXLIRws", */
    T: 1
  },
  /*::[*/
  300: {
    /* n:"BrtEndSXLIRws", */
    T: -1
  },
  /*::[*/
  301: {
    /* n:"BrtBeginSXLICols", */
    T: 1
  },
  /*::[*/
  302: {
    /* n:"BrtEndSXLICols", */
    T: -1
  },
  /*::[*/
  303: {
    /* n:"BrtBeginSXFormat", */
    T: 1
  },
  /*::[*/
  304: {
    /* n:"BrtEndSXFormat", */
    T: -1
  },
  /*::[*/
  305: {
    /* n:"BrtBeginSXFormats", */
    T: 1
  },
  /*::[*/
  306: {
    /* n:"BrtEndSxFormats", */
    T: -1
  },
  /*::[*/
  307: {
    /* n:"BrtBeginSxSelect", */
    T: 1
  },
  /*::[*/
  308: {
    /* n:"BrtEndSxSelect", */
    T: -1
  },
  /*::[*/
  309: {
    /* n:"BrtBeginISXVDRws", */
    T: 1
  },
  /*::[*/
  310: {
    /* n:"BrtEndISXVDRws", */
    T: -1
  },
  /*::[*/
  311: {
    /* n:"BrtBeginISXVDCols", */
    T: 1
  },
  /*::[*/
  312: {
    /* n:"BrtEndISXVDCols", */
    T: -1
  },
  /*::[*/
  313: {
    /* n:"BrtEndSXLocation", */
    T: -1
  },
  /*::[*/
  314: {
    /* n:"BrtBeginSXLocation", */
    T: 1
  },
  /*::[*/
  315: {
    /* n:"BrtEndSXView", */
    T: -1
  },
  /*::[*/
  316: {
    /* n:"BrtBeginSXTHs", */
    T: 1
  },
  /*::[*/
  317: {
    /* n:"BrtEndSXTHs", */
    T: -1
  },
  /*::[*/
  318: {
    /* n:"BrtBeginSXTH", */
    T: 1
  },
  /*::[*/
  319: {
    /* n:"BrtEndSXTH", */
    T: -1
  },
  /*::[*/
  320: {
    /* n:"BrtBeginISXTHRws", */
    T: 1
  },
  /*::[*/
  321: {
    /* n:"BrtEndISXTHRws", */
    T: -1
  },
  /*::[*/
  322: {
    /* n:"BrtBeginISXTHCols", */
    T: 1
  },
  /*::[*/
  323: {
    /* n:"BrtEndISXTHCols", */
    T: -1
  },
  /*::[*/
  324: {
    /* n:"BrtBeginSXTDMPS", */
    T: 1
  },
  /*::[*/
  325: {
    /* n:"BrtEndSXTDMPs", */
    T: -1
  },
  /*::[*/
  326: {
    /* n:"BrtBeginSXTDMP", */
    T: 1
  },
  /*::[*/
  327: {
    /* n:"BrtEndSXTDMP", */
    T: -1
  },
  /*::[*/
  328: {
    /* n:"BrtBeginSXTHItems", */
    T: 1
  },
  /*::[*/
  329: {
    /* n:"BrtEndSXTHItems", */
    T: -1
  },
  /*::[*/
  330: {
    /* n:"BrtBeginSXTHItem", */
    T: 1
  },
  /*::[*/
  331: {
    /* n:"BrtEndSXTHItem", */
    T: -1
  },
  /*::[*/
  332: {
    /* n:"BrtBeginMetadata", */
    T: 1
  },
  /*::[*/
  333: {
    /* n:"BrtEndMetadata", */
    T: -1
  },
  /*::[*/
  334: {
    /* n:"BrtBeginEsmdtinfo", */
    T: 1
  },
  /*::[*/
  335: {
    /* n:"BrtMdtinfo", */
    f: kf
  },
  /*::[*/
  336: {
    /* n:"BrtEndEsmdtinfo", */
    T: -1
  },
  /*::[*/
  337: {
    /* n:"BrtBeginEsmdb", */
    f: Sf,
    T: 1
  },
  /*::[*/
  338: {
    /* n:"BrtEndEsmdb", */
    T: -1
  },
  /*::[*/
  339: {
    /* n:"BrtBeginEsfmd", */
    T: 1
  },
  /*::[*/
  340: {
    /* n:"BrtEndEsfmd", */
    T: -1
  },
  /*::[*/
  341: {
    /* n:"BrtBeginSingleCells", */
    T: 1
  },
  /*::[*/
  342: {
    /* n:"BrtEndSingleCells", */
    T: -1
  },
  /*::[*/
  343: {
    /* n:"BrtBeginList", */
    T: 1
  },
  /*::[*/
  344: {
    /* n:"BrtEndList", */
    T: -1
  },
  /*::[*/
  345: {
    /* n:"BrtBeginListCols", */
    T: 1
  },
  /*::[*/
  346: {
    /* n:"BrtEndListCols", */
    T: -1
  },
  /*::[*/
  347: {
    /* n:"BrtBeginListCol", */
    T: 1
  },
  /*::[*/
  348: {
    /* n:"BrtEndListCol", */
    T: -1
  },
  /*::[*/
  349: {
    /* n:"BrtBeginListXmlCPr", */
    T: 1
  },
  /*::[*/
  350: {
    /* n:"BrtEndListXmlCPr", */
    T: -1
  },
  /*::[*/
  351: {
    /* n:"BrtListCCFmla" */
  },
  /*::[*/
  352: {
    /* n:"BrtListTrFmla" */
  },
  /*::[*/
  353: {
    /* n:"BrtBeginExternals", */
    T: 1
  },
  /*::[*/
  354: {
    /* n:"BrtEndExternals", */
    T: -1
  },
  /*::[*/
  355: {
    /* n:"BrtSupBookSrc", */
    f: g4
  },
  /*::[*/
  357: {
    /* n:"BrtSupSelf" */
  },
  /*::[*/
  358: {
    /* n:"BrtSupSame" */
  },
  /*::[*/
  359: {
    /* n:"BrtSupTabs" */
  },
  /*::[*/
  360: {
    /* n:"BrtBeginSupBook", */
    T: 1
  },
  /*::[*/
  361: {
    /* n:"BrtPlaceholderName" */
  },
  /*::[*/
  362: {
    /* n:"BrtExternSheet", */
    f: C7
  },
  /*::[*/
  363: {
    /* n:"BrtExternTableStart" */
  },
  /*::[*/
  364: {
    /* n:"BrtExternTableEnd" */
  },
  /*::[*/
  366: {
    /* n:"BrtExternRowHdr" */
  },
  /*::[*/
  367: {
    /* n:"BrtExternCellBlank" */
  },
  /*::[*/
  368: {
    /* n:"BrtExternCellReal" */
  },
  /*::[*/
  369: {
    /* n:"BrtExternCellBool" */
  },
  /*::[*/
  370: {
    /* n:"BrtExternCellError" */
  },
  /*::[*/
  371: {
    /* n:"BrtExternCellString" */
  },
  /*::[*/
  372: {
    /* n:"BrtBeginEsmdx", */
    T: 1
  },
  /*::[*/
  373: {
    /* n:"BrtEndEsmdx", */
    T: -1
  },
  /*::[*/
  374: {
    /* n:"BrtBeginMdxSet", */
    T: 1
  },
  /*::[*/
  375: {
    /* n:"BrtEndMdxSet", */
    T: -1
  },
  /*::[*/
  376: {
    /* n:"BrtBeginMdxMbrProp", */
    T: 1
  },
  /*::[*/
  377: {
    /* n:"BrtEndMdxMbrProp", */
    T: -1
  },
  /*::[*/
  378: {
    /* n:"BrtBeginMdxKPI", */
    T: 1
  },
  /*::[*/
  379: {
    /* n:"BrtEndMdxKPI", */
    T: -1
  },
  /*::[*/
  380: {
    /* n:"BrtBeginEsstr", */
    T: 1
  },
  /*::[*/
  381: {
    /* n:"BrtEndEsstr", */
    T: -1
  },
  /*::[*/
  382: {
    /* n:"BrtBeginPRFItem", */
    T: 1
  },
  /*::[*/
  383: {
    /* n:"BrtEndPRFItem", */
    T: -1
  },
  /*::[*/
  384: {
    /* n:"BrtBeginPivotCacheIDs", */
    T: 1
  },
  /*::[*/
  385: {
    /* n:"BrtEndPivotCacheIDs", */
    T: -1
  },
  /*::[*/
  386: {
    /* n:"BrtBeginPivotCacheID", */
    T: 1
  },
  /*::[*/
  387: {
    /* n:"BrtEndPivotCacheID", */
    T: -1
  },
  /*::[*/
  388: {
    /* n:"BrtBeginISXVIs", */
    T: 1
  },
  /*::[*/
  389: {
    /* n:"BrtEndISXVIs", */
    T: -1
  },
  /*::[*/
  390: {
    /* n:"BrtBeginColInfos", */
    T: 1
  },
  /*::[*/
  391: {
    /* n:"BrtEndColInfos", */
    T: -1
  },
  /*::[*/
  392: {
    /* n:"BrtBeginRwBrk", */
    T: 1
  },
  /*::[*/
  393: {
    /* n:"BrtEndRwBrk", */
    T: -1
  },
  /*::[*/
  394: {
    /* n:"BrtBeginColBrk", */
    T: 1
  },
  /*::[*/
  395: {
    /* n:"BrtEndColBrk", */
    T: -1
  },
  /*::[*/
  396: {
    /* n:"BrtBrk" */
  },
  /*::[*/
  397: {
    /* n:"BrtUserBookView" */
  },
  /*::[*/
  398: {
    /* n:"BrtInfo" */
  },
  /*::[*/
  399: {
    /* n:"BrtCUsr" */
  },
  /*::[*/
  400: {
    /* n:"BrtUsr" */
  },
  /*::[*/
  401: {
    /* n:"BrtBeginUsers", */
    T: 1
  },
  /*::[*/
  403: {
    /* n:"BrtEOF" */
  },
  /*::[*/
  404: {
    /* n:"BrtUCR" */
  },
  /*::[*/
  405: {
    /* n:"BrtRRInsDel" */
  },
  /*::[*/
  406: {
    /* n:"BrtRREndInsDel" */
  },
  /*::[*/
  407: {
    /* n:"BrtRRMove" */
  },
  /*::[*/
  408: {
    /* n:"BrtRREndMove" */
  },
  /*::[*/
  409: {
    /* n:"BrtRRChgCell" */
  },
  /*::[*/
  410: {
    /* n:"BrtRREndChgCell" */
  },
  /*::[*/
  411: {
    /* n:"BrtRRHeader" */
  },
  /*::[*/
  412: {
    /* n:"BrtRRUserView" */
  },
  /*::[*/
  413: {
    /* n:"BrtRRRenSheet" */
  },
  /*::[*/
  414: {
    /* n:"BrtRRInsertSh" */
  },
  /*::[*/
  415: {
    /* n:"BrtRRDefName" */
  },
  /*::[*/
  416: {
    /* n:"BrtRRNote" */
  },
  /*::[*/
  417: {
    /* n:"BrtRRConflict" */
  },
  /*::[*/
  418: {
    /* n:"BrtRRTQSIF" */
  },
  /*::[*/
  419: {
    /* n:"BrtRRFormat" */
  },
  /*::[*/
  420: {
    /* n:"BrtRREndFormat" */
  },
  /*::[*/
  421: {
    /* n:"BrtRRAutoFmt" */
  },
  /*::[*/
  422: {
    /* n:"BrtBeginUserShViews", */
    T: 1
  },
  /*::[*/
  423: {
    /* n:"BrtBeginUserShView", */
    T: 1
  },
  /*::[*/
  424: {
    /* n:"BrtEndUserShView", */
    T: -1
  },
  /*::[*/
  425: {
    /* n:"BrtEndUserShViews", */
    T: -1
  },
  /*::[*/
  426: {
    /* n:"BrtArrFmla", */
    f: oh
  },
  /*::[*/
  427: {
    /* n:"BrtShrFmla", */
    f: lh
  },
  /*::[*/
  428: {
    /* n:"BrtTable" */
  },
  /*::[*/
  429: {
    /* n:"BrtBeginExtConnections", */
    T: 1
  },
  /*::[*/
  430: {
    /* n:"BrtEndExtConnections", */
    T: -1
  },
  /*::[*/
  431: {
    /* n:"BrtBeginPCDCalcMems", */
    T: 1
  },
  /*::[*/
  432: {
    /* n:"BrtEndPCDCalcMems", */
    T: -1
  },
  /*::[*/
  433: {
    /* n:"BrtBeginPCDCalcMem", */
    T: 1
  },
  /*::[*/
  434: {
    /* n:"BrtEndPCDCalcMem", */
    T: -1
  },
  /*::[*/
  435: {
    /* n:"BrtBeginPCDHGLevels", */
    T: 1
  },
  /*::[*/
  436: {
    /* n:"BrtEndPCDHGLevels", */
    T: -1
  },
  /*::[*/
  437: {
    /* n:"BrtBeginPCDHGLevel", */
    T: 1
  },
  /*::[*/
  438: {
    /* n:"BrtEndPCDHGLevel", */
    T: -1
  },
  /*::[*/
  439: {
    /* n:"BrtBeginPCDHGLGroups", */
    T: 1
  },
  /*::[*/
  440: {
    /* n:"BrtEndPCDHGLGroups", */
    T: -1
  },
  /*::[*/
  441: {
    /* n:"BrtBeginPCDHGLGroup", */
    T: 1
  },
  /*::[*/
  442: {
    /* n:"BrtEndPCDHGLGroup", */
    T: -1
  },
  /*::[*/
  443: {
    /* n:"BrtBeginPCDHGLGMembers", */
    T: 1
  },
  /*::[*/
  444: {
    /* n:"BrtEndPCDHGLGMembers", */
    T: -1
  },
  /*::[*/
  445: {
    /* n:"BrtBeginPCDHGLGMember", */
    T: 1
  },
  /*::[*/
  446: {
    /* n:"BrtEndPCDHGLGMember", */
    T: -1
  },
  /*::[*/
  447: {
    /* n:"BrtBeginQSI", */
    T: 1
  },
  /*::[*/
  448: {
    /* n:"BrtEndQSI", */
    T: -1
  },
  /*::[*/
  449: {
    /* n:"BrtBeginQSIR", */
    T: 1
  },
  /*::[*/
  450: {
    /* n:"BrtEndQSIR", */
    T: -1
  },
  /*::[*/
  451: {
    /* n:"BrtBeginDeletedNames", */
    T: 1
  },
  /*::[*/
  452: {
    /* n:"BrtEndDeletedNames", */
    T: -1
  },
  /*::[*/
  453: {
    /* n:"BrtBeginDeletedName", */
    T: 1
  },
  /*::[*/
  454: {
    /* n:"BrtEndDeletedName", */
    T: -1
  },
  /*::[*/
  455: {
    /* n:"BrtBeginQSIFs", */
    T: 1
  },
  /*::[*/
  456: {
    /* n:"BrtEndQSIFs", */
    T: -1
  },
  /*::[*/
  457: {
    /* n:"BrtBeginQSIF", */
    T: 1
  },
  /*::[*/
  458: {
    /* n:"BrtEndQSIF", */
    T: -1
  },
  /*::[*/
  459: {
    /* n:"BrtBeginAutoSortScope", */
    T: 1
  },
  /*::[*/
  460: {
    /* n:"BrtEndAutoSortScope", */
    T: -1
  },
  /*::[*/
  461: {
    /* n:"BrtBeginConditionalFormatting", */
    T: 1
  },
  /*::[*/
  462: {
    /* n:"BrtEndConditionalFormatting", */
    T: -1
  },
  /*::[*/
  463: {
    /* n:"BrtBeginCFRule", */
    T: 1
  },
  /*::[*/
  464: {
    /* n:"BrtEndCFRule", */
    T: -1
  },
  /*::[*/
  465: {
    /* n:"BrtBeginIconSet", */
    T: 1
  },
  /*::[*/
  466: {
    /* n:"BrtEndIconSet", */
    T: -1
  },
  /*::[*/
  467: {
    /* n:"BrtBeginDatabar", */
    T: 1
  },
  /*::[*/
  468: {
    /* n:"BrtEndDatabar", */
    T: -1
  },
  /*::[*/
  469: {
    /* n:"BrtBeginColorScale", */
    T: 1
  },
  /*::[*/
  470: {
    /* n:"BrtEndColorScale", */
    T: -1
  },
  /*::[*/
  471: {
    /* n:"BrtCFVO" */
  },
  /*::[*/
  472: {
    /* n:"BrtExternValueMeta" */
  },
  /*::[*/
  473: {
    /* n:"BrtBeginColorPalette", */
    T: 1
  },
  /*::[*/
  474: {
    /* n:"BrtEndColorPalette", */
    T: -1
  },
  /*::[*/
  475: {
    /* n:"BrtIndexedColor" */
  },
  /*::[*/
  476: {
    /* n:"BrtMargins", */
    f: uh
  },
  /*::[*/
  477: {
    /* n:"BrtPrintOptions" */
  },
  /*::[*/
  478: {
    /* n:"BrtPageSetup" */
  },
  /*::[*/
  479: {
    /* n:"BrtBeginHeaderFooter", */
    T: 1
  },
  /*::[*/
  480: {
    /* n:"BrtEndHeaderFooter", */
    T: -1
  },
  /*::[*/
  481: {
    /* n:"BrtBeginSXCrtFormat", */
    T: 1
  },
  /*::[*/
  482: {
    /* n:"BrtEndSXCrtFormat", */
    T: -1
  },
  /*::[*/
  483: {
    /* n:"BrtBeginSXCrtFormats", */
    T: 1
  },
  /*::[*/
  484: {
    /* n:"BrtEndSXCrtFormats", */
    T: -1
  },
  /*::[*/
  485: {
    /* n:"BrtWsFmtInfo", */
    f: Hl
  },
  /*::[*/
  486: {
    /* n:"BrtBeginMgs", */
    T: 1
  },
  /*::[*/
  487: {
    /* n:"BrtEndMGs", */
    T: -1
  },
  /*::[*/
  488: {
    /* n:"BrtBeginMGMaps", */
    T: 1
  },
  /*::[*/
  489: {
    /* n:"BrtEndMGMaps", */
    T: -1
  },
  /*::[*/
  490: {
    /* n:"BrtBeginMG", */
    T: 1
  },
  /*::[*/
  491: {
    /* n:"BrtEndMG", */
    T: -1
  },
  /*::[*/
  492: {
    /* n:"BrtBeginMap", */
    T: 1
  },
  /*::[*/
  493: {
    /* n:"BrtEndMap", */
    T: -1
  },
  /*::[*/
  494: {
    /* n:"BrtHLink", */
    f: ch
  },
  /*::[*/
  495: {
    /* n:"BrtBeginDCon", */
    T: 1
  },
  /*::[*/
  496: {
    /* n:"BrtEndDCon", */
    T: -1
  },
  /*::[*/
  497: {
    /* n:"BrtBeginDRefs", */
    T: 1
  },
  /*::[*/
  498: {
    /* n:"BrtEndDRefs", */
    T: -1
  },
  /*::[*/
  499: {
    /* n:"BrtDRef" */
  },
  /*::[*/
  500: {
    /* n:"BrtBeginScenMan", */
    T: 1
  },
  /*::[*/
  501: {
    /* n:"BrtEndScenMan", */
    T: -1
  },
  /*::[*/
  502: {
    /* n:"BrtBeginSct", */
    T: 1
  },
  /*::[*/
  503: {
    /* n:"BrtEndSct", */
    T: -1
  },
  /*::[*/
  504: {
    /* n:"BrtSlc" */
  },
  /*::[*/
  505: {
    /* n:"BrtBeginDXFs", */
    T: 1
  },
  /*::[*/
  506: {
    /* n:"BrtEndDXFs", */
    T: -1
  },
  /*::[*/
  507: {
    /* n:"BrtDXF" */
  },
  /*::[*/
  508: {
    /* n:"BrtBeginTableStyles", */
    T: 1
  },
  /*::[*/
  509: {
    /* n:"BrtEndTableStyles", */
    T: -1
  },
  /*::[*/
  510: {
    /* n:"BrtBeginTableStyle", */
    T: 1
  },
  /*::[*/
  511: {
    /* n:"BrtEndTableStyle", */
    T: -1
  },
  /*::[*/
  512: {
    /* n:"BrtTableStyleElement" */
  },
  /*::[*/
  513: {
    /* n:"BrtTableStyleClient" */
  },
  /*::[*/
  514: {
    /* n:"BrtBeginVolDeps", */
    T: 1
  },
  /*::[*/
  515: {
    /* n:"BrtEndVolDeps", */
    T: -1
  },
  /*::[*/
  516: {
    /* n:"BrtBeginVolType", */
    T: 1
  },
  /*::[*/
  517: {
    /* n:"BrtEndVolType", */
    T: -1
  },
  /*::[*/
  518: {
    /* n:"BrtBeginVolMain", */
    T: 1
  },
  /*::[*/
  519: {
    /* n:"BrtEndVolMain", */
    T: -1
  },
  /*::[*/
  520: {
    /* n:"BrtBeginVolTopic", */
    T: 1
  },
  /*::[*/
  521: {
    /* n:"BrtEndVolTopic", */
    T: -1
  },
  /*::[*/
  522: {
    /* n:"BrtVolSubtopic" */
  },
  /*::[*/
  523: {
    /* n:"BrtVolRef" */
  },
  /*::[*/
  524: {
    /* n:"BrtVolNum" */
  },
  /*::[*/
  525: {
    /* n:"BrtVolErr" */
  },
  /*::[*/
  526: {
    /* n:"BrtVolStr" */
  },
  /*::[*/
  527: {
    /* n:"BrtVolBool" */
  },
  /*::[*/
  528: {
    /* n:"BrtBeginCalcChain$", */
    T: 1
  },
  /*::[*/
  529: {
    /* n:"BrtEndCalcChain$", */
    T: -1
  },
  /*::[*/
  530: {
    /* n:"BrtBeginSortState", */
    T: 1
  },
  /*::[*/
  531: {
    /* n:"BrtEndSortState", */
    T: -1
  },
  /*::[*/
  532: {
    /* n:"BrtBeginSortCond", */
    T: 1
  },
  /*::[*/
  533: {
    /* n:"BrtEndSortCond", */
    T: -1
  },
  /*::[*/
  534: {
    /* n:"BrtBookProtection" */
  },
  /*::[*/
  535: {
    /* n:"BrtSheetProtection" */
  },
  /*::[*/
  536: {
    /* n:"BrtRangeProtection" */
  },
  /*::[*/
  537: {
    /* n:"BrtPhoneticInfo" */
  },
  /*::[*/
  538: {
    /* n:"BrtBeginECTxtWiz", */
    T: 1
  },
  /*::[*/
  539: {
    /* n:"BrtEndECTxtWiz", */
    T: -1
  },
  /*::[*/
  540: {
    /* n:"BrtBeginECTWFldInfoLst", */
    T: 1
  },
  /*::[*/
  541: {
    /* n:"BrtEndECTWFldInfoLst", */
    T: -1
  },
  /*::[*/
  542: {
    /* n:"BrtBeginECTwFldInfo", */
    T: 1
  },
  /*::[*/
  548: {
    /* n:"BrtFileSharing" */
  },
  /*::[*/
  549: {
    /* n:"BrtOleSize" */
  },
  /*::[*/
  550: {
    /* n:"BrtDrawing", */
    f: g4
  },
  /*::[*/
  551: {
    /* n:"BrtLegacyDrawing", */
    f: Ke
  },
  /*::[*/
  552: {
    /* n:"BrtLegacyDrawingHF" */
  },
  /*::[*/
  553: {
    /* n:"BrtWebOpt" */
  },
  /*::[*/
  554: {
    /* n:"BrtBeginWebPubItems", */
    T: 1
  },
  /*::[*/
  555: {
    /* n:"BrtEndWebPubItems", */
    T: -1
  },
  /*::[*/
  556: {
    /* n:"BrtBeginWebPubItem", */
    T: 1
  },
  /*::[*/
  557: {
    /* n:"BrtEndWebPubItem", */
    T: -1
  },
  /*::[*/
  558: {
    /* n:"BrtBeginSXCondFmt", */
    T: 1
  },
  /*::[*/
  559: {
    /* n:"BrtEndSXCondFmt", */
    T: -1
  },
  /*::[*/
  560: {
    /* n:"BrtBeginSXCondFmts", */
    T: 1
  },
  /*::[*/
  561: {
    /* n:"BrtEndSXCondFmts", */
    T: -1
  },
  /*::[*/
  562: {
    /* n:"BrtBkHim" */
  },
  /*::[*/
  564: {
    /* n:"BrtColor" */
  },
  /*::[*/
  565: {
    /* n:"BrtBeginIndexedColors", */
    T: 1
  },
  /*::[*/
  566: {
    /* n:"BrtEndIndexedColors", */
    T: -1
  },
  /*::[*/
  569: {
    /* n:"BrtBeginMRUColors", */
    T: 1
  },
  /*::[*/
  570: {
    /* n:"BrtEndMRUColors", */
    T: -1
  },
  /*::[*/
  572: {
    /* n:"BrtMRUColor" */
  },
  /*::[*/
  573: {
    /* n:"BrtBeginDVals", */
    T: 1
  },
  /*::[*/
  574: {
    /* n:"BrtEndDVals", */
    T: -1
  },
  /*::[*/
  577: {
    /* n:"BrtSupNameStart" */
  },
  /*::[*/
  578: {
    /* n:"BrtSupNameValueStart" */
  },
  /*::[*/
  579: {
    /* n:"BrtSupNameValueEnd" */
  },
  /*::[*/
  580: {
    /* n:"BrtSupNameNum" */
  },
  /*::[*/
  581: {
    /* n:"BrtSupNameErr" */
  },
  /*::[*/
  582: {
    /* n:"BrtSupNameSt" */
  },
  /*::[*/
  583: {
    /* n:"BrtSupNameNil" */
  },
  /*::[*/
  584: {
    /* n:"BrtSupNameBool" */
  },
  /*::[*/
  585: {
    /* n:"BrtSupNameFmla" */
  },
  /*::[*/
  586: {
    /* n:"BrtSupNameBits" */
  },
  /*::[*/
  587: {
    /* n:"BrtSupNameEnd" */
  },
  /*::[*/
  588: {
    /* n:"BrtEndSupBook", */
    T: -1
  },
  /*::[*/
  589: {
    /* n:"BrtCellSmartTagProperty" */
  },
  /*::[*/
  590: {
    /* n:"BrtBeginCellSmartTag", */
    T: 1
  },
  /*::[*/
  591: {
    /* n:"BrtEndCellSmartTag", */
    T: -1
  },
  /*::[*/
  592: {
    /* n:"BrtBeginCellSmartTags", */
    T: 1
  },
  /*::[*/
  593: {
    /* n:"BrtEndCellSmartTags", */
    T: -1
  },
  /*::[*/
  594: {
    /* n:"BrtBeginSmartTags", */
    T: 1
  },
  /*::[*/
  595: {
    /* n:"BrtEndSmartTags", */
    T: -1
  },
  /*::[*/
  596: {
    /* n:"BrtSmartTagType" */
  },
  /*::[*/
  597: {
    /* n:"BrtBeginSmartTagTypes", */
    T: 1
  },
  /*::[*/
  598: {
    /* n:"BrtEndSmartTagTypes", */
    T: -1
  },
  /*::[*/
  599: {
    /* n:"BrtBeginSXFilters", */
    T: 1
  },
  /*::[*/
  600: {
    /* n:"BrtEndSXFilters", */
    T: -1
  },
  /*::[*/
  601: {
    /* n:"BrtBeginSXFILTER", */
    T: 1
  },
  /*::[*/
  602: {
    /* n:"BrtEndSXFilter", */
    T: -1
  },
  /*::[*/
  603: {
    /* n:"BrtBeginFills", */
    T: 1
  },
  /*::[*/
  604: {
    /* n:"BrtEndFills", */
    T: -1
  },
  /*::[*/
  605: {
    /* n:"BrtBeginCellWatches", */
    T: 1
  },
  /*::[*/
  606: {
    /* n:"BrtEndCellWatches", */
    T: -1
  },
  /*::[*/
  607: {
    /* n:"BrtCellWatch" */
  },
  /*::[*/
  608: {
    /* n:"BrtBeginCRErrs", */
    T: 1
  },
  /*::[*/
  609: {
    /* n:"BrtEndCRErrs", */
    T: -1
  },
  /*::[*/
  610: {
    /* n:"BrtCrashRecErr" */
  },
  /*::[*/
  611: {
    /* n:"BrtBeginFonts", */
    T: 1
  },
  /*::[*/
  612: {
    /* n:"BrtEndFonts", */
    T: -1
  },
  /*::[*/
  613: {
    /* n:"BrtBeginBorders", */
    T: 1
  },
  /*::[*/
  614: {
    /* n:"BrtEndBorders", */
    T: -1
  },
  /*::[*/
  615: {
    /* n:"BrtBeginFmts", */
    T: 1
  },
  /*::[*/
  616: {
    /* n:"BrtEndFmts", */
    T: -1
  },
  /*::[*/
  617: {
    /* n:"BrtBeginCellXFs", */
    T: 1
  },
  /*::[*/
  618: {
    /* n:"BrtEndCellXFs", */
    T: -1
  },
  /*::[*/
  619: {
    /* n:"BrtBeginStyles", */
    T: 1
  },
  /*::[*/
  620: {
    /* n:"BrtEndStyles", */
    T: -1
  },
  /*::[*/
  625: {
    /* n:"BrtBigName" */
  },
  /*::[*/
  626: {
    /* n:"BrtBeginCellStyleXFs", */
    T: 1
  },
  /*::[*/
  627: {
    /* n:"BrtEndCellStyleXFs", */
    T: -1
  },
  /*::[*/
  628: {
    /* n:"BrtBeginComments", */
    T: 1
  },
  /*::[*/
  629: {
    /* n:"BrtEndComments", */
    T: -1
  },
  /*::[*/
  630: {
    /* n:"BrtBeginCommentAuthors", */
    T: 1
  },
  /*::[*/
  631: {
    /* n:"BrtEndCommentAuthors", */
    T: -1
  },
  /*::[*/
  632: {
    /* n:"BrtCommentAuthor", */
    f: Uf
  },
  /*::[*/
  633: {
    /* n:"BrtBeginCommentList", */
    T: 1
  },
  /*::[*/
  634: {
    /* n:"BrtEndCommentList", */
    T: -1
  },
  /*::[*/
  635: {
    /* n:"BrtBeginComment", */
    T: 1,
    f: Bf
  },
  /*::[*/
  636: {
    /* n:"BrtEndComment", */
    T: -1
  },
  /*::[*/
  637: {
    /* n:"BrtCommentText", */
    f: ri
  },
  /*::[*/
  638: {
    /* n:"BrtBeginOleObjects", */
    T: 1
  },
  /*::[*/
  639: {
    /* n:"BrtOleObject" */
  },
  /*::[*/
  640: {
    /* n:"BrtEndOleObjects", */
    T: -1
  },
  /*::[*/
  641: {
    /* n:"BrtBeginSxrules", */
    T: 1
  },
  /*::[*/
  642: {
    /* n:"BrtEndSxRules", */
    T: -1
  },
  /*::[*/
  643: {
    /* n:"BrtBeginActiveXControls", */
    T: 1
  },
  /*::[*/
  644: {
    /* n:"BrtActiveX" */
  },
  /*::[*/
  645: {
    /* n:"BrtEndActiveXControls", */
    T: -1
  },
  /*::[*/
  646: {
    /* n:"BrtBeginPCDSDTCEMembersSortBy", */
    T: 1
  },
  /*::[*/
  648: {
    /* n:"BrtBeginCellIgnoreECs", */
    T: 1
  },
  /*::[*/
  649: {
    /* n:"BrtCellIgnoreEC" */
  },
  /*::[*/
  650: {
    /* n:"BrtEndCellIgnoreECs", */
    T: -1
  },
  /*::[*/
  651: {
    /* n:"BrtCsProp", */
    f: Th
  },
  /*::[*/
  652: {
    /* n:"BrtCsPageSetup" */
  },
  /*::[*/
  653: {
    /* n:"BrtBeginUserCsViews", */
    T: 1
  },
  /*::[*/
  654: {
    /* n:"BrtEndUserCsViews", */
    T: -1
  },
  /*::[*/
  655: {
    /* n:"BrtBeginUserCsView", */
    T: 1
  },
  /*::[*/
  656: {
    /* n:"BrtEndUserCsView", */
    T: -1
  },
  /*::[*/
  657: {
    /* n:"BrtBeginPcdSFCIEntries", */
    T: 1
  },
  /*::[*/
  658: {
    /* n:"BrtEndPCDSFCIEntries", */
    T: -1
  },
  /*::[*/
  659: {
    /* n:"BrtPCDSFCIEntry" */
  },
  /*::[*/
  660: {
    /* n:"BrtBeginListParts", */
    T: 1
  },
  /*::[*/
  661: {
    /* n:"BrtListPart" */
  },
  /*::[*/
  662: {
    /* n:"BrtEndListParts", */
    T: -1
  },
  /*::[*/
  663: {
    /* n:"BrtSheetCalcProp" */
  },
  /*::[*/
  664: {
    /* n:"BrtBeginFnGroup", */
    T: 1
  },
  /*::[*/
  665: {
    /* n:"BrtFnGroup" */
  },
  /*::[*/
  666: {
    /* n:"BrtEndFnGroup", */
    T: -1
  },
  /*::[*/
  667: {
    /* n:"BrtSupAddin" */
  },
  /*::[*/
  668: {
    /* n:"BrtSXTDMPOrder" */
  },
  /*::[*/
  669: {
    /* n:"BrtCsProtection" */
  },
  /*::[*/
  671: {
    /* n:"BrtBeginWsSortMap", */
    T: 1
  },
  /*::[*/
  672: {
    /* n:"BrtEndWsSortMap", */
    T: -1
  },
  /*::[*/
  673: {
    /* n:"BrtBeginRRSort", */
    T: 1
  },
  /*::[*/
  674: {
    /* n:"BrtEndRRSort", */
    T: -1
  },
  /*::[*/
  675: {
    /* n:"BrtRRSortItem" */
  },
  /*::[*/
  676: {
    /* n:"BrtFileSharingIso" */
  },
  /*::[*/
  677: {
    /* n:"BrtBookProtectionIso" */
  },
  /*::[*/
  678: {
    /* n:"BrtSheetProtectionIso" */
  },
  /*::[*/
  679: {
    /* n:"BrtCsProtectionIso" */
  },
  /*::[*/
  680: {
    /* n:"BrtRangeProtectionIso" */
  },
  /*::[*/
  681: {
    /* n:"BrtDValList" */
  },
  /*::[*/
  1024: {
    /* n:"BrtRwDescent" */
  },
  /*::[*/
  1025: {
    /* n:"BrtKnownFonts" */
  },
  /*::[*/
  1026: {
    /* n:"BrtBeginSXTupleSet", */
    T: 1
  },
  /*::[*/
  1027: {
    /* n:"BrtEndSXTupleSet", */
    T: -1
  },
  /*::[*/
  1028: {
    /* n:"BrtBeginSXTupleSetHeader", */
    T: 1
  },
  /*::[*/
  1029: {
    /* n:"BrtEndSXTupleSetHeader", */
    T: -1
  },
  /*::[*/
  1030: {
    /* n:"BrtSXTupleSetHeaderItem" */
  },
  /*::[*/
  1031: {
    /* n:"BrtBeginSXTupleSetData", */
    T: 1
  },
  /*::[*/
  1032: {
    /* n:"BrtEndSXTupleSetData", */
    T: -1
  },
  /*::[*/
  1033: {
    /* n:"BrtBeginSXTupleSetRow", */
    T: 1
  },
  /*::[*/
  1034: {
    /* n:"BrtEndSXTupleSetRow", */
    T: -1
  },
  /*::[*/
  1035: {
    /* n:"BrtSXTupleSetRowItem" */
  },
  /*::[*/
  1036: {
    /* n:"BrtNameExt" */
  },
  /*::[*/
  1037: {
    /* n:"BrtPCDH14" */
  },
  /*::[*/
  1038: {
    /* n:"BrtBeginPCDCalcMem14", */
    T: 1
  },
  /*::[*/
  1039: {
    /* n:"BrtEndPCDCalcMem14", */
    T: -1
  },
  /*::[*/
  1040: {
    /* n:"BrtSXTH14" */
  },
  /*::[*/
  1041: {
    /* n:"BrtBeginSparklineGroup", */
    T: 1
  },
  /*::[*/
  1042: {
    /* n:"BrtEndSparklineGroup", */
    T: -1
  },
  /*::[*/
  1043: {
    /* n:"BrtSparkline" */
  },
  /*::[*/
  1044: {
    /* n:"BrtSXDI14" */
  },
  /*::[*/
  1045: {
    /* n:"BrtWsFmtInfoEx14" */
  },
  /*::[*/
  1046: {
    /* n:"BrtBeginConditionalFormatting14", */
    T: 1
  },
  /*::[*/
  1047: {
    /* n:"BrtEndConditionalFormatting14", */
    T: -1
  },
  /*::[*/
  1048: {
    /* n:"BrtBeginCFRule14", */
    T: 1
  },
  /*::[*/
  1049: {
    /* n:"BrtEndCFRule14", */
    T: -1
  },
  /*::[*/
  1050: {
    /* n:"BrtCFVO14" */
  },
  /*::[*/
  1051: {
    /* n:"BrtBeginDatabar14", */
    T: 1
  },
  /*::[*/
  1052: {
    /* n:"BrtBeginIconSet14", */
    T: 1
  },
  /*::[*/
  1053: {
    /* n:"BrtDVal14", */
    f: ph
  },
  /*::[*/
  1054: {
    /* n:"BrtBeginDVals14", */
    T: 1
  },
  /*::[*/
  1055: {
    /* n:"BrtColor14" */
  },
  /*::[*/
  1056: {
    /* n:"BrtBeginSparklines", */
    T: 1
  },
  /*::[*/
  1057: {
    /* n:"BrtEndSparklines", */
    T: -1
  },
  /*::[*/
  1058: {
    /* n:"BrtBeginSparklineGroups", */
    T: 1
  },
  /*::[*/
  1059: {
    /* n:"BrtEndSparklineGroups", */
    T: -1
  },
  /*::[*/
  1061: {
    /* n:"BrtSXVD14" */
  },
  /*::[*/
  1062: {
    /* n:"BrtBeginSXView14", */
    T: 1
  },
  /*::[*/
  1063: {
    /* n:"BrtEndSXView14", */
    T: -1
  },
  /*::[*/
  1064: {
    /* n:"BrtBeginSXView16", */
    T: 1
  },
  /*::[*/
  1065: {
    /* n:"BrtEndSXView16", */
    T: -1
  },
  /*::[*/
  1066: {
    /* n:"BrtBeginPCD14", */
    T: 1
  },
  /*::[*/
  1067: {
    /* n:"BrtEndPCD14", */
    T: -1
  },
  /*::[*/
  1068: {
    /* n:"BrtBeginExtConn14", */
    T: 1
  },
  /*::[*/
  1069: {
    /* n:"BrtEndExtConn14", */
    T: -1
  },
  /*::[*/
  1070: {
    /* n:"BrtBeginSlicerCacheIDs", */
    T: 1
  },
  /*::[*/
  1071: {
    /* n:"BrtEndSlicerCacheIDs", */
    T: -1
  },
  /*::[*/
  1072: {
    /* n:"BrtBeginSlicerCacheID", */
    T: 1
  },
  /*::[*/
  1073: {
    /* n:"BrtEndSlicerCacheID", */
    T: -1
  },
  /*::[*/
  1075: {
    /* n:"BrtBeginSlicerCache", */
    T: 1
  },
  /*::[*/
  1076: {
    /* n:"BrtEndSlicerCache", */
    T: -1
  },
  /*::[*/
  1077: {
    /* n:"BrtBeginSlicerCacheDef", */
    T: 1
  },
  /*::[*/
  1078: {
    /* n:"BrtEndSlicerCacheDef", */
    T: -1
  },
  /*::[*/
  1079: {
    /* n:"BrtBeginSlicersEx", */
    T: 1
  },
  /*::[*/
  1080: {
    /* n:"BrtEndSlicersEx", */
    T: -1
  },
  /*::[*/
  1081: {
    /* n:"BrtBeginSlicerEx", */
    T: 1
  },
  /*::[*/
  1082: {
    /* n:"BrtEndSlicerEx", */
    T: -1
  },
  /*::[*/
  1083: {
    /* n:"BrtBeginSlicer", */
    T: 1
  },
  /*::[*/
  1084: {
    /* n:"BrtEndSlicer", */
    T: -1
  },
  /*::[*/
  1085: {
    /* n:"BrtSlicerCachePivotTables" */
  },
  /*::[*/
  1086: {
    /* n:"BrtBeginSlicerCacheOlapImpl", */
    T: 1
  },
  /*::[*/
  1087: {
    /* n:"BrtEndSlicerCacheOlapImpl", */
    T: -1
  },
  /*::[*/
  1088: {
    /* n:"BrtBeginSlicerCacheLevelsData", */
    T: 1
  },
  /*::[*/
  1089: {
    /* n:"BrtEndSlicerCacheLevelsData", */
    T: -1
  },
  /*::[*/
  1090: {
    /* n:"BrtBeginSlicerCacheLevelData", */
    T: 1
  },
  /*::[*/
  1091: {
    /* n:"BrtEndSlicerCacheLevelData", */
    T: -1
  },
  /*::[*/
  1092: {
    /* n:"BrtBeginSlicerCacheSiRanges", */
    T: 1
  },
  /*::[*/
  1093: {
    /* n:"BrtEndSlicerCacheSiRanges", */
    T: -1
  },
  /*::[*/
  1094: {
    /* n:"BrtBeginSlicerCacheSiRange", */
    T: 1
  },
  /*::[*/
  1095: {
    /* n:"BrtEndSlicerCacheSiRange", */
    T: -1
  },
  /*::[*/
  1096: {
    /* n:"BrtSlicerCacheOlapItem" */
  },
  /*::[*/
  1097: {
    /* n:"BrtBeginSlicerCacheSelections", */
    T: 1
  },
  /*::[*/
  1098: {
    /* n:"BrtSlicerCacheSelection" */
  },
  /*::[*/
  1099: {
    /* n:"BrtEndSlicerCacheSelections", */
    T: -1
  },
  /*::[*/
  1100: {
    /* n:"BrtBeginSlicerCacheNative", */
    T: 1
  },
  /*::[*/
  1101: {
    /* n:"BrtEndSlicerCacheNative", */
    T: -1
  },
  /*::[*/
  1102: {
    /* n:"BrtSlicerCacheNativeItem" */
  },
  /*::[*/
  1103: {
    /* n:"BrtRangeProtection14" */
  },
  /*::[*/
  1104: {
    /* n:"BrtRangeProtectionIso14" */
  },
  /*::[*/
  1105: {
    /* n:"BrtCellIgnoreEC14" */
  },
  /*::[*/
  1111: {
    /* n:"BrtList14" */
  },
  /*::[*/
  1112: {
    /* n:"BrtCFIcon" */
  },
  /*::[*/
  1113: {
    /* n:"BrtBeginSlicerCachesPivotCacheIDs", */
    T: 1
  },
  /*::[*/
  1114: {
    /* n:"BrtEndSlicerCachesPivotCacheIDs", */
    T: -1
  },
  /*::[*/
  1115: {
    /* n:"BrtBeginSlicers", */
    T: 1
  },
  /*::[*/
  1116: {
    /* n:"BrtEndSlicers", */
    T: -1
  },
  /*::[*/
  1117: {
    /* n:"BrtWbProp14" */
  },
  /*::[*/
  1118: {
    /* n:"BrtBeginSXEdit", */
    T: 1
  },
  /*::[*/
  1119: {
    /* n:"BrtEndSXEdit", */
    T: -1
  },
  /*::[*/
  1120: {
    /* n:"BrtBeginSXEdits", */
    T: 1
  },
  /*::[*/
  1121: {
    /* n:"BrtEndSXEdits", */
    T: -1
  },
  /*::[*/
  1122: {
    /* n:"BrtBeginSXChange", */
    T: 1
  },
  /*::[*/
  1123: {
    /* n:"BrtEndSXChange", */
    T: -1
  },
  /*::[*/
  1124: {
    /* n:"BrtBeginSXChanges", */
    T: 1
  },
  /*::[*/
  1125: {
    /* n:"BrtEndSXChanges", */
    T: -1
  },
  /*::[*/
  1126: {
    /* n:"BrtSXTupleItems" */
  },
  /*::[*/
  1128: {
    /* n:"BrtBeginSlicerStyle", */
    T: 1
  },
  /*::[*/
  1129: {
    /* n:"BrtEndSlicerStyle", */
    T: -1
  },
  /*::[*/
  1130: {
    /* n:"BrtSlicerStyleElement" */
  },
  /*::[*/
  1131: {
    /* n:"BrtBeginStyleSheetExt14", */
    T: 1
  },
  /*::[*/
  1132: {
    /* n:"BrtEndStyleSheetExt14", */
    T: -1
  },
  /*::[*/
  1133: {
    /* n:"BrtBeginSlicerCachesPivotCacheID", */
    T: 1
  },
  /*::[*/
  1134: {
    /* n:"BrtEndSlicerCachesPivotCacheID", */
    T: -1
  },
  /*::[*/
  1135: {
    /* n:"BrtBeginConditionalFormattings", */
    T: 1
  },
  /*::[*/
  1136: {
    /* n:"BrtEndConditionalFormattings", */
    T: -1
  },
  /*::[*/
  1137: {
    /* n:"BrtBeginPCDCalcMemExt", */
    T: 1
  },
  /*::[*/
  1138: {
    /* n:"BrtEndPCDCalcMemExt", */
    T: -1
  },
  /*::[*/
  1139: {
    /* n:"BrtBeginPCDCalcMemsExt", */
    T: 1
  },
  /*::[*/
  1140: {
    /* n:"BrtEndPCDCalcMemsExt", */
    T: -1
  },
  /*::[*/
  1141: {
    /* n:"BrtPCDField14" */
  },
  /*::[*/
  1142: {
    /* n:"BrtBeginSlicerStyles", */
    T: 1
  },
  /*::[*/
  1143: {
    /* n:"BrtEndSlicerStyles", */
    T: -1
  },
  /*::[*/
  1144: {
    /* n:"BrtBeginSlicerStyleElements", */
    T: 1
  },
  /*::[*/
  1145: {
    /* n:"BrtEndSlicerStyleElements", */
    T: -1
  },
  /*::[*/
  1146: {
    /* n:"BrtCFRuleExt" */
  },
  /*::[*/
  1147: {
    /* n:"BrtBeginSXCondFmt14", */
    T: 1
  },
  /*::[*/
  1148: {
    /* n:"BrtEndSXCondFmt14", */
    T: -1
  },
  /*::[*/
  1149: {
    /* n:"BrtBeginSXCondFmts14", */
    T: 1
  },
  /*::[*/
  1150: {
    /* n:"BrtEndSXCondFmts14", */
    T: -1
  },
  /*::[*/
  1152: {
    /* n:"BrtBeginSortCond14", */
    T: 1
  },
  /*::[*/
  1153: {
    /* n:"BrtEndSortCond14", */
    T: -1
  },
  /*::[*/
  1154: {
    /* n:"BrtEndDVals14", */
    T: -1
  },
  /*::[*/
  1155: {
    /* n:"BrtEndIconSet14", */
    T: -1
  },
  /*::[*/
  1156: {
    /* n:"BrtEndDatabar14", */
    T: -1
  },
  /*::[*/
  1157: {
    /* n:"BrtBeginColorScale14", */
    T: 1
  },
  /*::[*/
  1158: {
    /* n:"BrtEndColorScale14", */
    T: -1
  },
  /*::[*/
  1159: {
    /* n:"BrtBeginSxrules14", */
    T: 1
  },
  /*::[*/
  1160: {
    /* n:"BrtEndSxrules14", */
    T: -1
  },
  /*::[*/
  1161: {
    /* n:"BrtBeginPRule14", */
    T: 1
  },
  /*::[*/
  1162: {
    /* n:"BrtEndPRule14", */
    T: -1
  },
  /*::[*/
  1163: {
    /* n:"BrtBeginPRFilters14", */
    T: 1
  },
  /*::[*/
  1164: {
    /* n:"BrtEndPRFilters14", */
    T: -1
  },
  /*::[*/
  1165: {
    /* n:"BrtBeginPRFilter14", */
    T: 1
  },
  /*::[*/
  1166: {
    /* n:"BrtEndPRFilter14", */
    T: -1
  },
  /*::[*/
  1167: {
    /* n:"BrtBeginPRFItem14", */
    T: 1
  },
  /*::[*/
  1168: {
    /* n:"BrtEndPRFItem14", */
    T: -1
  },
  /*::[*/
  1169: {
    /* n:"BrtBeginCellIgnoreECs14", */
    T: 1
  },
  /*::[*/
  1170: {
    /* n:"BrtEndCellIgnoreECs14", */
    T: -1
  },
  /*::[*/
  1171: {
    /* n:"BrtDxf14" */
  },
  /*::[*/
  1172: {
    /* n:"BrtBeginDxF14s", */
    T: 1
  },
  /*::[*/
  1173: {
    /* n:"BrtEndDxf14s", */
    T: -1
  },
  /*::[*/
  1177: {
    /* n:"BrtFilter14" */
  },
  /*::[*/
  1178: {
    /* n:"BrtBeginCustomFilters14", */
    T: 1
  },
  /*::[*/
  1180: {
    /* n:"BrtCustomFilter14" */
  },
  /*::[*/
  1181: {
    /* n:"BrtIconFilter14" */
  },
  /*::[*/
  1182: {
    /* n:"BrtPivotCacheConnectionName" */
  },
  /*::[*/
  2048: {
    /* n:"BrtBeginDecoupledPivotCacheIDs", */
    T: 1
  },
  /*::[*/
  2049: {
    /* n:"BrtEndDecoupledPivotCacheIDs", */
    T: -1
  },
  /*::[*/
  2050: {
    /* n:"BrtDecoupledPivotCacheID" */
  },
  /*::[*/
  2051: {
    /* n:"BrtBeginPivotTableRefs", */
    T: 1
  },
  /*::[*/
  2052: {
    /* n:"BrtEndPivotTableRefs", */
    T: -1
  },
  /*::[*/
  2053: {
    /* n:"BrtPivotTableRef" */
  },
  /*::[*/
  2054: {
    /* n:"BrtSlicerCacheBookPivotTables" */
  },
  /*::[*/
  2055: {
    /* n:"BrtBeginSxvcells", */
    T: 1
  },
  /*::[*/
  2056: {
    /* n:"BrtEndSxvcells", */
    T: -1
  },
  /*::[*/
  2057: {
    /* n:"BrtBeginSxRow", */
    T: 1
  },
  /*::[*/
  2058: {
    /* n:"BrtEndSxRow", */
    T: -1
  },
  /*::[*/
  2060: {
    /* n:"BrtPcdCalcMem15" */
  },
  /*::[*/
  2067: {
    /* n:"BrtQsi15" */
  },
  /*::[*/
  2068: {
    /* n:"BrtBeginWebExtensions", */
    T: 1
  },
  /*::[*/
  2069: {
    /* n:"BrtEndWebExtensions", */
    T: -1
  },
  /*::[*/
  2070: {
    /* n:"BrtWebExtension" */
  },
  /*::[*/
  2071: {
    /* n:"BrtAbsPath15" */
  },
  /*::[*/
  2072: {
    /* n:"BrtBeginPivotTableUISettings", */
    T: 1
  },
  /*::[*/
  2073: {
    /* n:"BrtEndPivotTableUISettings", */
    T: -1
  },
  /*::[*/
  2075: {
    /* n:"BrtTableSlicerCacheIDs" */
  },
  /*::[*/
  2076: {
    /* n:"BrtTableSlicerCacheID" */
  },
  /*::[*/
  2077: {
    /* n:"BrtBeginTableSlicerCache", */
    T: 1
  },
  /*::[*/
  2078: {
    /* n:"BrtEndTableSlicerCache", */
    T: -1
  },
  /*::[*/
  2079: {
    /* n:"BrtSxFilter15" */
  },
  /*::[*/
  2080: {
    /* n:"BrtBeginTimelineCachePivotCacheIDs", */
    T: 1
  },
  /*::[*/
  2081: {
    /* n:"BrtEndTimelineCachePivotCacheIDs", */
    T: -1
  },
  /*::[*/
  2082: {
    /* n:"BrtTimelineCachePivotCacheID" */
  },
  /*::[*/
  2083: {
    /* n:"BrtBeginTimelineCacheIDs", */
    T: 1
  },
  /*::[*/
  2084: {
    /* n:"BrtEndTimelineCacheIDs", */
    T: -1
  },
  /*::[*/
  2085: {
    /* n:"BrtBeginTimelineCacheID", */
    T: 1
  },
  /*::[*/
  2086: {
    /* n:"BrtEndTimelineCacheID", */
    T: -1
  },
  /*::[*/
  2087: {
    /* n:"BrtBeginTimelinesEx", */
    T: 1
  },
  /*::[*/
  2088: {
    /* n:"BrtEndTimelinesEx", */
    T: -1
  },
  /*::[*/
  2089: {
    /* n:"BrtBeginTimelineEx", */
    T: 1
  },
  /*::[*/
  2090: {
    /* n:"BrtEndTimelineEx", */
    T: -1
  },
  /*::[*/
  2091: {
    /* n:"BrtWorkBookPr15" */
  },
  /*::[*/
  2092: {
    /* n:"BrtPCDH15" */
  },
  /*::[*/
  2093: {
    /* n:"BrtBeginTimelineStyle", */
    T: 1
  },
  /*::[*/
  2094: {
    /* n:"BrtEndTimelineStyle", */
    T: -1
  },
  /*::[*/
  2095: {
    /* n:"BrtTimelineStyleElement" */
  },
  /*::[*/
  2096: {
    /* n:"BrtBeginTimelineStylesheetExt15", */
    T: 1
  },
  /*::[*/
  2097: {
    /* n:"BrtEndTimelineStylesheetExt15", */
    T: -1
  },
  /*::[*/
  2098: {
    /* n:"BrtBeginTimelineStyles", */
    T: 1
  },
  /*::[*/
  2099: {
    /* n:"BrtEndTimelineStyles", */
    T: -1
  },
  /*::[*/
  2100: {
    /* n:"BrtBeginTimelineStyleElements", */
    T: 1
  },
  /*::[*/
  2101: {
    /* n:"BrtEndTimelineStyleElements", */
    T: -1
  },
  /*::[*/
  2102: {
    /* n:"BrtDxf15" */
  },
  /*::[*/
  2103: {
    /* n:"BrtBeginDxfs15", */
    T: 1
  },
  /*::[*/
  2104: {
    /* n:"BrtEndDxfs15", */
    T: -1
  },
  /*::[*/
  2105: {
    /* n:"BrtSlicerCacheHideItemsWithNoData" */
  },
  /*::[*/
  2106: {
    /* n:"BrtBeginItemUniqueNames", */
    T: 1
  },
  /*::[*/
  2107: {
    /* n:"BrtEndItemUniqueNames", */
    T: -1
  },
  /*::[*/
  2108: {
    /* n:"BrtItemUniqueName" */
  },
  /*::[*/
  2109: {
    /* n:"BrtBeginExtConn15", */
    T: 1
  },
  /*::[*/
  2110: {
    /* n:"BrtEndExtConn15", */
    T: -1
  },
  /*::[*/
  2111: {
    /* n:"BrtBeginOledbPr15", */
    T: 1
  },
  /*::[*/
  2112: {
    /* n:"BrtEndOledbPr15", */
    T: -1
  },
  /*::[*/
  2113: {
    /* n:"BrtBeginDataFeedPr15", */
    T: 1
  },
  /*::[*/
  2114: {
    /* n:"BrtEndDataFeedPr15", */
    T: -1
  },
  /*::[*/
  2115: {
    /* n:"BrtTextPr15" */
  },
  /*::[*/
  2116: {
    /* n:"BrtRangePr15" */
  },
  /*::[*/
  2117: {
    /* n:"BrtDbCommand15" */
  },
  /*::[*/
  2118: {
    /* n:"BrtBeginDbTables15", */
    T: 1
  },
  /*::[*/
  2119: {
    /* n:"BrtEndDbTables15", */
    T: -1
  },
  /*::[*/
  2120: {
    /* n:"BrtDbTable15" */
  },
  /*::[*/
  2121: {
    /* n:"BrtBeginDataModel", */
    T: 1
  },
  /*::[*/
  2122: {
    /* n:"BrtEndDataModel", */
    T: -1
  },
  /*::[*/
  2123: {
    /* n:"BrtBeginModelTables", */
    T: 1
  },
  /*::[*/
  2124: {
    /* n:"BrtEndModelTables", */
    T: -1
  },
  /*::[*/
  2125: {
    /* n:"BrtModelTable" */
  },
  /*::[*/
  2126: {
    /* n:"BrtBeginModelRelationships", */
    T: 1
  },
  /*::[*/
  2127: {
    /* n:"BrtEndModelRelationships", */
    T: -1
  },
  /*::[*/
  2128: {
    /* n:"BrtModelRelationship" */
  },
  /*::[*/
  2129: {
    /* n:"BrtBeginECTxtWiz15", */
    T: 1
  },
  /*::[*/
  2130: {
    /* n:"BrtEndECTxtWiz15", */
    T: -1
  },
  /*::[*/
  2131: {
    /* n:"BrtBeginECTWFldInfoLst15", */
    T: 1
  },
  /*::[*/
  2132: {
    /* n:"BrtEndECTWFldInfoLst15", */
    T: -1
  },
  /*::[*/
  2133: {
    /* n:"BrtBeginECTWFldInfo15", */
    T: 1
  },
  /*::[*/
  2134: {
    /* n:"BrtFieldListActiveItem" */
  },
  /*::[*/
  2135: {
    /* n:"BrtPivotCacheIdVersion" */
  },
  /*::[*/
  2136: {
    /* n:"BrtSXDI15" */
  },
  /*::[*/
  2137: {
    /* n:"BrtBeginModelTimeGroupings", */
    T: 1
  },
  /*::[*/
  2138: {
    /* n:"BrtEndModelTimeGroupings", */
    T: -1
  },
  /*::[*/
  2139: {
    /* n:"BrtBeginModelTimeGrouping", */
    T: 1
  },
  /*::[*/
  2140: {
    /* n:"BrtEndModelTimeGrouping", */
    T: -1
  },
  /*::[*/
  2141: {
    /* n:"BrtModelTimeGroupingCalcCol" */
  },
  /*::[*/
  3072: {
    /* n:"BrtUid" */
  },
  /*::[*/
  3073: {
    /* n:"BrtRevisionPtr" */
  },
  /*::[*/
  4096: {
    /* n:"BrtBeginDynamicArrayPr", */
    T: 1
  },
  /*::[*/
  4097: {
    /* n:"BrtEndDynamicArrayPr", */
    T: -1
  },
  /*::[*/
  5002: {
    /* n:"BrtBeginRichValueBlock", */
    T: 1
  },
  /*::[*/
  5003: {
    /* n:"BrtEndRichValueBlock", */
    T: -1
  },
  /*::[*/
  5081: {
    /* n:"BrtBeginRichFilters", */
    T: 1
  },
  /*::[*/
  5082: {
    /* n:"BrtEndRichFilters", */
    T: -1
  },
  /*::[*/
  5083: {
    /* n:"BrtRichFilter" */
  },
  /*::[*/
  5084: {
    /* n:"BrtBeginRichFilterColumn", */
    T: 1
  },
  /*::[*/
  5085: {
    /* n:"BrtEndRichFilterColumn", */
    T: -1
  },
  /*::[*/
  5086: {
    /* n:"BrtBeginCustomRichFilters", */
    T: 1
  },
  /*::[*/
  5087: {
    /* n:"BrtEndCustomRichFilters", */
    T: -1
  },
  /*::[*/
  5088: {
    /* n:"BrtCustomRichFilter" */
  },
  /*::[*/
  5089: {
    /* n:"BrtTop10RichFilter" */
  },
  /*::[*/
  5090: {
    /* n:"BrtDynamicRichFilter" */
  },
  /*::[*/
  5092: {
    /* n:"BrtBeginRichSortCondition", */
    T: 1
  },
  /*::[*/
  5093: {
    /* n:"BrtEndRichSortCondition", */
    T: -1
  },
  /*::[*/
  5094: {
    /* n:"BrtRichFilterDateGroupItem" */
  },
  /*::[*/
  5095: {
    /* n:"BrtBeginCalcFeatures", */
    T: 1
  },
  /*::[*/
  5096: {
    /* n:"BrtEndCalcFeatures", */
    T: -1
  },
  /*::[*/
  5097: {
    /* n:"BrtCalcFeature" */
  },
  /*::[*/
  5099: {
    /* n:"BrtExternalLinksPr" */
  },
  /*::[*/
  65535: { n: "" }
}, k4 = {
  /* [MS-XLS] 2.3 Record Enumeration 2021-08-17 */
  /*::[*/
  6: {
    /* n:"Formula", */
    f: h4
  },
  /*::[*/
  10: {
    /* n:"EOF", */
    f: y2
  },
  /*::[*/
  12: {
    /* n:"CalcCount", */
    f: i1
  },
  //
  /*::[*/
  13: {
    /* n:"CalcMode", */
    f: i1
  },
  //
  /*::[*/
  14: {
    /* n:"CalcPrecision", */
    f: f1
  },
  //
  /*::[*/
  15: {
    /* n:"CalcRefMode", */
    f: f1
  },
  //
  /*::[*/
  16: {
    /* n:"CalcDelta", */
    f: F1
  },
  //
  /*::[*/
  17: {
    /* n:"CalcIter", */
    f: f1
  },
  //
  /*::[*/
  18: {
    /* n:"Protect", */
    f: f1
  },
  /*::[*/
  19: {
    /* n:"Password", */
    f: i1
  },
  /*::[*/
  20: {
    /* n:"Header", */
    f: ar
  },
  /*::[*/
  21: {
    /* n:"Footer", */
    f: ar
  },
  /*::[*/
  23: {
    /* n:"ExternSheet", */
    f: C7
  },
  /*::[*/
  24: {
    /* n:"Lbl", */
    f: ir
  },
  /*::[*/
  25: {
    /* n:"WinProtect", */
    f: f1
  },
  /*::[*/
  26: {
    /* n:"VerticalPageBreaks", */
  },
  /*::[*/
  27: {
    /* n:"HorizontalPageBreaks", */
  },
  /*::[*/
  28: {
    /* n:"Note", */
    f: bs
  },
  /*::[*/
  29: {
    /* n:"Selection", */
  },
  /*::[*/
  34: {
    /* n:"Date1904", */
    f: f1
  },
  /*::[*/
  35: {
    /* n:"ExternName", */
    f: nr
  },
  /*::[*/
  38: {
    /* n:"LeftMargin", */
    f: F1
  },
  // *
  /*::[*/
  39: {
    /* n:"RightMargin", */
    f: F1
  },
  // *
  /*::[*/
  40: {
    /* n:"TopMargin", */
    f: F1
  },
  // *
  /*::[*/
  41: {
    /* n:"BottomMargin", */
    f: F1
  },
  // *
  /*::[*/
  42: {
    /* n:"PrintRowCol", */
    f: f1
  },
  /*::[*/
  43: {
    /* n:"PrintGrid", */
    f: f1
  },
  /*::[*/
  47: {
    /* n:"FilePass", */
    f: Pc
  },
  /*::[*/
  49: {
    /* n:"Font", */
    f: os
  },
  /*::[*/
  51: {
    /* n:"PrintSize", */
    f: i1
  },
  /*::[*/
  60: {
    /* n:"Continue", */
  },
  /*::[*/
  61: {
    /* n:"Window1", */
    f: ss
  },
  /*::[*/
  64: {
    /* n:"Backup", */
    f: f1
  },
  /*::[*/
  65: {
    /* n:"Pane", */
    f: fs
  },
  /*::[*/
  66: {
    /* n:"CodePage", */
    f: i1
  },
  /*::[*/
  77: {
    /* n:"Pls", */
  },
  /*::[*/
  80: {
    /* n:"DCon", */
  },
  /*::[*/
  81: {
    /* n:"DConRef", */
  },
  /*::[*/
  82: {
    /* n:"DConName", */
  },
  /*::[*/
  85: {
    /* n:"DefColWidth", */
    f: i1
  },
  /*::[*/
  89: {
    /* n:"XCT", */
  },
  /*::[*/
  90: {
    /* n:"CRN", */
  },
  /*::[*/
  91: {
    /* n:"FileSharing", */
  },
  /*::[*/
  92: {
    /* n:"WriteAccess", */
    f: Zi
  },
  /*::[*/
  93: {
    /* n:"Obj", */
    f: Os
  },
  /*::[*/
  94: {
    /* n:"Uncalced", */
  },
  /*::[*/
  95: {
    /* n:"CalcSaveRecalc", */
    f: f1
  },
  //
  /*::[*/
  96: {
    /* n:"Template", */
  },
  /*::[*/
  97: {
    /* n:"Intl", */
  },
  /*::[*/
  99: {
    /* n:"ObjProtect", */
    f: f1
  },
  /*::[*/
  125: {
    /* n:"ColInfo", */
    f: S7
  },
  /*::[*/
  128: {
    /* n:"Guts", */
    f: ws
  },
  /*::[*/
  129: {
    /* n:"WsBool", */
    f: Qi
  },
  /*::[*/
  130: {
    /* n:"GridSet", */
    f: i1
  },
  /*::[*/
  131: {
    /* n:"HCenter", */
    f: f1
  },
  /*::[*/
  132: {
    /* n:"VCenter", */
    f: f1
  },
  /*::[*/
  133: {
    /* n:"BoundSheet8", */
    f: es
  },
  /*::[*/
  134: {
    /* n:"WriteProtect", */
  },
  /*::[*/
  140: {
    /* n:"Country", */
    f: Bs
  },
  /*::[*/
  141: {
    /* n:"HideObj", */
    f: i1
  },
  /*::[*/
  144: {
    /* n:"Sort", */
  },
  /*::[*/
  146: {
    /* n:"Palette", */
    f: Hs
  },
  /*::[*/
  151: {
    /* n:"Sync", */
  },
  /*::[*/
  152: {
    /* n:"LPr", */
  },
  /*::[*/
  153: {
    /* n:"DxGCol", */
  },
  /*::[*/
  154: {
    /* n:"FnGroupName", */
  },
  /*::[*/
  155: {
    /* n:"FilterMode", */
  },
  /*::[*/
  156: {
    /* n:"BuiltInFnGroupCount", */
    f: i1
  },
  /*::[*/
  157: {
    /* n:"AutoFilterInfo", */
  },
  /*::[*/
  158: {
    /* n:"AutoFilter", */
  },
  /*::[*/
  160: {
    /* n:"Scl", */
    f: zs
  },
  /*::[*/
  161: {
    /* n:"Setup", */
    f: Vs
  },
  /*::[*/
  174: {
    /* n:"ScenMan", */
  },
  /*::[*/
  175: {
    /* n:"SCENARIO", */
  },
  /*::[*/
  176: {
    /* n:"SxView", */
  },
  /*::[*/
  177: {
    /* n:"Sxvd", */
  },
  /*::[*/
  178: {
    /* n:"SXVI", */
  },
  /*::[*/
  180: {
    /* n:"SxIvd", */
  },
  /*::[*/
  181: {
    /* n:"SXLI", */
  },
  /*::[*/
  182: {
    /* n:"SXPI", */
  },
  /*::[*/
  184: {
    /* n:"DocRoute", */
  },
  /*::[*/
  185: {
    /* n:"RecipName", */
  },
  /*::[*/
  189: {
    /* n:"MulRk", */
    f: ps
  },
  /*::[*/
  190: {
    /* n:"MulBlank", */
    f: ms
  },
  /*::[*/
  193: {
    /* n:"Mms", */
    f: y2
  },
  /*::[*/
  197: {
    /* n:"SXDI", */
  },
  /*::[*/
  198: {
    /* n:"SXDB", */
  },
  /*::[*/
  199: {
    /* n:"SXFDB", */
  },
  /*::[*/
  200: {
    /* n:"SXDBB", */
  },
  /*::[*/
  201: {
    /* n:"SXNum", */
  },
  /*::[*/
  202: {
    /* n:"SxBool", */
    f: f1
  },
  /*::[*/
  203: {
    /* n:"SxErr", */
  },
  /*::[*/
  204: {
    /* n:"SXInt", */
  },
  /*::[*/
  205: {
    /* n:"SXString", */
  },
  /*::[*/
  206: {
    /* n:"SXDtr", */
  },
  /*::[*/
  207: {
    /* n:"SxNil", */
  },
  /*::[*/
  208: {
    /* n:"SXTbl", */
  },
  /*::[*/
  209: {
    /* n:"SXTBRGIITM", */
  },
  /*::[*/
  210: {
    /* n:"SxTbpg", */
  },
  /*::[*/
  211: {
    /* n:"ObProj", */
  },
  /*::[*/
  213: {
    /* n:"SXStreamID", */
  },
  /*::[*/
  215: {
    /* n:"DBCell", */
  },
  /*::[*/
  216: {
    /* n:"SXRng", */
  },
  /*::[*/
  217: {
    /* n:"SxIsxoper", */
  },
  /*::[*/
  218: {
    /* n:"BookBool", */
    f: i1
  },
  /*::[*/
  220: {
    /* n:"DbOrParamQry", */
  },
  /*::[*/
  221: {
    /* n:"ScenarioProtect", */
    f: f1
  },
  /*::[*/
  222: {
    /* n:"OleObjectSize", */
  },
  /*::[*/
  224: {
    /* n:"XF", */
    f: gs
  },
  /*::[*/
  225: {
    /* n:"InterfaceHdr", */
    f: qi
  },
  /*::[*/
  226: {
    /* n:"InterfaceEnd", */
    f: y2
  },
  /*::[*/
  227: {
    /* n:"SXVS", */
  },
  /*::[*/
  229: {
    /* n:"MergeCells", */
    f: Ds
  },
  /*::[*/
  233: {
    /* n:"BkHim", */
  },
  /*::[*/
  235: {
    /* n:"MsoDrawingGroup", */
  },
  /*::[*/
  236: {
    /* n:"MsoDrawing", */
  },
  /*::[*/
  237: {
    /* n:"MsoDrawingSelection", */
  },
  /*::[*/
  239: {
    /* n:"PhoneticInfo", */
  },
  /*::[*/
  240: {
    /* n:"SxRule", */
  },
  /*::[*/
  241: {
    /* n:"SXEx", */
  },
  /*::[*/
  242: {
    /* n:"SxFilt", */
  },
  /*::[*/
  244: {
    /* n:"SxDXF", */
  },
  /*::[*/
  245: {
    /* n:"SxItm", */
  },
  /*::[*/
  246: {
    /* n:"SxName", */
  },
  /*::[*/
  247: {
    /* n:"SxSelect", */
  },
  /*::[*/
  248: {
    /* n:"SXPair", */
  },
  /*::[*/
  249: {
    /* n:"SxFmla", */
  },
  /*::[*/
  251: {
    /* n:"SxFormat", */
  },
  /*::[*/
  252: {
    /* n:"SST", */
    f: rs
  },
  /*::[*/
  253: {
    /* n:"LabelSst", */
    f: ls
  },
  /*::[*/
  255: {
    /* n:"ExtSST", */
    f: ts
  },
  /*::[*/
  256: {
    /* n:"SXVDEx", */
  },
  /*::[*/
  259: {
    /* n:"SXFormula", */
  },
  /*::[*/
  290: {
    /* n:"SXDBEx", */
  },
  /*::[*/
  311: {
    /* n:"RRDInsDel", */
  },
  /*::[*/
  312: {
    /* n:"RRDHead", */
  },
  /*::[*/
  315: {
    /* n:"RRDChgCell", */
  },
  /*::[*/
  317: {
    /* n:"RRTabId", */
    f: v7
  },
  /*::[*/
  318: {
    /* n:"RRDRenSheet", */
  },
  /*::[*/
  319: {
    /* n:"RRSort", */
  },
  /*::[*/
  320: {
    /* n:"RRDMove", */
  },
  /*::[*/
  330: {
    /* n:"RRFormat", */
  },
  /*::[*/
  331: {
    /* n:"RRAutoFmt", */
  },
  /*::[*/
  333: {
    /* n:"RRInsertSh", */
  },
  /*::[*/
  334: {
    /* n:"RRDMoveBegin", */
  },
  /*::[*/
  335: {
    /* n:"RRDMoveEnd", */
  },
  /*::[*/
  336: {
    /* n:"RRDInsDelBegin", */
  },
  /*::[*/
  337: {
    /* n:"RRDInsDelEnd", */
  },
  /*::[*/
  338: {
    /* n:"RRDConflict", */
  },
  /*::[*/
  339: {
    /* n:"RRDDefName", */
  },
  /*::[*/
  340: {
    /* n:"RRDRstEtxp", */
  },
  /*::[*/
  351: {
    /* n:"LRng", */
  },
  /*::[*/
  352: {
    /* n:"UsesELFs", */
    f: f1
  },
  /*::[*/
  353: {
    /* n:"DSF", */
    f: y2
  },
  /*::[*/
  401: {
    /* n:"CUsr", */
  },
  /*::[*/
  402: {
    /* n:"CbUsr", */
  },
  /*::[*/
  403: {
    /* n:"UsrInfo", */
  },
  /*::[*/
  404: {
    /* n:"UsrExcl", */
  },
  /*::[*/
  405: {
    /* n:"FileLock", */
  },
  /*::[*/
  406: {
    /* n:"RRDInfo", */
  },
  /*::[*/
  407: {
    /* n:"BCUsrs", */
  },
  /*::[*/
  408: {
    /* n:"UsrChk", */
  },
  /*::[*/
  425: {
    /* n:"UserBView", */
  },
  /*::[*/
  426: {
    /* n:"UserSViewBegin", */
  },
  /*::[*/
  427: {
    /* n:"UserSViewEnd", */
  },
  /*::[*/
  428: {
    /* n:"RRDUserView", */
  },
  /*::[*/
  429: {
    /* n:"Qsi", */
  },
  /*::[*/
  430: {
    /* n:"SupBook", */
    f: Ss
  },
  /*::[*/
  431: {
    /* n:"Prot4Rev", */
    f: f1
  },
  /*::[*/
  432: {
    /* n:"CondFmt", */
  },
  /*::[*/
  433: {
    /* n:"CF", */
  },
  /*::[*/
  434: {
    /* n:"DVal", */
  },
  /*::[*/
  437: {
    /* n:"DConBin", */
  },
  /*::[*/
  438: {
    /* n:"TxO", */
    f: Ns
  },
  /*::[*/
  439: {
    /* n:"RefreshAll", */
    f: f1
  },
  //
  /*::[*/
  440: {
    /* n:"HLink", */
    f: Ps
  },
  /*::[*/
  441: {
    /* n:"Lel", */
  },
  /*::[*/
  442: {
    /* n:"CodeName", */
    f: te
  },
  /*::[*/
  443: {
    /* n:"SXFDBType", */
  },
  /*::[*/
  444: {
    /* n:"Prot4RevPass", */
    f: i1
  },
  /*::[*/
  445: {
    /* n:"ObNoMacros", */
  },
  /*::[*/
  446: {
    /* n:"Dv", */
  },
  /*::[*/
  448: {
    /* n:"Excel9File", */
    f: y2
  },
  /*::[*/
  449: {
    /* n:"RecalcId", */
    f: is,
    r: 2
  },
  /*::[*/
  450: {
    /* n:"EntExU2", */
    f: y2
  },
  /*::[*/
  512: {
    /* n:"Dimensions", */
    f: tr
  },
  /*::[*/
  513: {
    /* n:"Blank", */
    f: js
  },
  /*::[*/
  515: {
    /* n:"Number", */
    f: Cs
  },
  /*::[*/
  516: {
    /* n:"Label", */
    f: hs
  },
  /*::[*/
  517: {
    /* n:"BoolErr", */
    f: ks
  },
  /*::[*/
  519: {
    /* n:"String", */
    f: $s
  },
  /*::[*/
  520: {
    /* n:"Row", */
    f: as
  },
  /*::[*/
  523: {
    /* n:"Index", */
  },
  /*::[*/
  545: {
    /* n:"Array", */
    f: cr
  },
  /*::[*/
  549: {
    /* n:"DefaultRowHeight", */
    f: rr
  },
  /*::[*/
  566: {
    /* n:"Table", */
  },
  /*::[*/
  574: {
    /* n:"Window2", */
    f: cs
  },
  /*::[*/
  638: {
    /* n:"RK", */
    f: ds
  },
  /*::[*/
  659: {
    /* n:"Style", */
  },
  /*::[*/
  1048: {
    /* n:"BigName", */
  },
  /*::[*/
  1054: {
    /* n:"Format", */
    f: us
  },
  /*::[*/
  1084: {
    /* n:"ContinueBigName", */
  },
  /*::[*/
  1212: {
    /* n:"ShrFmla", */
    f: Fs
  },
  /*::[*/
  2048: {
    /* n:"HLinkTooltip", */
    f: Ls
  },
  /*::[*/
  2049: {
    /* n:"WebPub", */
  },
  /*::[*/
  2050: {
    /* n:"QsiSXTag", */
  },
  /*::[*/
  2051: {
    /* n:"DBQueryExt", */
  },
  /*::[*/
  2052: {
    /* n:"ExtString", */
  },
  /*::[*/
  2053: {
    /* n:"TxtQry", */
  },
  /*::[*/
  2054: {
    /* n:"Qsir", */
  },
  /*::[*/
  2055: {
    /* n:"Qsif", */
  },
  /*::[*/
  2056: {
    /* n:"RRDTQSIF", */
  },
  /*::[*/
  2057: {
    /* n:"BOF", */
    f: ge
  },
  /*::[*/
  2058: {
    /* n:"OleDbConn", */
  },
  /*::[*/
  2059: {
    /* n:"WOpt", */
  },
  /*::[*/
  2060: {
    /* n:"SXViewEx", */
  },
  /*::[*/
  2061: {
    /* n:"SXTH", */
  },
  /*::[*/
  2062: {
    /* n:"SXPIEx", */
  },
  /*::[*/
  2063: {
    /* n:"SXVDTEx", */
  },
  /*::[*/
  2064: {
    /* n:"SXViewEx9", */
  },
  /*::[*/
  2066: {
    /* n:"ContinueFrt", */
  },
  /*::[*/
  2067: {
    /* n:"RealTimeData", */
  },
  /*::[*/
  2128: {
    /* n:"ChartFrtInfo", */
  },
  /*::[*/
  2129: {
    /* n:"FrtWrapper", */
  },
  /*::[*/
  2130: {
    /* n:"StartBlock", */
  },
  /*::[*/
  2131: {
    /* n:"EndBlock", */
  },
  /*::[*/
  2132: {
    /* n:"StartObject", */
  },
  /*::[*/
  2133: {
    /* n:"EndObject", */
  },
  /*::[*/
  2134: {
    /* n:"CatLab", */
  },
  /*::[*/
  2135: {
    /* n:"YMult", */
  },
  /*::[*/
  2136: {
    /* n:"SXViewLink", */
  },
  /*::[*/
  2137: {
    /* n:"PivotChartBits", */
  },
  /*::[*/
  2138: {
    /* n:"FrtFontList", */
  },
  /*::[*/
  2146: {
    /* n:"SheetExt", */
  },
  /*::[*/
  2147: {
    /* n:"BookExt", */
    r: 12
  },
  /*::[*/
  2148: {
    /* n:"SXAddl", */
  },
  /*::[*/
  2149: {
    /* n:"CrErr", */
  },
  /*::[*/
  2150: {
    /* n:"HFPicture", */
  },
  /*::[*/
  2151: {
    /* n:"FeatHdr", */
    f: y2
  },
  /*::[*/
  2152: {
    /* n:"Feat", */
  },
  /*::[*/
  2154: {
    /* n:"DataLabExt", */
  },
  /*::[*/
  2155: {
    /* n:"DataLabExtContents", */
  },
  /*::[*/
  2156: {
    /* n:"CellWatch", */
  },
  /*::[*/
  2161: {
    /* n:"FeatHdr11", */
  },
  /*::[*/
  2162: {
    /* n:"Feature11", */
  },
  /*::[*/
  2164: {
    /* n:"DropDownObjIds", */
  },
  /*::[*/
  2165: {
    /* n:"ContinueFrt11", */
  },
  /*::[*/
  2166: {
    /* n:"DConn", */
  },
  /*::[*/
  2167: {
    /* n:"List12", */
  },
  /*::[*/
  2168: {
    /* n:"Feature12", */
  },
  /*::[*/
  2169: {
    /* n:"CondFmt12", */
  },
  /*::[*/
  2170: {
    /* n:"CF12", */
  },
  /*::[*/
  2171: {
    /* n:"CFEx", */
  },
  /*::[*/
  2172: {
    /* n:"XFCRC", */
    f: Ws,
    r: 12
  },
  /*::[*/
  2173: {
    /* n:"XFExt", */
    f: Ef,
    r: 12
  },
  /*::[*/
  2174: {
    /* n:"AutoFilter12", */
  },
  /*::[*/
  2175: {
    /* n:"ContinueFrt12", */
  },
  /*::[*/
  2180: {
    /* n:"MDTInfo", */
  },
  /*::[*/
  2181: {
    /* n:"MDXStr", */
  },
  /*::[*/
  2182: {
    /* n:"MDXTuple", */
  },
  /*::[*/
  2183: {
    /* n:"MDXSet", */
  },
  /*::[*/
  2184: {
    /* n:"MDXProp", */
  },
  /*::[*/
  2185: {
    /* n:"MDXKPI", */
  },
  /*::[*/
  2186: {
    /* n:"MDB", */
  },
  /*::[*/
  2187: {
    /* n:"PLV", */
  },
  /*::[*/
  2188: {
    /* n:"Compat12", */
    f: f1,
    r: 12
  },
  /*::[*/
  2189: {
    /* n:"DXF", */
  },
  /*::[*/
  2190: {
    /* n:"TableStyles", */
    r: 12
  },
  /*::[*/
  2191: {
    /* n:"TableStyle", */
  },
  /*::[*/
  2192: {
    /* n:"TableStyleElement", */
  },
  /*::[*/
  2194: {
    /* n:"StyleExt", */
  },
  /*::[*/
  2195: {
    /* n:"NamePublish", */
  },
  /*::[*/
  2196: {
    /* n:"NameCmt", */
    f: As,
    r: 12
  },
  /*::[*/
  2197: {
    /* n:"SortData", */
  },
  /*::[*/
  2198: {
    /* n:"Theme", */
    f: pf,
    r: 12
  },
  /*::[*/
  2199: {
    /* n:"GUIDTypeLib", */
  },
  /*::[*/
  2200: {
    /* n:"FnGrp12", */
  },
  /*::[*/
  2201: {
    /* n:"NameFnGrp12", */
  },
  /*::[*/
  2202: {
    /* n:"MTRSettings", */
    f: ys,
    r: 12
  },
  /*::[*/
  2203: {
    /* n:"CompressPictures", */
    f: y2
  },
  /*::[*/
  2204: {
    /* n:"HeaderFooter", */
  },
  /*::[*/
  2205: {
    /* n:"CrtLayout12", */
  },
  /*::[*/
  2206: {
    /* n:"CrtMlFrt", */
  },
  /*::[*/
  2207: {
    /* n:"CrtMlFrtContinue", */
  },
  /*::[*/
  2211: {
    /* n:"ForceFullCalculation", */
    f: ns
  },
  /*::[*/
  2212: {
    /* n:"ShapePropsStream", */
  },
  /*::[*/
  2213: {
    /* n:"TextPropsStream", */
  },
  /*::[*/
  2214: {
    /* n:"RichTextStream", */
  },
  /*::[*/
  2215: {
    /* n:"CrtLayout12A", */
  },
  /*::[*/
  4097: {
    /* n:"Units", */
  },
  /*::[*/
  4098: {
    /* n:"Chart", */
  },
  /*::[*/
  4099: {
    /* n:"Series", */
  },
  /*::[*/
  4102: {
    /* n:"DataFormat", */
  },
  /*::[*/
  4103: {
    /* n:"LineFormat", */
  },
  /*::[*/
  4105: {
    /* n:"MarkerFormat", */
  },
  /*::[*/
  4106: {
    /* n:"AreaFormat", */
  },
  /*::[*/
  4107: {
    /* n:"PieFormat", */
  },
  /*::[*/
  4108: {
    /* n:"AttachedLabel", */
  },
  /*::[*/
  4109: {
    /* n:"SeriesText", */
  },
  /*::[*/
  4116: {
    /* n:"ChartFormat", */
  },
  /*::[*/
  4117: {
    /* n:"Legend", */
  },
  /*::[*/
  4118: {
    /* n:"SeriesList", */
  },
  /*::[*/
  4119: {
    /* n:"Bar", */
  },
  /*::[*/
  4120: {
    /* n:"Line", */
  },
  /*::[*/
  4121: {
    /* n:"Pie", */
  },
  /*::[*/
  4122: {
    /* n:"Area", */
  },
  /*::[*/
  4123: {
    /* n:"Scatter", */
  },
  /*::[*/
  4124: {
    /* n:"CrtLine", */
  },
  /*::[*/
  4125: {
    /* n:"Axis", */
  },
  /*::[*/
  4126: {
    /* n:"Tick", */
  },
  /*::[*/
  4127: {
    /* n:"ValueRange", */
  },
  /*::[*/
  4128: {
    /* n:"CatSerRange", */
  },
  /*::[*/
  4129: {
    /* n:"AxisLine", */
  },
  /*::[*/
  4130: {
    /* n:"CrtLink", */
  },
  /*::[*/
  4132: {
    /* n:"DefaultText", */
  },
  /*::[*/
  4133: {
    /* n:"Text", */
  },
  /*::[*/
  4134: {
    /* n:"FontX", */
    f: i1
  },
  /*::[*/
  4135: {
    /* n:"ObjectLink", */
  },
  /*::[*/
  4146: {
    /* n:"Frame", */
  },
  /*::[*/
  4147: {
    /* n:"Begin", */
  },
  /*::[*/
  4148: {
    /* n:"End", */
  },
  /*::[*/
  4149: {
    /* n:"PlotArea", */
  },
  /*::[*/
  4154: {
    /* n:"Chart3d", */
  },
  /*::[*/
  4156: {
    /* n:"PicF", */
  },
  /*::[*/
  4157: {
    /* n:"DropBar", */
  },
  /*::[*/
  4158: {
    /* n:"Radar", */
  },
  /*::[*/
  4159: {
    /* n:"Surf", */
  },
  /*::[*/
  4160: {
    /* n:"RadarArea", */
  },
  /*::[*/
  4161: {
    /* n:"AxisParent", */
  },
  /*::[*/
  4163: {
    /* n:"LegendException", */
  },
  /*::[*/
  4164: {
    /* n:"ShtProps", */
    f: Gs
  },
  /*::[*/
  4165: {
    /* n:"SerToCrt", */
  },
  /*::[*/
  4166: {
    /* n:"AxesUsed", */
  },
  /*::[*/
  4168: {
    /* n:"SBaseRef", */
  },
  /*::[*/
  4170: {
    /* n:"SerParent", */
  },
  /*::[*/
  4171: {
    /* n:"SerAuxTrend", */
  },
  /*::[*/
  4174: {
    /* n:"IFmtRecord", */
  },
  /*::[*/
  4175: {
    /* n:"Pos", */
  },
  /*::[*/
  4176: {
    /* n:"AlRuns", */
  },
  /*::[*/
  4177: {
    /* n:"BRAI", */
  },
  /*::[*/
  4187: {
    /* n:"SerAuxErrBar", */
  },
  /*::[*/
  4188: {
    /* n:"ClrtClient", */
    f: Us
  },
  /*::[*/
  4189: {
    /* n:"SerFmt", */
  },
  /*::[*/
  4191: {
    /* n:"Chart3DBarShape", */
  },
  /*::[*/
  4192: {
    /* n:"Fbi", */
  },
  /*::[*/
  4193: {
    /* n:"BopPop", */
  },
  /*::[*/
  4194: {
    /* n:"AxcExt", */
  },
  /*::[*/
  4195: {
    /* n:"Dat", */
  },
  /*::[*/
  4196: {
    /* n:"PlotGrowth", */
  },
  /*::[*/
  4197: {
    /* n:"SIIndex", */
  },
  /*::[*/
  4198: {
    /* n:"GelFrame", */
  },
  /*::[*/
  4199: {
    /* n:"BopPopCustom", */
  },
  /*::[*/
  4200: {
    /* n:"Fbi2", */
  },
  /*::[*/
  0: {
    /* n:"Dimensions", */
    f: tr
  },
  /*::[*/
  1: {
    /* n:"BIFF2BLANK", */
  },
  /*::[*/
  2: {
    /* n:"BIFF2INT", */
    f: Js
  },
  /*::[*/
  3: {
    /* n:"BIFF2NUM", */
    f: Ys
  },
  /*::[*/
  4: {
    /* n:"BIFF2STR", */
    f: Ks
  },
  /*::[*/
  5: {
    /* n:"BIFF2BOOLERR", */
    f: Zs
  },
  /*::[*/
  7: {
    /* n:"String", */
    f: qs
  },
  /*::[*/
  8: {
    /* n:"BIFF2ROW", */
  },
  /*::[*/
  9: {
    /* n:"BOF", */
    f: ge
  },
  /*::[*/
  11: {
    /* n:"Index", */
  },
  /*::[*/
  22: {
    /* n:"ExternCount", */
    f: i1
  },
  /*::[*/
  30: {
    /* n:"BIFF2FORMAT", */
    f: xs
  },
  /*::[*/
  31: {
    /* n:"BIFF2FMTCNT", */
  },
  /* 16-bit cnt of BIFF2FORMAT records */
  /*::[*/
  32: {
    /* n:"BIFF2COLINFO", */
  },
  /*::[*/
  33: {
    /* n:"Array", */
    f: cr
  },
  /*::[*/
  36: {
    /* n:"COLWIDTH", */
  },
  /*::[*/
  37: {
    /* n:"DefaultRowHeight", */
    f: rr
  },
  // 0x002c ??
  // 0x002d ??
  // 0x002e ??
  // 0x0030 FONTCOUNT: number of fonts
  /*::[*/
  50: {
    /* n:"BIFF2FONTXTRA", */
    f: Qs
  },
  // 0x0035: INFOOPTS
  // 0x0036: TABLE (BIFF2 only)
  // 0x0037: TABLE2 (BIFF2 only)
  // 0x0038: WNDESK
  // 0x0039 ??
  // 0x003a: BEGINPREF
  // 0x003b: ENDPREF
  /*::[*/
  62: {
    /* n:"BIFF2WINDOW2", */
  },
  // 0x003f ??
  // 0x0046: SHOWSCROLL
  // 0x0047: SHOWFORMULA
  // 0x0048: STATUSBAR
  // 0x0049: SHORTMENUS
  // 0x004A:
  // 0x004B:
  // 0x004C:
  // 0x004E:
  // 0x004F:
  // 0x0058: TOOLBAR (BIFF3)
  /* - - - */
  /*::[*/
  52: {
    /* n:"DDEObjName", */
  },
  /*::[*/
  67: {
    /* n:"BIFF2XF", */
    f: _s
  },
  /*::[*/
  68: {
    /* n:"BIFF2XFINDEX", */
    f: i1
  },
  /*::[*/
  69: {
    /* n:"BIFF2FONTCLR", */
  },
  /*::[*/
  86: {
    /* n:"BIFF4FMTCNT", */
  },
  /* 16-bit cnt, similar to BIFF2 */
  /*::[*/
  126: {
    /* n:"RK", */
  },
  /* Not necessarily same as 0x027e */
  /*::[*/
  127: {
    /* n:"ImData", */
    f: Xs
  },
  /*::[*/
  135: {
    /* n:"Addin", */
  },
  /*::[*/
  136: {
    /* n:"Edg", */
  },
  /*::[*/
  137: {
    /* n:"Pub", */
  },
  // 0x8A
  // 0x8B LH: alternate menu key flag (BIFF3/4)
  // 0x8E
  /*::[*/
  143: {
    /* n:"BIFF4SheetInfo", */
    f: rc
  },
  /*::[*/
  145: {
    /* n:"Sub", */
  },
  // 0x93 STYLE
  /*::[*/
  148: {
    /* n:"LHRecord", */
  },
  /*::[*/
  149: {
    /* n:"LHNGraph", */
  },
  /*::[*/
  150: {
    /* n:"Sound", */
  },
  // 0xA2 FNPROTO: function prototypes (BIFF4)
  // 0xA3
  // 0xA8
  /*::[*/
  169: {
    /* n:"CoordList", */
  },
  /*::[*/
  171: {
    /* n:"GCW", */
  },
  /*::[*/
  188: {
    /* n:"ShrFmla", */
  },
  /* Not necessarily same as 0x04bc */
  /*::[*/
  191: {
    /* n:"ToolbarHdr", */
  },
  /*::[*/
  192: {
    /* n:"ToolbarEnd", */
  },
  /*::[*/
  194: {
    /* n:"AddMenu", */
  },
  /*::[*/
  195: {
    /* n:"DelMenu", */
  },
  /*::[*/
  214: {
    /* n:"RString", */
    f: ec
  },
  /*::[*/
  223: {
    /* n:"UDDesc", */
  },
  /*::[*/
  234: {
    /* n:"TabIdConf", */
  },
  /*::[*/
  354: {
    /* n:"XL5Modify", */
  },
  /*::[*/
  421: {
    /* n:"FileSharing2", */
  },
  /*::[*/
  518: {
    /* n:"Formula", */
    f: h4
  },
  /*::[*/
  521: {
    /* n:"BOF", */
    f: ge
  },
  /*::[*/
  536: {
    /* n:"Lbl", */
    f: ir
  },
  /*::[*/
  547: {
    /* n:"ExternName", */
    f: nr
  },
  /*::[*/
  561: {
    /* n:"Font", */
  },
  /*::[*/
  579: {
    /* n:"BIFF3XF", */
    f: Ts
  },
  /*::[*/
  1030: {
    /* n:"Formula", */
    f: h4
  },
  /*::[*/
  1033: {
    /* n:"BOF", */
    f: ge
  },
  /*::[*/
  1091: {
    /* n:"BIFF4XF", */
    f: Es
  },
  /*::[*/
  2157: {
    /* n:"FeatInfo", */
  },
  /*::[*/
  2163: {
    /* n:"FeatInfo11", */
  },
  /*::[*/
  2177: {
    /* n:"SXAddl12", */
  },
  /*::[*/
  2240: {
    /* n:"AutoWebPub", */
  },
  /*::[*/
  2241: {
    /* n:"ListObj", */
  },
  /*::[*/
  2242: {
    /* n:"ListField", */
  },
  /*::[*/
  2243: {
    /* n:"ListDV", */
  },
  /*::[*/
  2244: {
    /* n:"ListCondFmt", */
  },
  /*::[*/
  2245: {
    /* n:"ListCF", */
  },
  /*::[*/
  2246: {
    /* n:"FMQry", */
  },
  /*::[*/
  2247: {
    /* n:"FMSQry", */
  },
  /*::[*/
  2248: {
    /* n:"PLV", */
  },
  /*::[*/
  2249: {
    /* n:"LnExt", */
  },
  /*::[*/
  2250: {
    /* n:"MkrExt", */
  },
  /*::[*/
  2251: {
    /* n:"CrtCoopt", */
  },
  /*::[*/
  2262: {
    /* n:"FRTArchId$", */
    r: 12
  },
  /* --- multiplan 4 records --- */
  /*::[*/
  101: {
    /* n:"", */
  },
  // one per window
  /*::[*/
  102: {
    /* n:"", */
  },
  // calc settings
  /*::[*/
  105: {
    /* n:"", */
  },
  // print header
  /*::[*/
  106: {
    /* n:"", */
  },
  // print footer
  /*::[*/
  107: {
    /* n:"", */
  },
  // print settings
  /*::[*/
  109: {
    /* n:"", */
  },
  // one per window
  /*::[*/
  112: {
    /* n:"", */
  },
  // includes default col width
  /*::[*/
  114: {
    /* n:"", */
  },
  // includes selected cell
  /*::[*/
  29282: {}
};
function V1(e, t, r, a) {
  var n = t;
  if (!isNaN(n)) {
    var i = (r || []).length || 0, c = e.next(4);
    c.write_shift(2, n), c.write_shift(2, i), /*:: len != null &&*/
    i > 0 && a7(r) && e.push(r);
  }
}
function _r(e, t) {
  var r = t || {}, a = r.dense != null ? r.dense : b9, n = {};
  a && (n["!data"] = []), e = e.replace(/<!--.*?-->/g, "");
  var i = e.match(/<table/i);
  if (!i)
    throw new Error("Invalid HTML: could not find <table>");
  var c = e.match(/<\/table/i), s = i.index, f = c && c.index || e.length, o = _n(e.slice(s, f), /(:?<tr[^>]*>)/i, "<tr>"), l = -1, d = 0, u = 0, h = 0, p = { s: { r: 1e7, c: 1e7 }, e: { r: 0, c: 0 } }, v = [];
  for (s = 0; s < o.length; ++s) {
    var x = o[s].trim(), m = x.slice(0, 3).toLowerCase();
    if (m == "<tr") {
      if (++l, r.sheetRows && r.sheetRows <= l) {
        --l;
        break;
      }
      d = 0;
      continue;
    }
    if (!(m != "<td" && m != "<th")) {
      var T = x.split(/<\/t[dh]>/i);
      for (f = 0; f < T.length; ++f) {
        var g = T[f].trim();
        if (g.match(/<t[dh]/i)) {
          for (var O = g, H = 0; O.charAt(0) == "<" && (H = O.indexOf(">")) > -1; )
            O = O.slice(H + 1);
          for (var W = 0; W < v.length; ++W) {
            var E = v[W];
            E.s.c == d && E.s.r < l && l <= E.e.r && (d = E.e.c + 1, W = -1);
          }
          var b = x0(g.slice(0, g.indexOf(">")));
          h = b.colspan ? +b.colspan : 1, ((u = +b.rowspan) > 1 || h > 1) && v.push({ s: { r: l, c: d }, e: { r: l + (u || 1) - 1, c: d + h - 1 } });
          var I = b.t || b["data-t"] || "";
          if (!O.length) {
            d += h;
            continue;
          }
          if (O = j6(O), p.s.r > l && (p.s.r = l), p.e.r < l && (p.e.r = l), p.s.c > d && (p.s.c = d), p.e.c < d && (p.e.c = d), !O.length) {
            d += h;
            continue;
          }
          var P = { t: "s", v: O };
          r.raw || !O.trim().length || I == "s" || (O === "TRUE" ? P = { t: "b", v: !0 } : O === "FALSE" ? P = { t: "b", v: !1 } : isNaN(z1(O)) ? isNaN($3(O).getDate()) || (P = { t: "d", v: w1(O) }, r.UTC === !1 && (P.v = J2(P.v)), r.cellDates || (P = { t: "n", v: v1(P.v) }), P.z = r.dateNF || k0[14]) : P = { t: "n", v: z1(O) }), P.cellText !== !1 && (P.w = O), a ? (n["!data"][l] || (n["!data"][l] = []), n["!data"][l][d] = P) : n[H0({ r: l, c: d })] = P, d += h;
        }
      }
    }
  }
  return n["!ref"] = M0(p), v.length && (n["!merges"] = v), n;
}
function nu(e, t, r, a) {
  for (var n = e["!merges"] || [], i = [], c = {}, s = e["!data"] != null, f = t.s.c; f <= t.e.c; ++f) {
    for (var o = 0, l = 0, d = 0; d < n.length; ++d)
      if (!(n[d].s.r > r || n[d].s.c > f) && !(n[d].e.r < r || n[d].e.c < f)) {
        if (n[d].s.r < r || n[d].s.c < f) {
          o = -1;
          break;
        }
        o = n[d].e.r - n[d].s.r + 1, l = n[d].e.c - n[d].s.c + 1;
        break;
      }
    if (!(o < 0)) {
      var u = W0(f) + j0(r), h = s ? (e["!data"][r] || [])[f] : e[u], p = h && h.v != null && (h.h || Ie(h.w || (M2(h), h.w) || "")) || "";
      c = {}, o > 1 && (c.rowspan = o), l > 1 && (c.colspan = l), a.editable ? p = '<span contenteditable="true">' + p + "</span>" : h && (c["data-t"] = h && h.t || "z", h.v != null && (c["data-v"] = h.v instanceof Date ? h.v.toISOString() : h.v), h.z != null && (c["data-z"] = h.z), h.l && (h.l.Target || "#").charAt(0) != "#" && (p = '<a href="' + Ie(h.l.Target) + '">' + p + "</a>")), c.id = (a.id || "sjs") + "-" + u, i.push(Nn("td", p, c));
    }
  }
  var v = "<tr>";
  return v + i.join("") + "</tr>";
}
var iu = '<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>', su = "</body></html>";
function cu(e, t) {
  var r = e.match(/<table[\s\S]*?>[\s\S]*?<\/table>/gi);
  if (!r || r.length == 0)
    throw new Error("Invalid HTML: could not find <table>");
  if (r.length == 1) {
    var a = B2(_r(r[0], t), t);
    return a.bookType = "html", a;
  }
  var n = t5();
  return r.forEach(function(i, c) {
    se(n, _r(i, t), "Sheet" + (c + 1));
  }), n.bookType = "html", n;
}
function fu(e, t, r) {
  var a = [];
  return a.join("") + "<table" + (r && r.id ? ' id="' + r.id + '"' : "") + ">";
}
function ou(e, t) {
  var r = t || {}, a = r.header != null ? r.header : iu, n = r.footer != null ? r.footer : su, i = [a], c = Q2(e["!ref"] || "A1");
  if (i.push(fu(e, c, r)), e["!ref"])
    for (var s = c.s.r; s <= c.e.r; ++s)
      i.push(nu(e, c, s, r));
  return i.push("</table>" + n), i.join("");
}
function J7(e, t, r) {
  var a = t.rows;
  if (!a)
    throw "Unsupported origin when " + t.tagName + " is not a TABLE";
  var n = r || {}, i = e["!data"] != null, c = 0, s = 0;
  if (n.origin != null)
    if (typeof n.origin == "number")
      c = n.origin;
    else {
      var f = typeof n.origin == "string" ? y1(n.origin) : n.origin;
      c = f.r, s = f.c;
    }
  var o = Math.min(n.sheetRows || 1e7, a.length), l = { s: { r: 0, c: 0 }, e: { r: c, c: s } };
  if (e["!ref"]) {
    var d = Q2(e["!ref"]);
    l.s.r = Math.min(l.s.r, d.s.r), l.s.c = Math.min(l.s.c, d.s.c), l.e.r = Math.max(l.e.r, d.e.r), l.e.c = Math.max(l.e.c, d.e.c), c == -1 && (l.e.r = c = d.e.r + 1);
  }
  var u = [], h = 0, p = e["!rows"] || (e["!rows"] = []), v = 0, x = 0, m = 0, T = 0, g = 0, O = 0;
  for (e["!cols"] || (e["!cols"] = []); v < a.length && x < o; ++v) {
    var H = a[v];
    if (Tr(H)) {
      if (n.display)
        continue;
      p[x] = { hidden: !0 };
    }
    var W = H.cells;
    for (m = T = 0; m < W.length; ++m) {
      var E = W[m];
      if (!(n.display && Tr(E))) {
        var b = E.hasAttribute("data-v") ? E.getAttribute("data-v") : E.hasAttribute("v") ? E.getAttribute("v") : j6(E.innerHTML), I = E.getAttribute("data-z") || E.getAttribute("z");
        for (h = 0; h < u.length; ++h) {
          var P = u[h];
          P.s.c == T + s && P.s.r < x + c && x + c <= P.e.r && (T = P.e.c + 1 - s, h = -1);
        }
        O = +E.getAttribute("colspan") || 1, ((g = +E.getAttribute("rowspan") || 1) > 1 || O > 1) && u.push({ s: { r: x + c, c: T + s }, e: { r: x + c + (g || 1) - 1, c: T + s + (O || 1) - 1 } });
        var L = { t: "s", v: b }, z = E.getAttribute("data-t") || E.getAttribute("t") || "";
        b != null && (b.length == 0 ? L.t = z || "z" : n.raw || b.trim().length == 0 || z == "s" || (b === "TRUE" ? L = { t: "b", v: !0 } : b === "FALSE" ? L = { t: "b", v: !1 } : isNaN(z1(b)) ? isNaN($3(b).getDate()) || (L = { t: "d", v: w1(b) }, n.UTC && (L.v = $e(L.v)), n.cellDates || (L = { t: "n", v: v1(L.v) }), L.z = n.dateNF || k0[14]) : L = { t: "n", v: z1(b) })), L.z === void 0 && I != null && (L.z = I);
        var Y = "", f0 = E.getElementsByTagName("A");
        if (f0 && f0.length)
          for (var i0 = 0; i0 < f0.length && !(f0[i0].hasAttribute("href") && (Y = f0[i0].getAttribute("href"), Y.charAt(0) != "#")); ++i0)
            ;
        Y && Y.charAt(0) != "#" && Y.slice(0, 11).toLowerCase() != "javascript:" && (L.l = { Target: Y }), i ? (e["!data"][x + c] || (e["!data"][x + c] = []), e["!data"][x + c][T + s] = L) : e[H0({ c: T + s, r: x + c })] = L, l.e.c < T + s && (l.e.c = T + s), T += O;
      }
    }
    ++x;
  }
  return u.length && (e["!merges"] = (e["!merges"] || []).concat(u)), l.e.r = Math.max(l.e.r, x - 1 + c), e["!ref"] = M0(l), x >= o && (e["!fullref"] = M0((l.e.r = a.length - v + x - 1 + c, l))), e;
}
function q7(e, t) {
  var r = t || {}, a = {};
  return r.dense && (a["!data"] = []), J7(a, e, t);
}
function lu(e, t) {
  var r = B2(q7(e, t), t);
  return r;
}
function Tr(e) {
  var t = "", r = hu(e);
  return r && (t = r(e).getPropertyValue("display")), t || (t = e.style && e.style.display), t === "none";
}
function hu(e) {
  return e.ownerDocument.defaultView && typeof e.ownerDocument.defaultView.getComputedStyle == "function" ? e.ownerDocument.defaultView.getComputedStyle : typeof getComputedStyle == "function" ? getComputedStyle : null;
}
function uu(e) {
  var t = e.replace(/[\t\r\n]/g, " ").trim().replace(/ +/g, " ").replace(/<text:s\/>/g, " ").replace(/<text:s text:c="(\d+)"\/>/g, function(a, n) {
    return Array(parseInt(n, 10) + 1).join(" ");
  }).replace(/<text:tab[^>]*\/>/g, "	").replace(/<text:line-break\/>/g, `
`), r = R0(t.replace(/<[^>]*>/g, ""));
  return [r];
}
function Z7(e, t, r) {
  var a = r || {}, n = Xe(e);
  u1.lastIndex = 0, n = n.replace(/<!--([\s\S]*?)-->/mg, "").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm, "");
  for (var i, c, s = "", f = "", o, l = 0, d = -1, u = ""; i = u1.exec(n); )
    switch (i[3] = i[3].replace(/_.*$/, "")) {
      case "number-style":
      case "currency-style":
      case "percentage-style":
      case "date-style":
      case "time-style":
      case "text-style":
        i[1] === "/" ? (c["truncate-on-overflow"] == "false" && (s.match(/h/) ? s = s.replace(/h+/, "[$&]") : s.match(/m/) ? s = s.replace(/m+/, "[$&]") : s.match(/s/) && (s = s.replace(/s+/, "[$&]"))), a[c.name] = s, s = "") : i[0].charAt(i[0].length - 2) !== "/" && (s = "", c = x0(i[0], !1));
        break;
      case "boolean-style":
        i[1] === "/" ? (a[c.name] = "General", s = "") : i[0].charAt(i[0].length - 2) !== "/" && (s = "", c = x0(i[0], !1));
        break;
      case "boolean":
        s += "General";
        break;
      case "text":
        i[1] === "/" ? (u = n.slice(d, u1.lastIndex - i[0].length), u == "%" && c[0] == "<number:percentage-style" ? s += "%" : s += '"' + u.replace(/"/g, '""') + '"') : i[0].charAt(i[0].length - 2) !== "/" && (d = u1.lastIndex);
        break;
      case "day":
        switch (o = x0(i[0], !1), o.style) {
          case "short":
            s += "d";
            break;
          case "long":
            s += "dd";
            break;
          default:
            s += "dd";
            break;
        }
        break;
      case "day-of-week":
        switch (o = x0(i[0], !1), o.style) {
          case "short":
            s += "ddd";
            break;
          case "long":
            s += "dddd";
            break;
          default:
            s += "ddd";
            break;
        }
        break;
      case "era":
        switch (o = x0(i[0], !1), o.style) {
          case "short":
            s += "ee";
            break;
          case "long":
            s += "eeee";
            break;
          default:
            s += "eeee";
            break;
        }
        break;
      case "hours":
        switch (o = x0(i[0], !1), o.style) {
          case "short":
            s += "h";
            break;
          case "long":
            s += "hh";
            break;
          default:
            s += "hh";
            break;
        }
        break;
      case "minutes":
        switch (o = x0(i[0], !1), o.style) {
          case "short":
            s += "m";
            break;
          case "long":
            s += "mm";
            break;
          default:
            s += "mm";
            break;
        }
        break;
      case "month":
        switch (o = x0(i[0], !1), o.textual && (s += "mm"), o.style) {
          case "short":
            s += "m";
            break;
          case "long":
            s += "mm";
            break;
          default:
            s += "m";
            break;
        }
        break;
      case "seconds":
        {
          switch (o = x0(i[0], !1), o.style) {
            case "short":
              s += "s";
              break;
            case "long":
              s += "ss";
              break;
            default:
              s += "ss";
              break;
          }
          o["decimal-places"] && (s += "." + P0("0", +o["decimal-places"]));
        }
        break;
      case "year":
        switch (o = x0(i[0], !1), o.style) {
          case "short":
            s += "yy";
            break;
          case "long":
            s += "yyyy";
            break;
          default:
            s += "yy";
            break;
        }
        break;
      case "am-pm":
        s += "AM/PM";
        break;
      case "week-of-year":
      case "quarter":
        console.error("Excel does not support ODS format token " + i[3]);
        break;
      case "fill-character":
        i[1] === "/" ? (u = n.slice(d, u1.lastIndex - i[0].length), s += '"' + u.replace(/"/g, '""') + '"*') : i[0].charAt(i[0].length - 2) !== "/" && (d = u1.lastIndex);
        break;
      case "scientific-number":
        o = x0(i[0], !1), s += "0." + P0("0", +o["min-decimal-places"] || +o["decimal-places"] || 2) + P0("?", +o["decimal-places"] - +o["min-decimal-places"] || 0) + "E" + (G0(o["forced-exponent-sign"]) ? "+" : "") + P0("0", +o["min-exponent-digits"] || 2);
        break;
      case "fraction":
        o = x0(i[0], !1), +o["min-integer-digits"] ? s += P0("0", +o["min-integer-digits"]) : s += "#", s += " ", s += P0("?", +o["min-numerator-digits"] || 1), s += "/", +o["denominator-value"] ? s += o["denominator-value"] : s += P0("?", +o["min-denominator-digits"] || 1);
        break;
      case "currency-symbol":
        i[1] === "/" ? s += '"' + n.slice(d, u1.lastIndex - i[0].length).replace(/"/g, '""') + '"' : i[0].charAt(i[0].length - 2) !== "/" ? d = u1.lastIndex : s += "$";
        break;
      case "text-properties":
        switch (o = x0(i[0], !1), (o.color || "").toLowerCase().replace("#", "")) {
          case "ff0000":
          case "red":
            s = "[Red]" + s;
            break;
        }
        break;
      case "text-content":
        s += "@";
        break;
      case "map":
        o = x0(i[0], !1), R0(o.condition) == "value()>=0" ? s = a[o["apply-style-name"]] + ";" + s : console.error("ODS number format may be incorrect: " + o.condition);
        break;
      case "number":
        if (i[1] === "/")
          break;
        o = x0(i[0], !1), f = "", f += P0("0", +o["min-integer-digits"] || 1), G0(o.grouping) && (f = g2(P0("#", Math.max(0, 4 - f.length)) + f)), (+o["min-decimal-places"] || +o["decimal-places"]) && (f += "."), +o["min-decimal-places"] && (f += P0("0", +o["min-decimal-places"] || 1)), +o["decimal-places"] - (+o["min-decimal-places"] || 0) && (f += P0("0", +o["decimal-places"] - (+o["min-decimal-places"] || 0))), s += f;
        break;
      case "embedded-text":
        i[1] === "/" ? l == 0 ? s += '"' + n.slice(d, u1.lastIndex - i[0].length).replace(/"/g, '""') + '"' : s = s.slice(0, l) + '"' + n.slice(d, u1.lastIndex - i[0].length).replace(/"/g, '""') + '"' + s.slice(l) : i[0].charAt(i[0].length - 2) !== "/" && (d = u1.lastIndex, l = -+x0(i[0], !1).position || 0);
        break;
    }
  return a;
}
function Q7(e, t, r) {
  var a = t || {}, n = Xe(e), i = [], c, s, f, o = "", l = 0, d, u, h = {}, p = [], v = {};
  a.dense && (v["!data"] = []);
  var x, m, T = { value: "" }, g = "", O = 0, H = "", W = 0, E = [], b = [], I = -1, P = -1, L = { s: { r: 1e6, c: 1e7 }, e: { r: 0, c: 0 } }, z = 0, Y = r || {}, f0 = {}, i0 = [], p0 = {}, n0 = 0, v0 = 0, I0 = [], K = 1, T0 = 1, S0 = [], w0 = { Names: [], WBProps: {} }, r0 = {}, E0 = ["", ""], b0 = [], D0 = {}, F = "", B = 0, R = !1, D = !1, Z = 0;
  for (u1.lastIndex = 0, n = n.replace(/<!--([\s\S]*?)-->/mg, "").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm, ""); x = u1.exec(n); )
    switch (x[3] = x[3].replace(/_.*$/, "")) {
      case "table":
      case "工作表":
        x[1] === "/" ? (L.e.c >= L.s.c && L.e.r >= L.s.r ? v["!ref"] = M0(L) : v["!ref"] = "A1:A1", a.sheetRows > 0 && a.sheetRows <= L.e.r && (v["!fullref"] = v["!ref"], L.e.r = a.sheetRows - 1, v["!ref"] = M0(L)), i0.length && (v["!merges"] = i0), I0.length && (v["!rows"] = I0), d.name = d.名称 || d.name, typeof JSON < "u" && JSON.stringify(d), p.push(d.name), h[d.name] = v, D = !1) : x[0].charAt(x[0].length - 2) !== "/" && (d = x0(x[0], !1), I = P = -1, L.s.r = L.s.c = 1e7, L.e.r = L.e.c = 0, v = {}, a.dense && (v["!data"] = []), i0 = [], I0 = [], D = !0);
        break;
      case "table-row-group":
        x[1] === "/" ? --z : ++z;
        break;
      case "table-row":
      case "行":
        if (x[1] === "/") {
          I += K, K = 1;
          break;
        }
        if (u = x0(x[0], !1), u.行号 ? I = u.行号 - 1 : I == -1 && (I = 0), K = +u["number-rows-repeated"] || 1, K < 10)
          for (Z = 0; Z < K; ++Z)
            z > 0 && (I0[I + Z] = { level: z });
        P = -1;
        break;
      case "covered-table-cell":
        x[1] !== "/" && ++P, a.sheetStubs && (a.dense ? (v["!data"][I] || (v["!data"][I] = []), v["!data"][I][P] = { t: "z" }) : v[H0({ r: I, c: P })] = { t: "z" }), g = "", E = [];
        break;
      case "table-cell":
      case "数据":
        if (x[0].charAt(x[0].length - 2) === "/")
          ++P, T = x0(x[0], !1), T0 = parseInt(T["number-columns-repeated"] || "1", 10), m = {
            t: "z",
            v: null
            /*:: , z:null, w:"",c:[]*/
          }, T.formula && a.cellFormula != !1 && (m.f = pr(R0(T.formula))), T["style-name"] && f0[T["style-name"]] && (m.z = f0[T["style-name"]]), (T.数据类型 || T["value-type"]) == "string" && (m.t = "s", m.v = R0(T["string-value"] || ""), a.dense ? (v["!data"][I] || (v["!data"][I] = []), v["!data"][I][P] = m) : v[W0(P) + j0(I)] = m), P += T0 - 1;
        else if (x[1] !== "/") {
          ++P, g = H = "", O = W = 0, E = [], b = [], T0 = 1;
          var A = K ? I + K - 1 : I;
          if (P > L.e.c && (L.e.c = P), P < L.s.c && (L.s.c = P), I < L.s.r && (L.s.r = I), A > L.e.r && (L.e.r = A), T = x0(x[0], !1), b0 = [], D0 = {}, m = {
            t: T.数据类型 || T["value-type"],
            v: null
            /*:: , z:null, w:"",c:[]*/
          }, T["style-name"] && f0[T["style-name"]] && (m.z = f0[T["style-name"]]), a.cellFormula)
            if (T.formula && (T.formula = R0(T.formula)), T["number-matrix-columns-spanned"] && T["number-matrix-rows-spanned"] && (n0 = parseInt(T["number-matrix-rows-spanned"], 10) || 0, v0 = parseInt(T["number-matrix-columns-spanned"], 10) || 0, p0 = { s: { r: I, c: P }, e: { r: I + n0 - 1, c: P + v0 - 1 } }, m.F = M0(p0), S0.push([p0, m.F])), T.formula)
              m.f = pr(T.formula);
            else
              for (Z = 0; Z < S0.length; ++Z)
                I >= S0[Z][0].s.r && I <= S0[Z][0].e.r && P >= S0[Z][0].s.c && P <= S0[Z][0].e.c && (m.F = S0[Z][1]);
          switch ((T["number-columns-spanned"] || T["number-rows-spanned"]) && (n0 = parseInt(T["number-rows-spanned"], 10) || 0, v0 = parseInt(T["number-columns-spanned"], 10) || 0, p0 = { s: { r: I, c: P }, e: { r: I + n0 - 1, c: P + v0 - 1 } }, i0.push(p0)), T["number-columns-repeated"] && (T0 = parseInt(T["number-columns-repeated"], 10)), m.t) {
            case "boolean":
              m.t = "b", m.v = G0(T["boolean-value"]) || +T["boolean-value"] >= 1;
              break;
            case "float":
              m.t = "n", m.v = parseFloat(T.value), a.cellDates && m.z && u2(m.z) && (m.v = O2(m.v + (w0.WBProps.date1904 ? 1462 : 0)), m.t = typeof m.v == "number" ? "n" : "d");
              break;
            case "percentage":
              m.t = "n", m.v = parseFloat(T.value);
              break;
            case "currency":
              m.t = "n", m.v = parseFloat(T.value);
              break;
            case "date":
              m.t = "d", m.v = w1(T["date-value"], w0.WBProps.date1904), a.cellDates || (m.t = "n", m.v = v1(m.v, w0.WBProps.date1904)), m.z || (m.z = "m/d/yy");
              break;
            case "time":
              m.t = "n", m.v = on(T["time-value"]) / 86400, a.cellDates && (m.v = O2(m.v), m.t = typeof m.v == "number" ? "n" : "d"), m.z || (m.z = "HH:MM:SS");
              break;
            case "number":
              m.t = "n", m.v = parseFloat(T.数据数值);
              break;
            default:
              if (m.t === "string" || m.t === "text" || !m.t)
                m.t = "s", T["string-value"] != null && (g = R0(T["string-value"]), E = []);
              else
                throw new Error("Unsupported value type " + m.t);
          }
        } else {
          if (R = !1, m.t === "s" && (m.v = g || "", E.length && (m.R = E), R = O == 0), r0.Target && (m.l = r0), b0.length > 0 && (m.c = b0, b0 = []), g && a.cellText !== !1 && (m.w = g), R && (m.t = "z", delete m.v), (!R || a.sheetStubs) && !(a.sheetRows && a.sheetRows <= I))
            for (var Q = 0; Q < K; ++Q) {
              if (T0 = parseInt(T["number-columns-repeated"] || "1", 10), a.dense)
                for (v["!data"][I + Q] || (v["!data"][I + Q] = []), v["!data"][I + Q][P] = Q == 0 ? m : x1(m); --T0 > 0; )
                  v["!data"][I + Q][P + T0] = x1(m);
              else
                for (v[H0({ r: I + Q, c: P })] = m; --T0 > 0; )
                  v[H0({ r: I + Q, c: P + T0 })] = x1(m);
              L.e.c <= P && (L.e.c = P);
            }
          T0 = parseInt(T["number-columns-repeated"] || "1", 10), P += T0 - 1, T0 = 0, m = {
            /*:: t:"", v:null, z:null, w:"",c:[]*/
          }, g = "", E = [];
        }
        r0 = {};
        break;
      case "document":
      case "document-content":
      case "电子表格文档":
      case "spreadsheet":
      case "主体":
      case "scripts":
      case "styles":
      case "font-face-decls":
      case "master-styles":
        if (x[1] === "/") {
          if ((c = i.pop())[0] !== x[3])
            throw "Bad state: " + c;
        } else
          x[0].charAt(x[0].length - 2) !== "/" && i.push([x[3], !0]);
        break;
      case "annotation":
        if (x[1] === "/") {
          if ((c = i.pop())[0] !== x[3])
            throw "Bad state: " + c;
          D0.t = g, E.length && (D0.R = E), D0.a = F, b0.push(D0), g = H, O = W, E = b;
        } else if (x[0].charAt(x[0].length - 2) !== "/") {
          i.push([x[3], !1]);
          var m0 = x0(x[0], !0);
          m0.display && G0(m0.display) || (b0.hidden = !0), H = g, W = O, b = E, g = "", O = 0, E = [];
        }
        F = "", B = 0;
        break;
      case "creator":
        x[1] === "/" ? F = n.slice(B, x.index) : B = x.index + x[0].length;
        break;
      case "meta":
      case "元数据":
      case "settings":
      case "config-item-set":
      case "config-item-map-indexed":
      case "config-item-map-entry":
      case "config-item-map-named":
      case "shapes":
      case "frame":
      case "text-box":
      case "image":
      case "data-pilot-tables":
      case "list-style":
      case "form":
      case "dde-links":
      case "event-listeners":
      case "chart":
        if (x[1] === "/") {
          if ((c = i.pop())[0] !== x[3])
            throw "Bad state: " + c;
        } else
          x[0].charAt(x[0].length - 2) !== "/" && i.push([x[3], !1]);
        g = "", O = 0, E = [];
        break;
      case "scientific-number":
      case "currency-symbol":
      case "fill-character":
        break;
      case "text-style":
      case "boolean-style":
      case "number-style":
      case "currency-style":
      case "percentage-style":
      case "date-style":
      case "time-style":
        if (x[1] === "/") {
          var a0 = u1.lastIndex;
          Z7(n.slice(f, u1.lastIndex), t, Y), u1.lastIndex = a0;
        } else
          x[0].charAt(x[0].length - 2) !== "/" && (f = u1.lastIndex - x[0].length);
        break;
      case "script":
        break;
      case "libraries":
        break;
      case "automatic-styles":
        break;
      case "default-style":
      case "page-layout":
        break;
      case "style":
        {
          var g0 = x0(x[0], !1);
          g0.family == "table-cell" && Y[g0["data-style-name"]] && (f0[g0.name] = Y[g0["data-style-name"]]);
        }
        break;
      case "map":
        break;
      case "font-face":
        break;
      case "paragraph-properties":
        break;
      case "table-properties":
        break;
      case "table-column-properties":
        break;
      case "table-row-properties":
        break;
      case "table-cell-properties":
        break;
      case "number":
        break;
      case "fraction":
        break;
      case "day":
      case "month":
      case "year":
      case "era":
      case "day-of-week":
      case "week-of-year":
      case "quarter":
      case "hours":
      case "minutes":
      case "seconds":
      case "am-pm":
        break;
      case "boolean":
        break;
      case "text":
        if (x[0].slice(-2) === "/>")
          break;
        if (x[1] === "/")
          switch (i[i.length - 1][0]) {
            case "number-style":
            case "date-style":
            case "time-style":
              o += n.slice(l, x.index);
              break;
          }
        else
          l = x.index + x[0].length;
        break;
      case "named-range":
        s = x0(x[0], !1), E0 = u4(s["cell-range-address"]);
        var _0 = { Name: s.name, Ref: E0[0] + "!" + E0[1] };
        D && (_0.Sheet = p.length), w0.Names.push(_0);
        break;
      case "text-content":
        break;
      case "text-properties":
        break;
      case "embedded-text":
        break;
      case "body":
      case "电子表格":
        break;
      case "forms":
        break;
      case "table-column":
        break;
      case "table-header-rows":
        break;
      case "table-rows":
        break;
      case "table-column-group":
        break;
      case "table-header-columns":
        break;
      case "table-columns":
        break;
      case "null-date":
        switch (s = x0(x[0], !1), s["date-value"]) {
          case "1904-01-01":
            w0.WBProps.date1904 = !0;
            break;
        }
        break;
      case "graphic-properties":
        break;
      case "calculation-settings":
        break;
      case "named-expressions":
        break;
      case "label-range":
        break;
      case "label-ranges":
        break;
      case "named-expression":
        break;
      case "sort":
        break;
      case "sort-by":
        break;
      case "sort-groups":
        break;
      case "tab":
        break;
      case "line-break":
        break;
      case "span":
        break;
      case "p":
      case "文本串":
        if (["master-styles"].indexOf(i[i.length - 1][0]) > -1)
          break;
        if (x[1] === "/" && (!T || !T["string-value"])) {
          var A0 = uu(n.slice(O, x.index));
          g = (g.length > 0 ? g + `
` : "") + A0[0];
        } else
          x[0].slice(-2) == "/>" ? g += `
` : (x0(x[0], !1), O = x.index + x[0].length);
        break;
      case "s":
        break;
      case "database-range":
        if (x[1] === "/")
          break;
        try {
          E0 = u4(x0(x[0])["target-range-address"]), h[E0[0]]["!autofilter"] = { ref: E0[1] };
        } catch {
        }
        break;
      case "date":
        break;
      case "object":
        break;
      case "title":
      case "标题":
        break;
      case "desc":
        break;
      case "binary-data":
        break;
      case "table-source":
        break;
      case "scenario":
        break;
      case "iteration":
        break;
      case "content-validations":
        break;
      case "content-validation":
        break;
      case "help-message":
        break;
      case "error-message":
        break;
      case "database-ranges":
        break;
      case "filter":
        break;
      case "filter-and":
        break;
      case "filter-or":
        break;
      case "filter-condition":
        break;
      case "filter-set-item":
        break;
      case "list-level-style-bullet":
        break;
      case "list-level-style-number":
        break;
      case "list-level-properties":
        break;
      case "sender-firstname":
      case "sender-lastname":
      case "sender-initials":
      case "sender-title":
      case "sender-position":
      case "sender-email":
      case "sender-phone-private":
      case "sender-fax":
      case "sender-company":
      case "sender-phone-work":
      case "sender-street":
      case "sender-city":
      case "sender-postal-code":
      case "sender-country":
      case "sender-state-or-province":
      case "author-name":
      case "author-initials":
      case "chapter":
      case "file-name":
      case "template-name":
      case "sheet-name":
        break;
      case "event-listener":
        break;
      case "initial-creator":
      case "creation-date":
      case "print-date":
      case "generator":
      case "document-statistic":
      case "user-defined":
      case "editing-duration":
      case "editing-cycles":
        break;
      case "config-item":
        break;
      case "page-number":
        break;
      case "page-count":
        break;
      case "time":
        break;
      case "cell-range-source":
        break;
      case "detective":
        break;
      case "operation":
        break;
      case "highlighted-range":
        break;
      case "data-pilot-table":
      case "source-cell-range":
      case "source-service":
      case "data-pilot-field":
      case "data-pilot-level":
      case "data-pilot-subtotals":
      case "data-pilot-subtotal":
      case "data-pilot-members":
      case "data-pilot-member":
      case "data-pilot-display-info":
      case "data-pilot-sort-info":
      case "data-pilot-layout-info":
      case "data-pilot-field-reference":
      case "data-pilot-groups":
      case "data-pilot-group":
      case "data-pilot-group-member":
        break;
      case "rect":
        break;
      case "dde-connection-decls":
      case "dde-connection-decl":
      case "dde-link":
      case "dde-source":
        break;
      case "properties":
        break;
      case "property":
        break;
      case "a":
        if (x[1] !== "/") {
          if (r0 = x0(x[0], !1), !r0.href)
            break;
          r0.Target = R0(r0.href), delete r0.href, r0.Target.charAt(0) == "#" && r0.Target.indexOf(".") > -1 ? (E0 = u4(r0.Target.slice(1)), r0.Target = "#" + E0[0] + "!" + E0[1]) : r0.Target.match(/^\.\.[\\\/]/) && (r0.Target = r0.Target.slice(3));
        }
        break;
      case "table-protection":
        break;
      case "data-pilot-grand-total":
        break;
      case "office-document-common-attrs":
        break;
      default:
        switch (x[2]) {
          case "dc:":
          case "calcext:":
          case "loext:":
          case "ooo:":
          case "chartooo:":
          case "draw:":
          case "style:":
          case "chart:":
          case "form:":
          case "uof:":
          case "表:":
          case "字:":
            break;
          default:
            if (a.WTF)
              throw new Error(x);
        }
    }
  var V0 = {
    Sheets: h,
    SheetNames: p,
    Workbook: w0
  };
  return a.bookSheets && delete /*::(*/
  V0.Sheets, V0;
}
function Er(e, t) {
  t = t || {}, Q1(e, "META-INF/manifest.xml") && Ei(h1(e, "META-INF/manifest.xml"), t);
  var r = P1(e, "styles.xml"), a = r && Z7(X0(r)), n = P1(e, "content.xml");
  if (!n)
    throw new Error("Missing content.xml in ODS / UOF file");
  var i = Q7(X0(n), t, a);
  return Q1(e, "meta.xml") && (i.Props = h7(h1(e, "meta.xml"))), i.bookType = "ods", i;
}
function wr(e, t) {
  var r = Q7(e, t);
  return r.bookType = "fods", r;
}
/*! sheetjs (C) 2013-present SheetJS -- http://sheetjs.com */
var E1 = function() {
  try {
    return typeof Uint8Array > "u" || typeof Uint8Array.prototype.subarray > "u" ? "slice" : typeof Buffer < "u" ? typeof Buffer.prototype.subarray > "u" ? "slice" : (typeof Buffer.from == "function" ? Buffer.from([72, 62]) : new Buffer([72, 62])) instanceof Uint8Array ? "subarray" : "slice" : "subarray";
  } catch {
    return "slice";
  }
}();
function q3(e) {
  return new DataView(e.buffer, e.byteOffset, e.byteLength);
}
function d3(e) {
  return typeof TextDecoder < "u" ? new TextDecoder().decode(e) : X0(w2(e));
}
function e8(e) {
  for (var t = 0, r = 0; r < e.length; ++r)
    t += e[r].length;
  var a = new Uint8Array(t), n = 0;
  for (r = 0; r < e.length; ++r) {
    var i = e[r], c = i.length;
    if (c < 250)
      for (var s = 0; s < c; ++s)
        a[n++] = i[s];
    else
      a.set(i, n), n += c;
  }
  return a;
}
function V3(e) {
  return e -= e >> 1 & 1431655765, e = (e & 858993459) + (e >> 2 & 858993459), (e + (e >> 4) & 252645135) * 16843009 >>> 24;
}
function xu(e, t) {
  for (var r = (e[t + 15] & 127) << 7 | e[t + 14] >> 1, a = e[t + 14] & 1, n = t + 13; n >= t; --n)
    a = a * 256 + e[n];
  return (e[t + 15] & 128 ? -a : a) * Math.pow(10, r - 6176);
}
function Le(e, t) {
  var r = t.l, a = e[r] & 127;
  e:
    if (e[r++] >= 128 && (a |= (e[r] & 127) << 7, e[r++] < 128 || (a |= (e[r] & 127) << 14, e[r++] < 128) || (a |= (e[r] & 127) << 21, e[r++] < 128) || (a += (e[r] & 127) * Math.pow(2, 28), ++r, e[r++] < 128) || (a += (e[r] & 127) * Math.pow(2, 35), ++r, e[r++] < 128) || (a += (e[r] & 127) * Math.pow(2, 42), ++r, e[r++] < 128)))
      break e;
  return t.l = r, a;
}
function $0(e) {
  var t = 0, r = e[t] & 127;
  return e[t++] < 128 || (r |= (e[t] & 127) << 7, e[t++] < 128) || (r |= (e[t] & 127) << 14, e[t++] < 128) || (r |= (e[t] & 127) << 21, e[t++] < 128) || (r |= (e[t] & 15) << 28), r;
}
function z0(e) {
  for (var t = [], r = { l: 0 }; r.l < e.length; ) {
    var a = r.l, n = Le(e, r), i = n & 7;
    n = n / 8 | 0;
    var c, s = r.l;
    switch (i) {
      case 0:
        {
          for (; e[s++] >= 128; )
            ;
          c = e[E1](r.l, s), r.l = s;
        }
        break;
      case 1:
        c = e[E1](s, s + 8), r.l = s + 8;
        break;
      case 2:
        {
          var f = Le(e, r);
          c = e[E1](r.l, r.l + f), r.l += f;
        }
        break;
      case 5:
        c = e[E1](s, s + 4), r.l = s + 4;
        break;
      default:
        throw new Error("PB Type ".concat(i, " for Field ").concat(n, " at offset ").concat(a));
    }
    var o = { data: c, type: i };
    t[n] == null && (t[n] = []), t[n].push(o);
  }
  return t;
}
function Q4(e, t) {
  return e?.map(function(r) {
    return t(r.data);
  }) || [];
}
function du(e) {
  for (var t, r = [], a = { l: 0 }; a.l < e.length; ) {
    var n = Le(e, a), i = z0(e[E1](a.l, a.l + n));
    a.l += n;
    var c = {
      id: $0(i[1][0].data),
      messages: []
    };
    i[2].forEach(function(s) {
      var f = z0(s.data), o = $0(f[3][0].data);
      c.messages.push({
        meta: f,
        data: e[E1](a.l, a.l + o)
      }), a.l += o;
    }), (t = i[3]) != null && t[0] && (c.merge = $0(i[3][0].data) >>> 0 > 0), r.push(c);
  }
  return r;
}
function pu(e, t) {
  if (e != 0)
    throw new Error("Unexpected Snappy chunk type ".concat(e));
  for (var r = { l: 0 }, a = Le(t, r), n = [], i = r.l; i < t.length; ) {
    var c = t[i] & 3;
    if (c == 0) {
      var s = t[i++] >> 2;
      if (s < 60)
        ++s;
      else {
        var f = s - 59;
        s = t[i], f > 1 && (s |= t[i + 1] << 8), f > 2 && (s |= t[i + 2] << 16), f > 3 && (s |= t[i + 3] << 24), s >>>= 0, s++, i += f;
      }
      n.push(t[E1](i, i + s)), i += s;
      continue;
    } else {
      var o = 0, l = 0;
      if (c == 1 ? (l = (t[i] >> 2 & 7) + 4, o = (t[i++] & 224) << 3, o |= t[i++]) : (l = (t[i++] >> 2) + 1, c == 2 ? (o = t[i] | t[i + 1] << 8, i += 2) : (o = (t[i] | t[i + 1] << 8 | t[i + 2] << 16 | t[i + 3] << 24) >>> 0, i += 4)), o == 0)
        throw new Error("Invalid offset 0");
      for (var d = n.length - 1, u = o; d >= 0 && u >= n[d].length; )
        u -= n[d].length, --d;
      if (d < 0)
        if (u == 0)
          u = n[d = 0].length;
        else
          throw new Error("Invalid offset beyond length");
      if (l < u)
        n.push(n[d][E1](n[d].length - u, n[d].length - u + l));
      else {
        for (u > 0 && (n.push(n[d][E1](n[d].length - u)), l -= u), ++d; l >= n[d].length; )
          n.push(n[d]), l -= n[d].length, ++d;
        l && n.push(n[d][E1](0, l));
      }
      n.length > 25 && (n = [e8(n)]);
    }
  }
  for (var h = 0, p = 0; p < n.length; ++p)
    h += n[p].length;
  if (h != a)
    throw new Error("Unexpected length: ".concat(h, " != ").concat(a));
  return n;
}
function mu(e) {
  Array.isArray(e) && (e = new Uint8Array(e));
  for (var t = [], r = 0; r < e.length; ) {
    var a = e[r++], n = e[r] | e[r + 1] << 8 | e[r + 2] << 16;
    r += 3, t.push.apply(t, pu(a, e[E1](r, r + n))), r += n;
  }
  if (r !== e.length)
    throw new Error("data is not a valid framed stream!");
  return t.length == 1 ? t[0] : e8(t);
}
var vu = function() {
  return { sst: [], rsst: [], ofmt: [], nfmt: [], fmla: [], ferr: [], cmnt: [] };
};
function r8(e, t, r, a, n) {
  var i, c, s, f, o = t & 255, l = t >> 8, d = l >= 5 ? n : a;
  e:
    if (r & (l > 4 ? 8 : 4) && e.t == "n" && o == 7) {
      var u = (i = d[7]) != null && i[0] ? $0(d[7][0].data) : -1;
      if (u == -1)
        break e;
      var h = (c = d[15]) != null && c[0] ? $0(d[15][0].data) : -1, p = (s = d[16]) != null && s[0] ? $0(d[16][0].data) : -1, v = (f = d[40]) != null && f[0] ? $0(d[40][0].data) : -1, x = e.v, m = x;
      r:
        if (v) {
          if (x == 0) {
            h = p = 2;
            break r;
          }
          x >= 604800 ? h = 1 : x >= 86400 ? h = 2 : x >= 3600 ? h = 4 : x >= 60 ? h = 8 : x >= 1 ? h = 16 : h = 32, Math.floor(x) != x ? p = 32 : x % 60 ? p = 16 : x % 3600 ? p = 8 : x % 86400 ? p = 4 : x % 604800 && (p = 2), p < h && (p = h);
        }
      if (h == -1 || p == -1)
        break e;
      var T = [], g = [];
      h == 1 && (m = x / 604800, p == 1 ? g.push('d"d"') : (m |= 0, x -= 604800 * m), T.push(m + (u == 2 ? " week" + (m == 1 ? "" : "s") : u == 1 ? "w" : ""))), h <= 2 && p >= 2 && (m = x / 86400, p > 2 && (m |= 0, x -= 86400 * m), g.push('d"d"'), T.push(m + (u == 2 ? " day" + (m == 1 ? "" : "s") : u == 1 ? "d" : ""))), h <= 4 && p >= 4 && (m = x / 3600, p > 4 && (m |= 0, x -= 3600 * m), g.push((h >= 4 ? "[h]" : "h") + '"h"'), T.push(m + (u == 2 ? " hour" + (m == 1 ? "" : "s") : u == 1 ? "h" : ""))), h <= 8 && p >= 8 && (m = x / 60, p > 8 && (m |= 0, x -= 60 * m), g.push((h >= 8 ? "[m]" : "m") + '"m"'), u == 0 ? T.push((h == 8 && p == 8 || m >= 10 ? "" : "0") + m) : T.push(m + (u == 2 ? " minute" + (m == 1 ? "" : "s") : u == 1 ? "m" : ""))), h <= 16 && p >= 16 && (m = x, p > 16 && (m |= 0, x -= m), g.push((h >= 16 ? "[s]" : "s") + '"s"'), u == 0 ? T.push((p == 16 && h == 16 || m >= 10 ? "" : "0") + m) : T.push(m + (u == 2 ? " second" + (m == 1 ? "" : "s") : u == 1 ? "s" : ""))), p >= 32 && (m = Math.round(1e3 * x), h < 32 && g.push('.000"ms"'), u == 0 ? T.push((m >= 100 ? "" : m >= 10 ? "0" : "00") + m) : T.push(m + (u == 2 ? " millisecond" + (m == 1 ? "" : "s") : u == 1 ? "ms" : ""))), e.w = T.join(u == 0 ? ":" : " "), e.z = g.join(u == 0 ? '":"' : " "), u == 0 && (e.w = e.w.replace(/:(\d\d\d)$/, ".$1"));
    }
}
function gu(e, t, r, a) {
  var n = q3(e), i = n.getUint32(4, !0), c = -1, s = -1, f = -1, o = NaN, l = 0, d = new Date(Date.UTC(2001, 0, 1)), u = r > 1 ? 12 : 8;
  i & 2 && (f = n.getUint32(u, !0), u += 4), u += V3(i & (r > 1 ? 3468 : 396)) * 4, i & 512 && (c = n.getUint32(u, !0), u += 4), u += V3(i & (r > 1 ? 12288 : 4096)) * 4, i & 16 && (s = n.getUint32(u, !0), u += 4), i & 32 && (o = n.getFloat64(u, !0), u += 8), i & 64 && (d.setTime(d.getTime() + (l = n.getFloat64(u, !0)) * 1e3), u += 8), r > 1 && (i = n.getUint32(8, !0) >>> 16, i & 255 && (f == -1 && (f = n.getUint32(u, !0)), u += 4));
  var h, p = e[r >= 4 ? 1 : 2];
  switch (p) {
    case 0:
      return;
    case 2:
      h = { t: "n", v: o };
      break;
    case 3:
      h = { t: "s", v: t.sst[s] };
      break;
    case 5:
      a?.cellDates ? h = { t: "d", v: d } : h = { t: "n", v: l / 86400 + 35430, z: k0[14] };
      break;
    case 6:
      h = { t: "b", v: o > 0 };
      break;
    case 7:
      h = { t: "n", v: o };
      break;
    case 8:
      h = { t: "e", v: 0 };
      break;
    case 9:
      if (c > -1) {
        var v = t.rsst[c];
        h = { t: "s", v: v.v }, v.l && (h.l = { Target: v.l });
      } else
        throw new Error("Unsupported cell type ".concat(e[E1](0, 4)));
      break;
    default:
      throw new Error("Unsupported cell type ".concat(e[E1](0, 4)));
  }
  return f > -1 && r8(h, p | r << 8, i, t.ofmt[f], t.nfmt[f]), p == 7 && (h.v /= 86400), h;
}
function _u(e, t, r) {
  var a = q3(e);
  a.getUint32(4, !0);
  var n = a.getUint32(8, !0), i = 12, c = -1, s = -1, f = -1, o = NaN, l = NaN, d = 0, u = new Date(Date.UTC(2001, 0, 1));
  n & 1 && (o = xu(e, i), i += 16), n & 2 && (l = a.getFloat64(i, !0), i += 8), n & 4 && (u.setTime(u.getTime() + (d = a.getFloat64(i, !0)) * 1e3), i += 8), n & 8 && (s = a.getUint32(i, !0), i += 4), n & 16 && (c = a.getUint32(i, !0), i += 4), i += V3(n & 480) * 4, n & 512 && (a.getUint32(i, !0), i += 4), i += V3(n & 1024) * 4, n & 2048 && (a.getUint32(i, !0), i += 4);
  var h, p = e[1];
  switch (p) {
    case 0:
      h = { t: "z" };
      break;
    case 2:
      h = { t: "n", v: o };
      break;
    case 3:
      h = { t: "s", v: t.sst[s] };
      break;
    case 5:
      r?.cellDates ? h = { t: "d", v: u } : h = { t: "n", v: d / 86400 + 35430, z: k0[14] };
      break;
    case 6:
      h = { t: "b", v: l > 0 };
      break;
    case 7:
      h = { t: "n", v: l };
      break;
    case 8:
      h = { t: "e", v: 0 };
      break;
    case 9:
      if (c > -1) {
        var v = t.rsst[c];
        h = { t: "s", v: v.v }, v.l && (h.l = { Target: v.l });
      } else
        throw new Error("Unsupported cell type ".concat(e[1], " : ").concat(n & 31, " : ").concat(e[E1](0, 4)));
      break;
    case 10:
      h = { t: "n", v: o };
      break;
    default:
      throw new Error("Unsupported cell type ".concat(e[1], " : ").concat(n & 31, " : ").concat(e[E1](0, 4)));
  }
  if (i += V3(n & 4096) * 4, n & 516096 && (f == -1 && (f = a.getUint32(i, !0)), i += 4), n & 524288) {
    var x = a.getUint32(i, !0);
    i += 4, t.cmnt[x] && (h.c = ku(t.cmnt[x]));
  }
  return f > -1 && r8(h, p | 1280, n >> 13, t.ofmt[f], t.nfmt[f]), p == 7 && (h.v /= 86400), h;
}
function Tu(e, t, r) {
  switch (e[0]) {
    case 0:
    case 1:
    case 2:
    case 3:
    case 4:
      return gu(e, t, e[0], r);
    case 5:
      return _u(e, t, r);
    default:
      throw new Error("Unsupported payload version ".concat(e[0]));
  }
}
function _1(e) {
  var t = z0(e);
  return $0(t[1][0].data);
}
function V2(e, t) {
  var r = z0(t.data), a = $0(r[1][0].data), n = r[3], i = [];
  return (n || []).forEach(function(c) {
    var s, f, o = z0(c.data);
    if (o[1]) {
      var l = $0(o[1][0].data) >>> 0;
      switch (a) {
        case 1:
          i[l] = d3(o[3][0].data);
          break;
        case 8:
          {
            var d = e[_1(o[9][0].data)][0], u = z0(d.data), h = e[_1(u[1][0].data)][0], p = $0(h.meta[1][0].data);
            if (p != 2001)
              throw new Error("2000 unexpected reference to ".concat(p));
            var v = z0(h.data), x = { v: v[3].map(function(g) {
              return d3(g.data);
            }).join("") };
            i[l] = x;
            e:
              if ((s = v?.[11]) != null && s[0]) {
                var m = (f = z0(v[11][0].data)) == null ? void 0 : f[1];
                if (!m)
                  break e;
                m.forEach(function(g) {
                  var O, H, W, E = z0(g.data);
                  if ((O = E[2]) != null && O[0]) {
                    var b = e[_1((H = E[2]) == null ? void 0 : H[0].data)][0], I = $0(b.meta[1][0].data);
                    switch (I) {
                      case 2032:
                        var P = z0(b.data);
                        (W = P?.[2]) != null && W[0] && !x.l && (x.l = d3(P[2][0].data));
                        break;
                      case 2039:
                        break;
                      default:
                        console.log("unrecognized ObjectAttribute type ".concat(I));
                    }
                  }
                });
              }
          }
          break;
        case 2:
          i[l] = z0(o[6][0].data);
          break;
        case 3:
          i[l] = z0(o[5][0].data);
          break;
        case 10:
          {
            var T = e[_1(o[10][0].data)][0];
            i[l] = t8(e, T.data);
          }
          break;
        default:
          throw a;
      }
    }
  }), i;
}
function Eu(e, t) {
  var r, a, n, i, c, s, f, o, l, d, u, h, p, v, x = z0(e), m = $0(x[1][0].data) >>> 0, T = $0(x[2][0].data) >>> 0, g = ((a = (r = x[8]) == null ? void 0 : r[0]) == null ? void 0 : a.data) && $0(x[8][0].data) > 0 || !1, O, H;
  if ((i = (n = x[7]) == null ? void 0 : n[0]) != null && i.data && t != 0)
    O = (s = (c = x[7]) == null ? void 0 : c[0]) == null ? void 0 : s.data, H = (o = (f = x[6]) == null ? void 0 : f[0]) == null ? void 0 : o.data;
  else if ((d = (l = x[4]) == null ? void 0 : l[0]) != null && d.data && t != 1)
    O = (h = (u = x[4]) == null ? void 0 : u[0]) == null ? void 0 : h.data, H = (v = (p = x[3]) == null ? void 0 : p[0]) == null ? void 0 : v.data;
  else
    throw "NUMBERS Tile missing ".concat(t, " cell storage");
  for (var W = g ? 4 : 1, E = q3(O), b = [], I = 0; I < O.length / 2; ++I) {
    var P = E.getUint16(I * 2, !0);
    P < 65535 && b.push([I, P]);
  }
  if (b.length != T)
    throw "Expected ".concat(T, " cells, found ").concat(b.length);
  var L = [];
  for (I = 0; I < b.length - 1; ++I)
    L[b[I][0]] = H[E1](b[I][1] * W, b[I + 1][1] * W);
  return b.length >= 1 && (L[b[b.length - 1][0]] = H[E1](b[b.length - 1][1] * W)), { R: m, cells: L };
}
function wu(e, t) {
  var r, a = z0(t.data), n = -1;
  (r = a?.[7]) != null && r[0] && ($0(a[7][0].data) >>> 0 ? n = 1 : n = 0);
  var i = Q4(a[5], function(c) {
    return Eu(c, n);
  });
  return {
    nrows: $0(a[4][0].data) >>> 0,
    data: i.reduce(function(c, s) {
      return c[s.R] || (c[s.R] = []), s.cells.forEach(function(f, o) {
        if (c[s.R][o])
          throw new Error("Duplicate cell r=".concat(s.R, " c=").concat(o));
        c[s.R][o] = f;
      }), c;
    }, [])
  };
}
function t8(e, t) {
  var r, a, n, i, c, s, f, o, l, d, u = { t: "", a: "" }, h = z0(t);
  if ((a = (r = h?.[1]) == null ? void 0 : r[0]) != null && a.data && (u.t = d3((i = (n = h?.[1]) == null ? void 0 : n[0]) == null ? void 0 : i.data) || ""), (s = (c = h?.[3]) == null ? void 0 : c[0]) != null && s.data) {
    var p = e[_1((o = (f = h?.[3]) == null ? void 0 : f[0]) == null ? void 0 : o.data)][0], v = z0(p.data);
    (d = (l = v[1]) == null ? void 0 : l[0]) != null && d.data && (u.a = d3(v[1][0].data));
  }
  return h?.[4] && (u.replies = [], h[4].forEach(function(x) {
    var m = e[_1(x.data)][0];
    u.replies.push(t8(e, m.data));
  })), u;
}
function ku(e) {
  var t = [];
  return t.push({ t: e.t || "", a: e.a, T: e.replies && e.replies.length > 0 }), e.replies && e.replies.forEach(function(r) {
    t.push({ t: r.t || "", a: r.a, T: !0 });
  }), t;
}
function Cu(e, t, r, a) {
  var n, i, c, s, f, o, l, d, u, h, p = z0(t.data), v = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } };
  if (v.e.r = ($0(p[6][0].data) >>> 0) - 1, v.e.r < 0)
    throw new Error("Invalid row varint ".concat(p[6][0].data));
  if (v.e.c = ($0(p[7][0].data) >>> 0) - 1, v.e.c < 0)
    throw new Error("Invalid col varint ".concat(p[7][0].data));
  r["!ref"] = M0(v);
  var x = r["!data"] != null, m = r, T = z0(p[4][0].data), g = vu();
  (n = T[4]) != null && n[0] && (g.sst = V2(e, e[_1(T[4][0].data)][0])), (i = T[6]) != null && i[0] && (g.fmla = V2(e, e[_1(T[6][0].data)][0])), (c = T[11]) != null && c[0] && (g.ofmt = V2(e, e[_1(T[11][0].data)][0])), (s = T[12]) != null && s[0] && (g.ferr = V2(e, e[_1(T[12][0].data)][0])), (f = T[17]) != null && f[0] && (g.rsst = V2(e, e[_1(T[17][0].data)][0])), (o = T[19]) != null && o[0] && (g.cmnt = V2(e, e[_1(T[19][0].data)][0])), (l = T[22]) != null && l[0] && (g.nfmt = V2(e, e[_1(T[22][0].data)][0]));
  var O = z0(T[3][0].data), H = 0;
  if (!((d = T[9]) != null && d[0]))
    throw "NUMBERS file missing row tree";
  var W = z0(T[9][0].data)[1].map(function(I) {
    return z0(I.data);
  });
  if (W.forEach(function(I) {
    H = $0(I[1][0].data);
    var P = $0(I[2][0].data), L = O[1][P];
    if (!L)
      throw "NUMBERS missing tile " + P;
    var z = z0(L.data), Y = e[_1(z[2][0].data)][0], f0 = $0(Y.meta[1][0].data);
    if (f0 != 6002)
      throw new Error("6001 unexpected reference to ".concat(f0));
    var i0 = wu(e, Y);
    i0.data.forEach(function(p0, n0) {
      p0.forEach(function(v0, I0) {
        var K = Tu(v0, g, a);
        K && (x ? (m["!data"][H + n0] || (m["!data"][H + n0] = []), m["!data"][H + n0][I0] = K) : r[W0(I0) + j0(H + n0)] = K);
      });
    }), H += i0.nrows;
  }), (u = T[13]) != null && u[0]) {
    var E = e[_1(T[13][0].data)][0], b = $0(E.meta[1][0].data);
    if (b != 6144)
      throw new Error("Expected merge type 6144, found ".concat(b));
    r["!merges"] = (h = z0(E.data)) == null ? void 0 : h[1].map(function(I) {
      var P = z0(I.data), L = q3(z0(P[1][0].data)[1][0].data), z = q3(z0(P[2][0].data)[1][0].data);
      return {
        s: { r: L.getUint16(0, !0), c: L.getUint16(2, !0) },
        e: {
          r: L.getUint16(0, !0) + z.getUint16(0, !0) - 1,
          c: L.getUint16(2, !0) + z.getUint16(2, !0) - 1
        }
      };
    });
  }
}
function Su(e, t, r) {
  var a = z0(t.data), n = { "!ref": "A1" };
  r?.dense && (n["!data"] = []);
  var i = e[_1(a[2][0].data)], c = $0(i[0].meta[1][0].data);
  if (c != 6001)
    throw new Error("6000 unexpected reference to ".concat(c));
  return Cu(e, i[0], n, r), n;
}
function Au(e, t, r) {
  var a, n = z0(t.data), i = {
    name: (a = n[1]) != null && a[0] ? d3(n[1][0].data) : "",
    sheets: []
  }, c = Q4(n[2], _1);
  return c.forEach(function(s) {
    e[s].forEach(function(f) {
      var o = $0(f.meta[1][0].data);
      o == 6e3 && i.sheets.push(Su(e, f, r));
    });
  }), i;
}
function Fu(e, t, r) {
  var a, n = t5();
  n.Workbook = { WBProps: { date1904: !0 } };
  var i = z0(t.data);
  if ((a = i[2]) != null && a[0])
    throw new Error("Keynote presentations are not supported");
  var c = Q4(i[1], _1);
  if (c.forEach(function(s) {
    e[s].forEach(function(f) {
      var o = $0(f.meta[1][0].data);
      if (o == 2) {
        var l = Au(e, f, r);
        l.sheets.forEach(function(d, u) {
          se(n, d, u == 0 ? l.name : l.name + "_" + u, !0);
        });
      }
    });
  }), n.SheetNames.length == 0)
    throw new Error("Empty NUMBERS file");
  return n.bookType = "numbers", n;
}
function d4(e, t) {
  var r, a, n, i, c, s, f, o = {}, l = [];
  if (e.FullPaths.forEach(function(u) {
    if (u.match(/\.iwpv2/))
      throw new Error("Unsupported password protection");
  }), e.FileIndex.forEach(function(u) {
    if (u.name.match(/\.iwa$/) && u.content[0] == 0) {
      var h;
      try {
        h = mu(u.content);
      } catch (v) {
        return console.log("?? " + u.content.length + " " + (v.message || v));
      }
      var p;
      try {
        p = du(h);
      } catch (v) {
        return console.log("## " + (v.message || v));
      }
      p.forEach(function(v) {
        o[v.id] = v.messages, l.push(v.id);
      });
    }
  }), !l.length)
    throw new Error("File has no messages");
  if ((n = (a = (r = o?.[1]) == null ? void 0 : r[0].meta) == null ? void 0 : a[1]) != null && n[0].data && $0(o[1][0].meta[1][0].data) == 1e4)
    throw new Error("Pages documents are not supported");
  var d = ((f = (s = (c = (i = o?.[1]) == null ? void 0 : i[0]) == null ? void 0 : c.meta) == null ? void 0 : s[1]) == null ? void 0 : f[0].data) && $0(o[1][0].meta[1][0].data) == 1 && o[1][0];
  if (d || l.forEach(function(u) {
    o[u].forEach(function(h) {
      var p = $0(h.meta[1][0].data) >>> 0;
      if (p == 1)
        if (!d)
          d = h;
        else
          throw new Error("Document has multiple roots");
    });
  }), !d)
    throw new Error("Cannot find Document root");
  return Fu(o, d, t);
}
function yu(e) {
  return function(r) {
    for (var a = 0; a != e.length; ++a) {
      var n = e[a];
      r[n[0]] === void 0 && (r[n[0]] = n[1]), n[2] === "n" && (r[n[0]] = Number(r[n[0]]));
    }
  };
}
function e5(e) {
  yu([
    ["cellNF", !1],
    /* emit cell number format string as .z */
    ["cellHTML", !0],
    /* emit html string as .h */
    ["cellFormula", !0],
    /* emit formulae as .f */
    ["cellStyles", !1],
    /* emits style/theme as .s */
    ["cellText", !0],
    /* emit formatted text as .w */
    ["cellDates", !1],
    /* emit date cells with type `d` */
    ["sheetStubs", !1],
    /* emit empty cells */
    ["sheetRows", 0, "n"],
    /* read n rows (0 = read all rows) */
    ["bookDeps", !1],
    /* parse calculation chains */
    ["bookSheets", !1],
    /* only try to get sheet names (no Sheets) */
    ["bookProps", !1],
    /* only try to get properties (no Sheets) */
    ["bookFiles", !1],
    /* include raw file structure (keys, files, cfb) */
    ["bookVBA", !1],
    /* include vba raw data (vbaraw) */
    ["password", ""],
    /* password */
    ["WTF", !1]
    /* WTF mode (throws errors) */
  ])(e);
}
function Iu(e) {
  return l3.WS.indexOf(e) > -1 ? "sheet" : e == l3.CS ? "chart" : e == l3.DS ? "dialog" : e == l3.MS ? "macro" : e && e.length ? e : "sheet";
}
function bu(e, t) {
  if (!e)
    return 0;
  try {
    e = t.map(function(a) {
      return a.id || (a.id = a.strRelID), [a.name, e["!id"][a.id].Target, Iu(e["!id"][a.id].Type)];
    });
  } catch {
    return null;
  }
  return !e || e.length === 0 ? null : e;
}
function Du(e, t, r, a, n, i, c, s) {
  if (!(!e || !e["!legdrawel"])) {
    var f = o3(e["!legdrawel"].Target, a), o = P1(r, f, !0);
    o && Mf(X0(o), e, s || []);
  }
}
function Ou(e, t, r, a, n, i, c, s, f, o, l, d) {
  try {
    i[a] = P3(P1(e, r, !0), t);
    var u = h1(e, t), h;
    switch (s) {
      case "sheet":
        h = Nh(u, t, n, f, i[a], o, l, d);
        break;
      case "chart":
        if (h = Ph(u, t, n, f, i[a], o, l, d), !h || !h["!drawel"])
          break;
        var p = o3(h["!drawel"].Target, t), v = _4(p), x = Of(P1(e, p, !0), P3(P1(e, v, !0), p)), m = o3(x, p), T = _4(m);
        h = gh(P1(e, m, !0), m, f, P3(P1(e, T, !0), m), o, h);
        break;
      case "macro":
        h = Lh(u, t, n, f, i[a], o, l, d);
        break;
      case "dialog":
        h = Bh(u, t, n, f, i[a], o, l, d);
        break;
      default:
        throw new Error("Unrecognized sheet type " + s);
    }
    c[a] = h;
    var g = [], O = [];
    i && i[a] && t2(i[a]).forEach(function(H) {
      var W = "";
      if (i[a][H].Type == l3.CMNT) {
        if (W = o3(i[a][H].Target, t), g = Wh(h1(e, W, !0), W, f), !g || !g.length)
          return;
        or(h, g, !1);
      }
      i[a][H].Type == l3.TCMNT && (W = o3(i[a][H].Target, t), O = O.concat(Pf(h1(e, W, !0), f)));
    }), O && O.length && or(h, O, !0, f.people || []), Du(h, s, e, t, n, f, o, g);
  } catch (H) {
    if (f.WTF)
      throw H;
  }
}
function q1(e) {
  return e.charAt(0) == "/" ? e.slice(1) : e;
}
function Ru(e, t) {
  if (P6(), t = t || {}, e5(t), Q1(e, "META-INF/manifest.xml") || Q1(e, "objectdata.xml"))
    return Er(e, t);
  if (Q1(e, "Index/Document.iwa")) {
    if (typeof Uint8Array > "u")
      throw new Error("NUMBERS file parsing requires Uint8Array support");
    if (typeof d4 < "u") {
      if (e.FileIndex)
        return d4(e, t);
      var r = L0.utils.cfb_new();
      return P5(e).forEach(function(i0) {
        wn(r, i0, En(e, i0));
      }), d4(r, t);
    }
    throw new Error("Unsupported NUMBERS file");
  }
  if (!Q1(e, "[Content_Types].xml")) {
    if (Q1(e, "index.xml.gz"))
      throw new Error("Unsupported NUMBERS 08 file");
    if (Q1(e, "index.xml"))
      throw new Error("Unsupported NUMBERS 09 file");
    var a = L0.find(e, "Index.zip");
    if (a)
      return t = x1(t), delete t.type, typeof a.content == "string" && (t.type = "binary"), typeof Bun < "u" && Buffer.isBuffer(a.content) ? v3(new Uint8Array(a.content), t) : v3(a.content, t);
    throw new Error("Unsupported ZIP file");
  }
  var n = P5(e), i = _i(P1(e, "[Content_Types].xml")), c = !1, s, f;
  if (i.workbooks.length === 0 && (f = "xl/workbook.xml", h1(e, f, !0) && i.workbooks.push(f)), i.workbooks.length === 0) {
    if (f = "xl/workbook.bin", !h1(e, f, !0))
      throw new Error("Could not find workbook");
    i.workbooks.push(f), c = !0;
  }
  i.workbooks[0].slice(-3) == "bin" && (c = !0);
  var o = {}, l = {};
  if (!t.bookSheets && !t.bookProps) {
    if (U3 = [], i.sst)
      try {
        U3 = Hh(h1(e, q1(i.sst)), i.sst, t);
      } catch (i0) {
        if (t.WTF)
          throw i0;
      }
    t.cellStyles && i.themes.length && (o = R7(P1(e, i.themes[0].replace(/^\//, ""), !0) || "", t)), i.style && (l = Uh(h1(e, q1(i.style)), i.style, o, t));
  }
  i.links.map(function(i0) {
    try {
      var p0 = P3(P1(e, _4(q1(i0))), i0);
      return Gh(h1(e, q1(i0)), p0, i0, t);
    } catch {
    }
  });
  var d = Mh(h1(e, q1(i.workbooks[0])), i.workbooks[0], t), u = {}, h = "";
  i.coreprops.length && (h = h1(e, q1(i.coreprops[0]), !0), h && (u = h7(h)), i.extprops.length !== 0 && (h = h1(e, q1(i.extprops[0]), !0), h && Ci(h, u, t)));
  var p = {};
  (!t.bookSheets || t.bookProps) && i.custprops.length !== 0 && (h = P1(e, q1(i.custprops[0]), !0), h && (p = Ai(h, t)));
  var v = {};
  if ((t.bookSheets || t.bookProps) && (d.Sheets ? s = d.Sheets.map(function(p0) {
    return p0.name;
  }) : u.Worksheets && u.SheetNames.length > 0 && (s = u.SheetNames), t.bookProps && (v.Props = u, v.Custprops = p), t.bookSheets && typeof s < "u" && (v.SheetNames = s), t.bookSheets ? v.SheetNames : t.bookProps))
    return v;
  s = {};
  var x = {};
  t.bookDeps && i.calcchain && (x = Vh(h1(e, q1(i.calcchain)), i.calcchain));
  var m = 0, T = {}, g, O;
  {
    var H = d.Sheets;
    u.Worksheets = H.length, u.SheetNames = [];
    for (var W = 0; W != H.length; ++W)
      u.SheetNames[W] = H[W].name;
  }
  var E = c ? "bin" : "xml", b = i.workbooks[0].lastIndexOf("/"), I = (i.workbooks[0].slice(0, b + 1) + "_rels/" + i.workbooks[0].slice(b + 1) + ".rels").replace(/^\//, "");
  Q1(e, I) || (I = "xl/_rels/workbook." + E + ".rels");
  var P = P3(P1(e, I, !0), I.replace(/_rels.*/, "s5s"));
  (i.metadata || []).length >= 1 && (t.xlmeta = jh(h1(e, q1(i.metadata[0])), i.metadata[0], t)), (i.people || []).length >= 1 && (t.people = Lf(h1(e, q1(i.people[0])), t)), P && (P = bu(P, d.Sheets));
  var L = h1(e, "xl/worksheets/sheet.xml", !0) ? 1 : 0;
  e:
    for (m = 0; m != u.Worksheets; ++m) {
      var z = "sheet";
      if (P && P[m] ? (g = "xl/" + P[m][1].replace(/[\/]?xl\//, ""), Q1(e, g) || (g = P[m][1]), Q1(e, g) || (g = I.replace(/_rels\/.*$/, "") + P[m][1]), z = P[m][2]) : (g = "xl/worksheets/sheet" + (m + 1 - L) + "." + E, g = g.replace(/sheet0\./, "sheet.")), O = g.replace(/^(.*)(\/)([^\/]*)$/, "$1/_rels/$3.rels"), t && t.sheets != null)
        switch (typeof t.sheets) {
          case "number":
            if (m != t.sheets)
              continue e;
            break;
          case "string":
            if (u.SheetNames[m].toLowerCase() != t.sheets.toLowerCase())
              continue e;
            break;
          default:
            if (Array.isArray && Array.isArray(t.sheets)) {
              for (var Y = !1, f0 = 0; f0 != t.sheets.length; ++f0)
                typeof t.sheets[f0] == "number" && t.sheets[f0] == m && (Y = 1), typeof t.sheets[f0] == "string" && t.sheets[f0].toLowerCase() == u.SheetNames[m].toLowerCase() && (Y = 1);
              if (!Y)
                continue e;
            }
        }
      Ou(e, g, O, u.SheetNames[m], m, T, s, z, t, d, o, l);
    }
  return v = {
    Directory: i,
    Workbook: d,
    Props: u,
    Custprops: p,
    Deps: x,
    Sheets: s,
    SheetNames: u.SheetNames,
    Strings: U3,
    Styles: l,
    Themes: o,
    SSF: x1(k0)
  }, t && t.bookFiles && (e.files ? (v.keys = n, v.files = e.files) : (v.keys = [], v.files = {}, e.FullPaths.forEach(function(i0, p0) {
    i0 = i0.replace(/^Root Entry[\/]/, ""), v.keys.push(i0), v.files[i0] = e.FileIndex[p0];
  }))), t && t.bookVBA && (i.vba.length > 0 ? v.vbaraw = h1(e, q1(i.vba[0]), !0) : i.defaults && i.defaults.bin === Wf && (v.vbaraw = h1(e, "xl/vbaProject.bin", !0))), v.bookType = c ? "xlsb" : "xlsx", v;
}
function Mu(e, t) {
  var r = t || {}, a = "Workbook", n = L0.find(e, a);
  try {
    if (a = "/!DataSpaces/Version", n = L0.find(e, a), !n || !n.content)
      throw new Error("ECMA-376 Encrypted file missing " + a);
    if (_c(n.content), a = "/!DataSpaces/DataSpaceMap", n = L0.find(e, a), !n || !n.content)
      throw new Error("ECMA-376 Encrypted file missing " + a);
    var i = Ec(n.content);
    if (i.length !== 1 || i[0].comps.length !== 1 || i[0].comps[0].t !== 0 || i[0].name !== "StrongEncryptionDataSpace" || i[0].comps[0].v !== "EncryptedPackage")
      throw new Error("ECMA-376 Encrypted file bad " + a);
    if (a = "/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace", n = L0.find(e, a), !n || !n.content)
      throw new Error("ECMA-376 Encrypted file missing " + a);
    var c = wc(n.content);
    if (c.length != 1 || c[0] != "StrongEncryptionTransform")
      throw new Error("ECMA-376 Encrypted file bad " + a);
    if (a = "/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary", n = L0.find(e, a), !n || !n.content)
      throw new Error("ECMA-376 Encrypted file missing " + a);
    Cc(n.content);
  } catch {
  }
  if (a = "/EncryptionInfo", n = L0.find(e, a), !n || !n.content)
    throw new Error("ECMA-376 Encrypted file missing " + a);
  var s = Sc(n.content);
  if (a = "/EncryptedPackage", n = L0.find(e, a), !n || !n.content)
    throw new Error("ECMA-376 Encrypted file missing " + a);
  if (s[0] == 4 && typeof decrypt_agile < "u")
    return decrypt_agile(s[1], n.content, r.password || "", r);
  if (s[0] == 2 && typeof decrypt_std76 < "u")
    return decrypt_std76(s[1], n.content, r.password || "", r);
  throw new Error("File is password-protected");
}
function r5(e, t) {
  var r = "";
  switch ((t || {}).type || "base64") {
    case "buffer":
      return [e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]];
    case "base64":
      r = $1(e.slice(0, 12));
      break;
    case "binary":
      r = e;
      break;
    case "array":
      return [e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]];
    default:
      throw new Error("Unrecognized type " + (t && t.type || "undefined"));
  }
  return [r.charCodeAt(0), r.charCodeAt(1), r.charCodeAt(2), r.charCodeAt(3), r.charCodeAt(4), r.charCodeAt(5), r.charCodeAt(6), r.charCodeAt(7)];
}
function Nu(e, t) {
  return L0.find(e, "EncryptedPackage") ? Mu(e, t) : Y7(e, t);
}
function Pu(e, t) {
  var r, a = e, n = t || {};
  return n.type || (n.type = O0 && Buffer.isBuffer(e) ? "buffer" : "base64"), r = W6(a, n), Ru(r, n);
}
function a8(e, t) {
  var r = 0;
  e:
    for (; r < e.length; )
      switch (e.charCodeAt(r)) {
        case 10:
        case 13:
        case 32:
          ++r;
          break;
        case 60:
          return w4(e.slice(r), t);
        default:
          break e;
      }
  return K3.to_workbook(e, t);
}
function Lu(e, t) {
  var r = "", a = r5(e, t);
  switch (t.type) {
    case "base64":
      r = $1(e);
      break;
    case "binary":
      r = e;
      break;
    case "buffer":
      r = e.toString("binary");
      break;
    case "array":
      r = Y2(e);
      break;
    default:
      throw new Error("Unrecognized type " + t.type);
  }
  return a[0] == 239 && a[1] == 187 && a[2] == 191 && (r = X0(r)), t.type = "binary", a8(r, t);
}
function Bu(e, t) {
  var r = e;
  return t.type == "base64" && (r = $1(r)), typeof ArrayBuffer < "u" && e instanceof ArrayBuffer && (r = new Uint8Array(e)), r = O0 && Buffer.isBuffer(e) ? e.slice(2).toString("utf16le") : typeof Uint8Array < "u" && r instanceof Uint8Array ? typeof TextDecoder < "u" ? new TextDecoder("utf-16le").decode(r.slice(2)) : I9(r.slice(2)) : A6(r.slice(2)), t.type = "binary", a8(r, t);
}
function Uu(e) {
  return e.match(/[^\x00-\x7F]/) ? b3(e) : e;
}
function p4(e, t, r, a) {
  return a ? (r.type = "string", K3.to_workbook(e, r)) : K3.to_workbook(t, r);
}
function v3(e, t) {
  S6();
  var r = t || {};
  if (r.codepage && console.error("Codepage tables are not loaded.  Non-ASCII characters may not give expected results"), typeof ArrayBuffer < "u" && e instanceof ArrayBuffer)
    return v3(new Uint8Array(e), (r = x1(r), r.type = "array", r));
  typeof Uint8Array < "u" && e instanceof Uint8Array && !r.type && (r.type = typeof Deno < "u" ? "buffer" : "array");
  var a = e, n = [0, 0, 0, 0], i = !1;
  if (r.cellStyles && (r.cellNF = !0, r.sheetStubs = !0), x3 = {}, r.dateNF && (x3.dateNF = r.dateNF), r.type || (r.type = O0 && Buffer.isBuffer(e) ? "buffer" : "base64"), r.type == "file" && (r.type = O0 ? "buffer" : "binary", a = sn(e), typeof Uint8Array < "u" && !O0 && (r.type = "array")), r.type == "string" && (i = !0, r.type = "binary", r.codepage = 65001, a = Uu(e)), r.type == "array" && typeof Uint8Array < "u" && e instanceof Uint8Array && typeof ArrayBuffer < "u") {
    var c = new ArrayBuffer(3), s = new Uint8Array(c);
    if (s.foo = "bar", !s.foo)
      return r = x1(r), r.type = "array", v3(L4(a), r);
  }
  switch ((n = r5(a, r))[0]) {
    case 208:
      if (n[1] === 207 && n[2] === 17 && n[3] === 224 && n[4] === 161 && n[5] === 177 && n[6] === 26 && n[7] === 225)
        return Nu(L0.read(a, r), r);
      break;
    case 9:
      if (n[1] <= 8)
        return Y7(a, r);
      break;
    case 60:
      return w4(a, r);
    case 73:
      if (n[1] === 73 && n[2] === 42 && n[3] === 0)
        throw new Error("TIFF Image File is not a spreadsheet");
      if (n[1] === 68)
        return sc(a, r);
      break;
    case 84:
      if (n[1] === 65 && n[2] === 66 && n[3] === 76)
        return nc.to_workbook(a, r);
      break;
    case 80:
      return n[1] === 75 && n[2] < 9 && n[3] < 9 ? Pu(a, r) : p4(e, a, r, i);
    case 239:
      return n[3] === 60 ? w4(a, r) : p4(e, a, r, i);
    case 255:
      if (n[1] === 254)
        return Bu(a, r);
      if (n[1] === 0 && n[2] === 2 && n[3] === 0)
        return B3.to_workbook(a, r);
      break;
    case 0:
      if (n[1] === 0 && (n[2] >= 2 && n[3] === 0 || n[2] === 0 && (n[3] === 8 || n[3] === 9)))
        return B3.to_workbook(a, r);
      break;
    case 3:
    case 131:
    case 139:
    case 140:
      return fr.to_workbook(a, r);
    case 123:
      if (n[1] === 92 && n[2] === 114 && n[3] === 116)
        return Bc(a, r);
      break;
    case 10:
    case 13:
    case 32:
      return Lu(a, r);
    case 137:
      if (n[1] === 80 && n[2] === 78 && n[3] === 71)
        throw new Error("PNG Image File is not a spreadsheet");
      break;
    case 8:
      if (n[1] === 231)
        throw new Error("Unsupported Multiplan 1.x file!");
      break;
    case 12:
      if (n[1] === 236)
        throw new Error("Unsupported Multiplan 2.x file!");
      if (n[1] === 237)
        throw new Error("Unsupported Multiplan 3.x file!");
      break;
  }
  return tc.indexOf(n[0]) > -1 && n[2] <= 12 && n[3] <= 31 ? fr.to_workbook(a, r) : p4(e, a, r, i);
}
function Hu(e, t, r, a, n, i, c) {
  var s = j0(r), f = c.defval, o = c.raw || !Object.prototype.hasOwnProperty.call(c, "raw"), l = !0, d = e["!data"] != null, u = n === 1 ? [] : {};
  if (n !== 1)
    if (Object.defineProperty)
      try {
        Object.defineProperty(u, "__rowNum__", { value: r, enumerable: !1 });
      } catch {
        u.__rowNum__ = r;
      }
    else
      u.__rowNum__ = r;
  if (!d || e["!data"][r])
    for (var h = t.s.c; h <= t.e.c; ++h) {
      var p = d ? (e["!data"][r] || [])[h] : e[a[h] + s];
      if (p == null || p.t === void 0) {
        if (f === void 0)
          continue;
        i[h] != null && (u[i[h]] = f);
        continue;
      }
      var v = p.v;
      switch (p.t) {
        case "z":
          if (v == null)
            break;
          continue;
        case "e":
          v = v == 0 ? null : void 0;
          break;
        case "s":
        case "b":
        case "n":
          if (!p.z || !u2(p.z) || (v = O2(v), typeof v == "number"))
            break;
        case "d":
          c && (c.UTC || c.raw === !1) || (v = J2(new Date(v)));
          break;
        default:
          throw new Error("unrecognized type " + p.t);
      }
      if (i[h] != null) {
        if (v == null)
          if (p.t == "e" && v === null)
            u[i[h]] = null;
          else if (f !== void 0)
            u[i[h]] = f;
          else if (o && v === null)
            u[i[h]] = null;
          else
            continue;
        else
          u[i[h]] = (p.t === "n" && typeof c.rawNumbers == "boolean" ? c.rawNumbers : o) ? v : M2(p, v, c);
        v != null && (l = !1);
      }
    }
  return { row: u, isempty: l };
}
function C4(e, t) {
  if (e == null || e["!ref"] == null)
    return [];
  var r = { t: "n", v: 0 }, a = 0, n = 1, i = [], c = 0, s = "", f = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } }, o = t || {}, l = o.range != null ? o.range : e["!ref"];
  switch (o.header === 1 ? a = 1 : o.header === "A" ? a = 2 : Array.isArray(o.header) ? a = 3 : o.header == null && (a = 0), typeof l) {
    case "string":
      f = o1(l);
      break;
    case "number":
      f = o1(e["!ref"]), f.s.r = l;
      break;
    default:
      f = l;
  }
  a > 0 && (n = 0);
  var d = j0(f.s.r), u = [], h = [], p = 0, v = 0, x = e["!data"] != null, m = f.s.r, T = 0, g = {};
  x && !e["!data"][m] && (e["!data"][m] = []);
  var O = o.skipHidden && e["!cols"] || [], H = o.skipHidden && e["!rows"] || [];
  for (T = f.s.c; T <= f.e.c; ++T)
    if (!(O[T] || {}).hidden)
      switch (u[T] = W0(T), r = x ? e["!data"][m][T] : e[u[T] + d], a) {
        case 1:
          i[T] = T - f.s.c;
          break;
        case 2:
          i[T] = u[T];
          break;
        case 3:
          i[T] = o.header[T - f.s.c];
          break;
        default:
          if (r == null && (r = { w: "__EMPTY", t: "s" }), s = c = M2(r, null, o), v = g[c] || 0, !v)
            g[c] = 1;
          else {
            do
              s = c + "_" + v++;
            while (g[s]);
            g[c] = v, g[s] = 1;
          }
          i[T] = s;
      }
  for (m = f.s.r + n; m <= f.e.r; ++m)
    if (!(H[m] || {}).hidden) {
      var W = Hu(e, f, m, u, a, i, o);
      (W.isempty === !1 || (a === 1 ? o.blankrows !== !1 : o.blankrows)) && (h[p++] = W.row);
    }
  return h.length = p, h;
}
var kr = /"/g;
function Wu(e, t, r, a, n, i, c, s) {
  for (var f = !0, o = [], l = "", d = j0(r), u = e["!data"] != null, h = u && e["!data"][r] || [], p = t.s.c; p <= t.e.c; ++p)
    if (a[p]) {
      var v = u ? h[p] : e[a[p] + d];
      if (v == null)
        l = "";
      else if (v.v != null) {
        f = !1, l = "" + (s.rawNumbers && v.t == "n" ? v.v : M2(v, null, s));
        for (var x = 0, m = 0; x !== l.length; ++x)
          if ((m = l.charCodeAt(x)) === n || m === i || m === 34 || s.forceQuotes) {
            l = '"' + l.replace(kr, '""') + '"';
            break;
          }
        l == "ID" && (l = '"ID"');
      } else
        v.f != null && !v.F ? (f = !1, l = "=" + v.f, l.indexOf(",") >= 0 && (l = '"' + l.replace(kr, '""') + '"')) : l = "";
      o.push(l);
    }
  return s.blankrows === !1 && f ? null : o.join(c);
}
function n8(e, t) {
  var r = [], a = t ?? {};
  if (e == null || e["!ref"] == null)
    return "";
  for (var n = o1(e["!ref"]), i = a.FS !== void 0 ? a.FS : ",", c = i.charCodeAt(0), s = a.RS !== void 0 ? a.RS : `
`, f = s.charCodeAt(0), o = new RegExp((i == "|" ? "\\|" : i) + "+$"), l = "", d = [], u = a.skipHidden && e["!cols"] || [], h = a.skipHidden && e["!rows"] || [], p = n.s.c; p <= n.e.c; ++p)
    (u[p] || {}).hidden || (d[p] = W0(p));
  for (var v = 0, x = n.s.r; x <= n.e.r; ++x)
    (h[x] || {}).hidden || (l = Wu(e, n, x, d, c, f, i, a), l != null && (a.strip && (l = l.replace(o, "")), (l || a.blankrows !== !1) && r.push((v++ ? s : "") + l)));
  return r.join("");
}
function Vu(e, t) {
  t || (t = {}), t.FS = "	", t.RS = `
`;
  var r = n8(e, t);
  return r;
}
function Gu(e) {
  var t = "", r, a = "";
  if (e == null || e["!ref"] == null)
    return [];
  var n = o1(e["!ref"]), i = "", c = [], s, f = [], o = e["!data"] != null;
  for (s = n.s.c; s <= n.e.c; ++s)
    c[s] = W0(s);
  for (var l = n.s.r; l <= n.e.r; ++l)
    for (i = j0(l), s = n.s.c; s <= n.e.c; ++s)
      if (t = c[s] + i, r = o ? (e["!data"][l] || [])[s] : e[t], a = "", r !== void 0) {
        if (r.F != null) {
          if (t = r.F, !r.f)
            continue;
          a = r.f, t.indexOf(":") == -1 && (t = t + ":" + t);
        }
        if (r.f != null)
          a = r.f;
        else {
          if (r.t == "z")
            continue;
          if (r.t == "n" && r.v != null)
            a = "" + r.v;
          else if (r.t == "b")
            a = r.v ? "TRUE" : "FALSE";
          else if (r.w !== void 0)
            a = "'" + r.w;
          else {
            if (r.v === void 0)
              continue;
            r.t == "s" ? a = "'" + r.v : a = "" + r.v;
          }
        }
        f[f.length] = t + "=" + a;
      }
  return f;
}
function i8(e, t, r) {
  var a = r || {}, n = e ? e["!data"] != null : a.dense, i = +!a.skipHeader, c = e || {};
  !e && n && (c["!data"] = []);
  var s = 0, f = 0;
  if (c && a.origin != null)
    if (typeof a.origin == "number")
      s = a.origin;
    else {
      var o = typeof a.origin == "string" ? y1(a.origin) : a.origin;
      s = o.r, f = o.c;
    }
  var l = { s: { c: 0, r: 0 }, e: { c: f, r: s + t.length - 1 + i } };
  if (c["!ref"]) {
    var d = o1(c["!ref"]);
    l.e.c = Math.max(l.e.c, d.e.c), l.e.r = Math.max(l.e.r, d.e.r), s == -1 && (s = d.e.r + 1, l.e.r = s + t.length - 1 + i);
  } else
    s == -1 && (s = 0, l.e.r = t.length - 1 + i);
  var u = a.header || [], h = 0, p = [];
  t.forEach(function(x, m) {
    n && !c["!data"][s + m + i] && (c["!data"][s + m + i] = []), n && (p = c["!data"][s + m + i]), t2(x).forEach(function(T) {
      (h = u.indexOf(T)) == -1 && (u[h = u.length] = T);
      var g = x[T], O = "z", H = "", W = n ? "" : W0(f + h) + j0(s + m + i), E = n ? p[f + h] : c[W];
      g && typeof g == "object" && !(g instanceof Date) ? n ? p[f + h] = g : c[W] = g : (typeof g == "number" ? O = "n" : typeof g == "boolean" ? O = "b" : typeof g == "string" ? O = "s" : g instanceof Date ? (O = "d", a.UTC || (g = $e(g)), a.cellDates || (O = "n", g = v1(g)), H = E != null && E.z && u2(E.z) ? E.z : a.dateNF || k0[14]) : g === null && a.nullError && (O = "e", g = 0), E ? (E.t = O, E.v = g, delete E.w, delete E.R, H && (E.z = H)) : n ? p[f + h] = E = { t: O, v: g } : c[W] = E = { t: O, v: g }, H && (E.z = H));
    });
  }), l.e.c = Math.max(l.e.c, f + u.length - 1);
  var v = j0(s);
  if (n && !c["!data"][s] && (c["!data"][s] = []), i)
    for (h = 0; h < u.length; ++h)
      n ? c["!data"][s][h + f] = { t: "s", v: u[h] } : c[W0(h + f) + v] = { t: "s", v: u[h] };
  return c["!ref"] = M0(l), c;
}
function ju(e, t) {
  return i8(null, e, t);
}
function Z3(e, t, r) {
  if (typeof t == "string") {
    if (e["!data"] != null) {
      var a = y1(t);
      return e["!data"][a.r] || (e["!data"][a.r] = []), e["!data"][a.r][a.c] || (e["!data"][a.r][a.c] = { t: "z" });
    }
    return e[t] || (e[t] = { t: "z" });
  }
  return typeof t != "number" ? Z3(e, H0(t)) : Z3(e, W0(r || 0) + j0(t));
}
function zu(e, t) {
  if (typeof t == "number") {
    if (t >= 0 && e.SheetNames.length > t)
      return t;
    throw new Error("Cannot find sheet # " + t);
  } else if (typeof t == "string") {
    var r = e.SheetNames.indexOf(t);
    if (r > -1)
      return r;
    throw new Error("Cannot find sheet name |" + t + "|");
  } else
    throw new Error("Cannot find sheet |" + t + "|");
}
function t5(e, t) {
  var r = { SheetNames: [], Sheets: {} };
  return e && se(r, e, t || "Sheet1"), r;
}
function se(e, t, r, a) {
  var n = 1;
  if (!r)
    for (; n <= 65535 && e.SheetNames.indexOf(r = "Sheet" + n) != -1; ++n, r = void 0)
      ;
  if (!r || e.SheetNames.length >= 65535)
    throw new Error("Too many worksheets");
  if (a && e.SheetNames.indexOf(r) >= 0) {
    var i = r.match(/(^.*?)(\d+)$/);
    n = i && +i[2] || 0;
    var c = i && i[1] || r;
    for (++n; n <= 65535 && e.SheetNames.indexOf(r = c + n) != -1; ++n)
      ;
  }
  if (Ah(r), e.SheetNames.indexOf(r) >= 0)
    throw new Error("Worksheet with name |" + r + "| already exists!");
  return e.SheetNames.push(r), e.Sheets[r] = t, r;
}
function $u(e, t, r) {
  e.Workbook || (e.Workbook = {}), e.Workbook.Sheets || (e.Workbook.Sheets = []);
  var a = zu(e, t);
  switch (e.Workbook.Sheets[a] || (e.Workbook.Sheets[a] = {}), r) {
    case 0:
    case 1:
    case 2:
      break;
    default:
      throw new Error("Bad sheet visibility setting " + r);
  }
  e.Workbook.Sheets[a].Hidden = r;
}
function Xu(e, t) {
  return e.z = t, e;
}
function s8(e, t, r) {
  return t ? (e.l = { Target: t }, r && (e.l.Tooltip = r)) : delete e.l, e;
}
function Ku(e, t, r) {
  return s8(e, "#" + t, r);
}
function Yu(e, t, r) {
  e.c || (e.c = []), e.c.push({ t, a: r || "SheetJS" });
}
function Ju(e, t, r, a) {
  for (var n = typeof t != "string" ? t : o1(t), i = typeof t == "string" ? t : M0(t), c = n.s.r; c <= n.e.r; ++c)
    for (var s = n.s.c; s <= n.e.c; ++s) {
      var f = Z3(e, c, s);
      f.t = "n", f.F = i, delete f.v, c == n.s.r && s == n.s.c && (f.f = r, a && (f.D = !0));
    }
  var o = Q2(e["!ref"]);
  return o.s.r > n.s.r && (o.s.r = n.s.r), o.s.c > n.s.c && (o.s.c = n.s.c), o.e.r < n.e.r && (o.e.r = n.e.r), o.e.c < n.e.c && (o.e.c = n.e.c), e["!ref"] = M0(o), e;
}
var c8 = {
  encode_col: W0,
  encode_row: j0,
  encode_cell: H0,
  encode_range: M0,
  decode_col: j4,
  decode_row: G4,
  split_cell: Jn,
  decode_cell: y1,
  decode_range: Q2,
  format_cell: M2,
  sheet_new: Zn,
  sheet_add_aoa: i7,
  sheet_add_json: i8,
  sheet_add_dom: J7,
  aoa_to_sheet: E3,
  json_to_sheet: ju,
  table_to_sheet: q7,
  table_to_book: lu,
  sheet_to_csv: n8,
  sheet_to_txt: Vu,
  sheet_to_json: C4,
  sheet_to_html: ou,
  sheet_to_formulae: Gu,
  sheet_to_row_object_array: C4,
  sheet_get_cell: Z3,
  book_new: t5,
  book_append_sheet: se,
  book_set_sheet_visibility: $u,
  cell_set_number_format: Xu,
  cell_set_hyperlink: s8,
  cell_set_internal_link: Ku,
  cell_add_comment: Yu,
  sheet_set_array_formula: Ju,
  consts: {
    SHEET_VISIBLE: 0,
    SHEET_HIDDEN: 1,
    SHEET_VERY_HIDDEN: 2
  }
};
const qu = Fr(W8)(({
  theme: e
}) => ({
  "& .MuiAlert-icon": {
    alignItems: "flex-start",
    display: "flex",
    fontSize: "1rem",
    justifyContent: "center",
    lineHeight: "1rem",
    marginRight: e.spacing(0.75),
    padding: e.spacing(0.5, 0)
  },
  "& .MuiAlert-message": {
    fontSize: "0.875rem",
    lineHeight: "1.5rem",
    padding: e.spacing(0),
    whiteSpace: "pre-wrap"
  },
  borderRadius: 0,
  flex: 1,
  padding: e.spacing(0.5, 1)
})), f8 = K1(({
  OkayButtonProps: e,
  extractSchemaMode: t = !1
}) => {
  const {
    deferred: r,
    schema: a
  } = _3(), {
    showNavigator: n,
    uploadMode: i
  } = S4(), {
    file: c,
    fileEncoding: s,
    setFile: f,
    setFileEncoding: o
  } = He(), {
    analyzing: l,
    upload: d,
    validationError: u,
    uploading: h,
    uploadError: p,
    uploadResult: v,
    setUploading: x,
    setUploadResult: m,
    setUploadError: T,
    setUploadLabel: g,
    setUploadProgress: O,
    setAfterUploadResults: H,
    setBeforeUploadResults: W
  } = Ue(), {
    dropFailedRows: E,
    setShowColumns: b,
    setDeferringSchema: I
  } = g3(), {
    name: P,
    size: L
  } = c || {}, {
    currentStep: z,
    setCurrentStep: Y,
    steps: f0,
    currentStepKey: i0,
    setCurrentStepByKey: p0
  } = Rr(), n0 = () => {
    Y((r0) => r0 + 1);
  }, v0 = D3((r0) => {
    Y(r0);
  }, [Y]), {
    getInputProps: I0,
    open: K
  } = Or({
    maxFiles: 1,
    multiple: !1,
    noClick: !0,
    noKeyboard: !0,
    onDropAccepted: (r0) => {
      const [E0] = r0;
      if (E0.name.endsWith(".xlsx") || E0.name.endsWith(".xls")) {
        const b0 = new FileReader();
        b0.onload = function(D0) {
          if (D0.target?.result) {
            const F = D0.target.result, B = v3(F), R = B.Sheets[B.SheetNames[0]], D = c8.sheet_to_csv(R);
            f(new File([D], E0.name, {
              type: "text/csv"
            }));
          }
        }, b0.readAsArrayBuffer(E0);
      } else {
        const b0 = new FileReader();
        b0.onload = function(D0) {
          if (D0.target?.result) {
            const F = D0.target.result, {
              encoding: B
            } = C6.detect(F);
            o(B), f(E0);
          }
        }, b0.readAsBinaryString(E0.slice(0, 1024 * 1024));
      }
    }
  });
  ke(() => {
    p0(n ? r2.FormatData : r2.FixValues);
  }, [c, p0, n]), ke(() => {
    z >= 2 || r ? b(O3.Mapped) : b(O3.All);
  }, [z, b, r]);
  const T0 = i0 === r2.AdjustSchema;
  ke(() => {
    T0 && I(!0);
  }, [T0, I]);
  const S0 = !t, w0 = G3(() => i === "unbound" ? {
    defaultMessage: f0[z].message({
      dropFailedRows: E
    }),
    uploadErrorMessage: "The upload has failed. Please check the error details below.",
    uploadResultMessage: "The encryption and upload has completed successfully. This dialog can be now closed.",
    uploadingMessage: "Please wait for the encryption and upload to complete."
  } : {
    defaultMessage: f0[z].message({
      dropFailedRows: E
    })
  }, [f0, E, z, i]);
  return c ? /* @__PURE__ */ N.jsx(l0, { sx: {
    display: "flex",
    flex: "0 0 auto",
    overflow: "hidden"
  }, children: /* @__PURE__ */ N.jsxs(l0, { sx: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    gap: "0.5rem",
    overflow: "hidden",
    pl: 1,
    pr: 1
  }, children: [
    S0 ? /* @__PURE__ */ N.jsxs(l0, { sx: {
      alignItems: "center",
      display: "flex",
      gap: "0.5rem"
    }, children: [
      /* @__PURE__ */ N.jsx("input", { ...I0() }),
      /* @__PURE__ */ N.jsxs(l0, { "data-testid": "upload-button", onClick: h || v || p ? void 0 : K, sx: {
        alignItems: "center",
        cursor: h || v || p ? void 0 : "pointer",
        display: "flex",
        gap: "0.5rem"
      }, children: [
        /* @__PURE__ */ N.jsx(r1, { icon: lt, style: {
          fontSize: "20px"
        } }),
        /* @__PURE__ */ N.jsxs(l0, { sx: {
          display: "flex",
          flexDirection: "column"
        }, children: [
          P ? /* @__PURE__ */ N.jsx("span", { style: {
            fontSize: "0.875rem",
            fontWeight: 500
          }, children: P }) : null,
          /* @__PURE__ */ N.jsxs(l0, { sx: {
            display: "flex",
            fontSize: "0.75rem",
            gap: "0.5rem",
            lineHeight: 1
          }, children: [
            L ? /* @__PURE__ */ N.jsx("span", { children: Ot(L) }) : null,
            s ? /* @__PURE__ */ N.jsx("span", { children: s }) : null
          ] })
        ] }),
        !v && /* @__PURE__ */ N.jsx(r1, { icon: ht, style: {
          fontSize: "20px"
        } })
      ] }),
      /* @__PURE__ */ N.jsx(l0, { sx: {
        flex: 1
      }, children: /* @__PURE__ */ N.jsx(V8, { orientation: "horizontal", style: {
        visibility: n ? "visible" : "hidden"
      }, children: f0.map((r0, E0) => /* @__PURE__ */ N.jsx(G8, { "data-testid": r0.label, indicator: /* @__PURE__ */ N.jsx(j8, { color: E0 <= z ? "primary" : "neutral", variant: E0 <= z ? "solid" : "outlined", children: E0 + 1 }), onClick: n && E0 !== 3 && z >= E0 && !(h || v || p) ? () => v0(E0) : void 0, sx: n && E0 !== 3 && z >= E0 && !(h || v || p) ? {
        cursor: "pointer !important"
      } : void 0, children: /* @__PURE__ */ N.jsx(yr, { children: r0.label }) }, r0.label)) }) })
    ] }) : null,
    (c.name.endsWith(".xlsx") || c.name.endsWith(".xls")) && z === 0 ? /* @__PURE__ */ N.jsx(l0, { children: /* @__PURE__ */ N.jsx(qu, { color: "warning", startDecorator: /* @__PURE__ */ N.jsx(r1, { fixedWidth: !0, icon: It }), children: "Only the first tab of the selected Excel workbook was used." }) }) : null,
    /* @__PURE__ */ N.jsxs(l0, { sx: {
      alignItems: "center",
      display: "flex",
      gap: "0.5rem"
    }, children: [
      /* @__PURE__ */ N.jsx(yt, { ...w0 }),
      /* @__PURE__ */ N.jsx(l0, { children: t ? /* @__PURE__ */ N.jsx(f5, { color: "primary", disabled: !!u || h || l, onClick: (r0) => {
        e?.onClick?.(r0, u5(a));
      }, variant: "solid", children: "Import schema" }) : /* @__PURE__ */ N.jsx(f5, { color: "primary", "data-testid": "continue", disabled: !!u || h || l, onClick: (r0) => {
        p ? (x(!1), g(void 0), O(void 0), m(void 0), T(void 0), H(void 0), W(void 0), v0(2)) : v ? e?.onClick?.(r0, u5(a)) : (n0(), z === f0.length - 2 && d?.());
      }, startDecorator: z === f0.length - 2 ? /* @__PURE__ */ N.jsx(r1, { icon: ut }) : void 0, variant: "solid", children: z === f0.length - 2 ? e?.confirmationLabel || "Encrypt & provision" : z === f0.length - 1 ? p ? "Go back" : "Done" : "Continue" }) })
    ] }),
    h || v || p ? null : /* @__PURE__ */ N.jsx(l0, { sx: {
      flex: 1,
      overflow: "auto"
    }, children: f0[z].controls })
  ] }) }) : null;
});
f8.displayName = "Navigator";
const o8 = K1(() => {
  const {
    schema: e,
    setSchema: t
  } = _3(), {
    setMappedColumns: r
  } = g3(), [a, n] = Ce((e?.columns || []).map((d) => ({
    ...d,
    include: !0
  }))), [i] = Ce((e?.columns || []).map((d) => d.id)), c = D3((d) => {
    t((u) => {
      const h = d.filter((p) => p.include);
      return o5(h, u?.columns) ? u : {
        ...u,
        columns: h
      };
    }), r((u) => {
      const h = d.map(({
        id: p,
        include: v
      }) => v ? i.indexOf(p) : void 0).filter((p) => p !== void 0);
      return o5(h, u) ? u : h;
    });
  }, [t, i, r]), {
    run: s
  } = kt(c, {
    wait: 700
  }), f = D3((d) => {
    n((u) => {
      const h = u.map((p) => p.id === d.id ? d : p);
      return s(h), h;
    });
  }, [n, s]), o = D3((d) => {
    n((u) => {
      const h = u.slice().sort((p, v) => d.indexOf(p.id) - d.indexOf(v.id));
      return s(h), h;
    });
  }, [n, s]), l = G3(() => [{
    Cell: ({
      cell: d,
      row: u
    }) => /* @__PURE__ */ N.jsx(St, { cancelEditingButtonEnabled: !1, fullWidth: !0, onChange: (h) => f({
      ...u.original,
      name: h
    }), placeholder: "Name", saveEditingButtonEnabled: !1, saveEditingOnClickAway: !0, style: {
      width: "100%"
    }, validate: (h) => h.trim() ? a.some(({
      name: p
    }) => p === h) ? "Column name must be unique" : null : "Column name can't be empty", value: d.getValue() }),
    accessorKey: "name",
    header: "Column name"
  }, {
    Cell: ({
      cell: d,
      row: u
    }) => /* @__PURE__ */ N.jsx(r4, { checked: d.getValue(), onChange: (h) => f({
      ...u.original,
      include: h.target.checked
    }) }),
    accessorKey: "include",
    header: "Include",
    muiTableBodyCellProps: {
      align: "center"
    },
    muiTableHeadCellProps: {
      align: "center"
    },
    size: 50
  }, {
    Cell: ({
      cell: d,
      row: u
    }) => /* @__PURE__ */ N.jsx(Ir, { onChange: (h, p) => f({
      ...u.original,
      formatType: p
    }), slotProps: {
      listbox: {
        variant: "outlined"
      }
    }, value: d.getValue(), variant: "plain", children: Object.entries(Qu).map(([h, p], v) => /* @__PURE__ */ N.jsx(m4, { value: h, children: /* @__PURE__ */ N.jsxs(l0, { alignItems: "center", display: "flex", justifyContent: "flex-start", children: [
      Be[h],
      /* @__PURE__ */ N.jsx(yr, { paddingLeft: 0.5, children: p })
    ] }) }, v)) }),
    accessorKey: "formatType",
    header: "Data type"
  }, {
    Cell: ({
      cell: d,
      row: u
    }) => /* @__PURE__ */ N.jsx(r4, { checked: !!d.getValue(), onChange: (h) => f({
      ...u.original,
      hashWith: h.target.checked ? Ct.Sha256Hex : void 0
    }) }),
    accessorKey: "hashWith",
    header: "Hashed values",
    muiTableBodyCellProps: {
      align: "center"
    },
    muiTableHeadCellProps: {
      align: "center"
    },
    size: 75
  }, {
    Cell: ({
      cell: d,
      row: u
    }) => /* @__PURE__ */ N.jsx(r4, { checked: d.getValue(), onChange: (h) => f({
      ...u.original,
      nullable: h.target.checked
    }) }),
    accessorKey: "nullable",
    header: "Allow empty values",
    muiTableBodyCellProps: {
      align: "center"
    },
    muiTableHeadCellProps: {
      align: "center"
    },
    size: 100
  }], [f, a]);
  return /* @__PURE__ */ N.jsx(l0, { sx: {
    maxHeight: "250px",
    overflowY: "scroll"
  }, children: /* @__PURE__ */ N.jsx(n5, { autoResetPageIndex: !1, columns: l, data: a, enableBottomToolbar: !1, enablePagination: !1, enableRowOrdering: !0, localization: {
    move: ""
  }, muiRowDragHandleProps: ({
    table: d
  }) => ({
    onDragEnd: () => {
      const {
        draggingRow: u,
        hoveredRow: h
      } = d.getState();
      if (h && u) {
        const p = [...a];
        p.splice(h.index, 0, p.splice(u.index, 1)[0]);
        const v = p.map((x) => x.id);
        o(v);
      }
    }
  }), muiTableBodyCellProps: {
    sx: {
      p: 0
    }
  } }) });
});
o8.displayName = "AdjustSchemaControls";
const l8 = K1(({
  column: e
}) => {
  const {
    schema: t
  } = _3(), {
    mappedColumns: r
  } = g3(), a = t?.columns || [], n = r.indexOf(Number(e.id)), i = a[n];
  return /* @__PURE__ */ N.jsxs(
    l0,
    {
      className: "value",
      sx: {
        alignItems: "center",
        display: "flex",
        flex: 1,
        fontSize: "0.875rem",
        fontWeight: 500,
        gap: "0.375rem",
        lineHeight: "1.25rem",
        width: "100%"
      },
      children: [
        Be[i.formatType],
        /* @__PURE__ */ N.jsx(l0, { sx: {
          flex: "1 1 auto",
          overflow: "hidden",
          textOverflow: "ellipsis"
        }, children: i.name })
      ]
    }
  );
});
l8.displayName = "DeferredHeader";
const Cr = () => /* @__PURE__ */ N.jsx(l0, { sx: {
  alignItems: "center",
  display: "flex",
  flex: 1,
  fontSize: "0.75rem",
  fontWeight: 500,
  lineHeight: "1.25rem"
}, children: /* @__PURE__ */ N.jsx(l0, { sx: {
  fontSize: "10px",
  letterSpacing: "0.25px",
  textTransform: "uppercase"
}, children: "Skip" }) }), a5 = K1(({
  column: e,
  readOnly: t = !1,
  labelSx: r,
  selectSx: a
}) => {
  const {
    schema: n
  } = _3(), {
    columns: i = []
  } = n || {}, {
    mappedColumns: c,
    setMappedColumns: s
  } = g3(), {
    id: f
  } = e, o = parseInt(f), l = c.indexOf(o);
  return /* @__PURE__ */ N.jsxs(l0, { sx: {
    alignItems: "center",
    display: "flex",
    gap: "0.25rem"
  }, children: [
    /* @__PURE__ */ N.jsx(l0, { sx: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      ...r
    }, children: e.columnDef.header }),
    /* @__PURE__ */ N.jsx(l0, { children: /* @__PURE__ */ N.jsx(r1, { fixedWidth: !0, icon: xt }) }),
    /* @__PURE__ */ N.jsx(l0, { sx: {
      alignItems: "center",
      display: "flex",
      gap: "0.5rem"
    }, children: t ? l === -1 ? /* @__PURE__ */ N.jsx(l0, { sx: {
      alignItems: "center",
      display: "flex",
      flex: 1,
      fontSize: "0.75rem",
      fontWeight: 500,
      lineHeight: "1.25rem"
    }, children: /* @__PURE__ */ N.jsx(l0, { sx: {
      fontSize: "10px",
      letterSpacing: "0.25px",
      textTransform: "uppercase"
    }, children: "Skip" }) }) : /* @__PURE__ */ N.jsxs(l0, { className: "value", sx: {
      alignItems: "center",
      display: "flex",
      flex: 1,
      fontSize: "0.875rem",
      fontWeight: 500,
      gap: "0.375rem",
      lineHeight: "1.25rem",
      width: "100%"
    }, children: [
      Be[i[l].formatType],
      /* @__PURE__ */ N.jsx(l0, { sx: {
        flex: "1 1 auto",
        overflow: "hidden",
        textAlign: "left",
        textOverflow: "ellipsis"
      }, children: i[l].name })
    ] }) : /* @__PURE__ */ N.jsxs(Ir, { "data-testid": `mapped-columns-select-${o}`, onChange: (d, u) => {
      s((h) => {
        if (u !== "" && u !== null) {
          const p = h.map((v) => v === o ? void 0 : v);
          return p[Number(u)] = o, p;
        } else if (l > -1) {
          const p = [...h];
          return p[l] = void 0, p;
        }
        return h;
      });
    }, slotProps: {
      listbox: {
        variant: "outlined"
      }
    }, sx: {
      "& > .MuiSelect-button": {
        "& > .value": {
          "& > .map-indicator": {
            display: "none"
          }
        }
      },
      ...a
    }, value: l === -1 ? "" : l.toString(), variant: "plain", children: [
      i.map((d, u) => {
        const {
          name: h = `Column ${u + 1}`,
          formatType: p,
          hashWith: v
        } = d || {}, x = p ? Be[p] : null, m = /* @__PURE__ */ N.jsxs(l0, { className: "value", sx: {
          alignItems: "center",
          display: "flex",
          flex: 1,
          fontSize: "0.875rem",
          fontWeight: 500,
          gap: "0.375rem",
          lineHeight: "1.25rem",
          width: "100%"
        }, children: [
          x,
          /* @__PURE__ */ N.jsx(I2, { disableFocusListener: !0, disableTouchListener: !0, modifiers: [{
            name: "offset",
            options: {
              offset: [0, 6]
            }
          }], placement: "top-start", title: h, children: /* @__PURE__ */ N.jsx(l0, { sx: {
            flex: "1 1 auto",
            overflow: "hidden",
            textOverflow: "ellipsis"
          }, children: h }) }),
          v ? /* @__PURE__ */ N.jsx(l0, { sx: {
            marginBottom: -0.75,
            marginTop: -0.75
          }, children: /* @__PURE__ */ N.jsx(wt, { columnIndex: u }) }) : null,
          /* @__PURE__ */ N.jsx(l0, { className: "map-indicator", sx: {
            alignItems: "center",
            display: "flex",
            flex: "0 0 auto",
            fontSize: "0.75rem",
            height: "1rem",
            justifyContent: "center",
            marginLeft: "1px",
            width: "1rem"
          }, children: c.at(u) !== void 0 ? /* @__PURE__ */ N.jsx(r1, { fixedWidth: !0, icon: dt }) : null })
        ] });
        return /* @__PURE__ */ N.jsx(m4, { "data-testid": `mapped-columns-select-${o}-item-${u}`, label: m, value: u.toString(), children: m }, u);
      }),
      /* @__PURE__ */ N.jsx(z8, {}),
      /* @__PURE__ */ N.jsx(m4, { label: /* @__PURE__ */ N.jsx(Cr, {}), value: "", children: /* @__PURE__ */ N.jsx(Cr, {}) })
    ] }) })
  ] });
});
a5.displayName = "Header";
const h8 = K1(() => {
  const {
    fileHeaders: e
  } = He(), t = e?.length || 0;
  return /* @__PURE__ */ N.jsxs(l0, { children: [
    /* @__PURE__ */ N.jsxs(l0, { sx: {
      alignItems: "center",
      display: "flex",
      gap: "0.25rem",
      mb: 1
    }, children: [
      /* @__PURE__ */ N.jsx(l0, { sx: {
        fontWeight: 500,
        width: 218
      }, children: "File column" }),
      /* @__PURE__ */ N.jsx(l0, { sx: {
        fontWeight: 500
      }, children: "Table column" })
    ] }),
    /* @__PURE__ */ N.jsx(l0, { sx: {
      fontSize: "0.875rem",
      maxHeight: "25vh",
      mb: 2,
      overflow: "auto"
    }, children: [...Array(t).keys()].map((r) => /* @__PURE__ */ N.jsx(a5, { column: {
      columnDef: {
        header: e?.at(r) || `Column ${(r + 1).toString()}`
      },
      id: r.toString()
    }, labelSx: {
      width: 200
    }, selectSx: {
      width: 200
    } }, r)) })
  ] });
});
h8.displayName = "MappedColumnsControls";
const Zu = [{
  controls: /* @__PURE__ */ N.jsx(Mr, {}),
  key: r2.FormatData,
  label: "Format data",
  message: () => /* @__PURE__ */ N.jsx(l0, { children: "Select the option below if your file has headers in the first row and which kind of separators are used for columns and for decimal numbers." })
}, {
  controls: /* @__PURE__ */ N.jsx(h8, {}),
  key: r2.MappedColumns,
  label: "Map columns",
  message: () => /* @__PURE__ */ N.jsx(l0, { children: "Now map the table schema columns to your file columns by selecting them in the dropdown." })
}, {
  controls: /* @__PURE__ */ N.jsx(Nr, {}),
  key: r2.FixValues,
  label: "Fix values",
  message: ({
    dropFailedRows: e
  }) => /* @__PURE__ */ N.jsxs(l0, { children: [
    "By pressing “Encrypt & provision” your dataset will be securely provisioned",
    e ? " dropping all failed rows from it" : "",
    "."
  ] })
}, {
  controls: null,
  key: r2.EncryptAndProvision,
  label: "Encrypt & provision",
  message: () => /* @__PURE__ */ N.jsx(l0, { children: "Please wait for the encryption and provisioning to complete." })
}], Id = [{
  controls: /* @__PURE__ */ N.jsx(Mr, {}),
  key: r2.FormatData,
  label: "Format data",
  message: () => /* @__PURE__ */ N.jsx(l0, { children: "Select the option below if your file has headers in the first row and which kind of separators are used for columns and for decimal numbers." })
}, {
  controls: /* @__PURE__ */ N.jsx(o8, {}),
  key: r2.AdjustSchema,
  label: "Adjust schema",
  message: () => /* @__PURE__ */ N.jsx(l0, { children: "The schema of your data has been automatically detected. Please double-check and make adjustments if needed." })
}, {
  controls: /* @__PURE__ */ N.jsx(Nr, {}),
  key: r2.FixValues,
  label: "Fix values",
  message: ({
    dropFailedRows: e
  }) => /* @__PURE__ */ N.jsxs(l0, { children: [
    "By pressing “Encrypt & upload” your dataset will be securely uploaded",
    e ? " dropping all failed rows from it" : "",
    "."
  ] })
}, {
  controls: null,
  key: r2.EncryptAndProvision,
  label: "Encrypt & upload",
  message: () => /* @__PURE__ */ N.jsx(l0, { children: "Please wait for the encryption and upload to complete." })
}], G2 = {
  disableFocusListener: !0,
  disableTouchListener: !0,
  modifiers: [{
    name: "offset",
    options: {
      offset: [0, 9]
    }
  }],
  placement: "top"
}, Be = {
  DATE_ISO8601: /* @__PURE__ */ N.jsx(I2, { ...G2, title: "Date", children: /* @__PURE__ */ N.jsx(r1, { fixedWidth: !0, icon: Et }) }),
  EMAIL: /* @__PURE__ */ N.jsx(I2, { ...G2, title: "Email", children: /* @__PURE__ */ N.jsx(r1, { fixedWidth: !0, icon: Tt }) }),
  FLOAT: /* @__PURE__ */ N.jsx(I2, { ...G2, title: "Float", children: /* @__PURE__ */ N.jsxs("span", { style: {
    display: "flex",
    position: "relative"
  }, children: [
    /* @__PURE__ */ N.jsx("span", { style: {
      fontWeight: 600,
      left: "-2px",
      lineHeight: "1rem",
      position: "absolute"
    }, children: "." }),
    /* @__PURE__ */ N.jsx(r1, { fixedWidth: !0, icon: _t })
  ] }) }),
  HASH_SHA256_HEX: /* @__PURE__ */ N.jsx(I2, { ...G2, title: "Hash", children: /* @__PURE__ */ N.jsx(r1, { fixedWidth: !0, icon: gt }) }),
  INTEGER: /* @__PURE__ */ N.jsx(I2, { ...G2, title: "Integer", children: /* @__PURE__ */ N.jsx(r1, { fixedWidth: !0, icon: vt }) }),
  PHONE_NUMBER_E164: /* @__PURE__ */ N.jsx(I2, { ...G2, title: "Phone", children: /* @__PURE__ */ N.jsx(r1, { fixedWidth: !0, icon: mt }) }),
  STRING: /* @__PURE__ */ N.jsx(I2, { ...G2, title: "String", children: /* @__PURE__ */ N.jsx(r1, { fixedWidth: !0, icon: pt }) })
}, Qu = {
  DATE_ISO8601: "Date (YYYY-MM-DD)",
  EMAIL: "Email",
  FLOAT: "Number (decimal)",
  HASH_SHA256_HEX: "Hash (SHA256 hex)",
  INTEGER: "Number (whole)",
  PHONE_NUMBER_E164: "Phone number (E.164)",
  STRING: "String"
}, u8 = K1(({
  children: e,
  steps: t = Zu
}) => {
  const [r, a] = Ce(0), n = D3((c) => a((s) => {
    const f = typeof c == "function" ? c(t[s].key) : c;
    return t.findIndex((o) => o.key === f);
  }), [a, t]), i = G3(() => ({
    currentStep: r,
    currentStepKey: t[r].key,
    setCurrentStep: a,
    setCurrentStepByKey: n,
    steps: t
  }), [r, a, n, t]);
  return /* @__PURE__ */ N.jsx(Q8, { value: i, children: e });
});
u8.displayName = "NavigatorContainer";
const x8 = K1(({
  ViewWrapperComponent: e = l0,
  ControllerWrapperComponent: t = l0,
  BackButtonChildren: r,
  BackButtonProps: a,
  UploadButtonChildren: n,
  UploadButtonProps: i,
  OkayButtonChildren: c,
  OkayButtonProps: s,
  extractSchemaMode: f = !1
}) => {
  const {
    uploading: o,
    uploadError: l,
    uploadResult: d
  } = Ue();
  return /* @__PURE__ */ N.jsxs(Dr, { children: [
    /* @__PURE__ */ N.jsxs(e, { sx: {
      display: "flex",
      flex: 1,
      flexDirection: "column",
      gap: "0.5rem",
      overflow: "hidden",
      pb: 0,
      pl: 0,
      pr: 0,
      pt: 0
      // NOTE: this should also set the height if the parent doesn't set it, otherwise virtualization won't work
    }, children: [
      /* @__PURE__ */ N.jsx(f8, { OkayButtonProps: s, extractSchemaMode: f }),
      o || d || l ? /* @__PURE__ */ N.jsx(Dt, {}) : /* @__PURE__ */ N.jsx(v8, { onFileDialogCancel: () => {
        a?.onClick?.();
      } })
    ] }),
    null
  ] });
});
x8.displayName = "ViewContainer";
const ex = K1(({
  BackButtonChildren: e,
  BackButtonProps: t,
  ControllerWrapperComponent: r,
  initArguments: a,
  schema: n,
  OkayButtonChildren: i,
  OkayButtonProps: c,
  onAfterUpload: s,
  onBeforeUpload: f,
  onError: o,
  UploadButtonChildren: l,
  UploadButtonProps: d,
  uploadDatasetFulfilledLabel: u,
  uploadDatasetPendingLabel: h,
  uploadDatasetRejectedLabel: p,
  ViewWrapperComponent: v,
  children: x
}) => /* @__PURE__ */ N.jsx(Mt, { onError: o, children: /* @__PURE__ */ N.jsx(Rt, { children: /* @__PURE__ */ N.jsx(Ft, { schema: n, children: /* @__PURE__ */ N.jsx(ft, { children: /* @__PURE__ */ N.jsx(ot, { children: /* @__PURE__ */ N.jsx(At, { children: /* @__PURE__ */ N.jsx(u8, { children: /* @__PURE__ */ N.jsx(st, { initArguments: a, onAfterUpload: s, onBeforeUpload: f, uploadDatasetFulfilledLabel: u, uploadDatasetPendingLabel: h, uploadDatasetRejectedLabel: p, children: /* @__PURE__ */ N.jsx(ct, { children: /* @__PURE__ */ N.jsx(x8, { BackButtonChildren: e, BackButtonProps: t, ControllerWrapperComponent: r, OkayButtonChildren: i, OkayButtonProps: c, UploadButtonChildren: l, UploadButtonProps: d, ViewWrapperComponent: v, children: x }) }) }) }) }) }) }) }) }) }));
ex.displayName = "DatasetUploader";
const d8 = K1(({
  ownerState: {
    placeholder: e,
    value: t,
    onChange: r,
    inputProps: a
  }
}) => /* @__PURE__ */ N.jsx($8, { endDecorator: t ? (
  // @ts-expect-error: Events of course are incompatible, but given that `event.target.value` would be `undefined` this will clear the search field
  /* @__PURE__ */ N.jsx(X8, { onClick: r, children: /* @__PURE__ */ N.jsx(r1, { icon: Ar }) })
) : null, onChange: r, placeholder: e, slotProps: {
  input: a
}, startDecorator: /* @__PURE__ */ N.jsx(r1, { icon: P8 }), sx: {
  margin: 1,
  minWidth: "280px"
}, value: t }));
d8.displayName = "JoyInputAsSearchTextFieldRoot";
const c3 = (e, t, r) => {
  const a = e.table.options[t];
  return br(typeof a == "function" ? a(e) : {
    ...a
  }, r);
}, rx = (e) => e.startsWith("mui") && e.endsWith("Props"), tx = (e, t, r) => {
  if (rx(r) && (typeof e == "function" || typeof t == "function"))
    return (a) => br(typeof e == "function" ? e(a) : e, typeof t == "function" ? t(a) : t);
}, n5 = K1(({
  autoSelectFirstRow: e = !1,
  columns: t,
  data: r,
  ...a
}) => {
  const n = J8({
    columns: t,
    data: r,
    defaultColumn: {
      minSize: 36
      // NOTE: Equals to the width of the row actions columns' icon button
    },
    displayColumnDefOptions: {
      "mrt-row-actions": {
        enableResizing: !1,
        grow: !1,
        header: "",
        muiTableBodyCellProps: (s) => c3(s, "muiTableBodyCellProps", {
          align: "center"
        }),
        muiTableFooterCellProps: (s) => c3(s, "muiTableFooterCellProps", {
          align: "center"
        }),
        muiTableHeadCellProps: (s) => c3(s, "muiTableHeadCellProps", {
          align: "center"
        })
      },
      "mrt-row-drag": {
        enableResizing: !1,
        grow: !1,
        header: "",
        muiTableBodyCellProps: (s) => c3(s, "muiTableBodyCellProps", {
          align: "center"
        }),
        muiTableFooterCellProps: (s) => c3(s, "muiTableFooterCellProps", {
          align: "center"
        }),
        muiTableHeadCellProps: (s) => c3(s, "muiTableHeadCellProps", {
          align: "center"
        })
      }
    },
    enableBottomToolbar: !1,
    positionGlobalFilter: "left",
    enableColumnActions: !1,
    enableColumnFilters: !1,
    enableColumnResizing: !0,
    enableDensityToggle: !1,
    enableFullScreenToggle: !1,
    enableHiding: !1,
    enablePagination: !1,
    enableRowVirtualization: !0,
    enableSorting: !1,
    enableStickyFooter: !0,
    enableStickyHeader: !0,
    enableTableFooter: !1,
    enableToolbarInternalActions: !1,
    enableTopToolbar: !1,
    icons: {
      ArrowDownwardIcon: (s) => /* @__PURE__ */ N.jsx(r1, { fixedWidth: !0, icon: N8, ...s }),
      CloseIcon: (s) => /* @__PURE__ */ N.jsx(r1, { fixedWidth: !0, icon: Ar, ...s }),
      DragHandleIcon: (s) => /* @__PURE__ */ N.jsx(r1, { icon: M8, ...s }),
      SearchIcon: (s) => /* @__PURE__ */ N.jsx(r1, { fixedWidth: !0, icon: R8, ...s }),
      SyncAltIcon: (s) => /* @__PURE__ */ N.jsx(
        r1,
        {
          fixedWidth: !0,
          icon: O8,
          ...s,
          style: void 0
        }
      )
    },
    initialState: {
      density: "compact"
    },
    layoutMode: "grid",
    muiBottomToolbarProps: {
      sx: {
        boxShadow: "none"
      }
    },
    muiPaginationProps: {
      color: "primary",
      shape: "rounded",
      showRowsPerPage: !0
    },
    muiSearchTextFieldProps: {
      InputProps: {
        slots: {
          root: d8
        }
      }
    },
    muiTableBodyProps: ({
      table: s
    }) => s.getRowCount() === 0 ? {
      sx: {
        height: "auto",
        minHeight: "auto"
      }
    } : {},
    muiTableBodyRowProps: {
      sx: {
        [`&:not(.${at.selected}):hover td:after`]: {
          backgroundColor: "var(--variant-plainHoverBg, var(--joy-palette-neutral-plainHoverBg, var(--joy-palette-neutral-100, #F0F4F8)))",
          content: '""',
          height: "100%",
          left: 0,
          position: "absolute",
          top: 0,
          width: "100%",
          zIndex: -1
        },
        backgroundColor: "unset"
        // NOTE: MRT hardcodes this to `#fff !important` in MRT_TableBodyRow module, we don't want that
      }
    },
    muiTableContainerProps: {
      sx: {
        height: "100%"
      }
    },
    muiTableFooterRowProps: {
      sx: {
        boxShadow: "none"
      }
    },
    muiTableHeadCellProps: ({
      column: s,
      table: f
    }) => ({
      sx: {
        // "& .Mui-TableHeadCell-Content": { alignItems: "flex-start", flex: 1 },
        // "& .Mui-TableHeadCell-Content-Labels": { flex: 1 },
        // "& .Mui-TableHeadCell-Content-Wrapper": { flex: 1 },
        "& .Mui-TableHeadCell-ResizeHandle-Wrapper": {
          "& hr": {
            borderWidth: "1px",
            height: "100%",
            transform: "none"
          },
          "&:active > hr": {
            backgroundColor: "primary.main"
          },
          height: "100%",
          marginRight: 0,
          padding: "0 0.25rem",
          right: "-0.75rem",
          // NOTE: Equals to cell padding + resize handle wrapper padding
          zIndex: 1
        },
        "&:last-child": {
          "& .Mui-TableHeadCell-ResizeHandle-Wrapper": {
            // NOTE: Resize handle wrapper padding causes overflow (and with "hidden" on parent it would be cut off anyway)
            paddingRight: 0,
            right: "-0.5rem"
          }
        },
        fontWeight: "fontWeightSemiBold",
        // NOTE: MRT hardcodes this to `bold` in MRT_TableHeadCell, we don't want that
        p: "0.5rem",
        pb: "0.5rem",
        // NOTE: MRT hardcodes this to `0.4rem` for `compact` density in MRT_TableHeadCell, we don't want that
        pt: "0.5rem",
        // NOTE: MRT hardcodes this to `0.6rem` for `compact` density in MRT_TableHeadCell, we don't want that
        zIndex: f.getAllColumns().length - (s.getIndex() || 0)
        // NOTE: Each next column should have a lower `z-index` so that column resizer is always on top
      }
    }),
    muiTableHeadRowProps: {
      sx: {
        "& .Mui-TableHeadCell-ResizeHandle-Wrapper": {
          opacity: 0,
          transition: "opacity 0.4s"
        },
        "&:hover .Mui-TableHeadCell-ResizeHandle-Wrapper": {
          opacity: 1
        },
        boxShadow: "none"
      }
    },
    muiTablePaperProps: {
      elevation: 0,
      square: !0
    },
    muiTableProps: ({
      table: s
    }) => s.getRowCount() === 0 ? {
      sx: {
        gridTemplateRows: "max-content",
        height: "100%"
      }
    } : {},
    muiTopToolbarProps: {
      sx: {
        borderBottomColor: "divider",
        borderBottomStyle: "solid",
        borderBottomWidth: "1px",
        flex: "0 0 auto",
        minHeight: "auto"
      }
    },
    paginationDisplayMode: "pages",
    positionActionsColumn: "last",
    positionToolbarAlertBanner: "none",
    positionToolbarDropZone: "none",
    renderEmptyRowsFallback: ({
      table: s
    }) => {
      if (s.getRowCount() === 0)
        return /* @__PURE__ */ N.jsx(Nt, { title: a.localization?.noRecordsToDisplay ?? "No data available to display" });
    }
  }, a, tx), i = nt(n), {
    isLoading: c
  } = i.getState();
  return ke(() => {
    if (!c && e && !i.getIsSomeRowsSelected()) {
      const {
        rows: f
      } = i.getSortedRowModel();
      Array.isArray(f) && f.length > 0 && f[0]?.id && i.setRowSelection({
        [f[0].id]: !0
      });
    }
  }, [e, i, c]), /* @__PURE__ */ N.jsx(it, { table: i });
});
n5.displayName = "DqTable";
const ax = "transparent", Sr = "var(--joy-palette-danger-50) !important", nx = K1(({
  column: e
}) => /* @__PURE__ */ N.jsx(l0, { sx: {
  alignItems: "center",
  display: "flex",
  gap: "0.25rem"
}, children: /* @__PURE__ */ N.jsx(l0, { children: e.columnDef.header }) })), p8 = K1(() => {
  const {
    deferred: e
  } = _3(), {
    currentStepKey: t
  } = Rr(), {
    fileHeaders: r
  } = He(), {
    useDeferredSchemaTableHeader: a
  } = S4(), {
    introspecting: n
  } = Z8(), {
    typifying: i
  } = et(), {
    mappedColumns: c,
    showColumns: s,
    showRows: f,
    setShowRows: o
  } = g3(), {
    analyzing: l,
    autofixReport: d,
    numErrorsTotalSum: u,
    numModificationsTotalSum: h,
    rows: p = [],
    numRows: v = 0,
    validationReport: x
  } = Ue(), m = r?.length || 20, T = G3(() => Array.from({
    length: m
  }).map((O, H) => ({
    Cell: (E) => /* @__PURE__ */ N.jsx(Lt, { ...E }),
    Footer: (E) => /* @__PURE__ */ N.jsx(Pt, { ...E }),
    Header: (E) => a ? /* @__PURE__ */ N.jsx(l8, { ...E }) : t === r2.FormatData ? /* @__PURE__ */ N.jsx(nx, { ...E }) : /* @__PURE__ */ N.jsx(a5, { ...E, readOnly: !0 }),
    accessorFn: (E) => {
      const b = c.filter((I) => I !== void 0).indexOf(H);
      return b !== -1 ? E?.preview?.at(b) : E?.original?.at(H);
    },
    header: r?.at(H) || `Column ${(H + 1).toString()}`,
    id: H.toString(),
    size: 250
  })), [m, r, c, t, a]), g = G3(() => {
    const O = {};
    return s !== O3.All && T.forEach((H, W) => {
      const E = c.indexOf(W);
      (s === O3.Mapped && E === -1 || s === O3.Unmapped && E !== -1) && (O[W.toString()] = !1);
    }), O;
  }, [T, c, s]);
  return /* @__PURE__ */ N.jsx(n5, { columns: T, data: p, enableBottomToolbar: !1, enableColumnActions: !1, enableColumnFilters: !1, enableColumnResizing: !0, enableColumnVirtualization: !0, enableDensityToggle: !1, enablePagination: !1, enableRowVirtualization: !0, enableSorting: !1, enableStickyFooter: !0, enableStickyHeader: !0, enableTableFooter: !0, enableTopToolbar: !1, initialState: {
    density: "compact"
  }, muiSkeletonProps: {
    sx: {
      borderRadius: 0
    }
  }, muiTableBodyCellProps: ({
    column: {
      id: O
    },
    row: {
      original: {
        row: H = void 0
      } = {}
    }
  }) => {
    let W, E;
    if (O !== void 0 && H !== void 0) {
      let P = parseInt(O);
      c.indexOf(P) !== -1 && (P = c.indexOf(P), W = x?.report.columns.find(({
        column: Y
      }) => Y === P)?.recordedErrors?.find(({
        location: {
          row: Y,
          column: f0
        }
      }) => Y === H && f0 === P), E = d?.report.columnModifications.find(({
        column: Y
      }) => Y === P)?.recordedModifications?.find(({
        location: {
          row: Y,
          column: f0
        }
      }) => Y === H && f0 === P));
    }
    return {
      sx: {
        backgroundColor: !!E ? ax : !!W ? Sr : "transparent",
        borderBottom: "none",
        lineHeight: "1.25rem",
        padding: "0.25rem 0.5rem"
      }
    };
  }, muiTableBodyRowProps: ({
    row: {
      original: {
        row: O = void 0
      } = {}
    }
  }) => {
    let H = !1, W = !1;
    if (O !== void 0) {
      const {
        columns: E,
        schema: b
      } = x?.report || {};
      H = b?.recordedErrors.some(({
        row: I
      }) => I === O) || !1, W = E?.some(({
        recordedErrors: I
      }) => I.some(({
        location: P
      }) => P.row === O)) || !1;
    }
    return {
      hover: !1,
      sx: {
        // "&:nth-of-type(odd)": { backgroundColor: "whitesmoke" }, // NOTE: Disabling this for now as no other `DqTable` instance renders striped rows
        backgroundColor: H || W ? Sr : "transparent",
        height: "32px"
      }
    };
  }, muiTableContainerProps: {
    sx: {
      height: "100%",
      maxHeight: "100%"
    }
  }, muiTableFooterCellProps: {
    sx: (u || 0) > 0 || (h || 0) > 0 ? {
      borderTop: "1px solid rgba(224, 224, 224, 1)",
      padding: "0.25rem 0.5rem",
      transition: "none"
    } : {
      padding: 0,
      transition: "none"
    }
  }, muiTableFooterProps: {
    sx: {
      outline: "none"
    }
  }, muiTablePaperProps: {
    elevation: 0,
    sx: {
      border: 0,
      borderRadius: 0,
      height: "100%",
      maxHeight: "100%"
    }
  }, renderEmptyRowsFallback: ({
    table: O
  }) => {
    const {
      refs: H
    } = O, {
      tableContainerRef: W
    } = H, {
      current: E
    } = W;
    return /* @__PURE__ */ N.jsx(l0, { sx: {
      alignItems: "center",
      display: "flex",
      justifyContent: "center",
      maxWidth: `min(100vw, ${E?.clientWidth}px)`
    }, children: v > 0 ? f === S3.All ? "No rows to display" : f === S3.Invalid ? /* @__PURE__ */ N.jsxs(l0, { display: "flex", flexDirection: "column", justifyContent: "center", children: [
      /* @__PURE__ */ N.jsx(l0, { children: "No invalid rows to display" }),
      /* @__PURE__ */ N.jsx(x5, { onClick: () => o(S3.All), children: /* @__PURE__ */ N.jsxs(l0, { sx: {
        display: "flex",
        gap: "0.25rem"
      }, children: [
        /* @__PURE__ */ N.jsx("span", { children: "Show" }),
        /* @__PURE__ */ N.jsx("span", { style: {
          fontWeight: 500
        }, children: "All" }),
        /* @__PURE__ */ N.jsx("span", { children: "rows" })
      ] }) })
    ] }) : f === S3.Valid ? /* @__PURE__ */ N.jsxs(l0, { alignItems: "center", display: "flex", gap: "0.5rem", children: [
      /* @__PURE__ */ N.jsx(l0, { children: "No valid rows to display" }),
      /* @__PURE__ */ N.jsx(x5, { onClick: () => o(S3.All), children: /* @__PURE__ */ N.jsxs(l0, { sx: {
        display: "flex",
        gap: "0.25rem"
      }, children: [
        /* @__PURE__ */ N.jsx("span", { children: "Show" }),
        /* @__PURE__ */ N.jsx("span", { style: {
          fontWeight: 500
        }, children: "All" }),
        /* @__PURE__ */ N.jsx("span", { children: "rows" })
      ] }) })
    ] }) : "No rows to display" : "No rows to display" });
  }, rowVirtualizerOptions: {
    estimateSize: () => 32,
    overscan: 10
  }, state: {
    ...e ? {
      columnOrder: c.map((O) => O.toString())
    } : {},
    columnVisibility: g,
    showSkeletons: n || i || l
  } });
});
p8.displayName = "FilePreviewAndTagTable";
const m8 = "is-dragged-over", ix = Fr(l0)(({
  theme: {
    spacing: e,
    radius: t,
    palette: r
  }
}) => ({
  "& .upload-icon": {
    color: r.neutral[400]
  },
  [`&.${m8}`]: {
    "& .upload-icon": {
      color: r.primary[500]
    },
    background: r.primary[50],
    color: r.primary[500]
  },
  alignItems: "center",
  background: r.neutral[50],
  borderRadius: t.sm,
  display: "flex",
  flex: 1,
  flexDirection: "column",
  justifyContent: "center",
  margin: "0 auto",
  padding: e(1),
  width: "100%"
})), v8 = K1(({
  onFileDialogCancel: e
}) => {
  const {
    showColumnSelection: t,
    showRowSelection: r
  } = S4(), {
    schema: a,
    deferred: n
  } = _3(), {
    file: i,
    setFile: c,
    setFileEncoding: s
  } = He(), {
    setShowColumns: f,
    setShowRows: o,
    showColumns: l,
    showRows: d
  } = g3(), {
    analyzing: u,
    analyzeError: h,
    numRows: p
  } = Ue(), [v, x] = Ce(!1), {
    getRootProps: m,
    getInputProps: T,
    open: g
  } = Or({
    maxFiles: 1,
    multiple: !1,
    noClick: !0,
    noKeyboard: !0,
    onDragEnter: () => x(!0),
    onDragLeave: () => x(!1),
    onDropAccepted: (W) => {
      const [E] = W;
      if (E.name.endsWith(".xlsx") || E.name.endsWith(".xls")) {
        const b = new FileReader();
        b.onload = function(I) {
          if (I.target?.result) {
            const P = I.target.result, L = v3(P), z = L.Sheets[L.SheetNames[0]], Y = c8.sheet_to_csv(z);
            c(new File([Y], E.name, {
              type: "text/csv"
            }));
          }
        }, b.readAsArrayBuffer(E);
      } else {
        const b = new FileReader();
        b.onload = function(I) {
          if (I.target?.result) {
            const P = I.target.result, {
              encoding: L
            } = C6.detect(P);
            s(L), c(E);
          }
        }, b.readAsBinaryString(E.slice(0, 1024 * 1024));
      }
      x(!1);
    },
    onFileDialogCancel: e
  }), O = a !== null, H = a === null ? void 0 : a === void 0 && !n ? /* @__PURE__ */ N.jsxs(Dr, { children: [
    "Select a file with the same structure as the data to be uploaded to this table.",
    /* @__PURE__ */ N.jsx("br", {}),
    "This is a purely local operation, no data will be transferred.",
    /* @__PURE__ */ N.jsx("br", {}),
    "Supported formats: CSV and Excel."
  ] }) : "Supported formats: CSV and Excel.";
  return i ? O ? /* @__PURE__ */ N.jsxs(l0, { ...m(), sx: ({
    palette: W
  }) => ({
    backgroundColor: v ? W.primary[50] : "transparent",
    display: "flex",
    flex: 1,
    flexDirection: "column",
    height: "100%",
    overflow: "hidden",
    padding: "8px"
  }), children: [
    /* @__PURE__ */ N.jsx(oe, { container: !0, spacing: 1, children: /* @__PURE__ */ N.jsxs(oe, { container: !0, xs: 12, children: [
      /* @__PURE__ */ N.jsx(oe, { alignItems: "center", columnSpacing: 0, container: !0, flexGrow: 1, rowSpacing: 1, xs: "auto", children: /* @__PURE__ */ N.jsxs(l0, { alignItems: "baseline", display: "flex", gap: "0.5rem", children: [
        /* @__PURE__ */ N.jsx("span", { style: {
          fontWeight: 500
        }, children: "Preview" }),
        /* @__PURE__ */ N.jsx(q8, { collapsedSize: "calc(14px + 0.5rem)", in: !u, orientation: "horizontal", children: /* @__PURE__ */ N.jsxs(l0, { sx: {
          display: "inline-flex",
          flexWrap: "nowrap",
          height: "100%",
          whiteSpace: "nowrap"
        }, children: [
          u ? /* @__PURE__ */ N.jsx("span", { style: {
            alignSelf: "center",
            display: "flex",
            margin: "0 0.25rem"
          }, children: /* @__PURE__ */ N.jsx(l5, { in: u, children: /* @__PURE__ */ N.jsx(K8, { sx: {
            "--CircularProgress-size": "14px"
          }, thickness: 1 }) }) }) : null,
          p ? /* @__PURE__ */ N.jsx(l5, { in: !!p, children: /* @__PURE__ */ N.jsxs("span", { style: {
            fontSize: "0.75rem",
            margin: "0 0.25rem"
          }, children: [
            p,
            " rows"
          ] }) }) : null
        ] }) }),
        /* @__PURE__ */ N.jsx("input", { "data-testid": "dropzone-input", ...T() }),
        /* @__PURE__ */ N.jsx(h5, { onClick: (W) => {
          W.stopPropagation(), g();
        }, style: {
          visibility: "hidden"
        }, children: "Change file" })
      ] }) }),
      r || t ? /* @__PURE__ */ N.jsx(oe, { children: /* @__PURE__ */ N.jsxs(l0, { alignItems: "center", display: "flex", gap: "0.75rem", children: [
        /* @__PURE__ */ N.jsx(l0, { sx: {
          fontSize: "0.875rem"
        }, children: "Show" }),
        /* @__PURE__ */ N.jsxs(l0, { alignItems: "center", display: "flex", gap: "0.25rem", children: [
          /* @__PURE__ */ N.jsx(r1, { fixedWidth: !0, icon: L8 }),
          /* @__PURE__ */ N.jsx(rt, { setShowRows: o, showRows: d })
        ] }),
        t && /* @__PURE__ */ N.jsxs(l0, { alignItems: "center", display: "flex", gap: "0.25rem", children: [
          /* @__PURE__ */ N.jsx(r1, { fixedWidth: !0, icon: B8 }),
          /* @__PURE__ */ N.jsx(tt, { setShowColumns: f, showColumns: l })
        ] })
      ] }) }) : null
    ] }) }),
    h ? null : /* @__PURE__ */ N.jsx(l0, { sx: {
      flex: 1,
      mt: 1,
      overflow: "hidden"
    }, children: /* @__PURE__ */ N.jsx(p8, {}) }),
    h ? /* @__PURE__ */ N.jsxs(l0, { alignItems: "center", color: "danger.200", display: "flex", flex: 1, flexDirection: "column", justifyContent: "center", children: [
      /* @__PURE__ */ N.jsx(l0, { sx: {
        mb: 3
      }, children: /* @__PURE__ */ N.jsx(r1, { className: "upload-icon", fixedWidth: !0, icon: U8, size: "4x" }) }),
      /* @__PURE__ */ N.jsxs(l0, { alignItems: "center", display: "flex", flexDirection: "column", children: [
        /* @__PURE__ */ N.jsx("span", { style: {
          fontSize: "0.875rem",
          fontWeight: 600
        }, children: "File could not be parsed" }),
        /* @__PURE__ */ N.jsx("pre", { style: {
          fontSize: "0.75rem",
          margin: 0
        }, children: h })
      ] })
    ] }) : null
  ] }) : null : /* @__PURE__ */ N.jsx(l0, { ...m(), onClick: g, sx: {
    alignItems: "center",
    cursor: "pointer",
    display: "flex",
    flex: 1,
    flexDirection: "column",
    height: "100%",
    width: "100%"
  }, children: /* @__PURE__ */ N.jsxs(ix, { className: D8({
    [m8]: v
  }), children: [
    /* @__PURE__ */ N.jsx(l0, { sx: {
      mb: 3
    }, children: /* @__PURE__ */ N.jsx(r1, { className: "upload-icon", fixedWidth: !0, icon: H8, size: "4x" }) }),
    /* @__PURE__ */ N.jsxs(l0, { alignItems: "center", display: "flex", gap: "0.125rem", children: [
      /* @__PURE__ */ N.jsx("input", { "data-testid": "dropzone-input", ...T() }),
      /* @__PURE__ */ N.jsx(h5, { onClick: (W) => {
        W.stopPropagation(), g();
      }, children: "Select file" }),
      /* @__PURE__ */ N.jsx("span", { style: {
        fontSize: "0.875rem",
        lineHeight: "1rem"
      }, children: "or drop file here" })
    ] }),
    /* @__PURE__ */ N.jsx(l0, { alignItems: "center", display: "flex", mt: 0.5, children: /* @__PURE__ */ N.jsx("span", { style: {
      fontSize: "0.75rem",
      lineHeight: "1rem",
      textAlign: "center"
    }, children: H }) }),
    /* @__PURE__ */ N.jsx(l0, { sx: {
      display: "flex",
      fontSize: "0.875rem"
    }, children: /* @__PURE__ */ N.jsx(bt, {}) })
  ] }) });
});
v8.displayName = "Prepper";
export {
  o8 as A,
  ex as D,
  p8 as F,
  a5 as H,
  h8 as M,
  f8 as N,
  v8 as P,
  x8 as V,
  u8 as a,
  n5 as b,
  l8 as c,
  Id as u
};
//# sourceMappingURL=Prepper.Bv7VECW1.js.map
